var impacts = {
  "CA-A CANCER JOURNAL FOR CLINICIANS": 223.679,
  "NATURE REVIEWS MATERIALS": 74.449,
  "NEW ENGLAND JOURNAL OF MEDICINE": 70.67,
  "LANCET": 59.102,
  "NATURE REVIEWS DRUG DISCOVERY": 57.618,
  "CHEMICAL REVIEWS": 54.301,
  "NATURE ENERGY": 54,
  "NATURE REVIEWS CANCER": 51.848,
  "JAMA-JOURNAL OF THE AMERICAN MEDICAL ASSOCIATION": 51.273,
  "NATURE REVIEWS IMMUNOLOGY": 44.019,
  "NATURE REVIEWS GENETICS": 43.704,
  "NATURE REVIEWS MOLECULAR CELL BIOLOGY": 43.351,
  "NATURE": 43.07,
  "SCIENCE": 41.037,
  "CHEMICAL SOCIETY REVIEWS": 40.443,
  "NATURE MATERIALS": 38.887,
  "REVIEWS OF MODERN PHYSICS": 38.296,
  "CELL": 36.216,
  "LANCET ONCOLOGY": 35.386,
  "NATURE REVIEWS MICROBIOLOGY": 34.648,
  "NATURE REVIEWS CLINICAL ONCOLOGY": 34.106,
  "WORLD PSYCHIATRY": 34.024,
  "NATURE NANOTECHNOLOGY": 34.024,
  "ENERGY & ENVIRONMENTAL SCIENCE": 33.407,
  "NATURE REVIEWS NEUROSCIENCE": 33.25,
  "ANNUAL REVIEW OF ASTRONOMY AND ASTROPHYSICS": 33.162,
  "NATURE REVIEWS DISEASE PRIMERS": 33.069,
  "NATURE BIOTECHNOLOGY": 32.274,
  "NATURE PHOTONICS": 31.864,
  "NATURE MEDICINE": 31.583,
  "NATURE REVIEWS CHEMISTRY": 30.641,
  "LANCET NEUROLOGY": 30.628,
  "NATURE METHODS": 28.755,
  "PHYSICS REPORTS-REVIEW SECTION OF PHYSICS LETTERS": 28.467,
  "JOURNAL OF CLINICAL ONCOLOGY": 28.295,
  "LIVING REVIEWS IN RELATIVITY": 28.245,
  "BMJ-BRITISH MEDICAL JOURNAL": 27.778,
  "LANCET INFECTIOUS DISEASES": 27.604,
  "ANNUAL REVIEW OF BIOCHEMISTRY": 27.516,
  "PROGRESS IN ENERGY AND COMBUSTION SCIENCE": 26.922,
  "CANCER DISCOVERY": 26.467,
  "ADVANCES IN PHYSICS": 26.37,
  "ADVANCED MATERIALS": 26.1,
  "NATURE GENETICS": 25.809,
  "ADVANCED ENERGY MATERIALS": 25.455,
  "NATURE REVIEWS ENDOCRINOLOGY": 24.884,
  "LANCET DIABETES & ENDOCRINOLOGY": 24.646,
  "PROGRESS IN POLYMER SCIENCE": 24.54,
  "MATERIALS TODAY": 24.505,
  "PHYSIOLOGICAL REVIEWS": 24.372,
  "CANCER CELL": 24.25,
  "PROGRESS IN MATERIALS SCIENCE": 23.916,
  "NATURE REVIEWS GASTROENTEROLOGY & HEPATOLOGY": 23.725,
  "NATURE IMMUNOLOGY": 23.57,
  "EUROPEAN HEART JOURNAL": 23.53,
  "NATURE CHEMISTRY": 23.239,
  "CIRCULATION": 23.193,
  "LANCET RESPIRATORY MEDICINE": 23.054,
  "IEEE COMMUNICATIONS SURVEYS AND TUTORIALS": 22.992,
  "JAMA ONCOLOGY": 22.973,
  "CELL METABOLISM": 22.416,
  "MATERIALS SCIENCE & ENGINEERING R-REPORTS": 22.415,
  "PSYCHOLOGICAL SCIENCE IN THE PUBLIC INTEREST": 22.25,
  "NATURE CLIMATE CHANGE": 22.25,
  "ACCOUNTS OF CHEMICAL RESEARCH": 21.722,
  "IMMUNITY": 21.722,
  "CELL STEM CELL": 21.661,
  "ANNUAL REVIEW OF IMMUNOLOGY": 21.522,
  "NATURE REVIEWS NEUROLOGY": 21.464,
  "NATURE NEUROSCIENCE": 21.429,
  "INTERNATIONAL MATERIALS REVIEWS": 21.155,
  "JAMA INTERNAL MEDICINE": 21.126,
  "NATURE PHYSICS": 21.086,
  "ANNUAL REVIEW OF PSYCHOLOGY": 20.768,
  "NATURE REVIEWS NEPHROLOGY": 20.113,
  "SCIENCE ROBOTICS": 19.755,
  "ANNALS OF INTERNAL MEDICINE": 19.755,
  "GASTROENTEROLOGY": 19.684,
  "INTENSIVE CARE MEDICINE": 19.4,
  "JOURNAL OF HEPATOLOGY": 19.315,
  "ANNUAL REVIEW OF PLANT BIOLOGY": 19.233,
  "PHARMACOLOGICAL REVIEWS": 18.967,
  "JOURNAL OF THE AMERICAN COLLEGE OF CARDIOLOGY": 18.946,
  "NATURE REVIEWS RHEUMATOLOGY": 18.918,
  "LANCET PSYCHIATRY": 18.886,
  "CHEM": 18.639,
  "ACTA NEUROPATHOLOGICA": 18.545,
  "GUT": 18.329,
  "ANNUAL REVIEW OF PHYSIOLOGY": 18.329,
  "CELL RESEARCH": 18.205,
  "CLINICAL MICROBIOLOGY REVIEWS": 18.174,
  "IEEE TRANSACTIONS ON PATTERN ANALYSIS AND MACHINE INTELLIGENCE": 17.943,
  "NATURE CELL BIOLOGY": 17.902,
  "NATURE REVIEWS CARDIOLOGY": 17.848,
  "EUROPEAN UROLOGY": 17.75,
  "ANNUAL REVIEW OF FLUID MECHANICS": 17.73,
  "BEHAVIORAL AND BRAIN SCIENCES": 17.728,
  "SCIENCE TRANSLATIONAL MEDICINE": 17.42,
  "NATURE BIOMEDICAL ENGINEERING": 17.298,
  "TRENDS IN BIOCHEMICAL SCIENCES": 17.214,
  "ANNUAL REVIEW OF MATERIALS RESEARCH": 17.194,
  "REVIEWS OF GEOPHYSICS": 17.194,
  "REPORTS ON PROGRESS IN PHYSICS": 17.161,
  "TRENDS IN CELL BIOLOGY": 17.135,
  "NANO TODAY": 16.889,
  "BLOOD": 16.816,
  "AMERICAN JOURNAL OF RESPIRATORY AND CRITICAL CARE MEDICINE": 16.725,
  "PSYCHOLOGICAL BULLETIN": 16.62,
  "ACS ENERGY LETTERS": 16.588,
  "TRENDS IN COGNITIVE SCIENCES": 16.582,
  "JAMA PSYCHIATRY": 16.562,
  "LANCET GLOBAL HEALTH": 16.494,
  "CIRCULATION RESEARCH": 16.405,
  "ADVANCED SCIENCE": 16.405,
  "CELL HOST & MICROBE": 16.331,
  "ADVANCED FUNCTIONAL MATERIALS": 16.173,
  "FUNGAL DIVERSITY": 16.173,
  "ANNUAL REVIEW OF CONDENSED MATTER PHYSICS": 15.916,
  "NANO ENERGY": 15.916,
  "ADVANCED DRUG DELIVERY REVIEWS": 15.873,
  "DIABETES CARE": 15.873,
  "MICROBIOLOGY AND MOLECULAR BIOLOGY REVIEWS": 15.862,
  "TRENDS IN ECOLOGY & EVOLUTION": 15.804,
  "ANNUAL REVIEW OF MARINE SCIENCE": 15.753,
  "JOURNAL OF PINEAL RESEARCH": 15.621,
  "ENDOCRINE REVIEWS": 15.596,
  "ASTRONOMY AND ASTROPHYSICS REVIEW": 15.588,
  "HEPATOLOGY": 15.548,
  "MMWR-MORBIDITY AND MORTALITY WEEKLY REPORT": 15.519,
  "SURFACE SCIENCE REPORTS": 15.27,
  "MOLECULAR BIOLOGY AND EVOLUTION": 15.255,
  "LANCET HIV": 15.236,
  "JOURNAL OF THE AMERICAN CHEMICAL SOCIETY": 15.225,
  "LIVING REVIEWS IN SOLAR PHYSICS": 15.221,
  "MOLECULAR CELL": 15.167,
  "NATURE GEOSCIENCE": 15.143,
  "ALZHEIMERS & DEMENTIA": 14.971,
  "NEURON": 14.874,
  "MATERIALS HORIZONS": 14.824,
  "NATURE MICROBIOLOGY": 14.797,
  "ANNALS OF THE RHEUMATIC DISEASES": 14.753,
  "APPLIED CATALYSIS B-ENVIRONMENTAL": 14.695,
  "ANNALS OF ONCOLOGY": 14.625,
  "JOURNAL OF ALLERGY AND CLINICAL IMMUNOLOGY": 14.548,
  "ANNUAL REVIEW OF CLINICAL PSYCHOLOGY": 14.48,
  "GENOME BIOLOGY": 14.423,
  "TRENDS IN PLANT SCIENCE": 14.403,
  "LIGHT-SCIENCE & APPLICATIONS": 14.356,
  "EUROPEAN JOURNAL OF HEART FAILURE": 14.3,
  "ADVANCES IN OPTICS AND PHOTONICS": 14.299,
  "ACS NANO": 14.229,
  "ANNUAL REVIEW OF PATHOLOGY-MECHANISMS OF DISEASE": 14.196,
  "TRENDS IN BIOTECHNOLOGY": 14.11,
  "PSYCHOTHERAPY AND PSYCHOSOMATICS": 14.098,
  "AMERICAN JOURNAL OF PSYCHIATRY": 14.098,
  "COORDINATION CHEMISTRY REVIEWS": 14.028,
  "NATURE PLANTS": 14.006,
  "IEEE INDUSTRIAL ELECTRONICS MAGAZINE": 14,
  "NATIONAL SCIENCE REVIEW": 13.965,
  "TRENDS IN IMMUNOLOGY": 13.963,
  "HUMAN REPRODUCTION UPDATE": 13.903,
  "LANCET GASTROENTEROLOGY & HEPATOLOGY": 13.833,
  "ACS CENTRAL SCIENCE": 13.747,
  "BIOTECHNOLOGY ADVANCES": 13.744,
  "SCIENCE ADVANCES": 13.744,
  "APPLIED PHYSICS REVIEWS": 13.655,
  "PROGRESS IN LIPID RESEARCH": 13.655,
  "JOURNAL OF THORACIC ONCOLOGY": 13.476,
  "JAMA NEUROLOGY": 13.297,
  "TRENDS IN NEUROSCIENCES": 13.241,
  "ACADEMY OF MANAGEMENT ANNALS": 13.222,
  "JOURNAL OF CLINICAL INVESTIGATION": 13,
  "NANO LETTERS": 12.878,
  "ANGEWANDTE CHEMIE-INTERNATIONAL EDITION": 12.856,
  "ANNUAL REVIEW OF BIOMEDICAL ENGINEERING": 12.837,
  "ACS CATALYSIS": 12.831,
  "PHYSICAL REVIEW X": 12.804,
  "ANNUAL REVIEW OF BIOPHYSICS": 12.75,
  "NATURE CHEMICAL BIOLOGY": 12.54,
  "NATURE STRUCTURAL & MOLECULAR BIOLOGY": 12.46,
  "ANNUAL REVIEW OF PHARMACOLOGY AND TOXICOLOGY": 12.321,
  "ANNUAL REVIEW OF NEUROSCIENCE": 12.314,
  "JAMA PEDIATRICS": 12.289,
  "LANCET HAEMATOLOGY": 12.282,
  "ANNUAL REVIEW OF PHYSICAL CHEMISTRY": 12.279,
  "TRENDS IN MICROBIOLOGY": 12.257,
  "MOLECULAR PSYCHIATRY": 12.257,
  "NATURE COMMUNICATIONS": 12.221,
  "NATURAL PRODUCT REPORTS": 12.211,
  "JAMA CARDIOLOGY": 12.175,
  "BRAIN": 12.154,
  "EUROPEAN RESPIRATORY JOURNAL": 12.109,
  "ANNUAL REVIEW OF ENTOMOLOGY": 12.103,
  "QUARTERLY JOURNAL OF ECONOMICS": 12.043,
  "PROGRESS IN RETINAL AND EYE RESEARCH": 12.004,
  "DRUG RESISTANCE UPDATES": 11.99,
  "IEEE TRANSACTIONS ON NEURAL NETWORKS AND LEARNING SYSTEMS": 11.982,
  "JOURNAL OF STATISTICAL SOFTWARE": 11.974,
  "BRITISH JOURNAL OF SPORTS MEDICINE": 11.973,
  "LANCET PUBLIC HEALTH": 11.878,
  "FEMS MICROBIOLOGY REVIEWS": 11.876,
  "TRENDS IN PHARMACOLOGICAL SCIENCES": 11.866,
  "BIOLOGICAL PSYCHIATRY": 11.814,
  "NATURE PROTOCOLS": 11.807,
  "IMMUNOLOGICAL REVIEWS": 11.796,
  "EMBO JOURNAL": 11.775,
  "NUCLEIC ACIDS RESEARCH": 11.768,
  "AUTOPHAGY": 11.708,
  "PLOS MEDICINE": 11.683,
  "PHYSICS OF LIFE REVIEWS": 11.655,
  "TRENDS IN MOLECULAR MEDICINE": 11.645,
  "IEEE WIRELESS COMMUNICATIONS": 11.6,
  "JOURNAL OF EXTRACELLULAR VESICLES": 11.6,
  "JACC-CARDIOVASCULAR IMAGING": 11.524,
  "NATURE ECOLOGY & EVOLUTION": 11.523,
  "EARTH SYSTEM SCIENCE DATA": 11.501,
  "FRONTIERS IN ECOLOGY AND THE ENVIRONMENT": 11.334,
  "JOURNAL OF EXPERIMENTAL MEDICINE": 11.292,
  "GENOME MEDICINE": 11.227,
  "ANNUAL REVIEW OF ECOLOGY EVOLUTION AND SYSTEMATICS": 11.147,
  "SMALL": 11.059,
  "ANNUAL REVIEW OF CELL AND DEVELOPMENTAL BIOLOGY": 11.048,
  "MOLECULAR PLANT": 11.045,
  "ANNUAL REVIEW OF PUBLIC HEALTH": 11.028,
  "PROGRESS IN PARTICLE AND NUCLEAR PHYSICS": 11,
  "JOURNAL OF CACHEXIA SARCOPENIA AND MUSCLE": 11,
  "JOURNAL OF MATERIALS CHEMISTRY A": 10.975,
  "INFORMATION FUSION": 10.965,
  "PROCEEDINGS OF THE IEEE": 10.951,
  "MOLECULAR CANCER": 10.935,
  "JAMA SURGERY": 10.892,
  "ADVANCES IN APPLIED MECHANICS": 10.886,
  "PROGRESS IN NEUROBIOLOGY": 10.878,
  "ACADEMY OF MANAGEMENT REVIEW": 10.856,
  "TRENDS IN GENETICS": 10.833,
  "EMBO MOLECULAR MEDICINE": 10.812,
  "NATURE HUMAN BEHAVIOUR": 10.776,
  "RENEWABLE & SUSTAINABLE ENERGY REVIEWS": 10.776,
  "SCIENCE IMMUNOLOGY": 10.764,
  "SLEEP MEDICINE REVIEWS": 10.754,
  "NATURE ASTRONOMY": 10.733,
  "IEEE TRANSACTIONS ON SMART GRID": 10.716,
  "MICROBIOME": 10.694,
  "GLOBAL ENVIRONMENTAL CHANGE-HUMAN AND POLICY DIMENSIONS": 10.679,
  "JOURNAL OF PHOTOCHEMISTRY AND PHOTOBIOLOGY C-PHOTOCHEMISTRY REVIEWS": 10.668,
  "AGEING RESEARCH REVIEWS": 10.667,
  "IEEE TRANSACTIONS ON CYBERNETICS": 10.658,
  "IEEE COMMUNICATIONS MAGAZINE": 10.632,
  "BIOLOGICAL REVIEWS": 10.627,
  "BIOMATERIALS": 10.624,
  "PSYCHOLOGICAL INQUIRY": 10.575,
  "SYSTEMATIC BIOLOGY": 10.575,
  "ANNUAL REVIEW OF MICROBIOLOGY": 10.556,
  "AMERICAN JOURNAL OF GASTROENTEROLOGY": 10.551,
  "JNCI-JOURNAL OF THE NATIONAL CANCER INSTITUTE": 10.517,
  "ANNUAL REVIEW OF PHYTOPATHOLOGY": 10.5,
  "INTERNATIONAL REVIEWS IN PHYSICAL CHEMISTRY": 10.486,
  "CHEMISTRY OF MATERIALS": 10.465,
  "ANNUAL REVIEW OF MEDICINE": 10.427,
  "NEURO-ONCOLOGY": 10.427,
  "GENOME RESEARCH": 10.405,
  "LEUKEMIA": 10.39,
  "AMERICAN JOURNAL OF HUMAN GENETICS": 10.387,
  "CLINICAL PSYCHOLOGY REVIEW": 10.356,
  "PERSONALITY AND SOCIAL PSYCHOLOGY REVIEW": 10.288,
  "MOLECULAR SYSTEMS BIOLOGY": 10.273,
  "MEDICINAL RESEARCH REVIEWS": 10.273,
  "TRENDS IN ENDOCRINOLOGY AND METABOLISM": 10.266,
  "IEEE GEOSCIENCE AND REMOTE SENSING MAGAZINE": 10.242,
  "SEMINARS IN CANCER BIOLOGY": 10.241,
  "CHEST": 10.211,
  "THORAX": 10.2,
  "PROCEEDINGS OF THE NATIONAL ACADEMY OF SCIENCES OF THE UNITED STATES OF AMERICA": 10.172,
  "ANNUAL REVIEW OF CHEMICAL AND BIOMOLECULAR ENGINEERING": 10.159,
  "CHEMICAL SCIENCE": 10.091,
  "JACC-CARDIOVASCULAR INTERVENTIONS": 10.091,
  "EARTH-SCIENCE REVIEWS": 9.944,
  "BIOSENSORS & BIOELECTRONICS": 9.944,
  "IEEE INTERNET OF THINGS JOURNAL": 9.924,
  "ANNALS OF NEUROLOGY": 9.904,
  "ISME JOURNAL": 9.903,
  "ANNALS OF SURGERY": 9.8,
  "GREEN CHEMISTRY": 9.791,
  "PHARMACOLOGY & THERAPEUTICS": 9.777,
  "JOURNAL OF THE ACADEMY OF MARKETING SCIENCE": 9.659,
  "ANALYTIC METHODS IN ACCIDENT RESEARCH": 9.658,
  "NATURE REVIEWS UROLOGY": 9.657,
  "IEEE JOURNAL ON SELECTED AREAS IN COMMUNICATIONS": 9.64,
  "OPTICA": 9.58,
  "ANNUAL REVIEW OF EARTH AND PLANETARY SCIENCES": 9.569,
  "PHYSICAL REVIEW LETTERS": 9.556,
  "STUDIES IN MYCOLOGY": 9.544,
  "NPJ COMPUTATIONAL MATERIALS": 9.53,
  "CURRENT BIOLOGY": 9.518,
  "DEVELOPMENTAL CELL": 9.515,
  "ANNUAL REVIEW OF GENETICS": 9.496,
  "COLD SPRING HARBOR PERSPECTIVES IN BIOLOGY": 9.493,
  "OCULAR SURFACE": 9.476,
  "BRIEFINGS IN BIOINFORMATICS": 9.405,
  "NANOSCALE HORIZONS": 9.396,
  "HEALTH PSYCHOLOGY REVIEW": 9.36,
  "MASS SPECTROMETRY REVIEWS": 9.333,
  "JOURNAL OF MANAGEMENT": 9.333,
  "LASER & PHOTONICS REVIEWS": 9.302,
  "CLINICAL INFECTIOUS DISEASES": 9.263,
  "INTERNATIONAL JOURNAL OF ENGINEERING SCIENCE": 9.235,
  "NANO-MICRO LETTERS": 9.227,
  "ARTHRITIS & RHEUMATOLOGY": 9.206,
  "CATALYSIS REVIEWS-SCIENCE AND ENGINEERING": 9.2,
  "GENES & DEVELOPMENT": 9.193,
  "REVIEW OF EDUCATIONAL RESEARCH": 9.19,
  "CLINICAL CANCER RESEARCH": 9.184,
  "JACC-HEART FAILURE": 9.11,
  "JOURNAL OF CELL BIOLOGY": 9.108,
  "TRENDS IN CANCER": 9.101,
  "GLOBAL CHANGE BIOLOGY": 9.095,
  "MEDICAL IMAGE ANALYSIS": 9.07,
  "PROGRESS IN NUCLEAR MAGNETIC RESONANCE SPECTROSCOPY": 9.068,
  "PROGRESS IN SURFACE SCIENCE": 9.056,
  "IEEE TRANSACTIONS ON FUZZY SYSTEMS": 9.056,
  "REVIEWS IN MINERALOGY & GEOCHEMISTRY": 9.055,
  "COMPREHENSIVE REVIEWS IN FOOD SCIENCE AND FOOD SAFETY": 9.052,
  "SOCIAL ISSUES AND POLICY REVIEW": 9.043,
  "JOURNAL OF HEMATOLOGY & ONCOLOGY": 9.002,
  "ANNUAL REVIEW OF ANALYTICAL CHEMISTRY": 9,
  "ECOLOGY LETTERS": 8.99,
  "NEUROLOGY": 8.985,
  "GENETICS IN MEDICINE": 8.911,
  "JOURNAL FOR IMMUNOTHERAPY OF CANCER": 8.91,
  "CELL SYSTEMS": 8.891,
  "PLANT CELL": 8.884,
  "CANCER IMMUNOLOGY RESEARCH": 8.88,
  "ANNUAL REVIEW OF ENVIRONMENT AND RESOURCES": 8.88,
  "JOURNAL OF HEART AND LUNG TRANSPLANTATION": 8.848,
  "JOURNAL OF THE AMERICAN SOCIETY OF NEPHROLOGY": 8.762,
  "CURRENT OPINION IN CHEMICAL BIOLOGY": 8.759,
  "TRENDS IN FOOD SCIENCE & TECHNOLOGY": 8.745,
  "NANO RESEARCH": 8.738,
  "ANNUAL REVIEW OF FOOD SCIENCE AND TECHNOLOGY": 8.733,
  "IEEE TRANSACTIONS ON EVOLUTIONARY COMPUTATION": 8.731,
  "ORGANIZATION & ENVIRONMENT": 8.721,
  "ACS APPLIED MATERIALS & INTERFACES": 8.699,
  "TRAC-TRENDS IN ANALYTICAL CHEMISTRY": 8.689,
  "APPLIED ENERGY": 8.683,
  "ANNUAL REVIEW OF NUTRITION": 8.676,
  "CURRENT OPINION IN SOLID STATE & MATERIALS SCIENCE": 8.64,
  "MOLECULAR THERAPY": 8.631,
  "PLOS BIOLOGY": 8.619,
  "EMBO REPORTS": 8.617,
  "CANCER RESEARCH": 8.617,
  "ASTROPHYSICAL JOURNAL LETTERS": 8.578,
  "CHEMICAL ENGINEERING JOURNAL": 8.547,
  "CANCER TREATMENT REVIEWS": 8.544,
  "MOLECULAR ASPECTS OF MEDICINE": 8.519,
  "ASTROPHYSICAL JOURNAL SUPPLEMENT SERIES": 8.515,
  "KIDNEY INTERNATIONAL": 8.511,
  "BMC MEDICINE": 8.508,
  "MOLECULAR NEURODEGENERATION": 8.5,
  "JOURNAL OF NEUROLOGY NEUROSURGERY AND PSYCHIATRY": 8.456,
  "NPJ QUANTUM INFORMATION": 8.428,
  "ADVANCES IN COLLOID AND INTERFACE SCIENCE": 8.426,
  "CURRENT OPINION IN CELL BIOLOGY": 8.422,
  "REMOTE SENSING OF ENVIRONMENT": 8.418,
  "CELLULAR & MOLECULAR IMMUNOLOGY": 8.402,
  "OBESITY REVIEWS": 8.386,
  "PERSPECTIVES ON PSYCHOLOGICAL SCIENCE": 8.383,
  "PSYCHOLOGICAL METHODS": 8.378,
  "BULLETIN OF THE AMERICAN METEOROLOGICAL SOCIETY": 8.374,
  "SPACE SCIENCE REVIEWS": 8.355,
  "WILEY INTERDISCIPLINARY REVIEWS-COMPUTATIONAL MOLECULAR SCIENCE": 8.332,
  "CELL DEATH AND DIFFERENTIATION": 8.313,
  "CURRENT OPINION IN BIOTECHNOLOGY": 8.311,
  "THERANOSTICS": 8.306,
  "MOVEMENT DISORDERS": 8.285,
  "NPG ASIA MATERIALS": 8.274,
  "ENVIRONMENTAL HEALTH PERSPECTIVES": 8.272,
  "ADMINISTRATIVE SCIENCE QUARTERLY": 8.27,
  "TRENDS IN PARASITOLOGY": 8.243,
  "APPLIED MATERIALS TODAY": 8.233,
  "NEUROSCIENCE AND BIOBEHAVIORAL REVIEWS": 8.218,
  "JAMA DERMATOLOGY": 8.213,
  "CLINICAL GASTROENTEROLOGY AND HEPATOLOGY": 8.192,
  "ENVIRONMENT INTERNATIONAL": 8.19,
  "ANNUAL REVIEW OF GENOMICS AND HUMAN GENETICS": 8.188,
  "WATER RESEARCH": 8.166,
  "JOURNAL OF CONTROLLED RELEASE": 8.142,
  "BLOOD CANCER JOURNAL": 8.127,
  "PERIODONTOLOGY 2000": 8.086,
  "FRONTIERS IN NEUROENDOCRINOLOGY": 8.083,
  "JOURNAL OF CROHNS & COLITIS": 8.063,
  "GUT MICROBES": 8.061,
  "JOURNAL OF MARKETING": 8.052,
  "IEEE TRANSACTIONS ON MEDICAL IMAGING": 8.049,
  "CELL REPORTS": 8.024,
  "METABOLIC ENGINEERING": 8.02,
  "CHEMSUSCHEM": 8.013,
  "REDOX BIOLOGY": 8.002,
  "THYROID": 7.995,
  "CLADISTICS": 7.958,
  "JOURNAL OF OPERATIONS MANAGEMENT": 7.943,
  "PROGRESS IN PHOTOVOLTAICS": 7.914,
  "COCHRANE DATABASE OF SYSTEMATIC REVIEWS": 7.913,
  "OPHTHALMOLOGY": 7.901,
  "ALIMENTARY PHARMACOLOGY & THERAPEUTICS": 7.895,
  "JOURNAL OF INTERNATIONAL BUSINESS STUDIES": 7.861,
  "JOURNAL OF CATALYSIS": 7.852,
  "AUTOIMMUNITY REVIEWS": 7.827,
  "ENVIRONMENTAL SCIENCE-NANO": 7.823,
  "ANNUAL REVIEW OF NUCLEAR AND PARTICLE SCIENCE": 7.821,
  "ECOLOGICAL MONOGRAPHS": 7.816,
  "CURRENT OPINION IN IMMUNOLOGY": 7.815,
  "IEEE TRANSACTIONS ON SUSTAINABLE ENERGY": 7.808,
  "JOURNAL OF HAZARDOUS MATERIALS": 7.804,
  "RADIOLOGY": 7.793,
  "IEEE SIGNAL PROCESSING MAGAZINE": 7.786,
  "INTERNATIONAL JOURNAL OF MANAGEMENT REVIEWS": 7.779,
  "SPORTS MEDICINE": 7.776,
  "PROTEIN & CELL": 7.776,
  "HAEMATOLOGICA": 7.776,
  "JOURNAL OF THE NATIONAL COMPREHENSIVE CANCER NETWORK": 7.755,
  "RIVISTA DEL NUOVO CIMENTO": 7.732,
  "ELIFE": 7.731,
  "JOURNAL OF ALLERGY AND CLINICAL IMMUNOLOGY-IN PRACTICE": 7.724,
  "JOURNAL OF AUTOIMMUNITY": 7.723,
  "ENVIRONMENTAL INNOVATION AND SOCIETAL TRANSITIONS": 7.716,
  "CURRENT OPINION IN PLANT BIOLOGY": 7.704,
  "IEEE NETWORK": 7.7,
  "IEEE TRANSACTIONS ON INDUSTRIAL ELECTRONICS": 7.698,
  "JOURNAL OF POWER SOURCES": 7.667,
  "CARBON": 7.65,
  "MATERIALS RESEARCH LETTERS": 7.65,
  "MILBANK QUARTERLY": 7.608,
  "EUROSURVEILLANCE": 7.602,
  "ACTA NUMERICA": 7.6,
  "CONSERVATION LETTERS": 7.583,
  "IEEE TRANSACTIONS ON INDUSTRIAL INFORMATICS": 7.575,
  "SEMINARS IN IMMUNOLOGY": 7.57,
  "JOURNAL OF NUCLEAR MEDICINE": 7.57,
  "NEUROLOGY-NEUROIMMUNOLOGY & NEUROINFLAMMATION": 7.565,
  "MUCOSAL IMMUNOLOGY": 7.551,
  "IEEE TRANSACTIONS ON SYSTEMS MAN CYBERNETICS-SYSTEMS": 7.55,
  "AGING CELL": 7.543,
  "2D MATERIALS": 7.514,
  "INTERNATIONAL JOURNAL OF EPIDEMIOLOGY": 7.514,
  "JOURNAL OF PHYSICAL CHEMISTRY LETTERS": 7.508,
  "CLINICAL REVIEWS IN ALLERGY & IMMUNOLOGY": 7.503,
  "NEW PHYTOLOGIST": 7.503,
  "ACTA MATERIALIA": 7.467,
  "SCHIZOPHRENIA BULLETIN": 7.466,
  "ULTRASONICS SONOCHEMISTRY": 7.44,
  "CLINICAL & TRANSLATIONAL IMMUNOLOGY": 7.425,
  "ARCHIVES OF COMPUTATIONAL METHODS IN ENGINEERING": 7.425,
  "ADVANCES IN NUTRITION": 7.421,
  "BIOFABRICATION": 7.417,
  "BRITISH JOURNAL OF PSYCHIATRY": 7.397,
  "GASTROINTESTINAL ENDOSCOPY": 7.377,
  "INTERNATIONAL JOURNAL OF INTELLIGENT SYSTEMS": 7.358,
  "IEEE TRANSACTIONS ON POWER ELECTRONICS": 7.354,
  "SIAM REVIEW": 7.353,
  "DIABETES": 7.352,
  "ACADEMY OF MANAGEMENT JOURNAL": 7.351,
  "REVIEWS IN AQUACULTURE": 7.346,
  "EMERGING INFECTIOUS DISEASES": 7.343,
  "EUROPEAN JOURNAL OF NUCLEAR MEDICINE AND MOLECULAR IMAGING": 7.339,
  "ENERGY CONVERSION AND MANAGEMENT": 7.329,
  "ANNUAL REVIEW OF ORGANIZATIONAL PSYCHOLOGY AND ORGANIZATIONAL BEHAVIOR": 7.328,
  "ALCOHOL RESEARCH-CURRENT REVIEWS": 7.299,
  "ADDITIVE MANUFACTURING": 7.293,
  "AMERICAN JOURNAL OF TRANSPLANTATION": 7.289,
  "NEUROPSYCHOPHARMACOLOGY": 7.289,
  "ENVIRONMENTAL SCIENCE & TECHNOLOGY": 7.279,
  "ACS PHOTONICS": 7.271,
  "ADVANCED OPTICAL MATERIALS": 7.242,
  "JOURNAL OF SUPPLY CHAIN MANAGEMENT": 7.24,
  "DIABETOLOGIA": 7.236,
  "JOURNAL OF THE AMERICAN ACADEMY OF DERMATOLOGY": 7.233,
  "METHODS IN ECOLOGY AND EVOLUTION": 7.233,
  "MAYO CLINIC PROCEEDINGS": 7.229,
  "WILEY INTERDISCIPLINARY REVIEWS-CLIMATE CHANGE": 7.229,
  "CRITICAL REVIEWS IN BIOTECHNOLOGY": 7.224,
  "CURRENT OPINION IN STRUCTURAL BIOLOGY": 7.224,
  "MOLECULAR ECOLOGY RESOURCES": 7.199,
  "RESOURCES CONSERVATION AND RECYCLING": 7.191,
  "BMJ QUALITY & SAFETY": 7.19,
  "HYPERTENSION": 7.185,
  "JOURNAL OF MEMBRANE SCIENCE": 7.182,
  "CARDIOVASCULAR RESEARCH": 7.181,
  "CELLULAR AND MOLECULAR LIFE SCIENCES": 7.179,
  "MATRIX BIOLOGY": 7.174,
  "CRITICAL CARE MEDICINE": 7.173,
  "ACS SUSTAINABLE CHEMISTRY & ENGINEERING": 7.163,
  "NANOSCALE": 7.16,
  "CRITICAL CARE": 7.149,
  "ACS SENSORS": 7.143,
  "ISPRS JOURNAL OF PHOTOGRAMMETRY AND REMOTE SENSING": 7.125,
  "CANADIAN MEDICAL ASSOCIATION JOURNAL": 7.125,
  "ENVIRONMENTAL SCIENCE & TECHNOLOGY LETTERS": 7.113,
  "ADVANCES IN EXPERIMENTAL SOCIAL PSYCHOLOGY": 7.102,
  "NEW ASTRONOMY REVIEWS": 7.099,
  "PERSONNEL PSYCHOLOGY": 7.091,
  "BRAIN STIMULATION": 7.057,
  "CURRENT OPINION IN MICROBIOLOGY": 7.057,
  "LAB ON A CHIP": 7.054,
  "EPILEPSY CURRENTS": 7.052,
  "NANOPHOTONICS": 7.049,
  "INTERNATIONAL REVIEW OF SPORT AND EXERCISE PSYCHOLOGY": 7.044,
  "CLINICAL CHEMISTRY": 7.043,
  "BIOCHIMICA ET BIOPHYSICA ACTA-REVIEWS ON CANCER": 7.043,
  "DRUG DISCOVERY TODAY": 7.017,
  "NEUROPATHOLOGY AND APPLIED NEUROBIOLOGY": 7.015,
  "EDUCATIONAL PSYCHOLOGY REVIEW": 7.014,
  "COMPOSITES PART B-ENGINEERING": 7.014,
  "ECONOMIC GEOGRAPHY": 6.986,
  "PERSOONIA": 6.971,
  "ADDICTION": 6.97,
  "PLANT BIOTECHNOLOGY JOURNAL": 6.97,
  "VIRTUAL AND PHYSICAL PROTOTYPING": 6.959,
  "BULLETIN OF THE WORLD HEALTH ORGANIZATION": 6.944,
  "PROGRESS IN AEROSPACE SCIENCES": 6.942,
  "IEEE TRANSACTIONS ON POWER SYSTEMS": 6.938,
  "NEUROENDOCRINOLOGY": 6.934,
  "SEMINARS IN IMMUNOPATHOLOGY": 6.933,
  "NEUROSCIENTIST": 6.933,
  "IEEE TRANSACTIONS ON IMAGE PROCESSING": 6.93,
  "ALLERGY": 6.919,
  "POLYMER REVIEWS": 6.916,
  "CELL CHEMICAL BIOLOGY": 6.914,
  "MBIO": 6.909,
  "ACTA CRYSTALLOGRAPHICA SECTION B-STRUCTURAL SCIENCE CRYSTAL ENGINEERING AND MATERIALS": 6.908,
  "BMC BIOLOGY": 6.905,
  "EUROPEAN HEART JOURNAL-CARDIOVASCULAR PHARMACOTHERAPY": 6.891,
  "TOPICS IN CURRENT CHEMISTRY": 6.887,
  "BRITISH JOURNAL OF DERMATOLOGY": 6.88,
  "CRITICAL REVIEWS IN FOOD SCIENCE AND NUTRITION": 6.878,
  "IEEE JOURNAL OF SELECTED TOPICS IN SIGNAL PROCESSING": 6.866,
  "EBIOMEDICINE": 6.864,
  "EUROPEAN JOURNAL OF CANCER": 6.861,
  "BIORESOURCE TECHNOLOGY": 6.86,
  "CANCER AND METASTASIS REVIEWS": 6.851,
  "FISH AND FISHERIES": 6.851,
  "AMERICAN JOURNAL OF KIDNEY DISEASES": 6.84,
  "REVIEW OF ENVIRONMENTAL ECONOMICS AND POLICY": 6.825,
  "TRANSPORT REVIEWS": 6.818,
  "QUARTERLY REVIEWS OF BIOPHYSICS": 6.814,
  "JOURNAL OF MATERIALS CHEMISTRY C": 6.807,
  "ACTA BIOMATERIALIA": 6.804,
  "ADVANCES IN NONLINEAR ANALYSIS": 6.804,
  "ONCOGENE": 6.791,
  "ARTERIOSCLEROSIS THROMBOSIS AND VASCULAR BIOLOGY": 6.79,
  "GENOMICS PROTEOMICS & BIOINFORMATICS": 6.771,
  "BIOSCIENCE": 6.766,
  "BRITISH JOURNAL OF PHARMACOLOGY": 6.762,
  "PROGRESS IN HUMAN GEOGRAPHY": 6.747,
  "AMERICAN JOURNAL OF CLINICAL NUTRITION": 6.732,
  "ANNUAL REVIEW OF VIROLOGY": 6.723,
  "PARTICLE AND FIBRE TOXICOLOGY": 6.723,
  "ORGANIC LETTERS": 6.721,
  "ORGANIZATIONAL RESEARCH METHODS": 6.714,
  "EUROPEAN JOURNAL OF EPIDEMIOLOGY": 6.704,
  "CIRCULATION-HEART FAILURE": 6.688,
  "MSYSTEMS": 6.68,
  "METABOLISM-CLINICAL AND EXPERIMENTAL": 6.68,
  "TISSUE ENGINEERING PART B-REVIEWS": 6.669,
  "CANCER LETTERS": 6.667,
  "CLINICAL NUCLEAR MEDICINE": 6.655,
  "ACM TRANSACTIONS ON GRAPHICS": 6.653,
  "IEEE TRANSACTIONS ON ROBOTICS": 6.649,
  "SCIENCE SIGNALING": 6.648,
  "GONDWANA RESEARCH": 6.643,
  "BASIC RESEARCH IN CARDIOLOGY": 6.641,
  "PLOS PATHOGENS": 6.638,
  "CRITICAL REVIEWS IN SOLID STATE AND MATERIALS SCIENCES": 6.636,
  "EPIDEMIOLOGIC REVIEWS": 6.634,
  "EXERCISE IMMUNOLOGY REVIEW": 6.618,
  "JOURNAL OF ECONOMIC PERSPECTIVES": 6.597,
  "GEROSCIENCE": 6.591,
  "JOURNAL OF TOXICOLOGY AND ENVIRONMENTAL HEALTH-PART B-CRITICAL REVIEWS": 6.583,
  "CLINICAL MICROBIOLOGY AND INFECTION": 6.576,
  "ANESTHESIOLOGY": 6.568,
  "IEEE TRANSACTIONS ON DEPENDABLE AND SECURE COMPUTING": 6.566,
  "SOFT ROBOTICS": 6.561,
  "CLINICAL NUTRITION": 6.555,
  "EPIDEMIOLOGY AND PSYCHIATRIC SCIENCES": 6.551,
  "INTERNATIONAL JOURNAL OF NEURAL SYSTEMS": 6.529,
  "JOURNAL OF CLEANER PRODUCTION": 6.526,
  "IEEE TRANSACTIONS ON WIRELESS COMMUNICATIONS": 6.519,
  "SENSORS AND ACTUATORS B-CHEMICAL": 6.513,
  "JOURNAL OF THE AMERICAN ACADEMY OF CHILD AND ADOLESCENT PSYCHIATRY": 6.512,
  "BUSINESS STRATEGY AND THE ENVIRONMENT": 6.508,
  "ENDOSCOPY": 6.498,
  "PHYSIOLOGY": 6.495,
  "MODERN PATHOLOGY": 6.483,
  "JOURNAL OF COLLOID AND INTERFACE SCIENCE": 6.481,
  "AUTOMATICA": 6.478,
  "CORROSION SCIENCE": 6.47,
  "ANALYTICAL CHEMISTRY": 6.463,
  "ATOMIC DATA AND NUCLEAR DATA TABLES": 6.455,
  "JOURNAL OF POLITICAL ECONOMY": 6.455,
  "CLINICAL PHARMACOLOGY & THERAPEUTICS": 6.455,
  "JOURNAL OF BUSINESS VENTURING": 6.451,
  "NPJ BIOFILMS AND MICROBIOMES": 6.444,
  "SWARM AND EVOLUTIONARY COMPUTATION": 6.436,
  "ADVANCED ELECTRONIC MATERIALS": 6.425,
  "COMPOSITES SCIENCE AND TECHNOLOGY": 6.424,
  "PLANT PHYSIOLOGY": 6.404,
  "JOURNAL OF INVESTIGATIVE DERMATOLOGY": 6.403,
  "IEEE TRANSACTIONS ON AFFECTIVE COMPUTING": 6.402,
  "OCEANOGRAPHY AND MARINE BIOLOGY": 6.402,
  "COMPOSITES PART A-APPLIED SCIENCE AND MANUFACTURING": 6.402,
  "SCIENCE BULLETIN": 6.4,
  "CURRENT OPINION IN COLLOID & INTERFACE SCIENCE": 6.395,
  "ADVANCED HEALTHCARE MATERIALS": 6.394,
  "PSYCHOLOGICAL REVIEW": 6.393,
  "COMPREHENSIVE PHYSIOLOGY": 6.391,
  "CLINICAL JOURNAL OF THE AMERICAN SOCIETY OF NEPHROLOGY": 6.391,
  "IEEE CONTROL SYSTEMS MAGAZINE": 6.381,
  "TOBACCO CONTROL": 6.381,
  "REVIEWS OF PHYSIOLOGY BIOCHEMISTRY AND PHARMACOLOGY": 6.38,
  "EMERGING MICROBES & INFECTIONS": 6.365,
  "IEEE TRANSACTIONS ON INFORMATION FORENSICS AND SECURITY": 6.361,
  "ASTRONOMY & ASTROPHYSICS": 6.355,
  "COMPUTER-AIDED CIVIL AND INFRASTRUCTURE ENGINEERING": 6.355,
  "INTERNATIONAL JOURNAL OF RADIATION ONCOLOGY BIOLOGY PHYSICS": 6.35,
  "JOURNAL OF FINANCE": 6.349,
  "BRITISH JOURNAL OF ANAESTHESIA": 6.342,
  "CONSERVATION BIOLOGY": 6.336,
  "ENTREPRENEURSHIP THEORY AND PRACTICE": 6.333,
  "ENVIRONMENTAL RESEARCH LETTERS": 6.333,
  "FAMILY BUSINESS REVIEW": 6.33,
  "ALTEX-ALTERNATIVES TO ANIMAL EXPERIMENTATION": 6.312,
  "MOLECULAR METABOLISM": 6.309,
  "BRAIN BEHAVIOR AND IMMUNITY": 6.305,
  "JAMA OPHTHALMOLOGY": 6.29,
  "CHEMICAL COMMUNICATIONS": 6.288,
  "CANCERS": 6.286,
  "PROGRESS IN CARDIOVASCULAR DISEASES": 6.282,
  "AMERICAN JOURNAL OF SURGICAL PATHOLOGY": 6.277,
  "BRAIN PATHOLOGY": 6.271,
  "JOURNAL OF ECONOMIC GROWTH": 6.27,
  "IEEE VEHICULAR TECHNOLOGY MAGAZINE": 6.266,
  "ALZHEIMERS RESEARCH & THERAPY": 6.266,
  "WILEY INTERDISCIPLINARY REVIEWS-NANOMEDICINE AND NANOBIOTECHNOLOGY": 6.246,
  "PHILOSOPHICAL TRANSACTIONS OF THE ROYAL SOCIETY B-BIOLOGICAL SCIENCES": 6.243,
  "APPLIED MECHANICS REVIEWS": 6.228,
  "AMERICAN JOURNAL OF HEMATOLOGY": 6.221,
  "INTERNATIONAL JOURNAL OF ROBOTICS RESEARCH": 6.221,
  "DIABETES OBESITY & METABOLISM": 6.214,
  "ACM COMPUTING SURVEYS": 6.212,
  "JOURNAL OF CHILD PSYCHOLOGY AND PSYCHIATRY": 6.211,
  "BLOOD REVIEWS": 6.209,
  "AMERICAN JOURNAL OF OBSTETRICS AND GYNECOLOGY": 6.208,
  "JOURNAL OF THE AMERICAN SOCIETY OF ECHOCARDIOGRAPHY": 6.203,
  "CANCER": 6.201,
  "EUROPACE": 6.199,
  "AMERICAN JOURNAL OF SPORTS MEDICINE": 6.194,
  "INVESTIGATIVE RADIOLOGY": 6.193,
  "SCIENCE CHINA-CHEMISTRY": 6.192,
  "MUTATION RESEARCH-REVIEWS IN MUTATION RESEARCH": 6.188,
  "PROGRESS IN SOLID STATE CHEMISTRY": 6.183,
  "JOURNAL OF NEUROSCIENCE": 6.181,
  "INTERNATIONAL JOURNAL OF COMPUTER VISION": 6.17,
  "REVIEWS IN COMPUTATIONAL CHEMISTRY": 6.167,
  "CRITICAL REVIEWS IN BIOCHEMISTRY AND MOLECULAR BIOLOGY": 6.164,
  "CIRCULATION-CARDIOVASCULAR INTERVENTIONS": 6.162,
  "JOURNAL OF MEDICINAL CHEMISTRY": 6.162,
  "JOURNAL OF INTERNAL MEDICINE": 6.155,
  "STROKE": 6.155,
  "CARBOHYDRATE POLYMERS": 6.154,
  "JOURNAL OF CEREBRAL BLOOD FLOW AND METABOLISM": 6.145,
  "INTERNATIONAL JOURNAL OF MACHINE TOOLS & MANUFACTURE": 6.142,
  "INTERNATIONAL JOURNAL OF BEHAVIORAL NUTRITION AND PHYSICAL ACTIVITY": 6.14,
  "DESALINATION": 6.139,
  "PAIN": 6.138,
  "CLINICAL PSYCHOLOGY-SCIENCE AND PRACTICE": 6.137,
  "SOLAR ENERGY MATERIALS AND SOLAR CELLS": 6.134,
  "CURRENT OPINION IN NEUROBIOLOGY": 6.133,
  "JCI INSIGHT": 6.131,
  "TOURISM MANAGEMENT": 6.129,
  "MACROMOLECULES": 6.129,
  "ONCOGENESIS": 6.125,
  "CRITICAL REVIEWS IN ENVIRONMENTAL SCIENCE AND TECHNOLOGY": 6.12,
  "IEEE JOURNAL OF EMERGING AND SELECTED TOPICS IN POWER ELECTRONICS": 6.111,
  "IEEE TRANSACTIONS ON CLOUD COMPUTING": 6.102,
  "MOLECULAR ONCOLOGY": 6.1,
  "STEM CELLS TRANSLATIONAL MEDICINE": 6.093,
  "CELL DEATH & DISEASE": 6.091,
  "EDUCATIONAL PSYCHOLOGIST": 6.085,
  "NANOTOXICOLOGY": 6.081,
  "CARDIOVASCULAR DIABETOLOGY": 6.077,
  "ECOGRAPHY": 6.074,
  "LIVER CANCER": 6.071,
  "JOURNAL OF PATHOLOGY": 6.071,
  "INORGANIC CHEMISTRY FRONTIERS": 6.069,
  "SCIENTIFIC DATA": 6.06,
  "NBER MACROECONOMICS ANNUAL": 6.054,
  "JOURNAL OF PERSONALITY AND SOCIAL PSYCHOLOGY": 6.051,
  "MOLECULAR THERAPY-NUCLEIC ACIDS": 6.046,
  "JOURNAL OF MEDICAL GENETICS": 6.044,
  "PATTERN RECOGNITION": 6.04,
  "ACTA NEUROPATHOLOGICA COMMUNICATIONS": 6.039,
  "ANAESTHESIA": 6.037,
  "ENVIRONMENTAL SCIENCES EUROPE": 6.035,
  "SIGNAL TRANSDUCTION AND TARGETED THERAPY": 6.029,
  "ACTA PHYSIOLOGICA": 6.028,
  "CHINESE PHYSICS C": 6.019,
  "ADVANCES IN CATALYSIS": 6.014,
  "FOUNDATIONS AND TRENDS IN INFORMATION RETRIEVAL": 6.014,
  "IEEE COMPUTATIONAL INTELLIGENCE MAGAZINE": 6.012,
  "MOLECULAR ECOLOGY": 5.997,
  "TRANSLATIONAL STROKE RESEARCH": 5.995,
  "KIDNEY INTERNATIONAL SUPPLEMENTS": 5.98,
  "FOOD HYDROCOLLOIDS": 5.972,
  "JOURNAL OF MANAGEMENT STUDIES": 5.967,
  "JOURNAL OF HIGH ENERGY PHYSICS": 5.962,
  "GLIA": 5.962,
  "ANTIOXIDANTS & REDOX SIGNALING": 5.959,
  "CIRCULATION-CARDIOVASCULAR IMAGING": 5.956,
  "NEUROIMAGE": 5.955,
  "ACTA PHARMACEUTICA SINICA B": 5.948,
  "INTERNATIONAL JOURNAL OF PLASTICITY": 5.946,
  "JOURNAL OF WORLD BUSINESS": 5.944,
  "AMERICAN JOURNAL OF BIOETHICS": 5.942,
  "NEURAL NETWORKS": 5.934,
  "JOURNAL OF APPLIED ECOLOGY": 5.929,
  "EARTHS FUTURE": 5.923,
  "NUTRITION REVIEWS": 5.919,
  "ACS MACRO LETTERS": 5.919,
  "TRANSPORTATION RESEARCH PART C-EMERGING TECHNOLOGIES": 5.899,
  "ADVANCES IN IMMUNOLOGY": 5.898,
  "MATERIALS & DESIGN": 5.883,
  "FUTURE GENERATION COMPUTER SYSTEMS-THE INTERNATIONAL JOURNAL OF ESCIENCE": 5.879,
  "DEVELOPMENT": 5.878,
  "ANGIOGENESIS": 5.873,
  "GEOCHEMICAL PERSPECTIVES": 5.868,
  "IEEE TRANSACTIONS ON INTELLIGENT TRANSPORTATION SYSTEMS": 5.861,
  "ARCHIVES OF TOXICOLOGY": 5.857,
  "NEUROPSYCHOLOGY REVIEW": 5.857,
  "GLOBAL BIOGEOCHEMICAL CYCLES": 5.857,
  "CATALYSIS SCIENCE & TECHNOLOGY": 5.855,
  "PLANT JOURNAL": 5.847,
  "ADVANCES IN ECOLOGICAL RESEARCH": 5.842,
  "ENVIRONMENTAL POLLUTION": 5.839,
  "MOLECULAR AUTISM": 5.839,
  "HEALTH AFFAIRS": 5.833,
  "JOURNAL OF BONE AND MINERAL RESEARCH": 5.829,
  "MOLECULAR THERAPY-ONCOLYTICS": 5.828,
  "IEEE TRANSACTIONS ON SERVICES COMPUTING": 5.813,
  "JOURNAL OF NEUROINFLAMMATION": 5.812,
  "CRITICAL REVIEWS IN MICROBIOLOGY": 5.808,
  "HARVARD BUSINESS REVIEW": 5.8,
  "IEEE TRANSACTIONS ON COMMUNICATIONS": 5.789,
  "JOURNAL OF CLINICAL MEDICINE": 5.786,
  "JOURNAL OF ECOLOGY": 5.786,
  "AMERICAN JOURNAL OF MEDICAL GENETICS PART C-SEMINARS IN MEDICAL GENETICS": 5.785,
  "BREAST CANCER RESEARCH": 5.782,
  "THERAPEUTIC ADVANCES IN MEDICAL ONCOLOGY": 5.781,
  "ATMOSPHERIC CHEMISTRY AND PHYSICS": 5.779,
  "BIOMACROMOLECULES": 5.775,
  "GLOBAL ECOLOGY AND BIOGEOGRAPHY": 5.775,
  "PHYSICS OF THE DARK UNIVERSE": 5.771,
  "FREE RADICAL BIOLOGY AND MEDICINE": 5.77,
  "CELLS": 5.768,
  "BROOKINGS PAPERS ON ECONOMIC ACTIVITY": 5.763,
  "MULTIPLE SCLEROSIS JOURNAL": 5.759,
  "JOURNAL OF UROLOGY": 5.75,
  "JOURNAL OF EXPERIMENTAL & CLINICAL CANCER RESEARCH": 5.744,
  "PSYCHOLOGICAL MEDICINE": 5.741,
  "EUROPEAN JOURNAL OF PREVENTIVE CARDIOLOGY": 5.739,
  "SCIENCE CHINA-MATERIALS": 5.739,
  "LEADERSHIP QUARTERLY": 5.733,
  "IEEE TRANSACTIONS ON GEOSCIENCE AND REMOTE SENSING": 5.726,
  "COMPUTERS & EDUCATION": 5.726,
  "PLANT CELL AND ENVIRONMENT": 5.724,
  "ANNUAL REVIEW OF VISION SCIENCE": 5.714,
  "CEMENT AND CONCRETE RESEARCH": 5.712,
  "MICROSYSTEMS & NANOENGINEERING": 5.711,
  "STEM CELLS": 5.711,
  "JOURNAL OF CLINICAL ENDOCRINOLOGY & METABOLISM": 5.711,
  "ADVANCES IN VIRUS RESEARCH": 5.71,
  "NUTRITION RESEARCH REVIEWS": 5.707,
  "ULTRASOUND IN OBSTETRICS & GYNECOLOGY": 5.7,
  "CANADIAN JOURNAL OF CARDIOLOGY": 5.697,
  "SCIENCE OF THE TOTAL ENVIRONMENT": 5.691,
  "BRITISH JOURNAL OF SURGERY": 5.69,
  "ASTROPHYSICAL JOURNAL": 5.688,
  "PHARMACOLOGICAL RESEARCH": 5.687,
  "ECOSYSTEM SERVICES": 5.683,
  "STRATEGIC MANAGEMENT JOURNAL": 5.676,
  "ACS SYNTHETIC BIOLOGY": 5.67,
  "JOURNAL OF STROKE": 5.668,
  "NANOMEDICINE-NANOTECHNOLOGY BIOLOGY AND MEDICINE": 5.667,
  "COLD SPRING HARBOR PERSPECTIVES IN MEDICINE": 5.667,
  "FUNGAL BIOLOGY REVIEWS": 5.66,
  "EPILEPSIA": 5.657,
  "GASTRIC CANCER": 5.656,
  "NEUROTHERAPEUTICS": 5.655,
  "JOURNAL OF PHYSIOTHERAPY": 5.649,
  "LIVER INTERNATIONAL": 5.647,
  "ENERGY": 5.646,
  "TRANSLATIONAL NEURODEGENERATION": 5.641,
  "ENERGY RESEARCH & SOCIAL SCIENCE": 5.641,
  "INFORMATION SCIENCES": 5.64,
  "JOURNAL OF COSMOLOGY AND ASTROPARTICLE PHYSICS": 5.636,
  "PHOTONICS RESEARCH": 5.631,
  "JOURNAL OF ABNORMAL PSYCHOLOGY": 5.63,
  "REVIEWS IN ENDOCRINE & METABOLIC DISORDERS": 5.627,
  "AGING-US": 5.627,
  "CORPORATE SOCIAL RESPONSIBILITY AND ENVIRONMENTAL MANAGEMENT": 5.624,
  "HUMAN REPRODUCTION": 5.622,
  "CONTACT DERMATITIS": 5.618,
  "TRENDS IN ENVIRONMENTAL ANALYTICAL CHEMISTRY": 5.616,
  "STEM CELL REPORTS": 5.614,
  "ASTRONOMICAL JOURNAL": 5.605,
  "CLINICAL EPIGENETICS": 5.6,
  "ANNALS OF TOURISM RESEARCH": 5.595,
  "HEPATOLOGY INTERNATIONAL": 5.595,
  "MICROCHIMICA ACTA": 5.592,
  "RNA BIOLOGY": 5.589,
  "REVIEWS OF ENVIRONMENTAL CONTAMINATION AND TOXICOLOGY": 5.586,
  "SEMINARS IN CELL & DEVELOPMENTAL BIOLOGY": 5.58,
  "CYTOKINE & GROWTH FACTOR REVIEWS": 5.574,
  "TRAUMA VIOLENCE & ABUSE": 5.572,
  "GLOBAL FOOD SECURITY-AGRICULTURE POLICY ECONOMICS AND ENVIRONMENT": 5.572,
  "BIOTECHNOLOGY FOR BIOFUELS": 5.572,
  "IEEE TRANSACTIONS ON MULTIMEDIA": 5.571,
  "ADVANCED SYNTHESIS & CATALYSIS": 5.571,
  "RENEWABLE ENERGY": 5.57,
  "CEREBRAL CORTEX": 5.564,
  "WASTE MANAGEMENT": 5.563,
  "RESEARCH POLICY": 5.562,
  "JOURNAL OF PAIN": 5.554,
  "BRITISH JOURNAL OF CANCER": 5.552,
  "FERTILITY AND STERILITY": 5.551,
  "COMMUNICATIONS OF THE ACM": 5.542,
  "JOURNAL OF ECONOMIC LITERATURE": 5.537,
  "VIRUS EVOLUTION": 5.534,
  "PEDIATRICS": 5.525,
  "CURRENT OPINION IN VIROLOGY": 5.524,
  "EXPERT OPINION ON DRUG DELIVERY": 5.524,
  "FOOD CHEMISTRY": 5.522,
  "ADVANCED MATERIALS TECHNOLOGIES": 5.519,
  "AMERICAN SOCIOLOGICAL REVIEW": 5.516,
  "FASEB JOURNAL": 5.515,
  "CHEMICAL RECORD": 5.513,
  "ELECTROCHIMICA ACTA": 5.506,
  "AMERICAN JOURNAL OF PUBLIC HEALTH": 5.504,
  "AMERICAN STATISTICIAN": 5.5,
  "IEEE TRANSACTIONS ON CONTROL SYSTEMS TECHNOLOGY": 5.499,
  "JOURNAL OF EXPERIMENTAL BOTANY": 5.497,
  "JOURNAL OF NANOBIOTECHNOLOGY": 5.496,
  "OMEGA-INTERNATIONAL JOURNAL OF MANAGEMENT SCIENCE": 5.493,
  "IEEE TRANSACTIONS ON VEHICULAR TECHNOLOGY": 5.49,
  "JOURNAL OF TRAVEL RESEARCH": 5.479,
  "ONCOIMMUNOLOGY": 5.477,
  "MEDICAL JOURNAL OF AUSTRALIA": 5.462,
  "INTERNATIONAL JOURNAL OF COAL GEOLOGY": 5.46,
  "JOURNAL OF CHEMICAL THEORY AND COMPUTATION": 5.458,
  "SOIL BIOLOGY & BIOCHEMISTRY": 5.457,
  "CURRENT OPINION IN GENETICS & DEVELOPMENT": 5.456,
  "INTERNET AND HIGHER EDUCATION": 5.452,
  "JOURNAL OF NETWORK AND COMPUTER APPLICATIONS": 5.452,
  "IEEE TRANSACTIONS ON TRANSPORTATION ELECTRIFICATION": 5.451,
  "NONLINEAR ANALYSIS-HYBRID SYSTEMS": 5.439,
  "JOURNAL OF THORACIC AND CARDIOVASCULAR SURGERY": 5.437,
  "EUROPEAN HEART JOURNAL-CARDIOVASCULAR IMAGING": 5.431,
  "ANALYTICA CHIMICA ACTA": 5.425,
  "ONCOLOGIST": 5.424,
  "RADIOTHERAPY AND ONCOLOGY": 5.416,
  "BIOMATERIALS SCIENCE": 5.411,
  "FORUM OF MATHEMATICS PI": 5.41,
  "INDUSTRIAL AND ORGANIZATIONAL PSYCHOLOGY-PERSPECTIVES ON SCIENCE AND PRACTICE": 5.41,
  "PHOTOACOUSTICS": 5.408,
  "TECHNOVATION": 5.401,
  "CLINICAL SCIENCE": 5.4,
  "CLINICS IN LIVER DISEASE": 5.4,
  "MONTHLY NOTICES OF THE ROYAL ASTRONOMICAL SOCIETY": 5.399,
  "UNIVERSITY OF PENNSYLVANIA LAW REVIEW": 5.395,
  "IEEE TRANSACTIONS ON SIGNAL PROCESSING": 5.391,
  "SURVEYS IN GEOPHYSICS": 5.391,
  "HEART RHYTHM": 5.387,
  "IEEE TRANSACTIONS ON AUTOMATION SCIENCE AND ENGINEERING": 5.383,
  "PLOS GENETICS": 5.381,
  "CONTEMPORARY PHYSICS": 5.381,
  "INTERNATIONAL JOURNAL OF PHYSICAL DISTRIBUTION & LOGISTICS MANAGEMENT": 5.381,
  "ANNALS OF EMERGENCY MEDICINE": 5.371,
  "HUMAN GENETICS": 5.36,
  "BRITISH JOURNAL OF HAEMATOLOGY": 5.345,
  "FRONTIERS IN CELL AND DEVELOPMENTAL BIOLOGY": 5.341,
  "EDUCATIONAL RESEARCH REVIEW": 5.341,
  "CURRENT OPINION IN PHARMACOLOGY": 5.339,
  "JOURNAL OF BIOMEDICAL SCIENCE": 5.338,
  "ANNUAL REVIEW OF ANIMAL BIOSCIENCES": 5.333,
  "BJOG-AN INTERNATIONAL JOURNAL OF OBSTETRICS AND GYNAECOLOGY": 5.332,
  "JOURNAL OF THE INTERNATIONAL AIDS SOCIETY": 5.33,
  "JOURNAL OF CO2 UTILIZATION": 5.313,
  "TRANSLATIONAL PSYCHIATRY": 5.29,
  "JOURNAL OF EDUCATIONAL PSYCHOLOGY": 5.288,
  "NATUREZA & CONSERVACAO": 5.284,
  "IEEE JOURNAL OF SOLID-STATE CIRCUITS": 5.273,
  "CEMENT & CONCRETE COMPOSITES": 5.27,
  "JOURNAL OF ENERGY CHEMISTRY": 5.266,
  "CHEMISTRY-A EUROPEAN JOURNAL": 5.261,
  "NEUROBIOLOGY OF DISEASE": 5.26,
  "APPLIED SURFACE SCIENCE": 5.256,
  "GEOSCIENTIFIC MODEL DEVELOPMENT": 5.252,
  "RHEUMATOLOGY": 5.252,
  "ENVIRONMENTAL MICROBIOLOGY": 5.251,
  "LANDSCAPE AND URBAN PLANNING": 5.25,
  "JOURNAL OF PEST SCIENCE": 5.25,
  "JOURNAL OF GASTROENTEROLOGY": 5.25,
  "FUEL": 5.25,
  "JOURNAL OF OCCUPATIONAL HEALTH PSYCHOLOGY": 5.25,
  "NEUROINFORMATICS": 5.237,
  "REVISTA ESPANOLA DE CARDIOLOGIA": 5.233,
  "JOURNAL OF DENTAL RESEARCH": 5.231,
  "FRONTIERS IN BIOENGINEERING AND BIOTECHNOLOGY": 5.231,
  "JOURNAL OF ANTIMICROBIAL CHEMOTHERAPY": 5.23,
  "JOURNAL OF THE EUROPEAN ACADEMY OF DERMATOLOGY AND VENEREOLOGY": 5.226,
  "REGIONAL ANESTHESIA AND PAIN MEDICINE": 5.225,
  "CELL COMMUNICATION AND SIGNALING": 5.224,
  "CHEMOSPHERE": 5.224,
  "EUROPEAN JOURNAL OF ENDOCRINOLOGY": 5.219,
  "SEPARATION AND PURIFICATION TECHNOLOGY": 5.212,
  "PROGRESS IN QUANTUM ELECTRONICS": 5.209,
  "KNOWLEDGE-BASED SYSTEMS": 5.207,
  "JOURNAL OF INFECTION": 5.206,
  "CELL BIOLOGY AND TOXICOLOGY": 5.206,
  "ARTIFICIAL INTELLIGENCE REVIEW": 5.204,
  "IEEE TRANSACTIONS ON AUTOMATIC CONTROL": 5.203,
  "ACADEMIC MEDICINE": 5.203,
  "HEART": 5.2,
  "ORGANIC CHEMISTRY FRONTIERS": 5.193,
  "SEMINARS IN ARTHRITIS AND RHEUMATISM": 5.192,
  "JOURNAL OF CARDIOVASCULAR MAGNETIC RESONANCE": 5.189,
  "BMJ OPEN DIABETES RESEARCH & CARE": 5.182,
  "JOURNAL OF APPLIED PSYCHOLOGY": 5.178,
  "JOURNAL OF MOLECULAR BIOLOGY": 5.176,
  "INTERNATIONAL JOURNAL OF INFORMATION MANAGEMENT": 5.173,
  "CANCER EPIDEMIOLOGY BIOMARKERS & PREVENTION": 5.172,
  "JOURNAL OF MOLECULAR AND CELLULAR CARDIOLOGY": 5.162,
  "JOURNAL OF MATERIALS CHEMISTRY B": 5.16,
  "JOURNAL OF INFECTIOUS DISEASES": 5.16,
  "JOURNAL OF ADVANCED RESEARCH": 5.155,
  "PERSPECTIVES ON SEXUAL AND REPRODUCTIVE HEALTH": 5.154,
  "THERAPEUTIC ADVANCES IN MUSCULOSKELETAL DISEASE": 5.149,
  "RESEARCH SYNTHESIS METHODS": 5.147,
  "JOURNAL OF MATERIALS SCIENCE & TECHNOLOGY": 5.144,
  "CELL PROLIFERATION": 5.144,
  "EVOLUTIONARY APPLICATIONS": 5.133,
  "FUNCTIONAL ECOLOGY": 5.13,
  "VALUE IN HEALTH": 5.128,
  "ALLERGY ASTHMA & IMMUNOLOGY RESEARCH": 5.128,
  "ENVIRONMENTAL RESEARCH": 5.127,
  "CHILD DEVELOPMENT": 5.126,
  "CELLULAR ONCOLOGY": 5.125,
  "NPJ VACCINES": 5.122,
  "PROCEEDINGS OF THE NUTRITION SOCIETY": 5.113,
  "JOURNAL OF SANDWICH STRUCTURES & MATERIALS": 5.113,
  "BUSINESS & SOCIETY": 5.113,
  "CRITICAL REVIEWS IN ONCOLOGY HEMATOLOGY": 5.111,
  "HARMFUL ALGAE": 5.108,
  "JOURNAL OF MOLECULAR CATALYSIS A-CHEMICAL": 5.107,
  "GEOLOGY": 5.107,
  "MECHANICAL SYSTEMS AND SIGNAL PROCESSING": 5.105,
  "AUSTRALIAN AND NEW ZEALAND JOURNAL OF PSYCHIATRY": 5.101,
  "ADVANCES IN PHYSICS-X": 5.099,
  "CALIFORNIA MANAGEMENT REVIEW": 5.097,
  "JOURNAL OF ORGANIZATIONAL BEHAVIOR": 5.095,
  "YALE LAW JOURNAL": 5.093,
  "INTERNATIONAL JOURNAL OF PRODUCTION ECONOMICS": 5.083,
  "DRUGS": 5.082,
  "IEEE TRANSACTIONS ON EMERGING TOPICS IN COMPUTING": 5.076,
  "INTERNATIONAL JOURNAL OF CANCER": 5.072,
  "JOURNAL OF INDUSTRIAL AND ENGINEERING CHEMISTRY": 5.07,
  "REVIEW OF FINANCIAL STUDIES": 5.067,
  "CIRCULATION-ARRHYTHMIA AND ELECTROPHYSIOLOGY": 5.067,
  "OBSTETRICS AND GYNECOLOGY": 5.067,
  "JOURNAL OF CLINICAL MICROBIOLOGY": 5.063,
  "MATERIALS SCIENCE & ENGINEERING C-MATERIALS FOR BIOLOGICAL APPLICATIONS": 5.057,
  "PALLIATIVE MEDICINE": 5.055,
  "JOURNAL OF PHYSIOLOGY-LONDON": 5.047,
  "JOURNAL OF MEDICAL INTERNET RESEARCH": 5.045,
  "IEEE-ASME TRANSACTIONS ON MECHATRONICS": 5.045,
  "STRUCTURAL HEALTH MONITORING-AN INTERNATIONAL JOURNAL": 5.045,
  "REVIEWS IN ENVIRONMENTAL SCIENCE AND BIO-TECHNOLOGY": 5.045,
  "BIPOLAR DISORDERS": 5.043,
  "HYDROLOGY AND EARTH SYSTEM SCIENCES": 5.04,
  "DEPRESSION AND ANXIETY": 5.039,
  "EUROPEAN RESPIRATORY REVIEW": 5.038,
  "WILEY INTERDISCIPLINARY REVIEWS-RNA": 5.037,
  "DEVELOPMENTAL COGNITIVE NEUROSCIENCE": 5.037,
  "AMYLOID-JOURNAL OF PROTEIN FOLDING DISORDERS": 5.037,
  "TALANTA": 5.026,
  "ANNUAL REVIEW OF SOCIOLOGY": 5.026,
  "TRANSLATIONAL RESEARCH": 5.024,
  "CHINESE JOURNAL OF CATALYSIS": 5.02,
  "ADVANCES IN GENETICS": 5.02,
  "SUSTAINABLE ENERGY & FUELS": 5.017,
  "ACS INFECTIOUS DISEASES": 5.015,
  "CLINICAL RESEARCH IN CARDIOLOGY": 5.013,
  "INTEGRATED COMPUTER-AIDED ENGINEERING": 5.012,
  "BIODRUGS": 5.012,
  "PSYCHOLOGICAL SCIENCE": 5.008,
  "CANCER IMMUNOLOGY IMMUNOTHERAPY": 5.006,
  "JOURNAL OF PSYCHIATRY & NEUROSCIENCE": 5.005,
  "JOURNAL OF THE AMERICAN MEDICAL DIRECTORS ASSOCIATION": 5,
  "JOURNAL OF COMPUTER-MEDIATED COMMUNICATION": 5,
  "JOURNAL OF ACCOUNTING RESEARCH": 5,
  "CATALYSIS TODAY": 5,
  "FORENSIC SCIENCE INTERNATIONAL-GENETICS": 5,
  "ENERGY POLICY": 5,
  "OSTEOARTHRITIS AND CARTILAGE": 4.998,
  "PUBLICATIONS OF THE ASTRONOMICAL SOCIETY OF AUSTRALIA": 4.993,
  "MOLECULAR THERAPY-METHODS & CLINICAL DEVELOPMENT": 4.989,
  "APPLIED SOFT COMPUTING": 4.982,
  "JOURNAL OF BEHAVIORAL ADDICTIONS": 4.978,
  "JOURNAL OF NEUROCHEMISTRY": 4.975,
  "INTERNATIONAL JOURNAL OF LIFE CYCLE ASSESSMENT": 4.968,
  "OXIDATIVE MEDICINE AND CELLULAR LONGEVITY": 4.965,
  "TRAVEL MEDICINE AND INFECTIOUS DISEASE": 4.959,
  "DIALOGUES IN CLINICAL NEUROSCIENCE": 4.959,
  "JOURNAL OF ENVIRONMENTAL MANAGEMENT": 4.956,
  "CIRCULATION-CARDIOVASCULAR GENETICS": 4.95,
  "MICROBIAL BIOTECHNOLOGY": 4.945,
  "MOLECULAR CANCER THERAPEUTICS": 4.943,
  "MICROBIAL GENOMICS": 4.939,
  "INORGANIC CHEMISTRY": 4.938,
  "GLOBAL CHANGE BIOLOGY BIOENERGY": 4.936,
  "DEVELOPMENTAL REVIEW": 4.936,
  "INTERNATIONAL JOURNAL OF APPLIED EARTH OBSERVATION AND GEOINFORMATION": 4.935,
  "ESSAYS IN BIOCHEMISTRY": 4.935,
  "CURRENT OPINION IN LIPIDOLOGY": 4.929,
  "EUROPEAN PHYSICAL JOURNAL C": 4.928,
  "EUROPEAN JOURNAL OF MEDICINAL CHEMISTRY": 4.92,
  "BIOLOGY AND FERTILITY OF SOILS": 4.92,
  "COMPOSITE STRUCTURES": 4.919,
  "MOLECULAR & CELLULAR PROTEOMICS": 4.916,
  "JOURNAL OF INDUSTRIAL ECOLOGY": 4.915,
  "BIOCHEMICAL PHARMACOLOGY": 4.915,
  "COMPUTER METHODS IN APPLIED MECHANICS AND ENGINEERING": 4.914,
  "BUILDING AND ENVIRONMENT": 4.913,
  "CRITICAL REVIEWS IN CLINICAL LABORATORY SCIENCES": 4.912,
  "ENVIRONMENTAL SCIENCE & POLICY": 4.911,
  "TRANSLATIONAL LUNG CANCER RESEARCH": 4.907,
  "JOURNAL OF CLIMATE": 4.904,
  "CLINICAL AND TRANSLATIONAL GASTROENTEROLOGY": 4.903,
  "IEEE TRANSACTIONS ON CONTROL OF NETWORK SYSTEMS": 4.902,
  "IEEE POWER & ENERGY MAGAZINE": 4.9,
  "NEW MEDIA & SOCIETY": 4.899,
  "CLIMATE POLICY": 4.899,
  "CRYOSPHERE": 4.899,
  "INTERNATIONAL JOURNAL OF BIOLOGICAL MACROMOLECULES": 4.896,
  "FOOD AND ENERGY SECURITY": 4.891,
  "INDUSTRIAL MARKETING MANAGEMENT": 4.888,
  "IEEE TRANSACTIONS ON SOFTWARE ENGINEERING": 4.884,
  "NUCLEAR DATA SHEETS": 4.88,
  "VIRULENCE": 4.88,
  "ENDOCRINE-RELATED CANCER": 4.879,
  "PHARMACEUTICS": 4.878,
  "CRITICAL REVIEWS IN TOXICOLOGY": 4.875,
  "COMPUTERS IN INDUSTRY": 4.873,
  "REVIEW OF ECONOMIC STUDIES": 4.873,
  "AMERICAN JOURNAL OF MEDICINE": 4.873,
  "POLYMER CHEMISTRY": 4.87,
  "VACCINES": 4.868,
  "ANNUAL REVIEWS IN CONTROL": 4.868,
  "DIABETES-METABOLISM RESEARCH AND REVIEWS": 4.868,
  "INFECTIOUS DISEASE CLINICS OF NORTH AMERICA": 4.867,
  "IUCRJ": 4.865,
  "RESPIROLOGY": 4.864,
  "JOURNAL OF PEASANT STUDIES": 4.857,
  "CANCER SCIENCE": 4.856,
  "JOURNAL OF MOLECULAR MEDICINE-JMM": 4.853,
  "JOURNAL OF ORGANIC CHEMISTRY": 4.85,
  "EXPERIMENTAL AND MOLECULAR MEDICINE": 4.849,
  "JOURNAL OF LIPID RESEARCH": 4.846,
  "CLINICAL AND EXPERIMENTAL ALLERGY": 4.846,
  "BIOCHIMICA ET BIOPHYSICA ACTA-MOLECULAR CELL RESEARCH": 4.845,
  "EXERCISE AND SPORT SCIENCES REVIEWS": 4.844,
  "FEBS JOURNAL": 4.843,
  "AMERICAN JOURNAL OF CANCER RESEARCH": 4.833,
  "THROMBOSIS AND HAEMOSTASIS": 4.829,
  "OPERATIONS MANAGEMENT RESEARCH": 4.829,
  "COMPUTATIONAL AND STRUCTURAL BIOTECHNOLOGY JOURNAL": 4.828,
  "EPIDEMIOLOGY": 4.826,
  "JOURNAL OF IMMUNOLOGY": 4.825,
  "NANOMEDICINE": 4.821,
  "FRONTIERS IN IMMUNOLOGY": 4.82,
  "JOURNAL OF BONE AND JOINT SURGERY-AMERICAN VOLUME": 4.817,
  "ANTIMICROBIAL AGENTS AND CHEMOTHERAPY": 4.816,
  "SEPARATION AND PURIFICATION REVIEWS": 4.806,
  "ADVANCED MATERIALS INTERFACES": 4.805,
  "JOURNALS OF GERONTOLOGY SERIES A-BIOLOGICAL SCIENCES AND MEDICAL SCIENCES": 4.803,
  "INDOOR AIR": 4.802,
  "EUROPEAN JOURNAL OF PHARMACEUTICS AND BIOPHARMACEUTICS": 4.8,
  "MAMMAL REVIEW": 4.8,
  "DRUG METABOLISM REVIEWS": 4.797,
  "JOURNAL OF CONSUMER RESEARCH": 4.79,
  "STEM CELL REVIEWS AND REPORTS": 4.784,
  "EUROPEAN JOURNAL OF IMMUNOLOGY": 4.781,
  "ACTA PSYCHIATRICA SCANDINAVICA": 4.779,
  "BIOMOLECULES": 4.778,
  "INTERNATIONAL JOURNAL OF PROJECT MANAGEMENT": 4.778,
  "JOURNAL OF FINANCIAL ECONOMICS": 4.775,
  "JOURNAL OF INTERACTIVE MARKETING": 4.774,
  "GIGASCIENCE": 4.773,
  "PERSONALITY DISORDERS-THEORY RESEARCH AND TREATMENT": 4.771,
  "JOURNAL OF PHYSICAL AND CHEMICAL REFERENCE DATA": 4.769,
  "IEEE TRANSACTIONS ON NETWORK AND SERVICE MANAGEMENT": 4.767,
  "CANCER GENE THERAPY": 4.76,
  "IEEE JOURNAL OF SELECTED TOPICS IN QUANTUM ELECTRONICS": 4.76,
  "CLINICAL PHARMACOKINETICS": 4.76,
  "HARVARD LAW REVIEW": 4.759,
  "SOIL & TILLAGE RESEARCH": 4.758,
  "BONE MARROW TRANSPLANTATION": 4.757,
  "SOLAR ENERGY": 4.756,
  "JOURNAL OF MOLECULAR CELL BIOLOGY": 4.756,
  "SUSTAINABILITY SCIENCE": 4.754,
  "ADVANCES IN CANCER RESEARCH": 4.751,
  "NEURAL COMPUTING & APPLICATIONS": 4.746,
  "JOURNAL OF THROMBOSIS AND HAEMOSTASIS": 4.745,
  "EPMA JOURNAL": 4.743,
  "JOURNAL OF THE AMERICAN HEART ASSOCIATION": 4.743,
  "PUBLIC ADMINISTRATION REVIEW": 4.741,
  "JOURNAL OF CELLULAR AND MOLECULAR MEDICINE": 4.739,
  "ANNALS OF CLINICAL AND TRANSLATIONAL NEUROLOGY": 4.739,
  "MRS BULLETIN": 4.739,
  "PEDIATRIC ALLERGY AND IMMUNOLOGY": 4.737,
  "MOLECULAR NUTRITION & FOOD RESEARCH": 4.733,
  "JOURNAL OF CLINICAL EPIDEMIOLOGY": 4.727,
  "JOURNAL OF GENETICS AND GENOMICS": 4.72,
  "AGE": 4.719,
  "CURRENT OPINION IN NEUROLOGY": 4.719,
  "QUATERNARY SCIENCE REVIEWS": 4.718,
  "EARTH AND PLANETARY SCIENCE LETTERS": 4.717,
  "ONCOLOGY RESEARCH": 4.716,
  "APPLIED CATALYSIS A-GENERAL": 4.716,
  "STEM CELL RESEARCH & THERAPY": 4.715,
  "SUSTAINABLE CITIES AND SOCIETY": 4.714,
  "EXPERT OPINION ON THERAPEUTIC TARGETS": 4.713,
  "MEDICAL EDUCATION": 4.711,
  "ENVIRONMENTAL CHEMISTRY LETTERS": 4.711,
  "INTERNATIONAL JOURNAL OF ANTIMICROBIAL AGENTS": 4.71,
  "IEEE TRANSACTIONS ON ENERGY CONVERSION": 4.708,
  "ULTRASCHALL IN DER MEDIZIN": 4.706,
  "RUSSIAN CHEMICAL REVIEWS": 4.702,
  "JOURNAL OF GENERAL INTERNAL MEDICINE": 4.701,
  "NEUROSURGERY": 4.697,
  "JOURNAL OF KNOWLEDGE MANAGEMENT": 4.695,
  "NONLINEAR DYNAMICS": 4.694,
  "CELL DISCOVERY": 4.694,
  "PROSTATE CANCER AND PROSTATIC DISEASES": 4.694,
  "BIOCHIMICA ET BIOPHYSICA ACTA-GENE REGULATORY MECHANISMS": 4.694,
  "LUNG CANCER": 4.693,
  "TRANSPLANTATION": 4.691,
  "MOLECULAR NEUROBIOLOGY": 4.688,
  "GEOPHYSICAL RESEARCH LETTERS": 4.687,
  "STRUCTURE": 4.684,
  "TRANSPORTATION RESEARCH PART B-METHODOLOGICAL": 4.682,
  "RESUSCITATION": 4.681,
  "SLEEP": 4.681,
  "SCHIZOPHRENIA RESEARCH": 4.68,
  "CURRENT NEUROPHARMACOLOGY": 4.68,
  "ENGINEERING": 4.675,
  "ACCOUNTING REVIEW": 4.674,
  "EXPERIMENTAL NEUROLOGY": 4.674,
  "INTERNATIONAL JOURNAL OF PRECISION ENGINEERING AND MANUFACTURING-GREEN TECHNOLOGY": 4.671,
  "JOURNAL OF MOLECULAR LIQUIDS": 4.669,
  "ECOSYSTEMS": 4.667,
  "HUMAN BRAIN MAPPING": 4.664,
  "ENVIRONMENTAL MODELLING & SOFTWARE": 4.662,
  "JOURNAL OF NEURAL ENGINEERING": 4.661,
  "EMOTION REVIEW": 4.66,
  "IEEE TRANSACTIONS ON COMPUTATIONAL IMAGING": 4.659,
  "HUMAN MOLECULAR GENETICS": 4.658,
  "SCRIPTA MATERIALIA": 4.656,
  "EXPOSURE AND HEALTH": 4.655,
  "PHYSICAL REVIEW APPLIED": 4.654,
  "BIOINFORMATICS": 4.653,
  "BIOINFORMATICS (OXFORD, ENGLAND)": 4.653,
  "EXPERT REVIEW OF VACCINES": 4.65,
  "ARTHRITIS CARE & RESEARCH": 4.65,
  "INTERNATIONAL JOURNAL OF DRUG POLICY": 4.648,
  "JOURNAL OF GEODESY": 4.647,
  "ECOTOXICOLOGY AND ENVIRONMENTAL SAFETY": 4.641,
  "IMPLEMENTATION SCIENCE": 4.637,
  "BJU INTERNATIONAL": 4.634,
  "JOURNAL OF MAGNESIUM AND ALLOYS": 4.63,
  "JOURNAL OF CELLULAR PHYSIOLOGY": 4.627,
  "ANTIOXIDANTS": 4.624,
  "JOURNAL OF CELL SCIENCE": 4.621,
  "INTERNATIONAL JOURNAL OF OBESITY": 4.619,
  "ACS BIOMATERIALS SCIENCE & ENGINEERING": 4.617,
  "AGE AND AGEING": 4.615,
  "INTERNATIONAL ORGANIZATION": 4.614,
  "FUEL PROCESSING TECHNOLOGY": 4.613,
  "EUROPEAN REVIEW OF SOCIAL PSYCHOLOGY": 4.612,
  "INTERNATIONAL SECURITY": 4.606,
  "SOLID STATE PHYSICS": 4.605,
  "THEORETICAL LINGUISTICS": 4.604,
  "AIDS": 4.604,
  "CHEMCATCHEM": 4.6,
  "ENERGY AND BUILDINGS": 4.6,
  "IEEE TRANSACTIONS ON BIOMEDICAL ENGINEERING": 4.599,
  "ECOLOGICAL INDICATORS": 4.599,
  "JOURNAL OF NUTRITIONAL BIOCHEMISTRY": 4.593,
  "DIABETES TECHNOLOGY & THERAPEUTICS": 4.586,
  "PLOS NEGLECTED TROPICAL DISEASES": 4.578,
  "INTERNATIONAL JOURNAL OF HEALTH POLICY AND MANAGEMENT": 4.576,
  "MOLECULAR CANCER RESEARCH": 4.574,
  "AMERICAN JOURNAL OF OPHTHALMOLOGY": 4.574,
  "ARTIFICIAL INTELLIGENCE": 4.572,
  "CURRENT OPINION IN PSYCHIATRY": 4.571,
  "CURRENT DIRECTIONS IN PSYCHOLOGICAL SCIENCE": 4.569,
  "IEEE CIRCUITS AND SYSTEMS MAGAZINE": 4.569,
  "MEDICINE AND SCIENCE IN SPORTS AND EXERCISE": 4.568,
  "BIOELECTROCHEMISTRY": 4.568,
  "IEEE TRANSACTIONS ON MOBILE COMPUTING": 4.562,
  "AMERICAN JOURNAL OF EPIDEMIOLOGY": 4.562,
  "ADVANCES IN ATOMIC MOLECULAR AND OPTICAL PHYSICS": 4.561,
  "ADVANCES IN THE STUDY OF BEHAVIOR": 4.561,
  "INTERNATIONAL JOURNAL OF NANOMEDICINE": 4.555,
  "DEUTSCHES ARZTEBLATT INTERNATIONAL": 4.554,
  "EUROPEAN NEUROPSYCHOPHARMACOLOGY": 4.552,
  "CANCER BIOLOGY & MEDICINE": 4.551,
  "INTERNATIONAL JOURNAL OF STROKE": 4.547,
  "INTERNATIONAL JOURNAL OF HOSPITALITY MANAGEMENT": 4.546,
  "IEEE INTELLIGENT SYSTEMS": 4.544,
  "CURRENT OPINION IN CHEMICAL ENGINEERING": 4.539,
  "IEEE SYSTEMS JOURNAL": 4.532,
  "ARTIFICIAL CELLS NANOMEDICINE AND BIOTECHNOLOGY": 4.532,
  "TRENDS IN CARDIOVASCULAR MEDICINE": 4.531,
  "AMERICAN JOURNAL OF SOCIOLOGY": 4.531,
  "EMPIRICAL SOFTWARE ENGINEERING": 4.53,
  "ALDRICHIMICA ACTA": 4.528,
  "THERAPEUTIC ADVANCES IN CHRONIC DISEASE": 4.528,
  "HUMAN MUTATION": 4.527,
  "JOURNAL OF LABOR ECONOMICS": 4.525,
  "BIOLOGICAL CONSERVATION": 4.525,
  "JOURNAL OF THE AMERICAN COLLEGE OF SURGEONS": 4.524,
  "EUROPEAN JOURNAL OF NUTRITION": 4.523,
  "MSPHERE": 4.522,
  "BIOCHIMICA ET BIOPHYSICA ACTA-BIOENERGETICS": 4.52,
  "DENTAL MATERIALS": 4.517,
  "JOURNAL OF PHARMACEUTICAL ANALYSIS": 4.514,
  "CEPHALALGIA": 4.511,
  "WILEY INTERDISCIPLINARY REVIEWS-WATER": 4.511,
  "AMERICAN JOURNAL OF PREVENTIVE MEDICINE": 4.508,
  "IEEE TRANSACTIONS ON ANTENNAS AND PROPAGATION": 4.507,
  "BRITISH JOURNAL OF GENERAL PRACTICE": 4.5,
  "ARTHROSCOPY-THE JOURNAL OF ARTHROSCOPIC AND RELATED SURGERY": 4.5,
  "BULLETIN OF THE CHEMICAL SOCIETY OF JAPAN": 4.5,
  "ENVIRONMENTAL HEALTH": 4.5,
  "PLOS COMPUTATIONAL BIOLOGY": 4.499,
  "CHILD DEVELOPMENT PERSPECTIVES": 4.495,
  "JOURNAL OF MOLECULAR DIAGNOSTICS": 4.495,
  "STRUCTURAL EQUATION MODELING-A MULTIDISCIPLINARY JOURNAL": 4.491,
  "CANCER CYTOPATHOLOGY": 4.49,
  "NPJ GENOMIC MEDICINE": 4.49,
  "EXPERT OPINION ON DRUG DISCOVERY": 4.488,
  "INTERNATIONAL JOURNAL OF ELECTRICAL POWER & ENERGY SYSTEMS": 4.487,
  "JOURNAL OF NUTRITION": 4.485,
  "IEEE TRANSACTIONS ON POWER DELIVERY": 4.485,
  "EXPERT REVIEWS IN MOLECULAR MEDICINE": 4.484,
  "JOURNAL OF HYDROLOGY": 4.483,
  "MABS": 4.483,
  "EPIGENOMICS": 4.483,
  "BIOCHIMICA ET BIOPHYSICA ACTA-MOLECULAR AND CELL BIOLOGY OF LIPIDS": 4.483,
  "MICROBIAL CELL FACTORIES": 4.481,
  "EVOLUTION MEDICINE AND PUBLIC HEALTH": 4.481,
  "CLINICAL TOXICOLOGY": 4.478,
  "NEUROBIOLOGY OF AGING": 4.474,
  "BIOESSAYS": 4.474,
  "MOLECULAR PHARMACEUTICS": 4.473,
  "GYNECOLOGIC ONCOLOGY": 4.471,
  "IEEE CLOUD COMPUTING": 4.471,
  "ROBOTICS AND COMPUTER-INTEGRATED MANUFACTURING": 4.471,
  "FOREIGN AFFAIRS": 4.469,
  "EUROPEAN JOURNAL OF NEUROLOGY": 4.468,
  "PROCESS SAFETY AND ENVIRONMENTAL PROTECTION": 4.467,
  "APL PHOTONICS": 4.466,
  "CURRENT HIV/AIDS REPORTS": 4.465,
  "JOURNAL OF ENDOCRINOLOGY": 4.464,
  "INTERNATIONAL JOURNAL OF HYGIENE AND ENVIRONMENTAL HEALTH": 4.463,
  "MOLECULAR PLANT PATHOLOGY": 4.463,
  "CIRCULATION-CARDIOVASCULAR QUALITY AND OUTCOMES": 4.462,
  "ECOLOGICAL APPLICATIONS": 4.462,
  "JOURNAL OF ENVIRONMENTAL INFORMATICS": 4.458,
  "ACS CHEMICAL BIOLOGY": 4.457,
  "IEEE TRANSACTIONS ON BROADCASTING": 4.455,
  "MIS QUARTERLY": 4.455,
  "CARBON BALANCE AND MANAGEMENT": 4.453,
  "FORBES": 4.452,
  "PHYSICAL REVIEW D": 4.451,
  "NEUROPHARMACOLOGY": 4.45,
  "JOURNAL OF ANIMAL ECOLOGY": 4.449,
  "BONE": 4.447,
  "PARKINSONISM & RELATED DISORDERS": 4.441,
  "JOURNAL OF CONSULTING AND CLINICAL PSYCHOLOGY": 4.44,
  "JOURNAL OF CLINICAL CHILD AND ADOLESCENT PSYCHOLOGY": 4.44,
  "AMERICAN JOURNAL OF POLITICAL SCIENCE": 4.438,
  "EARTH SYSTEM DYNAMICS": 4.436,
  "BIOCONJUGATE CHEMISTRY": 4.435,
  "LANDSCAPE ECOLOGY": 4.435,
  "INTERNATIONAL JOURNAL OF HEAT AND MASS TRANSFER": 4.434,
  "JOURNAL OF FIELD ROBOTICS": 4.433,
  "TECHNOLOGICAL AND ECONOMIC DEVELOPMENT OF ECONOMY": 4.431,
  "ISA TRANSACTIONS": 4.43,
  "AMERICAN JOURNAL OF RESPIRATORY CELL AND MOLECULAR BIOLOGY": 4.428,
  "POLITICAL COMMUNICATION": 4.427,
  "GEODERMA": 4.426,
  "IMA FUNGUS": 4.426,
  "BIOCHEMICAL JOURNAL": 4.426,
  "PROGRESS IN PHYSICAL GEOGRAPHY-EARTH AND ENVIRONMENT": 4.425,
  "BIOCHIMICA ET BIOPHYSICA ACTA-MOLECULAR BASIS OF DISEASE": 4.422,
  "CRITICAL REVIEWS IN ANALYTICAL CHEMISTRY": 4.421,
  "LIMNOLOGY AND OCEANOGRAPHY": 4.418,
  "JOURNAL OF VIROLOGY": 4.416,
  "PROGRESS IN NEURO-PSYCHOPHARMACOLOGY & BIOLOGICAL PSYCHIATRY": 4.415,
  "AUTOMATION IN CONSTRUCTION": 4.407,
  "GOVERNMENT INFORMATION QUARTERLY": 4.405,
  "BEHAVIOUR RESEARCH AND THERAPY": 4.405,
  "JOURNAL OF PHYSICAL CHEMISTRY C": 4.404,
  "COMPUTERS IN HUMAN BEHAVIOR": 4.402,
  "AMERICAN ECONOMIC JOURNAL-APPLIED ECONOMICS": 4.402,
  "PROCEEDINGS OF THE ROYAL SOCIETY B-BIOLOGICAL SCIENCES": 4.4,
  "BONE & JOINT JOURNAL": 4.398,
  "JMIR MHEALTH AND UHEALTH": 4.398,
  "CYTOTHERAPY": 4.396,
  "APL MATERIALS": 4.396,
  "SUPPLY CHAIN MANAGEMENT-AN INTERNATIONAL JOURNAL": 4.393,
  "ANNALS OF THE NEW YORK ACADEMY OF SCIENCES": 4.393,
  "BRITISH JOURNAL OF POLITICAL SCIENCE": 4.392,
  "EXPERT SYSTEMS WITH APPLICATIONS": 4.39,
  "JOURNAL OF THE AMERICAN MEDICAL INFORMATICS ASSOCIATION": 4.387,
  "BIOCHEMICAL SOCIETY TRANSACTIONS": 4.384,
  "JOURNAL OF CYSTIC FIBROSIS": 4.383,
  "CELLULAR MICROBIOLOGY": 4.382,
  "COGNITIVE COMPUTATION": 4.381,
  "JOURNAL OF INHERITED METABOLIC DISEASE": 4.379,
  "ECOLOGY": 4.379,
  "ECOLOGICAL ECONOMICS": 4.378,
  "ECONOMETRICA": 4.378,
  "ANTHROPOCENE": 4.375,
  "CORTEX": 4.374,
  "LAND DEGRADATION & DEVELOPMENT": 4.374,
  "CURRENT OPINION IN HIV AND AIDS": 4.373,
  "AGRONOMY FOR SUSTAINABLE DEVELOPMENT": 4.373,
  "BIOTECHNOLOGY AND BIOENGINEERING": 4.372,
  "FRONTIERS IN MICROBIOLOGY": 4.368,
  "CURRENT OPINION IN ENVIRONMENTAL SUSTAINABILITY": 4.368,
  "GEOCHIMICA ET COSMOCHIMICA ACTA": 4.367,
  "JOURNAL OF GENERAL PHYSIOLOGY": 4.364,
  "JOURNAL OF NATURAL PRODUCTS": 4.36,
  "PHYTOCHEMISTRY REVIEWS": 4.36,
  "GEOSTANDARDS AND GEOANALYTICAL RESEARCH": 4.358,
  "ATHEROSCLEROSIS": 4.356,
  "JOURNAL OF GEOPHYSICAL RESEARCH-EARTH SURFACE": 4.354,
  "TRANSPORTATION RESEARCH PART E-LOGISTICS AND TRANSPORTATION REVIEW": 4.351,
  "IEEE TRANSACTIONS ON BIOMEDICAL CIRCUITS AND SYSTEMS": 4.349,
  "LANDSLIDES": 4.349,
  "IEEE ROBOTICS & AUTOMATION MAGAZINE": 4.346,
  "IMMUNITY & AGEING": 4.345,
  "FOOD CONTROL": 4.344,
  "NEUROSCIENCE BULLETIN": 4.343,
  "AGING AND DISEASE": 4.34,
  "CLINICAL AND TRANSLATIONAL ALLERGY": 4.339,
  "BIOFUELS BIOPRODUCTS & BIOREFINING-BIOFPR": 4.336,
  "ELEMENTS": 4.333,
  "ADDICTION BIOLOGY": 4.331,
  "JOURNAL OF PSYCHOPHARMACOLOGY": 4.329,
  "MANAGEMENT SCIENCE": 4.328,
  "MICROBIOLOGY SPECTRUM": 4.325,
  "FOOD ENGINEERING REVIEWS": 4.325,
  "IEEE JOURNAL OF BIOMEDICAL AND HEALTH INFORMATICS": 4.324,
  "ARCHIVOS DE BRONCONEUMOLOGIA": 4.315,
  "INTERNATIONAL JOURNAL OF PHARMACEUTICS": 4.313,
  "JOURNAL OF HYPERTENSION": 4.311,
  "INTERNATIONAL JOURNAL OF NEUROPSYCHOPHARMACOLOGY": 4.309,
  "JOURNAL OF NEUROLOGY": 4.309,
  "JOURNAL OF MARKETING RESEARCH": 4.306,
  "JOURNAL OF SECOND LANGUAGE WRITING": 4.304,
  "REVIEWS IN CHEMICAL ENGINEERING": 4.304,
  "NEPHROLOGY DIALYSIS TRANSPLANTATION": 4.301,
  "ELECTROCHEMISTRY COMMUNICATIONS": 4.301,
  "ANNALS OF PHYSICAL AND REHABILITATION MEDICINE": 4.297,
  "ENVIRONMENTAL SCIENCE-WATER RESEARCH & TECHNOLOGY": 4.296,
  "JOURNAL OF ENVIRONMENTAL POLICY & PLANNING": 4.296,
  "ADVANCES IN ENGINEERING SOFTWARE": 4.295,
  "GLYCOBIOLOGY": 4.292,
  "PARTICLE & PARTICLE SYSTEMS CHARACTERIZATION": 4.292,
  "CNS DRUGS": 4.292,
  "INDUSTRIAL CROPS AND PRODUCTS": 4.292,
  "AGRICULTURAL AND FOREST METEOROLOGY": 4.291,
  "CRITICAL REVIEWS IN PLANT SCIENCES": 4.29,
  "PPAR RESEARCH": 4.288,
  "ANNALS OF FAMILY MEDICINE": 4.287,
  "EPIGENETICS & CHROMATIN": 4.287,
  "INTERNATIONAL JOURNAL OF MOLECULAR SCIENCES": 4.285,
  "JOURNAL OF METAMORPHIC GEOLOGY": 4.281,
  "MICROPOROUS AND MESOPOROUS MATERIALS": 4.281,
  "CARDIOVASCULAR DRUGS AND THERAPY": 4.281,
  "PHYTOMEDICINE": 4.281,
  "JOURNAL OF MATERIALS PROCESSING TECHNOLOGY": 4.278,
  "JOURNAL OF FOOD AND DRUG ANALYSIS": 4.275,
  "JOURNAL OF ALLOYS AND COMPOUNDS": 4.275,
  "JOURNAL OF ENVIRONMENTAL ECONOMICS AND MANAGEMENT": 4.268,
  "EPIGENETICS": 4.263,
  "PIGMENT CELL & MELANOMA RESEARCH": 4.26,
  "NUTRIENTS": 4.259,
  "CLIMATIC CHANGE": 4.258,
  "INTERNATIONAL IMMUNOLOGY": 4.258,
  "ADVANCES IN HETEROCYCLIC CHEMISTRY": 4.258,
  "MICROORGANISMS": 4.257,
  "ANNALS OF MATHEMATICS": 4.257,
  "JOURNAL OF CLINICAL PERIODONTOLOGY": 4.256,
  "JOURNAL OF LIGHTWAVE TECHNOLOGY": 4.255,
  "PHYSICS LETTERS B": 4.253,
  "GEOSCIENCE FRONTIERS": 4.253,
  "LIVER TRANSPLANTATION": 4.253,
  "JOURNAL OF HYDROMETEOROLOGY": 4.252,
  "JOURNAL OF TRAVEL MEDICINE": 4.252,
  "CLINICAL ORTHOPAEDICS AND RELATED RESEARCH": 4.25,
  "CULTURAL ANTHROPOLOGY": 4.25,
  "JOURNAL OF CHEMINFORMATICS": 4.248,
  "CRYSTAL GROWTH & DESIGN": 4.246,
  "ARCHIVES OF PATHOLOGY & LABORATORY MEDICINE": 4.232,
  "ENERGY ECONOMICS": 4.232,
  "ENDOCRINE PRACTICE": 4.224,
  "ARTHRITIS RESEARCH & THERAPY": 4.224,
  "JOURNAL OF TISSUE ENGINEERING": 4.223,
  "IMMUNOLOGY": 4.221,
  "WATER RESOURCES RESEARCH": 4.219,
  "JOURNAL OF THE ACADEMY OF NUTRITION AND DIETETICS": 4.219,
  "EUROPEAN JOURNAL OF ANAESTHESIOLOGY": 4.218,
  "JOURNAL OF NEUROSCIENCE RESEARCH": 4.217,
  "FRONTIERS IN ONCOLOGY": 4.217,
  "ECOLOGY AND SOCIETY": 4.214,
  "INTERNATIONAL JOURNAL OF MECHANICAL SCIENCES": 4.213,
  "AGRICULTURAL SYSTEMS": 4.209,
  "ANTIVIRAL RESEARCH": 4.207,
  "JOURNAL OF NEUROSURGERY": 4.204,
  "FUZZY OPTIMIZATION AND DECISION MAKING": 4.2,
  "JOURNAL OF CLINICAL IMMUNOLOGY": 4.2,
  "PLASMA SOURCES SCIENCE & TECHNOLOGY": 4.2,
  "INTERNATIONAL COMMUNICATIONS IN HEAT AND MASS TRANSFER": 4.198,
  "AMERICAN JOURNAL OF PHYSIOLOGY-ENDOCRINOLOGY AND METABOLISM": 4.197,
  "INFORMATION COMMUNICATION & SOCIETY": 4.196,
  "ADVANCES IN MICROBIAL PHYSIOLOGY": 4.195,
  "COMBUSTION AND FLAME": 4.195,
  "INFORMATION & MANAGEMENT": 4.194,
  "REMOTE SENSING": 4.194,
  "CLINICAL LUNG CANCER": 4.194,
  "ATMOSPHERIC RESEARCH": 4.192,
  "JOURNAL OF THE AMERICAN GERIATRICS SOCIETY": 4.191,
  "JOURNAL OF NUCLEAR CARDIOLOGY": 4.189,
  "INTERNATIONAL JOURNAL OF OPERATIONS & PRODUCTION MANAGEMENT": 4.189,
  "ORGANIZATIONAL PSYCHOLOGY REVIEW": 4.186,
  "INTERNET RESEARCH": 4.185,
  "JOURNAL OF PARENTERAL AND ENTERAL NUTRITION": 4.185,
  "FRONTIERS IN PLANT SCIENCE": 4.183,
  "JOURNAL OF BIOLOGICAL CHEMISTRY": 4.182,
  "CLINICAL GENETICS": 4.182,
  "AMBIO": 4.181,
  "GLOBAL AND PLANETARY CHANGE": 4.18,
  "GEOBIOLOGY": 4.178,
  "ORGANOMETALLICS": 4.176,
  "ROCK MECHANICS AND ROCK ENGINEERING": 4.175,
  "FEMS MICROBIOLOGY ECOLOGY": 4.175,
  "IEEE ACCESS": 4.173,
  "JOURNAL OF TRANSLATIONAL MEDICINE": 4.172,
  "AMERICAN ECONOMIC REVIEW": 4.171,
  "DEVELOPMENTAL SCIENCE": 4.168,
  "BIOLOGICAL PROCEDURES ONLINE": 4.168,
  "ENVIRONMENT AND BEHAVIOR": 4.167,
  "DIVERSITY AND DISTRIBUTIONS": 4.167,
  "JOURNAL OF MACHINE LEARNING RESEARCH": 4.165,
  "JOURNAL OF THE AMERICAN MATHEMATICAL SOCIETY": 4.164,
  "FOOD MICROBIOLOGY": 4.162,
  "DISEASES OF THE COLON & RECTUM": 4.162,
  "JOURNAL OF THE MECHANICS AND PHYSICS OF SOLIDS": 4.16,
  "SIGNAL PROCESSING": 4.159,
  "INNOVATIVE FOOD SCIENCE & EMERGING TECHNOLOGIES": 4.158,
  "JOURNAL OF INNATE IMMUNITY": 4.155,
  "INTERNATIONAL JOURNAL OF HYDROGEN ENERGY": 4.154,
  "JOURNAL OF AFFECTIVE DISORDERS": 4.154,
  "MATERIALS SCIENCE AND ENGINEERING A-STRUCTURAL MATERIALS PROPERTIES MICROSTRUCTURE AND PROCESSING": 4.154,
  "CANADIAN JOURNAL OF PSYCHIATRY-REVUE CANADIENNE DE PSYCHIATRIE": 4.153,
  "MACROMOLECULAR RAPID COMMUNICATIONS": 4.151,
  "APPLIED AND ENVIRONMENTAL MICROBIOLOGY": 4.151,
  "EXTREME MECHANICS LETTERS": 4.149,
  "NEUROCOMPUTING": 4.148,
  "JOURNAL OF SERVICE RESEARCH": 4.148,
  "INTERNATIONAL JOURNAL OF BIOLOGICAL SCIENCES": 4.147,
  "JOURNAL OF PHOTOCHEMISTRY AND PHOTOBIOLOGY B-BIOLOGY": 4.142,
  "BEHAVIOR RESEARCH METHODS": 4.141,
  "AMERICAN JOURNAL OF PHYSIOLOGY-LUNG CELLULAR AND MOLECULAR PHYSIOLOGY": 4.14,
  "OPTICS AND LASERS IN ENGINEERING": 4.139,
  "CELL DIVISION": 4.137,
  "ADVANCES IN ORGANOMETALLIC CHEMISTRY": 4.136,
  "DALTON TRANSACTIONS": 4.136,
  "MOLECULAR BRAIN": 4.134,
  "TRANSPORTATION RESEARCH PART D-TRANSPORT AND ENVIRONMENT": 4.131,
  "AMERICAN JOURNAL OF PHYSIOLOGY-HEART AND CIRCULATORY PHYSIOLOGY": 4.13,
  "CLIMATE DYNAMICS": 4.13,
  "CHILD MALTREATMENT": 4.128,
  "CONSTRUCTION AND BUILDING MATERIALS": 4.128,
  "IEEE TRANSACTIONS ON CIRCUITS AND SYSTEMS FOR VIDEO TECHNOLOGY": 4.128,
  "MANAGEMENT ACCOUNTING RESEARCH": 4.127,
  "PLANT GENOME": 4.125,
  "JOURNAL OF SYSTEMATICS AND EVOLUTION": 4.124,
  "WORLD JOURNAL OF BIOLOGICAL PSYCHIATRY": 4.12,
  "RELIABILITY ENGINEERING & SYSTEM SAFETY": 4.12,
  "JOURNAL OF TECHNOLOGY TRANSFER": 4.12,
  "NANOMATERIALS": 4.12,
  "GEOCHEMICAL PERSPECTIVES LETTERS": 4.118,
  "EXPERT OPINION ON INVESTIGATIONAL DRUGS": 4.117,
  "JOURNAL OF THE EUROPEAN CERAMIC SOCIETY": 4.114,
  "JOURNAL OF GINSENG RESEARCH": 4.113,
  "DISEASE MODELS & MECHANISMS": 4.113,
  "JOURNAL OF BUSINESS RESEARCH": 4.112,
  "ANATOMICAL SCIENCES EDUCATION": 4.111,
  "JOURNAL OF ENZYME INHIBITION AND MEDICINAL CHEMISTRY": 4.111,
  "APPLIED THERMAL ENGINEERING": 4.109,
  "ANNALS OF THE AMERICAN THORACIC SOCIETY": 4.109,
  "AMERICAN HEART JOURNAL": 4.109,
  "JOURNAL OF CLINICAL PSYCHIATRY": 4.106,
  "APOPTOSIS": 4.106,
  "ANALYST": 4.104,
  "DYES AND PIGMENTS": 4.103,
  "EUROINTERVENTION": 4.1,
  "ASIAN JOURNAL OF PHARMACEUTICAL SCIENCES": 4.1,
  "JOURNAL OF VIRAL HEPATITIS": 4.1,
  "HEART FAILURE REVIEWS": 4.1,
  "PSYCHONEUROENDOCRINOLOGY": 4.098,
  "ATMOSPHERIC ENVIRONMENT": 4.098,
  "JOURNAL OF LEUKOCYTE BIOLOGY": 4.098,
  "SCIENTIFIC REPORTS": 4.097,
  "ACTA PHARMACOLOGICA SINICA": 4.096,
  "DIABETES & METABOLISM": 4.094,
  "INTERNATIONAL JOURNAL OF FOOD MICROBIOLOGY": 4.093,
  "INFLAMMATORY BOWEL DISEASES": 4.092,
  "CARCINOGENESIS": 4.091,
  "BELL LABS TECHNICAL JOURNAL": 4.091,
  "DNA RESEARCH": 4.089,
  "JOURNAL OF STRATEGIC INFORMATION SYSTEMS": 4.087,
  "SKELETAL MUSCLE": 4.087,
  "CURRENT DIABETES REPORTS": 4.086,
  "NEUROCHEMISTRY INTERNATIONAL": 4.085,
  "MOLECULAR PHYLOGENETICS AND EVOLUTION": 4.085,
  "FUNGAL ECOLOGY": 4.084,
  "CTS-CLINICAL AND TRANSLATIONAL SCIENCE": 4.084,
  "JOURNAL OF DERMATOLOGICAL SCIENCE": 4.084,
  "SCIENCE CHINA-PHYSICS MECHANICS & ASTRONOMY": 4.081,
  "INTERNATIONAL JOURNAL OF DIGITAL EARTH": 4.08,
  "CURRENT ALLERGY AND ASTHMA REPORTS": 4.08,
  "INTERNATIONAL JOURNAL OF SPORTS PHYSIOLOGY AND PERFORMANCE": 4.078,
  "CHEMELECTROCHEM": 4.077,
  "TECTONICS": 4.075,
  "COLLOIDS AND SURFACES B-BIOINTERFACES": 4.072,
  "JOURNAL OF CRIMINAL JUSTICE": 4.071,
  "GEOTEXTILES AND GEOMEMBRANES": 4.067,
  "GEOLOGICAL SOCIETY OF AMERICA BULLETIN": 4.067,
  "JOURNAL OF GEOPHYSICAL RESEARCH-PLANETS": 4.063,
  "OBESITY": 4.06,
  "COMMUNICATIONS IN NONLINEAR SCIENCE AND NUMERICAL SIMULATION": 4.059,
  "JOURNAL OF CHEMICAL INFORMATION AND MODELING": 4.056,
  "ALLERGOLOGY INTERNATIONAL": 4.053,
  "EUROPEAN RADIOLOGY": 4.052,
  "QUATERNARY GEOCHRONOLOGY": 4.051,
  "THERAPEUTIC ADVANCES IN GASTROENTEROLOGY": 4.051,
  "SURVEY OF OPHTHALMOLOGY": 4.051,
  "ENVIRONMENTAL REVIEWS": 4.048,
  "INTERNATIONAL JOURNAL OF CONTEMPORARY HOSPITALITY MANAGEMENT": 4.048,
  "JOURNAL OF ADOLESCENT HEALTH": 4.047,
  "RESEARCH IN ORGANIZATIONAL BEHAVIOR": 4.046,
  "AGRICULTURE ECOSYSTEMS & ENVIRONMENT": 4.046,
  "INTERNATIONAL JOURNAL OF ROBUST AND NONLINEAR CONTROL": 4.044,
  "BIOGEOSCIENCES": 4.042,
  "CURRENT FORESTRY REPORTS": 4.04,
  "TRAFFIC": 4.04,
  "NUTRITIONAL NEUROSCIENCE": 4.039,
  "CURRENT ONCOLOGY REPORTS": 4.037,
  "HORMONES AND BEHAVIOR": 4.034,
  "RNA": 4.032,
  "IMMUNOLOGY AND CELL BIOLOGY": 4.031,
  "PLASTIC AND RECONSTRUCTIVE SURGERY": 4.029,
  "NEUROIMAGE-CLINICAL": 4.029,
  "TUNNELLING AND UNDERGROUND SPACE TECHNOLOGY": 4.028,
  "EUROPEAN PSYCHIATRY": 4.028,
  "CNS SPECTRUMS": 4.027,
  "PSYCHOSOMATIC MEDICINE": 4.027,
  "REACTION CHEMISTRY & ENGINEERING": 4.026,
  "IEEE TRANSACTIONS ON CIRCUITS AND SYSTEMS I-REGULAR PAPERS": 4.026,
  "FOOD REVIEWS INTERNATIONAL": 4.023,
  "CELL CALCIUM": 4.023,
  "ANNALS OF INTENSIVE CARE": 4.023,
  "PLANT AND CELL PHYSIOLOGY": 4.021,
  "STEM CELL RESEARCH": 4.019,
  "FRONTIERS IN SYSTEMS NEUROSCIENCE": 4.018,
  "PLANT MOLECULAR BIOLOGY": 4.018,
  "CURRENT OSTEOPOROSIS REPORTS": 4.016,
  "POSTHARVEST BIOLOGY AND TECHNOLOGY": 4.016,
  "BIOORGANIC CHEMISTRY": 4.015,
  "THEORETICAL AND APPLIED GENETICS": 4.013,
  "JOURNAL OF NEUROINTERVENTIONAL SURGERY": 4.012,
  "STRUCTURAL AND MULTIDISCIPLINARY OPTIMIZATION": 4.012,
  "JOURNAL DER DEUTSCHEN DERMATOLOGISCHEN GESELLSCHAFT": 4.011,
  "RADIOGRAPHICS": 4.01,
  "ANNALS OF THORACIC SURGERY": 4.008,
  "COMMON MARKET LAW REVIEW": 4.006,
  "JOURNAL OF HEADACHE AND PAIN": 4.005,
  "CELLULOSE": 4.004,
  "JOURNAL OF PSYCHIATRIC RESEARCH": 4,
  "LEARNING AND INSTRUCTION": 4,
  "LIQUID CRYSTALS REVIEWS": 4,
  "POLICY STUDIES JOURNAL": 4,
  "ANNUAL REVIEW OF POLITICAL SCIENCE": 4,
  "LITHOS": 3.996,
  "OCEANOGRAPHY": 3.994,
  "HEPATOBILIARY SURGERY AND NUTRITION": 3.992,
  "BIOMEDICAL OPTICS EXPRESS": 3.99,
  "ENGINEERING GEOLOGY": 3.989,
  "EXPERT REVIEW OF CLINICAL IMMUNOLOGY": 3.986,
  "MOLECULAR BIOLOGY OF THE CELL": 3.986,
  "WORLD DEVELOPMENT": 3.985,
  "JOURNAL OF DIABETES INVESTIGATION": 3.982,
  "STEM CELLS INTERNATIONAL": 3.979,
  "FRONTIERS IN CELLULAR NEUROSCIENCE": 3.975,
  "JOURNAL OF QUANTITATIVE CRIMINOLOGY": 3.975,
  "STEEL AND COMPOSITE STRUCTURES": 3.973,
  "AUTISM": 3.973,
  "PHARMACEUTICAL RESEARCH": 3.972,
  "AMERICAN POLITICAL SCIENCE REVIEW": 3.97,
  "TOXINS": 3.969,
  "CURRENT MEDICINAL CHEMISTRY": 3.969,
  "INFORMATION PROCESSING & MANAGEMENT": 3.967,
  "APPLIED CLAY SCIENCE": 3.966,
  "OPEN BIOLOGY": 3.965,
  "SEISMOLOGICAL RESEARCH LETTERS": 3.962,
  "JOURNAL OF BIOGEOGRAPHY": 3.962,
  "FRONTIERS OF ENVIRONMENTAL SCIENCE & ENGINEERING": 3.961,
  "JOURNAL OF INFORMETRICS": 3.959,
  "DIALOGUES IN HUMAN GEOGRAPHY": 3.958,
  "PROGRESS IN PLANNING": 3.957,
  "JOURNAL OF EPIDEMIOLOGY AND COMMUNITY HEALTH": 3.957,
  "PROGRESS IN CRYSTAL GROWTH AND CHARACTERIZATION OF MATERIALS": 3.957,
  "JOURNAL OF NEUROIMMUNE PHARMACOLOGY": 3.955,
  "FIELD CROPS RESEARCH": 3.954,
  "BRITISH JOURNAL OF CLINICAL PHARMACOLOGY": 3.953,
  "CANCER PREVENTION RESEARCH": 3.951,
  "OPTICS LETTERS": 3.951,
  "BIOLOGY OF THE CELL": 3.951,
  "JAIDS-JOURNAL OF ACQUIRED IMMUNE DEFICIENCY SYNDROMES": 3.95,
  "ACS CHEMICAL NEUROSCIENCE": 3.949,
  "JOURNAL OF NATURAL GAS SCIENCE AND ENGINEERING": 3.949,
  "JOURNAL OF CHROMATOGRAPHY A": 3.949,
  "JOURNAL OF MEMORY AND LANGUAGE": 3.947,
  "MAGNETIC RESONANCE IN MEDICINE": 3.946,
  "ACADEMY OF MANAGEMENT PERSPECTIVES": 3.943,
  "ANNUAL REVIEW OF STATISTICS AND ITS APPLICATION": 3.942,
  "IEEE TRANSACTIONS ON KNOWLEDGE AND DATA ENGINEERING": 3.941,
  "JOURNAL OF CARDIAC FAILURE": 3.941,
  "JOURNAL OF HUMAN RESOURCES": 3.94,
  "AMERICAN NATURALIST": 3.937,
  "HUMAN GENE THERAPY": 3.937,
  "CITIES": 3.935,
  "MOLECULAR PHARMACOLOGY": 3.934,
  "CATENA": 3.933,
  "CURRENT OPINION IN RHEUMATOLOGY": 3.932,
  "CURRENT TREATMENT OPTIONS IN ONCOLOGY": 3.931,
  "COASTAL ENGINEERING": 3.929,
  "JOURNAL OF COUNSELING PSYCHOLOGY": 3.929,
  "DECISION SUPPORT SYSTEMS": 3.928,
  "EUROPEAN JOURNAL OF CARDIO-THORACIC SURGERY": 3.928,
  "HABITAT INTERNATIONAL": 3.927,
  "SEMINARS IN FETAL & NEONATAL MEDICINE": 3.927,
  "FRONTIERS IN PHARMACOLOGY": 3.926,
  "INTERNATIONAL JOURNAL OF MACHINE LEARNING AND CYBERNETICS": 3.926,
  "CRIMINOLOGY": 3.925,
  "JOURNAL OF THE INTERNATIONAL SOCIETY OF SPORTS NUTRITION": 3.925,
  "AMERICAN JOURNAL OF CLINICAL DERMATOLOGY": 3.924,
  "TOXIN REVIEWS": 3.923,
  "CHINESE CHEMICAL LETTERS": 3.919,
  "INFLAMMOPHARMACOLOGY": 3.918,
  "NEOPLASIA": 3.918,
  "JOURNAL OF THE TAIWAN INSTITUTE OF CHEMICAL ENGINEERS": 3.917,
  "PRECAMBRIAN RESEARCH": 3.917,
  "ENERGY REPORTS": 3.917,
  "DRUG DELIVERY": 3.917,
  "RESPIRATORY RESEARCH": 3.917,
  "CURRENT OPINION IN FOOD SCIENCE": 3.917,
  "JOURNAL OF POLICY ANALYSIS AND MANAGEMENT": 3.915,
  "ENVIRONMENTAL POLITICS": 3.913,
  "CIRP ANNALS-MANUFACTURING TECHNOLOGY": 3.913,
  "CLINICAL ORAL IMPLANTS RESEARCH": 3.911,
  "STANFORD LAW REVIEW": 3.91,
  "INTERNATIONAL BIODETERIORATION & BIODEGRADATION": 3.909,
  "JOURNAL OF INTEGRATIVE PLANT BIOLOGY": 3.907,
  "TAXON": 3.905,
  "SUSTAINABLE DEVELOPMENT": 3.905,
  "HEALTH TECHNOLOGY ASSESSMENT": 3.902,
  "OSTEOPOROSIS INTERNATIONAL": 3.902,
  "CURRENT PSYCHIATRY REPORTS": 3.9,
  "RETINA-THE JOURNAL OF RETINAL AND VITREOUS DISEASES": 3.899,
  "TECHNOLOGICAL FORECASTING AND SOCIAL CHANGE": 3.899,
  "IEEE PERVASIVE COMPUTING": 3.898,
  "INVESTIGATIVE OPHTHALMOLOGY & VISUAL SCIENCE": 3.896,
  "CELLULAR AND MOLECULAR NEUROBIOLOGY": 3.895,
  "REJUVENATION RESEARCH": 3.895,
  "VIRUSES-BASEL": 3.894,
  "BEST PRACTICE & RESEARCH CLINICAL ENDOCRINOLOGY & METABOLISM": 3.892,
  "EUROPEAN JOURNAL OF OPERATIONAL RESEARCH": 3.892,
  "BIOGERONTOLOGY": 3.89,
  "ASSESSMENT": 3.89,
  "IEEE ANTENNAS AND PROPAGATION MAGAZINE": 3.888,
  "NEUROGASTROENTEROLOGY AND MOTILITY": 3.884,
  "JOURNAL OF INVESTIGATIONAL ALLERGOLOGY AND CLINICAL IMMUNOLOGY": 3.883,
  "ENDOCRINOLOGY": 3.879,
  "JOURNAL OF DESTINATION MARKETING & MANAGEMENT": 3.879,
  "SEMINARS IN NUCLEAR MEDICINE": 3.875,
  "WORLD JOURNAL OF EMERGENCY SURGERY": 3.875,
  "JOURNAL OF BUSINESS ETHICS": 3.872,
  "MEDICAL CARE": 3.872,
  "AQUATIC TOXICOLOGY": 3.872,
  "BIOCHIMICA ET BIOPHYSICA ACTA-BIOMEMBRANES": 3.87,
  "TRANSACTIONS OF THE INSTITUTE OF BRITISH GEOGRAPHERS": 3.868,
  "FOOD POLICY": 3.867,
  "INTERNATIONAL REVIEW OF CELL AND MOLECULAR BIOLOGY": 3.866,
  "NICOTINE & TOBACCO RESEARCH": 3.866,
  "JOURNAL OF STEROID BIOCHEMISTRY AND MOLECULAR BIOLOGY": 3.863,
  "JOURNAL OF THE AMERICAN COLLEGE OF RADIOLOGY": 3.863,
  "MATHEMATICAL PROGRAMMING": 3.861,
  "PLANT SCIENCE": 3.859,
  "CURRENT OPINION IN INSECT SCIENCE": 3.858,
  "ADVANCES IN PROTEIN CHEMISTRY AND STRUCTURAL BIOLOGY": 3.858,
  "FRONTIERS IN CHEMISTRY": 3.858,
  "MARINE POLLUTION BULLETIN": 3.858,
  "METHODS": 3.857,
  "JOURNAL OF PRODUCT INNOVATION MANAGEMENT": 3.857,
  "IEEE TRANSACTIONS ON VISUALIZATION AND COMPUTER GRAPHICS": 3.857,
  "INTERNATIONAL JOURNAL OF ROCK MECHANICS AND MINING SCIENCES": 3.857,
  "JOURNAL OF PROTEOME RESEARCH": 3.857,
  "NUCLEIC ACID THERAPEUTICS": 3.855,
  "POLYMER DEGRADATION AND STABILITY": 3.855,
  "ARCHIVES OF DISEASE IN CHILDHOOD-FETAL AND NEONATAL EDITION": 3.853,
  "FOOD AND CHEMICAL TOXICOLOGY": 3.853,
  "REVIEWS IN FISHERIES SCIENCE & AQUACULTURE": 3.851,
  "JOURNAL OF THE ENERGY INSTITUTE": 3.851,
  "NEW JOURNAL OF PHYSICS": 3.851,
  "ADVANCED ENGINEERING INFORMATICS": 3.85,
  "MARINE DRUGS": 3.85,
  "POLYMER": 3.847,
  "CURRENT ATHEROSCLEROSIS REPORTS": 3.847,
  "ASTROBIOLOGY": 3.846,
  "PHYTOTHERAPY RESEARCH": 3.846,
  "EARTH SURFACE DYNAMICS": 3.845,
  "JOURNAL OF BIOPHOTONICS": 3.844,
  "AMERICAN JOURNAL OF PATHOLOGY": 3.842,
  "CURRENT POLLUTION REPORTS": 3.841,
  "MODERN LANGUAGE JOURNAL": 3.84,
  "SURGERY FOR OBESITY AND RELATED DISEASES": 3.84,
  "NEUROREHABILITATION AND NEURAL REPAIR": 3.839,
  "IEEE TRANSACTIONS ON MICROWAVE THEORY AND TECHNIQUES": 3.838,
  "JOURNAL OF NEUROTRAUMA": 3.837,
  "JOURNAL OF STRUCTURAL BIOLOGY": 3.834,
  "WILEY INTERDISCIPLINARY REVIEWS-DEVELOPMENTAL BIOLOGY": 3.834,
  "IEEE ELECTRON DEVICE LETTERS": 3.83,
  "JOURNAL OF ACCOUNTING & ECONOMICS": 3.829,
  "JOURNAL OF COMMUNICATION": 3.829,
  "CURRENT OPINION IN INFECTIOUS DISEASES": 3.828,
  "ENVIRONMENTAL IMPACT ASSESSMENT REVIEW": 3.828,
  "GENE THERAPY": 3.827,
  "HEADACHE": 3.826,
  "INTERNATIONAL AFFAIRS": 3.825,
  "COGNITIVE PSYCHOLOGY": 3.825,
  "MOVEMENT ECOLOGY": 3.824,
  "BUILDING RESEARCH AND INFORMATION": 3.824,
  "JOURNAL OF MOLECULAR ENDOCRINOLOGY": 3.823,
  "JOURNAL OF INTELLECTUAL CAPITAL": 3.821,
  "RETROVIROLOGY": 3.819,
  "BIOMEDICINE & PHARMACOTHERAPY": 3.819,
  "AIDS PATIENT CARE AND STDS": 3.816,
  "MYCOTOXIN RESEARCH": 3.816,
  "EUROPEAN CHILD & ADOLESCENT PSYCHIATRY": 3.815,
  "STRUCTURAL CONTROL & HEALTH MONITORING": 3.815,
  "JOURNAL OF PEDIATRICS": 3.813,
  "NEW BIOTECHNOLOGY": 3.812,
  "SEMINARS IN HEMATOLOGY": 3.811,
  "ACS MEDICINAL CHEMISTRY LETTERS": 3.811,
  "PHYSICAL REVIEW B": 3.811,
  "MOLECULAR AND CELLULAR BIOLOGY": 3.808,
  "EUROPEAN HEART JOURNAL-ACUTE CARDIOVASCULAR CARE": 3.806,
  "HIV MEDICINE": 3.805,
  "AMERICAN ECONOMIC JOURNAL-ECONOMIC POLICY": 3.804,
  "JOURNAL OF MAGNETIC RESONANCE IMAGING": 3.804,
  "KOREAN JOURNAL OF RADIOLOGY": 3.803,
  "ORAL ONCOLOGY": 3.802,
  "AMERICAN JOURNAL OF PHYSIOLOGY-GASTROINTESTINAL AND LIVER PHYSIOLOGY": 3.8,
  "PHYSICA STATUS SOLIDI-RAPID RESEARCH LETTERS": 3.8,
  "FLUIDS AND BARRIERS OF THE CNS": 3.798,
  "INDUSTRIAL MANAGEMENT & DATA SYSTEMS": 3.798,
  "SYSTEMATIC ENTOMOLOGY": 3.796,
  "GENOME BIOLOGY AND EVOLUTION": 3.795,
  "ALGAL RESEARCH-BIOMASS BIOFUELS AND BIOPRODUCTS": 3.795,
  "FRONTIERS IN MOLECULAR NEUROSCIENCE": 3.794,
  "ADVANCES IN WOUND CARE": 3.79,
  "LWT-FOOD SCIENCE AND TECHNOLOGY": 3.789,
  "TELEMATICS AND INFORMATICS": 3.788,
  "PEDIATRIC OBESITY": 3.788,
  "ENVIRONMENTAL AND EXPERIMENTAL BOTANY": 3.788,
  "FARADAY DISCUSSIONS": 3.786,
  "CLINICAL AND EXPERIMENTAL IMMUNOLOGY": 3.786,
  "DNA REPAIR": 3.785,
  "INTERNATIONAL SMALL BUSINESS JOURNAL-RESEARCHING ENTREPRENEURSHIP": 3.785,
  "ANNUAL REVIEW OF ECONOMICS": 3.785,
  "PHARMACOECONOMICS": 3.785,
  "JOURNAL OF HOSPITAL INFECTION": 3.784,
  "PSYCHONOMIC BULLETIN & REVIEW": 3.783,
  "REVIEWS IN MEDICAL VIROLOGY": 3.782,
  "MICROBIOLOGICAL RESEARCH": 3.782,
  "ADVANCES IN APPLIED MICROBIOLOGY": 3.782,
  "PROGRESS IN OPTICS": 3.781,
  "EXPERT OPINION ON THERAPEUTIC PATENTS": 3.781,
  "CURRENT PROBLEMS IN CANCER": 3.78,
  "CHEMISTRY-AN ASIAN JOURNAL": 3.78,
  "JOURNAL OF NEPHROLOGY": 3.78,
  "JOURNAL OF PARKINSONS DISEASE": 3.78,
  "AUTISM RESEARCH": 3.78,
  "ALEXANDRIA ENGINEERING JOURNAL": 3.776,
  "MOLECULAR AND CELLULAR ENDOCRINOLOGY": 3.775,
  "TRANSPORTATION RESEARCH PART A-POLICY AND PRACTICE": 3.775,
  "JOURNAL OF CELL COMMUNICATION AND SIGNALING": 3.774,
  "SPACE WEATHER-THE INTERNATIONAL JOURNAL OF RESEARCH AND APPLICATIONS": 3.773,
  "ANNALS OF TRANSLATIONAL MEDICINE": 3.772,
  "ORPHANET JOURNAL OF RARE DISEASES": 3.772,
  "FOOD QUALITY AND PREFERENCE": 3.771,
  "LABORATORY INVESTIGATION": 3.769,
  "WORLD ALLERGY ORGANIZATION JOURNAL": 3.768,
  "DATABASE-THE JOURNAL OF BIOLOGICAL DATABASES AND CURATION": 3.766,
  "LANGMUIR": 3.765,
  "TARGETED ONCOLOGY": 3.763,
  "EUROPEAN CELLS & MATERIALS": 3.762,
  "EUROPEAN JOURNAL OF PSYCHOLOGY APPLIED TO LEGAL CONTEXT": 3.762,
  "ANNALS OF SURGICAL ONCOLOGY": 3.762,
  "BIOCHIMICA ET BIOPHYSICA ACTA-GENERAL SUBJECTS": 3.758,
  "GEOMORPHOLOGY": 3.757,
  "CLINICAL NEUROPHYSIOLOGY": 3.756,
  "CATALYSIS COMMUNICATIONS": 3.754,
  "ADVANCES IN WATER RESOURCES": 3.754,
  "INTERNATIONAL JOURNAL OF FATIGUE": 3.754,
  "JOURNAL OF RETAILING": 3.753,
  "APPLIED MICROBIOLOGY AND BIOTECHNOLOGY": 3.753,
  "BMC PLANT BIOLOGY": 3.753,
  "JOURNAL OF DEMOCRACY": 3.752,
  "BIOPHYSICAL JOURNAL": 3.749,
  "SOCIAL COGNITIVE AND AFFECTIVE NEUROSCIENCE": 3.749,
  "EUROPEAN JOURNAL OF INTERNAL MEDICINE": 3.749,
  "JOURNAL OF ATTENTION DISORDERS": 3.748,
  "MATURITAS": 3.746,
  "JOURNAL OF THE FRANKLIN INSTITUTE-ENGINEERING AND APPLIED MATHEMATICS": 3.746,
  "BONE & JOINT RESEARCH": 3.745,
  "EUROPEAN JOURNAL OF HUMAN GENETICS": 3.744,
  "JOURNAL OF SEXUAL MEDICINE": 3.744,
  "MOLECULAR MICROBIOLOGY": 3.744,
  "MOLECULAR PLANT-MICROBE INTERACTIONS": 3.744,
  "FRONTIERS IN NEUROSCIENCE": 3.743,
  "JOURNAL OF ANALYTICAL ATOMIC SPECTROMETRY": 3.742,
  "CURRENT RHEUMATOLOGY REPORTS": 3.742,
  "JOURNAL OF SPORT AND HEALTH SCIENCE": 3.741,
  "GOVERNANCE-AN INTERNATIONAL JOURNAL OF POLICY ADMINISTRATION AND INSTITUTIONS": 3.74,
  "SAUDI PHARMACEUTICAL JOURNAL": 3.74,
  "EUROPEAN JOURNAL OF VASCULAR AND ENDOVASCULAR SURGERY": 3.74,
  "JOURNAL OF MANUFACTURING SYSTEMS": 3.739,
  "DIGESTIVE ENDOSCOPY": 3.739,
  "HORTICULTURE RESEARCH": 3.738,
  "INTERNATIONAL BUSINESS REVIEW": 3.737,
  "CLINICAL CHEMISTRY AND LABORATORY MEDICINE": 3.736,
  "REVIEW OF ECONOMICS AND STATISTICS": 3.735,
  "AUTONOMOUS ROBOTS": 3.734,
  "CONSERVATION PHYSIOLOGY": 3.734,
  "FRONTIERS IN ENDOCRINOLOGY": 3.733,
  "JOURNAL OF RHEUMATOLOGY": 3.732,
  "VADOSE ZONE JOURNAL": 3.73,
  "FRONTIERS IN AGING NEUROSCIENCE": 3.73,
  "JOURNAL OF GEOPHYSICAL RESEARCH-ATMOSPHERES": 3.729,
  "JOURNAL OF BIOLOGICAL INORGANIC CHEMISTRY": 3.729,
  "JOURNAL OF GASTROENTEROLOGY AND HEPATOLOGY": 3.727,
  "CORAL REEFS": 3.727,
  "SCANDINAVIAN JOURNAL OF MEDICINE & SCIENCE IN SPORTS": 3.727,
  "FOOD PACKAGING AND SHELF LIFE": 3.726,
  "MOBILE DNA": 3.723,
  "SEMINARS IN NEPHROLOGY": 3.72,
  "GERONTOLOGIST": 3.714,
  "MOLECULAR ENDOCRINOLOGY": 3.714,
  "JOURNAL OF ENVIRONMENTAL PSYCHOLOGY": 3.714,
  "HUMAN RESOURCE MANAGEMENT REVIEW": 3.713,
  "JOURNAL OF FOOD ENGINEERING": 3.712,
  "JOURNAL OF SCIENCE AND MEDICINE IN SPORT": 3.712,
  "BRAIN STRUCTURE & FUNCTION": 3.711,
  "SMART STRUCTURES AND SYSTEMS": 3.711,
  "EUROPEAN POLYMER JOURNAL": 3.706,
  "JOURNAL OF GEOPHYSICAL RESEARCH-BIOGEOSCIENCES": 3.705,
  "CHINESE JOURNAL OF CANCER": 3.705,
  "SAFETY SCIENCE": 3.705,
  "CHEMICAL GEOLOGY": 3.704,
  "INSECT BIOCHEMISTRY AND MOLECULAR BIOLOGY": 3.704,
  "FUTURE MEDICINAL CHEMISTRY": 3.702,
  "TISSUE ENGINEERING PART A": 3.701,
  "BRITISH JOURNAL OF OPHTHALMOLOGY": 3.7,
  "DERMATOLOGY AND THERAPY": 3.7,
  "JOURNAL OF PHARMACOLOGY AND EXPERIMENTAL THERAPEUTICS": 3.699,
  "MICROBIAL ECOLOGY": 3.698,
  "MOLECULAR GENETICS AND METABOLISM": 3.698,
  "TRANSFUSION MEDICINE REVIEWS": 3.698,
  "CURRENT HYPERTENSION REPORTS": 3.698,
  "SEMINARS IN ONCOLOGY": 3.697,
  "IET RENEWABLE POWER GENERATION": 3.697,
  "SOCIAL PSYCHOLOGICAL AND PERSONALITY SCIENCE": 3.696,
  "MECHANISMS OF AGEING AND DEVELOPMENT": 3.693,
  "OBESITY SURGERY": 3.693,
  "AMERICAN PSYCHOLOGIST": 3.693,
  "INTERNATIONAL JOURNAL OF CLIMATOLOGY": 3.691,
  "ADVANCES IN AGRONOMY": 3.691,
  "BUSINESS & INFORMATION SYSTEMS ENGINEERING": 3.689,
  "BIOLOGY OF BLOOD AND MARROW TRANSPLANTATION": 3.687,
  "NUTRITION & METABOLISM": 3.684,
  "BIOFACTORS": 3.684,
  "EARTH SURFACE PROCESSES AND LANDFORMS": 3.684,
  "IEEE-ACM TRANSACTIONS ON NETWORKING": 3.683,
  "DEVELOPMENT AND PSYCHOPATHOLOGY": 3.683,
  "NUTRITION JOURNAL": 3.683,
  "NEURAL PLASTICITY": 3.682,
  "NUTRITION": 3.682,
  "HAEMOPHILIA": 3.681,
  "JOURNAL OF NEURODEVELOPMENTAL DISORDERS": 3.681,
  "INTERNATIONAL JOURNAL OF HYPERTHERMIA": 3.681,
  "GISCIENCE & REMOTE SENSING": 3.675,
  "EXPERT OPINION ON BIOLOGICAL THERAPY": 3.674,
  "JOURNAL OF GEOPHYSICAL RESEARCH-SOLID EARTH": 3.673,
  "JOURNAL OF CANCER SURVIVORSHIP": 3.673,
  "JOURNAL OF RETAILING AND CONSUMER SERVICES": 3.671,
  "SCIENCE AND TECHNOLOGY OF ADVANCED MATERIALS": 3.67,
  "TOXICOLOGY AND APPLIED PHARMACOLOGY": 3.67,
  "BEST PRACTICE & RESEARCH CLINICAL GASTROENTEROLOGY": 3.667,
  "PLANT DISEASE": 3.665,
  "SCIENCE CHINA-LIFE SCIENCES": 3.662,
  "JOURNAL OF NEUROENGINEERING AND REHABILITATION": 3.662,
  "JOURNAL OF CLINICAL LIPIDOLOGY": 3.66,
  "NEUROPHOTONICS": 3.656,
  "THERAPEUTIC ADVANCES IN NEUROLOGICAL DISORDERS": 3.656,
  "FOOD RESEARCH INTERNATIONAL": 3.654,
  "MARKETING THEORY": 3.653,
  "ANNALS OF BEHAVIORAL MEDICINE": 3.652,
  "ARTIFICIAL INTELLIGENCE IN MEDICINE": 3.65,
  "CURRENT TREATMENT OPTIONS IN NEUROLOGY": 3.649,
  "EVOLUTION": 3.649,
  "LAND USE POLICY": 3.649,
  "INTERNATIONAL JOURNAL OF ONCOLOGY": 3.648,
  "JOURNAL OF AGRICULTURAL AND FOOD CHEMISTRY": 3.646,
  "METALLOMICS": 3.645,
  "CURRENT OPINION IN CLINICAL NUTRITION AND METABOLIC CARE": 3.644,
  "INTERNATIONAL JOURNAL OF NURSING STUDIES": 3.644,
  "APPLIED VEGETATION SCIENCE": 3.643,
  "PHYSICAL CHEMISTRY CHEMICAL PHYSICS": 3.643,
  "URBAN GEOGRAPHY": 3.642,
  "FRONTIERS IN MOLECULAR BIOSCIENCES": 3.642,
  "ICARUS": 3.64,
  "COMPUTER": 3.64,
  "GENETICS": 3.639,
  "TOXICOLOGICAL SCIENCES": 3.638,
  "OPTICS EXPRESS": 3.636,
  "ANNALS OF ALLERGY ASTHMA & IMMUNOLOGY": 3.634,
  "JOURNAL OF TRANSPORT GEOGRAPHY": 3.634,
  "ARCHIVES OF BIOCHEMISTRY AND BIOPHYSICS": 3.634,
  "GEOTECHNIQUE": 3.634,
  "CLINICAL CHILD AND FAMILY PSYCHOLOGY REVIEW": 3.634,
  "ECONOMIC SYSTEMS RESEARCH": 3.633,
  "IEEE MULTIMEDIA": 3.633,
  "JOURNAL OF ENVIRONMENTAL SCIENCES-CHINA": 3.632,
  "OCCUPATIONAL AND ENVIRONMENTAL MEDICINE": 3.632,
  "SMALL BUSINESS ECONOMICS": 3.631,
  "TRANSBOUNDARY AND EMERGING DISEASES": 3.631,
  "AMERICAN JOURNAL OF PHYSIOLOGY-CELL PHYSIOLOGY": 3.63,
  "ENZYME AND MICROBIAL TECHNOLOGY": 3.63,
  "ELECTRONIC MARKETS": 3.629,
  "ENGINEERING WITH COMPUTERS": 3.628,
  "INTERNATIONAL JOURNAL OF BIPOLAR DISORDERS": 3.628,
  "CLINICAL IMMUNOLOGY": 3.626,
  "TOXICOLOGY": 3.625,
  "IEEE WIRELESS COMMUNICATIONS LETTERS": 3.625,
  "AAPS JOURNAL": 3.623,
  "INTERNATIONAL JOURNAL OF GEOGRAPHICAL INFORMATION SCIENCE": 3.622,
  "JOURNAL OF HUMAN GENETICS": 3.622,
  "JOURNAL OF THE LEARNING SCIENCES": 3.621,
  "MEDIATORS OF INFLAMMATION": 3.621,
  "BIOTECHNOLOGY JOURNAL": 3.62,
  "ORGANIZATION STUDIES": 3.619,
  "SMART MATERIALS AND STRUCTURES": 3.618,
  "THERAPEUTIC ADVANCES IN ENDOCRINOLOGY AND METABOLISM": 3.618,
  "AGRICULTURAL WATER MANAGEMENT": 3.617,
  "BASIN RESEARCH": 3.616,
  "JOURNAL OF CLINICAL ANESTHESIA": 3.615,
  "WILEY INTERDISCIPLINARY REVIEWS-SYSTEMS BIOLOGY AND MEDICINE": 3.615,
  "INTERNATIONAL JOURNAL OF INFECTIOUS DISEASES": 3.615,
  "JOURNAL OF THE ROYAL SOCIETY OF MEDICINE": 3.611,
  "MARINE AND PETROLEUM GEOLOGY": 3.61,
  "BIOMASS & BIOENERGY": 3.61,
  "COGNITION": 3.606,
  "JOURNAL OF PROTEOMICS": 3.606,
  "JOURNAL OF INTELLIGENT MANUFACTURING": 3.605,
  "MECHANISM AND MACHINE THEORY": 3.605,
  "HUMAN COMMUNICATION RESEARCH": 3.603,
  "IEEE GEOSCIENCE AND REMOTE SENSING LETTERS": 3.603,
  "JOURNAL OF PHYSICS G-NUCLEAR AND PARTICLE PHYSICS": 3.602,
  "WORLD JOURNAL OF STEM CELLS": 3.601,
  "ADIPOCYTE": 3.6,
  "MOLECULES AND CELLS": 3.6,
  "DEVELOPMENTAL MEDICINE AND CHILD NEUROLOGY": 3.599,
  "EUROPEAN JOURNAL OF PHARMACEUTICAL SCIENCES": 3.599,
  "ACTA DERMATO-VENEREOLOGICA": 3.598,
  "BOREAS": 3.598,
  "IEEE-ACM TRANSACTIONS ON AUDIO SPEECH AND LANGUAGE PROCESSING": 3.597,
  "ADVANCES IN ANATOMIC PATHOLOGY": 3.593,
  "CHROMOSOMA": 3.592,
  "HEALTH PSYCHOLOGY": 3.591,
  "VEHICULAR COMMUNICATIONS": 3.591,
  "RHEUMATIC DISEASE CLINICS OF NORTH AMERICA": 3.59,
  "DRUG SAFETY": 3.59,
  "ENGINEERING APPLICATIONS OF ARTIFICIAL INTELLIGENCE": 3.589,
  "IET CONTROL THEORY AND APPLICATIONS": 3.588,
  "TRANSPLANT INTERNATIONAL": 3.585,
  "JOURNAL OF ARTHROPLASTY": 3.585,
  "JOURNAL OF MIXED METHODS RESEARCH": 3.585,
  "SEMANTIC WEB": 3.585,
  "INTERNATIONAL JOURNAL OF EATING DISORDERS": 3.585,
  "APPLIED PHYSICS LETTERS": 3.585,
  "QUARTERLY REVIEW OF BIOLOGY": 3.585,
  "COMPUTERS & INDUSTRIAL ENGINEERING": 3.583,
  "ELEMENTA-SCIENCE OF THE ANTHROPOCENE": 3.583,
  "FRONTIERS IN CELLULAR AND INFECTION MICROBIOLOGY": 3.583,
  "JOURNAL OF ADVERTISING": 3.582,
  "FRONTIERS IN GENETICS": 3.581,
  "JOURNAL OF ALZHEIMERS DISEASE": 3.581,
  "JOURNAL OF ENVIRONMENTAL SCIENCE AND HEALTH PART C-ENVIRONMENTAL CARCINOGENESIS & ECOTOXICOLOGY REVIEWS": 3.58,
  "JOURNAL OF ENERGY STORAGE": 3.579,
  "STRUCTURAL SAFETY": 3.577,
  "TRIBOLOGY INTERNATIONAL": 3.575,
  "NUCLEAR FUSION": 3.574,
  "FRACTIONAL CALCULUS AND APPLIED ANALYSIS": 3.574,
  "RICE": 3.573,
  "AMERICAN JOURNAL OF CHINESE MEDICINE": 3.573,
  "IEEE ANTENNAS AND WIRELESS PROPAGATION LETTERS": 3.571,
  "BRAIN TUMOR PATHOLOGY": 3.571,
  "HIGH VOLTAGE": 3.571,
  "WEST EUROPEAN POLITICS": 3.57,
  "MATERIALS SCIENCE AND ENGINEERING B-ADVANCED FUNCTIONAL SOLID-STATE MATERIALS": 3.57,
  "REVIEWS IN FISH BIOLOGY AND FISHERIES": 3.57,
  "PHARMACOGENOMICS JOURNAL": 3.568,
  "JAMA OTOLARYNGOLOGY-HEAD & NECK SURGERY": 3.567,
  "APPETITE": 3.567,
  "BMC GENOMICS": 3.565,
  "CELL STRUCTURE AND FUNCTION": 3.565,
  "FUTURE OF CHILDREN": 3.564,
  "PLANT CELL REPORTS": 3.564,
  "TOXICOLOGY LETTERS": 3.564,
  "JOURNAL OF EXPERIMENTAL PSYCHOLOGY-GENERAL": 3.561,
  "ORGANIC ELECTRONICS": 3.56,
  "BREAST": 3.56,
  "EXPERIMENTAL THERMAL AND FLUID SCIENCE": 3.559,
  "SCANDINAVIAN JOURNAL OF WORK ENVIRONMENT & HEALTH": 3.559,
  "AD HOC NETWORKS": 3.558,
  "ORGANIC & BIOMOLECULAR CHEMISTRY": 3.556,
  "ANESTHESIA AND ANALGESIA": 3.556,
  "PSYCHIATRY AND CLINICAL NEUROSCIENCES": 3.556,
  "AMERICAN JOURNAL OF GERIATRIC PSYCHIATRY": 3.556,
  "INTERNATIONAL JOURNAL OF THERMAL SCIENCES": 3.555,
  "THIN-WALLED STRUCTURES": 3.554,
  "APPLIED MATHEMATICS LETTERS": 3.553,
  "CLASSICAL AND QUANTUM GRAVITY": 3.553,
  "EXPERT OPINION ON DRUG METABOLISM & TOXICOLOGY": 3.553,
  "BMC CELL BIOLOGY": 3.551,
  "JOURNAL OF THE MECHANICAL BEHAVIOR OF BIOMEDICAL MATERIALS": 3.55,
  "XENOTRANSPLANTATION": 3.548,
  "MEAT SCIENCE": 3.547,
  "INTERNATIONAL REVIEWS OF IMMUNOLOGY": 3.546,
  "JOURNAL OF SUPERCRITICAL FLUIDS": 3.545,
  "AESTHETIC SURGERY JOURNAL": 3.545,
  "IEEE TRANSACTIONS ON NEURAL SYSTEMS AND REHABILITATION ENGINEERING": 3.545,
  "INTERNATIONAL JOURNAL FOR PARASITOLOGY": 3.545,
  "JOURNAL OF ATHEROSCLEROSIS AND THROMBOSIS": 3.545,
  "CELL TRANSPLANTATION": 3.545,
  "TREE PHYSIOLOGY": 3.543,
  "SURGERY": 3.543,
  "EJNMMI PHYSICS": 3.543,
  "ANNALS OF BIOMEDICAL ENGINEERING": 3.543,
  "GEORGETOWN LAW JOURNAL": 3.542,
  "JOURNAL OF ANXIETY DISORDERS": 3.542,
  "JOURNAL OF GEOCHEMICAL EXPLORATION": 3.542,
  "BREAST CANCER RESEARCH AND TREATMENT": 3.542,
  "INTERNATIONAL JOURNAL OF CARDIOLOGY": 3.538,
  "CLIMATE OF THE PAST": 3.538,
  "GEOTHERMICS": 3.538,
  "JOURNAL OF ANALYTICAL AND APPLIED PYROLYSIS": 3.537,
  "PUBLICATIONS OF THE ASTRONOMICAL SOCIETY OF THE PACIFIC": 3.537,
  "EVOLUTIONARY COMPUTATION": 3.537,
  "PSYCHOLOGICAL ASSESSMENT": 3.535,
  "JOURNAL OF RHEOLOGY": 3.535,
  "OIKOS": 3.534,
  "DRUG AND ALCOHOL DEPENDENCE": 3.534,
  "HYDROMETALLURGY": 3.534,
  "CURRENT GENETICS": 3.534,
  "AICHE JOURNAL": 3.533,
  "JOURNAL OF MANUFACTURING PROCESSES": 3.533,
  "JOURNAL OF NEUROPATHOLOGY AND EXPERIMENTAL NEUROLOGY": 3.532,
  "SEMINARS IN LIVER DISEASE": 3.532,
  "IEEE COMMUNICATIONS LETTERS": 3.531,
  "JOURNAL OF EUROPEAN PUBLIC POLICY": 3.531,
  "JOURNAL OF ADVANCES IN MODELING EARTH SYSTEMS": 3.531,
  "TRANSPORTATION": 3.53,
  "JOURNAL OF CLINICAL SLEEP MEDICINE": 3.53,
  "SUSTAINABLE ENERGY TECHNOLOGIES AND ASSESSMENTS": 3.53,
  "APPLIED PHYSIOLOGY NUTRITION AND METABOLISM": 3.53,
  "CLINICS IN CHEST MEDICINE": 3.53,
  "JOURNAL OF IMMUNOTHERAPY": 3.527,
  "ANNALS OF BOTANY": 3.526,
  "CURRENT OBESITY REPORTS": 3.526,
  "EXPERT REVIEW OF NEUROTHERAPEUTICS": 3.526,
  "UNITED EUROPEAN GASTROENTEROLOGY JOURNAL": 3.526,
  "CERAMICS INTERNATIONAL": 3.524,
  "MITOCHONDRION": 3.524,
  "PREVENTIVE MEDICINE": 3.524,
  "JOURNAL OF CELLULAR BIOCHEMISTRY": 3.523,
  "LIFE SCIENCES": 3.523,
  "INTERNATIONAL MARKETING REVIEW": 3.521,
  "METROLOGIA": 3.519,
  "APPLIED SOIL ECOLOGY": 3.518,
  "MARINE ENVIRONMENTAL RESEARCH": 3.518,
  "CATALYSTS": 3.518,
  "ADVANCES IN CLINICAL CHEMISTRY": 3.518,
  "CURRENT TOPICS IN MEDICINAL CHEMISTRY": 3.517,
  "JOURNAL OF MATERIALS SCIENCE": 3.517,
  "CHEMPLUSCHEM": 3.517,
  "JOURNAL OF ANIMAL SCIENCE AND BIOTECHNOLOGY": 3.517,
  "BIOMEDICAL MATERIALS": 3.517,
  "HEPATOLOGY RESEARCH": 3.517,
  "CANCER CELL INTERNATIONAL": 3.516,
  "HEMATOLOGICAL ONCOLOGY": 3.514,
  "INTERNATIONAL JOURNAL OF ELECTRONIC COMMERCE": 3.513,
  "JOURNAL OF ENDOCRINOLOGICAL INVESTIGATION": 3.51,
  "CYTOMETRY PART A": 3.51,
  "IEEE JOURNAL ON EMERGING AND SELECTED TOPICS IN CIRCUITS AND SYSTEMS": 3.509,
  "SEXUAL ABUSE-A JOURNAL OF RESEARCH AND TREATMENT": 3.508,
  "JOURNAL OF SLEEP RESEARCH": 3.508,
  "PSYCHO-ONCOLOGY": 3.507,
  "COMPUTER METHODS AND PROGRAMS IN BIOMEDICINE": 3.506,
  "ECONOMIC POLICY": 3.503,
  "PSYCHOPHARMACOLOGY": 3.502,
  "CURRENT OPINION IN BEHAVIORAL SCIENCES": 3.501,
  "ENVIRONMENTAL TOXICOLOGY AND CHEMISTRY": 3.501,
  "PROGRESS IN ORGANIC COATINGS": 3.5,
  "EARTHQUAKE ENGINEERING & STRUCTURAL DYNAMICS": 3.5,
  "PLANNING THEORY": 3.499,
  "BRAIN IMAGING AND BEHAVIOR": 3.499,
  "JOURNALS OF GERONTOLOGY SERIES B-PSYCHOLOGICAL SCIENCES AND SOCIAL SCIENCES": 3.498,
  "JOURNAL OF ETHNOPHARMACOLOGY": 3.495,
  "NMR IN BIOMEDICINE": 3.494,
  "CEREBELLUM": 3.493,
  "POWDER TECHNOLOGY": 3.491,
  "JOURNAL OF THE AMERICAN STATISTICAL ASSOCIATION": 3.491,
  "CLINICAL AND EXPERIMENTAL OPHTHALMOLOGY": 3.49,
  "MOLECULAR CARCINOGENESIS": 3.49,
  "WORLD JOURNAL OF GASTROENTEROLOGY": 3.489,
  "CHEMICO-BIOLOGICAL INTERACTIONS": 3.489,
  "ESC HEART FAILURE": 3.488,
  "JOURNAL OF PUBLIC ADMINISTRATION RESEARCH AND THEORY": 3.488,
  "BIOGEOCHEMISTRY": 3.488,
  "ECOLOGICAL ENGINEERING": 3.488,
  "JOURNAL OF ABNORMAL CHILD PSYCHOLOGY": 3.487,
  "PATHOGENS": 3.487,
  "FRESHWATER BIOLOGY": 3.487,
  "JOURNAL OF WATER RESOURCES PLANNING AND MANAGEMENT": 3.485,
  "JOURNAL OF IMMUNOLOGY RESEARCH": 3.485,
  "PLANT PHYSIOLOGY AND BIOCHEMISTRY": 3.484,
  "IEEE TRANSACTIONS ON PARALLEL AND DISTRIBUTED SYSTEMS": 3.483,
  "SEMINARS IN THROMBOSIS AND HEMOSTASIS": 3.481,
  "ATMOSPHERIC MEASUREMENT TECHNIQUES": 3.481,
  "CURRENT NEUROLOGY AND NEUROSCIENCE REPORTS": 3.48,
  "JOURNAL OF SUSTAINABLE TOURISM": 3.478,
  "USER MODELING AND USER-ADAPTED INTERACTION": 3.478,
  "NANOTECHNOLOGY": 3.478,
  "SOFT MATTER": 3.477,
  "IEEE JOURNAL OF PHOTOVOLTAICS": 3.477,
  "GLOBAL ENVIRONMENTAL POLITICS": 3.476,
  "MINERALIUM DEPOSITA": 3.475,
  "MOLECULAR HUMAN REPRODUCTION": 3.474,
  "COMMUNICATION THEORY": 3.472,
  "CURRENT ISSUES IN TOURISM": 3.472,
  "INTERNATIONAL JOURNAL OF BIO-INSPIRED COMPUTATION": 3.472,
  "CNS NEUROSCIENCE & THERAPEUTICS": 3.471,
  "COMPUTERS ENVIRONMENT AND URBAN SYSTEMS": 3.471,
  "IEEE JOURNAL OF SELECTED TOPICS IN APPLIED EARTH OBSERVATIONS AND REMOTE SENSING": 3.47,
  "CORPORATE GOVERNANCE-AN INTERNATIONAL REVIEW": 3.47,
  "JOURNAL OF PHYSICAL OCEANOGRAPHY": 3.47,
  "CELLULAR SIGNALLING": 3.47,
  "JOURNAL OF VOCATIONAL BEHAVIOR": 3.469,
  "ORE GEOLOGY REVIEWS": 3.469,
  "EDUCATIONAL RESEARCHER": 3.468,
  "INTERNATIONAL JOURNAL OF FORECASTING": 3.468,
  "JOURNAL OF PATIENT SAFETY": 3.466,
  "EUROPEAN JOURNAL OF AGRONOMY": 3.466,
  "CRYSTENGCOMM": 3.465,
  "REGENERATIVE BIOMATERIALS": 3.464,
  "JOURNAL OF PETROLOGY": 3.463,
  "CHEMNANOMAT": 3.462,
  "EJSO": 3.46,
  "JOURNAL OF PAIN AND SYMPTOM MANAGEMENT": 3.459,
  "PSYCHOPHYSIOLOGY": 3.457,
  "JOURNAL OF DERMATOLOGY": 3.457,
  "JOURNAL OF TRAUMA AND ACUTE CARE SURGERY": 3.457,
  "PFLUGERS ARCHIV-EUROPEAN JOURNAL OF PHYSIOLOGY": 3.457,
  "EVOLUTIONARY ANTHROPOLOGY": 3.457,
  "INDUSTRIAL & ENGINEERING CHEMISTRY RESEARCH": 3.456,
  "JOURNAL OF INTERNATIONAL MARKETING": 3.456,
  "CANADIAN JOURNAL OF ANESTHESIA-JOURNAL CANADIEN D ANESTHESIE": 3.455,
  "CHEMICAL ENGINEERING SCIENCE": 3.455,
  "BIOCHEMICAL ENGINEERING JOURNAL": 3.455,
  "NITRIC OXIDE-BIOLOGY AND CHEMISTRY": 3.454,
  "OPEN FORUM INFECTIOUS DISEASES": 3.454,
  "POLICE QUARTERLY": 3.453,
  "WORLD POLITICS": 3.453,
  "CELLULAR & MOLECULAR BIOLOGY LETTERS": 3.45,
  "HUMAN RELATIONS": 3.449,
  "ICES JOURNAL OF MARINE SCIENCE": 3.449,
  "ENDOCRINE PATHOLOGY": 3.448,
  "GASTROENTEROLOGY CLINICS OF NORTH AMERICA": 3.448,
  "SEXUALLY TRANSMITTED INFECTIONS": 3.447,
  "COMMENTS ON INORGANIC CHEMISTRY": 3.447,
  "CANCER RESEARCH AND TREATMENT": 3.445,
  "LONG RANGE PLANNING": 3.445,
  "BIOCHIMIE": 3.444,
  "INTERNATIONAL JOURNAL OF MEDICAL MICROBIOLOGY": 3.443,
  "COGNITIVE NEUROSCIENCE": 3.442,
  "INTERNATIONAL IMMUNOPHARMACOLOGY": 3.442,
  "CELL AND TISSUE RESEARCH": 3.441,
  "HUMAN-COMPUTER INTERACTION": 3.441,
  "SLEEP MEDICINE": 3.44,
  "JOURNAL OF ECONOMIC GEOGRAPHY": 3.44,
  "CANCER MEDICINE": 3.439,
  "PRECISION AGRICULTURE": 3.439,
  "CELL AND BIOSCIENCE": 3.439,
  "MATERIALS RESEARCH BULLETIN": 3.439,
  "COMPUTERS & STRUCTURES": 3.439,
  "DRUG METABOLISM AND DISPOSITION": 3.433,
  "RHINOLOGY": 3.433,
  "GERONTOLOGY": 3.433,
  "INTERMETALLICS": 3.432,
  "BLOOD TRANSFUSION": 3.43,
  "HELICOBACTER": 3.43,
  "JOURNAL OF HEALTH ECONOMICS": 3.424,
  "JMIR SERIOUS GAMES": 3.424,
  "EMERGENCIAS": 3.424,
  "MATERIALS AND MANUFACTURING PROCESSES": 3.422,
  "MARINE GEOLOGY": 3.422,
  "IEEE TRANSACTIONS ON INDUSTRY APPLICATIONS": 3.421,
  "PEDIATRIC DIABETES": 3.42,
  "COMPUTERS AND GEOTECHNICS": 3.419,
  "INTERNATIONAL JOURNAL OF ENERGY RESEARCH": 3.419,
  "DEVELOPMENTAL PSYCHOLOGY": 3.418,
  "JOURNAL OF PHYSIOLOGICAL SCIENCES": 3.418,
  "MOLECULAR IMAGING AND BIOLOGY": 3.418,
  "NUTRITION METABOLISM AND CARDIOVASCULAR DISEASES": 3.414,
  "PRODUCTION PLANNING & CONTROL": 3.414,
  "COMUNICAR": 3.413,
  "PITUITARY": 3.413,
  "COMPUTERS & CHEMICAL ENGINEERING": 3.412,
  "CURRENT PROBLEMS IN CARDIOLOGY": 3.411,
  "GM CROPS & FOOD-BIOTECHNOLOGY IN AGRICULTURE AND THE FOOD CHAIN": 3.411,
  "WILDLIFE MONOGRAPHS": 3.411,
  "IEEE TRANSACTIONS ON HUMAN-MACHINE SYSTEMS": 3.407,
  "JOURNAL OF CANCER RESEARCH AND CLINICAL ONCOLOGY": 3.407,
  "GENES": 3.407,
  "INTERNATIONAL ENDODONTIC JOURNAL": 3.406,
  "VASCULAR PHARMACOLOGY": 3.406,
  "CALIFORNIA LAW REVIEW": 3.406,
  "EUROPEAN JOURNAL OF PERSONALITY": 3.405,
  "EXPERIMENTAL CELL RESEARCH": 3.404,
  "SOCIO-ECONOMIC REVIEW": 3.404,
  "JOURNAL OF MATERIALS RESEARCH AND TECHNOLOGY-JMR&T": 3.404,
  "ORGANIC PROCESS RESEARCH & DEVELOPMENT": 3.404,
  "FOOD AND BIOPRODUCTS PROCESSING": 3.402,
  "NANO CONVERGENCE": 3.401,
  "AMERICAN JOURNAL OF PHYSIOLOGY-RENAL PHYSIOLOGY": 3.4,
  "BIOLOGY LETTERS": 3.4,
  "EARLY INTERVENTION IN PSYCHIATRY": 3.4,
  "NANOSCALE AND MICROSCALE THERMOPHYSICAL ENGINEERING": 3.4,
  "INTERNATIONAL JOURNAL OF RESEARCH IN MARKETING": 3.399,
  "BRITISH JOURNAL OF NUTRITION": 3.399,
  "DIABETES METABOLIC SYNDROME AND OBESITY-TARGETS AND THERAPY": 3.398,
  "JOURNAL OF TISSUE ENGINEERING AND REGENERATIVE MEDICINE": 3.397,
  "OPTICS AND LASER TECHNOLOGY": 3.397,
  "JOURNAL OF THE METEOROLOGICAL SOCIETY OF JAPAN": 3.396,
  "INTERNATIONAL JOURNAL OF CLINICAL AND HEALTH PSYCHOLOGY": 3.395,
  "JOURNAL OF PROCESS CONTROL": 3.395,
  "JOURNAL OF CARDIOVASCULAR COMPUTED TOMOGRAPHY": 3.395,
  "MINERALS ENGINEERING": 3.394,
  "FUNGAL GENETICS AND BIOLOGY": 3.393,
  "PEDIATRIC DENTISTRY": 3.392,
  "NEUROTOXICITY RESEARCH": 3.39,
  "JOURNAL OF BIOMOLECULAR STRUCTURE & DYNAMICS": 3.389,
  "PUBLIC OPINION QUARTERLY": 3.388,
  "PROGRESS IN NATURAL SCIENCE-MATERIALS INTERNATIONAL": 3.387,
  "TRANSPORTATION SCIENCE": 3.387,
  "COMPUTER PHYSICS COMMUNICATIONS": 3.386,
  "BRITISH JOURNAL OF PSYCHOLOGY": 3.386,
  "ENERGY FOR SUSTAINABLE DEVELOPMENT": 3.386,
  "LGBT HEALTH": 3.386,
  "ENDOCRINOLOGY AND METABOLISM CLINICS OF NORTH AMERICA": 3.384,
  "MATERNAL AND CHILD NUTRITION": 3.382,
  "METABOLITES": 3.382,
  "JOURNAL OF RURAL STUDIES": 3.38,
  "COGNITION AND INSTRUCTION": 3.379,
  "JOURNAL OF THE GEOLOGICAL SOCIETY": 3.379,
  "PROCEEDINGS OF THE COMBUSTION INSTITUTE": 3.378,
  "ACTA ONCOLOGICA": 3.378,
  "ARABIAN JOURNAL OF CHEMISTRY": 3.378,
  "COMPUTERIZED MEDICAL IMAGING AND GRAPHICS": 3.377,
  "CURRENT OPINION IN ENDOCRINOLOGY DIABETES AND OBESITY": 3.377,
  "FISH & SHELLFISH IMMUNOLOGY": 3.377,
  "JOURNAL OF DIABETES": 3.375,
  "WILEY INTERDISCIPLINARY REVIEWS-ENERGY AND ENVIRONMENT": 3.375,
  "CELL ADHESION & MIGRATION": 3.375,
  "ENDOCRINE": 3.374,
  "JOURNAL OF THE EUROPEAN ECONOMIC ASSOCIATION": 3.372,
  "HISTOPATHOLOGY": 3.371,
  "IEEE INTELLIGENT TRANSPORTATION SYSTEMS MAGAZINE": 3.371,
  "CELLULAR IMMUNOLOGY": 3.371,
  "JOURNAL OF EXPERIMENTAL SOCIAL PSYCHOLOGY": 3.368,
  "ANTIPODE": 3.368,
  "JOURNAL OF GRID COMPUTING": 3.367,
  "BMC MICROBIOLOGY": 3.367,
  "ANALYTICAL AND BIOANALYTICAL CHEMISTRY": 3.367,
  "INFORMATION SYSTEMS JOURNAL": 3.366,
  "THERAPEUTIC ADVANCES IN RESPIRATORY DISEASE": 3.366,
  "ECONOMIC GEOLOGY": 3.365,
  "JOURNAL OF THE ATMOSPHERIC SCIENCES": 3.364,
  "JOURNAL OF DENTISTRY": 3.363,
  "JOINT BONE SPINE": 3.363,
  "JOURNAL OF THE ROYAL STATISTICAL SOCIETY SERIES B-STATISTICAL METHODOLOGY": 3.362,
  "JOURNAL OF DRUG TARGETING": 3.362,
  "ANNALEN DER PHYSIK": 3.361,
  "ACADEMY OF MANAGEMENT LEARNING & EDUCATION": 3.361,
  "CHEMICAL RESEARCH IN TOXICOLOGY": 3.36,
  "INTERNATIONAL JOURNAL OF CHRONIC OBSTRUCTIVE PULMONARY DISEASE": 3.36,
  "IEEE CONSUMER ELECTRONICS MAGAZINE": 3.36,
  "JOURNAL OF RESEARCH IN CRIME AND DELINQUENCY": 3.359,
  "URBAN STUDIES": 3.357,
  "JOURNAL OF MANAGEMENT IN ENGINEERING": 3.356,
  "VACCINE": 3.355,
  "IEEE SIGNAL PROCESSING LETTERS": 3.355,
  "HIPPOCAMPUS": 3.354,
  "AMERICAN JOURNAL OF TRANSLATIONAL RESEARCH": 3.354,
  "THROMBOSIS RESEARCH": 3.354,
  "APPLIED PSYCHOLOGY-AN INTERNATIONAL REVIEW-PSYCHOLOGIE APPLIQUEE-REVUE INTERNATIONALE": 3.353,
  "CALCIFIED TISSUE INTERNATIONAL": 3.353,
  "PHYTOPATHOLOGY": 3.352,
  "PSYCHOLOGY OF WOMEN QUARTERLY": 3.352,
  "DIABETES & METABOLISM JOURNAL": 3.352,
  "JOURNAL OF TEACHER EDUCATION": 3.352,
  "NEUROTOXICOLOGY": 3.351,
  "EPJ DATA SCIENCE": 3.35,
  "LASERS IN SURGERY AND MEDICINE": 3.35,
  "CURRENT OPINION IN ONCOLOGY": 3.349,
  "JOURNAL OF GLACIOLOGY": 3.347,
  "JOURNAL OF PHOTOCHEMISTRY AND PHOTOBIOLOGY A-CHEMISTRY": 3.347,
  "ADVANCES IN THERAPY": 3.345,
  "3D PRINTING AND ADDITIVE MANUFACTURING": 3.343,
  "APPLIED ORGANOMETALLIC CHEMISTRY": 3.342,
  "CELL CYCLE": 3.341,
  "INTERNATIONAL JOURNAL FOR UNCERTAINTY QUANTIFICATION": 3.341,
  "JOURNAL OF YOUTH AND ADOLESCENCE": 3.34,
  "PLANT AND SOIL": 3.34,
  "ORGANIZATION SCIENCE": 3.338,
  "AMERICAN JOURNAL OF NEURORADIOLOGY": 3.335,
  "PEST MANAGEMENT SCIENCE": 3.334,
  "ENVIRONMENTAL GEOCHEMISTRY AND HEALTH": 3.333,
  "MEDICAL ONCOLOGY": 3.333,
  "ADVANCED POWDER TECHNOLOGY": 3.333,
  "AQUACULTURE ECONOMICS & MANAGEMENT": 3.332,
  "BRQ-BUSINESS RESEARCH QUARTERLY": 3.332,
  "IEEE TRANSACTIONS ON CIRCUITS AND SYSTEMS II-EXPRESS BRIEFS": 3.331,
  "JOURNAL OF COMPUTER-AIDED MOLECULAR DESIGN": 3.331,
  "MALACOLOGIA": 3.33,
  "STUDIES IN SCIENCE EDUCATION": 3.329,
  "ACTA GEOTECHNICA": 3.329,
  "PROGRESS IN OCEANOGRAPHY": 3.329,
  "JOURNAL OF ENGINEERING EDUCATION": 3.328,
  "NEUROSCIENCE": 3.327,
  "SEDIMENTARY GEOLOGY": 3.327,
  "SEDIMENTOLOGY": 3.324,
  "BEHAVIOR THERAPY": 3.324,
  "JOURNAL OF VASCULAR SURGERY": 3.323,
  "FOOD & FUNCTION": 3.323,
  "PANCREATOLOGY": 3.323,
  "JOURNAL OF FLOOD RISK MANAGEMENT": 3.323,
  "DIABETES RESEARCH AND CLINICAL PRACTICE": 3.323,
  "EPIDEMICS": 3.32,
  "JOURNAL OF COMPARATIVE NEUROLOGY": 3.319,
  "CLINICAL AND EXPERIMENTAL RHEUMATOLOGY": 3.319,
  "GLOBAL HEART": 3.319,
  "RESPIRATORY MEDICINE": 3.319,
  "ALCOHOLISM-CLINICAL AND EXPERIMENTAL RESEARCH": 3.318,
  "JOURNAL OF GEOPHYSICAL RESEARCH-OCEANS": 3.317,
  "JOURNAL OF BACTERIOLOGY": 3.316,
  "CLINICAL AND VACCINE IMMUNOLOGY": 3.316,
  "CONTROL ENGINEERING PRACTICE": 3.315,
  "INTERNATIONAL JOURNAL OF GREENHOUSE GAS CONTROL": 3.314,
  "CONTRIBUTIONS TO MINERALOGY AND PETROLOGY": 3.312,
  "EXPERT OPINION ON EMERGING DRUGS": 3.311,
  "JOURNAL OF SERVICE MANAGEMENT": 3.31,
  "IET GENERATION TRANSMISSION & DISTRIBUTION": 3.31,
  "ACTA CRYSTALLOGRAPHICA SECTION D-STRUCTURAL BIOLOGY": 3.31,
  "ACTA CRYSTALLOGRAPHICA SECTION D: BIOLOGICAL CRYSTALLOGRAPHY": 3.31,
  "JOURNAL OF FAMILY BUSINESS STRATEGY": 3.31,
  "JOURNAL OF POSITIVE PSYCHOLOGY": 3.31,
  "ANTIMICROBIAL RESISTANCE AND INFECTION CONTROL": 3.309,
  "JOURNAL OF INORGANIC BIOCHEMISTRY": 3.308,
  "JOURNAL OF THE ROYAL SOCIETY INTERFACE": 3.307,
  "WAVES IN RANDOM AND COMPLEX MEDIA": 3.307,
  "JOURNAL OF BIOMEDICAL MATERIALS RESEARCH PART A": 3.307,
  "EXPERT OPINION ON DRUG SAFETY": 3.306,
  "FOOD BIOSCIENCE": 3.305,
  "GENERAL HOSPITAL PSYCHIATRY": 3.303,
  "INTEGRATED ENVIRONMENTAL ASSESSMENT AND MANAGEMENT": 3.301,
  "MATERIALS CHARACTERIZATION": 3.3,
  "JOURNAL OF ELECTROANALYTICAL CHEMISTRY": 3.3,
  "TRAVEL BEHAVIOUR AND SOCIETY": 3.299,
  "ACTA ORTHOPAEDICA": 3.298,
  "HYPERTENSION RESEARCH": 3.298,
  "IEEE TRANSACTIONS ON INFORMATION THEORY": 3.298,
  "JUSTICE QUARTERLY": 3.298,
  "CLINICAL IMPLANT DENTISTRY AND RELATED RESEARCH": 3.298,
  "HUMAN-CENTRIC COMPUTING AND INFORMATION SCIENCES": 3.298,
  "CURRENT ALZHEIMER RESEARCH": 3.297,
  "SURGICAL ENDOSCOPY AND OTHER INTERVENTIONAL TECHNIQUES": 3.296,
  "BMJ SUPPORTIVE & PALLIATIVE CARE": 3.296,
  "DRUG DESIGN DEVELOPMENT AND THERAPY": 3.296,
  "MICROCHEMICAL JOURNAL": 3.294,
  "HEALTH & PLACE": 3.294,
  "JOURNAL OF THE AMERICAN SOCIETY FOR MASS SPECTROMETRY": 3.291,
  "FRONTIERS IN PHYSIOLOGY": 3.291,
  "ACS COMBINATORIAL SCIENCE": 3.289,
  "BIRTH DEFECTS RESEARCH PART C-EMBRYO TODAY-REVIEWS": 3.288,
  "BRITISH JOURNAL OF SOCIOLOGY": 3.287,
  "REPRODUCTIVE TOXICOLOGY": 3.286,
  "INTERNATIONAL JOURNAL OF PRODUCTION RESEARCH": 3.286,
  "APPLIED NANOSCIENCE": 3.286,
  "QUARTERLY JOURNAL OF THE ROYAL METEOROLOGICAL SOCIETY": 3.285,
  "JOURNAL OF PHARMACEUTICAL SCIENCES": 3.282,
  "JOURNAL OF FUNCTIONAL FOODS": 3.28,
  "SPINE JOURNAL": 3.278,
  "JOURNAL OF COMPUTATIONAL CHEMISTRY": 3.278,
  "EUROPEAN ARCHIVES OF PSYCHIATRY AND CLINICAL NEUROSCIENCE": 3.277,
  "SURFACE & COATINGS TECHNOLOGY": 3.276,
  "COMPARATIVE POLITICAL STUDIES": 3.274,
  "TRANSPORT POLICY": 3.274,
  "HYDROLOGICAL PROCESSES": 3.274,
  "BIOLOGY OF SEX DIFFERENCES": 3.273,
  "EUROPEAN JOURNAL OF PAIN": 3.273,
  "JMIR MEDICAL INFORMATICS": 3.272,
  "PEDOSPHERE": 3.269,
  "NUCLEAR PHYSICS B": 3.269,
  "RESOURCES POLICY": 3.268,
  "IAWA JOURNAL": 3.267,
  "JOURNAL OF CANCER": 3.266,
  "SUSTAINABLE ENERGY GRIDS & NETWORKS": 3.266,
  "CROP JOURNAL": 3.265,
  "HEREDITY": 3.265,
  "JOURNAL OF NEUROGASTROENTEROLOGY AND MOTILITY": 3.264,
  "CLINICAL EPIDEMIOLOGY": 3.264,
  "INTERNATIONAL JOURNAL OF REFRIGERATION-REVUE INTERNATIONALE DU FROID": 3.263,
  "MEDICAL PHYSICS": 3.263,
  "AMERICAN JOURNAL OF PHYSIOLOGY-REGULATORY INTEGRATIVE AND COMPARATIVE PHYSIOLOGY": 3.263,
  "CLINICAL COLORECTAL CANCER": 3.262,
  "ENVIRONMENT": 3.262,
  "PHYSICA E-LOW-DIMENSIONAL SYSTEMS & NANOSTRUCTURES": 3.262,
  "POLITICAL PSYCHOLOGY": 3.261,
  "WILEY INTERDISCIPLINARY REVIEWS-COGNITIVE SCIENCE": 3.261,
  "INTERNATIONAL JOURNAL OF IMPACT ENGINEERING": 3.261,
  "JOURNAL OF WATER PROCESS ENGINEERING": 3.26,
  "PLASMA PROCESSES AND POLYMERS": 3.259,
  "BEHAVIORAL SLEEP MEDICINE": 3.259,
  "COMPUTERS AND ELECTRONICS IN AGRICULTURE": 3.259,
  "JOURNAL OF BUSINESS LOGISTICS": 3.259,
  "AMERICAN EDUCATIONAL RESEARCH JOURNAL": 3.259,
  "EUROPEAN JOURNAL OF PHARMACOLOGY": 3.259,
  "PLANT METHODS": 3.257,
  "GUT PATHOGENS": 3.256,
  "ADICCIONES": 3.255,
  "MICHIGAN LAW REVIEW": 3.252,
  "METABOLOMICS": 3.252,
  "JOURNAL OF GERIATRIC ONCOLOGY": 3.25,
  "POLYMERS": 3.25,
  "ENERGY TECHNOLOGY": 3.25,
  "JOURNAL OF BIOTECHNOLOGY": 3.25,
  "PATHOLOGY": 3.25,
  "PUBLIC MANAGEMENT REVIEW": 3.25,
  "AMERICAN JOURNAL OF ROENTGENOLOGY": 3.25,
  "FRONTIERS IN PSYCHIATRY": 3.25,
  "JOURNAL OF APPLIED CRYSTALLOGRAPHY": 3.247,
  "APPLIED AND COMPUTATIONAL MATHEMATICS": 3.245,
  "GENOMICS": 3.244,
  "INFECTION AND IMMUNITY": 3.244,
  "SCIENCE TECHNOLOGY & HUMAN VALUES": 3.244,
  "COMPUTATIONAL MECHANICS": 3.244,
  "NANOSCALE RESEARCH LETTERS": 3.244,
  "ARCHIVES OF DISEASE IN CHILDHOOD": 3.243,
  "INTERNATIONAL JOURNAL OF SURGERY": 3.243,
  "GENES BRAIN AND BEHAVIOR": 3.241,
  "INDUSTRY AND INNOVATION": 3.241,
  "JOURNAL OF ENVIRONMENT & DEVELOPMENT": 3.24,
  "JOURNAL OF HUMAN EVOLUTION": 3.239,
  "EUROPEAN EATING DISORDERS REVIEW": 3.239,
  "ACTA OPHTHALMOLOGICA": 3.239,
  "CANCER IMAGING": 3.238,
  "CURRENT TOPICS IN MICROBIOLOGY AND IMMUNOLOGY": 3.238,
  "IEEE TRANSACTIONS ON SIGNAL AND INFORMATION PROCESSING OVER NETWORKS": 3.237,
  "SOCIAL PSYCHIATRY AND PSYCHIATRIC EPIDEMIOLOGY": 3.235,
  "INTERNATIONAL JOURNAL OF HUMAN RESOURCE MANAGEMENT": 3.235,
  "JOURNAL OF ANALYTICAL TOXICOLOGY": 3.234,
  "BOUNDARY-LAYER METEOROLOGY": 3.233,
  "KNEE SURGERY SPORTS TRAUMATOLOGY ARTHROSCOPY": 3.232,
  "REGIONAL ENVIRONMENTAL CHANGE": 3.231,
  "ACCOUNTING ORGANIZATIONS AND SOCIETY": 3.23,
  "CANCER GENOMICS & PROTEOMICS": 3.23,
  "STEM CELLS AND DEVELOPMENT": 3.23,
  "MONTHLY WEATHER REVIEW": 3.229,
  "SOCIOLOGY OF EDUCATION": 3.227,
  "INTERNATIONAL JOURNAL OF BIOCHEMISTRY & CELL BIOLOGY": 3.225,
  "INTERNATIONAL JOURNAL OF MECHANICS AND MATERIALS IN DESIGN": 3.225,
  "JOURNAL OF ASTRONOMICAL TELESCOPES INSTRUMENTS AND SYSTEMS": 3.224,
  "BIODIVERSITY AND CONSERVATION": 3.224,
  "INTERNATIONAL JOURNAL OF GERIATRIC PSYCHIATRY": 3.224,
  "QUALITATIVE RESEARCH": 3.223,
  "JOURNAL OF APPLIED PHYSIOLOGY": 3.221,
  "COMMUNICATIONS ON PURE AND APPLIED MATHEMATICS": 3.22,
  "TRANSLATIONAL ONCOLOGY": 3.22,
  "JOURNAL OF FLUID MECHANICS": 3.22,
  "JOURNAL OF RESEARCH IN SCIENCE TEACHING": 3.22,
  "BRIEFINGS IN FUNCTIONAL GENOMICS": 3.22,
  "PHYSICAL REVIEW C": 3.22,
  "ANNALS OF GLACIOLOGY": 3.218,
  "COLLOIDS AND SURFACES A-PHYSICOCHEMICAL AND ENGINEERING ASPECTS": 3.218,
  "IEEE TRANSACTIONS ON COMPUTERS": 3.217,
  "BIOINSPIRATION & BIOMIMETICS": 3.217,
  "JOURNAL OF NEURO-ONCOLOGY": 3.215,
  "AGRICULTURE AND HUMAN VALUES": 3.214,
  "JOURNAL OF STRUCTURAL GEOLOGY": 3.212,
  "EDUCATIONAL EVALUATION AND POLICY ANALYSIS": 3.212,
  "EMOTION": 3.211,
  "MATHEMATICAL MODELS & METHODS IN APPLIED SCIENCES": 3.209,
  "FOREST ECOLOGY AND MANAGEMENT": 3.208,
  "JOURNAL OF INFORMATION TECHNOLOGY": 3.208,
  "REPRODUCTION": 3.206,
  "WIND ENERGY": 3.202,
  "BODY IMAGE": 3.202,
  "AMERICAN JOURNAL OF MEDICAL GENETICS PART B-NEUROPSYCHIATRIC GENETICS": 3.202,
  "INFECTIOUS DISEASES OF POVERTY": 3.201,
  "JOURNAL OF SOUND AND VIBRATION": 3.2,
  "EUROPEAN UROLOGY SUPPLEMENTS": 3.2,
  "JOURNAL OF SMALL BUSINESS MANAGEMENT": 3.2,
  "JOURNAL OF THE ELECTROCHEMICAL SOCIETY": 3.2,
  "ORGANIC GEOCHEMISTRY": 3.199,
  "DEVELOPMENTAL AND COMPARATIVE IMMUNOLOGY": 3.198,
  "VETERINARY RESEARCH": 3.198,
  "ARCHIVES OF SEXUAL BEHAVIOR": 3.197,
  "EUROPEAN JOURNAL OF CLINICAL NUTRITION": 3.197,
  "JOURNAL OF SURGICAL ONCOLOGY": 3.196,
  "MYCORRHIZA": 3.194,
  "FRONTIERS IN MEDICINE": 3.192,
  "ANTHROPOCENE REVIEW": 3.192,
  "DRUG DELIVERY AND TRANSLATIONAL RESEARCH": 3.19,
  "IMMUNE NETWORK": 3.19,
  "NPJ MICROGRAVITY": 3.189,
  "TRANSFUSION": 3.188,
  "JOURNAL OF BUILDING PERFORMANCE SIMULATION": 3.188,
  "STRATEGIC ORGANIZATION": 3.188,
  "DIABETIC MEDICINE": 3.188,
  "JOURNAL OF NUMERICAL MATHEMATICS": 3.185,
  "ANDROLOGY": 3.185,
  "PLATELETS": 3.182,
  "PROTEOMICS": 3.182,
  "THERAPEUTIC ADVANCES IN HEMATOLOGY": 3.182,
  "BRAIN TOPOGRAPHY": 3.179,
  "GROUP & ORGANIZATION MANAGEMENT": 3.179,
  "BRAIN RESEARCH BULLETIN": 3.179,
  "JOURNAL OF THE ASSOCIATION FOR INFORMATION SYSTEMS": 3.178,
  "SOCIOLOGICAL METHODS & RESEARCH": 3.177,
  "FRONTIERS IN NEURAL CIRCUITS": 3.177,
  "INTEGRATIVE AND COMPARATIVE BIOLOGY": 3.176,
  "SPECTROCHIMICA ACTA PART B-ATOMIC SPECTROSCOPY": 3.176,
  "EXPERT REVIEW OF MOLECULAR DIAGNOSTICS": 3.176,
  "FOREST POLICY AND ECONOMICS": 3.176,
  "JOURNAL OF THE INTERNATIONAL NEUROPSYCHOLOGICAL SOCIETY": 3.176,
  "NUTRITION & DIABETES": 3.175,
  "OCEAN MODELLING": 3.175,
  "SPE JOURNAL": 3.173,
  "EUROPEAN JOURNAL OF DERMATOLOGY": 3.173,
  "GENETICS SELECTION EVOLUTION": 3.173,
  "INFLUENZA AND OTHER RESPIRATORY VIRUSES": 3.171,
  "JOURNAL OF THE AMERICAN CERAMIC SOCIETY": 3.171,
  "JOURNAL OF OPTICAL COMMUNICATIONS AND NETWORKING": 3.171,
  "PHILOSOPHICAL TRANSACTIONS OF THE ROYAL SOCIETY A-MATHEMATICAL PHYSICAL AND ENGINEERING SCIENCES": 3.17,
  "PHYSICS TODAY": 3.17,
  "APPLIED MATHEMATICS AND COMPUTATION": 3.17,
  "INTERFACE FOCUS": 3.169,
  "AMERICAN JOURNAL OF REPRODUCTIVE IMMUNOLOGY": 3.167,
  "AIN SHAMS ENGINEERING JOURNAL": 3.167,
  "EXPERT REVIEW OF ANTI-INFECTIVE THERAPY": 3.167,
  "PHYSICS-USPEKHI": 3.167,
  "BIOMOLECULES & THERAPEUTICS": 3.164,
  "JOURNAL OF PURCHASING AND SUPPLY MANAGEMENT": 3.164,
  "ARCHAEA-AN INTERNATIONAL MICROBIOLOGICAL JOURNAL": 3.163,
  "JOURNAL OF CLINICAL APHERESIS": 3.163,
  "JOURNAL OF HUMAN NUTRITION AND DIETETICS": 3.163,
  "COMMUNICATION RESEARCH": 3.162,
  "PALEOCEANOGRAPHY": 3.161,
  "SOCIAL SCIENCE & MEDICINE": 3.161,
  "FRONTIERS IN MARINE SCIENCE": 3.161,
  "INTERNATIONAL JOURNAL OF FUZZY SYSTEMS": 3.161,
  "NEW POLITICAL ECONOMY": 3.16,
  "ENGINEERING STRUCTURES": 3.16,
  "JOURNAL OF PERSONALITY": 3.16,
  "SHOCK": 3.16,
  "JOURNAL OF DAIRY SCIENCE": 3.159,
  "EXPERIMENTAL GERONTOLOGY": 3.159,
  "JOURNAL OF GLOBAL HEALTH": 3.158,
  "CYTOKINE": 3.158,
  "JOURNAL OF EPIDEMIOLOGY": 3.157,
  "LIQUID CRYSTALS": 3.157,
  "CHEMPHYSCHEM": 3.156,
  "IEEE SENSORS JOURNAL": 3.155,
  "JOURNAL OF SCHOOL PSYCHOLOGY": 3.155,
  "QUANTITATIVE IMAGING IN MEDICINE AND SURGERY": 3.154,
  "REACTIVE & FUNCTIONAL POLYMERS": 3.153,
  "REGIONAL STUDIES": 3.153,
  "CHEMICAL ENGINEERING RESEARCH & DESIGN": 3.153,
  "PRESLIA": 3.153,
  "JOURNAL OF FLUIDS AND STRUCTURES": 3.152,
  "NEW JOURNAL OF CHEMISTRY": 3.152,
  "APPLIED GEOGRAPHY": 3.15,
  "IEEE TRANSACTIONS ON INSTRUMENTATION AND MEASUREMENT": 3.15,
  "TOXICOLOGY IN VITRO": 3.149,
  "EUROPEAN JOURNAL OF POLITICAL RESEARCH": 3.149,
  "JOURNAL OF APPLIED TOXICOLOGY": 3.149,
  "MYCOSES": 3.149,
  "CHAOS SOLITONS & FRACTALS": 3.147,
  "JOURNAL OF INTERPERSONAL VIOLENCE": 3.147,
  "MOLECULAR IMMUNOLOGY": 3.147,
  "JOURNAL FOR RESEARCH IN MATHEMATICS EDUCATION": 3.146,
  "JOURNAL OF ORTHOPAEDIC TRANSLATION": 3.146,
  "COMPUTERS & SECURITY": 3.144,
  "ENVIRONMENTAL TOXICOLOGY AND PHARMACOLOGY": 3.143,
  "INFLAMMATION RESEARCH": 3.143,
  "MOLECULES": 3.142,
  "PLANTA": 3.141,
  "JOURNAL OF SEX RESEARCH": 3.141,
  "ACCIDENT ANALYSIS AND PREVENTION": 3.141,
  "GENDER & SOCIETY": 3.14,
  "JOURNAL OF ORTHOPAEDIC & SPORTS PHYSICAL THERAPY": 3.138,
  "MOLECULAR DIAGNOSIS & THERAPY": 3.138,
  "POLITICAL GEOGRAPHY": 3.137,
  "BOTANICAL JOURNAL OF THE LINNEAN SOCIETY": 3.135,
  "PHOTOSYNTHESIS RESEARCH": 3.133,
  "JAMA FACIAL PLASTIC SURGERY": 3.132,
  "EUROPEAN JOURNAL OF APPLIED PHYSIOLOGY": 3.131,
  "FOOD AND ENVIRONMENTAL VIROLOGY": 3.131,
  "TICKS AND TICK-BORNE DISEASES": 3.131,
  "NATURE AND SCIENCE OF SLEEP": 3.13,
  "AMERICAN ETHNOLOGIST": 3.129,
  "ANNALS OF NUTRITION AND METABOLISM": 3.128,
  "IET ELECTRIC POWER APPLICATIONS": 3.128,
  "IUBMB LIFE": 3.128,
  "ANNALS OF MEDICINE": 3.127,
  "COMPUTER-AIDED DESIGN": 3.127,
  "GPS SOLUTIONS": 3.127,
  "RSC ADVANCES": 3.126,
  "ANIMAL CONSERVATION": 3.125,
  "CLINICAL ONCOLOGY": 3.125,
  "HPB": 3.125,
  "ONCOTARGETS AND THERAPY": 3.125,
  "ACTA MATHEMATICA": 3.124,
  "BMC EVOLUTIONARY BIOLOGY": 3.123,
  "PHARMACOTHERAPY": 3.123,
  "JOURNAL OF ORTHOPAEDIC RESEARCH": 3.123,
  "PHYSICAL THERAPY": 3.121,
  "URBAN FORESTRY & URBAN GREENING": 3.12,
  "RESULTS IN PHYSICS": 3.12,
  "APPLIED LINGUISTICS": 3.12,
  "ONCOLOGY REPORTS": 3.119,
  "JOURNAL OF NEUROENDOCRINOLOGY": 3.117,
  "JOURNAL OF DIABETES RESEARCH": 3.116,
  "EXPERT OPINION ON PHARMACOTHERAPY": 3.114,
  "MACROMOLECULAR MATERIALS AND ENGINEERING": 3.114,
  "PURINERGIC SIGNALLING": 3.114,
  "ANNALS OF THE AMERICAN ASSOCIATION OF GEOGRAPHERS": 3.113,
  "DIGESTIVE AND LIVER DISEASE": 3.111,
  "DYSPHAGIA": 3.111,
  "PERSPECTIVES IN PUBLIC HEALTH": 3.111,
  "AMERICAN ECONOMIC JOURNAL-MACROECONOMICS": 3.111,
  "FOOD AND BIOPROCESS TECHNOLOGY": 3.111,
  "SUICIDE AND LIFE-THREATENING BEHAVIOR": 3.111,
  "CHEMICAL ENGINEERING AND PROCESSING-PROCESS INTENSIFICATION": 3.11,
  "PARASITES & VECTORS": 3.109,
  "SENSORS": 3.107,
  "COMPUTER NETWORKS": 3.107,
  "IEEE TRANSACTIONS ON TERAHERTZ SCIENCE AND TECHNOLOGY": 3.106,
  "INDIAN JOURNAL OF DERMATOLOGY VENEREOLOGY & LEPROLOGY": 3.106,
  "JOURNAL OF ARCHAEOLOGICAL SCIENCE": 3.106,
  "PHYSICS IN MEDICINE AND BIOLOGY": 3.105,
  "QUALITATIVE HEALTH RESEARCH": 3.104,
  "DIGESTION": 3.104,
  "EUROPEAN JOURNAL OF ORGANIC CHEMISTRY": 3.103,
  "JOURNAL OF COGNITIVE NEUROSCIENCE": 3.103,
  "IMMUNOTHERAPY": 3.103,
  "ENTOMOLOGIA GENERALIS": 3.102,
  "CIRCULATION JOURNAL": 3.101,
  "EUROPEAN THYROID JOURNAL": 3.101,
  "JOURNAL OF EXPOSURE SCIENCE AND ENVIRONMENTAL EPIDEMIOLOGY": 3.101,
  "CMC-COMPUTERS MATERIALS & CONTINUA": 3.099,
  "EUROPEAN JOURNAL OF CELL BIOLOGY": 3.099,
  "JOURNAL OF MANAGED CARE & SPECIALTY PHARMACY": 3.099,
  "AQUACULTURE": 3.098,
  "DIFFERENTIATION": 3.098,
  "ELECTRIC POWER SYSTEMS RESEARCH": 3.095,
  "IEEE DESIGN & TEST": 3.095,
  "JOURNAL OF MATHEMATICAL PSYCHOLOGY": 3.094,
  "QUANTUM SCIENCE AND TECHNOLOGY": 3.094,
  "COGNITIVE NEURODYNAMICS": 3.094,
  "ENERGY & FUELS": 3.094,
  "EUROPEAN JOURNAL OF PSYCHOTRAUMATOLOGY": 3.093,
  "JOURNAL OF CLINICAL VIROLOGY": 3.093,
  "MATERIALS LETTERS": 3.093,
  "GLOBAL NETWORKS-A JOURNAL OF TRANSNATIONAL AFFAIRS": 3.092,
  "JOURNAL OF EXPERIMENTAL BIOLOGY": 3.092,
  "JOURNAL OF STRENGTH AND CONDITIONING RESEARCH": 3.091,
  "NEUROGENETICS": 3.091,
  "BEST PRACTICE & RESEARCH IN CLINICAL RHEUMATOLOGY": 3.09,
  "CHEMMEDCHEM": 3.09,
  "AMERICAN JOURNAL OF CLINICAL ONCOLOGY-CANCER CLINICAL TRIALS": 3.089,
  "ENVIRONMENT AND URBANIZATION": 3.089,
  "IEEE SPECTRUM": 3.088,
  "JOURNAL OF PEDIATRIC GASTROENTEROLOGY AND NUTRITION": 3.088,
  "BIOLOGICAL CHEMISTRY": 3.088,
  "CURRENT OPINION IN ALLERGY AND CLINICAL IMMUNOLOGY": 3.087,
  "CURRENT OPINION IN NEPHROLOGY AND HYPERTENSION": 3.087,
  "JOURNAL OF MANAGEMENT INFORMATION SYSTEMS": 3.087,
  "FOODS": 3.087,
  "JOURNAL OF HOSPITALITY MARKETING & MANAGEMENT": 3.086,
  "BIOLOGY DIRECT": 3.085,
  "JOURNAL OF WIND ENGINEERING AND INDUSTRIAL AERODYNAMICS": 3.085,
  "NEUROBIOLOGY OF LEARNING AND MEMORY": 3.084,
  "CANCER CHEMOTHERAPY AND PHARMACOLOGY": 3.084,
  "ONCOLOGY-NEW YORK": 3.083,
  "EXPERIMENTAL BIOLOGY AND MEDICINE": 3.082,
  "HIGHER EDUCATION": 3.08,
  "COMPUTERS & OPERATIONS RESEARCH": 3.079,
  "EJNMMI RESEARCH": 3.079,
  "FRICTION": 3.078,
  "FRONTIERS IN NEUROROBOTICS": 3.078,
  "HIGH POWER LASER SCIENCE AND ENGINEERING": 3.078,
  "HUMAN RESOURCE DEVELOPMENT QUARTERLY": 3.077,
  "INTERNATIONAL GEOLOGY REVIEW": 3.076,
  "INFECTION AND DRUG RESISTANCE": 3.076,
  "INTERNATIONAL JOURNAL OF PRESS-POLITICS": 3.074,
  "JOURNAL OF REFRACTIVE SURGERY": 3.074,
  "JOURNAL OF BREATH RESEARCH": 3.074,
  "MINDFULNESS": 3.073,
  "PERMAFROST AND PERIGLACIAL PROCESSES": 3.071,
  "PHYSIOLOGIA PLANTARUM": 3.07,
  "PROTIST": 3.069,
  "SURGICAL ONCOLOGY-OXFORD": 3.068,
  "TRANSFUSION MEDICINE AND HEMOTHERAPY": 3.067,
  "THERAPEUTIC ADVANCES IN PSYCHOPHARMACOLOGY": 3.067,
  "TOPICS IN ORGANOMETALLIC CHEMISTRY": 3.066,
  "EXPERIMENTAL EYE RESEARCH": 3.065,
  "JOURNAL OF NEUROSURGERY-SPINE": 3.065,
  "COLORECTAL DISEASE": 3.064,
  "JOURNAL OF CHEMICAL PHYSICS": 3.064,
  "ACTA DIABETOLOGICA": 3.064,
  "REGULATORY TOXICOLOGY AND PHARMACOLOGY": 3.063,
  "JOURNAL OF FOOD COMPOSITION AND ANALYSIS": 3.063,
  "JOURNAL OF INDUSTRIAL MICROBIOLOGY & BIOTECHNOLOGY": 3.062,
  "EXPERT REVIEW OF GASTROENTEROLOGY & HEPATOLOGY": 3.061,
  "INTERNATIONAL REVIEW OF PSYCHIATRY": 3.061,
  "MOLECULAR MEDICINE": 3.06,
  "BIOTROPICA": 3.06,
  "IEEE TRANSACTIONS ON ULTRASONICS FERROELECTRICS AND FREQUENCY CONTROL": 3.059,
  "JOURNAL OF TRAVEL & TOURISM MARKETING": 3.058,
  "INJURY PREVENTION": 3.058,
  "WATER RESOURCES MANAGEMENT": 3.058,
  "JOURNAL OF ENDOVASCULAR THERAPY": 3.058,
  "SUBSTANCE ABUSE": 3.058,
  "EUROPEAN MANAGEMENT JOURNAL": 3.057,
  "BRITISH ACCOUNTING REVIEW": 3.057,
  "BIOSYSTEMS ENGINEERING": 3.056,
  "JOURNAL OF PHARMACEUTICAL AND BIOMEDICAL ANALYSIS": 3.055,
  "AMERICAN JOURNAL OF SCIENCE": 3.055,
  "FRONTIERS IN ZOOLOGY": 3.055,
  "YOUTH VIOLENCE AND JUVENILE JUSTICE": 3.054,
  "JOURNAL OF EXPERIMENTAL CHILD PSYCHOLOGY": 3.053,
  "ANNUAL REVIEW OF RESOURCE ECONOMICS": 3.051,
  "MECHATRONICS": 3.051,
  "JOURNAL OF CLINICAL PSYCHOPHARMACOLOGY": 3.051,
  "PLANT REPRODUCTION": 3.049,
  "CLINICAL KIDNEY JOURNAL": 3.049,
  "JOURNAL OF HYDRAULIC RESEARCH": 3.049,
  "MATERIALS": 3.049,
  "FRACTALS-COMPLEX GEOMETRY PATTERNS AND SCALING IN NATURE AND SOCIETY": 3.048,
  "JOURNAL OF PERSONALITY DISORDERS": 3.047,
  "PSYCHOLOGY OF ADDICTIVE BEHAVIORS": 3.047,
  "GUT AND LIVER": 3.046,
  "BMB REPORTS": 3.045,
  "JOURNAL OF BIOCHEMICAL AND MOLECULAR TOXICOLOGY": 3.045,
  "APPLIED AND COMPUTATIONAL HARMONIC ANALYSIS": 3.045,
  "ACADEMIC EMERGENCY MEDICINE": 3.043,
  "ADDICTIVE BEHAVIORS": 3.043,
  "EXPERT REVIEW OF PROTEOMICS": 3.043,
  "JOURNAL OF RADIATION RESEARCH AND APPLIED SCIENCES": 3.043,
  "PROBIOTICS AND ANTIMICROBIAL PROTEINS": 3.042,
  "AMERICAN JOURNAL OF NEPHROLOGY": 3.041,
  "CARTILAGE": 3.041,
  "JOURNAL OF LUMINESCENCE": 3.04,
  "PROGRESS IN BRAIN RESEARCH": 3.04,
  "BIOLOGY OF REPRODUCTION": 3.038,
  "JOURNAL OF AGRONOMY AND CROP SCIENCE": 3.038,
  "MEDICAL MICROBIOLOGY AND IMMUNOLOGY": 3.038,
  "EVOLUTION AND HUMAN BEHAVIOR": 3.037,
  "BIOSOCIETIES": 3.037,
  "MECHANICS OF MATERIALS": 3.034,
  "JOURNAL OF NEUROSURGICAL ANESTHESIOLOGY": 3.033,
  "AGING & MENTAL HEALTH": 3.032,
  "STRATEGIC ENTREPRENEURSHIP JOURNAL": 3.032,
  "JOURNAL OF QUANTITATIVE SPECTROSCOPY & RADIATIVE TRANSFER": 3.032,
  "EAR AND HEARING": 3.031,
  "POPULATION HEALTH METRICS": 3.031,
  "STRUCTURAL DYNAMICS-US": 3.031,
  "BIOCHEMISTRY": 3.03,
  "BIG DATA RESEARCH": 3.03,
  "HEARING RESEARCH": 3.03,
  "INTERNATIONAL JOURNAL FOR PARASITOLOGY-DRUGS AND DRUG RESISTANCE": 3.03,
  "JOURNAL OF BIOMEDICAL INFORMATICS": 3.03,
  "WEAR": 3.03,
  "IEEE MICROWAVE MAGAZINE": 3.03,
  "SOCIAL NETWORKS": 3.029,
  "EUROPEAN JOURNAL OF RADIOLOGY": 3.029,
  "GEOCHEMISTRY GEOPHYSICS GEOSYSTEMS": 3.029,
  "IEEE SOFTWARE": 3.029,
  "JOURNAL OF VEGETATION SCIENCE": 3.028,
  "BIOMEDICAL SIGNAL PROCESSING AND CONTROL": 3.027,
  "JOURNAL OF THERMAL STRESSES": 3.025,
  "POLYMER TESTING": 3.025,
  "MENOPAUSE-THE JOURNAL OF THE NORTH AMERICAN MENOPAUSE SOCIETY": 3.025,
  "PAIN PHYSICIAN": 3.024,
  "JOURNAL OF THROMBOSIS AND THROMBOLYSIS": 3.024,
  "GENES CHROMOSOMES & CANCER": 3.024,
  "METHODS AND APPLICATIONS IN FLUORESCENCE": 3.022,
  "BENEFICIAL MICROBES": 3.022,
  "INFLAMMATION": 3.022,
  "JOURNAL OF EXPERIMENTAL PSYCHOLOGY-HUMAN PERCEPTION AND PERFORMANCE": 3.022,
  "CYTOMETRY PART B-CLINICAL CYTOMETRY": 3.022,
  "MOLECULAR CATALYSIS": 3.022,
  "DIGESTIVE DISEASES AND SCIENCES": 3.022,
  "JOURNAL OF MOLECULAR HISTOLOGY": 3.021,
  "DEVELOPMENTAL BIOLOGY": 3.021,
  "AQUATIC CONSERVATION-MARINE AND FRESHWATER ECOSYSTEMS": 3.02,
  "CLINICAL THERAPEUTICS": 3.02,
  "JOURNAL OF VENOMOUS ANIMALS AND TOXINS INCLUDING TROPICAL DISEASES": 3.019,
  "RESPIRATION": 3.018,
  "HUMAN RESOURCE MANAGEMENT": 3.017,
  "NDT & E INTERNATIONAL": 3.017,
  "ANNALS OF THE MISSOURI BOTANICAL GARDEN": 3.017,
  "BMC CANCER": 3.016,
  "INTERNATIONAL ARCHIVES OF ALLERGY AND IMMUNOLOGY": 3.016,
  "EUROPEAN JOURNAL OF MECHANICS A-SOLIDS": 3.015,
  "SPECTROCHIMICA ACTA PART A-MOLECULAR AND BIOMOLECULAR SPECTROSCOPY": 3.015,
  "INTERNATIONAL JOURNAL OF CONTROL": 3.015,
  "REPRODUCTIVE BIOMEDICINE ONLINE": 3.015,
  "BRAIN RESEARCH": 3.014,
  "CONTRACEPTION": 3.014,
  "ENTREPRENEURSHIP AND REGIONAL DEVELOPMENT": 3.013,
  "INTERNATIONAL JOURNAL OF MOLECULAR MEDICINE": 3.013,
  "ROBOTICS AND AUTONOMOUS SYSTEMS": 3.013,
  "INFECTION": 3.011,
  "REVISTA DE PSIQUIATRIA Y SALUD MENTAL": 3.011,
  "ECONOMIC JOURNAL": 3.01,
  "GEOFORUM": 3.01,
  "GLYCOCONJUGATE JOURNAL": 3.01,
  "PHYSICAL REVIEW MATERIALS": 3.01,
  "PLASMONICS": 3.008,
  "MOLECULAR ORAL MICROBIOLOGY": 3.008,
  "ANNALS OF CLINICAL MICROBIOLOGY AND ANTIMICROBIALS": 3.005,
  "LUPUS": 3.005,
  "FRONTIERS IN NEUROANATOMY": 3.002,
  "JOURNAL OF PHYSICAL CHEMISTRY B": 3,
  "BMC PALLIATIVE CARE": 3,
  "SOCIAL SCIENCE COMPUTER REVIEW": 3,
  "ANTIBIOTICS-BASEL": 3,
  "INFORMATION AND SOFTWARE TECHNOLOGY": 3,
  "BUSINESS ETHICS-A EUROPEAN REVIEW": 3,
  "JOURNAL OF EXPERIMENTAL EDUCATION": 3,
  "ATMOSPHERIC POLLUTION RESEARCH": 3,
  "DNA AND CELL BIOLOGY": 3,
  "JOURNAL OF CLINICAL PHARMACOLOGY": 3,
  "OECOLOGIA": 3,
  "ENVIRONMENTAL SCIENCE AND POLLUTION RESEARCH": 3,
  "JOURNAL OF GYNECOLOGIC ONCOLOGY": 3,
  "ELECTRONIC COMMERCE RESEARCH AND APPLICATIONS": 3,
  "JOURNAL OF CARDIOVASCULAR ELECTROPHYSIOLOGY": 3,
  "JOURNAL OF PHARMACOKINETICS AND PHARMACODYNAMICS": 3,
  "ZOOLOGICAL JOURNAL OF THE LINNEAN SOCIETY": 3,
  "AIDS AND BEHAVIOR": 3,
  "DIGESTIVE DISEASES": 2.998,
  "ENGINEERING FRACTURE MECHANICS": 2.998,
  "ORGANIZATIONAL BEHAVIOR AND HUMAN DECISION PROCESSES": 2.997,
  "FUZZY SETS AND SYSTEMS": 2.997,
  "PHYSICAL REVIEW A": 2.996,
  "ADVANCED ENGINEERING MATERIALS": 2.996,
  "INVENTIONES MATHEMATICAE": 2.994,
  "VIRTUAL REALITY": 2.993,
  "PHYTOCHEMISTRY": 2.991,
  "CELL STRESS & CHAPERONES": 2.991,
  "JOURNAL OF NEURAL TRANSMISSION": 2.991,
  "SPINE": 2.989,
  "NEUROTOXICOLOGY AND TERATOLOGY": 2.989,
  "ANNALS OF STATISTICS": 2.988,
  "CRITICAL REVIEWS IN THERAPEUTIC DRUG CARRIER SYSTEMS": 2.987,
  "MUTAGENESIS": 2.987,
  "BIOLOGICAL INVASIONS": 2.987,
  "CLINICAL ENDOCRINOLOGY": 2.986,
  "SCIENCE EDUCATION": 2.986,
  "IEEE-ACM TRANSACTIONS ON COMPUTATIONAL BIOLOGY AND BIOINFORMATICS": 2.986,
  "ANNALS OF CARDIOTHORACIC SURGERY": 2.985,
  "JOURNAL OF TRACE ELEMENTS IN MEDICINE AND BIOLOGY": 2.984,
  "MACROMOLECULAR BIOSCIENCE": 2.983,
  "RADIATION ONCOLOGY": 2.983,
  "APPLIED GEOCHEMISTRY": 2.982,
  "CLINICAL JOURNAL OF PAIN": 2.982,
  "ENERGY SCIENCE & ENGINEERING": 2.981,
  "MIT TECHNOLOGY REVIEW": 2.98,
  "COMPTES RENDUS PHYSIQUE": 2.978,
  "CLINICAL PROTEOMICS": 2.978,
  "FRONTIERS IN EARTH SCIENCE": 2.978,
  "IEEE INTERNET COMPUTING": 2.977,
  "NEUROSURGICAL FOCUS": 2.976,
  "GEOSYNTHETICS INTERNATIONAL": 2.975,
  "APPLIED SPECTROSCOPY REVIEWS": 2.974,
  "IEEE TRANSACTIONS ON RELIABILITY": 2.972,
  "CANADIAN JOURNAL OF DIABETES": 2.971,
  "JOURNAL OF PETROLEUM SCIENCE AND ENGINEERING": 2.97,
  "SOLID STATE IONICS": 2.97,
  "CHRONIC RESPIRATORY DISEASE": 2.968,
  "IIE TRANSACTIONS": 2.966,
  "INTERNATIONAL JOURNAL OF FRACTURE": 2.965,
  "MOLECULAR AND CELLULAR BIOCHEMISTRY": 2.964,
  "AMYOTROPHIC LATERAL SCLEROSIS AND FRONTOTEMPORAL DEGENERATION": 2.963,
  "GENES AND NUTRITION": 2.963,
  "NATURAL HAZARDS AND EARTH SYSTEM SCIENCES": 2.963,
  "PROCESS BIOCHEMISTRY": 2.963,
  "SEMINARS IN PERINATOLOGY": 2.963,
  "APPLIED INTELLIGENCE": 2.962,
  "POLISH ARCHIVES OF INTERNAL MEDICINE-POLSKIE ARCHIWUM MEDYCYNY WEWNETRZNEJ": 2.961,
  "BRITISH JOURNAL OF CRIMINOLOGY": 2.961,
  "PEDIATRIC RESEARCH": 2.961,
  "CANCER BIOLOGY & THERAPY": 2.961,
  "DATA MINING AND KNOWLEDGE DISCOVERY": 2.96,
  "MOLECULAR GENETICS AND GENOMICS": 2.96,
  "ARCHIVUM IMMUNOLOGIAE ET THERAPIAE EXPERIMENTALIS": 2.96,
  "HEMATOLOGY-ONCOLOGY CLINICS OF NORTH AMERICA": 2.959,
  "FORESTRY": 2.959,
  "PROSTATE": 2.958,
  "SIAM JOURNAL ON OPTIMIZATION": 2.958,
  "EXPRESS POLYMER LETTERS": 2.957,
  "RESEARCH EVALUATION": 2.956,
  "REVIEWS IN ANALYTICAL CHEMISTRY": 2.956,
  "ENVIRONMENTAL MICROBIOLOGY REPORTS": 2.956,
  "JOURNAL OF INTENSIVE CARE MEDICINE": 2.955,
  "MECHANICS OF ADVANCED MATERIALS AND STRUCTURES": 2.954,
  "NEUROPSYCHOLOGIA": 2.953,
  "ACM TRANSACTIONS ON MULTIMEDIA COMPUTING COMMUNICATIONS AND APPLICATIONS": 2.953,
  "FRONTIERS IN HUMAN NEUROSCIENCE": 2.952,
  "PESTICIDE BIOCHEMISTRY AND PHYSIOLOGY": 2.952,
  "PHARMACOEPIDEMIOLOGY AND DRUG SAFETY": 2.952,
  "SYNTHETIC METALS": 2.951,
  "JOURNAL OF NUTRITION EDUCATION AND BEHAVIOR": 2.95,
  "EXPERIMENTAL DERMATOLOGY": 2.95,
  "JOURNAL OF BEHAVIORAL MEDICINE": 2.949,
  "VIRCHOWS ARCHIV": 2.949,
  "SYNTHESIS-STUTTGART": 2.948,
  "JOURNAL OF AEROSOL MEDICINE AND PULMONARY DRUG DELIVERY": 2.946,
  "JOURNAL OF BONE ONCOLOGY": 2.945,
  "JOURNAL OF SHOULDER AND ELBOW SURGERY": 2.944,
  "JOURNAL OF VIBRATION AND CONTROL": 2.943,
  "MARINE POLICY": 2.943,
  "MARINE STRUCTURES": 2.943,
  "AEOLIAN RESEARCH": 2.942,
  "CURRENT OPINION IN HEMATOLOGY": 2.942,
  "PROSTAGLANDINS LEUKOTRIENES AND ESSENTIAL FATTY ACIDS": 2.941,
  "UROLOGIC ONCOLOGY-SEMINARS AND ORIGINAL INVESTIGATIONS": 2.94,
  "ASIAN JOURNAL OF ANDROLOGY": 2.94,
  "INTERNATIONAL JOURNAL OF INFORMATION TECHNOLOGY & DECISION MAKING": 2.939,
  "INTERNATIONAL JOURNAL OF HEALTH GEOGRAPHICS": 2.939,
  "JOURNAL OF INSECT PHYSIOLOGY": 2.939,
  "ACM TRANSACTIONS ON INTELLIGENT SYSTEMS AND TECHNOLOGY": 2.939,
  "MYCOLOGIA": 2.938,
  "CANCER BIOMARKERS": 2.938,
  "BRAZILIAN JOURNAL OF MICROBIOLOGY": 2.937,
  "NEUROCRITICAL CARE": 2.937,
  "SOCIOLOGIA RURALIS": 2.936,
  "INFECTION CONTROL AND HOSPITAL EPIDEMIOLOGY": 2.935,
  "JOURNAL OF DEVELOPMENT ECONOMICS": 2.935,
  "MOLECULAR AND CELLULAR NEUROSCIENCE": 2.935,
  "MOLECULAR BIOSYSTEMS": 2.935,
  "PSYCHOLOGICAL RESEARCH-PSYCHOLOGISCHE FORSCHUNG": 2.934,
  "EXCEPTIONAL CHILDREN": 2.934,
  "STUDIES IN HIGHER EDUCATION": 2.933,
  "AEU-INTERNATIONAL JOURNAL OF ELECTRONICS AND COMMUNICATIONS": 2.933,
  "ACTA NEUROLOGICA SCANDINAVICA": 2.932,
  "DEVELOPMENTAL DYNAMICS": 2.931,
  "MEDICAL MYCOLOGY": 2.931,
  "PREVENTION SCIENCE": 2.93,
  "ANNALS OF HEMATOLOGY": 2.93,
  "WOUND REPAIR AND REGENERATION": 2.929,
  "JOURNAL OF HOSPITALITY & TOURISM RESEARCH": 2.928,
  "DEEP-SEA RESEARCH PART I-OCEANOGRAPHIC RESEARCH PAPERS": 2.928,
  "DERMATOLOGIC CLINICS": 2.928,
  "JOURNAL OF MODERN POWER SYSTEMS AND CLEAN ENERGY": 2.928,
  "NEWSLETTERS ON STRATIGRAPHY": 2.927,
  "NUTRIENT CYCLING IN AGROECOSYSTEMS": 2.927,
  "THEORETICAL AND APPLIED FRACTURE MECHANICS": 2.927,
  "BIOFOULING": 2.926,
  "GEOSPHERE": 2.926,
  "HEALTH EXPECTATIONS": 2.926,
  "ARCHIVES OF CIVIL AND MECHANICAL ENGINEERING": 2.926,
  "DRUGS & AGING": 2.926,
  "JOURNAL OF QUATERNARY SCIENCE": 2.925,
  "JOURNAL OF RARE EARTHS": 2.924,
  "CHILD ABUSE & NEGLECT": 2.924,
  "JOURNAL OF COMPUTATIONAL PHYSICS": 2.923,
  "JOURNAL OF THE FORMOSAN MEDICAL ASSOCIATION": 2.923,
  "AMERICAN JOURNAL OF CARDIOLOGY": 2.922,
  "COGNITIVE BEHAVIOUR THERAPY": 2.922,
  "HUMAN RESOURCE MANAGEMENT JOURNAL": 2.922,
  "MINI-REVIEWS IN MEDICINAL CHEMISTRY": 2.922,
  "AMERICAN JOURNAL OF BOTANY": 2.921,
  "APPLIED MATHEMATICAL MODELLING": 2.921,
  "EPJ QUANTUM TECHNOLOGY": 2.919,
  "MINERVA ANESTESIOLOGICA": 2.919,
  "IET POWER ELECTRONICS": 2.918,
  "MAGNETIC RESONANCE MATERIALS IN PHYSICS BIOLOGY AND MEDICINE": 2.918,
  "EARLY CHILDHOOD RESEARCH QUARTERLY": 2.915,
  "ENDOSCOPIC ULTRASOUND": 2.915,
  "JOURNAL OF KING SAUD UNIVERSITY SCIENCE": 2.914,
  "JOURNAL OF ENDODONTICS": 2.914,
  "JOURNAL OF NEUROIMMUNOLOGY": 2.911,
  "JOURNAL OF PHYCOLOGY": 2.911,
  "JOURNAL OF TISSUE VIABILITY": 2.91,
  "JOURNAL OF INTERNATIONAL MANAGEMENT": 2.91,
  "AEROSPACE SCIENCE AND TECHNOLOGY": 2.909,
  "BIOMECHANICS AND MODELING IN MECHANOBIOLOGY": 2.908,
  "INTERNATIONAL JOURNAL OF MULTIPHASE FLOW": 2.908,
  "JOURNAL OF PERSONALITY ASSESSMENT": 2.908,
  "JOURNAL OF PHYSICS D-APPLIED PHYSICS": 2.908,
  "BUSINESS HORIZONS": 2.907,
  "INTERNATIONAL JOURNAL OF LOGISTICS-RESEARCH AND APPLICATIONS": 2.907,
  "JOURNAL OF MECHANICAL DESIGN": 2.906,
  "JOURNAL OF VASCULAR AND INTERVENTIONAL RADIOLOGY": 2.906,
  "DIABETES THERAPY": 2.906,
  "RESTORATION ECOLOGY": 2.905,
  "ENVIRONMENT AND PLANNING B-URBAN ANALYTICS AND CITY SCIENCE": 2.903,
  "FREE RADICAL RESEARCH": 2.903,
  "JOURNAL OF PLANT PHYSIOLOGY": 2.903,
  "REVIEW OF PUBLIC PERSONNEL ADMINISTRATION": 2.902,
  "CURRENT OPINION IN OPHTHALMOLOGY": 2.901,
  "REVIEWS IN INORGANIC CHEMISTRY": 2.9,
  "CAMBRIDGE JOURNAL OF REGIONS ECONOMY AND SOCIETY": 2.898,
  "JOURNAL OF GEOPHYSICAL RESEARCH-SPACE PHYSICS": 2.897,
  "JOURNAL OF SPACE WEATHER AND SPACE CLIMATE": 2.897,
  "PATIENT EDUCATION AND COUNSELING": 2.897,
  "JOURNAL OF ASSISTED REPRODUCTION AND GENETICS": 2.896,
  "SAUDI JOURNAL OF BIOLOGICAL SCIENCES": 2.895,
  "NPJ PRIMARY CARE RESPIRATORY MEDICINE": 2.895,
  "PROGRESS IN MOLECULAR BIOLOGY AND TRANSLATIONAL SCIENCE": 2.895,
  "BMC GERIATRICS": 2.895,
  "EUROPEAN JOURNAL OF SOIL SCIENCE": 2.894,
  "JOURNAL OF EXPERIMENTAL CRIMINOLOGY": 2.893,
  "PROCEEDINGS OF THE ROYAL SOCIETY A-MATHEMATICAL PHYSICAL AND ENGINEERING SCIENCES": 2.893,
  "SOCIOLOGY-THE JOURNAL OF THE BRITISH SOCIOLOGICAL ASSOCIATION": 2.893,
  "PEDIATRIC NEPHROLOGY": 2.892,
  "SIGNAL PROCESSING-IMAGE COMMUNICATION": 2.892,
  "INTERNATIONAL REVIEW OF SOCIAL PSYCHOLOGY": 2.892,
  "JOURNAL OF CHROMATOGRAPHY B-ANALYTICAL TECHNOLOGIES IN THE BIOMEDICAL AND LIFE SCIENCES": 2.891,
  "JOURNAL OF GEODYNAMICS": 2.891,
  "COMPUTERS & MATHEMATICS WITH APPLICATIONS": 2.89,
  "INTERNATIONAL JOURNAL OF SUSTAINABLE DEVELOPMENT AND WORLD ECOLOGY": 2.888,
  "JOURNAL OF SPORTS SCIENCES": 2.888,
  "FRONTIERS IN INTEGRATIVE NEUROSCIENCE": 2.887,
  "PATTERN RECOGNITION LETTERS": 2.886,
  "FRONTIERS OF CHEMICAL SCIENCE AND ENGINEERING": 2.886,
  "JOURNAL OF GENERAL VIROLOGY": 2.885,
  "JOURNAL OF RAMAN SPECTROSCOPY": 2.884,
  "MACHINE LEARNING": 2.884,
  "SYSTEMATIC AND APPLIED MICROBIOLOGY": 2.884,
  "CLINICS AND RESEARCH IN HEPATOLOGY AND GASTROENTEROLOGY": 2.883,
  "STOCHASTIC ENVIRONMENTAL RESEARCH AND RISK ASSESSMENT": 2.883,
  "BRITISH MEDICAL BULLETIN": 2.883,
  "CHINESE JOURNAL OF POLYMER SCIENCE": 2.883,
  "CONDOR": 2.883,
  "JOURNAL OF FAMILY THEORY & REVIEW": 2.882,
  "STRUCTURAL ENGINEERING AND MECHANICS": 2.882,
  "BIOORGANIC & MEDICINAL CHEMISTRY": 2.881,
  "NEUROLOGIC CLINICS": 2.88,
  "ORYX": 2.879,
  "PEDIATRIC PULMONOLOGY": 2.879,
  "RAPID PROTOTYPING JOURNAL": 2.879,
  "BULLETIN OF THE AMERICAN MUSEUM OF NATURAL HISTORY": 2.878,
  "CLINICAL NEURORADIOLOGY": 2.878,
  "ENVIRONMENTAL TECHNOLOGY & INNOVATION": 2.876,
  "MARINE RESOURCE ECONOMICS": 2.876,
  "REVIEW OF INTERNATIONAL POLITICAL ECONOMY": 2.876,
  "DRUG TESTING AND ANALYSIS": 2.875,
  "PLASMA PHYSICS AND CONTROLLED FUSION": 2.875,
  "CLINICS IN PERINATOLOGY": 2.875,
  "IMMUNOBIOLOGY": 2.874,
  "MALARIA JOURNAL": 2.873,
  "MARINE BIOTECHNOLOGY": 2.873,
  "NEURODEGENERATIVE DISEASES": 2.872,
  "PEDIATRIC CRITICAL CARE MEDICINE": 2.872,
  "IEEE TRANSACTIONS ON AEROSPACE AND ELECTRONIC SYSTEMS": 2.87,
  "JOURNAL OF CLINICAL NEUROLOGY": 2.87,
  "INTERNATIONAL JOURNAL OF REFRACTORY METALS & HARD MATERIALS": 2.87,
  "LAB ANIMAL": 2.87,
  "PRACTICAL RADIATION ONCOLOGY": 2.87,
  "GEOPHYSICS": 2.869,
  "MEDICAL DECISION MAKING": 2.868,
  "BEST PRACTICE & RESEARCH CLINICAL OBSTETRICS & GYNAECOLOGY": 2.868,
  "DIGITAL SIGNAL PROCESSING": 2.868,
  "INTERNATIONAL JOURNAL OF FOOD SCIENCES AND NUTRITION": 2.867,
  "REGULATION & GOVERNANCE": 2.866,
  "MEASUREMENT": 2.866,
  "VETERINARY MICROBIOLOGY": 2.865,
  "TUBERCULOSIS": 2.865,
  "DRUG AND ALCOHOL REVIEW": 2.865,
  "SOCIAL PROBLEMS": 2.865,
  "AQUATIC MICROBIAL ECOLOGY": 2.864,
  "BUSINESS ETHICS QUARTERLY": 2.864,
  "IMMUNOLOGY AND ALLERGY CLINICS OF NORTH AMERICA": 2.864,
  "PSYCHOTHERAPY RESEARCH": 2.863,
  "CURRENT ANTHROPOLOGY": 2.862,
  "INTERNATIONAL JOURNAL OF SOLIDS AND STRUCTURES": 2.862,
  "JOURNAL OF PROSTHETIC DENTISTRY": 2.862,
  "BRAIN SCIENCES": 2.862,
  "CHEMOMETRICS AND INTELLIGENT LABORATORY SYSTEMS": 2.862,
  "JOURNAL OF AUTISM AND DEVELOPMENTAL DISORDERS": 2.861,
  "REVIEW OF GENERAL PSYCHOLOGY": 2.861,
  "HLA": 2.859,
  "JOURNAL OF NEUROSCIENCE METHODS": 2.857,
  "EUROPEAN JOURNAL OF CLINICAL INVESTIGATION": 2.857,
  "EUROPEAN JOURNAL OF NEUROSCIENCE": 2.857,
  "SOFT COMPUTING": 2.856,
  "JOURNAL OF CRITICAL CARE": 2.855,
  "NEUROCHEMICAL RESEARCH": 2.855,
  "MATERIALS CHEMISTRY AND PHYSICS": 2.855,
  "DESIGN STUDIES": 2.855,
  "LAW AND HUMAN BEHAVIOR": 2.854,
  "RADIATION RESEARCH": 2.854,
  "HUMAN GENE THERAPY CLINICAL DEVELOPMENT": 2.853,
  "ALCOHOL AND ALCOHOLISM": 2.852,
  "GEOPHYSICAL JOURNAL INTERNATIONAL": 2.852,
  "EXPERT REVIEW OF CLINICAL PHARMACOLOGY": 2.851,
  "PLOS ONE": 2.851,
  "EUROPEAN JOURNAL OF CLINICAL PHARMACOLOGY": 2.85,
  "INTEGRATIVE BIOLOGY": 2.85,
  "JOURNAL OF VESTIBULAR RESEARCH-EQUILIBRIUM & ORIENTATION": 2.849,
  "PSYCHOLOGY OF VIOLENCE": 2.848,
  "JOURNAL OF ENVIRONMENTAL HEALTH SCIENCE AND ENGINEERING": 2.848,
  "PHARMACOLOGY BIOCHEMISTRY AND BEHAVIOR": 2.848,
  "PLACENTA": 2.848,
  "APPLIED PHYSICS EXPRESS": 2.848,
  "JOURNAL OF APPLIED MECHANICS-TRANSACTIONS OF THE ASME": 2.848,
  "BEHAVIOURAL BRAIN RESEARCH": 2.847,
  "SCIENTOMETRICS": 2.847,
  "PERVASIVE AND MOBILE COMPUTING": 2.847,
  "HEALTH REPORTS": 2.847,
  "INTERNATIONAL JOURNAL OF URBAN AND REGIONAL RESEARCH": 2.846,
  "JOURNAL OF PERIODONTOLOGY": 2.846,
  "PLASMA CHEMISTRY AND PLASMA PROCESSING": 2.846,
  "TRENDS IN HEARING": 2.846,
  "WORLD JOURNAL OF SURGERY": 2.845,
  "AMERICAN JOURNAL OF DRUG AND ALCOHOL ABUSE": 2.845,
  "COLD REGIONS SCIENCE AND TECHNOLOGY": 2.844,
  "CURRENT PAIN AND HEADACHE REPORTS": 2.843,
  "COMPUTER COMMUNICATIONS": 2.843,
  "JOURNAL OF POLYMERS AND THE ENVIRONMENT": 2.843,
  "SEIZURE-EUROPEAN JOURNAL OF EPILEPSY": 2.842,
  "TECTONOPHYSICS": 2.841,
  "EUROPEAN SOCIOLOGICAL REVIEW": 2.841,
  "CLINICAL BREAST CANCER": 2.84,
  "JOURNAL OF ASIAN EARTH SCIENCES": 2.84,
  "ADVANCES IN HEALTH SCIENCES EDUCATION": 2.839,
  "CNS & NEUROLOGICAL DISORDERS-DRUG TARGETS": 2.836,
  "DISEASE MARKERS": 2.835,
  "PHARMACOLOGICAL REPORTS": 2.835,
  "REQUIREMENTS ENGINEERING": 2.835,
  "WORLD JOURNAL OF UROLOGY": 2.833,
  "ASTRONOMY AND COMPUTING": 2.832,
  "ENVIRONMENTAL CONSERVATION": 2.831,
  "JOURNAL OF ENERGY RESOURCES TECHNOLOGY-TRANSACTIONS OF THE ASME": 2.831,
  "JOURNAL OF SAUDI CHEMICAL SOCIETY": 2.831,
  "NANOTECHNOLOGY REVIEWS": 2.83,
  "JOURNAL OF ECONOMIC SURVEYS": 2.829,
  "JOURNAL OF MAMMARY GLAND BIOLOGY AND NEOPLASIA": 2.829,
  "PAIN MEDICINE": 2.829,
  "WORLD JOURNAL OF GASTROINTESTINAL ONCOLOGY": 2.829,
  "IEEE TRANSACTIONS ON HAPTICS": 2.829,
  "EUROPEAN JOURNAL OF INTERNATIONAL RELATIONS": 2.828,
  "GEOPOLITICS": 2.828,
  "JOURNAL OF CARDIOVASCULAR TRANSLATIONAL RESEARCH": 2.828,
  "CURRENT INFECTIOUS DISEASE REPORTS": 2.828,
  "IEEE TRANSACTIONS ON COGNITIVE AND DEVELOPMENTAL SYSTEMS": 2.827,
  "PARASITE IMMUNOLOGY": 2.826,
  "ELECTROPHORESIS": 2.825,
  "GREEN CHEMISTRY LETTERS AND REVIEWS": 2.825,
  "JOURNAL OF EARTHQUAKE ENGINEERING": 2.825,
  "PUBLIC UNDERSTANDING OF SCIENCE": 2.825,
  "SUPPORTIVE CARE IN CANCER": 2.824,
  "IEEE JOURNAL OF QUANTUM ELECTRONICS": 2.824,
  "JOURNAL OF OPTICS": 2.823,
  "JOURNAL OF PHYSICS AND CHEMISTRY OF SOLIDS": 2.821,
  "GLOBAL ECOLOGY AND CONSERVATION": 2.821,
  "BRITISH JOURNAL OF MANAGEMENT": 2.821,
  "INTERNATIONAL JOURNAL OF ORAL SCIENCE": 2.821,
  "JOURNAL OF RENAL NUTRITION": 2.82,
  "METACOGNITION AND LEARNING": 2.82,
  "PUBLICATIONS OF THE ASTRONOMICAL SOCIETY OF JAPAN": 2.82,
  "IMAGE AND VISION COMPUTING": 2.819,
  "JOURNAL OF GERIATRIC PSYCHIATRY AND NEUROLOGY": 2.818,
  "TOURISM GEOGRAPHIES": 2.818,
  "UPSALA JOURNAL OF MEDICAL SCIENCES": 2.818,
  "ECOSPHERE": 2.818,
  "FUTURE MICROBIOLOGY": 2.818,
  "INTERNATIONAL JOURNAL FOR NUMERICAL METHODS IN ENGINEERING": 2.817,
  "JCMS-JOURNAL OF COMMON MARKET STUDIES": 2.816,
  "MOLECULAR PAIN": 2.814,
  "PLANTA MEDICA": 2.813,
  "FUNCTIONAL & INTEGRATIVE GENOMICS": 2.813,
  "HARM REDUCTION JOURNAL": 2.813,
  "CRITICAL CARE CLINICS": 2.811,
  "PSYCHOMETRIKA": 2.811,
  "CRITICAL PUBLIC HEALTH": 2.811,
  "JOURNAL OF ORAL MICROBIOLOGY": 2.81,
  "ACTA OBSTETRICIA ET GYNECOLOGICA SCANDINAVICA": 2.81,
  "CURRENT OPINION IN GASTROENTEROLOGY": 2.809,
  "SEMINARS IN RADIATION ONCOLOGY": 2.809,
  "FISHERIES": 2.809,
  "HUMAN PATHOLOGY": 2.809,
  "SENSORS AND ACTUATORS A-PHYSICAL": 2.808,
  "CLINICAL REHABILITATION": 2.807,
  "JOURNAL OF THE ASSOCIATION FOR INFORMATION SCIENCE AND TECHNOLOGY": 2.807,
  "MICROBIOLOGYOPEN": 2.804,
  "PHARMACOPSYCHIATRY": 2.804,
  "ASIA PACIFIC JOURNAL OF MANAGEMENT": 2.804,
  "EARTH PLANETS AND SPACE": 2.804,
  "MEDIA PSYCHOLOGY": 2.804,
  "VIRUS RESEARCH": 2.802,
  "AEROSOL AND AIR QUALITY RESEARCH": 2.802,
  "CLINICA CHIMICA ACTA": 2.801,
  "INTERNATIONAL DAIRY JOURNAL": 2.801,
  "ANAESTHESIA CRITICAL CARE & PAIN MEDICINE": 2.801,
  "JOURNAL OF CONSTRUCTION ENGINEERING AND MANAGEMENT": 2.8,
  "INTERNATIONAL JOURNAL OF MEDICAL INFORMATICS": 2.8,
  "JOURNAL OF ANTHROPOLOGICAL SCIENCES": 2.8,
  "SCIENCE CHINA-INFORMATION SCIENCES": 2.8,
  "ENVIRONMENT AND PLANNING D-SOCIETY & SPACE": 2.8,
  "EATING AND WEIGHT DISORDERS-STUDIES ON ANOREXIA BULIMIA AND OBESITY": 2.8,
  "GLOBAL STRATEGY JOURNAL": 2.799,
  "OCEAN ENGINEERING": 2.799,
  "IEEE PHOTONICS JOURNAL": 2.798,
  "TERRITORY POLITICS GOVERNANCE": 2.798,
  "MULTIPLE SCLEROSIS AND RELATED DISORDERS": 2.798,
  "JOURNAL OF CLINICAL GASTROENTEROLOGY": 2.798,
  "JOURNAL OF PSYCHOSOMATIC RESEARCH": 2.798,
  "MATERIALS SCIENCE IN SEMICONDUCTOR PROCESSING": 2.798,
  "COMPUTERS & GEOSCIENCES": 2.797,
  "EUROPEAN REVIEW FOR MEDICAL AND PHARMACOLOGICAL SCIENCES": 2.796,
  "PHARMACOGENOMICS & PERSONALIZED MEDICINE": 2.794,
  "CURRENT CANCER DRUG TARGETS": 2.794,
  "CYTOSKELETON": 2.794,
  "THEORETICAL AND APPLIED CLIMATOLOGY": 2.793,
  "ALPINE BOTANY": 2.793,
  "JOURNAL OF THE AMERICAN PLANNING ASSOCIATION": 2.792,
  "RESEARCH IN SOCIAL & ADMINISTRATIVE PHARMACY": 2.792,
  "TESOL QUARTERLY": 2.792,
  "HEALTH POLICY AND PLANNING": 2.792,
  "STRAHLENTHERAPIE UND ONKOLOGIE": 2.791,
  "JARO-JOURNAL OF THE ASSOCIATION FOR RESEARCH IN OTOLARYNGOLOGY": 2.791,
  "JOURNAL OF BUSINESS & ECONOMIC STATISTICS": 2.79,
  "MEDICAL CLINICS OF NORTH AMERICA": 2.789,
  "KOREAN JOURNAL OF INTERNAL MEDICINE": 2.789,
  "MARINE CHEMISTRY": 2.788,
  "JOURNAL OF PHYSICS-CONDENSED MATTER": 2.788,
  "INSECT SCIENCE": 2.788,
  "PSYCHOLOGY OF SPORT AND EXERCISE": 2.788,
  "AMERICAN ANTHROPOLOGIST": 2.787,
  "MOLECULAR SYSTEMS DESIGN & ENGINEERING": 2.787,
  "NEUROLOGY INDIA": 2.787,
  "ASN NEURO": 2.786,
  "ENERGIES": 2.786,
  "AUGMENTATIVE AND ALTERNATIVE COMMUNICATION": 2.786,
  "HEALTH SERVICES RESEARCH": 2.786,
  "MEDICAL TEACHER": 2.785,
  "SCANDINAVIAN JOURNAL OF RHEUMATOLOGY": 2.785,
  "BIOCHEMICAL AND BIOPHYSICAL RESEARCH COMMUNICATIONS": 2.784,
  "FORTSCHRITTE DER PHYSIK-PROGRESS OF PHYSICS": 2.784,
  "ANAEROBE": 2.784,
  "IEEE TRANSACTIONS ON ELECTRON DEVICES": 2.783,
  "ORGANIZATION": 2.782,
  "PROGRESS IN BIOPHYSICS & MOLECULAR BIOLOGY": 2.781,
  "CLINICAL JOURNAL OF SPORT MEDICINE": 2.78,
  "BILINGUALISM-LANGUAGE AND COGNITION": 2.78,
  "JOURNAL OF GEOTECHNICAL AND GEOENVIRONMENTAL ENGINEERING": 2.779,
  "BRAIN AND LANGUAGE": 2.778,
  "FUNGAL BIOLOGY": 2.777,
  "JOURNAL OF ADDICTION MEDICINE": 2.777,
  "ANNUAL REVIEW OF ANTHROPOLOGY": 2.777,
  "DARU-JOURNAL OF PHARMACEUTICAL SCIENCES": 2.776,
  "ARCHIVES OF PHYSICAL MEDICINE AND REHABILITATION": 2.776,
  "COMPARATIVE BIOCHEMISTRY AND PHYSIOLOGY C-TOXICOLOGY & PHARMACOLOGY": 2.774,
  "CONFLICT AND HEALTH": 2.774,
  "JOURNAL OF VASCULAR SURGERY-VENOUS AND LYMPHATIC DISORDERS": 2.774,
  "READING RESEARCH QUARTERLY": 2.774,
  "BEHAVIORAL ECOLOGY": 2.773,
  "PHARMACOGENETICS AND GENOMICS": 2.773,
  "ELECTROANALYSIS": 2.773,
  "JOURNALISM": 2.772,
  "FRONTIERS IN MATERIALS": 2.772,
  "JOURNAL OF MAGNETIC RESONANCE": 2.77,
  "MANAGEMENT INTERNATIONAL REVIEW": 2.77,
  "NEUROEPIDEMIOLOGY": 2.77,
  "ENVIRONMENTAL SCIENCE-PROCESSES & IMPACTS": 2.769,
  "INTERNATIONAL JOURNAL OF MINERAL PROCESSING": 2.768,
  "IMMUNOLOGICAL INVESTIGATIONS": 2.768,
  "OPTICAL MATERIALS": 2.768,
  "ESTUARIES AND COASTS": 2.768,
  "FRONTIERS IN ECOLOGY AND EVOLUTION": 2.768,
  "JOURNAL OF GASTROINTESTINAL SURGERY": 2.768,
  "PRECISION ENGINEERING-JOURNAL OF THE INTERNATIONAL SOCIETIES FOR PRECISION ENGINEERING AND NANOTECHNOLOGY": 2.768,
  "CRIMINOLOGY & PUBLIC POLICY": 2.767,
  "JOURNAL OF DIABETES AND ITS COMPLICATIONS": 2.767,
  "JOURNAL OF EDUCATION POLICY": 2.767,
  "EYE AND VISION": 2.767,
  "JOURNAL OF APPLIED MICROBIOLOGY": 2.766,
  "JOURNAL OF MAGNETISM AND MAGNETIC MATERIALS": 2.765,
  "WORK AND STRESS": 2.765,
  "R JOURNAL": 2.764,
  "ADMINISTRATION AND POLICY IN MENTAL HEALTH AND MENTAL HEALTH SERVICES RESEARCH": 2.763,
  "CEREBROVASCULAR DISEASES": 2.762,
  "PAEDIATRIC AND PERINATAL EPIDEMIOLOGY": 2.762,
  "CSEE JOURNAL OF POWER AND ENERGY SYSTEMS": 2.761,
  "CANCER MICROENVIRONMENT": 2.761,
  "FRONTIERS IN NEUROINFORMATICS": 2.761,
  "DIGITAL JOURNALISM": 2.761,
  "FAMILY PROCESS": 2.761,
  "JOURNAL OF PHARMACOLOGICAL AND TOXICOLOGICAL METHODS": 2.761,
  "MICROCIRCULATION": 2.761,
  "AAPG BULLETIN": 2.76,
  "PROGRESS IN EARTH AND PLANETARY SCIENCE": 2.759,
  "ANIMAL BEHAVIOUR": 2.759,
  "FEBS LETTERS": 2.759,
  "PANCREAS": 2.759,
  "JOURNAL OF BIOMEDICAL MATERIALS RESEARCH PART B-APPLIED BIOMATERIALS": 2.758,
  "LEUKEMIA & LYMPHOMA": 2.758,
  "MEMETIC COMPUTING": 2.758,
  "ADVANCES IN CHRONIC KIDNEY DISEASE": 2.758,
  "MICROSCOPY AND MICROANALYSIS": 2.757,
  "OPTICAL MATERIALS EXPRESS": 2.756,
  "PATIENT-PATIENT CENTERED OUTCOMES RESEARCH": 2.756,
  "PEDIATRIC RHEUMATOLOGY": 2.756,
  "BRITISH JOURNAL OF CLINICAL PSYCHOLOGY": 2.755,
  "ETHNICITY & HEALTH": 2.755,
  "JOURNAL OF PEDIATRIC PSYCHOLOGY": 2.755,
  "JOURNAL OF EXPERIMENTAL PSYCHOLOGY-LEARNING MEMORY AND COGNITION": 2.754,
  "JOURNAL OF SOILS AND SEDIMENTS": 2.754,
  "MICROBES AND INFECTION": 2.754,
  "PULMONARY PHARMACOLOGY & THERAPEUTICS": 2.754,
  "ACM TRANSACTIONS ON INFORMATION AND SYSTEM SECURITY": 2.754,
  "CRYSTALLOGRAPHY REVIEWS": 2.753,
  "GEOSCIENCE DATA JOURNAL": 2.753,
  "JOURNAL OF ARCHAEOLOGICAL RESEARCH": 2.752,
  "JOURNAL OF HEAD TRAUMA REHABILITATION": 2.751,
  "JOURNAL OF PLANNING EDUCATION AND RESEARCH": 2.75,
  "JOURNAL OF BIOLOGICAL ENGINEERING": 2.75,
  "M&SOM-MANUFACTURING & SERVICE OPERATIONS MANAGEMENT": 2.75,
  "NEUROPSYCHOLOGICAL REHABILITATION": 2.75,
  "BMC PSYCHIATRY": 2.75,
  "ALLERGY ASTHMA AND CLINICAL IMMUNOLOGY": 2.747,
  "APPLIED HEALTH ECONOMICS AND HEALTH POLICY": 2.747,
  "ADVANCES IN POLYMER TECHNOLOGY": 2.747,
  "INVESTIGATIONAL NEW DRUGS": 2.747,
  "MARINE MICROPALEONTOLOGY": 2.746,
  "NEUROMODULATION": 2.746,
  "AMERICAN JOURNAL OF PHYSICAL ANTHROPOLOGY": 2.746,
  "JOURNAL OF INFLAMMATION-LONDON": 2.746,
  "COGNITIVE AFFECTIVE & BEHAVIORAL NEUROSCIENCE": 2.746,
  "ACM TRANSACTIONS ON AUTONOMOUS AND ADAPTIVE SYSTEMS": 2.746,
  "FISHERIES OCEANOGRAPHY": 2.745,
  "JOURNAL OF NUTRITION HEALTH & AGING": 2.745,
  "SOFTWARE AND SYSTEMS MODELING": 2.744,
  "AUK": 2.743,
  "JOURNAL OF CHEMICAL TECHNOLOGY AND BIOTECHNOLOGY": 2.743,
  "PEPTIDES": 2.742,
  "VIROLOGY": 2.742,
  "INTERNATIONAL JOURNAL OF WILDLAND FIRE": 2.741,
  "WORK AND OCCUPATIONS": 2.741,
  "JOURNAL OF REPRODUCTIVE IMMUNOLOGY": 2.741,
  "SEMICONDUCTOR SCIENCE AND TECHNOLOGY": 2.74,
  "OBESITY FACTS": 2.74,
  "CALPHAD-COMPUTER COUPLING OF PHASE DIAGRAMS AND THERMOCHEMISTRY": 2.739,
  "CHINA JOURNAL": 2.738,
  "WORLD JOURNAL OF MICROBIOLOGY & BIOTECHNOLOGY": 2.738,
  "JOURNAL OF THE NEUROLOGICAL SCIENCES": 2.738,
  "LIPIDS IN HEALTH AND DISEASE": 2.738,
  "MITIGATION AND ADAPTATION STRATEGIES FOR GLOBAL CHANGE": 2.738,
  "RESEARCH IN MICROBIOLOGY": 2.737,
  "CYBERPSYCHOLOGY BEHAVIOR AND SOCIAL NETWORKING": 2.736,
  "JOURNAL OF CONSTRUCTIONAL STEEL RESEARCH": 2.736,
  "JOURNAL OF CONTAMINANT HYDROLOGY": 2.736,
  "ENVIRONMENTAL TOXICOLOGY": 2.735,
  "HUMAN FACTORS": 2.735,
  "JOURNAL OF TOXICOLOGY AND ENVIRONMENTAL HEALTH-PART A-CURRENT ISSUES": 2.735,
  "QJM-AN INTERNATIONAL JOURNAL OF MEDICINE": 2.734,
  "SPORTS HEALTH-A MULTIDISCIPLINARY APPROACH": 2.734,
  "LEUKOS": 2.731,
  "POPULATION AND DEVELOPMENT REVIEW": 2.731,
  "COMPUTER VISION AND IMAGE UNDERSTANDING": 2.731,
  "COMPUTATIONAL MATERIALS SCIENCE": 2.73,
  "ULTRAMICROSCOPY": 2.73,
  "CHAOS": 2.73,
  "AUDITING-A JOURNAL OF PRACTICE & THEORY": 2.73,
  "CLINICAL AND EXPERIMENTAL MEDICINE": 2.729,
  "CURRENT DRUG TARGETS": 2.729,
  "JOURNAL OF MANUFACTURING TECHNOLOGY MANAGEMENT": 2.725,
  "GROUP PROCESSES & INTERGROUP RELATIONS": 2.724,
  "INTERNATIONAL JOURNAL OF COLORECTAL DISEASE": 2.722,
  "JOURNAL OF PHYSICAL CHEMISTRY A": 2.722,
  "JOURNAL OF POSITIVE BEHAVIOR INTERVENTIONS": 2.722,
  "ACTA ASTRONOMICA": 2.721,
  "HISTOCHEMISTRY AND CELL BIOLOGY": 2.721,
  "POLYMER JOURNAL": 2.721,
  "GENE": 2.72,
  "JOURNAL OF ANATOMY": 2.72,
  "TISSUE ENGINEERING PART C-METHODS": 2.72,
  "ACUPUNCTURE IN MEDICINE": 2.719,
  "AMERICAN JOURNAL OF HEALTH PROMOTION": 2.719,
  "HEALTH CARE MANAGEMENT REVIEW": 2.719,
  "JOURNAL OF PROSTHODONTIC RESEARCH": 2.718,
  "ANNALS OF LABORATORY MEDICINE": 2.717,
  "FRONTIERS IN NEUROLOGY": 2.717,
  "JOURNAL OF APPLIED PHYCOLOGY": 2.717,
  "PHYSIOLOGY & BEHAVIOR": 2.716,
  "TECHNIQUES IN COLOPROCTOLOGY": 2.716,
  "ECOLOGICAL MODELLING": 2.716,
  "INTEGRATIVE CANCER THERAPIES": 2.716,
  "ANNALS OF FOREST SCIENCE": 2.714,
  "ENERGY STRATEGY REVIEWS": 2.713,
  "PROTOPLASMA": 2.711,
  "JOURNAL OF WORLD PREHISTORY": 2.71,
  "PALAEONTOLOGY": 2.71,
  "PLANTS-BASEL": 2.71,
  "AMERICAN MINERALOGIST": 2.709,
  "GENES AND IMMUNITY": 2.708,
  "CARDIOVASCULAR TOXICOLOGY": 2.708,
  "DERMATITIS": 2.707,
  "EXPERIMENTAL NEUROBIOLOGY": 2.707,
  "G3-GENES GENOMES GENETICS": 2.706,
  "ACTA TROPICA": 2.706,
  "ACM TRANSACTIONS ON INFORMATION SYSTEMS": 2.706,
  "BIOLOGICAL PSYCHOLOGY": 2.706,
  "NUTRITION RESEARCH": 2.706,
  "PHYSICS OF FLUIDS": 2.706,
  "EUROPEAN JOURNAL OF PROTISTOLOGY": 2.705,
  "ORAL DISEASES": 2.705,
  "EXPERIMENTAL PHYSIOLOGY": 2.704,
  "SYSTEMS & CONTROL LETTERS": 2.704,
  "EXPERT REVIEW OF RESPIRATORY MEDICINE": 2.704,
  "FRONTIERS IN BEHAVIORAL NEUROSCIENCE": 2.703,
  "MACROMOLECULAR CHEMISTRY AND PHYSICS": 2.702,
  "MANUAL THERAPY": 2.701,
  "JOURNAL OF MICROELECTROMECHANICAL SYSTEMS": 2.701,
  "BMC NEUROSCIENCE": 2.7,
  "INTERNATIONAL JOURNAL OF BILINGUAL EDUCATION AND BILINGUALISM": 2.7,
  "BRAIN AND COGNITION": 2.699,
  "CANCER EPIDEMIOLOGY": 2.699,
  "CROSS CULTURAL & STRATEGIC MANAGEMENT": 2.698,
  "MYRMECOLOGICAL NEWS": 2.698,
  "POLICY SCIENCES": 2.697,
  "ADVANCES IN CONCRETE CONSTRUCTION": 2.697,
  "JOURNAL OF HEREDITY": 2.696,
  "JOURNAL OF VOLCANOLOGY AND GEOTHERMAL RESEARCH": 2.696,
  "REMEDIAL AND SPECIAL EDUCATION": 2.696,
  "JOURNAL OF MANUFACTURING SCIENCE AND ENGINEERING-TRANSACTIONS OF THE ASME": 2.696,
  "PALAEOGEOGRAPHY PALAEOCLIMATOLOGY PALAEOECOLOGY": 2.695,
  "PARTICUOLOGY": 2.693,
  "GEOCHEMICAL TRANSACTIONS": 2.691,
  "PARTY POLITICS": 2.691,
  "PHYSICS OF THE EARTH AND PLANETARY INTERIORS": 2.689,
  "PAEDIATRIC RESPIRATORY REVIEWS": 2.689,
  "TRANSPLANTATION REVIEWS": 2.689,
  "JOURNAL OF NEUROPHYSIOLOGY": 2.689,
  "JOURNAL OF NEUROLOGIC PHYSICAL THERAPY": 2.688,
  "PSYCHOSOCIAL INTERVENTION": 2.688,
  "INTERNATIONAL JOURNAL OF CLINICAL PRACTICE": 2.687,
  "JOURNAL OF PERIODONTAL RESEARCH": 2.687,
  "VEHICLE SYSTEM DYNAMICS": 2.686,
  "CURRENT STEM CELL RESEARCH & THERAPY": 2.686,
  "EUROPEAN PHYSICAL JOURNAL PLUS": 2.686,
  "NEUROMUSCULAR DISORDERS": 2.685,
  "ARCHIVES OF GERONTOLOGY AND GERIATRICS": 2.684,
  "ESTUARINE COASTAL AND SHELF SCIENCE": 2.684,
  "INFECTION GENETICS AND EVOLUTION": 2.684,
  "APPLIED ERGONOMICS": 2.683,
  "IMMUNOLOGIC RESEARCH": 2.683,
  "OMICS-A JOURNAL OF INTEGRATIVE BIOLOGY": 2.683,
  "CURRENT TOPICS IN MEMBRANES": 2.683,
  "INTELLIGENCE": 2.682,
  "ZOOLOGICA SCRIPTA": 2.681,
  "AAPS PHARMSCITECH": 2.681,
  "PSYCHOLOGY AND AGING": 2.681,
  "BIOLOGICAL CONTROL": 2.68,
  "JOURNAL OF COMPOSITES FOR CONSTRUCTION": 2.68,
  "JOURNAL OF DRUG DELIVERY SCIENCE AND TECHNOLOGY": 2.68,
  "JOURNAL OF MENTAL HEALTH": 2.679,
  "MICROVASCULAR RESEARCH": 2.679,
  "OPERATIONS RESEARCH": 2.679,
  "EUROPEAN JOURNAL OF INFORMATION SYSTEMS": 2.679,
  "PERSONALITY AND SOCIAL PSYCHOLOGY BULLETIN": 2.677,
  "AMERICAN REVIEW OF PUBLIC ADMINISTRATION": 2.676,
  "DEVELOPMENTAL NEUROBIOLOGY": 2.675,
  "EUROPEAN UNION POLITICS": 2.675,
  "JOURNAL OF NON-CRYSTALLINE SOLIDS": 2.675,
  "JOURNAL OF ONCOLOGY": 2.674,
  "PUBLIC ADMINISTRATION": 2.674,
  "STUDIES IN SECOND LANGUAGE ACQUISITION": 2.674,
  "ASTROPARTICLE PHYSICS": 2.673,
  "EUROPEAN JOURNAL OF WORK AND ORGANIZATIONAL PSYCHOLOGY": 2.673,
  "PLANT FOODS FOR HUMAN NUTRITION": 2.673,
  "ULTRASONICS": 2.673,
  "GEOHERITAGE": 2.673,
  "JOURNAL OF POLYMER SCIENCE PART B-POLYMER PHYSICS": 2.673,
  "BEILSTEIN JOURNAL OF ORGANIC CHEMISTRY": 2.672,
  "OCEAN & COASTAL MANAGEMENT": 2.671,
  "GEOMECHANICS AND ENGINEERING": 2.671,
  "CHEMBIOCHEM": 2.67,
  "HUMAN VACCINES & IMMUNOTHERAPEUTICS": 2.669,
  "JOURNAL OF TURBOMACHINERY-TRANSACTIONS OF THE ASME": 2.669,
  "SUSTAINABILITY": 2.669,
  "COMPLEXITY": 2.669,
  "EUROPEAN JOURNAL OF CLINICAL MICROBIOLOGY & INFECTIOUS DISEASES": 2.669,
  "JOURNAL OF POLYMER SCIENCE PART A-POLYMER CHEMISTRY": 2.667,
  "JOURNAL OF OCCUPATIONAL MEDICINE AND TOXICOLOGY": 2.667,
  "NEURAL PROCESSING LETTERS": 2.667,
  "ANIMAL FEED SCIENCE AND TECHNOLOGY": 2.667,
  "ORTHOPAEDIC JOURNAL OF SPORTS MEDICINE": 2.667,
  "PHOTODIAGNOSIS AND PHOTODYNAMIC THERAPY": 2.667,
  "REPRODUCTIVE BIOLOGY AND ENDOCRINOLOGY": 2.667,
  "BRITISH JOURNAL OF EDUCATIONAL TECHNOLOGY": 2.667,
  "JOURNAL OF FINANCIAL INTERMEDIATION": 2.667,
  "JOURNAL OF REAL-TIME IMAGE PROCESSING": 2.667,
  "NUTRITION IN CLINICAL PRACTICE": 2.667,
  "COMPREHENSIVE PSYCHIATRY": 2.666,
  "INTERNATIONAL JOURNAL OF SUSTAINABLE TRANSPORTATION": 2.664,
  "CLINICAL INTERVENTIONS IN AGING": 2.664,
  "SEMINARS IN REPRODUCTIVE MEDICINE": 2.664,
  "ACS OMEGA": 2.663,
  "JOURNAL OF STUDIES ON ALCOHOL AND DRUGS": 2.663,
  "BIOINORGANIC CHEMISTRY AND APPLICATIONS": 2.663,
  "CURRENT VASCULAR PHARMACOLOGY": 2.663,
  "JOURNAL OF TRANSPORT & HEALTH": 2.662,
  "GOVERNMENT AND OPPOSITION": 2.662,
  "JOURNAL OF BUSINESS AND PSYCHOLOGY": 2.662,
  "JOURNAL OF INTELLIGENT MATERIAL SYSTEMS AND STRUCTURES": 2.661,
  "JOURNAL OF MARRIAGE AND FAMILY": 2.66,
  "MICROBIAL PATHOGENESIS": 2.66,
  "PHYSIOLOGICAL GENOMICS": 2.66,
  "AMERICAN FAMILY PHYSICIAN": 2.66,
  "HOLZFORSCHUNG": 2.659,
  "JOURNAL OF ENVIRONMENTAL QUALITY": 2.659,
  "AMERICAN JOURNAL OF CARDIOVASCULAR DRUGS": 2.659,
  "EUROPEAN JOURNAL OF INORGANIC CHEMISTRY": 2.657,
  "JOURNAL OF LEARNING DISABILITIES": 2.656,
  "SOIL DYNAMICS AND EARTHQUAKE ENGINEERING": 2.655,
  "VIRGINIA LAW REVIEW": 2.654,
  "CHILD NEUROPSYCHOLOGY": 2.654,
  "JOURNAL OF MOLECULAR NEUROSCIENCE": 2.653,
  "MEDICAL CARE RESEARCH AND REVIEW": 2.652,
  "PLASMID": 2.652,
  "JOURNAL OF BIOMECHANICS": 2.652,
  "NEUROMOLECULAR MEDICINE": 2.651,
  "MICROBES AND ENVIRONMENTS": 2.651,
  "CURRENT OPINION IN ORGAN TRANSPLANTATION": 2.651,
  "COMPARATIVE BIOCHEMISTRY AND PHYSIOLOGY D-GENOMICS & PROTEOMICS": 2.651,
  "JOURNAL OF DIGITAL IMAGING": 2.65,
  "JOURNAL OF THE AMERICAN DENTAL ASSOCIATION": 2.65,
  "BIOTECHNOLOGY & GENETIC ENGINEERING REVIEWS": 2.65,
  "EXPERT REVIEW OF ANTICANCER THERAPY": 2.649,
  "JOURNAL OF ARCHAEOLOGICAL METHOD AND THEORY": 2.649,
  "LANGUAGE LEARNING & TECHNOLOGY": 2.649,
  "IEEE MICRO": 2.649,
  "JOURNAL OF CARDIOVASCULAR PHARMACOLOGY AND THERAPEUTICS": 2.649,
  "JOURNAL OF RESEARCH IN PERSONALITY": 2.649,
  "BMC MOLECULAR BIOLOGY": 2.647,
  "BMC MEDICAL GENOMICS": 2.647,
  "INTERNATIONAL JOURNAL OF DISASTER RISK REDUCTION": 2.645,
  "JOURNAL OF INTELLIGENT TRANSPORTATION SYSTEMS": 2.644,
  "BMC PUBLIC HEALTH": 2.644,
  "CANADIAN JOURNAL OF FISHERIES AND AQUATIC SCIENCES": 2.643,
  "IEEE JOURNAL OF OCEANIC ENGINEERING": 2.642,
  "BMC INFECTIOUS DISEASES": 2.642,
  "PERSPECTIVES IN ECOLOGY AND CONSERVATION": 2.642,
  "ECOHYDROLOGY": 2.642,
  "RISK ANALYSIS": 2.642,
  "SCANDINAVIAN JOURNAL OF IMMUNOLOGY": 2.641,
  "CHRONOBIOLOGY INTERNATIONAL": 2.641,
  "INGEGNERIA SISMICA": 2.641,
  "OPHTHALMIC AND PHYSIOLOGICAL OPTICS": 2.641,
  "JOURNAL OF SYSTEMS AND SOFTWARE": 2.64,
  "REPRODUCTIVE SCIENCES": 2.64,
  "JOURNAL OF BREAST CANCER": 2.639,
  "PREHOSPITAL EMERGENCY CARE": 2.638,
  "SCANDINAVIAN JOURNAL OF TRAUMA RESUSCITATION & EMERGENCY MEDICINE": 2.638,
  "FATIGUE & FRACTURE OF ENGINEERING MATERIALS & STRUCTURES": 2.638,
  "JOURNAL OF BIOMEDICAL OPTICS": 2.637,
  "JOURNAL OF GAMBLING STUDIES": 2.636,
  "GLOBALIZATION AND HEALTH": 2.636,
  "JOURNAL OF COMPUTING IN CIVIL ENGINEERING": 2.636,
  "NEONATOLOGY": 2.635,
  "CANADIAN JOURNAL OF REMOTE SENSING": 2.635,
  "FOOD & NUTRITION RESEARCH": 2.635,
  "IEEE PHOTONICS TECHNOLOGY LETTERS": 2.635,
  "INFANCY": 2.635,
  "NEUROSURGERY CLINICS OF NORTH AMERICA": 2.635,
  "IMMUNOLOGY LETTERS": 2.634,
  "CATHETERIZATION AND CARDIOVASCULAR INTERVENTIONS": 2.634,
  "INTERNATIONAL REVIEW OF NEUROBIOLOGY": 2.633,
  "ANNALS OF EPIDEMIOLOGY": 2.633,
  "RESEARCH IN SPORTS MEDICINE": 2.633,
  "AGGRESSIVE BEHAVIOR": 2.632,
  "JOURNAL OF BIOENERGETICS AND BIOMEMBRANES": 2.632,
  "JOURNAL OF HYDRO-ENVIRONMENT RESEARCH": 2.632,
  "MATERIALS AND STRUCTURES": 2.631,
  "POLITICAL ANALYSIS": 2.631,
  "BMC GENETICS": 2.63,
  "HOLOCENE": 2.63,
  "HUMAN RESOURCES FOR HEALTH": 2.63,
  "JOURNAL OF NUCLEAR MATERIALS": 2.63,
  "JOURNAL OF STUDIES IN INTERNATIONAL EDUCATION": 2.629,
  "SYNAPSE": 2.627,
  "CHINESE JOURNAL OF PHYSICS": 2.627,
  "HUMAN GENOMICS": 2.627,
  "JOURNAL OF PHYSIOLOGY AND PHARMACOLOGY": 2.627,
  "ADVANCES IN ASTRONOMY": 2.627,
  "JOURNAL OF SUBSTANCE ABUSE TREATMENT": 2.626,
  "CURRENT OPINION IN PULMONARY MEDICINE": 2.625,
  "JOURNAL OF EVOLUTIONARY BIOLOGY": 2.624,
  "WILEY INTERDISCIPLINARY REVIEWS-DATA MINING AND KNOWLEDGE DISCOVERY": 2.624,
  "BIOCHIMICA ET BIOPHYSICA ACTA-PROTEINS AND PROTEOMICS": 2.622,
  "CURRENT OPINION IN CRITICAL CARE": 2.622,
  "FOUNDATIONS OF COMPUTATIONAL MATHEMATICS": 2.622,
  "JOURNAL OF NURSING SCHOLARSHIP": 2.622,
  "NURSING OUTLOOK": 2.621,
  "PETROLEUM EXPLORATION AND DEVELOPMENT": 2.62,
  "INFORMATION SYSTEMS FRONTIERS": 2.62,
  "JOURNAL OF MARINE SYSTEMS": 2.619,
  "OCEAN SCIENCE": 2.619,
  "ACM TRANSACTIONS ON KNOWLEDGE DISCOVERY FROM DATA": 2.619,
  "ACADEMIC PEDIATRICS": 2.619,
  "ACCOUNTING AUDITING & ACCOUNTABILITY JOURNAL": 2.619,
  "INTERNATIONAL ENTREPRENEURSHIP AND MANAGEMENT JOURNAL": 2.619,
  "BOTANICAL REVIEW": 2.618,
  "CHEMISTRY AND PHYSICS OF LIPIDS": 2.618,
  "BIOSCIENCE REPORTS": 2.617,
  "INFORMATION RETRIEVAL JOURNAL": 2.617,
  "BIODEGRADATION": 2.616,
  "PHYSIOTHERAPY": 2.616,
  "CLIMACTERIC": 2.616,
  "INTERNATIONAL REVIEW OF HYDROBIOLOGY": 2.615,
  "JOURNAL OF ENGINEERING TECHNOLOGY": 2.615,
  "AMERICAN JOURNAL OF AGRICULTURAL ECONOMICS": 2.615,
  "NEUROSURGICAL REVIEW": 2.615,
  "PHYSICA MEDICA-EUROPEAN JOURNAL OF MEDICAL PHYSICS": 2.615,
  "BIOMICROFLUIDICS": 2.614,
  "JOURNAL OF SOLID STATE ELECTROCHEMISTRY": 2.614,
  "POLITICAL BEHAVIOR": 2.614,
  "RHEOLOGICA ACTA": 2.613,
  "AMERICAN JOURNAL OF HYPERTENSION": 2.613,
  "MEDICINAL CHEMISTRY": 2.613,
  "MATHEMATICAL FINANCE": 2.612,
  "PSYCHOLOGICAL TRAUMA-THEORY RESEARCH PRACTICE AND POLICY": 2.612,
  "CORROSION REVIEWS": 2.612,
  "CRITICAL PERSPECTIVES ON ACCOUNTING": 2.611,
  "DIAGNOSTIC PATHOLOGY": 2.611,
  "ENVIRONMENTAL AND MOLECULAR MUTAGENESIS": 2.611,
  "JOURNAL OF STRUCTURAL ENGINEERING": 2.61,
  "TEXAS LAW REVIEW": 2.61,
  "EUROPEAN BIOPHYSICS JOURNAL WITH BIOPHYSICS LETTERS": 2.61,
  "EUROPEAN JOURNAL OF PHYCOLOGY": 2.61,
  "PUBLIC HEALTH NUTRITION": 2.609,
  "NJAS-WAGENINGEN JOURNAL OF LIFE SCIENCES": 2.609,
  "PERSPECTIVES IN PLANT ECOLOGY EVOLUTION AND SYSTEMATICS": 2.609,
  "THORACIC CANCER": 2.608,
  "WATER": 2.608,
  "JOURNAL OF PHYSIOLOGY AND BIOCHEMISTRY": 2.607,
  "YOUTH & SOCIETY": 2.606,
  "INTERNATIONAL FORUM OF ALLERGY & RHINOLOGY": 2.606,
  "AMINO ACIDS": 2.604,
  "CRITICAL CARE AND RESUSCITATION": 2.604,
  "FLEXIBLE SERVICES AND MANUFACTURING JOURNAL": 2.604,
  "JOURNAL OF PEACE RESEARCH": 2.604,
  "EUROPEAN REVIEW OF AGING AND PHYSICAL ACTIVITY": 2.603,
  "JOURNAL OF SEPARATION SCIENCE": 2.603,
  "AUSTRALIAN CRITICAL CARE": 2.603,
  "CHINESE JOURNAL OF CANCER RESEARCH": 2.602,
  "ROYAL SOCIETY OPEN SCIENCE": 2.6,
  "VACUUM": 2.6,
  "FLUID PHASE EQUILIBRIA": 2.6,
  "SIAM JOURNAL ON IMAGING SCIENCES": 2.6,
  "CLINICAL & EXPERIMENTAL METASTASIS": 2.6,
  "EUROPEAN SPINE JOURNAL": 2.6,
  "EUROPEAN JOURNAL OF ORAL IMPLANTOLOGY": 2.598,
  "BMC BIOINFORMATICS": 2.598,
  "CURRENT ISSUES IN MOLECULAR BIOLOGY": 2.598,
  "JOURNAL OF HAPPINESS STUDIES": 2.598,
  "JOURNAL OF THE AMERICAN BOARD OF FAMILY MEDICINE": 2.597,
  "MOLECULAR AND CELLULAR PROBES": 2.596,
  "JOURNAL OF CARDIOVASCULAR NURSING": 2.595,
  "BMC MEDICAL RESEARCH METHODOLOGY": 2.595,
  "JOURNAL OF NEURO-OPHTHALMOLOGY": 2.594,
  "JOURNAL OF HIGHER EDUCATION": 2.593,
  "SCANDINAVIAN JOURNAL OF HOSPITALITY AND TOURISM": 2.592,
  "ACM TRANSACTIONS ON SENSOR NETWORKS": 2.592,
  "ANALYTICAL BIOCHEMISTRY": 2.592,
  "BMC MEDICAL ETHICS": 2.592,
  "HARVARD REVIEW OF PSYCHIATRY": 2.591,
  "JOURNAL OF LIPOSOME RESEARCH": 2.591,
  "JOURNAL OF AGRICULTURAL ECONOMICS": 2.591,
  "AQUATIC ECOLOGY": 2.591,
  "EXPERT REVIEW OF HEMATOLOGY": 2.591,
  "NEURORADIOLOGY": 2.59,
  "COPD-JOURNAL OF CHRONIC OBSTRUCTIVE PULMONARY DISEASE": 2.589,
  "INTERNATIONAL JOURNAL OF CLINICAL ONCOLOGY": 2.589,
  "ACTA BIOCHIMICA ET BIOPHYSICA SINICA": 2.589,
  "JOURNAL OF COMPUTATIONAL SCIENCE": 2.588,
  "INTERNATIONAL JOURNAL OF ADHESION AND ADHESIVES": 2.588,
  "PROTEINS-STRUCTURE FUNCTION AND BIOINFORMATICS": 2.588,
  "AGING MALE": 2.587,
  "BIOENERGY RESEARCH": 2.586,
  "CELL COMMUNICATION AND ADHESION": 2.586,
  "ENVIRONMENTAL DEVELOPMENT": 2.586,
  "GENETIC EPIDEMIOLOGY": 2.585,
  "PHYSICA A-STATISTICAL MECHANICS AND ITS APPLICATIONS": 2.585,
  "WORLDVIEWS ON EVIDENCE-BASED NURSING": 2.584,
  "DERMATOLOGY": 2.584,
  "EUROPEAN JOURNAL OF CARDIOVASCULAR NURSING": 2.584,
  "HEMATOLOGY-AMERICAN SOCIETY OF HEMATOLOGY EDUCATION PROGRAM": 2.583,
  "ASIAN JOURNAL OF ORGANIC CHEMISTRY": 2.583,
  "EUROPEAN JOURNAL OF PAEDIATRIC NEUROLOGY": 2.583,
  "INTERNATIONAL JOURNAL OF ADVANCED MANUFACTURING TECHNOLOGY": 2.582,
  "JOURNAL OF HOSPITALITY AND TOURISM MANAGEMENT": 2.582,
  "ASAIO JOURNAL": 2.582,
  "VITAMINS AND HORMONES": 2.582,
  "BURNS & TRAUMA": 2.581,
  "INTERNATIONAL JOURNAL OF REMOTE SENSING": 2.581,
  "PLANT PATHOLOGY": 2.58,
  "URBAN ECOSYSTEMS": 2.579,
  "CORNELL HOSPITALITY QUARTERLY": 2.579,
  "IMMUNOGENETICS": 2.578,
  "NUCLEAR MEDICINE AND BIOLOGY": 2.578,
  "PHARMACEUTICAL BIOLOGY": 2.578,
  "GEOLOGICAL MAGAZINE": 2.578,
  "MARKETING SCIENCE": 2.578,
  "ULTRASONIC IMAGING": 2.577,
  "DEMOGRAPHY": 2.577,
  "DIAGNOSTICS": 2.577,
  "INTERNATIONAL JOURNAL OF INTEGRATED CARE": 2.577,
  "SUPERCONDUCTOR SCIENCE & TECHNOLOGY": 2.577,
  "ANIMAL COGNITION": 2.576,
  "BIOSCIENCE OF MICROBIOTA FOOD AND HEALTH": 2.576,
  "CHEMOECOLOGY": 2.575,
  "NEOBIOTA": 2.574,
  "QUALITY OF LIFE RESEARCH": 2.573,
  "QUARTERLY JOURNAL OF EXPERIMENTAL PSYCHOLOGY": 2.572,
  "REVIEW OF RESEARCH IN EDUCATION": 2.572,
  "HUMAN RESOURCE DEVELOPMENT REVIEW": 2.571,
  "JOURNAL OF POLITICS": 2.571,
  "JOURNAL OF INFECTION AND PUBLIC HEALTH": 2.571,
  "DIAGNOSTIC AND INTERVENTIONAL IMAGING": 2.571,
  "LITHOSPHERE": 2.57,
  "PEDIATRIC BLOOD & CANCER": 2.57,
  "PAIN PRACTICE": 2.569,
  "CLINICAL AUTONOMIC RESEARCH": 2.568,
  "JOURNAL OF RESEARCH ON EDUCATIONAL EFFECTIVENESS": 2.568,
  "TOURISM MANAGEMENT PERSPECTIVES": 2.568,
  "CONTEMPORARY EDUCATIONAL PSYCHOLOGY": 2.568,
  "NEUROLOGICAL SCIENCES": 2.568,
  "FRONTIERS OF PHYSICS": 2.567,
  "ACTA ASTRONAUTICA": 2.567,
  "BIOLOGICAL RESEARCH": 2.567,
  "JOURNAL OF EXPERIMENTAL NANOSCIENCE": 2.565,
  "VEGETATION HISTORY AND ARCHAEOBOTANY": 2.565,
  "ANNUAL REVIEW OF APPLIED LINGUISTICS": 2.564,
  "BRITISH JOURNAL OF EDUCATIONAL PSYCHOLOGY": 2.564,
  "EUROPEAN PHYSICAL JOURNAL A": 2.564,
  "INTERNATIONAL JOURNAL FOR NUMERICAL AND ANALYTICAL METHODS IN GEOMECHANICS": 2.563,
  "BMC COMPLEMENTARY AND ALTERNATIVE MEDICINE": 2.562,
  "INTERNATIONAL PSYCHOGERIATRICS": 2.561,
  "CELLULAR AND MOLECULAR BIOENGINEERING": 2.561,
  "JOURNAL OF PALLIATIVE MEDICINE": 2.559,
  "MINERVA UROLOGICA E NEFROLOGICA": 2.559,
  "NEUROPSYCHOLOGY": 2.558,
  "FORENSIC TOXICOLOGY": 2.557,
  "KOREAN JOURNAL OF CHEMICAL ENGINEERING": 2.556,
  "UPDATES IN SURGERY": 2.555,
  "ASSESSMENT IN EDUCATION-PRINCIPLES POLICY & PRACTICE": 2.555,
  "HYDROLOGY RESEARCH": 2.555,
  "INTERNATIONAL BREASTFEEDING JOURNAL": 2.554,
  "MINERVA MEDICA": 2.554,
  "ORTHOPEDIC CLINICS OF NORTH AMERICA": 2.554,
  "ADVANCES IN POLYMER SCIENCE": 2.554,
  "BASIC AND APPLIED ECOLOGY": 2.553,
  "ENDOCRINE CONNECTIONS": 2.553,
  "ASSESSMENT & EVALUATION IN HIGHER EDUCATION": 2.553,
  "INTERNATIONAL JOURNAL FOR EQUITY IN HEALTH": 2.553,
  "JOURNAL OF BIOLOGICAL RHYTHMS": 2.553,
  "PLANT GROWTH REGULATION": 2.552,
  "BRITISH JOURNAL OF HEALTH PSYCHOLOGY": 2.551,
  "NEURAL REGENERATION RESEARCH": 2.551,
  "CLIMATE AND DEVELOPMENT": 2.55,
  "JOURNAL OF CONFLICT RESOLUTION": 2.549,
  "JOURNAL OF RURAL HEALTH": 2.548,
  "JOURNAL OF THERMAL ANALYSIS AND CALORIMETRY": 2.548,
  "CLINICAL PSYCHOPHARMACOLOGY AND NEUROSCIENCE": 2.548,
  "INFECTIOUS AGENTS AND CANCER": 2.548,
  "SCIENTIFIC STUDIES OF READING": 2.548,
  "ARCHIVES OF OSTEOPOROSIS": 2.548,
  "ENVIRONMENTAL COMMUNICATION-A JOURNAL OF NATURE AND CULTURE": 2.547,
  "INTERNATIONAL JOURNAL OF SYSTEMS SCIENCE": 2.547,
  "JOURNAL OF GLOBAL ANTIMICROBIAL RESISTANCE": 2.547,
  "JOURNAL OF OVARIAN RESEARCH": 2.547,
  "INTERNATIONAL JOURNAL OF ENVIRONMENTAL RESEARCH AND PUBLIC HEALTH": 2.547,
  "JOURNAL OF NEUROPSYCHOLOGY": 2.545,
  "JOURNAL OF MATERIALS SCIENCE-MATERIALS IN MEDICINE": 2.544,
  "JOURNAL OF NEURORADIOLOGY": 2.544,
  "VIROLOGICA SINICA": 2.544,
  "JOURNAL OF CONSUMER PSYCHOLOGY": 2.542,
  "EVOLUTIONARY ECOLOGY": 2.542,
  "TERRA NOVA": 2.541,
  "VIROLOGY JOURNAL": 2.541,
  "ACTA CHIMICA SINICA": 2.541,
  "BEHAVIOR ANALYST": 2.54,
  "JOURNAL OF BIONIC ENGINEERING": 2.54,
  "EXPERIMENTAL HEMATOLOGY": 2.54,
  "JOURNAL OF PHONETICS": 2.54,
  "JOURNAL OF THE AMERICAN WATER RESOURCES ASSOCIATION": 2.54,
  "MOBILITIES": 2.54,
  "SEMINARS IN PEDIATRIC SURGERY": 2.54,
  "ECOTOXICOLOGY": 2.54,
  "ENVIRONMENT AND PLANNING A-ECONOMY AND SPACE": 2.539,
  "ARCHIVES OF PHARMACAL RESEARCH": 2.539,
  "FEMS YEAST RESEARCH": 2.539,
  "BEHAVIORAL AND BRAIN FUNCTIONS": 2.538,
  "EARTH INTERACTIONS": 2.537,
  "INFORMATION SYSTEMS RESEARCH": 2.537,
  "JOURNAL OF PUBLIC POLICY & MARKETING": 2.537,
  "ENERGY JOURNAL": 2.536,
  "FINITE ELEMENTS IN ANALYSIS AND DESIGN": 2.536,
  "PARASITOLOGY": 2.535,
  "SOUTH EUROPEAN SOCIETY AND POLITICS": 2.535,
  "BIOMETALS": 2.534,
  "CLINICAL CARDIOLOGY": 2.534,
  "COMPARATIVE EDUCATION": 2.533,
  "JOURNAL OF MICROBIOLOGY IMMUNOLOGY AND INFECTION": 2.533,
  "CLINICAL ORAL INVESTIGATIONS": 2.533,
  "BASIC & CLINICAL PHARMACOLOGY & TOXICOLOGY": 2.532,
  "JOURNAL OF CEREAL SCIENCE": 2.532,
  "JOURNAL OF SYNCHROTRON RADIATION": 2.532,
  "DOSE-RESPONSE": 2.532,
  "JOURNAL OF COMPUTER ASSISTED LEARNING": 2.531,
  "CLINICAL GENITOURINARY CANCER": 2.531,
  "INTERNATIONAL JOURNAL OF GEOMECHANICS": 2.531,
  "BIOORGANIC & MEDICINAL CHEMISTRY LETTERS": 2.531,
  "MOLECULAR GENETICS & GENOMIC MEDICINE": 2.53,
  "PROBABILITY THEORY AND RELATED FIELDS": 2.53,
  "JOURNAL OF CHEMICAL ECOLOGY": 2.529,
  "JOURNAL OF URBAN ECONOMICS": 2.529,
  "JOURNAL OF ANTIBIOTICS": 2.529,
  "JOURNAL OF GENETIC COUNSELING": 2.528,
  "GENERAL AND COMPARATIVE ENDOCRINOLOGY": 2.528,
  "JOURNAL OF MONETARY ECONOMICS": 2.528,
  "JOURNAL OF CLINICAL HYPERTENSION": 2.528,
  "LANGUAGE COGNITION AND NEUROSCIENCE": 2.528,
  "ANNALS OF PHARMACOTHERAPY": 2.528,
  "EXPERIMENTS IN FLUIDS": 2.527,
  "HEAD AND NECK-JOURNAL FOR THE SCIENCES AND SPECIALTIES OF THE HEAD AND NECK": 2.526,
  "JOURNAL OF BIOMATERIALS APPLICATIONS": 2.526,
  "NURSE EDUCATION TODAY": 2.525,
  "PHYSICAL REVIEW FLUIDS": 2.524,
  "COMPUTER STANDARDS & INTERFACES": 2.524,
  "CLINICAL & TRANSLATIONAL ONCOLOGY": 2.524,
  "JOURNAL OF THE PERIPHERAL NERVOUS SYSTEM": 2.523,
  "IRRIGATION SCIENCE": 2.523,
  "REVISTA BRASILEIRA DE PSIQUIATRIA": 2.521,
  "JOURNAL OF PHARMACOLOGICAL SCIENCES": 2.52,
  "SURFACE TOPOGRAPHY-METROLOGY AND PROPERTIES": 2.52,
  "CALIFORNIA COOPERATIVE OCEANIC FISHERIES INVESTIGATIONS REPORTS": 2.519,
  "CANADIAN GEOTECHNICAL JOURNAL": 2.518,
  "INSECT MOLECULAR BIOLOGY": 2.517,
  "MICROFLUIDICS AND NANOFLUIDICS": 2.516,
  "APPLIED OCEAN RESEARCH": 2.515,
  "ANNUAL REVIEW OF LINGUISTICS": 2.515,
  "AEROSOL SCIENCE AND TECHNOLOGY": 2.515,
  "MYCOKEYS": 2.515,
  "JOURNAL OF SPORT & EXERCISE PSYCHOLOGY": 2.515,
  "PRENATAL DIAGNOSIS": 2.514,
  "BREAST JOURNAL": 2.514,
  "INORGANICA CHIMICA ACTA": 2.513,
  "INTERNATIONAL JOURNAL OF MENTAL HEALTH NURSING": 2.513,
  "PATHOLOGY & ONCOLOGY RESEARCH": 2.513,
  "POLYMER INTERNATIONAL": 2.511,
  "BIOLOGICAL TRACE ELEMENT RESEARCH": 2.511,
  "BMC FAMILY PRACTICE": 2.511,
  "FITOTERAPIA": 2.511,
  "JOURNAL OF LAW AND THE BIOSCIENCES": 2.511,
  "CLINICAL BIOCHEMISTRY": 2.51,
  "DEEP-SEA RESEARCH PART II-TOPICAL STUDIES IN OCEANOGRAPHY": 2.51,
  "STRUCTURE AND INFRASTRUCTURE ENGINEERING": 2.509,
  "ADVANCES IN CARBOHYDRATE CHEMISTRY AND BIOCHEMISTRY": 2.509,
  "EDUCATION FINANCE AND POLICY": 2.508,
  "JOURNAL OF WEB SEMANTICS": 2.508,
  "SOCIAL STUDIES OF SCIENCE": 2.507,
  "CHILDHOOD OBESITY": 2.507,
  "MICROMACHINES": 2.507,
  "SIMULATION MODELLING PRACTICE AND THEORY": 2.507,
  "UNIVERSITY OF CHICAGO LAW REVIEW": 2.507,
  "EUROPEAN JOURNAL OF HISTOCHEMISTRY": 2.507,
  "IT PROFESSIONAL": 2.507,
  "AGRICULTURAL ECONOMICS": 2.506,
  "HORMONE AND METABOLIC RESEARCH": 2.506,
  "PUNISHMENT & SOCIETY-INTERNATIONAL JOURNAL OF PENOLOGY": 2.505,
  "TROPICAL MEDICINE & INTERNATIONAL HEALTH": 2.505,
  "JOURNAL OF THE SCIENCE OF FOOD AND AGRICULTURE": 2.504,
  "EUROPEAN JOURNAL OF CANCER CARE": 2.503,
  "JOURNAL OF SERVICES MARKETING": 2.503,
  "JOURNAL OF THE MEDICAL LIBRARY ASSOCIATION": 2.502,
  "PROTEIN SCIENCE": 2.502,
  "EUROPEAN REVIEW OF AGRICULTURAL ECONOMICS": 2.501,
  "ENTROPY": 2.501,
  "FOOD ADDITIVES & CONTAMINANTS PART B-SURVEILLANCE": 2.5,
  "JOURNAL OF HEALTH AND SOCIAL BEHAVIOR": 2.5,
  "JOURNAL OF SOCIAL ISSUES": 2.5,
  "STUDIES IN APPLIED MATHEMATICS": 2.5,
  "CHEMICAL ENGINEERING & TECHNOLOGY": 2.5,
  "JOURNAL OF APPLIED RESEARCH IN MEMORY AND COGNITION": 2.5,
  "SYNLETT": 2.5,
  "NUMERICAL ALGORITHMS": 2.5,
  "UTILITIES POLICY": 2.497,
  "ECOLOGY AND EVOLUTION": 2.497,
  "JOURNAL OF MEDICAL SYSTEMS": 2.497,
  "ANNUAL REPORTS ON NMR SPECTROSCOPY": 2.497,
  "GAIT & POSTURE": 2.496,
  "JOURNAL OF MINIMALLY INVASIVE GYNECOLOGY": 2.496,
  "BMC PREGNANCY AND CHILDBIRTH": 2.496,
  "FOOD ANALYTICAL METHODS": 2.496,
  "CURRENT PHARMACEUTICAL DESIGN": 2.494,
  "JOURNAL OF AIR TRANSPORT MANAGEMENT": 2.494,
  "CURRENT OPINION IN OBSTETRICS & GYNECOLOGY": 2.493,
  "FOOD BIOPHYSICS": 2.493,
  "METABOLIC BRAIN DISEASE": 2.493,
  "TEACHING AND TEACHER EDUCATION": 2.493,
  "PHOTOCHEMICAL & PHOTOBIOLOGICAL SCIENCES": 2.492,
  "INTERNATIONAL JOURNAL OF PSYCHOPHYSIOLOGY": 2.492,
  "NEUROPEPTIDES": 2.492,
  "BIOTECHNOLOGY PROGRESS": 2.492,
  "BULLETIN OF EARTHQUAKE ENGINEERING": 2.49,
  "WORLD MYCOTOXIN JOURNAL": 2.49,
  "SOLAR PHYSICS": 2.49,
  "WIRELESS NETWORKS": 2.489,
  "SUSTAINABLE CHEMISTRY AND PHARMACY": 2.489,
  "AUTOIMMUNITY": 2.489,
  "IEEE TRANSACTIONS ON COMPUTER-AIDED DESIGN OF INTEGRATED CIRCUITS AND SYSTEMS": 2.489,
  "HYDROGEOLOGY JOURNAL": 2.489,
  "JOURNAL OF SAFETY RESEARCH": 2.488,
  "PSYCHOLOGY & HEALTH": 2.488,
  "MANAGEMENT AND ORGANIZATION REVIEW": 2.488,
  "TRANSLATIONAL VISION SCIENCE & TECHNOLOGY": 2.488,
  "FOOD AND AGRICULTURAL IMMUNOLOGY": 2.488,
  "CURRENT HEMATOLOGIC MALIGNANCY REPORTS": 2.488,
  "IMA JOURNAL OF NUMERICAL ANALYSIS": 2.488,
  "KNOWLEDGE AND INFORMATION SYSTEMS": 2.488,
  "MICROBIAL DRUG RESISTANCE": 2.488,
  "PEER-TO-PEER NETWORKING AND APPLICATIONS": 2.487,
  "CURRENT CARDIOLOGY REPORTS": 2.487,
  "JOURNAL OF ASIAN CERAMIC SOCIETIES": 2.487,
  "YEAST": 2.486,
  "MEDCHEMCOMM": 2.486,
  "MUSCLE & NERVE": 2.486,
  "PLANT BIOLOGY": 2.486,
  "REVIEW OF MANAGERIAL SCIENCE": 2.485,
  "JOURNAL OF ADOLESCENT AND YOUNG ADULT ONCOLOGY": 2.485,
  "JOURNAL OF MARKETING MANAGEMENT": 2.485,
  "OXFORD REVIEW OF ECONOMIC POLICY": 2.484,
  "INTERNATIONAL JOURNAL OF ENTREPRENEURIAL BEHAVIOR & RESEARCH": 2.484,
  "JOURNAL OF PHARMACY AND PHARMACOLOGY": 2.483,
  "MOBILE NETWORKS & APPLICATIONS": 2.482,
  "LINGUISTIC APPROACHES TO BILINGUALISM": 2.482,
  "STATISTICAL METHODS IN MEDICAL RESEARCH": 2.482,
  "EYE & CONTACT LENS-SCIENCE AND CLINICAL PRACTICE": 2.482,
  "JOURNAL OF NURSING MANAGEMENT": 2.481,
  "INTERNATIONAL WOUND JOURNAL": 2.481,
  "SUPERLATTICES AND MICROSTRUCTURES": 2.481,
  "TRANSPORTATION GEOTECHNICS": 2.481,
  "INTERNATIONAL ORTHOPAEDICS": 2.479,
  "REGENERATIVE MEDICINE": 2.478,
  "STATISTICS AND COMPUTING": 2.478,
  "ACM TRANSACTIONS ON INTERNET TECHNOLOGY": 2.477,
  "ENVIRONMENT AND PLANNING C-POLITICS AND SPACE": 2.477,
  "BMC ECOLOGY": 2.477,
  "MELANOMA RESEARCH": 2.477,
  "AQUACULTURE ENVIRONMENT INTERACTIONS": 2.477,
  "ARCHIVES OF MEDICAL SCIENCE": 2.476,
  "CBE-LIFE SCIENCES EDUCATION": 2.476,
  "REVISTA MEXICANA DE ASTRONOMIA Y ASTROFISICA": 2.476,
  "SOLID EARTH": 2.475,
  "ARTIFICIAL ORGANS": 2.475,
  "CRYPTOGAMIE MYCOLOGIE": 2.475,
  "JOURNAL OF BERRY RESEARCH": 2.475,
  "TETRAHEDRON": 2.475,
  "VETERINARY AND COMPARATIVE ONCOLOGY": 2.474,
  "ALZHEIMER DISEASE & ASSOCIATED DISORDERS": 2.474,
  "ANALYTICAL METHODS": 2.474,
  "EPILEPSY & BEHAVIOR": 2.473,
  "JOURNAL OF BUILDING ENGINEERING": 2.473,
  "CLINICAL OTOLARYNGOLOGY": 2.473,
  "INTERNATIONAL JOURNAL OF BIOMETEOROLOGY": 2.473,
  "JOURNAL OF MECHANISMS AND ROBOTICS-TRANSACTIONS OF THE ASME": 2.472,
  "ANGIOLOGY": 2.472,
  "BMJ OPEN": 2.471,
  "CHINESE JOURNAL OF CHEMISTRY": 2.471,
  "ENVIRONMENTAL MANAGEMENT": 2.471,
  "EUROPEAN JOURNAL OF SPORT SCIENCE": 2.471,
  "JOURNAL OF ADVANCED NURSING": 2.471,
  "EUROPEAN URBAN AND REGIONAL STUDIES": 2.47,
  "MOLECULAR INFORMATICS": 2.47,
  "IEEE MICROWAVE AND WIRELESS COMPONENTS LETTERS": 2.47,
  "COMPUTER GRAPHICS FORUM": 2.469,
  "INTERNATIONAL JOURNAL OF PUBLIC HEALTH": 2.469,
  "LEARNING & MEMORY": 2.469,
  "LEARNING MEDIA AND TECHNOLOGY": 2.469,
  "CATALYSIS LETTERS": 2.469,
  "BIOPROCESS AND BIOSYSTEMS ENGINEERING": 2.468,
  "FLOW TURBULENCE AND COMBUSTION": 2.468,
  "JOURNAL OF CARDIOVASCULAR PHARMACOLOGY": 2.468,
  "JOURNAL OF STATISTICAL MECHANICS-THEORY AND EXPERIMENT": 2.468,
  "COGNITION & EMOTION": 2.467,
  "JOURNAL OF HISTOCHEMISTRY & CYTOCHEMISTRY": 2.467,
  "JOURNAL OF SCIENTIFIC COMPUTING": 2.467,
  "RICE SCIENCE": 2.466,
  "BMC DEVELOPMENTAL BIOLOGY": 2.465,
  "BRYOLOGIST": 2.464,
  "MEMORIAS DO INSTITUTO OSWALDO CRUZ": 2.464,
  "DRUG DEVELOPMENT AND INDUSTRIAL PHARMACY": 2.463,
  "INTERNATIONAL JOURNAL OF DEVELOPMENTAL NEUROSCIENCE": 2.463,
  "RESOURCE AND ENERGY ECONOMICS": 2.463,
  "COMPTES RENDUS CHIMIE": 2.462,
  "EYE": 2.462,
  "JOURNAL OF ADHESION": 2.462,
  "JOURNAL OF APPLIED ELECTROCHEMISTRY": 2.462,
  "ACM TRANSACTIONS ON MATHEMATICAL SOFTWARE": 2.462,
  "BRITISH JOURNAL OF BIOMEDICAL SCIENCE": 2.46,
  "COMMUNICATION MONOGRAPHS": 2.459,
  "GEOCARTO INTERNATIONAL": 2.458,
  "JOURNAL OF EXPERIMENTAL MARINE BIOLOGY AND ECOLOGY": 2.458,
  "PHOTOSYNTHETICA": 2.457,
  "CHEMIE DER ERDE-GEOCHEMISTRY": 2.457,
  "JOURNAL OF APPLIED METEOROLOGY AND CLIMATOLOGY": 2.457,
  "JOURNAL OF BIOLOGICAL RESEARCH-THESSALONIKI": 2.457,
  "MULTIBODY SYSTEM DYNAMICS": 2.456,
  "VOX SANGUINIS": 2.456,
  "WORK EMPLOYMENT AND SOCIETY": 2.456,
  "BLOOD PURIFICATION": 2.456,
  "JOURNAL OF SERVICE THEORY AND PRACTICE": 2.456,
  "DIABETOLOGY & METABOLIC SYNDROME": 2.455,
  "JOURNAL OF EUKARYOTIC MICROBIOLOGY": 2.455,
  "ANNUAL REVIEW OF LAW AND SOCIAL SCIENCE": 2.455,
  "NEUROUROLOGY AND URODYNAMICS": 2.455,
  "TRANSPORTATION RESEARCH PART F-TRAFFIC PSYCHOLOGY AND BEHAVIOUR": 2.453,
  "MARINE ECOLOGY PROGRESS SERIES": 2.452,
  "SCIENCE AND TECHNOLOGY OF WELDING AND JOINING": 2.452,
  "WASTE AND BIOMASS VALORIZATION": 2.452,
  "AIDS REVIEWS": 2.451,
  "DIABETES & VASCULAR DISEASE RESEARCH": 2.451,
  "GEOGRAPHICAL JOURNAL": 2.45,
  "JOURNAL OF CHEMICAL NEUROANATOMY": 2.45,
  "SYSTEMATICS AND BIODIVERSITY": 2.448,
  "ARCHIVES OF CARDIOVASCULAR DISEASES": 2.448,
  "EUROPEAN JOURNAL OF FOREST RESEARCH": 2.448,
  "JOURNAL OF FAMILY PSYCHOLOGY": 2.447,
  "PALEOBIOLOGY": 2.447,
  "R & D MANAGEMENT": 2.446,
  "CURRENT RESEARCH IN TRANSLATIONAL MEDICINE": 2.446,
  "JOURNAL OF HEPATO-BILIARY-PANCREATIC SCIENCES": 2.446,
  "PHYSICAL REVIEW E": 2.445,
  "PEERJ": 2.444,
  "ATHEROSCLEROSIS SUPPLEMENTS": 2.444,
  "EXPERIMENTAL AND MOLECULAR PATHOLOGY": 2.444,
  "JOURNAL OF ADOLESCENCE": 2.444,
  "PURE AND APPLIED CHEMISTRY": 2.443,
  "FRONTIERS IN PEDIATRICS": 2.443,
  "JOURNAL OF CORPORATE FINANCE": 2.442,
  "JOURNAL OF FLUENCY DISORDERS": 2.442,
  "JOURNAL OF HUMAN LACTATION": 2.442,
  "ARCHIVES OF WOMENS MENTAL HEALTH": 2.442,
  "JOURNAL OF THE AMERICAN ACADEMY OF ORTHOPAEDIC SURGEONS": 2.442,
  "JOURNAL OF GEOGRAPHICAL SCIENCES": 2.441,
  "PHARMACEUTICAL DEVELOPMENT AND TECHNOLOGY": 2.441,
  "JOURNAL OF CLINICAL PATHOLOGY": 2.441,
  "ADVANCES IN ANATOMY EMBRYOLOGY AND CELL BIOLOGY": 2.44,
  "CURRENT MEDICAL RESEARCH AND OPINION": 2.44,
  "INTERNATIONAL JOURNAL OF TRANSGENDERISM": 2.44,
  "BEHAVIORAL MEDICINE": 2.439,
  "CHINESE JOURNAL OF INTERNATIONAL POLITICS": 2.439,
  "FRESHWATER SCIENCE": 2.438,
  "PSYCHOLOGY OF LEARNING AND MOTIVATION": 2.437,
  "AUSTRALIAN JOURNAL OF GRAPE AND WINE RESEARCH": 2.437,
  "FISHERIES RESEARCH": 2.437,
  "LARYNGOSCOPE": 2.436,
  "MAMMALIAN GENOME": 2.436,
  "INTERNATIONAL JOURNAL OF DAMAGE MECHANICS": 2.435,
  "THINKING & REASONING": 2.435,
  "ADVANCES IN BIOCHEMICAL ENGINEERING-BIOTECHNOLOGY": 2.434,
  "FOOT & ANKLE INTERNATIONAL": 2.434,
  "INTERNATIONAL TRANSACTIONS IN OPERATIONAL RESEARCH": 2.434,
  "JOURNAL OF ORAL REHABILITATION": 2.433,
  "JOURNAL OF COMPARATIVE PHYSIOLOGY B-BIOCHEMICAL SYSTEMS AND ENVIRONMENTAL PHYSIOLOGY": 2.433,
  "ETHICS AND INFORMATION TECHNOLOGY": 2.433,
  "JOURNAL OF DEVELOPMENTAL ORIGINS OF HEALTH AND DISEASE": 2.433,
  "SURGICAL ONCOLOGY CLINICS OF NORTH AMERICA": 2.433,
  "VETERINARY QUARTERLY": 2.433,
  "NONLINEAR ANALYSIS-MODELLING AND CONTROL": 2.431,
  "MULTIDIMENSIONAL SYSTEMS AND SIGNAL PROCESSING": 2.431,
  "PHOTOCHEMISTRY AND PHOTOBIOLOGY": 2.431,
  "TRANSACTIONS OF NONFERROUS METALS SOCIETY OF CHINA": 2.431,
  "CHEMICAL SENSES": 2.431,
  "CLINICAL AND EXPERIMENTAL PHARMACOLOGY AND PHYSIOLOGY": 2.43,
  "CLINICAL PSYCHOLOGY & PSYCHOTHERAPY": 2.43,
  "INTERNAL AND EMERGENCY MEDICINE": 2.43,
  "ADVANCES IN PHYSICAL ORGANIC CHEMISTRY": 2.429,
  "CIRP JOURNAL OF MANUFACTURING SCIENCE AND TECHNOLOGY": 2.429,
  "CURRENT OPINION IN PEDIATRICS": 2.429,
  "CURRENT PROBLEMS IN PEDIATRIC AND ADOLESCENT HEALTH CARE": 2.427,
  "HUMAN CELL": 2.427,
  "INTERNATIONAL JOURNAL OF MEDICAL SCIENCES": 2.426,
  "JOURNAL OF INTEGRATED PEST MANAGEMENT": 2.426,
  "MOBILE MEDIA & COMMUNICATION": 2.426,
  "SURFACE INNOVATIONS": 2.426,
  "GEOMATICS NATURAL HAZARDS & RISK": 2.425,
  "AGING CLINICAL AND EXPERIMENTAL RESEARCH": 2.424,
  "COATINGS": 2.423,
  "EUROPEAN JOURNAL OF CANCER PREVENTION": 2.423,
  "FUEL CELLS": 2.423,
  "PROBABILISTIC ENGINEERING MECHANICS": 2.423,
  "JOURNAL OF APPLIED PHYSICS": 2.423,
  "LASER PHYSICS LETTERS": 2.422,
  "PHOTODERMATOLOGY PHOTOIMMUNOLOGY & PHOTOMEDICINE": 2.421,
  "BIOMEDICAL MICRODEVICES": 2.421,
  "FUNCTIONAL PLANT BIOLOGY": 2.421,
  "JOURNAL OF INFORMATION SCIENCE": 2.42,
  "JOURNAL OF PSYCHOSOMATIC OBSTETRICS & GYNECOLOGY": 2.42,
  "BIOMASS CONVERSION AND BIOREFINERY": 2.419,
  "CARIES RESEARCH": 2.419,
  "PEDIATRIC NEUROLOGY": 2.419,
  "PERSPECTIVES ON POLITICS": 2.419,
  "SLEEP AND BREATHING": 2.419,
  "HYDROBIOLOGIA": 2.419,
  "PSYCHOLOGY OF AESTHETICS CREATIVITY AND THE ARTS": 2.419,
  "HORMONE RESEARCH IN PAEDIATRICS": 2.418,
  "PROTEOMICS CLINICAL APPLICATIONS": 2.418,
  "CELL BIOCHEMISTRY AND BIOPHYSICS": 2.418,
  "DISEASES OF THE ESOPHAGUS": 2.417,
  "FRONTIERS IN COMPUTATIONAL NEUROSCIENCE": 2.417,
  "JOURNAL OF OCCUPATIONAL AND ORGANIZATIONAL PSYCHOLOGY": 2.417,
  "EUROPEAN ACCOUNTING REVIEW": 2.415,
  "GROUNDWATER": 2.415,
  "PROGRESS IN ELECTROMAGNETICS RESEARCH-PIER": 2.414,
  "SIAM JOURNAL ON NUMERICAL ANALYSIS": 2.414,
  "ZEITSCHRIFT FUR MEDIZINISCHE PHYSIK": 2.414,
  "BIOANALYSIS": 2.413,
  "INTERNATIONAL JOURNAL OF RETAIL & DISTRIBUTION MANAGEMENT": 2.413,
  "PLANNING THEORY & PRACTICE": 2.412,
  "STATISTICAL SCIENCE": 2.412,
  "ADDICTION RESEARCH & THEORY": 2.411,
  "JOURNAL OF BIOMOLECULAR NMR": 2.411,
  "JOURNAL OF MICROBIOLOGY": 2.411,
  "LANGUAGE TEACHING RESEARCH": 2.411,
  "NATURAL HAZARDS": 2.408,
  "HEALTH AND QUALITY OF LIFE OUTCOMES": 2.407,
  "METEORITICS & PLANETARY SCIENCE": 2.407,
  "NEURAL DEVELOPMENT": 2.407,
  "PEDIATRIC INFECTIOUS DISEASE JOURNAL": 2.406,
  "ARCHIVES OF SUICIDE RESEARCH": 2.406,
  "ADVANCES IN CALCULUS OF VARIATIONS": 2.406,
  "CANCER JOURNAL": 2.405,
  "MECCANICA": 2.405,
  "AMERICAN JOURNAL OF TROPICAL MEDICINE AND HYGIENE": 2.404,
  "CARDIOVASCULAR THERAPEUTICS": 2.403,
  "IEEE TRANSACTIONS ON LEARNING TECHNOLOGIES": 2.402,
  "JOURNAL OF SYSTEMATIC PALAEONTOLOGY": 2.401,
  "DIAGNOSTIC MICROBIOLOGY AND INFECTIOUS DISEASE": 2.401,
  "BEHAVIOR GENETICS": 2.401,
  "CORNEA": 2.4,
  "EDUCATIONAL ADMINISTRATION QUARTERLY": 2.399,
  "INFRARED PHYSICS & TECHNOLOGY": 2.398,
  "INSECT CONSERVATION AND DIVERSITY": 2.397,
  "JOURNAL OF ENVIRONMENTAL LAW": 2.397,
  "INTERNATIONAL ENVIRONMENTAL AGREEMENTS-POLITICS LAW AND ECONOMICS": 2.397,
  "JOURNAL OF PLASMA PHYSICS": 2.397,
  "ELECTROCATALYSIS": 2.397,
  "LIGHTING RESEARCH & TECHNOLOGY": 2.395,
  "ECOLOGICAL INFORMATICS": 2.395,
  "JOURNAL OF BONE AND MINERAL METABOLISM": 2.395,
  "OTOLARYNGOLOGY-HEAD AND NECK SURGERY": 2.394,
  "SIAM JOURNAL ON SCIENTIFIC COMPUTING": 2.393,
  "ARCHIVES OF DERMATOLOGICAL RESEARCH": 2.393,
  "ADVANCES IN MARINE BIOLOGY": 2.393,
  "DRYING TECHNOLOGY": 2.392,
  "EMERGENCY MEDICINE JOURNAL": 2.392,
  "TRANSACTIONS OF THE ROYAL SOCIETY OF TROPICAL MEDICINE AND HYGIENE": 2.392,
  "CANADIAN JOURNAL OF SURGERY": 2.391,
  "COMMUNICATION METHODS AND MEASURES": 2.39,
  "EGYPTIAN INFORMATICS JOURNAL": 2.39,
  "INVERTEBRATE SYSTEMATICS": 2.388,
  "ANTIVIRAL THERAPY": 2.388,
  "BLOOD CELLS MOLECULES AND DISEASES": 2.386,
  "JOM": 2.386,
  "ACCOUNTING FORUM": 2.386,
  "AQUATIC SCIENCES": 2.385,
  "BMC BIOTECHNOLOGY": 2.385,
  "INTERNATIONAL JOURNAL OF GENOMICS": 2.385,
  "JOURNAL OF HEALTH SERVICES RESEARCH & POLICY": 2.384,
  "DOMESTIC ANIMAL ENDOCRINOLOGY": 2.383,
  "JOURNAL OF NEUROVIROLOGY": 2.383,
  "PREVENTIVE VETERINARY MEDICINE": 2.382,
  "SCIENCE COMMUNICATION": 2.382,
  "BIODATA MINING": 2.381,
  "BIOMEDICAL JOURNAL": 2.381,
  "DUKE LAW JOURNAL": 2.38,
  "JOURNAL OF FINANCIAL STABILITY": 2.38,
  "ADVANCES IN INORGANIC CHEMISTRY": 2.38,
  "CANCER CAUSES & CONTROL": 2.38,
  "JOURNAL OF ADVANCED CERAMICS": 2.38,
  "THERIOGENOLOGY": 2.379,
  "BRITISH JOURNAL OF EDUCATIONAL STUDIES": 2.379,
  "INTERNATIONAL JOURNAL OF PAVEMENT ENGINEERING": 2.379,
  "JOURNAL OF CHEMICAL AND ENGINEERING DATA": 2.379,
  "JOURNAL OF PEDIATRIC AND ADOLESCENT GYNECOLOGY": 2.379,
  "APPLIED ACOUSTICS": 2.378,
  "AIR QUALITY ATMOSPHERE AND HEALTH": 2.378,
  "HEALTH INFORMATICS JOURNAL": 2.378,
  "JOURNAL OF BIOMOLECULAR SCREENING": 2.378,
  "JOURNAL OF ETHNIC AND MIGRATION STUDIES": 2.377,
  "MEMOIRS OF THE AMERICAN MATHEMATICAL SOCIETY": 2.377,
  "INTERNATIONAL JOURNAL OF SOCIAL ROBOTICS": 2.377,
  "JOURNAL OF SOCIAL POLICY": 2.376,
  "INTERNATIONAL JOURNAL OF EARTH SCIENCES": 2.376,
  "REPRODUCTIVE HEALTH": 2.376,
  "SECURITY DIALOGUE": 2.376,
  "ACTIVE LEARNING IN HIGHER EDUCATION": 2.376,
  "CLINICAL RHEUMATOLOGY": 2.376,
  "SERVICE BUSINESS": 2.376,
  "BLOOD PRESSURE": 2.375,
  "IEEE TRANSACTIONS ON NANOTECHNOLOGY": 2.375,
  "ADVANCES IN BOTANICAL RESEARCH": 2.374,
  "JOURNAL OF SOLID STATE CHEMISTRY": 2.373,
  "SOCIAL FORCES": 2.373,
  "DIAMOND AND RELATED MATERIALS": 2.373,
  "JOURNAL OF CHEMICAL THERMODYNAMICS": 2.373,
  "BULLETIN OF THE SEISMOLOGICAL SOCIETY OF AMERICA": 2.373,
  "CHANNELS": 2.372,
  "IONICS": 2.371,
  "JOURNAL FOR NATURE CONSERVATION": 2.371,
  "JOURNAL OF CARDIOLOGY": 2.371,
  "HERNIA": 2.371,
  "WEATHER AND FORECASTING": 2.37,
  "ADVANCES IN PHYSIOLOGY EDUCATION": 2.37,
  "INTERNATIONAL JOURNAL OF ENDOCRINOLOGY": 2.37,
  "SAR AND QSAR IN ENVIRONMENTAL RESEARCH": 2.37,
  "APPLIED SPATIAL ANALYSIS AND POLICY": 2.368,
  "CANADIAN JOURNAL OF NEUROLOGICAL SCIENCES": 2.368,
  "COMPUTERS IN BIOLOGY AND MEDICINE": 2.368,
  "CLINICAL SIMULATION IN NURSING": 2.367,
  "EUROPEAN JOURNAL OF TEACHER EDUCATION": 2.367,
  "JOURNAL OF VETERINARY INTERNAL MEDICINE": 2.367,
  "CHEMISTRY EDUCATION RESEARCH AND PRACTICE": 2.366,
  "ANNALS OF OPERATIONS RESEARCH": 2.366,
  "JOURNAL OF THE OPTICAL SOCIETY OF AMERICA B-OPTICAL PHYSICS": 2.366,
  "POLYHEDRON": 2.366,
  "CONSERVATION GENETICS": 2.365,
  "JOURNAL OF GERIATRIC PHYSICAL THERAPY": 2.365,
  "RISK MANAGEMENT AND HEALTHCARE POLICY": 2.365,
  "JOURNAL OF SEDIMENTARY RESEARCH": 2.365,
  "JOURNAL OF PLANT ECOLOGY": 2.365,
  "DENDROCHRONOLOGIA": 2.365,
  "INTERNATIONAL JOURNAL OF FOOD SCIENCE AND TECHNOLOGY": 2.364,
  "PSYCHIATRIC CLINICS OF NORTH AMERICA": 2.364,
  "CONTEMPORARY CLINICAL TRIALS": 2.364,
  "JOURNAL OF ECT": 2.364,
  "FUTURE ONCOLOGY": 2.364,
  "GOLD BULLETIN": 2.364,
  "POPULATION SPACE AND PLACE": 2.363,
  "COGNITIVE THERAPY AND RESEARCH": 2.363,
  "COMMUNITY DENTISTRY AND ORAL EPIDEMIOLOGY": 2.361,
  "INTERNATIONAL JOURNAL OF TOURISM RESEARCH": 2.361,
  "MYCOPATHOLOGIA": 2.36,
  "ONCOLOGY": 2.36,
  "CURRENT DRUG METABOLISM": 2.36,
  "CLEAN TECHNOLOGIES AND ENVIRONMENTAL POLICY": 2.359,
  "JOURNAL OF FLOW CHEMISTRY": 2.358,
  "JOURNAL OF PHOTONICS FOR ENERGY": 2.358,
  "SEX ROLES": 2.357,
  "INTERNATIONAL JOURNAL OF METHODS IN PSYCHIATRIC RESEARCH": 2.357,
  "JOURNAL OF HOSPITAL MEDICINE": 2.357,
  "TOXICOLOGY MECHANISMS AND METHODS": 2.357,
  "TOXICON": 2.356,
  "SCIENCE AND ENGINEERING ETHICS": 2.355,
  "CLINICAL LYMPHOMA MYELOMA & LEUKEMIA": 2.354,
  "IEEE TRANSACTIONS ON ELECTROMAGNETIC COMPATIBILITY": 2.354,
  "CLINICAL PHYSIOLOGY AND FUNCTIONAL IMAGING": 2.354,
  "GENDER WORK AND ORGANIZATION": 2.354,
  "JOURNAL OF ETHNOBIOLOGY AND ETHNOMEDICINE": 2.353,
  "INTERNATIONAL JOURNAL OF ENGINE RESEARCH": 2.353,
  "TISSUE ENGINEERING AND REGENERATIVE MEDICINE": 2.353,
  "CARTOGRAPHY AND GEOGRAPHIC INFORMATION SCIENCE": 2.353,
  "AOB PLANTS": 2.35,
  "EUROPEAN SPORT MANAGEMENT QUARTERLY": 2.35,
  "JOURNAL OF NON-NEWTONIAN FLUID MECHANICS": 2.35,
  "PSYCHIATRIC REHABILITATION JOURNAL": 2.35,
  "PSYCHIATRY RESEARCH-NEUROIMAGING": 2.349,
  "SEXUALLY TRANSMITTED DISEASES": 2.349,
  "ANNUAL REVIEW OF FINANCIAL ECONOMICS": 2.349,
  "BEILSTEIN JOURNAL OF NANOTECHNOLOGY": 2.349,
  "HELLENIC JOURNAL OF CARDIOLOGY": 2.349,
  "INFORMATION AND ORGANIZATION": 2.348,
  "JOURNAL OF ACCOUNTING AND PUBLIC POLICY": 2.348,
  "JOURNAL OF THE PEDIATRIC INFECTIOUS DISEASES SOCIETY": 2.347,
  "WORLD JOURNAL OF MENS HEALTH": 2.347,
  "BIOMARKERS IN MEDICINE": 2.346,
  "JOURNAL OF ZOOLOGICAL SYSTEMATICS AND EVOLUTIONARY RESEARCH": 2.345,
  "JOURNAL OF THE AMERICAN SOCIETY OF HYPERTENSION": 2.345,
  "POLITICS & SOCIETY": 2.345,
  "POLYMER COMPOSITES": 2.345,
  "ACADEMIC RADIOLOGY": 2.344,
  "ANNALS OF PHYSICS": 2.344,
  "JOURNAL OF ENDOUROLOGY": 2.344,
  "JOURNAL OF MASS SPECTROMETRY": 2.344,
  "INTERNATIONAL JOURNAL OF RADIATION BIOLOGY": 2.344,
  "JOURNAL OF FINANCIAL AND QUANTITATIVE ANALYSIS": 2.343,
  "PEDIATRIC CLINICS OF NORTH AMERICA": 2.343,
  "ACTA PAEDIATRICA": 2.343,
  "CHINESE MEDICINE": 2.343,
  "HUMAN PSYCHOPHARMACOLOGY-CLINICAL AND EXPERIMENTAL": 2.342,
  "PHARMACOGENOMICS": 2.342,
  "JOURNAL OF ENGINEERING MECHANICS": 2.341,
  "BEHAVIOR MODIFICATION": 2.341,
  "INTERNATIONAL JOURNAL OF QUANTUM CHEMISTRY": 2.341,
  "INTERNATIONAL JOURNAL OF POLYMERIC MATERIALS AND POLYMERIC BIOMATERIALS": 2.341,
  "PUBLICATIONS MATHEMATIQUES DE L IHES": 2.341,
  "ARCHIVES OF VIROLOGY": 2.341,
  "CONTEMPORARY ACCOUNTING RESEARCH": 2.34,
  "NEURAL COMPUTATION": 2.34,
  "DEMENTIA AND GERIATRIC COGNITIVE DISORDERS": 2.34,
  "AGRONOMY-BASEL": 2.34,
  "INTERNATIONAL JOURNAL OF GENERAL SYSTEMS": 2.339,
  "JOURNAL OF VISUAL COMMUNICATION AND IMAGE REPRESENTATION": 2.338,
  "METALS": 2.338,
  "TETRAHEDRON LETTERS": 2.338,
  "CROATIAN JOURNAL OF FOREST ENGINEERING": 2.336,
  "SCIENCE CHINA-EARTH SCIENCES": 2.336,
  "CLINICAL TRIALS": 2.335,
  "INTERNATIONAL JOURNAL OF QUALITATIVE METHODS": 2.335,
  "CHEMICAL BIOLOGY & DRUG DESIGN": 2.333,
  "EXPERIMENTAL MECHANICS": 2.333,
  "JOURNAL OF DEVELOPMENTAL AND BEHAVIORAL PEDIATRICS": 2.333,
  "JOURNAL OF HEALTH PSYCHOLOGY": 2.333,
  "MUTATION RESEARCH-GENETIC TOXICOLOGY AND ENVIRONMENTAL MUTAGENESIS": 2.333,
  "ENVIRONMENTAL EDUCATION RESEARCH": 2.333,
  "JOURNAL OF ATHLETIC TRAINING": 2.333,
  "JUDGMENT AND DECISION MAKING": 2.333,
  "PROSTAGLANDINS & OTHER LIPID MEDIATORS": 2.333,
  "PSYCHIATRIC SERVICES": 2.332,
  "BMC GASTROENTEROLOGY": 2.331,
  "BRITISH JOURNAL OF POLITICS & INTERNATIONAL RELATIONS": 2.33,
  "COGNITIVE SCIENCE": 2.33,
  "PHYSICAL MEDICINE AND REHABILITATION CLINICS OF NORTH AMERICA": 2.33,
  "INTERNATIONAL JOURNAL OF HEMATOLOGY": 2.329,
  "THERMOCHIMICA ACTA": 2.328,
  "ACCOUNTING AND BUSINESS RESEARCH": 2.328,
  "APIDOLOGIE": 2.328,
  "CATALYSIS SURVEYS FROM ASIA": 2.327,
  "GRAEFES ARCHIVE FOR CLINICAL AND EXPERIMENTAL OPHTHALMOLOGY": 2.327,
  "JOURNAL OF URBAN TECHNOLOGY": 2.327,
  "MINERALS": 2.327,
  "NANO COMMUNICATION NETWORKS": 2.327,
  "SEXUAL DEVELOPMENT": 2.327,
  "WETLANDS ECOLOGY AND MANAGEMENT": 2.326,
  "JOURNAL OF APPLIED GERONTOLOGY": 2.326,
  "AUTONOMIC NEUROSCIENCE-BASIC & CLINICAL": 2.326,
  "BURNS": 2.326,
  "PHYSIOLOGICAL MEASUREMENT": 2.326,
  "UCLA LAW REVIEW": 2.325,
  "UROLOGIC CLINICS OF NORTH AMERICA": 2.325,
  "ANIMAL GENETICS": 2.324,
  "EUROPEAN JOURNAL OF SOIL BIOLOGY": 2.324,
  "PSYCHOLOGY AND PSYCHOTHERAPY-THEORY RESEARCH AND PRACTICE": 2.323,
  "ACS EARTH AND SPACE CHEMISTRY": 2.323,
  "CANCER MANAGEMENT AND RESEARCH": 2.323,
  "ENGINEERING ANALYSIS WITH BOUNDARY ELEMENTS": 2.323,
  "INTERNATIONAL JOURNAL OF AGRICULTURAL SUSTAINABILITY": 2.322,
  "JOURNAL OF OCCUPATIONAL REHABILITATION": 2.322,
  "ANNALS OF ANATOMY-ANATOMISCHER ANZEIGER": 2.322,
  "ANNALS OF OCCUPATIONAL HYGIENE": 2.322,
  "JALA": 2.322,
  "SIMULATION IN HEALTHCARE-JOURNAL OF THE SOCIETY FOR SIMULATION IN HEALTHCARE": 2.321,
  "AIDS RESEARCH AND THERAPY": 2.321,
  "JOURNAL OF AEROSOL SCIENCE": 2.321,
  "COMMUNICATIONS IN MATHEMATICAL PHYSICS": 2.32,
  "HORMONES & CANCER": 2.319,
  "INTERNATIONAL JOURNAL OF ADAPTIVE CONTROL AND SIGNAL PROCESSING": 2.319,
  "BUILDING SIMULATION": 2.319,
  "DEMENTIA-INTERNATIONAL JOURNAL OF SOCIAL RESEARCH AND PRACTICE": 2.319,
  "JOURNAL OF CATARACT AND REFRACTIVE SURGERY": 2.319,
  "INTERNATIONAL JOURNAL OF PHYTOREMEDIATION": 2.318,
  "POSTGRADUATE MEDICINE": 2.318,
  "TRANSLATIONAL BEHAVIORAL MEDICINE": 2.318,
  "CHINA QUARTERLY": 2.317,
  "JOURNAL OF PAIN RESEARCH": 2.317,
  "TELLUS SERIES B-CHEMICAL AND PHYSICAL METEOROLOGY": 2.316,
  "TRIBOLOGY LETTERS": 2.316,
  "EUROPEAN JOURNAL OF PUBLIC HEALTH": 2.316,
  "INTERNATIONAL JOURNAL OF ADVERTISING": 2.316,
  "BMC NEUROLOGY": 2.315,
  "JOURNAL OF ENVIRONMENTAL ENGINEERING AND LANDSCAPE MANAGEMENT": 2.315,
  "JOURNAL OF NANOMATERIALS": 2.315,
  "JOURNALISM STUDIES": 2.315,
  "BULLETIN OF VOLCANOLOGY": 2.315,
  "JOURNAL OF AVIAN BIOLOGY": 2.314,
  "GEOMECHANICS FOR ENERGY AND THE ENVIRONMENT": 2.313,
  "LUNG": 2.313,
  "OCULAR IMMUNOLOGY AND INFLAMMATION": 2.313,
  "JOURNAL OF BIOCHEMISTRY": 2.313,
  "FUNDAMENTAL & CLINICAL PHARMACOLOGY": 2.313,
  "JOURNAL OF TELEMEDICINE AND TELECARE": 2.313,
  "MECHANICS RESEARCH COMMUNICATIONS": 2.313,
  "SURFACE ENGINEERING": 2.312,
  "TRANSPORTMETRICA B-TRANSPORT DYNAMICS": 2.312,
  "ACTA ANAESTHESIOLOGICA SCANDINAVICA": 2.311,
  "JOURNAL OF PLASTIC RECONSTRUCTIVE AND AESTHETIC SURGERY": 2.311,
  "NEUROPSYCHIATRIC DISEASE AND TREATMENT": 2.31,
  "CLINICAL PHARMACOLOGY IN DRUG DEVELOPMENT": 2.31,
  "AMB EXPRESS": 2.31,
  "ARCHIVES OF CLINICAL NEUROPSYCHOLOGY": 2.31,
  "INTERNATIONAL HEART JOURNAL": 2.309,
  "INTERNATIONAL JOURNAL OF LOGISTICS MANAGEMENT": 2.308,
  "TOPICS IN CATALYSIS": 2.307,
  "APMIS": 2.307,
  "EUROPEAN JOURNAL OF PSYCHOLOGICAL ASSESSMENT": 2.307,
  "ECOHEALTH": 2.306,
  "INTERNATIONAL JOURNAL OF NON-LINEAR MECHANICS": 2.306,
  "INTERNATIONAL JOURNAL OF CRITICAL INFRASTRUCTURE PROTECTION": 2.306,
  "JOURNAL OF MOLECULAR SPECTROSCOPY": 2.306,
  "JOURNAL OF HAND SURGERY-EUROPEAN VOLUME": 2.305,
  "COLUMBIA LAW REVIEW": 2.305,
  "JOURNAL OF ATMOSPHERIC AND OCEANIC TECHNOLOGY": 2.305,
  "BRAZILIAN JOURNAL OF INFECTIOUS DISEASES": 2.304,
  "COMPUTERS & FLUIDS": 2.303,
  "QUANTUM INFORMATION PROCESSING": 2.303,
  "CRISIS-THE JOURNAL OF CRISIS INTERVENTION AND SUICIDE PREVENTION": 2.303,
  "ISRAEL JOURNAL OF CHEMISTRY": 2.303,
  "JOURNAL OF VISCERAL SURGERY": 2.302,
  "PSYCHOLOGY PUBLIC POLICY AND LAW": 2.302,
  "CURRENT GENE THERAPY": 2.302,
  "HEALTH RESEARCH POLICY AND SYSTEMS": 2.302,
  "APPLIED SCIENCES-BASEL": 2.301,
  "EUROPEAN JOURNAL OF HAEMATOLOGY": 2.301,
  "INTERNATIONAL JOURNAL OF SPORT NUTRITION AND EXERCISE METABOLISM": 2.301,
  "JOURNAL OF INTERNATIONAL ECONOMICS": 2.301,
  "TEACHING AND LEARNING IN MEDICINE": 2.3,
  "ATTACHMENT & HUMAN DEVELOPMENT": 2.3,
  "CARDIORENAL MEDICINE": 2.3,
  "FUTURES": 2.299,
  "FRONTIERS IN BIOSCIENCE-LANDMARK": 2.298,
  "IEEE TRANSACTIONS ON EDUCATION": 2.298,
  "BRITISH JOURNAL OF SOCIAL PSYCHOLOGY": 2.298,
  "EXPERT REVIEW OF MEDICAL DEVICES": 2.298,
  "EUROPEAN JOURNAL OF CRIMINOLOGY": 2.297,
  "SOCIOLOGY OF HEALTH & ILLNESS": 2.297,
  "MINERALOGICAL MAGAZINE": 2.297,
  "FAMILIAL CANCER": 2.297,
  "INTERNATIONAL STATISTICAL REVIEW": 2.297,
  "JOURNAL OF PLANKTON RESEARCH": 2.297,
  "JOURNAL OF SURGICAL EDUCATION": 2.296,
  "PSYCHIATRY RESEARCH": 2.296,
  "SWARM INTELLIGENCE": 2.295,
  "INTERNATIONAL JOURNAL OF COMPUTER-SUPPORTED COLLABORATIVE LEARNING": 2.295,
  "JOURNAL OF HYDRAULIC ENGINEERING": 2.295,
  "MIS QUARTERLY EXECUTIVE": 2.295,
  "CHEMISTRYOPEN": 2.294,
  "JOURNAL OF BANKING & FINANCE": 2.293,
  "ULTRASOUND IN MEDICINE AND BIOLOGY": 2.293,
  "STRUCTURAL DESIGN OF TALL AND SPECIAL BUILDINGS": 2.292,
  "BIOLOGICAL JOURNAL OF THE LINNEAN SOCIETY": 2.292,
  "ENGINEERING FAILURE ANALYSIS": 2.291,
  "EVOLUTIONARY BIOINFORMATICS": 2.291,
  "JOURNAL OF APPLIED SPORT PSYCHOLOGY": 2.291,
  "BIOLOGY OF SPORT": 2.29,
  "BIOCHEMIA MEDICA": 2.29,
  "HUMAN IMMUNOLOGY": 2.289,
  "AMERICAN JOURNAL OF SURGERY": 2.289,
  "ANNALES DE L INSTITUT HENRI POINCARE-ANALYSE NON LINEAIRE": 2.289,
  "ABACUS-A JOURNAL OF ACCOUNTING FINANCE AND BUSINESS STUDIES": 2.289,
  "AUTOMATED SOFTWARE ENGINEERING": 2.289,
  "LEARNED PUBLISHING": 2.288,
  "PLANT CELL TISSUE AND ORGAN CULTURE": 2.288,
  "POST-SOVIET AFFAIRS": 2.287,
  "RHEUMATOLOGY INTERNATIONAL": 2.287,
  "ARCHIVES OF GYNECOLOGY AND OBSTETRICS": 2.287,
  "DUKE MATHEMATICAL JOURNAL": 2.286,
  "EUROPEAN JOURNAL OF GASTROENTEROLOGY & HEPATOLOGY": 2.286,
  "ILR REVIEW": 2.286,
  "AMERICAN JOURNAL OF MEDICAL GENETICS PART A": 2.286,
  "BIOMED RESEARCH INTERNATIONAL": 2.286,
  "CURRENT MOLECULAR MEDICINE": 2.286,
  "INTERNATIONAL JOURNAL OF BANK MARKETING": 2.286,
  "MIT SLOAN MANAGEMENT REVIEW": 2.285,
  "SOCIO-ECONOMIC PLANNING SCIENCES": 2.285,
  "JOURNAL OF MATERIALS SCIENCE-MATERIALS IN ELECTRONICS": 2.284,
  "JOURNAL OF MEDICAL ETHICS": 2.284,
  "GASTROENTEROLOGY REPORT": 2.284,
  "JASSS-THE JOURNAL OF ARTIFICIAL SOCIETIES AND SOCIAL SIMULATION": 2.283,
  "ENVIRONMENTAL CHEMISTRY": 2.283,
  "SLAS DISCOVERY": 2.283,
  "BIOCONTROL": 2.283,
  "INFECTIOUS DISEASES": 2.282,
  "DERMATOLOGIC SURGERY": 2.282,
  "HARVARD EDUCATIONAL REVIEW": 2.281,
  "HARVARD INTERNATIONAL LAW JOURNAL": 2.281,
  "HEALTH EDUCATION & BEHAVIOR": 2.281,
  "JOURNAL OF CLINICAL BIOCHEMISTRY AND NUTRITION": 2.28,
  "COMPUTERS & ELECTRICAL ENGINEERING": 2.28,
  "JOURNAL OF BEHAVIOR THERAPY AND EXPERIMENTAL PSYCHIATRY": 2.28,
  "MASS COMMUNICATION AND SOCIETY": 2.279,
  "AFRICAN AFFAIRS": 2.279,
  "AUSTRALIAN ARCHAEOLOGY": 2.279,
  "EUROPEAN JOURNAL OF PEDIATRICS": 2.278,
  "JOURNAL OF APPLIED POLYMER SCIENCE": 2.278,
  "TRANSACTIONS IN GIS": 2.278,
  "ARCHIVE FOR RATIONAL MECHANICS AND ANALYSIS": 2.278,
  "BMC IMMUNOLOGY": 2.278,
  "CANADIAN FAMILY PHYSICIAN": 2.277,
  "DEVELOPMENT GENES AND EVOLUTION": 2.277,
  "PANMINERVA MEDICA": 2.277,
  "CRITICAL SOCIAL POLICY": 2.277,
  "BMC PULMONARY MEDICINE": 2.277,
  "JOURNAL OF CLINICAL DENSITOMETRY": 2.276,
  "CHROMOSOME RESEARCH": 2.276,
  "CANCER GENETICS": 2.276,
  "ECONOMICS & HUMAN BIOLOGY": 2.276,
  "JAPANESE JOURNAL OF CLINICAL ONCOLOGY": 2.276,
  "EUROPEAN JOURNAL OF AGEING": 2.275,
  "INTERNATIONAL JOURNAL OF STRESS MANAGEMENT": 2.275,
  "PATHOGENS AND DISEASE": 2.274,
  "ERGONOMICS": 2.274,
  "INTERNATIONAL JOURNAL OF CONTROL AUTOMATION AND SYSTEMS": 2.273,
  "TOTAL QUALITY MANAGEMENT & BUSINESS EXCELLENCE": 2.273,
  "ANTI-CANCER AGENTS IN MEDICINAL CHEMISTRY": 2.273,
  "HYDROLOGICAL SCIENCES JOURNAL-JOURNAL DES SCIENCES HYDROLOGIQUES": 2.272,
  "INTERNATIONAL JOURNAL OF IMMUNOPATHOLOGY AND PHARMACOLOGY": 2.272,
  "SCIENCE CHINA-TECHNOLOGICAL SCIENCES": 2.271,
  "JOURNAL OF CLINICAL MONITORING AND COMPUTING": 2.27,
  "JOURNAL OF ENVIRONMENTAL RADIOACTIVITY": 2.27,
  "JOURNAL OF PLANT GROWTH REGULATION": 2.27,
  "CLINICS IN SPORTS MEDICINE": 2.27,
  "EPILEPSY RESEARCH": 2.27,
  "EATING BEHAVIORS": 2.27,
  "VISION RESEARCH": 2.269,
  "REVUE NEUROLOGIQUE": 2.269,
  "MECHANISMS OF DEVELOPMENT": 2.269,
  "JOURNAL OF GREAT LAKES RESEARCH": 2.269,
  "JOURNAL OF SOIL AND WATER CONSERVATION": 2.269,
  "JOURNAL OF OTOLARYNGOLOGY-HEAD & NECK SURGERY": 2.269,
  "CURRENT GENOMICS": 2.269,
  "INTERNATIONAL REVIEW OF ADMINISTRATIVE SCIENCES": 2.268,
  "MOLECULAR VISION": 2.268,
  "THEORY CULTURE & SOCIETY": 2.268,
  "INNATE IMMUNITY": 2.268,
  "NEUROSCIENCE LETTERS": 2.268,
  "ANNALI DELL ISTITUTO SUPERIORE DI SANITA": 2.267,
  "CROP PROTECTION": 2.267,
  "INTERNATIONAL STUDIES QUARTERLY": 2.267,
  "JOURNAL OF PROSTHODONTICS-IMPLANT ESTHETIC AND RECONSTRUCTIVE DENTISTRY": 2.267,
  "ANNALS OF DYSLEXIA": 2.266,
  "HUMAN & EXPERIMENTAL TOXICOLOGY": 2.266,
  "PRODUCTION AND OPERATIONS MANAGEMENT": 2.266,
  "SOCIOLOGICAL THEORY": 2.265,
  "FOOD ADDITIVES AND CONTAMINANTS PART A-CHEMISTRY ANALYSIS CONTROL EXPOSURE & RISK ASSESSMENT": 2.265,
  "JOURNAL OF THE ACM": 2.265,
  "JOURNAL OF NEUROSURGERY-PEDIATRICS": 2.265,
  "EUROPEAN JOURNAL OF HEALTH ECONOMICS": 2.264,
  "STRESS-THE INTERNATIONAL JOURNAL ON THE BIOLOGY OF STRESS": 2.263,
  "CONNECTIVE TISSUE RESEARCH": 2.263,
  "EUROPEAN PSYCHOLOGIST": 2.263,
  "GROWTH HORMONE & IGF RESEARCH": 2.263,
  "JOURNAL OF CLINICAL PHARMACY AND THERAPEUTICS": 2.261,
  "JOURNAL OF SPORT MANAGEMENT": 2.261,
  "NEUROPHYSIOLOGIE CLINIQUE-CLINICAL NEUROPHYSIOLOGY": 2.261,
  "ACTA MECHANICA": 2.26,
  "INTERNATIONAL JOURNAL OF SYSTEMATIC AND EVOLUTIONARY MICROBIOLOGY": 2.259,
  "HERITAGE SCIENCE": 2.259,
  "UNIVERSE": 2.259,
  "CRIMINAL JUSTICE AND BEHAVIOR": 2.259,
  "ZOONOSES AND PUBLIC HEALTH": 2.259,
  "CLINICS IN GERIATRIC MEDICINE": 2.258,
  "ENGINEERING APPLICATIONS OF COMPUTATIONAL FLUID MECHANICS": 2.258,
  "INTERNATIONAL JOURNAL OF DISASTER RISK SCIENCE": 2.257,
  "POLYMERS FOR ADVANCED TECHNOLOGIES": 2.257,
  "NEUROPATHOLOGY": 2.256,
  "JOURNAL OF CHILD AND ADOLESCENT PSYCHOPHARMACOLOGY": 2.256,
  "THEORETICAL ECONOMICS": 2.256,
  "BIOCYBERNETICS AND BIOMEDICAL ENGINEERING": 2.256,
  "JOURNAL OF ENGINEERING AND TECHNOLOGY MANAGEMENT": 2.256,
  "ANNALS OF GENERAL PSYCHIATRY": 2.256,
  "CLINICAL DRUG INVESTIGATION": 2.255,
  "MOLECULAR AND BIOCHEMICAL PARASITOLOGY": 2.253,
  "VASCULAR MEDICINE": 2.253,
  "JOURNAL OF SUPERCOMPUTING": 2.253,
  "NUCLEUS": 2.253,
  "REVIEWS IN THE NEUROSCIENCES": 2.253,
  "ALGAE": 2.252,
  "INTERNATIONAL JOURNAL OF STRUCTURAL STABILITY AND DYNAMICS": 2.252,
  "JOURNAL OF RESEARCH IN INTERACTIVE MARKETING": 2.252,
  "THIRD WORLD QUARTERLY": 2.252,
  "INTERNATIONAL JOURNAL OF COMPUTER ASSISTED RADIOLOGY AND SURGERY": 2.251,
  "SOLID STATE SCIENCES": 2.251,
  "STRAIN": 2.25,
  "BIOTECHNOLOGY LETTERS": 2.25,
  "COMPUTATIONAL INTELLIGENCE AND NEUROSCIENCE": 2.25,
  "ENVIRONMENTAL & RESOURCE ECONOMICS": 2.25,
  "JOURNAL OF URBAN HEALTH-BULLETIN OF THE NEW YORK ACADEMY OF MEDICINE": 2.25,
  "SOCIAL NEUROSCIENCE": 2.25,
  "FOOD SECURITY": 2.25,
  "INTERNATIONAL JOURNAL OF COMPUTATIONAL INTELLIGENCE SYSTEMS": 2.25,
  "EARTH AND SPACE SCIENCE": 2.25,
  "GENOME": 2.248,
  "SCANDINAVIAN JOURNAL OF GASTROENTEROLOGY": 2.247,
  "PHYSICA SCRIPTA": 2.247,
  "SOCIOLOGICAL REVIEW": 2.246,
  "HUMAN NATURE-AN INTERDISCIPLINARY BIOSOCIAL PERSPECTIVE": 2.245,
  "ABDOMINAL RADIOLOGY": 2.245,
  "JOURNAL OF RACIAL AND ETHNIC HEALTH DISPARITIES": 2.244,
  "BIRTH DEFECTS RESEARCH PART A-CLINICAL AND MOLECULAR TERATOLOGY": 2.244,
  "JOURNAL OF THE EXPERIMENTAL ANALYSIS OF BEHAVIOR": 2.244,
  "ARCHIV DER PHARMAZIE": 2.244,
  "GRANULAR MATTER": 2.243,
  "INTERNATIONAL JOURNAL OF BIFURCATION AND CHAOS": 2.243,
  "MINE WATER AND THE ENVIRONMENT": 2.243,
  "LIPIDS": 2.243,
  "AQUACULTURAL ENGINEERING": 2.242,
  "AQUATIC BOTANY": 2.241,
  "EURASIAN BUSINESS REVIEW": 2.241,
  "JOURNAL OF TRANSPORT AND LAND USE": 2.241,
  "ORGANISMS DIVERSITY & EVOLUTION": 2.241,
  "POLITICAL SCIENCE RESEARCH AND METHODS": 2.24,
  "SYMMETRY-BASEL": 2.24,
  "CELL BIOCHEMISTRY AND FUNCTION": 2.239,
  "COMPARATIVE BIOCHEMISTRY AND PHYSIOLOGY A-MOLECULAR & INTEGRATIVE PHYSIOLOGY": 2.239,
  "CRYOBIOLOGY": 2.239,
  "JOURNAL OF MICROMECHANICS AND MICROENGINEERING": 2.238,
  "MULTIVARIATE BEHAVIORAL RESEARCH": 2.238,
  "SOFTWARE QUALITY JOURNAL": 2.238,
  "APPLIED BIOCHEMISTRY AND BIOTECHNOLOGY": 2.237,
  "CARDIOLOGY RESEARCH AND PRACTICE": 2.237,
  "INTEGRATIVE ZOOLOGY": 2.237,
  "JOURNAL OF CLOUD COMPUTING-ADVANCES SYSTEMS AND APPLICATIONS": 2.237,
  "CONTRIBUTIONS TO ZOOLOGY": 2.236,
  "INSECTS": 2.236,
  "JOURNAL OF NONDESTRUCTIVE EVALUATION": 2.235,
  "AVIAN CONSERVATION AND ECOLOGY": 2.235,
  "BULLETIN OF ENGINEERING GEOLOGY AND THE ENVIRONMENT": 2.234,
  "SPORT MANAGEMENT REVIEW": 2.234,
  "NUMERISCHE MATHEMATIK": 2.234,
  "STEROIDS": 2.233,
  "ARCHIVES OF ENVIRONMENTAL CONTAMINATION AND TOXICOLOGY": 2.233,
  "IEEE TRANSACTIONS ON DIELECTRICS AND ELECTRICAL INSULATION": 2.233,
  "JOURNAL OF COMPUTATIONAL AND NONLINEAR DYNAMICS": 2.233,
  "CONTINENTAL SHELF RESEARCH": 2.232,
  "MARINE BIOLOGY": 2.232,
  "AREA": 2.231,
  "EDUCATIONAL TECHNOLOGY & SOCIETY": 2.231,
  "QUATERNARY RESEARCH": 2.231,
  "INTERNATIONAL JOURNAL OF SPORTS MEDICINE": 2.23,
  "COMPUTATIONAL LINGUISTICS": 2.229,
  "JOURNAL OF MAMMALOGY": 2.229,
  "BIRTH-ISSUES IN PERINATAL CARE": 2.229,
  "FRONTIERS IN PSYCHOLOGY": 2.229,
  "JOURNAL OF THERMAL SPRAY TECHNOLOGY": 2.229,
  "CELL BIOLOGY INTERNATIONAL": 2.229,
  "GENETICS AND MOLECULAR BIOLOGY": 2.228,
  "ADVANCES IN EXPERIMENTAL MEDICINE AND BIOLOGY": 2.228,
  "JOURNAL OF ENTERPRISE INFORMATION MANAGEMENT": 2.228,
  "MATCH-COMMUNICATIONS IN MATHEMATICAL AND IN COMPUTER CHEMISTRY": 2.227,
  "COGNITIVE NEUROPSYCHOLOGY": 2.226,
  "DEVELOPMENTAL NEUROSCIENCE": 2.226,
  "JOURNAL OF CLUSTER SCIENCE": 2.226,
  "JOURNAL OF MEDICAL SCREENING": 2.226,
  "JOURNAL OF PLANNING LITERATURE": 2.226,
  "JOURNAL OF PUBLIC RELATIONS RESEARCH": 2.226,
  "REVIEW OF EUROPEAN COMPARATIVE & INTERNATIONAL ENVIRONMENTAL LAW": 2.225,
  "ALLERGY AND ASTHMA PROCEEDINGS": 2.225,
  "JOURNALISM PRACTICE": 2.225,
  "MOLECULAR REPRODUCTION AND DEVELOPMENT": 2.225,
  "KIDNEY & BLOOD PRESSURE RESEARCH": 2.225,
  "ENDANGERED SPECIES RESEARCH": 2.225,
  "ENTERPRISE INFORMATION SYSTEMS": 2.225,
  "JOURNAL OF RISK AND UNCERTAINTY": 2.224,
  "JOURNAL OF BIOMATERIALS SCIENCE-POLYMER EDITION": 2.224,
  "RECENT PATENTS ON ANTI-CANCER DRUG DISCOVERY": 2.223,
  "STRUCTURE AND BONDING": 2.223,
  "CRETACEOUS RESEARCH": 2.222,
  "EVODEVO": 2.221,
  "JOURNAL OF MOLECULAR STRUCTURE": 2.22,
  "JOURNAL OF EUROPEAN SOCIAL POLICY": 2.219,
  "REPRODUCTIVE HEALTH MATTERS": 2.219,
  "GERIATRICS & GERONTOLOGY INTERNATIONAL": 2.218,
  "FORESTS": 2.218,
  "VETERINARY PATHOLOGY": 2.217,
  "EQUINE VETERINARY JOURNAL": 2.217,
  "ETR&D-EDUCATIONAL TECHNOLOGY RESEARCH AND DEVELOPMENT": 2.217,
  "JOURNAL OF PHYSICS B-ATOMIC MOLECULAR AND OPTICAL PHYSICS": 2.216,
  "JOURNAL OF AGRARIAN CHANGE": 2.216,
  "IEEE AEROSPACE AND ELECTRONIC SYSTEMS MAGAZINE": 2.215,
  "OBSTETRICAL & GYNECOLOGICAL SURVEY": 2.214,
  "TRANSLATIONAL ANDROLOGY AND UROLOGY": 2.214,
  "EXCLI JOURNAL": 2.214,
  "JOURNAL OF DERMATOLOGICAL TREATMENT": 2.214,
  "MAGNETIC RESONANCE IMAGING": 2.213,
  "TRANSPLANT INFECTIOUS DISEASE": 2.212,
  "INTERNATIONAL JOURNAL OF CONCRETE STRUCTURES AND MATERIALS": 2.211,
  "JOURNAL OF EXPERIMENTAL & THEORETICAL ARTIFICIAL INTELLIGENCE": 2.211,
  "ARCHIVES OF PHYSIOLOGY AND BIOCHEMISTRY": 2.21,
  "JOURNAL OF PHYSICS A-MATHEMATICAL AND THEORETICAL": 2.209,
  "ADVANCES IN NANO RESEARCH": 2.209,
  "COMPUTATIONAL GEOSCIENCES": 2.209,
  "EMERGING MARKETS REVIEW": 2.209,
  "JOURNAL OF APPLIED BEHAVIOR ANALYSIS": 2.208,
  "REVIEW OF ACCOUNTING STUDIES": 2.208,
  "ADVANCES IN CHEMICAL PHYSICS": 2.208,
  "INTERNATIONAL JOURNAL OF UROLOGY": 2.206,
  "MOLECULAR BIOLOGY REPORTS": 2.206,
  "BIG DATA": 2.206,
  "CHINA ECONOMIC REVIEW": 2.205,
  "CRITICAL STUDIES IN EDUCATION": 2.205,
  "JOURNAL OF INTERVENTIONAL CARDIOLOGY": 2.205,
  "AIDS CARE-PSYCHOLOGICAL AND SOCIO-MEDICAL ASPECTS OF AIDS/HIV": 2.204,
  "BEHAVIORAL ECOLOGY AND SOCIOBIOLOGY": 2.203,
  "BMC PHARMACOLOGY & TOXICOLOGY": 2.203,
  "MIND BRAIN AND EDUCATION": 2.203,
  "BEHAVIORAL NEUROSCIENCE": 2.203,
  "CURRENT OPINION IN ANESTHESIOLOGY": 2.203,
  "EUROPEAN PLANNING STUDIES": 2.202,
  "EUROPEAN JOURNAL OF PHYSICAL AND REHABILITATION MEDICINE": 2.202,
  "JOURNAL OF INVERTEBRATE PATHOLOGY": 2.202,
  "MULTIMEDIA TOOLS AND APPLICATIONS": 2.201,
  "SUBSTANCE ABUSE TREATMENT PREVENTION AND POLICY": 2.201,
  "VETERINARY RECORD": 2.2,
  "REVISTA DE PSICODIDACTICA": 2.2,
  "AQUACULTURE NUTRITION": 2.2,
  "ADVANCES IN DATA ANALYSIS AND CLASSIFICATION": 2.2,
  "FIRE ECOLOGY": 2.2,
  "PATIENT PREFERENCE AND ADHERENCE": 2.2,
  "REVISTA PORTUGUESA DE PNEUMOLOGIA": 2.199,
  "CHINESE JOURNAL OF AERONAUTICS": 2.199,
  "SCANDINAVIAN JOURNAL OF PRIMARY HEALTH CARE": 2.198,
  "CHEMISTRY CENTRAL JOURNAL": 2.198,
  "INTERNATIONAL JOURNAL OF LEGAL MEDICINE": 2.197,
  "LIMNOLOGY AND OCEANOGRAPHY-METHODS": 2.197,
  "LANGENBECKS ARCHIVES OF SURGERY": 2.196,
  "IET BIOMETRICS": 2.196,
  "JOURNAL OF CHILD NEUROLOGY": 2.196,
  "JOURNAL OF PEDIATRIC SURGERY": 2.196,
  "REGIONAL SCIENCE AND URBAN ECONOMICS": 2.196,
  "JOURNAL OF MATHEMATICAL NEUROSCIENCE": 2.195,
  "INTERNATIONAL JOURNAL OF COMPUTER INTEGRATED MANUFACTURING": 2.195,
  "INTERNATIONAL UROGYNECOLOGY JOURNAL": 2.195,
  "JOURNAL OF HAND SURGERY-AMERICAN VOLUME": 2.194,
  "EXPERIMENTAL AGRICULTURE": 2.194,
  "HIV CLINICAL TRIALS": 2.193,
  "HUMAN GENE THERAPY METHODS": 2.192,
  "JOURNAL OF VISION": 2.191,
  "TECHNOMETRICS": 2.191,
  "BMC NEPHROLOGY": 2.19,
  "EURASIAN GEOGRAPHY AND ECONOMICS": 2.19,
  "BREAST CARE": 2.19,
  "MATHEMATICS OF COMPUTATION": 2.19,
  "PHYSICS LETTERS A": 2.19,
  "IMMUNOPHARMACOLOGY AND IMMUNOTOXICOLOGY": 2.189,
  "POPULATION HEALTH MANAGEMENT": 2.189,
  "ANNALS OF PROBABILITY": 2.189,
  "BAYESIAN ANALYSIS": 2.188,
  "JOURNAL OF OCEANOGRAPHY": 2.188,
  "NEPHRON": 2.188,
  "NONLINEAR ANALYSIS-REAL WORLD APPLICATIONS": 2.188,
  "NETWORKS & SPATIAL ECONOMICS": 2.188,
  "SEMINARS IN DIAGNOSTIC PATHOLOGY": 2.186,
  "IEEE TRANSACTIONS ON CONSUMER ELECTRONICS": 2.186,
  "JOURNAL OF NON-EQUILIBRIUM THERMODYNAMICS": 2.186,
  "URBAN WATER JOURNAL": 2.186,
  "CLINICAL RADIOLOGY": 2.186,
  "INTERNATIONAL JOURNAL FOR NUMERICAL METHODS IN BIOMEDICAL ENGINEERING": 2.185,
  "JOURNAL OF MAMMALIAN EVOLUTION": 2.184,
  "JOURNAL OF PLANT RESEARCH": 2.184,
  "PATHOLOGY INTERNATIONAL": 2.183,
  "ADVANCES IN INSECT PHYSIOLOGY": 2.183,
  "INTERNATIONAL JOURNAL OF WATER RESOURCES DEVELOPMENT": 2.183,
  "JOURNAL OF ASTHMA": 2.183,
  "JOURNAL OF FOOD SCIENCE": 2.183,
  "JOURNAL OF PEPTIDE SCIENCE": 2.182,
  "URBAN AFFAIRS REVIEW": 2.182,
  "ADVANCES IN MEDICAL SCIENCES": 2.182,
  "JOURNAL OF NEUROIMAGING": 2.181,
  "JOURNAL OF THE AMERICAN COLLEGE OF NUTRITION": 2.181,
  "CURRENT UROLOGY REPORTS": 2.181,
  "JOURNAL OF PHYSICAL ACTIVITY & HEALTH": 2.181,
  "WOMEN AND BIRTH": 2.18,
  "HEART LUNG AND CIRCULATION": 2.18,
  "JOURNAL OF THORACIC IMAGING": 2.18,
  "LEARNING DISABILITIES RESEARCH & PRACTICE": 2.18,
  "PLANT SPECIES BIOLOGY": 2.179,
  "SURGERY TODAY": 2.179,
  "INTERNATIONAL STUDIES REVIEW": 2.179,
  "JOURNAL OF THE AMERICAN PHARMACISTS ASSOCIATION": 2.178,
  "LASERS IN MEDICAL SCIENCE": 2.178,
  "SCHOOL PSYCHOLOGY QUARTERLY": 2.178,
  "HEALTH POLICY": 2.178,
  "IEEE JOURNAL OF TRANSLATIONAL ENGINEERING IN HEALTH AND MEDICINE-JTEHM": 2.177,
  "INTERNATIONAL JOURNAL OF PRESSURE VESSELS AND PIPING": 2.176,
  "INTERNATIONAL JOURNAL FOR PARASITOLOGY-PARASITES AND WILDLIFE": 2.175,
  "PULMONARY CIRCULATION": 2.175,
  "STUDIES IN FAMILY PLANNING": 2.175,
  "ECOLOGICAL ENTOMOLOGY": 2.174,
  "INTERNATIONAL JOURNAL OF LABORATORY HEMATOLOGY": 2.174,
  "JOURNAL OF ADOLESCENT RESEARCH": 2.174,
  "BRAIN AND BEHAVIOR": 2.174,
  "JOURNAL OF SENSORY STUDIES": 2.173,
  "ACM TRANSACTIONS ON SOFTWARE ENGINEERING AND METHODOLOGY": 2.173,
  "CHILD PSYCHIATRY & HUMAN DEVELOPMENT": 2.172,
  "JOURNAL OF RESEARCH ON ADOLESCENCE": 2.172,
  "MEDITERRANEAN MARINE SCIENCE": 2.172,
  "NEUROSCIENCE RESEARCH": 2.172,
  "CURRENT ZOOLOGY": 2.171,
  "JOURNAL OF LOSS PREVENTION IN THE PROCESS INDUSTRIES": 2.171,
  "BMC MEDICAL INFORMATICS AND DECISION MAKING": 2.171,
  "CLINICS IN DERMATOLOGY": 2.171,
  "INTERNATIONAL JOURNAL OF EMERGING MARKETS": 2.17,
  "PARASITOLOGY RESEARCH": 2.17,
  "INFORMATION SYSTEMS": 2.17,
  "JOURNAL OF ORGANOMETALLIC CHEMISTRY": 2.169,
  "LEUKEMIA RESEARCH": 2.168,
  "LIFE SCIENCES IN SPACE RESEARCH": 2.167,
  "RESEARCH IN TRANSPORTATION BUSINESS AND MANAGEMENT": 2.167,
  "APPLIED SPECTROSCOPY": 2.167,
  "EXTRACTIVE INDUSTRIES AND SOCIETY-AN INTERNATIONAL JOURNAL": 2.167,
  "RESEARCH ON CHEMICAL INTERMEDIATES": 2.167,
  "ZOOLOGICAL LETTERS": 2.167,
  "AMERICAN JOURNAL OF CRITICAL CARE": 2.167,
  "COMPUTING": 2.166,
  "JOURNAL OF GASTROINTESTINAL AND LIVER DISEASES": 2.166,
  "OTOLOGY & NEUROTOLOGY": 2.165,
  "CARDIOLOGY CLINICS": 2.165,
  "CRYSTALS": 2.164,
  "ESOPHAGUS": 2.164,
  "JOURNAL OF GUIDANCE CONTROL AND DYNAMICS": 2.163,
  "NORDIC JOURNAL OF PSYCHIATRY": 2.163,
  "COGNITIVE DEVELOPMENT": 2.162,
  "HEALTH CARE MANAGEMENT SCIENCE": 2.162,
  "JOURNAL OF CLINICAL PSYCHOLOGY": 2.161,
  "EVOLUTIONARY BIOLOGY": 2.16,
  "NAUNYN-SCHMIEDEBERGS ARCHIVES OF PHARMACOLOGY": 2.16,
  "INTERNATIONAL JOURNAL OF PAEDIATRIC DENTISTRY": 2.159,
  "JOURNAL OF PLANT NUTRITION AND SOIL SCIENCE": 2.159,
  "4OR-A QUARTERLY JOURNAL OF OPERATIONS RESEARCH": 2.159,
  "ASSEMBLY AUTOMATION": 2.158,
  "CURRENT OPINION IN UROLOGY": 2.158,
  "ECONOMIC MODELLING": 2.158,
  "EUROPEAN FOOD RESEARCH AND TECHNOLOGY": 2.158,
  "OBESITY RESEARCH & CLINICAL PRACTICE": 2.158,
  "PAPERS IN PALAEONTOLOGY": 2.157,
  "SEMINARS IN DIALYSIS": 2.157,
  "ACM JOURNAL ON EMERGING TECHNOLOGIES IN COMPUTING SYSTEMS": 2.157,
  "JOURNAL OF FLUORINE CHEMISTRY": 2.156,
  "DISABILITY AND REHABILITATION": 2.156,
  "AUDIOLOGY AND NEURO-OTOLOGY": 2.156,
  "GEOGRAPHY COMPASS": 2.156,
  "JOURNAL OF APPLIED ECONOMETRICS": 2.155,
  "EPILEPTIC DISORDERS": 2.155,
  "EDUCATIONAL AND PSYCHOLOGICAL MEASUREMENT": 2.155,
  "JOURNAL OF ECONOMIC POLICY REFORM": 2.154,
  "LIMNOLOGICA": 2.154,
  "MONOGRAPHS OF THE SOCIETY FOR RESEARCH IN CHILD DEVELOPMENT": 2.154,
  "PARKINSONS DISEASE": 2.154,
  "BIOSTATISTICS": 2.154,
  "IET INTELLIGENT TRANSPORT SYSTEMS": 2.153,
  "JOURNAL OF GEOLOGY": 2.153,
  "TOPICS IN COGNITIVE SCIENCE": 2.152,
  "JOURNAL OF MEDICAL VIROLOGY": 2.152,
  "BMC ORAL HEALTH": 2.152,
  "BMC SYSTEMS BIOLOGY": 2.151,
  "MIDWIFERY": 2.151,
  "SLAS TECHNOLOGY": 2.148,
  "ADVANCES IN PRODUCTION ENGINEERING & MANAGEMENT": 2.147,
  "DIVERSITY-BASEL": 2.147,
  "EPIDEMIOLOGY AND INFECTION": 2.146,
  "THERAPEUTIC DRUG MONITORING": 2.146,
  "ATMOSPHERE": 2.146,
  "CLINICAL MEDICINE": 2.145,
  "CELL JOURNAL": 2.145,
  "EXTREMOPHILES": 2.145,
  "JOURNAL OF PEDIATRIC ORTHOPAEDICS": 2.145,
  "JOURNAL OF PERINATOLOGY": 2.144,
  "NEUROIMAGING CLINICS OF NORTH AMERICA": 2.143,
  "JOURNAL OF LAND USE SCIENCE": 2.143,
  "RAPID COMMUNICATIONS IN MASS SPECTROMETRY": 2.143,
  "BREAST CANCER": 2.143,
  "CARDIOVASCULAR ULTRASOUND": 2.143,
  "PROJECT MANAGEMENT JOURNAL": 2.143,
  "SOCIAL & CULTURAL GEOGRAPHY": 2.143,
  "URBAN EDUCATION": 2.142,
  "WEATHER CLIMATE AND SOCIETY": 2.142,
  "ECONOMIC DEVELOPMENT AND CULTURAL CHANGE": 2.141,
  "FEMINIST MEDIA STUDIES": 2.141,
  "INFORMATION SYSTEMS MANAGEMENT": 2.141,
  "CANADIAN JOURNAL OF PHYSIOLOGY AND PHARMACOLOGY": 2.141,
  "ELECTRONIC JOURNAL OF BIOTECHNOLOGY": 2.141,
  "FETAL DIAGNOSIS AND THERAPY": 2.14,
  "JOURNAL OF ENVIRONMENTAL EDUCATION": 2.14,
  "JOURNAL OF MICROENCAPSULATION": 2.14,
  "ALCOHOL": 2.14,
  "MEDICAL & BIOLOGICAL ENGINEERING & COMPUTING": 2.139,
  "PUBLIC HEALTH REPORTS": 2.139,
  "JOURNAL OF CONSUMER AFFAIRS": 2.139,
  "JOURNAL OF FISH BIOLOGY": 2.138,
  "JOURNAL OF TURBULENCE": 2.138,
  "NEUROLOGIA": 2.138,
  "PREVENTING CHRONIC DISEASE": 2.137,
  "RUSSIAN MATHEMATICAL SURVEYS": 2.136,
  "TRANSLATIONAL NEUROSCIENCE": 2.135,
  "ANNALS OF GLOBAL HEALTH": 2.135,
  "PEDIATRIC ANESTHESIA": 2.135,
  "CONGENITAL HEART DISEASE": 2.134,
  "IET MICROWAVES ANTENNAS & PROPAGATION": 2.134,
  "PHYSICAL EDUCATION AND SPORT PEDAGOGY": 2.133,
  "ANIMAL HEALTH RESEARCH REVIEWS": 2.133,
  "ECONOMICS OF ENERGY & ENVIRONMENTAL POLICY": 2.133,
  "ORGANOGENESIS": 2.132,
  "JOURNAL OF BIOSCIENCE AND BIOENGINEERING": 2.13,
  "MOLECULAR DIVERSITY": 2.13,
  "RESEARCH QUARTERLY FOR EXERCISE AND SPORT": 2.13,
  "FRONTIERS IN PUBLIC HEALTH": 2.129,
  "INTERNATIONAL JOURNAL OF ENVIRONMENTAL SCIENCE AND TECHNOLOGY": 2.129,
  "BRACHYTHERAPY": 2.129,
  "JOURNAL OF CONTEMPORARY ASIA": 2.129,
  "JOURNAL OF EXPERIMENTAL PSYCHOLOGY-ANIMAL LEARNING AND COGNITION": 2.127,
  "JOURNAL OF ORAL PATHOLOGY & MEDICINE": 2.127,
  "JOURNALISM & MASS COMMUNICATION QUARTERLY": 2.126,
  "CURRENT ORGANIC CHEMISTRY": 2.126,
  "FRONTIERS IN VETERINARY SCIENCE": 2.126,
  "JOURNAL OF CIVIL ENGINEERING AND MANAGEMENT": 2.125,
  "NUTRITION AND CANCER-AN INTERNATIONAL JOURNAL": 2.125,
  "POLICY AND POLITICS": 2.125,
  "SWISS JOURNAL OF GEOSCIENCES": 2.125,
  "HEALTH ECONOMICS": 2.125,
  "JOURNAL OF THORACIC DISEASE": 2.125,
  "MEDICAL AND VETERINARY ENTOMOLOGY": 2.125,
  "OPERATIVE DENTISTRY": 2.125,
  "POULTRY SCIENCE": 2.124,
  "ANIMAL": 2.124,
  "INTERNATIONAL JOURNAL OF PHOTOENERGY": 2.124,
  "MAGAZINE OF CONCRETE RESEARCH": 2.123,
  "COMPOSITE INTERFACES": 2.122,
  "INTERNATIONAL ARCHIVES OF OCCUPATIONAL AND ENVIRONMENTAL HEALTH": 2.122,
  "JOURNAL OF BIOMECHANICAL ENGINEERING-TRANSACTIONS OF THE ASME": 2.122,
  "NUCLEAR MATERIALS AND ENERGY": 2.121,
  "EUROPEAN JOURNAL OF OBSTETRICS & GYNECOLOGY AND REPRODUCTIVE BIOLOGY": 2.121,
  "INTERNATIONAL JOURNAL OF TUBERCULOSIS AND LUNG DISEASE": 2.121,
  "JOURNAL OF SENSORS": 2.12,
  "REMOTE SENSING LETTERS": 2.12,
  "JOURNAL OF HYDROLOGY AND HYDROMECHANICS": 2.12,
  "CANCER NURSING": 2.119,
  "EUROPEAN JOURNAL OF MEDICAL GENETICS": 2.119,
  "PEDIATRIC RADIOLOGY": 2.118,
  "PROGRESS OF THEORETICAL AND EXPERIMENTAL PHYSICS": 2.118,
  "SOLID STATE NUCLEAR MAGNETIC RESONANCE": 2.116,
  "FIELD METHODS": 2.116,
  "INTERNATIONAL JOURNAL OF COAL PREPARATION AND UTILIZATION": 2.115,
  "JOURNAL OF INTELLIGENT & ROBOTIC SYSTEMS": 2.115,
  "JOURNAL OF MEDICINAL FOOD": 2.115,
  "JOURNAL ON MULTIMODAL USER INTERFACES": 2.115,
  "NURSING RESEARCH": 2.113,
  "PAPERS IN REGIONAL SCIENCE": 2.113,
  "ETHICS": 2.113,
  "COMPUTER ASSISTED LANGUAGE LEARNING": 2.112,
  "JOURNAL OF PRODUCT AND BRAND MANAGEMENT": 2.112,
  "MARINE MAMMAL SCIENCE": 2.112,
  "JOURNAL OF NONLINEAR SCIENCE": 2.112,
  "PARASITOLOGY INTERNATIONAL": 2.111,
  "COASTAL ENGINEERING JOURNAL": 2.111,
  "INTERNATIONAL GAMBLING STUDIES": 2.11,
  "AMERICAN JOURNAL OF RHINOLOGY & ALLERGY": 2.11,
  "CREATIVITY AND INNOVATION MANAGEMENT": 2.109,
  "EUROPEAN JOURNAL OF COMMUNICATION": 2.108,
  "IET RADAR SONAR AND NAVIGATION": 2.108,
  "ILAR JOURNAL": 2.108,
  "INTERNATIONAL JOURNAL OF BEHAVIORAL DEVELOPMENT": 2.108,
  "WASTE MANAGEMENT & RESEARCH": 2.107,
  "BIOCHEMISTRY AND CELL BIOLOGY": 2.107,
  "JOURNAL OF RADIATION RESEARCH": 2.107,
  "BIOMEDICAL ENGINEERING ONLINE": 2.106,
  "SIAM JOURNAL ON APPLIED DYNAMICAL SYSTEMS": 2.106,
  "AMERICAN JOURNAL OF HEALTH-SYSTEM PHARMACY": 2.106,
  "EXPERIMENTAL ECONOMICS": 2.106,
  "HUMAN AND ECOLOGICAL RISK ASSESSMENT": 2.105,
  "MUTATION RESEARCH-FUNDAMENTAL AND MOLECULAR MECHANISMS OF MUTAGENESIS": 2.103,
  "MAGNETIC RESONANCE IMAGING CLINICS OF NORTH AMERICA": 2.103,
  "CURRENT APPLIED PHYSICS": 2.103,
  "GROUP DECISION AND NEGOTIATION": 2.102,
  "MENDELEEV COMMUNICATIONS": 2.102,
  "AMERICAN JOURNAL OF PRIMATOLOGY": 2.101,
  "BIOINTERPHASES": 2.101,
  "JOURNAL OF NANOPARTICLE RESEARCH": 2.101,
  "JOURNAL OF PALEOLIMNOLOGY": 2.101,
  "JOURNAL OF WOMENS HEALTH": 2.101,
  "JOURNAL OF PSYCHIATRIC AND MENTAL HEALTH NURSING": 2.101,
  "SYMBIOSIS": 2.1,
  "VETERINARY PARASITOLOGY": 2.098,
  "BEHAVIOURAL PROCESSES": 2.098,
  "PRIMARY CARE DIABETES": 2.098,
  "JOURNAL OF AGING AND HEALTH": 2.097,
  "CLINICAL NEUROPSYCHOLOGIST": 2.096,
  "CARDIOVASCULAR DIAGNOSIS AND THERAPY": 2.095,
  "INTERNATIONAL JOURNAL OF GYNECOLOGICAL PATHOLOGY": 2.095,
  "INTERNATIONAL JOURNAL OF HUMAN-COMPUTER STUDIES": 2.094,
  "JOURNAL OF SOIL SCIENCE AND PLANT NUTRITION": 2.094,
  "ASIAN JOURNAL OF CONTROL": 2.094,
  "EARTHQUAKE SPECTRA": 2.093,
  "IET IMAGE PROCESSING": 2.092,
  "INTERNATIONAL JOURNAL OF MODERN PHYSICS D": 2.092,
  "JOURNAL OF MATERIAL CYCLES AND WASTE MANAGEMENT": 2.092,
  "BMC MUSCULOSKELETAL DISORDERS": 2.092,
  "POLAR BIOLOGY": 2.091,
  "CANADIAN PSYCHOLOGY-PSYCHOLOGIE CANADIENNE": 2.09,
  "EXPERIMENTAL HEAT TRANSFER": 2.09,
  "EUROPEAN PHYSICAL EDUCATION REVIEW": 2.09,
  "EVIDENCE & POLICY": 2.089,
  "FOODBORNE PATHOGENS AND DISEASE": 2.089,
  "IEEE JOURNAL OF THE ELECTRON DEVICES SOCIETY": 2.089,
  "INTERNATIONAL JOURNAL OF HEAT AND FLUID FLOW": 2.089,
  "JOURNAL OF MATHEMATICAL SOCIOLOGY": 2.089,
  "JOURNAL OF MEDICAL BIOCHEMISTRY": 2.088,
  "LANGUAGE LEARNING": 2.088,
  "MYCOLOGICAL PROGRESS": 2.087,
  "NATURAL RESOURCES RESEARCH": 2.087,
  "PHYSICAL THERAPY IN SPORT": 2.087,
  "RESEARCH IN ENGINEERING DESIGN": 2.086,
  "SCHOOL MENTAL HEALTH": 2.086,
  "SOCIAL MOVEMENT STUDIES": 2.085,
  "TELECOMMUNICATIONS POLICY": 2.085,
  "TELLUS SERIES A-DYNAMIC METEOROLOGY AND OCEANOGRAPHY": 2.085,
  "THEORETICAL CRIMINOLOGY": 2.085,
  "WEED SCIENCE": 2.085,
  "NATURAL PRODUCT RESEARCH": 2.084,
  "PERSONALITY AND INDIVIDUAL DIFFERENCES": 2.084,
  "SOIL SCIENCE SOCIETY OF AMERICA JOURNAL": 2.083,
  "TRANSPORT IN POROUS MEDIA": 2.083,
  "TELEMEDICINE AND E-HEALTH": 2.083,
  "FEMS MICROBIOLOGY LETTERS": 2.082,
  "IBIS": 2.082,
  "JOURNAL OF CLINICAL AND EXPERIMENTAL NEUROPSYCHOLOGY": 2.082,
  "JOURNAL OF INVESTIGATIVE MEDICINE": 2.082,
  "MYCOSPHERE": 2.082,
  "PREGNANCY HYPERTENSION-AN INTERNATIONAL JOURNAL OF WOMENS CARDIOVASCULAR HEALTH": 2.081,
  "COMPARATIVE BIOCHEMISTRY AND PHYSIOLOGY B-BIOCHEMISTRY & MOLECULAR BIOLOGY": 2.081,
  "CANCER CONTROL": 2.081,
  "FORENSIC SCIENCE INTERNATIONAL": 2.081,
  "INTERNATIONAL JOURNAL OF SOCIAL RESEARCH METHODOLOGY": 2.081,
  "JOURNAL OF ELECTRONIC PACKAGING": 2.081,
  "VISCERAL MEDICINE": 2.08,
  "BEST PRACTICE & RESEARCH CLINICAL HAEMATOLOGY": 2.08,
  "ESAIM-MATHEMATICAL MODELLING AND NUMERICAL ANALYSIS-MODELISATION MATHEMATIQUE ET ANALYSE NUMERIQUE": 2.08,
  "JOURNAL OF FISH DISEASES": 2.079,
  "OCEANOLOGIA": 2.079,
  "TRANSPORTMETRICA A-TRANSPORT SCIENCE": 2.079,
  "FAMILY PRACTICE": 2.079,
  "INTERNATIONAL JOURNAL OF MENTAL HEALTH SYSTEMS": 2.078,
  "JOURNAL OF MANAGEMENT INQUIRY": 2.078,
  "JOURNAL OF SOL-GEL SCIENCE AND TECHNOLOGY": 2.077,
  "MECHANICS BASED DESIGN OF STRUCTURES AND MACHINES": 2.077,
  "SIAM JOURNAL ON CONTROL AND OPTIMIZATION": 2.077,
  "THEORETICAL ECOLOGY": 2.076,
  "CONTACT LENS & ANTERIOR EYE": 2.076,
  "METALLURGICAL AND MATERIALS TRANSACTIONS A-PHYSICAL METALLURGY AND MATERIALS SCIENCE": 2.076,
  "ANIMAL FRONTIERS": 2.076,
  "BRITISH JOURNAL OF INDUSTRIAL RELATIONS": 2.075,
  "CLIMATE RESEARCH": 2.075,
  "CONTRAST MEDIA & MOLECULAR IMAGING": 2.075,
  "EVIDENCE-BASED COMPLEMENTARY AND ALTERNATIVE MEDICINE": 2.075,
  "JOURNAL OF MATERIALS IN CIVIL ENGINEERING": 2.075,
  "MEMORY STUDIES": 2.075,
  "RADIATION PHYSICS AND CHEMISTRY": 2.075,
  "AGGRESSION AND VIOLENT BEHAVIOR": 2.073,
  "BMC PEDIATRICS": 2.073,
  "IEEE ELECTRICAL INSULATION MAGAZINE": 2.073,
  "JOURNAL OF ADVANCED TRANSPORTATION": 2.072,
  "NEUROLOGICAL RESEARCH": 2.072,
  "POLICY AND SOCIETY": 2.071,
  "INTERNATIONAL JOURNAL OF APPROXIMATE REASONING": 2.071,
  "JOURNAL OF MATERIALS RESEARCH": 2.071,
  "MEDICINA INTENSIVA": 2.071,
  "ANXIETY STRESS AND COPING": 2.071,
  "CALCOLO": 2.07,
  "EMERGENCY MEDICINE CLINICS OF NORTH AMERICA": 2.069,
  "JOURNAL OF FORESTRY": 2.067,
  "MEDICAL SCIENCE MONITOR": 2.067,
  "PROTEIN ENGINEERING DESIGN & SELECTION": 2.067,
  "ROAD MATERIALS AND PAVEMENT DESIGN": 2.067,
  "COMPLEMENTARY THERAPIES IN MEDICINE": 2.066,
  "CURRENT OPINION IN CARDIOLOGY": 2.066,
  "ACTA NEUROPSYCHIATRICA": 2.066,
  "ARCHAEOLOGICAL AND ANTHROPOLOGICAL SCIENCES": 2.066,
  "CLINICAL BIOMECHANICS": 2.065,
  "FLOW MEASUREMENT AND INSTRUMENTATION": 2.064,
  "JOURNAL OF BIOACTIVE AND COMPATIBLE POLYMERS": 2.064,
  "JOURNAL OF PSYCHOPATHOLOGY AND BEHAVIORAL ASSESSMENT": 2.064,
  "PHYCOLOGIA": 2.064,
  "POPULATION AND ENVIRONMENT": 2.063,
  "JOURNAL OF MICROBIOLOGY AND BIOTECHNOLOGY": 2.063,
  "TRIALS": 2.063,
  "ARDEOLA-INTERNATIONAL JOURNAL OF ORNITHOLOGY": 2.063,
  "PHYTOPATHOLOGIA MEDITERRANEA": 2.061,
  "APPLIED OPTICS": 2.061,
  "ARCHIVES OF ORTHOPAEDIC AND TRAUMA SURGERY": 2.061,
  "MICROGRAVITY SCIENCE AND TECHNOLOGY": 2.061,
  "MODERN RHEUMATOLOGY": 2.061,
  "VLDB JOURNAL": 2.061,
  "JOURNAL OF EXPERIMENTAL PSYCHOLOGY-APPLIED": 2.06,
  "JOURNAL OF THE ROYAL ANTHROPOLOGICAL INSTITUTE": 2.059,
  "NETHERLANDS HEART JOURNAL": 2.059,
  "AMERICAN JOURNAL OF INFECTION CONTROL": 2.058,
  "CLINICAL AND EXPERIMENTAL NEPHROLOGY": 2.058,
  "JOURNAL OF NEUROPSYCHIATRY AND CLINICAL NEUROSCIENCES": 2.057,
  "INTERNATIONAL JOURNAL OF SEDIMENT RESEARCH": 2.057,
  "JOURNAL OF ADVERTISING RESEARCH": 2.056,
  "LEISURE SCIENCES": 2.056,
  "PATHOGENS AND GLOBAL HEALTH": 2.056,
  "PHYSICS AND CHEMISTRY OF THE EARTH": 2.056,
  "REVISTA DE SAUDE PUBLICA": 2.056,
  "NEW LEFT REVIEW": 2.056,
  "JOURNAL OF ELECTROCERAMICS": 2.056,
  "JOURNAL OF APPLIED RESEARCH ON MEDICINAL AND AROMATIC PLANTS": 2.056,
  "JOURNAL OF NATURAL MEDICINES": 2.055,
  "MATHEMATICAL GEOSCIENCES": 2.055,
  "WORLD JOURNAL OF SURGICAL ONCOLOGY": 2.054,
  "CRIME & DELINQUENCY": 2.054,
  "PALLIATIVE & SUPPORTIVE CARE": 2.053,
  "HUMAN DEVELOPMENT": 2.053,
  "PHYSICAL REVIEW PHYSICS EDUCATION RESEARCH": 2.053,
  "TOPICS IN STROKE REHABILITATION": 2.052,
  "JOURNAL OF COMPARATIVE POLICY ANALYSIS": 2.051,
  "MANAGEMENT DECISION": 2.051,
  "PHYTOCHEMICAL ANALYSIS": 2.051,
  "PROCESSES": 2.051,
  "REDOX REPORT": 2.051,
  "AMERICAN JOURNAL OF CLINICAL PATHOLOGY": 2.051,
  "AMERICAN JOURNAL OF THE MEDICAL SCIENCES": 2.05,
  "BIOLOGY OPEN": 2.05,
  "CANCER INVESTIGATION": 2.05,
  "JOURNAL OF SCHOOL VIOLENCE": 2.05,
  "SPORT EDUCATION AND SOCIETY": 2.049,
  "AVIAN PATHOLOGY": 2.048,
  "ENERGY EFFICIENCY": 2.048,
  "INTERNATIONAL JOURNAL OF ORAL AND MAXILLOFACIAL SURGERY": 2.048,
  "JOURNAL DE MATHEMATIQUES PURES ET APPLIQUEES": 2.048,
  "JOURNAL OF BUSINESS & INDUSTRIAL MARKETING": 2.048,
  "OPTICS COMMUNICATIONS": 2.047,
  "RESEARCH IN HIGHER EDUCATION": 2.047,
  "SCIENTIA HORTICULTURAE": 2.047,
  "BIOLOGICALS": 2.047,
  "DECISION SCIENCES": 2.046,
  "ENVIRONMENTAL MONITORING AND ASSESSMENT": 2.046,
  "FEBS OPEN BIO": 2.046,
  "HEALTH ECONOMICS POLICY AND LAW": 2.046,
  "SURGICAL CLINICS OF NORTH AMERICA": 2.046,
  "INTERNATIONAL JOURNAL OF NUMERICAL METHODS FOR HEAT & FLUID FLOW": 2.046,
  "INTERNATIONAL JOURNAL OF OBSTETRIC ANESTHESIA": 2.046,
  "INTERNATIONAL POLITICAL SOCIOLOGY": 2.045,
  "PARASITE": 2.045,
  "SOIL USE AND MANAGEMENT": 2.044,
  "CHILDHOOD-A GLOBAL JOURNAL OF CHILD RESEARCH": 2.043,
  "EUROPEAN ADDICTION RESEARCH": 2.043,
  "NURSING ETHICS": 2.043,
  "PHOTONICS AND NANOSTRUCTURES-FUNDAMENTALS AND APPLICATIONS": 2.043,
  "WOMENS HEALTH ISSUES": 2.043,
  "INTERNATIONAL JOURNAL OF HIGH PERFORMANCE COMPUTING APPLICATIONS": 2.043,
  "MULTIMEDIA SYSTEMS": 2.042,
  "RESEARCH ON LANGUAGE AND SOCIAL INTERACTION": 2.042,
  "TRANSACTIONS OF THE INSTITUTE OF MEASUREMENT AND CONTROL": 2.042,
  "EDUCATIONAL POLICY": 2.041,
  "GEOGRAPHICAL ANALYSIS": 2.04,
  "INTERNATIONAL JOURNAL OF BEHAVIORAL MEDICINE": 2.04,
  "JOURNAL OF CULTURAL HERITAGE": 2.04,
  "JOURNAL OF STORED PRODUCTS RESEARCH": 2.04,
  "RIVER RESEARCH AND APPLICATIONS": 2.039,
  "ADVANCES IN HIGH ENERGY PHYSICS": 2.039,
  "NUMERICAL HEAT TRANSFER PART A-APPLICATIONS": 2.039,
  "AMERICAN JOURNAL OF OCCUPATIONAL THERAPY": 2.039,
  "COMPARATIVE EDUCATION REVIEW": 2.038,
  "METALLURGICAL AND MATERIALS TRANSACTIONS B-PROCESS METALLURGY AND MATERIALS PROCESSING SCIENCE": 2.038,
  "MINERVA": 2.038,
  "QUATERNARY INTERNATIONAL": 2.038,
  "AIAA JOURNAL": 2.038,
  "CONSUMPTION MARKETS & CULTURE": 2.038,
  "BIOCHIP JOURNAL": 2.038,
  "MEMORY & COGNITION": 2.038,
  "GEOLOGICAL JOURNAL": 2.037,
  "JOURNAL OF ECONOMETRICS": 2.037,
  "SOCIETY & NATURAL RESOURCES": 2.036,
  "JOURNAL OF WOUND CARE": 2.036,
  "RANGELAND ECOLOGY & MANAGEMENT": 2.035,
  "BMC CARDIOVASCULAR DISORDERS": 2.034,
  "JOURNAL OF CELLULAR PLASTICS": 2.034,
  "JOURNAL OF POROUS MATERIALS": 2.034,
  "AMERICAN JOURNAL ON ADDICTIONS": 2.032,
  "APPLIED PSYCHOLOGY-HEALTH AND WELL BEING": 2.032,
  "COLLEGE & RESEARCH LIBRARIES": 2.032,
  "DRUG AND CHEMICAL TOXICOLOGY": 2.032,
  "ENERGY EXPLORATION & EXPLOITATION": 2.031,
  "IEEE TRANSACTIONS ON VERY LARGE SCALE INTEGRATION (VLSI) SYSTEMS": 2.031,
  "POSTGRADUATE MEDICAL JOURNAL": 2.031,
  "SCIENTIFIC AMERICAN": 2.03,
  "BIOELECTROMAGNETICS": 2.03,
  "MICROSURGERY": 2.03,
  "JOURNAL OF REGIONAL SCIENCE": 2.03,
  "GLOBAL PUBLIC HEALTH": 2.03,
  "JOURNAL OF NUTRIGENETICS AND NUTRIGENOMICS": 2.03,
  "JOURNAL OF CRANIO-MAXILLOFACIAL SURGERY": 2.029,
  "MOLECULAR IMAGING": 2.029,
  "READING AND WRITING": 2.029,
  "REVIEW OF FINANCE": 2.029,
  "SOCIAL ANTHROPOLOGY": 2.028,
  "JOURNAL OF INTELLECTUAL DISABILITY RESEARCH": 2.028,
  "JOURNAL OF LEGAL ANALYSIS": 2.027,
  "ENDOCRINE JOURNAL": 2.027,
  "ELECTRONIC COMMERCE RESEARCH": 2.027,
  "GEO-MARINE LETTERS": 2.027,
  "JOURNAL OF MATHEMATICAL BIOLOGY": 2.027,
  "MULTISCALE MODELING & SIMULATION": 2.027,
  "ROMANIAN REPORTS IN PHYSICS": 2.026,
  "THEORETICAL AND COMPUTATIONAL FLUID DYNAMICS": 2.026,
  "BRITISH JOURNAL OF RADIOLOGY": 2.026,
  "CELL AND TISSUE BANKING": 2.025,
  "INTERNATIONAL JOURNAL OF APPLIED MECHANICS": 2.025,
  "JOURNAL OF ANTHROPOLOGICAL ARCHAEOLOGY": 2.025,
  "VECTOR-BORNE AND ZOONOTIC DISEASES": 2.025,
  "APPLIED ECONOMIC PERSPECTIVES AND POLICY": 2.024,
  "INTERNATIONAL JOURNAL OF RHEUMATIC DISEASES": 2.024,
  "JOURNAL OF DIFFERENTIAL EQUATIONS": 2.024,
  "MATERIALS SCIENCE AND TECHNOLOGY": 2.024,
  "ENGINEERING IN LIFE SCIENCES": 2.023,
  "ANTICANCER RESEARCH": 2.022,
  "JOURNAL OF HUMAN HYPERTENSION": 2.022,
  "MANAGEMENT LEARNING": 2.022,
  "MRS COMMUNICATIONS": 2.022,
  "TRANSPORTATION JOURNAL": 2.022,
  "ANTONIE VAN LEEUWENHOEK INTERNATIONAL JOURNAL OF GENERAL AND MOLECULAR MICROBIOLOGY": 2.022,
  "PERITONEAL DIALYSIS INTERNATIONAL": 2.02,
  "ANDEAN GEOLOGY": 2.02,
  "ENVIRONMENTAL VALUES": 2.02,
  "ANNALES SCIENTIFIQUES DE L ECOLE NORMALE SUPERIEURE": 2.02,
  "ASIAN JOURNAL OF PSYCHIATRY": 2.02,
  "BMC HEALTH SERVICES RESEARCH": 2.02,
  "COGNITIVE AND BEHAVIORAL PRACTICE": 2.02,
  "AEROBIOLOGIA": 2.02,
  "BIOCHEMICAL GENETICS": 2.019,
  "INTERACTIVE CARDIOVASCULAR AND THORACIC SURGERY": 2.018,
  "QUARTERLY JOURNAL OF NUCLEAR MEDICINE AND MOLECULAR IMAGING": 2.018,
  "SOFTWARE-PRACTICE & EXPERIENCE": 2.018,
  "BRITISH JOURNAL OF MATHEMATICAL & STATISTICAL PSYCHOLOGY": 2.017,
  "SYSTEM": 2.017,
  "DISCOVERY MEDICINE": 2.016,
  "INTERACTIVE LEARNING ENVIRONMENTS": 2.016,
  "JOURNAL OF VIBRATION AND ACOUSTICS-TRANSACTIONS OF THE ASME": 2.015,
  "CARDIOVASCULAR AND INTERVENTIONAL RADIOLOGY": 2.015,
  "HUMAN MOVEMENT SCIENCE": 2.015,
  "INFORMATICA": 2.015,
  "ONLINE INFORMATION REVIEW": 2.015,
  "CHIRALITY": 2.015,
  "EXPERIMENTAL AND CLINICAL ENDOCRINOLOGY & DIABETES": 2.015,
  "IEEE TRANSACTIONS ON NANOBIOSCIENCE": 2.014,
  "INTERNATIONAL JOURNAL OF THE COMMONS": 2.014,
  "POLICY AND INTERNET": 2.013,
  "JOURNAL OF MEDICAL MICROBIOLOGY": 2.013,
  "PSYCHOLOGY OF MEN & MASCULINITY": 2.012,
  "ACTA SOCIOLOGICA": 2.012,
  "IET NANOBIOTECHNOLOGY": 2.012,
  "NONPROFIT AND VOLUNTARY SECTOR QUARTERLY": 2.011,
  "MEN AND MASCULINITIES": 2.011,
  "CIRCUITS SYSTEMS AND SIGNAL PROCESSING": 2.01,
  "EXPERIMENTAL AND CLINICAL PSYCHOPHARMACOLOGY": 2.01,
  "GENES TO CELLS": 2.01,
  "GLAND SURGERY": 2.009,
  "INTERNATIONAL JOURNAL OF PRIMATOLOGY": 2.009,
  "INTERNATIONAL JOURNAL OF EDUCATIONAL TECHNOLOGY IN HIGHER EDUCATION": 2.009,
  "JOURNAL OF PHARMACY AND PHARMACEUTICAL SCIENCES": 2.009,
  "MICROBIOLOGY-SGM": 2.009,
  "FINANCE AND STOCHASTICS": 2.009,
  "SURGICAL INFECTIONS": 2.009,
  "POLYMER ENGINEERING AND SCIENCE": 2.009,
  "AGING NEUROPSYCHOLOGY AND COGNITION": 2.009,
  "JOURNAL OF MOLECULAR RECOGNITION": 2.009,
  "VETERINARY JOURNAL": 2.008,
  "CHILD CARE HEALTH AND DEVELOPMENT": 2.008,
  "ENVIRONMENTAL TECHNOLOGY": 2.008,
  "BIOMEDICAL AND ENVIRONMENTAL SCIENCES": 2.007,
  "IMF ECONOMIC REVIEW": 2.006,
  "JOURNAL OF BROADCASTING & ELECTRONIC MEDIA": 2.006,
  "NONPROFIT MANAGEMENT & LEADERSHIP": 2.006,
  "CURRENT OPINION IN SUPPORTIVE AND PALLIATIVE CARE": 2.006,
  "IMPACT ASSESSMENT AND PROJECT APPRAISAL": 2.006,
  "INTERNATIONAL PUBLIC MANAGEMENT JOURNAL": 2.006,
  "INLAND WATERS": 2.006,
  "OPTIK": 2.005,
  "HEALTH PROMOTION INTERNATIONAL": 2.005,
  "JOURNAL OF FLUORESCENCE": 2.004,
  "JOURNAL OF IMMUNOLOGICAL METHODS": 2.004,
  "NEPHROLOGY": 2.004,
  "PHOTOMEDICINE AND LASER SURGERY": 2.002,
  "PHYSICS OF PLASMAS": 2.002,
  "SIAM JOURNAL ON MATRIX ANALYSIS AND APPLICATIONS": 2,
  "WOOD SCIENCE AND TECHNOLOGY": 2,
  "AMERICAN JOURNAL OF ORTHODONTICS AND DENTOFACIAL ORTHOPEDICS": 2,
  "AUSTRALIAN AND NEW ZEALAND JOURNAL OF PUBLIC HEALTH": 2,
  "CHINESE JOURNAL OF CHEMICAL ENGINEERING": 2,
  "DIABETES EDUCATOR": 2,
  "HEALTH SECURITY": 2,
  "JOURNAL OF AMBIENT INTELLIGENCE AND HUMANIZED COMPUTING": 2,
  "AMERICAN JOURNAL OF PHYSICAL MEDICINE & REHABILITATION": 2,
  "BEHAVIOURAL NEUROLOGY": 2,
  "JOURNAL OF HYDROINFORMATICS": 2,
  "CHINESE OPTICS LETTERS": 2,
  "JOURNAL OF MEDICAL ENTOMOLOGY": 2,
  "JOURNAL OF REHABILITATION MEDICINE": 2,
  "JOURNAL OF ORTHOPAEDIC SURGERY AND RESEARCH": 2,
  "COLLOID AND POLYMER SCIENCE": 2,
  "COMPUTATIONAL OPTIMIZATION AND APPLICATIONS": 2,
  "JOURNAL OF ELASTICITY": 2,
  "JOURNAL OF CHOICE MODELLING": 2,
  "STEREOTACTIC AND FUNCTIONAL NEUROSURGERY": 2,
  "EUROPEAN JOURNAL OF REMOTE SENSING": 2,
  "MARINE GENOMICS": 2,
  "AMERICAN JOURNAL OF INDUSTRIAL MEDICINE": 1.999,
  "JOURNAL OF THERMAL BIOLOGY": 1.997,
  "JOURNAL OF FINANCIAL ECONOMETRICS": 1.997,
  "LANDSCAPE RESEARCH": 1.997,
  "PM&R": 1.996,
  "SPATIAL ECONOMIC ANALYSIS": 1.994,
  "XENOBIOTICA": 1.994,
  "CHEMICAL PHYSICS LETTERS": 1.994,
  "ENERGY SUSTAINABILITY AND SOCIETY": 1.994,
  "EUROPEAN JOURNAL OF WOOD AND WOOD PRODUCTS": 1.994,
  "JOURNAL OF TRAUMA & DISSOCIATION": 1.992,
  "ACM TRANSACTIONS ON DATABASE SYSTEMS": 1.992,
  "NEW YORK UNIVERSITY LAW REVIEW": 1.99,
  "THEORY AND SOCIETY": 1.99,
  "TRANSFUSION MEDICINE": 1.99,
  "INTERNATIONAL NEUROUROLOGY JOURNAL": 1.99,
  "LANGUAGE": 1.99,
  "AMERICAN JOURNAL OF ORTHOPSYCHIATRY": 1.989,
  "SPINAL CORD": 1.988,
  "JCR-JOURNAL OF CLINICAL RHEUMATOLOGY": 1.988,
  "AGEING & SOCIETY": 1.988,
  "APPLIED MATHEMATICS AND OPTIMIZATION": 1.988,
  "ARCHIVES OF MEDICAL RESEARCH": 1.988,
  "ANNALS OF HEPATOLOGY": 1.988,
  "FRONTIERS IN PHYSICS": 1.986,
  "HEART FAILURE CLINICS": 1.986,
  "IET SCIENCE MEASUREMENT & TECHNOLOGY": 1.986,
  "CANCER BIOTHERAPY AND RADIOPHARMACEUTICALS": 1.986,
  "JOURNAL OF THE CHINESE MEDICAL ASSOCIATION": 1.986,
  "SIGNAL IMAGE AND VIDEO PROCESSING": 1.986,
  "ANNALS OF CLINICAL BIOCHEMISTRY": 1.986,
  "INTERNATIONAL JOURNAL OF POLYMER SCIENCE": 1.985,
  "SKIN PHARMACOLOGY AND PHYSIOLOGY": 1.985,
  "SEXUALITY RESEARCH AND SOCIAL POLICY": 1.984,
  "JOURNAL OF FAMILY NURSING": 1.984,
  "JOURNAL OF CONTEXTUAL BEHAVIORAL SCIENCE": 1.984,
  "COMPUTERS AND CONCRETE": 1.984,
  "JOURNAL OF INTEGRATIVE ENVIRONMENTAL SCIENCES": 1.984,
  "TOBACCO INDUCED DISEASES": 1.984,
  "ENVIRONMENTAL POLICY AND GOVERNANCE": 1.984,
  "THIN SOLID FILMS": 1.984,
  "AQUACULTURE REPORTS": 1.983,
  "BIOCHEMISTRY-MOSCOW": 1.983,
  "EPL": 1.983,
  "JOURNAL OF LITERACY RESEARCH": 1.983,
  "MATERIALES DE CONSTRUCCION": 1.983,
  "MEDIA CULTURE & SOCIETY": 1.983,
  "CURRENT PROTEIN & PEPTIDE SCIENCE": 1.982,
  "JOURNAL OF MEDICAL ECONOMICS": 1.982,
  "JOURNAL OF THE AMERICAN ACADEMY OF PSYCHIATRY AND THE LAW": 1.982,
  "SERVICE SCIENCE": 1.981,
  "STRUCTURAL CONCRETE": 1.981,
  "WATER INTERNATIONAL": 1.98,
  "DIGESTIVE SURGERY": 1.98,
  "JOURNAL OF INDUSTRIAL TEXTILES": 1.98,
  "BRITISH JOURNAL OF SOCIOLOGY OF EDUCATION": 1.98,
  "JOURNAL OF COMPUTATIONAL AND APPLIED MATHEMATICS": 1.98,
  "JOURNAL OF NEUROSURGICAL SCIENCES": 1.979,
  "CHINA COMMUNICATIONS": 1.979,
  "GEOARCHAEOLOGY-AN INTERNATIONAL JOURNAL": 1.978,
  "HOUSING STUDIES": 1.978,
  "JOURNAL OF CARDIOTHORACIC AND VASCULAR ANESTHESIA": 1.978,
  "JOURNAL OF COMPARATIVE PHYSIOLOGY A-NEUROETHOLOGY SENSORY NEURAL AND BEHAVIORAL PHYSIOLOGY": 1.977,
  "JOURNAL OF COMPUTATIONAL AND GRAPHICAL STATISTICS": 1.977,
  "PSYCHOLOGY & MARKETING": 1.976,
  "ROFO-FORTSCHRITTE AUF DEM GEBIET DER RONTGENSTRAHLEN UND DER BILDGEBENDEN VERFAHREN": 1.976,
  "ELECTRONIC MATERIALS LETTERS": 1.976,
  "JOURNAL OF WILDLIFE MANAGEMENT": 1.976,
  "PACKAGING TECHNOLOGY AND SCIENCE": 1.975,
  "ACADEMIC PSYCHIATRY": 1.975,
  "ANGLE ORTHODONTIST": 1.974,
  "BUSINESS PROCESS MANAGEMENT JOURNAL": 1.974,
  "JOURNAL OF WOOD CHEMISTRY AND TECHNOLOGY": 1.973,
  "REPRODUCTIVE BIOLOGY": 1.973,
  "BRAZILIAN JOURNAL OF PHYSICAL THERAPY": 1.973,
  "COMPUTING IN SCIENCE & ENGINEERING": 1.973,
  "ISLETS": 1.973,
  "JOURNAL OF ZHEJIANG UNIVERSITY-SCIENCE B": 1.972,
  "ACTA CRYSTALLOGRAPHICA A-FOUNDATION AND ADVANCES": 1.972,
  "EXPERIMENTAL BRAIN RESEARCH": 1.972,
  "COOPERATION AND CONFLICT": 1.971,
  "EUROPEAN CYTOKINE NETWORK": 1.971,
  "GAIA-ECOLOGICAL PERSPECTIVES FOR SCIENCE AND SOCIETY": 1.971,
  "JOURNAL OF ADHESIVE DENTISTRY": 1.97,
  "JOURNAL OF THEORETICAL BIOLOGY": 1.969,
  "RADIOLOGIC CLINICS OF NORTH AMERICA": 1.969,
  "STRESS AND HEALTH": 1.969,
  "DRUG METABOLISM AND PHARMACOKINETICS": 1.968,
  "PHYSICA B-CONDENSED MATTER": 1.968,
  "PHYSICIAN AND SPORTSMEDICINE": 1.968,
  "SURGEON-JOURNAL OF THE ROYAL COLLEGES OF SURGEONS OF EDINBURGH AND IRELAND": 1.967,
  "CARBOHYDRATE RESEARCH": 1.966,
  "EUROPEAN JOURNAL OF ENVIRONMENTAL AND CIVIL ENGINEERING": 1.966,
  "PHYSIOLOGICAL AND BIOCHEMICAL ZOOLOGY": 1.966,
  "PSYCHIATRY-INTERPERSONAL AND BIOLOGICAL PROCESSES": 1.966,
  "ACM TRANSACTIONS ON MODELING AND COMPUTER SIMULATION": 1.966,
  "JOURNAL OF SURGICAL RESEARCH": 1.965,
  "OR SPECTRUM": 1.965,
  "RESEARCH IN DEVELOPMENTAL DISABILITIES": 1.964,
  "COMPARATIVE IMMUNOLOGY MICROBIOLOGY AND INFECTIOUS DISEASES": 1.964,
  "ENVIRONMENTAL EARTH SCIENCES": 1.964,
  "INTERNATIONAL JOURNAL OF OFFENDER THERAPY AND COMPARATIVE CRIMINOLOGY": 1.964,
  "ONCOLOGY LETTERS": 1.963,
  "BMC MEDICAL EDUCATION": 1.963,
  "COLLOID AND INTERFACE SCIENCE COMMUNICATIONS": 1.963,
  "HEALTH PROMOTION AND CHRONIC DISEASE PREVENTION IN CANADA-RESEARCH POLICY AND PRACTICE": 1.963,
  "INTERNATIONAL JOURNAL OF STEM CELLS": 1.963,
  "JOURNAL OF COMPUTING IN HIGHER EDUCATION": 1.962,
  "MEDICINE": 1.962,
  "MORAVIAN GEOGRAPHICAL REPORTS": 1.962,
  "RURAL SOCIOLOGY": 1.962,
  "CLINICS IN LABORATORY MEDICINE": 1.962,
  "OCEAN DYNAMICS": 1.962,
  "JOURNAL OF ALTERNATIVE AND COMPLEMENTARY MEDICINE": 1.962,
  "MIRES AND PEAT": 1.961,
  "COMPTES RENDUS BIOLOGIES": 1.961,
  "IEEE TRANSACTIONS ON ENGINEERING MANAGEMENT": 1.961,
  "JOURNAL OF CONTEMPORARY CHINA": 1.961,
  "OIL & GAS SCIENCE AND TECHNOLOGY-REVUE D IFP ENERGIES NOUVELLES": 1.961,
  "CORROSION": 1.961,
  "INTERNATIONAL JOURNAL OF HYPERTENSION": 1.961,
  "JOURNAL OF PSYCHOACTIVE DRUGS": 1.961,
  "JOURNAL OF VACATION MARKETING": 1.961,
  "PACIFIC REVIEW": 1.96,
  "REVIEW OF POLICY RESEARCH": 1.96,
  "APPLIED IMMUNOHISTOCHEMISTRY & MOLECULAR MORPHOLOGY": 1.959,
  "JOURNAL OF MOLECULAR GRAPHICS & MODELLING": 1.959,
  "CURRENT ONCOLOGY": 1.959,
  "MOLECULAR BREEDING": 1.959,
  "METHODS IN ENZYMOLOGY": 1.958,
  "TREE GENETICS & GENOMES": 1.958,
  "JOURNAL OF THE OPTICAL SOCIETY OF AMERICA A-OPTICS IMAGE SCIENCE AND VISION": 1.958,
  "MEASUREMENT SCIENCE AND TECHNOLOGY": 1.958,
  "UROLOGY": 1.958,
  "VIBRATIONAL SPECTROSCOPY": 1.957,
  "IEEE TRANSACTIONS ON COMPONENTS PACKAGING AND MANUFACTURING TECHNOLOGY": 1.957,
  "INFORMATION SOCIETY": 1.957,
  "INTERNATIONAL JOURNAL OF CARDIOVASCULAR IMAGING": 1.957,
  "JOURNAL OF NONVERBAL BEHAVIOR": 1.957,
  "JOURNAL FUR DIE REINE UND ANGEWANDTE MATHEMATIK": 1.957,
  "JOURNAL OF NERVOUS AND MENTAL DISEASE": 1.957,
  "MARINE AND FRESHWATER RESEARCH": 1.956,
  "MATERIALS TODAY COMMUNICATIONS": 1.956,
  "INVERSE PROBLEMS": 1.956,
  "JOURNAL OF THE AIR & WASTE MANAGEMENT ASSOCIATION": 1.956,
  "POLYMER BULLETIN": 1.955,
  "REVISTA ESPANOLA DE ENFERMEDADES DIGESTIVAS": 1.955,
  "COMPUTER SPEECH AND LANGUAGE": 1.955,
  "WEED RESEARCH": 1.955,
  "CLEVELAND CLINIC JOURNAL OF MEDICINE": 1.954,
  "CONSCIOUSNESS AND COGNITION": 1.954,
  "DEVELOPMENTAL PSYCHOBIOLOGY": 1.953,
  "JOURNAL OF VASCULAR RESEARCH": 1.953,
  "JOURNAL OF BUSINESS ECONOMICS AND MANAGEMENT": 1.952,
  "JOURNAL OF ENVIRONMENTAL PLANNING AND MANAGEMENT": 1.952,
  "JOURNAL OF HYDRODYNAMICS": 1.952,
  "PHILOSOPHICAL MAGAZINE": 1.952,
  "AIDS EDUCATION AND PREVENTION": 1.952,
  "IRANIAN JOURNAL OF BASIC MEDICAL SCIENCES": 1.951,
  "WETLANDS": 1.951,
  "EARLY HUMAN DEVELOPMENT": 1.95,
  "EUROPEAN JOURNAL OF LIPID SCIENCE AND TECHNOLOGY": 1.95,
  "FOREST ECOSYSTEMS": 1.949,
  "INTERNATIONAL JOURNAL OF NEUROSCIENCE": 1.949,
  "CLUSTER COMPUTING-THE JOURNAL OF NETWORKS SOFTWARE TOOLS AND APPLICATIONS": 1.949,
  "MOLECULAR MEDICINE REPORTS": 1.949,
  "BRAZILIAN JOURNAL OF MEDICAL AND BIOLOGICAL RESEARCH": 1.948,
  "DEMOCRATIZATION": 1.948,
  "INFORMS JOURNAL ON COMPUTING": 1.947,
  "JOURNAL OF FOOD SCIENCE AND TECHNOLOGY-MYSORE": 1.947,
  "PHOTOGRAMMETRIE FERNERKUNDUNG GEOINFORMATION": 1.947,
  "SURFACE SCIENCE": 1.946,
  "LOCAL ENVIRONMENT": 1.946,
  "FRONTIERS OF MEDICINE": 1.946,
  "JOURNAL OF CHEMOMETRICS": 1.946,
  "JOURNAL OF CONTEMPORARY BRACHYTHERAPY": 1.946,
  "STATISTICS IN MEDICINE": 1.946,
  "CLINICAL AND APPLIED THROMBOSIS-HEMOSTASIS": 1.946,
  "HEALTH COMMUNICATION": 1.946,
  "JOURNAL OF FIELD ORNITHOLOGY": 1.945,
  "PETROLEUM SCIENCE": 1.945,
  "RADIOLOGY AND ONCOLOGY": 1.944,
  "VETERINARY IMMUNOLOGY AND IMMUNOPATHOLOGY": 1.943,
  "BIOPOLYMERS": 1.943,
  "INTERNATIONAL JOURNAL OF APPLIED GLASS SCIENCE": 1.942,
  "JOURNAL OF MARINE SCIENCE AND TECHNOLOGY": 1.942,
  "MOLECULAR GENETICS AND METABOLISM REPORTS": 1.942,
  "ARTHROPOD STRUCTURE & DEVELOPMENT": 1.942,
  "EVALUATION": 1.942,
  "APPLIED DEVELOPMENTAL SCIENCE": 1.941,
  "ASSESSING WRITING": 1.941,
  "CRITICAL REVIEWS IN EUKARYOTIC GENE EXPRESSION": 1.94,
  "CURRENT ORGANIC SYNTHESIS": 1.94,
  "EUROPEAN JOURNAL OF ORTHODONTICS": 1.94,
  "ANDROLOGIA": 1.94,
  "COMPTES RENDUS GEOSCIENCE": 1.94,
  "EARTH AND ENVIRONMENTAL SCIENCE TRANSACTIONS OF THE ROYAL SOCIETY OF EDINBURGH": 1.94,
  "HEART & LUNG": 1.94,
  "ISPRS INTERNATIONAL JOURNAL OF GEO-INFORMATION": 1.939,
  "JOURNAL OF BRIDGE ENGINEERING": 1.939,
  "PSYCHOLOGY RESEARCH AND BEHAVIOR MANAGEMENT": 1.939,
  "JOURNAL OF HEALTH POLITICS POLICY AND LAW": 1.939,
  "JOURNAL OF PLANT INTERACTIONS": 1.939,
  "MACROMOLECULAR THEORY AND SIMULATIONS": 1.938,
  "RESTORATIVE NEUROLOGY AND NEUROSCIENCE": 1.938,
  "SCIENCE OF NATURE": 1.938,
  "CELESTIAL MECHANICS & DYNAMICAL ASTRONOMY": 1.938,
  "JOURNAL OF RECONSTRUCTIVE MICROSURGERY": 1.938,
  "EUROPEAN CONSTITUTIONAL LAW REVIEW": 1.936,
  "JOURNAL OF COGNITION AND DEVELOPMENT": 1.935,
  "JOURNAL OF INTERNATIONAL FINANCIAL MARKETS INSTITUTIONS & MONEY": 1.935,
  "JOURNAL OF MAPS": 1.935,
  "SOUTHERN CALIFORNIA LAW REVIEW": 1.935,
  "CLAYS AND CLAY MINERALS": 1.935,
  "ELECTROMAGNETIC BIOLOGY AND MEDICINE": 1.934,
  "ACTA NEUROCHIRURGICA": 1.934,
  "INJURY-INTERNATIONAL JOURNAL OF THE CARE OF THE INJURED": 1.933,
  "HEALTHCARE-THE JOURNAL OF DELIVERY SCIENCE AND INNOVATION": 1.933,
  "INTERNATIONAL JOURNAL ON SEMANTIC WEB AND INFORMATION SYSTEMS": 1.932,
  "JOURNAL OF VACUUM SCIENCE & TECHNOLOGY A": 1.932,
  "PEDOBIOLOGIA": 1.932,
  "PROCEEDINGS OF THE JAPAN ACADEMY SERIES B-PHYSICAL AND BIOLOGICAL SCIENCES": 1.932,
  "WORLD BANK RESEARCH OBSERVER": 1.931,
  "ANIMALS": 1.931,
  "MECHANICS OF TIME-DEPENDENT MATERIALS": 1.931,
  "PATHOBIOLOGY": 1.931,
  "PSYCHOLOGY OF RELIGION AND SPIRITUALITY": 1.931,
  "SOLVENT EXTRACTION AND ION EXCHANGE": 1.93,
  "INTERNATIONAL REVIEW OF RESEARCH IN OPEN AND DISTRIBUTED LEARNING": 1.93,
  "MOLECULAR & CELLULAR TOXICOLOGY": 1.93,
  "CANADIAN JOURNAL OF EMERGENCY MEDICINE": 1.929,
  "INTERNATIONAL JOURNAL FOR QUALITY IN HEALTH CARE": 1.929,
  "JOURNAL OF PROFESSIONAL NURSING": 1.929,
  "JOURNAL OF BRAND MANAGEMENT": 1.928,
  "MULTISENSORY RESEARCH": 1.928,
  "ACTA METALLURGICA SINICA-ENGLISH LETTERS": 1.928,
  "EXPERT REVIEW OF PHARMACOECONOMICS & OUTCOMES RESEARCH": 1.928,
  "JOURNAL OF HEALTH POPULATION AND NUTRITION": 1.928,
  "REVIEWS ON ADVANCED MATERIALS SCIENCE": 1.928,
  "JOURNAL OF APPLIED ENTOMOLOGY": 1.927,
  "JOURNAL OF APPLIED DEVELOPMENTAL PSYCHOLOGY": 1.927,
  "JOURNAL OF ONCOLOGY PHARMACY PRACTICE": 1.927,
  "JOURNAL OF ORTHOPAEDIC TRAUMA": 1.927,
  "MODELLING AND SIMULATION IN MATERIALS SCIENCE AND ENGINEERING": 1.927,
  "GASTROENTEROLOGY RESEARCH AND PRACTICE": 1.926,
  "INTERNATIONAL JOURNAL OF SIMULATION MODELLING": 1.926,
  "JOURNAL OF ARID ENVIRONMENTS": 1.925,
  "JOURNAL OF CULTURAL ECONOMICS": 1.925,
  "LOCAL GOVERNMENT STUDIES": 1.925,
  "HIGHER EDUCATION RESEARCH & DEVELOPMENT": 1.923,
  "INDUSTRIAL AND CORPORATE CHANGE": 1.922,
  "OPTICAL FIBER TECHNOLOGY": 1.922,
  "OPTIMIZATION AND ENGINEERING": 1.922,
  "THERAPEUTICS AND CLINICAL RISK MANAGEMENT": 1.922,
  "EVOLUTIONARY PSYCHOLOGY": 1.922,
  "JOURNAL OF BIOSCIENCES": 1.922,
  "CHEMICAL PHYSICS": 1.922,
  "CLINICAL EEG AND NEUROSCIENCE": 1.922,
  "INTERNATIONAL JOURNAL OF INFORMATION SECURITY": 1.922,
  "INTERNATIONAL JOURNAL OF AUDIOLOGY": 1.921,
  "INTERNATIONAL JOURNAL OF PSYCHIATRY IN CLINICAL PRACTICE": 1.921,
  "JOURNAL OF FAMILY PLANNING AND REPRODUCTIVE HEALTH CARE": 1.921,
  "SWISS MEDICAL WEEKLY": 1.92,
  "EVOLUTION & DEVELOPMENT": 1.919,
  "JOURNAL OF ARTIFICIAL INTELLIGENCE RESEARCH": 1.919,
  "MATERIALS TECHNOLOGY": 1.919,
  "ADVANCES IN ATMOSPHERIC SCIENCES": 1.918,
  "JOURNAL OF PARALLEL AND DISTRIBUTED COMPUTING": 1.918,
  "JOURNAL OF THE ACOUSTICAL SOCIETY OF AMERICA": 1.918,
  "QUEST": 1.917,
  "COMPTES RENDUS PALEVOL": 1.917,
  "PHYSICAL BIOLOGY": 1.917,
  "ANIMAL REPRODUCTION SCIENCE": 1.917,
  "APPLIED ANIMAL BEHAVIOUR SCIENCE": 1.916,
  "ELECTORAL STUDIES": 1.915,
  "GLOBAL HEALTH ACTION": 1.915,
  "MINERVA ENDOCRINOLOGICA": 1.914,
  "TRANSGENIC RESEARCH": 1.914,
  "BMC ENDOCRINE DISORDERS": 1.913,
  "FINANCIAL ANALYSTS JOURNAL": 1.913,
  "PSYCHOPATHOLOGY": 1.913,
  "AGRICULTURAL AND FOREST ENTOMOLOGY": 1.913,
  "FORENSIC SCIENCE MEDICINE AND PATHOLOGY": 1.913,
  "INTERNATIONAL & COMPARATIVE LAW QUARTERLY": 1.913,
  "JOURNAL OF CHILD LANGUAGE": 1.913,
  "PLANETARY AND SPACE SCIENCE": 1.912,
  "SCHOOL EFFECTIVENESS AND SCHOOL IMPROVEMENT": 1.912,
  "GRASS AND FORAGE SCIENCE": 1.911,
  "JOURNAL FOR THE THEORY OF SOCIAL BEHAVIOUR": 1.911,
  "CLINICAL ANATOMY": 1.911,
  "COMMUNICATIONS IN COMPUTATIONAL PHYSICS": 1.911,
  "JOURNAL OF MICROSCOPY": 1.91,
  "ODONTOLOGY": 1.91,
  "PSYCHIATRISCHE PRAXIS": 1.91,
  "PUBLIC POLICY AND ADMINISTRATION": 1.91,
  "CULTURAL DIVERSITY & ETHNIC MINORITY PSYCHOLOGY": 1.908,
  "CURRENT NEUROVASCULAR RESEARCH": 1.908,
  "EUROPEAN JOURNAL OF MECHANICS B-FLUIDS": 1.908,
  "JOURNAL OF LATINA-O PSYCHOLOGY": 1.907,
  "KINDHEIT UND ENTWICKLUNG": 1.907,
  "BULLETIN OF ENTOMOLOGICAL RESEARCH": 1.907,
  "EUROPEAN JOURNAL OF ORAL SCIENCES": 1.907,
  "EUROPEAN JOURNAL OF INTERNATIONAL LAW": 1.906,
  "JOURNAL OF MATHEMATICAL CHEMISTRY": 1.906,
  "PHYSICA D-NONLINEAR PHENOMENA": 1.906,
  "ENGINEERING OPTIMIZATION": 1.905,
  "LEARNING AND INDIVIDUAL DIFFERENCES": 1.905,
  "CARBON LETTERS": 1.904,
  "SPE RESERVOIR EVALUATION & ENGINEERING": 1.904,
  "EKSPLOATACJA I NIEZAWODNOSC-MAINTENANCE AND RELIABILITY": 1.902,
  "SOCIAL DEVELOPMENT": 1.902,
  "WATER RESOURCES AND ECONOMICS": 1.902,
  "AGRONOMY JOURNAL": 1.902,
  "AIDS RESEARCH AND HUMAN RETROVIRUSES": 1.902,
  "JOURNAL OF PUBLIC POLICY": 1.902,
  "LETTERS IN APPLIED MICROBIOLOGY": 1.902,
  "OXIDATION OF METALS": 1.901,
  "EDUCATIONAL MANAGEMENT ADMINISTRATION & LEADERSHIP": 1.901,
  "JOURNAL OF TRAUMATIC STRESS": 1.901,
  "CANADIAN RESPIRATORY JOURNAL": 1.901,
  "HUMAN FERTILITY": 1.9,
  "JOURNAL OF MICROBIOLOGICAL METHODS": 1.9,
  "JOURNAL OF PROPULSION AND POWER": 1.9,
  "ANTI-CANCER DRUGS": 1.9,
  "ADVANCES IN GEOPHYSICS": 1.899,
  "CHEMICAL SPECIATION AND BIOAVAILABILITY": 1.899,
  "JOURNAL OF OCCUPATIONAL HEALTH": 1.898,
  "SUSTAINABLE COMPUTING-INFORMATICS & SYSTEMS": 1.898,
  "VETERINARY DERMATOLOGY": 1.897,
  "RESEARCH IN AUTISM SPECTRUM DISORDERS": 1.895,
  "TREES-STRUCTURE AND FUNCTION": 1.895,
  "PARLIAMENTARY AFFAIRS": 1.895,
  "RESEARCH IN TRANSPORTATION ECONOMICS": 1.895,
  "SOCIAL PSYCHOLOGY OF EDUCATION": 1.895,
  "TEACHERS AND TEACHING": 1.895,
  "DISASTERS": 1.895,
  "MENTAL HEALTH AND PHYSICAL ACTIVITY": 1.894,
  "WORLD BANK ECONOMIC REVIEW": 1.894,
  "ATMOSPHERIC SCIENCE LETTERS": 1.894,
  "BOTANICAL STUDIES": 1.893,
  "JOURNAL OF DEVELOPMENT EFFECTIVENESS": 1.892,
  "STATA JOURNAL": 1.892,
  "CONSERVATION & SOCIETY": 1.892,
  "ECS JOURNAL OF SOLID STATE SCIENCE AND TECHNOLOGY": 1.891,
  "INORGANIC CHEMISTRY COMMUNICATIONS": 1.891,
  "JOURNAL OF AGING AND PHYSICAL ACTIVITY": 1.89,
  "JOURNAL OF RISK AND INSURANCE": 1.889,
  "PROTEOME SCIENCE": 1.889,
  "QUALITATIVE INQUIRY": 1.889,
  "RESEARCH AND PRACTICE FOR PERSONS WITH SEVERE DISABILITIES": 1.889,
  "STARCH-STARKE": 1.888,
  "INTERNATIONAL JOURNAL OF DERMATOLOGY": 1.888,
  "PATHOLOGY RESEARCH AND PRACTICE": 1.887,
  "ATTENTION PERCEPTION & PSYCHOPHYSICS": 1.886,
  "EUROPEAN JOURNAL OF INNOVATION MANAGEMENT": 1.886,
  "AGROFORESTRY SYSTEMS": 1.886,
  "ANALYSIS AND MATHEMATICAL PHYSICS": 1.886,
  "BMC VETERINARY RESEARCH": 1.886,
  "JOURNAL OF OCULAR PHARMACOLOGY AND THERAPEUTICS": 1.885,
  "JOURNAL OF BEHAVIORAL DECISION MAKING": 1.885,
  "MATHEMATICS AND MECHANICS OF SOLIDS": 1.885,
  "REVIEW OF INTERNATIONAL STUDIES": 1.885,
  "JOURNAL OF ATMOSPHERIC AND SOLAR-TERRESTRIAL PHYSICS": 1.885,
  "ANNALS OF THE AMERICAN ACADEMY OF POLITICAL AND SOCIAL SCIENCE": 1.885,
  "PLANT ECOLOGY": 1.884,
  "ANALYTICAL CELLULAR PATHOLOGY": 1.884,
  "BEHAVIOURAL PHARMACOLOGY": 1.883,
  "MACHINE VISION AND APPLICATIONS": 1.883,
  "PHYSICAL REVIEW ACCELERATORS AND BEAMS": 1.883,
  "CLAY MINERALS": 1.882,
  "JOURNAL OF GASTRIC CANCER": 1.882,
  "3 BIOTECH": 1.882,
  "ARCHIVES OF ANIMAL NUTRITION": 1.882,
  "HOUSING POLICY DEBATE": 1.882,
  "JOURNAL OF REINFORCED PLASTICS AND COMPOSITES": 1.882,
  "JOURNAL OF ELECTRONIC COMMERCE RESEARCH": 1.882,
  "JOURNAL OF THE ROYAL STATISTICAL SOCIETY SERIES A-STATISTICS IN SOCIETY": 1.882,
  "JOURNAL OF SCIENCE EDUCATION AND TECHNOLOGY": 1.881,
  "MEDICAL ENGINEERING & PHYSICS": 1.881,
  "RARE METALS": 1.881,
  "APPLIED PHYSICS A-MATERIALS SCIENCE & PROCESSING": 1.88,
  "JOURNAL OF EARTH SCIENCE": 1.88,
  "AMERICAN JOURNAL OF ENOLOGY AND VITICULTURE": 1.88,
  "JOURNAL OF ATMOSPHERIC CHEMISTRY": 1.88,
  "EUROPEAN JOURNAL OF POLITICAL ECONOMY": 1.88,
  "FOREIGN LANGUAGE ANNALS": 1.879,
  "GAMES FOR HEALTH JOURNAL": 1.879,
  "JOURNAL OF MOLECULAR EVOLUTION": 1.879,
  "JOURNAL OF MONEY CREDIT AND BANKING": 1.879,
  "MOLECULAR SIMULATION": 1.878,
  "EUROPEAN JOURNAL OF TRAUMA AND EMERGENCY SURGERY": 1.878,
  "JOURNAL OF ORAL AND MAXILLOFACIAL SURGERY": 1.877,
  "OPHTHALMOLOGICA": 1.875,
  "BIOACOUSTICS-THE INTERNATIONAL JOURNAL OF ANIMAL SOUND AND ITS RECORDING": 1.875,
  "HEREDITARY CANCER IN CLINICAL PRACTICE": 1.875,
  "JOURNAL OF INTERNATIONAL MONEY AND FINANCE": 1.875,
  "JOURNAL OF THE EUROPEAN MATHEMATICAL SOCIETY": 1.875,
  "POLITICAL QUARTERLY": 1.875,
  "IET COMMUNICATIONS": 1.875,
  "INTERNATIONAL JOURNAL OF PRECISION ENGINEERING AND MANUFACTURING": 1.875,
  "JOURNAL OF ECONOMIC ENTOMOLOGY": 1.874,
  "SOCIOLOGICAL FORUM": 1.874,
  "ZOOLOGY": 1.874,
  "EXTREMES": 1.874,
  "IMAGE ANALYSIS & STEREOLOGY": 1.873,
  "AMERICAN JOURNAL OF COMMUNITY PSYCHOLOGY": 1.873,
  "HISTOLOGY AND HISTOPATHOLOGY": 1.873,
  "CARDIOVASCULAR ENGINEERING AND TECHNOLOGY": 1.873,
  "MICROSCOPY": 1.873,
  "BMC SURGERY": 1.872,
  "EUROPEAN JOURNAL OF SOCIAL PSYCHOLOGY": 1.872,
  "JOURNAL OF EMOTIONAL AND BEHAVIORAL DISORDERS": 1.872,
  "JOURNAL OF TEACHING IN PHYSICAL EDUCATION": 1.872,
  "JOURNAL OF INTERFERON AND CYTOKINE RESEARCH": 1.871,
  "JOURNAL OF SPORTS SCIENCE AND MEDICINE": 1.871,
  "QUARTERLY JOURNAL OF POLITICAL SCIENCE": 1.871,
  "WATER AIR AND SOIL POLLUTION": 1.871,
  "BRAZILIAN ORAL RESEARCH": 1.87,
  "CHINESE JOURNAL OF NATURAL MEDICINES": 1.87,
  "JOURNAL OF HEALTH COMMUNICATION": 1.87,
  "JOURNAL OF PUBLIC ECONOMICS": 1.87,
  "JOURNAL OF SEMANTICS": 1.87,
  "ASIA-PACIFIC JOURNAL OF ATMOSPHERIC SCIENCES": 1.87,
  "ASIAN PACIFIC JOURNAL OF TROPICAL MEDICINE": 1.87,
  "JOURNAL OF INTERPROFESSIONAL CARE": 1.87,
  "CLINICAL AND EXPERIMENTAL DERMATOLOGY": 1.87,
  "INTERNATIONAL REVIEW FOR THE SOCIOLOGY OF SPORT": 1.869,
  "NEOPLASMA": 1.869,
  "RENEWABLE AGRICULTURE AND FOOD SYSTEMS": 1.868,
  "WORLD WIDE WEB-INTERNET AND WEB INFORMATION SYSTEMS": 1.868,
  "APPLIED PHYSICS B-LASERS AND OPTICS": 1.867,
  "AUSTRAL ENTOMOLOGY": 1.867,
  "INTERNATIONAL POLITICAL SCIENCE REVIEW": 1.867,
  "JOURNAL OF APPLIED RESEARCH IN INTELLECTUAL DISABILITIES": 1.867,
  "BRITISH JOURNAL FOR THE PHILOSOPHY OF SCIENCE": 1.867,
  "EUROPEAN JOURNAL OF POPULATION-REVUE EUROPEENNE DE DEMOGRAPHIE": 1.865,
  "JOURNAL OF SCHOOL NURSING": 1.865,
  "INTERNAL MEDICINE JOURNAL": 1.865,
  "INTERNATIONAL JOURNAL OF BIOLOGICAL MARKERS": 1.865,
  "JOURNAL OF EDUCATIONAL AND BEHAVIORAL STATISTICS": 1.865,
  "YALE JOURNAL ON REGULATION": 1.864,
  "JOURNAL OF SURVEYING ENGINEERING": 1.863,
  "RUBBER CHEMISTRY AND TECHNOLOGY": 1.863,
  "CARDIOVASCULAR PATHOLOGY": 1.862,
  "COMPARE-A JOURNAL OF COMPARATIVE AND INTERNATIONAL EDUCATION": 1.862,
  "NORWEGIAN JOURNAL OF GEOLOGY": 1.862,
  "SOCIAL SCIENCE RESEARCH": 1.862,
  "ELECTRONICS": 1.861,
  "LEGAL AND CRIMINOLOGICAL PSYCHOLOGY": 1.861,
  "REAL ESTATE ECONOMICS": 1.861,
  "JOURNAL OF CHEMICAL EDUCATION": 1.861,
  "JOURNAL OF LEGAL STUDIES": 1.86,
  "JOURNAL OF GERIATRIC CARDIOLOGY": 1.86,
  "REVIEW OF INTERNATIONAL ORGANIZATIONS": 1.86,
  "SHIPS AND OFFSHORE STRUCTURES": 1.86,
  "THORACIC SURGERY CLINICS": 1.859,
  "JOURNAL OF INFRARED MILLIMETER AND TERAHERTZ WAVES": 1.859,
  "KNEE": 1.859,
  "JOURNAL OF FOREST ECONOMICS": 1.859,
  "SCANDINAVIAN JOURNAL OF PUBLIC HEALTH": 1.859,
  "APPLIED PSYCHOLINGUISTICS": 1.858,
  "EXPERIMENTAL AND APPLIED ACAROLOGY": 1.858,
  "JOURNAL OF BASIC MICROBIOLOGY": 1.858,
  "PEDIATRIC DRUGS": 1.858,
  "JOURNAL OF DIFFERENTIAL GEOMETRY": 1.857,
  "TRIBOLOGY TRANSACTIONS": 1.857,
  "YONSEI MEDICAL JOURNAL": 1.855,
  "ADMINISTRATIVE LAW REVIEW": 1.855,
  "CONTINUUM MECHANICS AND THERMODYNAMICS": 1.855,
  "MACROMOLECULAR RESEARCH": 1.855,
  "TRANSNATIONAL ENVIRONMENTAL LAW": 1.855,
  "JOURNAL OF CLINICAL NURSING": 1.855,
  "POSTEPY DERMATOLOGII I ALERGOLOGII": 1.855,
  "BRAIN & DEVELOPMENT": 1.855,
  "MIGRATION STUDIES": 1.854,
  "BIOMETRICS": 1.854,
  "JOURNAL OF COMPOSITE MATERIALS": 1.854,
  "JOURNAL OF QUALITY TECHNOLOGY": 1.853,
  "IET SIGNAL PROCESSING": 1.852,
  "JOURNAL OF THE OPERATIONAL RESEARCH SOCIETY": 1.852,
  "REVISTA BRASILEIRA DE FARMACOGNOSIA-BRAZILIAN JOURNAL OF PHARMACOGNOSY": 1.852,
  "JOURNAL OF ELECTROMYOGRAPHY AND KINESIOLOGY": 1.851,
  "JOURNAL OF APICULTURAL RESEARCH": 1.851,
  "PROCEEDINGS OF THE INSTITUTION OF MECHANICAL ENGINEERS PART B-JOURNAL OF ENGINEERING MANUFACTURE": 1.85,
  "CLINICAL RESPIRATORY JOURNAL": 1.85,
  "RESEARCH IN VETERINARY SCIENCE": 1.85,
  "EUROPEAN ARCHIVES OF OTO-RHINO-LARYNGOLOGY": 1.85,
  "ECONOMICS OF TRANSPORTATION": 1.85,
  "FEMINIST CRIMINOLOGY": 1.849,
  "INTERNATIONAL JOURNAL OF HEALTH SERVICES": 1.848,
  "INTERNATIONAL JOURNAL OF MATERIAL FORMING": 1.848,
  "JOURNAL OF EARLY ADOLESCENCE": 1.847,
  "JOURNAL OF THE ECONOMICS OF AGEING": 1.847,
  "PHYTOCOENOLOGIA": 1.847,
  "RECENT PATENTS ON NANOTECHNOLOGY": 1.847,
  "SECOND LANGUAGE RESEARCH": 1.846,
  "SOCIAL PSYCHOLOGY QUARTERLY": 1.846,
  "SWISS POLITICAL SCIENCE REVIEW": 1.846,
  "EURASIP JOURNAL ON ADVANCES IN SIGNAL PROCESSING": 1.846,
  "JOURNAL OF SPEECH LANGUAGE AND HEARING RESEARCH": 1.846,
  "BIOMEDICAL CHROMATOGRAPHY": 1.846,
  "ASIAN PACIFIC JOURNAL OF ALLERGY AND IMMUNOLOGY": 1.845,
  "FOOD SCIENCE & NUTRITION": 1.845,
  "ADVANCES IN SPACE RESEARCH": 1.845,
  "CULTURE HEALTH & SEXUALITY": 1.845,
  "CURRENT SOCIOLOGY": 1.843,
  "INTERNATIONAL JOURNAL OF GYNECOLOGICAL CANCER": 1.843,
  "JOURNAL OF MEMBRANE BIOLOGY": 1.841,
  "JOURNAL OF VIROLOGICAL METHODS": 1.841,
  "BIOPHYSICAL CHEMISTRY": 1.841,
  "SUSTAINABILITY ACCOUNTING MANAGEMENT AND POLICY JOURNAL": 1.841,
  "EUROPEAN JOURNAL OF PLANT PATHOLOGY": 1.841,
  "JOURNAL OF PALAEOGEOGRAPHY-ENGLISH": 1.84,
  "ASIA-PACIFIC JOURNAL OF PUBLIC HEALTH": 1.84,
  "BREEDING SCIENCE": 1.84,
  "CANADIAN WATER RESOURCES JOURNAL": 1.84,
  "CARDIOLOGY JOURNAL": 1.84,
  "JOURNAL OF PHYSIOLOGICAL ANTHROPOLOGY": 1.84,
  "JOURNAL OF THE BRAZILIAN SOCIETY OF MECHANICAL SCIENCES AND ENGINEERING": 1.84,
  "MARINE BIODIVERSITY": 1.839,
  "AJIDD-AMERICAN JOURNAL ON INTELLECTUAL AND DEVELOPMENTAL DISABILITIES": 1.839,
  "BULLETIN OF MARINE SCIENCE": 1.839,
  "DRUG DEVELOPMENT RESEARCH": 1.839,
  "ECOLOGY OF FRESHWATER FISH": 1.839,
  "HEALTH INFORMATION MANAGEMENT JOURNAL": 1.839,
  "JOURNAL OF THE IRANIAN CHEMICAL SOCIETY": 1.837,
  "ZEBRAFISH": 1.837,
  "ACM SIGCOMM COMPUTER COMMUNICATION REVIEW": 1.836,
  "BMC MEDICAL GENETICS": 1.836,
  "DERMATOLOGIC THERAPY": 1.836,
  "GENESIS": 1.836,
  "EUROPEAN LAW JOURNAL": 1.836,
  "TECHNOLOGY ANALYSIS & STRATEGIC MANAGEMENT": 1.836,
  "INTERNATIONAL MIGRATION REVIEW": 1.835,
  "JOURNAL OF VERTEBRATE PALEONTOLOGY": 1.835,
  "AMERICAN JOURNAL OF PHARMACEUTICAL EDUCATION": 1.834,
  "CRIME MEDIA CULTURE": 1.834,
  "HEMODIALYSIS INTERNATIONAL": 1.833,
  "JOURNAL OF REFUGEE STUDIES": 1.833,
  "CULTURAL GEOGRAPHIES": 1.833,
  "EUROPEAN JOURNAL OF MEDICAL RESEARCH": 1.833,
  "HYPERTENSION IN PREGNANCY": 1.833,
  "JOURNAL OF PEDIATRIC UROLOGY": 1.833,
  "LETHAIA": 1.832,
  "MATERNAL AND CHILD HEALTH JOURNAL": 1.831,
  "RESPIRATORY CARE": 1.831,
  "JOURNAL OF MUSIC THERAPY": 1.831,
  "NONDESTRUCTIVE TESTING AND EVALUATION": 1.831,
  "PERSONAL AND UBIQUITOUS COMPUTING": 1.83,
  "VANDERBILT LAW REVIEW": 1.83,
  "ACM TRANSACTIONS ON COMPUTER-HUMAN INTERACTION": 1.829,
  "INTERNATIONAL JOURNAL OF ORAL & MAXILLOFACIAL IMPLANTS": 1.829,
  "JOURNAL OF IMMUNOTOXICOLOGY": 1.829,
  "GEOTHERMAL ENERGY": 1.829,
  "JOURNAL OF TOXICOLOGICAL SCIENCES": 1.829,
  "JOURNAL OF ENGLISH FOR ACADEMIC PURPOSES": 1.829,
  "JOURNAL OF MARINE SCIENCE AND ENGINEERING": 1.829,
  "JOURNAL OF YOUTH STUDIES": 1.829,
  "MEDITERRANEAN POLITICS": 1.828,
  "PERSONALITY AND MENTAL HEALTH": 1.828,
  "SYSTEMATIC AND APPLIED ACAROLOGY": 1.828,
  "ADSORPTION-JOURNAL OF THE INTERNATIONAL ADSORPTION SOCIETY": 1.828,
  "MAGNETIC RESONANCE IN CHEMISTRY": 1.828,
  "SMALL-SCALE FORESTRY": 1.827,
  "TURKISH JOURNAL OF AGRICULTURE AND FORESTRY": 1.826,
  "BIOMARKERS": 1.826,
  "EDUCATIONAL REVIEW": 1.826,
  "INHALATION TOXICOLOGY": 1.826,
  "CORNELL LAW REVIEW": 1.825,
  "DISTANCE EDUCATION": 1.825,
  "FISH PHYSIOLOGY AND BIOCHEMISTRY": 1.825,
  "MACROMOLECULAR REACTION ENGINEERING": 1.825,
  "NONLINEARITY": 1.825,
  "HASTINGS CENTER REPORT": 1.824,
  "JOURNAL OF CLINICAL LABORATORY ANALYSIS": 1.824,
  "EUROPEAN TRANSPORT RESEARCH REVIEW": 1.824,
  "FOTTEA": 1.824,
  "INTERNATIONAL JOURNAL OF MINING RECLAMATION AND ENVIRONMENT": 1.824,
  "JOURNAL OF CHEMISTRY": 1.823,
  "PROGRESS IN TUMOR RESEARCH": 1.823,
  "TIME & SOCIETY": 1.822,
  "CLINICAL SPINE SURGERY": 1.822,
  "ITALIAN JOURNAL OF PEDIATRICS": 1.822,
  "BIRD CONSERVATION INTERNATIONAL": 1.821,
  "IEEE COMPUTER GRAPHICS AND APPLICATIONS": 1.821,
  "JOURNAL OF APPLIED GENETICS": 1.821,
  "JOURNAL OF SEX & MARITAL THERAPY": 1.821,
  "MUSCULOSKELETAL SCIENCE AND PRACTICE": 1.821,
  "PRIMARY CARE": 1.82,
  "REPRODUCTION FERTILITY AND DEVELOPMENT": 1.82,
  "SOUTHEAST EUROPEAN AND BLACK SEA STUDIES": 1.82,
  "WORLD NEUROSURGERY": 1.819,
  "EDUCATIONAL ASSESSMENT EVALUATION AND ACCOUNTABILITY": 1.819,
  "DISCOURSE-STUDIES IN THE CULTURAL POLITICS OF EDUCATION": 1.819,
  "JOURNAL OF FLUIDS ENGINEERING-TRANSACTIONS OF THE ASME": 1.819,
  "JOURNAL OF THE AMERICAN OIL CHEMISTS SOCIETY": 1.819,
  "MEDICINAL CHEMISTRY RESEARCH": 1.818,
  "ACTA HISTOCHEMICA": 1.818,
  "EXPERIMENTAL PARASITOLOGY": 1.817,
  "FACIES": 1.817,
  "FEMINIST ECONOMICS": 1.817,
  "JOURNAL OF ULTRASOUND IN MEDICINE": 1.817,
  "BRITISH FOOD JOURNAL": 1.817,
  "JOURNAL OF COMPUTING AND INFORMATION SCIENCE IN ENGINEERING": 1.817,
  "JOURNAL OF OPERATIONAL OCEANOGRAPHY": 1.817,
  "PUBLIC CULTURE": 1.816,
  "REAL-TIME SYSTEMS": 1.816,
  "SYSTEMS BIOLOGY IN REPRODUCTIVE MEDICINE": 1.816,
  "CHEMISTRYSELECT": 1.816,
  "EUROPEAN JOURNAL OF MARKETING": 1.815,
  "EUROPEAN JOURNAL OF OPHTHALMOLOGY": 1.815,
  "JOURNAL OF EXPERIMENTAL ZOOLOGY PART B-MOLECULAR AND DEVELOPMENTAL EVOLUTION": 1.815,
  "JOURNAL OF KOREAN MEDICAL SCIENCE": 1.815,
  "JOURNAL OF ESTHETIC AND RESTORATIVE DENTISTRY": 1.815,
  "MACHINING SCIENCE AND TECHNOLOGY": 1.815,
  "MEDICAL EDUCATION ONLINE": 1.814,
  "TEACHING IN HIGHER EDUCATION": 1.814,
  "ACM TRANSACTIONS ON PRIVACY AND SECURITY": 1.813,
  "AUSTRALIAN ENDODONTIC JOURNAL": 1.813,
  "BULLETIN OF MATHEMATICAL SCIENCES": 1.813,
  "COMPUTER LANGUAGES SYSTEMS & STRUCTURES": 1.813,
  "CANADIAN JOURNAL OF GASTROENTEROLOGY AND HEPATOLOGY": 1.813,
  "DISPLAYS": 1.813,
  "JOURNAL OF PLASTIC FILM & SHEETING": 1.812,
  "JOURNAL OF INDUSTRIAL RELATIONS": 1.811,
  "NUTRITION RESEARCH AND PRACTICE": 1.811,
  "SPORTS BIOMECHANICS": 1.811,
  "ECOLOGICAL COMPLEXITY": 1.811,
  "INTERNATIONAL JOURNAL OF INTERCULTURAL RELATIONS": 1.81,
  "MEMORY": 1.81,
  "JOURNAL OF ADDICTIVE DISEASES": 1.81,
  "MOLECULAR BIOTECHNOLOGY": 1.81,
  "TECHNOLOGY PEDAGOGY AND EDUCATION": 1.81,
  "EUROPEAN ECONOMIC REVIEW": 1.809,
  "JOURNAL OF SPINAL CORD MEDICINE": 1.809,
  "JOURNAL OF SPATIAL SCIENCE": 1.807,
  "METEOROLOGICAL APPLICATIONS": 1.807,
  "FINANCE RESEARCH LETTERS": 1.806,
  "ARCTIC ANTARCTIC AND ALPINE RESEARCH": 1.806,
  "EPISODES": 1.806,
  "JOURNAL OF COMPARATIVE ECONOMICS": 1.806,
  "IRANIAN POLYMER JOURNAL": 1.805,
  "JOURNAL OF CAREER ASSESSMENT": 1.805,
  "PEDIATRIC EXERCISE SCIENCE": 1.805,
  "TELECOMMUNICATION SYSTEMS": 1.805,
  "AMERICAN JOURNAL OF MANAGED CARE": 1.805,
  "SECURITY STUDIES": 1.804,
  "AQUATIC INVASIONS": 1.804,
  "CAMBRIDGE JOURNAL OF EDUCATION": 1.803,
  "INTERNATIONAL FORESTRY REVIEW": 1.803,
  "POLYMER-PLASTICS TECHNOLOGY AND ENGINEERING": 1.803,
  "ENGLISH FOR SPECIFIC PURPOSES": 1.803,
  "JOURNAL OF SEA RESEARCH": 1.801,
  "SAUDI JOURNAL OF GASTROENTEROLOGY": 1.8,
  "WATER ALTERNATIVES-AN INTERDISCIPLINARY JOURNAL ON WATER POLITICS AND DEVELOPMENT": 1.8,
  "ANNALS OF APPLIED PROBABILITY": 1.8,
  "CANADIAN JOURNAL OF FOREST RESEARCH": 1.8,
  "HEAT TRANSFER ENGINEERING": 1.8,
  "JOURNAL OF ANIMAL PHYSIOLOGY AND ANIMAL NUTRITION": 1.799,
  "SOCIAL INDICATORS RESEARCH": 1.799,
  "STUDIES IN CONFLICT & TERRORISM": 1.798,
  "ASLIB JOURNAL OF INFORMATION MANAGEMENT": 1.798,
  "JOURNAL OF MUSCLE RESEARCH AND CELL MOTILITY": 1.798,
  "POPULATION STUDIES-A JOURNAL OF DEMOGRAPHY": 1.798,
  "AUSTRALASIAN JOURNAL OF DERMATOLOGY": 1.797,
  "COASTAL MANAGEMENT": 1.797,
  "CONTRIBUTIONS TO NEPHROLOGY": 1.797,
  "FRONTIERS IN ENERGY": 1.796,
  "FRONTIERS OF MATERIALS SCIENCE": 1.796,
  "PHYSIOLOGICAL RESEARCH": 1.796,
  "PAIN RESEARCH & MANAGEMENT": 1.796,
  "SOIL SCIENCE": 1.796,
  "APPLIED MATHEMATICS AND MECHANICS-ENGLISH EDITION": 1.795,
  "GEOLOGICA CARPATHICA": 1.795,
  "GEOTECHNIQUE LETTERS": 1.795,
  "JOURNAL OF RISK RESEARCH": 1.795,
  "NONLINEAR PROCESSES IN GEOPHYSICS": 1.795,
  "ADMINISTRATION & SOCIETY": 1.795,
  "JOURNAL OF NEUROGENETICS": 1.795,
  "METHODS IN CELL BIOLOGY": 1.795,
  "EUROPEAN JOURNAL OF ONCOLOGY NURSING": 1.795,
  "JOURNAL OF ANIMAL SCIENCE": 1.795,
  "AMERICAN JOURNAL OF INTERNATIONAL LAW": 1.794,
  "LEARNING & BEHAVIOR": 1.794,
  "PUBLIC HEALTH": 1.793,
  "TSINGHUA SCIENCE AND TECHNOLOGY": 1.793,
  "ITALIAN JOURNAL OF GEOSCIENCES": 1.793,
  "KOREAN CIRCULATION JOURNAL": 1.792,
  "PROCEEDINGS OF THE INSTITUTION OF MECHANICAL ENGINEERS PART A-JOURNAL OF POWER AND ENERGY": 1.792,
  "GREENHOUSE GASES-SCIENCE AND TECHNOLOGY": 1.792,
  "INTERNATIONAL REVIEW OF FINANCIAL ANALYSIS": 1.792,
  "IEEE TRANSACTIONS ON APPLIED SUPERCONDUCTIVITY": 1.791,
  "INTERNATIONAL JOURNAL OF CLINICAL PHARMACY": 1.791,
  "SOUTH AFRICAN JOURNAL OF ENOLOGY AND VITICULTURE": 1.791,
  "LIMNOLOGY": 1.79,
  "LUMINESCENCE": 1.789,
  "OBSTETRICS AND GYNECOLOGY CLINICS OF NORTH AMERICA": 1.789,
  "BIRTH DEFECTS RESEARCH": 1.788,
  "EXPERIMENTAL ASTRONOMY": 1.788,
  "JOURNAL OF CANCER EDUCATION": 1.788,
  "ORAL SURGERY ORAL MEDICINE ORAL PATHOLOGY ORAL RADIOLOGY": 1.788,
  "SPATIAL COGNITION AND COMPUTATION": 1.787,
  "ARCHIVES OF ENVIRONMENTAL PROTECTION": 1.787,
  "JORNAL DE PEDIATRIA": 1.786,
  "JOURNAL OF DIGESTIVE DISEASES": 1.786,
  "PERFORMANCE EVALUATION": 1.786,
  "JOURNAL OF ELECTROSTATICS": 1.786,
  "JOURNAL OF PAEDIATRICS AND CHILD HEALTH": 1.786,
  "RENAL FAILURE": 1.785,
  "BIOSCIENCE TRENDS": 1.785,
  "EUROPEAN PHYSICAL JOURNAL E": 1.785,
  "ENFERMEDADES INFECCIOSAS Y MICROBIOLOGIA CLINICA": 1.785,
  "JOURNAL OF COORDINATION CHEMISTRY": 1.785,
  "OPHTHALMIC RESEARCH": 1.785,
  "CHILDREN AND YOUTH SERVICES REVIEW": 1.784,
  "MILLENNIUM-JOURNAL OF INTERNATIONAL STUDIES": 1.784,
  "STUDIES IN EDUCATIONAL EVALUATION": 1.783,
  "JOURNAL OF ECONOMIC HISTORY": 1.783,
  "JOURNAL OF WATER AND HEALTH": 1.782,
  "INTERNATIONAL JOURNAL OF ANALYTICAL CHEMISTRY": 1.782,
  "LUBRICATION SCIENCE": 1.782,
  "ASTROPHYSICS AND SPACE SCIENCE": 1.782,
  "ARCHIVES OF AGRONOMY AND SOIL SCIENCE": 1.782,
  "CYBERNETICS AND SYSTEMS": 1.782,
  "MATHEMATICAL BIOSCIENCES": 1.781,
  "ARQUIVOS BRASILEIROS DE CARDIOLOGIA": 1.781,
  "HARVARD CIVIL RIGHTS-CIVIL LIBERTIES LAW REVIEW": 1.781,
  "APPLIED NUMERICAL MATHEMATICS": 1.78,
  "DISCOURSE STUDIES": 1.78,
  "JOURNAL OF SOCIAL AND PERSONAL RELATIONSHIPS": 1.78,
  "PHYSIOLOGICAL AND MOLECULAR PLANT PATHOLOGY": 1.78,
  "RESEARCH IN NURSING & HEALTH": 1.78,
  "ACTA CARDIOLOGICA SINICA": 1.779,
  "COST EFFECTIVENESS AND RESOURCE ALLOCATION": 1.779,
  "ENVIRONMENT DEVELOPMENT AND SUSTAINABILITY": 1.779,
  "JOURNAL OF APPLIED BEHAVIORAL SCIENCE": 1.779,
  "JOURNAL OF ELECTRONIC MATERIALS": 1.779,
  "JOURNAL OF ZOOLOGY": 1.778,
  "JOURNAL OF NETWORK AND SYSTEMS MANAGEMENT": 1.778,
  "ORIGINS OF LIFE AND EVOLUTION OF BIOSPHERES": 1.777,
  "JOURNAL OF PUBLIC HEALTH POLICY": 1.777,
  "NEUROPSYCHOBIOLOGY": 1.776,
  "RESEARCH IN THE TEACHING OF ENGLISH": 1.776,
  "RESEARCH ON AGING": 1.775,
  "SCIENCE & JUSTICE": 1.775,
  "STATE POLITICS & POLICY QUARTERLY": 1.775,
  "KYKLOS": 1.775,
  "KARDIOLOGIA POLSKA": 1.775,
  "MEDICAL ULTRASONOGRAPHY": 1.774,
  "REVIEW OF PALAEOBOTANY AND PALYNOLOGY": 1.774,
  "JOURNAL OF CLINICAL NEUROPHYSIOLOGY": 1.774,
  "SOILS AND FOUNDATIONS": 1.774,
  "THERAPEUTIC HYPOTHERMIA AND TEMPERATURE MANAGEMENT": 1.773,
  "CLINICAL NEUROLOGY AND NEUROSURGERY": 1.773,
  "CURRENT EYE RESEARCH": 1.773,
  "CYTOTECHNOLOGY": 1.773,
  "IEEE MAGNETICS LETTERS": 1.773,
  "JOURNAL OF SURFACTANTS AND DETERGENTS": 1.772,
  "UHOD-ULUSLARARASI HEMATOLOJI-ONKOLOJI DERGISI": 1.772,
  "AMERICAN ANTIQUITY": 1.772,
  "GLOBALIZATIONS": 1.772,
  "INTERNATIONAL JOURNAL OF GYNECOLOGY & OBSTETRICS": 1.771,
  "UROLITHIASIS": 1.771,
  "JOURNAL OF CONSUMER CULTURE": 1.771,
  "JOURNAL OF PEDIATRIC ONCOLOGY NURSING": 1.771,
  "TECHNOLOGY IN SOCIETY": 1.77,
  "APHASIOLOGY": 1.769,
  "ADVANCES IN THEORETICAL AND MATHEMATICAL PHYSICS": 1.769,
  "CLINICAL TRANSPLANTATION": 1.769,
  "EUROPEAN JOURNAL OF DEVELOPMENTAL PSYCHOLOGY": 1.769,
  "FISHERIES MANAGEMENT AND ECOLOGY": 1.768,
  "IET OPTOELECTRONICS": 1.768,
  "JOURNAL OF FINANCIAL SERVICES RESEARCH": 1.768,
  "SCANDINAVIAN JOURNAL OF FOREST RESEARCH": 1.768,
  "URBAN POLICY AND RESEARCH": 1.768,
  "ANNALS OF THE ENTOMOLOGICAL SOCIETY OF AMERICA": 1.767,
  "BIOETHICS": 1.767,
  "BRAIN INJURY": 1.767,
  "JOURNAL OF FOOD SAFETY": 1.767,
  "NURSE EDUCATION IN PRACTICE": 1.766,
  "INTERNATIONAL HEALTH": 1.766,
  "ARCHIVES OF ORAL BIOLOGY": 1.765,
  "EUROPEAN JOURNAL OF MINERALOGY": 1.765,
  "ISRAEL JOURNAL OF HEALTH POLICY RESEARCH": 1.765,
  "JOURNAL OF X-RAY SCIENCE AND TECHNOLOGY": 1.765,
  "ECOHYDROLOGY & HYDROBIOLOGY": 1.764,
  "INTERNATIONAL PEACEKEEPING": 1.764,
  "JOURNAL OF GLAUCOMA": 1.764,
  "MARITIME ECONOMICS & LOGISTICS": 1.763,
  "SPEECH COMMUNICATION": 1.763,
  "DIGITAL INVESTIGATION": 1.763,
  "EUROPEAN PHYSICAL JOURNAL-SPECIAL TOPICS": 1.763,
  "LANGUAGE IN SOCIETY": 1.763,
  "MIND & LANGUAGE": 1.763,
  "SUPRAMOLECULAR CHEMISTRY": 1.762,
  "BIOTECHNIQUES": 1.762,
  "DISEASES OF AQUATIC ORGANISMS": 1.761,
  "FIRE SAFETY JOURNAL": 1.761,
  "DEVELOPMENT AND CHANGE": 1.761,
  "INTERNATIONAL JOURNAL OF MASS SPECTROMETRY": 1.761,
  "RADIO SCIENCE": 1.76,
  "ACTA NATURAE": 1.76,
  "JOURNAL OF ENVIRONMENTAL ENGINEERING": 1.76,
  "JOURNAL OF MODERN OPTICS": 1.76,
  "JOURNAL OF THE ASTRONAUTICAL SCIENCES": 1.759,
  "SKIN RESEARCH AND TECHNOLOGY": 1.759,
  "ANNALS OF APPLIED STATISTICS": 1.759,
  "BMC INTERNATIONAL HEALTH AND HUMAN RIGHTS": 1.758,
  "CHILD INDICATORS RESEARCH": 1.758,
  "GACETA SANITARIA": 1.758,
  "METEOROLOGY AND ATMOSPHERIC PHYSICS": 1.758,
  "AMERICAN JOURNAL OF HOSPICE & PALLIATIVE MEDICINE": 1.757,
  "HIGH ENERGY DENSITY PHYSICS": 1.757,
  "JOURNAL OF SOUTH AMERICAN EARTH SCIENCES": 1.757,
  "LEGISLATIVE STUDIES QUARTERLY": 1.756,
  "THINKING SKILLS AND CREATIVITY": 1.756,
  "COMBUSTION THEORY AND MODELLING": 1.755,
  "JSLS-JOURNAL OF THE SOCIETY OF LAPAROENDOSCOPIC SURGEONS": 1.755,
  "KOREAN JOURNAL OF PHYSIOLOGY & PHARMACOLOGY": 1.755,
  "MICROELECTRONIC ENGINEERING": 1.754,
  "NEUROPEDIATRICS": 1.754,
  "ANTARCTIC SCIENCE": 1.754,
  "JAPANESE JOURNAL OF OPHTHALMOLOGY": 1.754,
  "JOURNAL OF ENGINEERING FOR GAS TURBINES AND POWER-TRANSACTIONS OF THE ASME": 1.753,
  "SIAM-ASA JOURNAL ON UNCERTAINTY QUANTIFICATION": 1.752,
  "CALCULUS OF VARIATIONS AND PARTIAL DIFFERENTIAL EQUATIONS": 1.752,
  "GEOGRAFISKA ANNALER SERIES A-PHYSICAL GEOGRAPHY": 1.751,
  "INTENSIVE AND CRITICAL CARE NURSING": 1.751,
  "AMERICAN JOURNAL OF EMERGENCY MEDICINE": 1.75,
  "IEEE TRANSACTIONS ON MAGNETICS": 1.75,
  "NEUROLOGIA MEDICO-CHIRURGICA": 1.75,
  "ADVANCED NONLINEAR STUDIES": 1.75,
  "BULLETIN OF ENVIRONMENTAL CONTAMINATION AND TOXICOLOGY": 1.75,
  "ENDOCRINOLOGIA Y NUTRICION": 1.75,
  "JOURNAL OF ENERGETIC MATERIALS": 1.75,
  "ANNALS OF NUCLEAR MEDICINE": 1.75,
  "IET COMPUTER VISION": 1.75,
  "JOURNAL OF PUBLIC HEALTH": 1.75,
  "JOURNAL OF TRIBOLOGY-TRANSACTIONS OF THE ASME": 1.75,
  "ANNALS OF DERMATOLOGY": 1.75,
  "METALS AND MATERIALS INTERNATIONAL": 1.75,
  "MOLECULAR MEMBRANE BIOLOGY": 1.749,
  "SEMINARS IN RESPIRATORY AND CRITICAL CARE MEDICINE": 1.749,
  "JOURNAL OF STROKE & CEREBROVASCULAR DISEASES": 1.749,
  "STRUCTURES": 1.748,
  "CURRENT DRUG DELIVERY": 1.747,
  "IN VITRO CELLULAR & DEVELOPMENTAL BIOLOGY-ANIMAL": 1.747,
  "JOURNAL OF FASHION MARKETING AND MANAGEMENT": 1.746,
  "VISUAL NEUROSCIENCE": 1.746,
  "CROP SCIENCE": 1.746,
  "JOURNAL OF MIDWIFERY & WOMENS HEALTH": 1.746,
  "PLANT SIGNALING & BEHAVIOR": 1.746,
  "BULLETIN OF MATHEMATICAL BIOLOGY": 1.746,
  "HERPETOLOGICAL MONOGRAPHS": 1.745,
  "HORMONES-INTERNATIONAL JOURNAL OF ENDOCRINOLOGY AND METABOLISM": 1.745,
  "ARCHIVES OF MICROBIOLOGY": 1.744,
  "CHILD AND ADOLESCENT PSYCHIATRIC CLINICS OF NORTH AMERICA": 1.744,
  "CLINICAL HEMORHEOLOGY AND MICROCIRCULATION": 1.743,
  "CHILD AND ADOLESCENT PSYCHIATRY AND MENTAL HEALTH": 1.743,
  "JOURNAL OF INVESTIGATIVE SURGERY": 1.743,
  "JOURNAL OF BIOLOGICAL DYNAMICS": 1.743,
  "SCANDINAVIAN JOURNAL OF CARING SCIENCES": 1.743,
  "TURKISH STUDIES": 1.743,
  "BIOMETRIKA": 1.743,
  "ALLERGOLOGIA ET IMMUNOPATHOLOGIA": 1.743,
  "ARCHAEOMETRY": 1.742,
  "JOURNAL OF HOUSING ECONOMICS": 1.742,
  "JOURNAL OF TAIBAH UNIVERSITY FOR SCIENCE": 1.742,
  "LAND ECONOMICS": 1.742,
  "ACTA PALAEONTOLOGICA POLONICA": 1.742,
  "AUSTRALIAN GEOGRAPHER": 1.742,
  "JOURNAL OF MULTILINGUAL AND MULTICULTURAL DEVELOPMENT": 1.742,
  "NURSING IN CRITICAL CARE": 1.742,
  "ADVANCES IN COMPUTATIONAL MATHEMATICS": 1.74,
  "DEVELOPMENT GROWTH & DIFFERENTIATION": 1.74,
  "INTERNATIONAL CLINICAL PSYCHOPHARMACOLOGY": 1.74,
  "INVESTIGATIVE AND CLINICAL UROLOGY": 1.74,
  "JOURNAL OF INTERNATIONAL DISPUTE SETTLEMENT": 1.739,
  "MAMMALIAN BIOLOGY": 1.739,
  "REPRODUCTION IN DOMESTIC ANIMALS": 1.738,
  "BOUNDARY VALUE PROBLEMS": 1.738,
  "JOURNAL OF FUNCTIONAL ANALYSIS": 1.737,
  "JOURNAL OF INTELLIGENT & FUZZY SYSTEMS": 1.737,
  "JOURNAL OF COMPUTATIONAL ELECTRONICS": 1.737,
  "JOURNAL OF INORGANIC AND ORGANOMETALLIC POLYMERS AND MATERIALS": 1.737,
  "GEOGRAPHICAL REVIEW": 1.736,
  "JOURNAL OF CLASSIFICATION": 1.736,
  "PALAIOS": 1.736,
  "PROBLEMS OF POST-COMMUNISM": 1.736,
  "VIOLENCE AGAINST WOMEN": 1.736,
  "AGRIBUSINESS": 1.736,
  "MOBILE INFORMATION SYSTEMS": 1.736,
  "TOXICOLOGY AND INDUSTRIAL HEALTH": 1.735,
  "INTERNATIONAL JOURNAL OF MEDICAL ROBOTICS AND COMPUTER ASSISTED SURGERY": 1.735,
  "PROPELLANTS EXPLOSIVES PYROTECHNICS": 1.735,
  "RAND JOURNAL OF ECONOMICS": 1.735,
  "BOLETIN DE LA SOCIEDAD ESPANOLA DE CERAMICA Y VIDRIO": 1.734,
  "INTERNATIONAL JOURNAL OF SATELLITE COMMUNICATIONS AND NETWORKING": 1.734,
  "JOURNAL OF AFRICAN EARTH SCIENCES": 1.734,
  "JOURNAL OF ANIMAL BREEDING AND GENETICS": 1.732,
  "NUMERICAL METHODS FOR PARTIAL DIFFERENTIAL EQUATIONS": 1.732,
  "JOURNAL OF COMMUNICATIONS AND NETWORKS": 1.732,
  "INTERNATIONAL JOURNAL FOR NUMERICAL METHODS IN FLUIDS": 1.732,
  "JOURNAL OF GLOBAL OPTIMIZATION": 1.732,
  "METEOROLOGISCHE ZEITSCHRIFT": 1.732,
  "ARTHROPOD-PLANT INTERACTIONS": 1.732,
  "COGNITIVE LINGUISTICS": 1.732,
  "ENDOCRINE RESEARCH": 1.731,
  "EUROPEAN SURGICAL RESEARCH": 1.731,
  "JOURNAL OF RECEPTORS AND SIGNAL TRANSDUCTION": 1.731,
  "NAVIGATION-JOURNAL OF THE INSTITUTE OF NAVIGATION": 1.731,
  "INTERNATIONAL DENTAL JOURNAL": 1.73,
  "SHOCK AND VIBRATION": 1.73,
  "BIOCATALYSIS AND BIOTRANSFORMATION": 1.73,
  "JOURNAL OF WOUND OSTOMY AND CONTINENCE NURSING": 1.729,
  "ACTA BIOCHIMICA POLONICA": 1.729,
  "QUALITY ENGINEERING": 1.729,
  "ENTREPRENEURSHIP RESEARCH JOURNAL": 1.729,
  "JOURNAL OF WATERWAY PORT COASTAL AND OCEAN ENGINEERING": 1.729,
  "CROATIAN MEDICAL JOURNAL": 1.728,
  "MARKETING LETTERS": 1.728,
  "POLITICAL STUDIES": 1.728,
  "STRUCTURAL CHEMISTRY": 1.727,
  "WATER SCIENCE AND TECHNOLOGY": 1.727,
  "BIOSYSTEMS": 1.727,
  "ENTOMOLOGIA EXPERIMENTALIS ET APPLICATA": 1.727,
  "VETERINARY ANAESTHESIA AND ANALGESIA": 1.727,
  "BMC MEDICAL IMAGING": 1.727,
  "FRONTIERS IN LIFE SCIENCE": 1.727,
  "PSYCHOTHERAPY": 1.726,
  "GEOPHYSICAL PROSPECTING": 1.726,
  "INFORMATION SYSTEMS AND E-BUSINESS MANAGEMENT": 1.725,
  "HEART AND VESSELS": 1.725,
  "OTOLARYNGOLOGIC CLINICS OF NORTH AMERICA": 1.725,
  "BMC ANESTHESIOLOGY": 1.725,
  "ANALYTICAL SCIENCES": 1.725,
  "IETE TECHNICAL REVIEW": 1.723,
  "ZEITSCHRIFT FUR ANGEWANDTE MATHEMATIK UND PHYSIK": 1.723,
  "CLINICS IN COLON AND RECTAL SURGERY": 1.723,
  "EUROPEAN JOURNAL OF GENERAL PRACTICE": 1.723,
  "JOURNAL OF INTERNATIONAL ECONOMIC LAW": 1.722,
  "PUBLIC RELATIONS REVIEW": 1.721,
  "REVIEWS ON ENVIRONMENTAL HEALTH": 1.72,
  "VIRUS GENES": 1.72,
  "FRONTIERS OF HORMONE RESEARCH": 1.72,
  "MINERAL PROCESSING AND EXTRACTIVE METALLURGY REVIEW": 1.719,
  "PHARMACOLOGY": 1.719,
  "TOPICS IN EARLY CHILDHOOD SPECIAL EDUCATION": 1.719,
  "INTERNATIONAL JOURNAL OF DISTRIBUTED SENSOR NETWORKS": 1.719,
  "DISABILITY & SOCIETY": 1.718,
  "PSICOLOGIA EDUCATIVA": 1.717,
  "TEXTILE RESEARCH JOURNAL": 1.717,
  "ACTA NEUROLOGICA BELGICA": 1.717,
  "ANNALS OF APPLIED BIOLOGY": 1.717,
  "BIOPHARMACEUTICS & DRUG DISPOSITION": 1.717,
  "MINNESOTA LAW REVIEW": 1.717,
  "RESEARCH IN SOCIAL STRATIFICATION AND MOBILITY": 1.716,
  "WOUNDS-A COMPENDIUM OF CLINICAL RESEARCH AND PRACTICE": 1.716,
  "CANADIAN JOURNAL OF CHEMICAL ENGINEERING": 1.716,
  "COMPUTER METHODS IN BIOMECHANICS AND BIOMEDICAL ENGINEERING": 1.716,
  "ACCOUNTABILITY IN RESEARCH-POLICIES AND QUALITY ASSURANCE": 1.716,
  "GEOMICROBIOLOGY JOURNAL": 1.716,
  "IN VIVO": 1.716,
  "ACTA PHYSIOLOGIAE PLANTARUM": 1.715,
  "ARTIFICIAL LIFE": 1.715,
  "ANNALS OF DIAGNOSTIC PATHOLOGY": 1.714,
  "INTERNATIONAL JOURNAL OF PSYCHOLOGY": 1.714,
  "JOURNAL OF ACADEMIC LIBRARIANSHIP": 1.714,
  "ORTHOPEDICS": 1.714,
  "CONVERGENCE-THE INTERNATIONAL JOURNAL OF RESEARCH INTO NEW MEDIA TECHNOLOGIES": 1.714,
  "JOURNAL OF FAMILY ISSUES": 1.714,
  "JOURNAL OF LIMNOLOGY": 1.714,
  "PETROLEUM GEOSCIENCE": 1.714,
  "PHYSICA STATUS SOLIDI A-APPLICATIONS AND MATERIALS SCIENCE": 1.714,
  "AMERICAN MUSEUM NOVITATES": 1.714,
  "ANZ JOURNAL OF SURGERY": 1.713,
  "CYTA-JOURNAL OF FOOD": 1.713,
  "ENVIRONMENTAL FLUID MECHANICS": 1.713,
  "REVISTA DE CHIMIE": 1.712,
  "SILVA FENNICA": 1.712,
  "EVALUATION & THE HEALTH PROFESSIONS": 1.712,
  "JOURNAL OF FOOT AND ANKLE RESEARCH": 1.711,
  "LAW & SOCIETY REVIEW": 1.711,
  "PLANT MOLECULAR BIOLOGY REPORTER": 1.711,
  "ADVANCES IN MANUFACTURING": 1.711,
  "BRAZILIAN JOURNAL OF OTORHINOLARYNGOLOGY": 1.709,
  "JOURNAL OF MATHEMATICAL IMAGING AND VISION": 1.708,
  "JOURNAL OF PRODUCTIVITY ANALYSIS": 1.708,
  "PSYCHOLOGY HEALTH & MEDICINE": 1.708,
  "ZOOLOGISCHER ANZEIGER": 1.707,
  "BIRTH DEFECTS RESEARCH PART B-DEVELOPMENTAL AND REPRODUCTIVE TOXICOLOGY": 1.707,
  "EUROPEAN MANAGEMENT REVIEW": 1.707,
  "INTERNATIONAL JOURNAL OF MANAGING PROJECTS IN BUSINESS": 1.707,
  "JOURNAL OF OPTIMIZATION THEORY AND APPLICATIONS": 1.706,
  "NANOMATERIALS AND NANOTECHNOLOGY": 1.706,
  "PUBLIC PERFORMANCE & MANAGEMENT REVIEW": 1.706,
  "JOURNAL OF CHEMOTHERAPY": 1.705,
  "ACTA MECHANICA SINICA": 1.705,
  "JOURNAL OF SCHEDULING": 1.705,
  "NEW FORESTS": 1.705,
  "THEORETICAL CHEMISTRY ACCOUNTS": 1.704,
  "BIOLOGICALLY INSPIRED COGNITIVE ARCHITECTURES": 1.704,
  "EDUCACION XX1": 1.704,
  "INTERNATIONAL JOURNAL OF STRATEGIC PROPERTY MANAGEMENT": 1.704,
  "JOURNAL OF LEADERSHIP & ORGANIZATIONAL STUDIES": 1.704,
  "METABOLIC SYNDROME AND RELATED DISORDERS": 1.703,
  "REVISTA IBEROAMERICANA DE MICOLOGIA": 1.703,
  "ANNALS OF FOREST RESEARCH": 1.703,
  "CURRENT MOLECULAR PHARMACOLOGY": 1.703,
  "ENVIRONMENTAL PROGRESS & SUSTAINABLE ENERGY": 1.703,
  "IEEE SECURITY & PRIVACY": 1.703,
  "INTERNATIONAL UROLOGY AND NEPHROLOGY": 1.702,
  "PRION": 1.702,
  "ACTA PSYCHOLOGICA": 1.702,
  "BODY & SOCIETY": 1.702,
  "CURRENT MICROBIOLOGY": 1.701,
  "SPE PRODUCTION & OPERATIONS": 1.701,
  "BIOLOGY & PHILOSOPHY": 1.701,
  "JOURNAL OF CLINICAL NEUROSCIENCE": 1.701,
  "MATHEMATICS OF OPERATIONS RESEARCH": 1.701,
  "NEW MICROBIOLOGICA": 1.701,
  "TOXICOLOGY RESEARCH": 1.701,
  "BMC WOMENS HEALTH": 1.701,
  "EURASIP JOURNAL ON WIRELESS COMMUNICATIONS AND NETWORKING": 1.7,
  "JOURNAL OF BIOETHICAL INQUIRY": 1.699,
  "HEALTH SOCIOLOGY REVIEW": 1.699,
  "JOURNAL OF HUMANISTIC PSYCHOLOGY": 1.699,
  "JOURNAL OF OCCUPATIONAL AND ENVIRONMENTAL MEDICINE": 1.699,
  "JOURNAL OF KNEE SURGERY": 1.699,
  "PHILOSOPHY & PUBLIC AFFAIRS": 1.698,
  "PHOTOGRAMMETRIC RECORD": 1.698,
  "BRAZILIAN JOURNAL OF GEOLOGY": 1.698,
  "JOURNAL OF VETERINARY BEHAVIOR-CLINICAL APPLICATIONS AND RESEARCH": 1.697,
  "JOURNAL OF INTELLIGENT INFORMATION SYSTEMS": 1.697,
  "JOURNAL OF ANALYTICAL METHODS IN CHEMISTRY": 1.697,
  "ANNALS OF HUMAN BIOLOGY": 1.696,
  "HONG KONG MEDICAL JOURNAL": 1.696,
  "MAGNESIUM RESEARCH": 1.696,
  "ASIAN PACIFIC JOURNAL OF TROPICAL BIOMEDICINE": 1.696,
  "COMPLEMENTARY THERAPIES IN CLINICAL PRACTICE": 1.696,
  "REVIEW OF SCIENTIFIC INSTRUMENTS": 1.696,
  "ACTA RADIOLOGICA": 1.694,
  "CLINICAL GERONTOLOGIST": 1.694,
  "CURRENT NANOSCIENCE": 1.694,
  "MEDITERRANEAN JOURNAL OF HEMATOLOGY AND INFECTIOUS DISEASES": 1.693,
  "ANNALES GEOPHYSICAE": 1.693,
  "ALGORITHMS FOR MOLECULAR BIOLOGY": 1.692,
  "EDUCATIONAL RESEARCH": 1.692,
  "INTERNATIONAL JOURNAL OF COMPUTERS COMMUNICATIONS & CONTROL": 1.692,
  "MARKETING INTELLIGENCE & PLANNING": 1.691,
  "PLANT SYSTEMATICS AND EVOLUTION": 1.691,
  "HIGH PERFORMANCE POLYMERS": 1.691,
  "JOURNAL OF FELINE MEDICINE AND SURGERY": 1.69,
  "JOURNAL OF PALEONTOLOGY": 1.69,
  "JOURNAL OF COATINGS TECHNOLOGY AND RESEARCH": 1.69,
  "PHARMACEUTICAL STATISTICS": 1.69,
  "TOHOKU JOURNAL OF EXPERIMENTAL MEDICINE": 1.69,
  "BMC UROLOGY": 1.689,
  "DATA & KNOWLEDGE ENGINEERING": 1.689,
  "IEEE TRANSACTIONS ON DEVICE AND MATERIALS RELIABILITY": 1.689,
  "INTELLECTUAL AND DEVELOPMENTAL DISABILITIES": 1.689,
  "JOURNAL OF BIOMEDICAL SEMANTICS": 1.688,
  "JOURNAL OF IMMIGRANT AND MINORITY HEALTH": 1.688,
  "RESPIRATORY PHYSIOLOGY & NEUROBIOLOGY": 1.687,
  "AMERICAN JOURNAL OF PERINATOLOGY": 1.686,
  "COMPUTATIONAL BIOLOGY AND CHEMISTRY": 1.686,
  "POLITICAL RESEARCH QUARTERLY": 1.685,
  "ACM TRANSACTIONS ON THE WEB": 1.685,
  "DISCOURSE PROCESSES": 1.685,
  "JOURNAL OF CONSUMER BEHAVIOUR": 1.684,
  "JOURNAL OF OPHTHALMOLOGY": 1.684,
  "REVIEW OF ECONOMIC DYNAMICS": 1.684,
  "AIP ADVANCES": 1.683,
  "ARCHIVE OF APPLIED MECHANICS": 1.683,
  "AUSTRALASIAN JOURNAL OF EDUCATIONAL TECHNOLOGY": 1.682,
  "HEPATITIS MONTHLY": 1.682,
  "IRONMAKING & STEELMAKING": 1.681,
  "JOURNAL OF THE MARINE BIOLOGICAL ASSOCIATION OF THE UNITED KINGDOM": 1.681,
  "ADVANCES IN METEOROLOGY": 1.681,
  "JOURNAL OF MARITAL AND FAMILY THERAPY": 1.68,
  "MEDICAL LAW REVIEW": 1.679,
  "OPTOMETRY AND VISION SCIENCE": 1.679,
  "HEPATOBILIARY & PANCREATIC DISEASES INTERNATIONAL": 1.678,
  "INSTRUCTIONAL SCIENCE": 1.678,
  "INTERNATIONAL JOURNAL OF DESIGN": 1.678,
  "SOCIOLOGY OF RELIGION": 1.678,
  "WAVE MOTION": 1.678,
  "ANNALES HENRI POINCARE": 1.678,
  "ENVIRONMENTAL ENGINEERING SCIENCE": 1.676,
  "SCIENCE AND PUBLIC POLICY": 1.676,
  "CONTEMPORARY SECURITY POLICY": 1.676,
  "FOOD STRUCTURE-NETHERLANDS": 1.676,
  "GAMES AND CULTURE": 1.676,
  "JOURNAL OF SOCIOLINGUISTICS": 1.676,
  "SPORT EXERCISE AND PERFORMANCE PSYCHOLOGY": 1.676,
  "EARTHQUAKES AND STRUCTURES": 1.676,
  "HEALTH & SOCIAL CARE IN THE COMMUNITY": 1.675,
  "JOURNAL OF CRYSTAL GROWTH": 1.675,
  "JOURNAL OF DOCUMENTATION": 1.675,
  "JOURNAL OF APPLIED BIOMEDICINE": 1.675,
  "MINERALOGY AND PETROLOGY": 1.675,
  "JOURNAL OF COMMUNITY HEALTH": 1.675,
  "ORTHOPAEDICS & TRAUMATOLOGY-SURGERY & RESEARCH": 1.675,
  "ARCHIVES OF ENDOCRINOLOGY METABOLISM": 1.674,
  "CHEMOTHERAPY": 1.674,
  "INTERNATIONAL JOURNAL OF INDUSTRIAL ERGONOMICS": 1.674,
  "LANGUAGE CULTURE AND CURRICULUM": 1.674,
  "MOLECULAR PHYSICS": 1.673,
  "AMERICAN JOURNAL OF MEDICAL QUALITY": 1.673,
  "JOURNAL OF THE PHYSICAL SOCIETY OF JAPAN": 1.673,
  "ACTA CHIROPTEROLOGICA": 1.672,
  "BRITISH JOURNAL OF SOCIAL WORK": 1.672,
  "JOURNAL OF MATERNAL-FETAL & NEONATAL MEDICINE": 1.672,
  "PROGRESS IN NUCLEAR ENERGY": 1.672,
  "SOIL RESEARCH": 1.672,
  "CAMBRIDGE LAW JOURNAL": 1.672,
  "DYSLEXIA": 1.671,
  "EXPERIMENTAL LUNG RESEARCH": 1.671,
  "ENVIRONMENTAL HEALTH AND PREVENTIVE MEDICINE": 1.671,
  "JOURNAL OF COMPUTATIONAL NEUROSCIENCE": 1.671,
  "JOURNAL OF CARDIOPULMONARY REHABILITATION AND PREVENTION": 1.67,
  "PROCEEDINGS OF THE INSTITUTION OF MECHANICAL ENGINEERS PART L-JOURNAL OF MATERIALS-DESIGN AND APPLICATIONS": 1.67,
  "SEMINARS IN VASCULAR SURGERY": 1.67,
  "THEORETICAL BIOLOGY AND MEDICAL MODELLING": 1.67,
  "ANATOMICAL SCIENCE INTERNATIONAL": 1.669,
  "COMPUTATIONAL PARTICLE MECHANICS": 1.667,
  "ACTA ODONTOLOGICA SCANDINAVICA": 1.667,
  "GEOGRAPHICAL RESEARCH": 1.667,
  "JOURNAL OF TEXTURE STUDIES": 1.667,
  "LANGUAGE TEACHING": 1.667,
  "COMBUSTION SCIENCE AND TECHNOLOGY": 1.667,
  "JOURNAL OF COMPARATIVE PSYCHOLOGY": 1.667,
  "COMPUTATIONAL AND MATHEMATICAL METHODS IN MEDICINE": 1.667,
  "ECONOMY AND SOCIETY": 1.665,
  "JOURNAL OF HIGH ENERGY ASTROPHYSICS": 1.665,
  "JOURNAL OF PEDIATRIC NURSING-NURSING CARE OF CHILDREN & FAMILIES": 1.665,
  "KOREAN JOURNAL OF PAIN": 1.665,
  "SIAM JOURNAL ON COMPUTING": 1.665,
  "TRANSACTIONS OF THE AMERICAN FISHERIES SOCIETY": 1.665,
  "INTERNATIONAL NURSING REVIEW": 1.665,
  "JOURNAL OF MUSCULOSKELETAL & NEURONAL INTERACTIONS": 1.665,
  "JOURNAL OF BUSINESS FINANCE & ACCOUNTING": 1.664,
  "CARDIOLOGY": 1.664,
  "CAREER DEVELOPMENT INTERNATIONAL": 1.663,
  "ENGINEERING CONSTRUCTION AND ARCHITECTURAL MANAGEMENT": 1.663,
  "JOURNAL OF ECONOMIC PSYCHOLOGY": 1.662,
  "JOURNAL OF GENE MEDICINE": 1.662,
  "QUANTITATIVE ECONOMICS": 1.661,
  "ASIAN JOURNAL OF SURGERY": 1.661,
  "APPLIED BIOLOGICAL CHEMISTRY": 1.661,
  "ARCHIVES OF CONTROL SCIENCES": 1.661,
  "BIOTECHNOLOGY AND APPLIED BIOCHEMISTRY": 1.661,
  "CLINICAL AND EXPERIMENTAL OPTOMETRY": 1.66,
  "JOURNAL OF FOOD PROTECTION": 1.66,
  "THEORETICAL POPULATION BIOLOGY": 1.66,
  "JOURNAL OF BIOLOGICAL REGULATORS AND HOMEOSTATIC AGENTS": 1.66,
  "JOURNAL OF MORPHOLOGY": 1.66,
  "TRANSCULTURAL PSYCHIATRY": 1.659,
  "ECONOMIC AND INDUSTRIAL DEMOCRACY": 1.659,
  "STRUCTURAL CHANGE AND ECONOMIC DYNAMICS": 1.659,
  "APPLIED COMPOSITE MATERIALS": 1.658,
  "JOURNAL OF CHILD AND FAMILY STUDIES": 1.658,
  "JOURNAL OF DEAF STUDIES AND DEAF EDUCATION": 1.658,
  "MARINE AND COASTAL FISHERIES": 1.657,
  "ZOOLOGICAL RESEARCH": 1.657,
  "CHINESE MEDICAL JOURNAL": 1.657,
  "PROFESSIONAL GEOGRAPHER": 1.657,
  "CORONARY ARTERY DISEASE": 1.657,
  "INTERNATIONAL JOURNAL OF CIRCUIT THEORY AND APPLICATIONS": 1.656,
  "JOURNAL OF HERBAL MEDICINE": 1.656,
  "JOURNAL OF APPLIED SOCIAL PSYCHOLOGY": 1.656,
  "KONA POWDER AND PARTICLE JOURNAL": 1.656,
  "TISSUE & CELL": 1.656,
  "APPLIED COGNITIVE PSYCHOLOGY": 1.656,
  "ANNALS OF TELECOMMUNICATIONS": 1.655,
  "CHROMATOGRAPHIA": 1.655,
  "CARDIOLOGY IN REVIEW": 1.655,
  "COMPUTER LAW & SECURITY REVIEW": 1.655,
  "ARCHIVES OF BUDO": 1.655,
  "HEAT AND MASS TRANSFER": 1.654,
  "PSICOTHEMA": 1.654,
  "PHYSICAL MESOMECHANICS": 1.654,
  "CANADIAN JOURNAL OF MICROBIOLOGY": 1.654,
  "CLINICAL AND EXPERIMENTAL OTORHINOLARYNGOLOGY": 1.654,
  "FLY": 1.653,
  "EUROPEAN JOURNAL OF CONTROL": 1.653,
  "JOURNAL OF THE KOREAN ASTRONOMICAL SOCIETY": 1.653,
  "APPLIED NEUROPSYCHOLOGY-ADULT": 1.653,
  "INTERNATIONAL JOURNAL OF ACCOUNTING INFORMATION SYSTEMS": 1.652,
  "JOURNAL OF SOCIAL MARKETING": 1.652,
  "OPTICAL AND QUANTUM ELECTRONICS": 1.652,
  "ECOLOGICAL RESEARCH": 1.652,
  "NUCLEAR ENGINEERING AND TECHNOLOGY": 1.651,
  "EUROPEAN POLITICAL SCIENCE REVIEW": 1.651,
  "FINANCIAL MANAGEMENT": 1.651,
  "HERD-HEALTH ENVIRONMENTS RESEARCH & DESIGN JOURNAL": 1.65,
  "JOURNAL OF INTERNATIONAL RELATIONS AND DEVELOPMENT": 1.65,
  "MATERIALS AT HIGH TEMPERATURES": 1.649,
  "SOCIOLOGICAL METHODOLOGY": 1.649,
  "BIOENGINEERED": 1.648,
  "JOURNAL OF APPLIED CLINICAL MEDICAL PHYSICS": 1.648,
  "ARCHIVES OF MECHANICS": 1.648,
  "COMMUNICATIONS IN NUMBER THEORY AND PHYSICS": 1.648,
  "JOURNAL OF EDUCATIONAL COMPUTING RESEARCH": 1.648,
  "NEOTROPICAL ICHTHYOLOGY": 1.647,
  "BRAIN BEHAVIOR AND EVOLUTION": 1.647,
  "COGNITIVE NEUROPSYCHIATRY": 1.647,
  "JOURNAL OF PERFORMANCE OF CONSTRUCTED FACILITIES": 1.647,
  "JOURNAL OF PETROLEUM GEOLOGY": 1.646,
  "NUCLEAR ENGINEERING AND DESIGN": 1.646,
  "PHLEBOLOGY": 1.645,
  "PSYCHOSOMATICS": 1.645,
  "THERMAL SCIENCE": 1.645,
  "BIOLOGICAL & PHARMACEUTICAL BULLETIN": 1.645,
  "PROCEEDINGS OF THE INSTITUTION OF MECHANICAL ENGINEERS PART F-JOURNAL OF RAIL AND RAPID TRANSIT": 1.644,
  "REVISTA MATEMATICA IBEROAMERICANA": 1.644,
  "ASIA-PACIFIC JOURNAL OF CLINICAL ONCOLOGY": 1.644,
  "EARLY EDUCATION AND DEVELOPMENT": 1.644,
  "JOURNAL OF INFECTION AND CHEMOTHERAPY": 1.643,
  "PHYSIOLOGY AND MOLECULAR BIOLOGY OF PLANTS": 1.643,
  "VETERINARY CLINICS OF NORTH AMERICA-FOOD ANIMAL PRACTICE": 1.643,
  "FEMINISM & PSYCHOLOGY": 1.642,
  "JOURNAL OF BURN CARE & RESEARCH": 1.642,
  "JOURNAL OF INFRASTRUCTURE SYSTEMS": 1.642,
  "JOURNAL OF WATER REUSE AND DESALINATION": 1.642,
  "LANGUAGE SPEECH AND HEARING SERVICES IN SCHOOLS": 1.642,
  "NORDIC JOURNAL OF MUSIC THERAPY": 1.642,
  "BIOLOGICAL BULLETIN": 1.642,
  "BRITISH JOURNAL OF DEVELOPMENTAL PSYCHOLOGY": 1.642,
  "JOURNAL OF SPECIAL EDUCATION": 1.642,
  "JOURNAL OF INFORMATION SECURITY AND APPLICATIONS": 1.641,
  "JOURNAL OF COMMUNICATION DISORDERS": 1.64,
  "JOURNAL OF ENVIRONMENTAL SCIENCE AND HEALTH PART A-TOXIC/HAZARDOUS SUBSTANCES & ENVIRONMENTAL ENGINEERING": 1.64,
  "JOURNAL OF EVALUATION IN CLINICAL PRACTICE": 1.64,
  "PHYSICAL & OCCUPATIONAL THERAPY IN PEDIATRICS": 1.64,
  "EUROPEAN JOURNAL OF PSYCHOLOGY OF EDUCATION": 1.64,
  "EURASIP JOURNAL ON IMAGE AND VIDEO PROCESSING": 1.639,
  "JOURNAL OF ENVIRONMENTAL AND ENGINEERING GEOPHYSICS": 1.639,
  "JOURNAL OF INTERVENTIONAL CARDIAC ELECTROPHYSIOLOGY": 1.639,
  "VASA-EUROPEAN JOURNAL OF VASCULAR MEDICINE": 1.639,
  "GEOPHYSICAL AND ASTROPHYSICAL FLUID DYNAMICS": 1.639,
  "INDIAN JOURNAL OF MICROBIOLOGY": 1.638,
  "INTERNATIONAL JOURNAL OF PROSTHODONTICS": 1.638,
  "JOURNAL OF GEOGRAPHY IN HIGHER EDUCATION": 1.638,
  "JOURNAL OF SIMULATION": 1.638,
  "MATHEMATICAL METHODS IN THE APPLIED SCIENCES": 1.638,
  "SCANDINAVIAN JOURNAL OF SURGERY": 1.638,
  "JOURNAL OF HAND THERAPY": 1.638,
  "JOURNAL OF MATHEMATICAL FLUID MECHANICS": 1.637,
  "THEORETICAL AND EXPERIMENTAL PLANT PHYSIOLOGY": 1.637,
  "ANNALS OF GEOPHYSICS": 1.637,
  "EUROPEAN JOURNAL OF DENTAL EDUCATION": 1.637,
  "HORTICULTURE ENVIRONMENT AND BIOTECHNOLOGY": 1.637,
  "JOURNAL OF DEVELOPMENT STUDIES": 1.636,
  "JOURNAL OF MULTICULTURAL COUNSELING AND DEVELOPMENT": 1.636,
  "RADIOCARBON": 1.636,
  "TRANSPLANT IMMUNOLOGY": 1.636,
  "CANADIAN JOURNAL OF ELECTRICAL AND COMPUTER ENGINEERING-REVUE CANADIENNE DE GENIE ELECTRIQUE ET INFORMATIQUE": 1.636,
  "JOURNAL OF PHYSICAL ORGANIC CHEMISTRY": 1.636,
  "JOURNAL OF POLYMER RESEARCH": 1.635,
  "MICRON": 1.635,
  "ACTA NEUROBIOLOGIAE EXPERIMENTALIS": 1.635,
  "ECONOMICS OF INNOVATION AND NEW TECHNOLOGY": 1.635,
  "APPLIED NEUROPSYCHOLOGY-CHILD": 1.634,
  "APPLIED RESEARCH IN QUALITY OF LIFE": 1.634,
  "DESIGNED MONOMERS AND POLYMERS": 1.634,
  "PUBLIUS-THE JOURNAL OF FEDERALISM": 1.633,
  "AMERICAN JOURNAL OF MATHEMATICS": 1.633,
  "EUPHYTICA": 1.633,
  "FARMACIA": 1.633,
  "JOURNAL OF SEXUAL AGGRESSION": 1.633,
  "PUBLIC HEALTH GENOMICS": 1.632,
  "NATURAL HAZARDS REVIEW": 1.631,
  "PHYSICS AND CHEMISTRY OF LIQUIDS": 1.631,
  "APPLIED BIONICS AND BIOMECHANICS": 1.631,
  "DENTOMAXILLOFACIAL RADIOLOGY": 1.63,
  "ETHOLOGY": 1.63,
  "EARTH SCIENCE INFORMATICS": 1.629,
  "LEARNING DISABILITY QUARTERLY": 1.629,
  "PLANT BIOSYSTEMS": 1.629,
  "JOURNAL OF CUTANEOUS PATHOLOGY": 1.629,
  "PSYCHOLOGICA BELGICA": 1.628,
  "QUALITATIVE RESEARCH IN PSYCHOLOGY": 1.628,
  "TRANSPORT": 1.627,
  "FOOD AND NUTRITION BULLETIN": 1.627,
  "INTERNATIONAL JOURNAL OF AUTOMOTIVE TECHNOLOGY": 1.627,
  "JOURNAL OF WOOD SCIENCE": 1.626,
  "SCANDINAVIAN ACTUARIAL JOURNAL": 1.626,
  "ANIMAL WELFARE": 1.625,
  "AUSTRALIAN JOURNAL OF FORENSIC SCIENCES": 1.625,
  "CLINICAL AND EXPERIMENTAL HYPERTENSION": 1.624,
  "INTERNATIONAL JOURNAL OF DAIRY TECHNOLOGY": 1.624,
  "JOURNAL OF WINE ECONOMICS": 1.624,
  "POETICS": 1.624,
  "STEEL RESEARCH INTERNATIONAL": 1.624,
  "BREASTFEEDING MEDICINE": 1.623,
  "ENDOKRYNOLOGIA POLSKA": 1.623,
  "JOURNAL OF SCHOOL HEALTH": 1.623,
  "JOURNAL OF TRANSPORTATION ENGINEERING": 1.622,
  "ORGANIC PREPARATIONS AND PROCEDURES INTERNATIONAL": 1.622,
  "COMPARATIVE POLITICS": 1.622,
  "ECONOMICS OF EDUCATION REVIEW": 1.621,
  "JOURNAL OF ARTIFICIAL ORGANS": 1.621,
  "JOURNAL OF ANALYTICAL SCIENCE AND TECHNOLOGY": 1.62,
  "JOURNAL OF HOSPITALITY LEISURE SPORT & TOURISM EDUCATION": 1.62,
  "ARABIAN JOURNAL FOR SCIENCE AND ENGINEERING": 1.619,
  "COUNSELING PSYCHOLOGIST": 1.618,
  "PSYCHOGERIATRICS": 1.618,
  "SKELETAL RADIOLOGY": 1.618,
  "BULLETIN OF INDONESIAN ECONOMIC STUDIES": 1.617,
  "DAEDALUS": 1.617,
  "FOOD TECHNOLOGY AND BIOTECHNOLOGY": 1.617,
  "GERIATRIC NURSING": 1.616,
  "JOURNAL OF MACROMARKETING": 1.616,
  "QUANTUM INFORMATION & COMPUTATION": 1.616,
  "RESEARCH IN NONDESTRUCTIVE EVALUATION": 1.615,
  "CAMBRIDGE JOURNAL OF ECONOMICS": 1.615,
  "CURRENT PHARMACEUTICAL BIOTECHNOLOGY": 1.615,
  "JOURNAL OF BLACK PSYCHOLOGY": 1.615,
  "JOURNAL OF HUMAN DEVELOPMENT AND CAPABILITIES": 1.614,
  "LINGUISTICS AND EDUCATION": 1.613,
  "ANNALS OF ANIMAL SCIENCE": 1.613,
  "GENERAL RELATIVITY AND GRAVITATION": 1.613,
  "JOURNAL OF ELECTROCHEMICAL ENERGY CONVERSION AND STORAGE": 1.612,
  "MANAGEMENT OF BIOLOGICAL INVASIONS": 1.611,
  "INTERNATIONAL JOURNAL OF ASTROBIOLOGY": 1.611,
  "JOURNAL OF MEDIA PSYCHOLOGY-THEORIES METHODS AND APPLICATIONS": 1.611,
  "POLISH JOURNAL OF FOOD AND NUTRITION SCIENCES": 1.611,
  "BIOLOGICAL RESEARCH FOR NURSING": 1.611,
  "JOURNAL OF STATISTICAL PHYSICS": 1.61,
  "MICROSYSTEM TECHNOLOGIES-MICRO-AND NANOSYSTEMS-INFORMATION STORAGE AND PROCESSING SYSTEMS": 1.61,
  "REVISTA DE INVESTIGACION CLINICA-CLINICAL AND TRANSLATIONAL INVESTIGATION": 1.609,
  "ANNALS OF THORACIC MEDICINE": 1.609,
  "CLEAN-SOIL AIR WATER": 1.609,
  "OPEN CHEMISTRY": 1.608,
  "POPULATION ECOLOGY": 1.608,
  "JOURNAL OF RENEWABLE AND SUSTAINABLE ENERGY": 1.608,
  "NORTH AMERICAN JOURNAL OF FISHERIES MANAGEMENT": 1.608,
  "ADVANCES IN DIFFERENCE EQUATIONS": 1.608,
  "LICHENOLOGIST": 1.608,
  "ACTA VETERINARIA SCANDINAVICA": 1.607,
  "ANTHROPOLOGICAL THEORY": 1.607,
  "ACTA MECHANICA SOLIDA SINICA": 1.606,
  "JOURNAL OF THE SOCIETY FOR SOCIAL WORK AND RESEARCH": 1.606,
  "LAW AND SOCIAL INQUIRY-JOURNAL OF THE AMERICAN BAR FOUNDATION": 1.606,
  "GEOMETRIC AND FUNCTIONAL ANALYSIS": 1.605,
  "INTERNATIONAL JOURNAL OF CONSUMER STUDIES": 1.605,
  "JOURNAL OF DENTAL EDUCATION": 1.605,
  "JOURNAL OF NAVIGATION": 1.605,
  "JOURNAL OF APPLIED ORAL SCIENCE": 1.605,
  "OSTOMY WOUND MANAGEMENT": 1.605,
  "SEMINARS IN PEDIATRIC NEUROLOGY": 1.604,
  "EXPERT SYSTEMS": 1.604,
  "IMA JOURNAL OF APPLIED MATHEMATICS": 1.604,
  "JOURNAL OF CHILD HEALTH CARE": 1.604,
  "PROFESIONAL DE LA INFORMACION": 1.604,
  "INTERNATIONAL JOURNAL OF LANGUAGE & COMMUNICATION DISORDERS": 1.603,
  "INTERNATIONAL JOURNAL OF APPLIED MATHEMATICS AND COMPUTER SCIENCE": 1.603,
  "SOUTH AFRICAN JOURNAL OF BOTANY": 1.603,
  "COMBINATORIAL CHEMISTRY & HIGH THROUGHPUT SCREENING": 1.603,
  "JOURNAL OF VETERINARY SCIENCE": 1.603,
  "PERCEPTION": 1.603,
  "AQUACULTURE RESEARCH": 1.601,
  "JOURNAL OF ECONOMIC DYNAMICS & CONTROL": 1.6,
  "INTERNATIONAL JOURNAL OF STD & AIDS": 1.6,
  "MONATSHEFTE FUR CHEMIE": 1.6,
  "ARCHAEOLOGICAL PROSPECTION": 1.6,
  "BMC BIOPHYSICS": 1.6,
  "BULLETIN OF GEOSCIENCES": 1.6,
  "CURRENT PROBLEMS IN SURGERY": 1.599,
  "CLINICAL NURSING RESEARCH": 1.598,
  "ECONOMICA": 1.598,
  "ETHOS": 1.598,
  "EMERGENCY MEDICINE AUSTRALASIA": 1.598,
  "GEODERMA REGIONAL": 1.597,
  "IEEE EMBEDDED SYSTEMS LETTERS": 1.597,
  "JOURNAL OF MICROPALAEONTOLOGY": 1.597,
  "JOURNAL OF NURSING CARE QUALITY": 1.597,
  "JOURNAL OF REPRODUCTION AND DEVELOPMENT": 1.597,
  "JOURNAL OF SPORT REHABILITATION": 1.597,
  "JAPANESE JOURNAL OF RADIOLOGY": 1.596,
  "JOURNAL OF HUMAN CAPITAL": 1.596,
  "NEW ZEALAND JOURNAL OF MARINE AND FRESHWATER RESEARCH": 1.596,
  "NURSING INQUIRY": 1.596,
  "PHYTOKEYS": 1.596,
  "REVIEW OF HIGHER EDUCATION": 1.596,
  "ROMANIAN JOURNAL OF MORPHOLOGY AND EMBRYOLOGY": 1.595,
  "SCIENCE PROGRESS": 1.595,
  "SOLDERING & SURFACE MOUNT TECHNOLOGY": 1.595,
  "SPORT PSYCHOLOGIST": 1.595,
  "TRANSPORTATION LETTERS-THE INTERNATIONAL JOURNAL OF TRANSPORTATION RESEARCH": 1.593,
  "REVISTA DA SOCIEDADE BRASILEIRA DE MEDICINA TROPICAL": 1.593,
  "EUROPEAN JOURNAL OF DRUG METABOLISM AND PHARMACOKINETICS": 1.593,
  "PEDIATRICS AND NEONATOLOGY": 1.593,
  "EMPLOYEE RELATIONS": 1.593,
  "GEOMETRY & TOPOLOGY": 1.593,
  "INTERNATIONAL OPHTHALMOLOGY": 1.592,
  "IRANIAN JOURNAL OF FUZZY SYSTEMS": 1.592,
  "JOURNAL OF CHEMICAL SCIENCES": 1.592,
  "DENTAL TRAUMATOLOGY": 1.592,
  "ETHNOS": 1.592,
  "INTERNATIONAL JOURNAL OF EXPERIMENTAL PATHOLOGY": 1.591,
  "JOURNAL OF SEISMOLOGY": 1.591,
  "NORTHWESTERN UNIVERSITY LAW REVIEW": 1.591,
  "INFORMATION TECHNOLOGY FOR DEVELOPMENT": 1.591,
  "LYMPHATIC RESEARCH AND BIOLOGY": 1.591,
  "AMERICAN JOURNAL OF EVALUATION": 1.591,
  "CHEMISTRY OF HETEROCYCLIC COMPOUNDS": 1.59,
  "HEAD & FACE MEDICINE": 1.59,
  "SOLID-STATE ELECTRONICS": 1.589,
  "E-POLYMERS": 1.589,
  "HEALTH RISK & SOCIETY": 1.588,
  "JOURNAL OF LOW TEMPERATURE PHYSICS": 1.588,
  "DEVIANT BEHAVIOR": 1.588,
  "GEOSCIENCES JOURNAL": 1.588,
  "HIGH ALTITUDE MEDICINE & BIOLOGY": 1.587,
  "JOURNAL OF POROUS MEDIA": 1.587,
  "HISTORICAL BIOLOGY": 1.587,
  "JOURNAL OF EMERGENCY NURSING": 1.586,
  "INTERNATIONAL JOURNAL OF ENVIRONMENTAL RESEARCH": 1.586,
  "ARCHIVES OF DISEASE IN CHILDHOOD-EDUCATION AND PRACTICE EDITION": 1.586,
  "CLINICAL OBSTETRICS AND GYNECOLOGY": 1.586,
  "JOURNAL OF ECONOMIC INTERACTION AND COORDINATION": 1.586,
  "CHEMISTRY LETTERS": 1.585,
  "CRIMINOLOGY & CRIMINAL JUSTICE": 1.585,
  "JOURNAL OF COMPARATIVE EFFECTIVENESS RESEARCH": 1.585,
  "KNOWLEDGE MANAGEMENT RESEARCH & PRACTICE": 1.585,
  "OPERATIONAL RESEARCH": 1.585,
  "FORUM OF MATHEMATICS SIGMA": 1.585,
  "INTERNATIONAL JOURNAL OF PUBLIC OPINION RESEARCH": 1.584,
  "ARCHIVES OF ENVIRONMENTAL & OCCUPATIONAL HEALTH": 1.584,
  "MICROELECTRONICS RELIABILITY": 1.584,
  "ONCOLOGY RESEARCH AND TREATMENT": 1.584,
  "INTERNATIONAL JOURNAL OF TRANSITIONAL JUSTICE": 1.584,
  "JOURNAL OF STRATEGIC STUDIES": 1.584,
  "PROSTHETICS AND ORTHOTICS INTERNATIONAL": 1.583,
  "ACCOUNTING AND FINANCE": 1.583,
  "BRITISH JOURNAL OF NEUROSURGERY": 1.583,
  "CRITICAL SOCIOLOGY": 1.582,
  "ECONOMIC BOTANY": 1.582,
  "INTERNATIONAL JOURNAL OF COSMETIC SCIENCE": 1.582,
  "JOURNAL OF HOUSING AND THE BUILT ENVIRONMENT": 1.582,
  "MAGNETIC RESONANCE IN MEDICAL SCIENCES": 1.581,
  "TECHNOLOGY IN CANCER RESEARCH & TREATMENT": 1.581,
  "HEALTH": 1.581,
  "NEW ZEALAND JOURNAL OF GEOLOGY AND GEOPHYSICS": 1.58,
  "ACTAS ESPANOLAS DE PSIQUIATRIA": 1.58,
  "COMPUTER SUPPORTED COOPERATIVE WORK-THE JOURNAL OF COLLABORATIVE COMPUTING": 1.58,
  "JOURNAL DE MYCOLOGIE MEDICALE": 1.58,
  "JOURNAL OF DISPERSION SCIENCE AND TECHNOLOGY": 1.58,
  "JOURNAL OF HEAT TRANSFER-TRANSACTIONS OF THE ASME": 1.579,
  "OENO ONE": 1.578,
  "SEX EDUCATION-SEXUALITY SOCIETY AND LEARNING": 1.578,
  "ACTA OECOLOGICA-INTERNATIONAL JOURNAL OF ECOLOGY": 1.578,
  "HOUSING THEORY & SOCIETY": 1.578,
  "JOURNAL OF INTERNATIONAL FINANCIAL MANAGEMENT & ACCOUNTING": 1.578,
  "JOURNAL OF CLINICAL PSYCHOLOGY IN MEDICAL SETTINGS": 1.577,
  "JOURNAL OF TERRAMECHANICS": 1.577,
  "CRIME AND JUSTICE-A REVIEW OF RESEARCH": 1.577,
  "JOURNAL OF MATERIALS ENGINEERING AND PERFORMANCE": 1.577,
  "KOREAN JOURNAL OF ORTHODONTICS": 1.577,
  "PHYSICS AND CHEMISTRY OF MINERALS": 1.576,
  "ELECTRONIC TRANSACTIONS ON NUMERICAL ANALYSIS": 1.576,
  "JOURNAL OF DYNAMICS AND DIFFERENTIAL EQUATIONS": 1.576,
  "SEXUALITIES": 1.576,
  "CYTOPATHOLOGY": 1.576,
  "JOURNAL OF VECTOR BORNE DISEASES": 1.576,
  "SEMINARS IN NEUROLOGY": 1.575,
  "INTERNATIONAL JOURNAL OF RF AND MICROWAVE COMPUTER-AIDED ENGINEERING": 1.575,
  "JOURNAL OF ORNITHOLOGY": 1.575,
  "JOURNAL OF MINERALOGICAL AND PETROLOGICAL SCIENCES": 1.574,
  "JOURNAL OF PERIODONTAL AND IMPLANT SCIENCE": 1.574,
  "SURGICAL INNOVATION": 1.574,
  "CLEFT PALATE-CRANIOFACIAL JOURNAL": 1.574,
  "DISABILITY AND HEALTH JOURNAL": 1.574,
  "INTERNATIONAL STUDIES PERSPECTIVES": 1.573,
  "JAPANESE JOURNAL OF APPLIED PHYSICS": 1.573,
  "MARINE GEOPHYSICAL RESEARCH": 1.573,
  "JOURNAL OF CARDIOTHORACIC SURGERY": 1.573,
  "OPERATIVE NEUROSURGERY": 1.573,
  "ANTIQUITY": 1.573,
  "BALTIC JOURNAL OF MANAGEMENT": 1.572,
  "CHILD & YOUTH CARE FORUM": 1.572,
  "CHINESE PHYSICS B": 1.571,
  "HOMEOPATHY": 1.571,
  "INVERSE PROBLEMS AND IMAGING": 1.571,
  "LANDSCAPE AND ECOLOGICAL ENGINEERING": 1.571,
  "VOLUNTAS": 1.571,
  "CURRENT PSYCHOLOGY": 1.571,
  "GENDER PLACE AND CULTURE": 1.57,
  "ACM JOURNAL ON COMPUTING AND CULTURAL HERITAGE": 1.57,
  "ECOLOGICAL CHEMISTRY AND ENGINEERING S-CHEMIA I INZYNIERIA EKOLOGICZNA S": 1.569,
  "JOURNAL OF INTELLECTUAL & DEVELOPMENTAL DISABILITY": 1.569,
  "JOURNAL OF RESEARCH IN MEDICAL SCIENCES": 1.569,
  "MEDICINA-LITHUANIA": 1.569,
  "RESEARCH IN INTERNATIONAL BUSINESS AND FINANCE": 1.569,
  "ZAMM-ZEITSCHRIFT FUR ANGEWANDTE MATHEMATIK UND MECHANIK": 1.568,
  "DRUGS-EDUCATION PREVENTION AND POLICY": 1.568,
  "JOURNAL OF DYNAMIC SYSTEMS MEASUREMENT AND CONTROL-TRANSACTIONS OF THE ASME": 1.568,
  "PURE AND APPLIED GEOPHYSICS": 1.568,
  "INTERNATIONAL JOURNAL OF ENVIRONMENTAL HEALTH RESEARCH": 1.568,
  "INTERNATIONAL JOURNAL OF NAVAL ARCHITECTURE AND OCEAN ENGINEERING": 1.568,
  "MATERIALS EXPRESS": 1.568,
  "NUCLEAR MEDICINE COMMUNICATIONS": 1.568,
  "TRAFFIC INJURY PREVENTION": 1.568,
  "AMERICAN JOURNAL OF ALZHEIMERS DISEASE AND OTHER DEMENTIAS": 1.568,
  "CHINESE GEOGRAPHICAL SCIENCE": 1.566,
  "DIAGNOSTIC AND INTERVENTIONAL RADIOLOGY": 1.566,
  "GERMAN POLITICS": 1.565,
  "INVERSE PROBLEMS IN SCIENCE AND ENGINEERING": 1.565,
  "PLANT PROTECTION SCIENCE": 1.565,
  "CELLULAR AND MOLECULAR BIOLOGY": 1.565,
  "CARBON MANAGEMENT": 1.564,
  "EMOTION SPACE AND SOCIETY": 1.564,
  "JOURNAL OF ENVIRONMENTAL SCIENCE AND HEALTH PART B-PESTICIDES FOOD CONTAMINANTS AND AGRICULTURAL WASTES": 1.564,
  "NUCLEAR PHYSICS A": 1.563,
  "UROLOGY JOURNAL": 1.563,
  "ANALYSIS & PDE": 1.563,
  "BOREAL ENVIRONMENT RESEARCH": 1.563,
  "INTERNATIONAL JOURNAL OF FOREST ENGINEERING": 1.563,
  "JOURNAL OF ANESTHESIA": 1.563,
  "LEADERSHIP & ORGANIZATION DEVELOPMENT JOURNAL": 1.563,
  "REGIONAL STUDIES IN MARINE SCIENCE": 1.563,
  "COMMUNITY MENTAL HEALTH JOURNAL": 1.562,
  "DOCUMENTA OPHTHALMOLOGICA": 1.562,
  "GERODONTOLOGY": 1.562,
  "PSYCHOLOGY CRIME & LAW": 1.562,
  "ROMANIAN JOURNAL OF PHYSICS": 1.561,
  "MOTIVATION AND EMOTION": 1.561,
  "ANNALS OF OTOLOGY RHINOLOGY AND LARYNGOLOGY": 1.561,
  "BOSNIAN JOURNAL OF BASIC MEDICAL SCIENCES": 1.561,
  "JOURNAL OF LOWER GENITAL TRACT DISEASE": 1.561,
  "MATERIALS AND CORROSION-WERKSTOFFE UND KORROSION": 1.561,
  "STANDARDS IN GENOMIC SCIENCES": 1.561,
  "FUSION ENGINEERING AND DESIGN": 1.56,
  "JOURNAL OF MOLECULAR MICROBIOLOGY AND BIOTECHNOLOGY": 1.559,
  "LAW & POLICY": 1.559,
  "MEDICAL ANTHROPOLOGY": 1.559,
  "WESTERN JOURNAL OF NURSING RESEARCH": 1.559,
  "AMERICAN HISTORICAL REVIEW": 1.559,
  "CULTURE MEDICINE AND PSYCHIATRY": 1.559,
  "AQUACULTURE INTERNATIONAL": 1.558,
  "AUSTRALIAN & NEW ZEALAND JOURNAL OF OBSTETRICS & GYNAECOLOGY": 1.558,
  "CENTRAL EUROPEAN JOURNAL OF IMMUNOLOGY": 1.558,
  "JOURNAL OF AMERICAN COLLEGE HEALTH": 1.557,
  "JOURNAL OF TOURISM AND CULTURAL CHANGE": 1.557,
  "MATHEMATICS AND FINANCIAL ECONOMICS": 1.556,
  "PAIN MANAGEMENT NURSING": 1.556,
  "SIMULATION-TRANSACTIONS OF THE SOCIETY FOR MODELING AND SIMULATION INTERNATIONAL": 1.556,
  "IN VITRO CELLULAR & DEVELOPMENTAL BIOLOGY-PLANT": 1.556,
  "PHYSICA STATUS SOLIDI B-BASIC SOLID STATE PHYSICS": 1.556,
  "ACI MATERIALS JOURNAL": 1.555,
  "AMERICAN ECONOMIC JOURNAL-MICROECONOMICS": 1.555,
  "CELLULAR REPROGRAMMING": 1.554,
  "EUROPEAN SECURITY": 1.554,
  "JOURNAL OF VOICE": 1.554,
  "INTERNATIONAL MATHEMATICS RESEARCH NOTICES": 1.553,
  "JOURNAL OF PHARMACEUTICAL INNOVATION": 1.553,
  "OPTIMAL CONTROL APPLICATIONS & METHODS": 1.553,
  "BIT NUMERICAL MATHEMATICS": 1.552,
  "INTERNATIONAL ECONOMIC REVIEW": 1.552,
  "INVERTEBRATE BIOLOGY": 1.552,
  "JOURNAL OF METEOROLOGICAL RESEARCH": 1.552,
  "JOURNAL OF PRIMARY PREVENTION": 1.552,
  "PHYSICAL COMMUNICATION": 1.551,
  "ENVIRONMENTAL ENTOMOLOGY": 1.551,
  "INTERNATIONAL JOURNAL OF HEALTH PLANNING AND MANAGEMENT": 1.551,
  "INTERVENTIONAL NEURORADIOLOGY": 1.551,
  "MEDICINE HEALTH CARE AND PHILOSOPHY": 1.55,
  "NONLINEAR ANALYSIS-THEORY METHODS & APPLICATIONS": 1.55,
  "POPULATION": 1.55,
  "WILDERNESS & ENVIRONMENTAL MEDICINE": 1.549,
  "CHEMISTRY & BIODIVERSITY": 1.549,
  "JOURNAL OF FUTURES MARKETS": 1.548,
  "MATERIALS RESEARCH EXPRESS": 1.548,
  "SIAM JOURNAL ON APPLIED MATHEMATICS": 1.548,
  "ANNALS OF PLASTIC SURGERY": 1.547,
  "ADVANCES IN DIFFERENTIAL EQUATIONS": 1.546,
  "EXPERIMENTAL AND THERAPEUTIC MEDICINE": 1.546,
  "FOLIA MICROBIOLOGICA": 1.545,
  "JOURNAL OF FOOD PROCESS ENGINEERING": 1.545,
  "POLICING & SOCIETY": 1.545,
  "SYSTEM DYNAMICS REVIEW": 1.545,
  "INTERNATIONAL REGIONAL SCIENCE REVIEW": 1.545,
  "NEW ZEALAND JOURNAL OF ECOLOGY": 1.545,
  "INTERNATIONAL JOURNAL OF OLDER PEOPLE NURSING": 1.544,
  "JOURNAL OF INSECT SCIENCE": 1.544,
  "CHINESE JOURNAL OF INTEGRATIVE MEDICINE": 1.543,
  "MADERAS-CIENCIA Y TECNOLOGIA": 1.543,
  "AMERICAN BEHAVIORAL SCIENTIST": 1.543,
  "AURIS NASUS LARYNX": 1.543,
  "ASIA PACIFIC JOURNAL OF TOURISM RESEARCH": 1.542,
  "JOURNAL INTERNATIONAL DES SCIENCES DE LA VIGNE ET DU VIN": 1.542,
  "SEXUAL MEDICINE": 1.542,
  "AUSTRALIAN ACCOUNTING REVIEW": 1.542,
  "EUROPEAN JOURNAL OF SOCIAL THEORY": 1.541,
  "JOURNAL OF LASER APPLICATIONS": 1.541,
  "JOURNAL OF ORAL & FACIAL PAIN AND HEADACHE": 1.541,
  "SELF AND IDENTITY": 1.541,
  "CALIFORNIA AGRICULTURE": 1.541,
  "MICROBIOLOGY AND IMMUNOLOGY": 1.541,
  "PACIFIC-BASIN FINANCE JOURNAL": 1.54,
  "SURVEY REVIEW": 1.54,
  "AQUATIC GEOCHEMISTRY": 1.54,
  "EUROPEAN PHYSICAL JOURNAL B": 1.539,
  "EUROPEAN JOURNAL OF DEVELOPMENT RESEARCH": 1.539,
  "INTERNATIONAL JOURNAL OF ARCHITECTURAL HERITAGE": 1.539,
  "CHILD AND ADOLESCENT MENTAL HEALTH": 1.539,
  "CHILDRENS GEOGRAPHIES": 1.539,
  "FIBERS AND POLYMERS": 1.538,
  "NEFROLOGIA": 1.538,
  "SYNTHETIC COMMUNICATIONS": 1.538,
  "SEMICONDUCTORS AND SEMIMETALS": 1.538,
  "ADULT EDUCATION QUARTERLY": 1.538,
  "AMERICAN JOURNAL OF HUMAN BIOLOGY": 1.538,
  "ATMOSFERA": 1.538,
  "BIOTECHNOLOGY AND BIOPROCESS ENGINEERING": 1.537,
  "BRITISH DENTAL JOURNAL": 1.537,
  "JOURNAL OF FORENSIC SCIENCES": 1.537,
  "JOURNAL OF HOMOSEXUALITY": 1.537,
  "JOURNAL OF HYDROLOGIC ENGINEERING": 1.536,
  "NEBRASKA SYMPOSIUM ON MOTIVATION": 1.536,
  "ONCOLOGY NURSING FORUM": 1.536,
  "OPTO-ELECTRONICS REVIEW": 1.536,
  "GEOFLUIDS": 1.536,
  "INTERNATIONAL JOURNAL OF SUSTAINABILITY IN HIGHER EDUCATION": 1.536,
  "JOURNAL OF VECTOR ECOLOGY": 1.535,
  "WORLD JOURNAL OF EMERGENCY MEDICINE": 1.534,
  "AMERICAN JOURNAL OF HEALTH BEHAVIOR": 1.534,
  "ARHIV ZA HIGIJENU RADA I TOKSIKOLOGIJU-ARCHIVES OF INDUSTRIAL HYGIENE AND TOXICOLOGY": 1.534,
  "BOSTON UNIVERSITY LAW REVIEW": 1.534,
  "ECOLOGICAL MANAGEMENT & RESTORATION": 1.533,
  "JOURNAL OF HELMINTHOLOGY": 1.533,
  "LANGUAGE AND SPEECH": 1.533,
  "MULTINATIONAL BUSINESS REVIEW": 1.533,
  "ADVANCES IN MATHEMATICS": 1.533,
  "COMPUTER APPLICATIONS IN ENGINEERING EDUCATION": 1.533,
  "JOURNAL OF EVOLUTIONARY ECONOMICS": 1.533,
  "RADIATION MEASUREMENTS": 1.532,
  "FOREST PATHOLOGY": 1.532,
  "SCIENTIA AGRICOLA": 1.532,
  "LANGUAGE AND INTERCULTURAL COMMUNICATION": 1.531,
  "NUCLEAR INSTRUMENTS & METHODS IN PHYSICS RESEARCH SECTION A-ACCELERATORS SPECTROMETERS DETECTORS AND ASSOCIATED EQUIPMENT": 1.531,
  "SOLID STATE COMMUNICATIONS": 1.531,
  "ADVANCES IN COGNITIVE PSYCHOLOGY": 1.531,
  "INTERNATIONAL REVIEW OF ECONOMICS & FINANCE": 1.531,
  "MCN-THE AMERICAN JOURNAL OF MATERNAL-CHILD NURSING": 1.531,
  "SCANDINAVIAN JOURNAL OF EDUCATIONAL RESEARCH": 1.531,
  "ANNALS OF MICROBIOLOGY": 1.53,
  "BMC OPHTHALMOLOGY": 1.53,
  "CHEMICAL ENGINEERING COMMUNICATIONS": 1.53,
  "EUROPEAN JOURNAL OF TRANSPORT AND INFRASTRUCTURE RESEARCH": 1.53,
  "JOURNAL OF CAREER DEVELOPMENT": 1.529,
  "SAFETY AND HEALTH AT WORK": 1.529,
  "ANNALES D ENDOCRINOLOGIE": 1.528,
  "JOURNAL OF PSYCHOLOGY": 1.528,
  "ADVANCES IN APPLIED CERAMICS": 1.528,
  "BEHAVIOUR & INFORMATION TECHNOLOGY": 1.528,
  "INNOVATION-ORGANIZATION & MANAGEMENT": 1.527,
  "INTERNATIONAL PERSPECTIVES ON SEXUAL AND REPRODUCTIVE HEALTH": 1.527,
  "JOURNAL OF INCLUSION PHENOMENA AND MACROCYCLIC CHEMISTRY": 1.527,
  "JOURNAL OF NANOPHOTONICS": 1.527,
  "IEEE TRANSACTIONS ON NUCLEAR SCIENCE": 1.527,
  "KSCE JOURNAL OF CIVIL ENGINEERING": 1.527,
  "REACTION KINETICS MECHANISMS AND CATALYSIS": 1.526,
  "ISIJ INTERNATIONAL": 1.526,
  "JOURNAL OF CARDIOVASCULAR MEDICINE": 1.526,
  "JOURNAL OF RENEWABLE MATERIALS": 1.525,
  "ARCTIC": 1.525,
  "BEHAVIOURAL AND COGNITIVE PSYCHOTHERAPY": 1.525,
  "INTERNATIONAL JOURNAL OF POLYMER ANALYSIS AND CHARACTERIZATION": 1.525,
  "INTERNATIONAL JOURNAL OF PLANT SCIENCES": 1.525,
  "LIBRARY & INFORMATION SCIENCE RESEARCH": 1.525,
  "DENTAL MATERIALS JOURNAL": 1.524,
  "ETHICS & INTERNATIONAL AFFAIRS": 1.524,
  "INTERNATIONAL JOURNAL OF QUALITATIVE STUDIES ON HEALTH AND WELL-BEING": 1.524,
  "PARTICULATE SCIENCE AND TECHNOLOGY": 1.524,
  "SHOCK WAVES": 1.523,
  "CYTOGENETIC AND GENOME RESEARCH": 1.523,
  "FLORA": 1.523,
  "INTERNATIONAL JOURNAL OF MEDICINAL MUSHROOMS": 1.523,
  "JOURNAL OF ETHOLOGY": 1.523,
  "JOURNAL OF MOUNTAIN SCIENCE": 1.522,
  "TEST": 1.522,
  "CANADIAN JOURNAL OF EARTH SCIENCES": 1.522,
  "GEOSPATIAL HEALTH": 1.522,
  "JOURNAL OF CUTANEOUS MEDICINE AND SURGERY": 1.522,
  "OPHTHALMIC SURGERY LASERS & IMAGING RETINA": 1.522,
  "BRITISH POULTRY SCIENCE": 1.522,
  "COMPUTER AIDED GEOMETRIC DESIGN": 1.522,
  "JOURNAL OF DAIRY RESEARCH": 1.521,
  "JOURNAL OF PHASE EQUILIBRIA AND DIFFUSION": 1.521,
  "SEXUAL HEALTH": 1.521,
  "ASSAY AND DRUG DEVELOPMENT TECHNOLOGIES": 1.521,
  "FIRE TECHNOLOGY": 1.52,
  "INTERNATIONAL JOURNAL OF MENTAL HEALTH AND ADDICTION": 1.52,
  "JOURNAL OF CURRICULUM STUDIES": 1.519,
  "JOURNAL OF PUBLIC HEALTH MANAGEMENT AND PRACTICE": 1.519,
  "RADIOLOGIA MEDICA": 1.519,
  "AUTONOMOUS AGENTS AND MULTI-AGENT SYSTEMS": 1.519,
  "INTERNATIONAL INTERACTIONS": 1.519,
  "SOCIAL WORK": 1.518,
  "IFOREST-BIOGEOSCIENCES AND FORESTRY": 1.518,
  "INTERNATIONAL JOURNAL OF TECHNOLOGY ASSESSMENT IN HEALTH CARE": 1.518,
  "INTERDISCIPLINARY SCIENCES-COMPUTATIONAL LIFE SCIENCES": 1.518,
  "JOURNAL OF CULTURAL ECONOMY": 1.517,
  "NOISE & HEALTH": 1.517,
  "SOCIOLOGY OF SPORT JOURNAL": 1.517,
  "IISE TRANSACTIONS": 1.517,
  "INTERNATIONAL JOURNAL OF CHEMICAL KINETICS": 1.517,
  "JOURNAL OF GEOGRAPHICAL SYSTEMS": 1.517,
  "PERIODICO DI MINERALOGIA": 1.517,
  "VIRAL IMMUNOLOGY": 1.517,
  "COMMUNICATIONS IN THEORETICAL PHYSICS": 1.516,
  "JOURNAL OF CROSS-CULTURAL PSYCHOLOGY": 1.516,
  "INTERNATIONAL EMERGENCY NURSING": 1.516,
  "JOURNAL OF PESTICIDE SCIENCE": 1.516,
  "JOURNAL OF FOOD MEASUREMENT AND CHARACTERIZATION": 1.516,
  "JOURNAL OF MANAGERIAL PSYCHOLOGY": 1.515,
  "SOIL SCIENCE AND PLANT NUTRITION": 1.515,
  "SCANDINAVIAN JOURNAL OF MANAGEMENT": 1.515,
  "VISUAL COMPUTER": 1.515,
  "GLOBAL GOVERNANCE": 1.514,
  "JOURNAL OF HUMAN KINETICS": 1.514,
  "PERSONALIZED MEDICINE": 1.514,
  "CHINESE JOURNAL OF MECHANICAL ENGINEERING": 1.513,
  "GEOGRAFISKA ANNALER SERIES B-HUMAN GEOGRAPHY": 1.513,
  "PEDIATRIC CARDIOLOGY": 1.513,
  "SCHOOL PSYCHOLOGY INTERNATIONAL": 1.513,
  "AUSTRALIAN PSYCHOLOGIST": 1.512,
  "INSECTES SOCIAUX": 1.512,
  "JETP LETTERS": 1.512,
  "SEMINARS IN ONCOLOGY NURSING": 1.512,
  "TRANSFUSION AND APHERESIS SCIENCE": 1.511,
  "FULLERENES NANOTUBES AND CARBON NANOSTRUCTURES": 1.511,
  "INDIAN JOURNAL OF DERMATOLOGY": 1.51,
  "JOURNAL OF INSTITUTIONAL ECONOMICS": 1.51,
  "CARDIOVASCULAR JOURNAL OF AFRICA": 1.509,
  "DEVELOPING WORLD BIOETHICS": 1.509,
  "PATTERN ANALYSIS AND APPLICATIONS": 1.508,
  "PUBLICACIONS MATEMATIQUES": 1.508,
  "AMERICAN JOURNAL OF MENS HEALTH": 1.507,
  "MATHEMATICS AND COMPUTERS IN SIMULATION": 1.506,
  "QUALITY AND RELIABILITY ENGINEERING INTERNATIONAL": 1.506,
  "ACTA OTORHINOLARYNGOLOGICA ITALICA": 1.506,
  "SYSTEMATIC PARASITOLOGY": 1.506,
  "HEALTH AND HUMAN RIGHTS": 1.506,
  "JOURNAL OF FINANCIAL MARKETS": 1.506,
  "LIBYAN JOURNAL OF MEDICINE": 1.506,
  "RESEARCH-TECHNOLOGY MANAGEMENT": 1.505,
  "REVIEW JOURNAL OF AUTISM AND DEVELOPMENTAL DISORDERS": 1.505,
  "FUSION SCIENCE AND TECHNOLOGY": 1.505,
  "GYNECOLOGICAL ENDOCRINOLOGY": 1.505,
  "HISTORY AND ANTHROPOLOGY": 1.505,
  "INTERNATIONAL JOURNAL OF EDUCATIONAL DEVELOPMENT": 1.504,
  "JOURNAL OF SHIP RESEARCH": 1.504,
  "ACTA PHARMACEUTICA": 1.504,
  "ACTA POLYMERICA SINICA": 1.504,
  "CHEMICAL & PHARMACEUTICAL BULLETIN": 1.503,
  "DYNAMICS OF ATMOSPHERES AND OCEANS": 1.503,
  "FOLIA PARASITOLOGICA": 1.503,
  "JOURNAL OF APPLIED PHILOSOPHY": 1.503,
  "AFRICAN ARCHAEOLOGICAL REVIEW": 1.502,
  "JOURNAL OF ECONOMIC BEHAVIOR & ORGANIZATION": 1.502,
  "JOURNAL OF FORAMINIFERAL RESEARCH": 1.501,
  "JOURNAL OF PSYCHOEDUCATIONAL ASSESSMENT": 1.501,
  "LEGAL MEDICINE": 1.5,
  "QUANTUM ELECTRONICS": 1.5,
  "AUSTRAL ECOLOGY": 1.5,
  "JOURNAL OF APPLIED BIOMATERIALS & FUNCTIONAL MATERIALS": 1.5,
  "DIAGNOSTIC CYTOPATHOLOGY": 1.5,
  "JOURNAL OF COUNSELING AND DEVELOPMENT": 1.5,
  "PROCEEDINGS OF THE ROMANIAN ACADEMY SERIES A-MATHEMATICS PHYSICS TECHNICAL SCIENCES INFORMATION SCIENCE": 1.5,
  "BEHAVIOUR": 1.5,
  "SCANDINAVIAN JOURNAL OF UROLOGY": 1.5,
  "SEMINARS IN OPHTHALMOLOGY": 1.5,
  "UROLOGIA INTERNATIONALIS": 1.5,
  "CHINESE SOCIOLOGICAL REVIEW": 1.5,
  "JOURNAL OF ORGANIZATIONAL COMPUTING AND ELECTRONIC COMMERCE": 1.5,
  "JOURNAL OF THE INSTITUTE OF MATHEMATICS OF JUSSIEU": 1.5,
  "MATHEMATICAL MEDICINE AND BIOLOGY-A JOURNAL OF THE IMA": 1.5,
  "MINDS AND MACHINES": 1.5,
  "PHILOSOPHY ETHICS AND HUMANITIES IN MEDICINE": 1.5,
  "SCIENCE AS CULTURE": 1.5,
  "AESTHETIC PLASTIC SURGERY": 1.5,
  "ADVANCES IN MATERIALS SCIENCE AND ENGINEERING": 1.5,
  "OPTIMIZATION LETTERS": 1.5,
  "CANADIAN MINERALOGIST": 1.5,
  "INTERNATIONAL JOURNAL OF FOOD PROPERTIES": 1.5,
  "JOURNAL OF AGRICULTURAL & ENVIRONMENTAL ETHICS": 1.5,
  "INTEGRATIVE PSYCHOLOGICAL AND BEHAVIORAL SCIENCE": 1.5,
  "JOURNAL OF VASCULAR ACCESS": 1.5,
  "ORGANIZATIONAL DYNAMICS": 1.5,
  "PEDIATRIC SURGERY INTERNATIONAL": 1.5,
  "ASIA-PACIFIC JOURNAL OF CHEMICAL ENGINEERING": 1.5,
  "BIORESOURCES": 1.5,
  "COGNITIVE AND BEHAVIORAL NEUROLOGY": 1.498,
  "LEARNING AND MOTIVATION": 1.497,
  "SALUD PUBLICA DE MEXICO": 1.497,
  "WIRELESS COMMUNICATIONS & MOBILE COMPUTING": 1.496,
  "JOURNAL OF FAMILY STUDIES": 1.496,
  "REVISTA LATINOAMERICANA DE PSICOLOGIA": 1.496,
  "CIVIL ENGINEERING AND ENVIRONMENTAL SYSTEMS": 1.496,
  "COMMUNICATIONS IN CONTEMPORARY MATHEMATICS": 1.496,
  "HELVETICA CHIMICA ACTA": 1.494,
  "JOURNAL OF ENGINEERING DESIGN": 1.494,
  "JOURNAL OF FOURIER ANALYSIS AND APPLICATIONS": 1.494,
  "JOURNAL OF DRUGS IN DERMATOLOGY": 1.494,
  "ADVANCED COMPOSITE MATERIALS": 1.494,
  "BERNOULLI": 1.493,
  "CORROSION ENGINEERING SCIENCE AND TECHNOLOGY": 1.493,
  "MATERIALE PLASTICE": 1.492,
  "IET SYSTEMS BIOLOGY": 1.492,
  "JOURNAL OF APPLIED BIOMECHANICS": 1.492,
  "JOURNAL OF HEURISTICS": 1.492,
  "JOURNAL OF CANCER RESEARCH AND THERAPEUTICS": 1.491,
  "QUINTESSENCE INTERNATIONAL": 1.491,
  "REHABILITATION PSYCHOLOGY": 1.491,
  "JOURNAL OF OBSESSIVE-COMPULSIVE AND RELATED DISORDERS": 1.49,
  "PHYSIOLOGICAL ENTOMOLOGY": 1.49,
  "TOURIST STUDIES": 1.49,
  "TERRORISM AND POLITICAL VIOLENCE": 1.49,
  "JOURNAL OF EMPIRICAL LEGAL STUDIES": 1.489,
  "FUNCTIONAL MATERIALS LETTERS": 1.489,
  "JOURNAL OF AGRICULTURAL EDUCATION & EXTENSION": 1.489,
  "JOURNAL OF CHILDREN AND MEDIA": 1.488,
  "MOUNTAIN RESEARCH AND DEVELOPMENT": 1.487,
  "NEW CARBON MATERIALS": 1.487,
  "INTERNATIONAL JOURNAL OF MODERN PHYSICS E": 1.487,
  "JOURNAL OF NEMATOLOGY": 1.485,
  "JOURNAL OF THE WORLD AQUACULTURE SOCIETY": 1.485,
  "INTERNATIONAL RELATIONS": 1.485,
  "X-RAY SPECTROMETRY": 1.485,
  "BIOLOGIA PLANTARUM": 1.485,
  "COGNITIVE SYSTEMS RESEARCH": 1.484,
  "INTERNATIONAL JOURNAL OF COMPUTATIONAL FLUID DYNAMICS": 1.484,
  "WEED TECHNOLOGY": 1.483,
  "CANADIAN JOURNAL OF EXPERIMENTAL PSYCHOLOGY-REVUE CANADIENNE DE PSYCHOLOGIE EXPERIMENTALE": 1.483,
  "CLINICAL PEDIATRICS": 1.483,
  "DU BOIS REVIEW-SOCIAL SCIENCE RESEARCH ON RACE": 1.482,
  "EUROPEAN JOURNAL OF EMERGENCY MEDICINE": 1.482,
  "KINESIOLOGY": 1.482,
  "MEDICAL MOLECULAR MORPHOLOGY": 1.481,
  "SUBSTANCE USE & MISUSE": 1.481,
  "SOCIAL POLICY AND SOCIETY": 1.481,
  "EUROPEAN JOURNAL OF CONTRACEPTION AND REPRODUCTIVE HEALTH CARE": 1.481,
  "EXCEPTIONALITY": 1.481,
  "JOURNAL OF IRON AND STEEL RESEARCH INTERNATIONAL": 1.481,
  "NATURAL RESOURCES FORUM": 1.481,
  "PERIODICA POLYTECHNICA-CHEMICAL ENGINEERING": 1.481,
  "RESEARCH IN SCIENCE EDUCATION": 1.48,
  "TOXICOLOGIC PATHOLOGY": 1.48,
  "AGROECOLOGY AND SUSTAINABLE FOOD SYSTEMS": 1.479,
  "ECONOMIC RESEARCH-EKONOMSKA ISTRAZIVANJA": 1.479,
  "KYBERNETES": 1.479,
  "NATURAL LANGUAGE SEMANTICS": 1.479,
  "NAUPLIUS": 1.479,
  "PROGRESS IN ORTHODONTICS": 1.479,
  "PSYCHOLOGY OF MUSIC": 1.479,
  "ANNALS OF NUCLEAR ENERGY": 1.478,
  "HERPETOLOGICA": 1.478,
  "KINETIC AND RELATED MODELS": 1.478,
  "MYCOSCIENCE": 1.477,
  "SCANDINAVIAN JOURNAL OF CLINICAL & LABORATORY INVESTIGATION": 1.477,
  "JOURNAL OF BUON": 1.476,
  "CITIZENSHIP STUDIES": 1.476,
  "INTERNATIONAL JOURNAL OF REHABILITATION RESEARCH": 1.476,
  "ACCOUNTING HORIZONS": 1.476,
  "FLAVOUR AND FRAGRANCE JOURNAL": 1.475,
  "INTERNATIONAL JOURNAL OF OCCUPATIONAL SAFETY AND ERGONOMICS": 1.475,
  "ISLAND STUDIES JOURNAL": 1.474,
  "POLITICS": 1.473,
  "JOURNAL OF SPECTROSCOPY": 1.473,
  "LIVESTOCK SCIENCE": 1.473,
  "SECURITY AND COMMUNICATION NETWORKS": 1.472,
  "ACM TRANSACTIONS ON COMPUTER SYSTEMS": 1.472,
  "ASIA PACIFIC JOURNAL OF CLINICAL NUTRITION": 1.472,
  "ENT-EAR NOSE & THROAT JOURNAL": 1.472,
  "INTERNATIONAL JOURNAL OF MULTILINGUALISM": 1.472,
  "LEISURE STUDIES": 1.471,
  "PSYCHIATRIC GENETICS": 1.471,
  "RESEARCH IN HUMAN DEVELOPMENT": 1.471,
  "SCANDINAVIAN JOURNAL OF PSYCHOLOGY": 1.471,
  "HEALTH ECONOMICS REVIEW": 1.471,
  "CANADIAN JOURNAL OF INFECTIOUS DISEASES & MEDICAL MICROBIOLOGY": 1.471,
  "HISTORY OF THE FAMILY": 1.47,
  "IEEE INDUSTRY APPLICATIONS MAGAZINE": 1.47,
  "JOURNAL OF AEROSPACE ENGINEERING": 1.469,
  "JOURNAL OF EDUCATION FOR TEACHING": 1.469,
  "BIODEMOGRAPHY AND SOCIAL BIOLOGY": 1.469,
  "COMPUTATIONAL AND MATHEMATICAL ORGANIZATION THEORY": 1.469,
  "JOURNAL OF PROFESSIONAL ISSUES IN ENGINEERING EDUCATION AND PRACTICE": 1.469,
  "SOUTHERN AFRICAN JOURNAL OF HIV MEDICINE": 1.469,
  "JORNAL BRASILEIRO DE PNEUMOLOGIA": 1.469,
  "MEDICAL ANTHROPOLOGY QUARTERLY": 1.469,
  "AUSTRALIAN JOURNAL OF AGRICULTURAL AND RESOURCE ECONOMICS": 1.468,
  "INTERNATIONAL JOURNAL OF SOCIAL PSYCHIATRY": 1.468,
  "JOURNAL OF SULFUR CHEMISTRY": 1.467,
  "ANNALS OF TRANSPLANTATION": 1.467,
  "JOURNAL OF ZHEJIANG UNIVERSITY-SCIENCE A": 1.467,
  "ACM TRANSACTIONS ON EMBEDDED COMPUTING SYSTEMS": 1.467,
  "BULLETIN OF THE ATOMIC SCIENTISTS": 1.467,
  "SOUTH AFRICAN JOURNAL OF CHEMISTRY-SUID-AFRIKAANSE TYDSKRIF VIR CHEMIE": 1.467,
  "INDOOR AND BUILT ENVIRONMENT": 1.467,
  "ISOTOPES IN ENVIRONMENTAL AND HEALTH STUDIES": 1.466,
  "MODERN PHYSICS LETTERS A": 1.466,
  "MIND CULTURE AND ACTIVITY": 1.466,
  "PHOTOGRAMMETRIC ENGINEERING AND REMOTE SENSING": 1.465,
  "REHABILITATION NURSING": 1.465,
  "VITIS": 1.465,
  "I-PERCEPTION": 1.465,
  "ENVIRONMENTAL HAZARDS-HUMAN AND POLICY DIMENSIONS": 1.465,
  "JOURNAL OF INSTRUMENTATION": 1.465,
  "PALAEONTOLOGIA ELECTRONICA": 1.464,
  "PROCEEDINGS OF THE GEOLOGISTS ASSOCIATION": 1.464,
  "SIGMOD RECORD": 1.464,
  "JOURNAL OF CONTINGENCIES AND CRISIS MANAGEMENT": 1.464,
  "BRITISH EDUCATIONAL RESEARCH JOURNAL": 1.464,
  "INTERNATIONAL JOURNAL OF HERITAGE STUDIES": 1.464,
  "PALAEONTOGRAPHICA ABTEILUNG B-PALAEOPHYTOLOGIE PALAEOBOTANY-PALAEOPHYTOLOGY": 1.463,
  "THERAPIE": 1.463,
  "WORLDS POULTRY SCIENCE JOURNAL": 1.463,
  "FOOT AND ANKLE SURGERY": 1.463,
  "JOURNAL OF INVASIVE CARDIOLOGY": 1.463,
  "PRIMATES": 1.463,
  "ADAPTIVE BEHAVIOR": 1.463,
  "BIOPRESERVATION AND BIOBANKING": 1.462,
  "JOURNAL OF GENDER STUDIES": 1.462,
  "PERSONNEL REVIEW": 1.462,
  "PAEDIATRICS AND INTERNATIONAL CHILD HEALTH": 1.462,
  "CRYPTOGAMIE ALGOLOGIE": 1.462,
  "JOURNAL OF BRYOLOGY": 1.462,
  "JOURNAL OF PERINATAL MEDICINE": 1.46,
  "MODERN LAW REVIEW": 1.46,
  "RECALL": 1.46,
  "CLINICAL CHILD PSYCHOLOGY AND PSYCHIATRY": 1.46,
  "JOURNAL OF FOOD QUALITY": 1.46,
  "JOURNAL OF ADVANCED PROSTHODONTICS": 1.459,
  "PAKISTAN VETERINARY JOURNAL": 1.458,
  "NANOETHICS": 1.458,
  "PROCEEDINGS OF THE INSTITUTION OF MECHANICAL ENGINEERS PART C-JOURNAL OF MECHANICAL ENGINEERING SCIENCE": 1.458,
  "SOCIAL PSYCHOLOGY": 1.458,
  "ANAESTHESIA AND INTENSIVE CARE": 1.458,
  "JOURNAL OF FOOD BIOCHEMISTRY": 1.457,
  "JOURNAL OF THE AMERICAN ACADEMY OF AUDIOLOGY": 1.457,
  "GESTURE": 1.457,
  "JOURNAL OF ARID LAND": 1.457,
  "POLITICA Y GOBIERNO": 1.457,
  "QUANTITATIVE FINANCE": 1.457,
  "ACM TRANSACTIONS ON COMPUTING EDUCATION": 1.456,
  "CANADIAN JOURNAL OF BEHAVIOURAL SCIENCE-REVUE CANADIENNE DES SCIENCES DU COMPORTEMENT": 1.456,
  "GEORGE WASHINGTON LAW REVIEW": 1.455,
  "JOURNAL OF THE RENIN-ANGIOTENSIN-ALDOSTERONE SYSTEM": 1.455,
  "MATHEMATISCHE ANNALEN": 1.455,
  "ADVANCES IN CEMENT RESEARCH": 1.455,
  "AMERICAN JOURNAL OF NURSING": 1.455,
  "ADVANCES IN SKIN & WOUND CARE": 1.455,
  "JOURNAL OF MATHEMATICAL PHYSICS": 1.455,
  "MARINE ECOLOGY-AN EVOLUTIONARY PERSPECTIVE": 1.455,
  "INTERNATIONAL JOURNAL OF HUMAN-COMPUTER INTERACTION": 1.455,
  "JOURNAL OF ENGINEERING MATERIALS AND TECHNOLOGY-TRANSACTIONS OF THE ASME": 1.455,
  "KOREA-AUSTRALIA RHEOLOGY JOURNAL": 1.454,
  "SEPARATION SCIENCE AND TECHNOLOGY": 1.454,
  "INFANT BEHAVIOR & DEVELOPMENT": 1.453,
  "INTERNATIONAL JOURNAL OF SPRAY AND COMBUSTION DYNAMICS": 1.453,
  "NEW GENETICS AND SOCIETY": 1.453,
  "NEW IDEAS IN PSYCHOLOGY": 1.453,
  "OPTICAL SWITCHING AND NETWORKING": 1.453,
  "SCHOOL PSYCHOLOGY REVIEW": 1.452,
  "COMMUNIST AND POST-COMMUNIST STUDIES": 1.452,
  "ELT JOURNAL": 1.452,
  "ENVIRONMETRICS": 1.451,
  "EMU-AUSTRAL ORNITHOLOGY": 1.451,
  "JOURNAL OF ELECTROMAGNETIC WAVES AND APPLICATIONS": 1.451,
  "JOURNAL OF INTERNATIONAL MEDICAL RESEARCH": 1.451,
  "JOURNAL OF VACUUM SCIENCE & TECHNOLOGY B": 1.451,
  "NEUROIMMUNOMODULATION": 1.451,
  "SOUTH AFRICAN JOURNAL OF SCIENCE": 1.45,
  "EUROPE-ASIA STUDIES": 1.45,
  "EDUCATIONAL MEASUREMENT-ISSUES AND PRACTICE": 1.45,
  "JOURNAL OF PUBLIC HEALTH DENTISTRY": 1.45,
  "POLICING-AN INTERNATIONAL JOURNAL OF POLICE STRATEGIES & MANAGEMENT": 1.45,
  "AMERICAN JOURNAL OF HEALTH ECONOMICS": 1.45,
  "EUROPEAN JOURNAL OF INTERNATIONAL MANAGEMENT": 1.45,
  "INTERNATIONAL JOURNAL OF AGRICULTURAL AND BIOLOGICAL ENGINEERING": 1.449,
  "EUROPEAN JOURNAL OF INDUSTRIAL RELATIONS": 1.449,
  "EATING DISORDERS": 1.449,
  "INTERNATIONAL JOURNAL OF ANTENNAS AND PROPAGATION": 1.449,
  "JOURNAL OF AGING STUDIES": 1.448,
  "STUDIES IN INFORMATICS AND CONTROL": 1.448,
  "THEORY INTO PRACTICE": 1.448,
  "ATENCION PRIMARIA": 1.448,
  "INTELLIGENT SERVICE ROBOTICS": 1.448,
  "RACE AND SOCIAL PROBLEMS": 1.448,
  "CONFLICT MANAGEMENT AND PEACE SCIENCE": 1.448,
  "FOSSIL RECORD": 1.447,
  "JOURNAL OF MOLLUSCAN STUDIES": 1.447,
  "NEW ZEALAND VETERINARY JOURNAL": 1.446,
  "STATISTICAL PAPERS": 1.446,
  "SURGICAL LAPAROSCOPY ENDOSCOPY & PERCUTANEOUS TECHNIQUES": 1.446,
  "ACTA GEOLOGICA POLONICA": 1.445,
  "BMC BIOCHEMISTRY": 1.445,
  "COMPUTATIONAL AND THEORETICAL CHEMISTRY": 1.444,
  "DEVELOPMENTAL NEUROPSYCHOLOGY": 1.444,
  "FOUNDATIONS OF PHYSICS": 1.444,
  "JOURNAL OF THE ROYAL STATISTICAL SOCIETY SERIES C-APPLIED STATISTICS": 1.444,
  "JOURNAL OF APPLIED REMOTE SENSING": 1.444,
  "REGENERATIVE THERAPY": 1.443,
  "APPLIED RADIATION AND ISOTOPES": 1.443,
  "BEHAVIORAL DISORDERS": 1.443,
  "ELECTRONICS LETTERS": 1.443,
  "JOURNAL OF BEHAVIORAL HEALTH SERVICES & RESEARCH": 1.443,
  "JOURNAL OF ELECTRON SPECTROSCOPY AND RELATED PHENOMENA": 1.442,
  "JOURNAL OF THERMOPLASTIC COMPOSITE MATERIALS": 1.442,
  "VOCATIONS AND LEARNING": 1.442,
  "BULLETIN OF THE AMERICAN MATHEMATICAL SOCIETY": 1.442,
  "PHYCOLOGICAL RESEARCH": 1.44,
  "PS-POLITICAL SCIENCE & POLITICS": 1.44,
  "STOCHASTIC PROCESSES AND THEIR APPLICATIONS": 1.44,
  "INTERNATIONAL JOURNAL OF EDUCATIONAL RESEARCH": 1.44,
  "WILDLIFE BIOLOGY": 1.439,
  "AMERICAN JOURNAL OF AUDIOLOGY": 1.439,
  "BOTHALIA": 1.439,
  "JOURNAL OF IRRIGATION AND DRAINAGE ENGINEERING": 1.439,
  "PACE-PACING AND CLINICAL ELECTROPHYSIOLOGY": 1.439,
  "WELDING JOURNAL": 1.439,
  "NUTRITION & DIETETICS": 1.439,
  "RADIOCHIMICA ACTA": 1.438,
  "CULTURE & PSYCHOLOGY": 1.438,
  "JOURNAL OF OCCUPATIONAL AND ENVIRONMENTAL HYGIENE": 1.438,
  "JOURNAL OF DUAL DIAGNOSIS": 1.438,
  "PHYTOCHEMISTRY LETTERS": 1.438,
  "VICTIMS & OFFENDERS": 1.438,
  "JOURNAL OF INTEGRATIVE AGRICULTURE": 1.438,
  "PLANT SOIL AND ENVIRONMENT": 1.438,
  "PSYCHOLOGICAL SERVICES": 1.438,
  "ZEITSCHRIFT FUR ANORGANISCHE UND ALLGEMEINE CHEMIE": 1.438,
  "CRYOGENICS": 1.438,
  "HUMAN ECOLOGY": 1.438,
  "JOURNAL OF ADVANCED CONCRETE TECHNOLOGY": 1.438,
  "OPTIMIZATION METHODS & SOFTWARE": 1.437,
  "JOURNAL OF MOLECULAR MODELING": 1.437,
  "JOURNAL OF THE BRAZILIAN CHEMICAL SOCIETY": 1.437,
  "SIAM JOURNAL ON MATHEMATICAL ANALYSIS": 1.437,
  "CELLS TISSUES ORGANS": 1.436,
  "GEODINAMICA ACTA": 1.436,
  "GENETIC PROGRAMMING AND EVOLVABLE MACHINES": 1.436,
  "HEALTH PROMOTION JOURNAL OF AUSTRALIA": 1.436,
  "HIGHER EDUCATION POLICY": 1.436,
  "JOURNAL OF COMMUNITY & APPLIED SOCIAL PSYCHOLOGY": 1.436,
  "JOURNAL OF ECONOMIC INEQUALITY": 1.436,
  "POLITICS AND GOVERNANCE": 1.436,
  "PSYCHIATRY INVESTIGATION": 1.435,
  "TURKISH JOURNAL OF EARTH SCIENCES": 1.435,
  "EUROPEAN PHYSICAL JOURNAL D": 1.435,
  "MOLECULAR CYTOGENETICS": 1.435,
  "ORTHOPAEDIC SURGERY": 1.434,
  "CROP & PASTURE SCIENCE": 1.434,
  "JOURNAL OF AGRICULTURAL SCIENCE": 1.433,
  "JOURNAL OF INSECT CONSERVATION": 1.433,
  "NATURAL COMPUTING": 1.433,
  "ANATOMICAL RECORD-ADVANCES IN INTEGRATIVE ANATOMY AND EVOLUTIONARY BIOLOGY": 1.432,
  "FACIAL PLASTIC SURGERY": 1.432,
  "JOURNAL OF PRAGMATICS": 1.432,
  "SEED SCIENCE RESEARCH": 1.432,
  "PHOTONIC NETWORK COMMUNICATIONS": 1.432,
  "SIAM JOURNAL ON FINANCIAL MATHEMATICS": 1.431,
  "APPLIED NURSING RESEARCH": 1.431,
  "CHILDS NERVOUS SYSTEM": 1.431,
  "FOCUS ON AUTISM AND OTHER DEVELOPMENTAL DISABILITIES": 1.431,
  "JOURNAL OF RADIOLOGICAL PROTECTION": 1.431,
  "LABOUR ECONOMICS": 1.431,
  "MICROSCOPY RESEARCH AND TECHNIQUE": 1.431,
  "SPE DRILLING & COMPLETION": 1.43,
  "TROPICAL CONSERVATION SCIENCE": 1.43,
  "ATLA-ALTERNATIVES TO LABORATORY ANIMALS": 1.429,
  "DISTRIBUTED COMPUTING": 1.429,
  "ECONOMIC SYSTEMS": 1.429,
  "PEDIATRIC TRANSPLANTATION": 1.429,
  "FAMILIES SYSTEMS & HEALTH": 1.429,
  "IEEE TRANSACTIONS ON PLASMA SCIENCE": 1.429,
  "INTERNATIONAL JOURNAL OF PERFORMANCE ANALYSIS IN SPORT": 1.429,
  "CROSS-CULTURAL RESEARCH": 1.428,
  "DEMOGRAPHIC RESEARCH": 1.428,
  "PROFESSIONAL PSYCHOLOGY-RESEARCH AND PRACTICE": 1.428,
  "COMPUTATIONAL STATISTICS & DATA ANALYSIS": 1.427,
  "JOURNAL OF RESEARCH IN READING": 1.427,
  "JOURNAL OF SOCIAL ARCHAEOLOGY": 1.427,
  "ACM TRANSACTIONS ON STORAGE": 1.426,
  "JOURNAL OF LAPAROENDOSCOPIC & ADVANCED SURGICAL TECHNIQUES": 1.426,
  "MEDICAL HYPOTHESES": 1.426,
  "REVISTA DO INSTITUTO DE MEDICINA TROPICAL DE SAO PAULO": 1.425,
  "AMERICAN JOURNAL OF SPEECH-LANGUAGE PATHOLOGY": 1.425,
  "EUROPEAN HEART JOURNAL SUPPLEMENTS": 1.424,
  "NURSING & HEALTH SCIENCES": 1.424,
  "ADVANCES IN STRUCTURAL ENGINEERING": 1.424,
  "ANNALS OF HUMAN GENETICS": 1.424,
  "INDUSTRIAL HEALTH": 1.424,
  "INTERNATIONAL JOURNAL OF TECHNOLOGY AND DESIGN EDUCATION": 1.423,
  "SURFACE AND INTERFACE ANALYSIS": 1.423,
  "CHINESE JOURNAL OF ORGANIC CHEMISTRY": 1.423,
  "EUROPEAN ANNALS OF OTORHINOLARYNGOLOGY-HEAD AND NECK DISEASES": 1.423,
  "HEMATOLOGY": 1.423,
  "JOURNAL OF POSTGRADUATE MEDICINE": 1.423,
  "TRANSACTIONS OF THE AMERICAN MATHEMATICAL SOCIETY": 1.422,
  "ACTA PETROLOGICA SINICA": 1.422,
  "ENVIRONMENTAL ARCHAEOLOGY": 1.422,
  "GEOINFORMATICA": 1.422,
  "INTERNATIONAL JOURNAL OF CRASHWORTHINESS": 1.421,
  "PROCEEDINGS OF THE INSTITUTION OF MECHANICAL ENGINEERS PART H-JOURNAL OF ENGINEERING IN MEDICINE": 1.421,
  "AI MAGAZINE": 1.421,
  "AMERICAN JOURNAL OF EDUCATION": 1.421,
  "GEOGRAPHY": 1.421,
  "SAMJ SOUTH AFRICAN MEDICAL JOURNAL": 1.421,
  "SCANDINAVIAN JOURNAL OF OCCUPATIONAL THERAPY": 1.42,
  "BOTANY": 1.42,
  "INSURANCE MATHEMATICS & ECONOMICS": 1.42,
  "JOURNAL OF EYE MOVEMENT RESEARCH": 1.42,
  "DEVELOPMENT POLICY REVIEW": 1.42,
  "INTERNATIONAL JOURNAL OF OCCUPATIONAL MEDICINE AND ENVIRONMENTAL HEALTH": 1.42,
  "INTERNATIONAL TRANSACTIONS ON ELECTRICAL ENERGY SYSTEMS": 1.42,
  "ACTA HAEMATOLOGICA": 1.419,
  "JOURNAL OF MOTOR BEHAVIOR": 1.419,
  "MATHEMATICAL BIOSCIENCES AND ENGINEERING": 1.419,
  "PROCEEDINGS OF THE INSTITUTION OF MECHANICAL ENGINEERS PART O-JOURNAL OF RISK AND RELIABILITY": 1.419,
  "REVISTA IBEROAMERICANA DE AUTOMATICA E INFORMATICA INDUSTRIAL": 1.418,
  "SALAMANDRA": 1.418,
  "GEBURTSHILFE UND FRAUENHEILKUNDE": 1.418,
  "ADVANCES IN NURSING SCIENCE": 1.418,
  "AUSTRALIAN JOURNAL OF PUBLIC ADMINISTRATION": 1.418,
  "CANADIAN JOURNAL OF ZOOLOGY": 1.418,
  "JOURNAL OF COSMETIC DERMATOLOGY": 1.417,
  "PSYCHIATRIA POLSKA": 1.417,
  "HOMICIDE STUDIES": 1.417,
  "JOURNAL OF HIGHER EDUCATION POLICY AND MANAGEMENT": 1.417,
  "GENERAL PHYSIOLOGY AND BIOPHYSICS": 1.417,
  "INTERNATIONAL JOURNAL OF BIOSTATISTICS": 1.416,
  "JANAC-JOURNAL OF THE ASSOCIATION OF NURSES IN AIDS CARE": 1.416,
  "ARTS IN PSYCHOTHERAPY": 1.415,
  "COMMUNICATIONS IN APPLIED MATHEMATICS AND COMPUTATIONAL SCIENCE": 1.415,
  "JOURNAL OF SPORT & SOCIAL ISSUES": 1.415,
  "SOCIOLOGICAL QUARTERLY": 1.415,
  "JOURNAL OF TOPOLOGY": 1.415,
  "SIGNS": 1.415,
  "ALTERNATIVE THERAPIES IN HEALTH AND MEDICINE": 1.415,
  "AVIAN DISEASES": 1.415,
  "APPLIED CLINICAL INFORMATICS": 1.414,
  "FORSCHENDE KOMPLEMENTARMEDIZIN": 1.414,
  "JOURNAL OF HEALTH ORGANIZATION AND MANAGEMENT": 1.414,
  "JOURNAL OF MEDICAL AND BIOLOGICAL ENGINEERING": 1.413,
  "PUBLIC HEALTH ETHICS": 1.413,
  "SINGAPORE JOURNAL OF TROPICAL GEOGRAPHY": 1.413,
  "BIOLOGICAL CYBERNETICS": 1.413,
  "CANADIAN JOURNAL OF OPHTHALMOLOGY-JOURNAL CANADIEN D OPHTALMOLOGIE": 1.412,
  "JOURNAL OF SOFTWARE-EVOLUTION AND PROCESS": 1.412,
  "ANIMAL BIOLOGY": 1.412,
  "GEODIVERSITAS": 1.412,
  "GIFTED CHILD QUARTERLY": 1.412,
  "JOURNAL OF LAW ECONOMICS & ORGANIZATION": 1.412,
  "JOURNAL OF MECHANICS": 1.411,
  "COMMUNICATIONS IN MATHEMATICAL SCIENCES": 1.411,
  "JAVMA-JOURNAL OF THE AMERICAN VETERINARY MEDICAL ASSOCIATION": 1.411,
  "COMPUTERS & GRAPHICS-UK": 1.41,
  "GYNECOLOGIC AND OBSTETRIC INVESTIGATION": 1.41,
  "GEOSCIENTIFIC INSTRUMENTATION METHODS AND DATA SYSTEMS": 1.41,
  "INTERNATIONAL JOURNAL OF GREEN ENERGY": 1.41,
  "JOURNAL OF SPORTS MEDICINE AND PHYSICAL FITNESS": 1.41,
  "JOURNAL OF PUBLIC TRANSPORTATION": 1.409,
  "MOTOR CONTROL": 1.409,
  "PROCEEDINGS OF THE INSTITUTION OF CIVIL ENGINEERS-ENGINEERING SUSTAINABILITY": 1.409,
  "SOCIAL POLITICS": 1.408,
  "ANIMAL SCIENCE JOURNAL": 1.408,
  "COMPOSITIO MATHEMATICA": 1.407,
  "HEALTH EDUCATION RESEARCH": 1.407,
  "INTERNATIONAL JOURNAL OF PALEOPATHOLOGY": 1.407,
  "JOURNAL OF COMPUTER ASSISTED TOMOGRAPHY": 1.407,
  "ARGUMENTATION": 1.407,
  "WORLD REVIEW OF NUTRITION AND DIETETICS": 1.407,
  "AMEGHINIANA": 1.406,
  "ARCHIVES OF PSYCHIATRIC NURSING": 1.406,
  "NUMERICAL LINEAR ALGEBRA WITH APPLICATIONS": 1.406,
  "AQUATIC BIOLOGY": 1.406,
  "BIOSCIENCE BIOTECHNOLOGY AND BIOCHEMISTRY": 1.406,
  "EVALUATION REVIEW": 1.405,
  "ENTERTAINMENT COMPUTING": 1.405,
  "ICSID REVIEW-FOREIGN INVESTMENT LAW JOURNAL": 1.405,
  "ELECTRICAL ENGINEERING": 1.405,
  "GENETIC RESOURCES AND CROP EVOLUTION": 1.405,
  "JOHNSON MATTHEY TECHNOLOGY REVIEW": 1.405,
  "JOURNAL OF CHILDRENS ORTHOPAEDICS": 1.404,
  "POLYMER SCIENCE SERIES C": 1.404,
  "ESAIM-CONTROL OPTIMISATION AND CALCULUS OF VARIATIONS": 1.404,
  "GEOTECHNICAL TESTING JOURNAL": 1.404,
  "JOURNAL OF HEALTHCARE ENGINEERING": 1.404,
  "JOURNAL OF EARLY INTERVENTION": 1.404,
  "JOURNAL OF AGROMEDICINE": 1.403,
  "JOURNAL OF DIVERSITY IN HIGHER EDUCATION": 1.403,
  "PALAEONTOGRAPHICA ABTEILUNG A-PALAOZOOLOGIE-STRATIGRAPHIE": 1.402,
  "PLANT PATHOLOGY JOURNAL": 1.402,
  "CLINICAL PSYCHOLOGIST": 1.402,
  "CURRENT OPINION IN OTOLARYNGOLOGY & HEAD AND NECK SURGERY": 1.401,
  "ELECTROCHEMISTRY": 1.401,
  "HISTORY OF PSYCHOLOGY": 1.401,
  "INTERNATIONAL JOURNAL OF BUSINESS COMMUNICATION": 1.401,
  "JOURNAL OF EUROPEAN INTEGRATION": 1.4,
  "NANO": 1.4,
  "STUDIA GEOPHYSICA ET GEODAETICA": 1.4,
  "ARCHEOSCIENCES-REVUE D ARCHEOMETRIE": 1.4,
  "EDUCATIONAL STUDIES IN MATHEMATICS": 1.4,
  "EUROPEAN FINANCIAL MANAGEMENT": 1.4,
  "IRISH VETERINARY JOURNAL": 1.4,
  "JOURNAL OF PORPHYRINS AND PHTHALOCYANINES": 1.4,
  "JOURNAL OF VINYL & ADDITIVE TECHNOLOGY": 1.399,
  "LANGUAGE & COMMUNICATION": 1.399,
  "MATHEMATICAL CONTROL AND RELATED FIELDS": 1.399,
  "CRITICAL CARE NURSE": 1.398,
  "JOURNAL OF LABELLED COMPOUNDS & RADIOPHARMACEUTICALS": 1.398,
  "KAOHSIUNG JOURNAL OF MEDICAL SCIENCES": 1.398,
  "MARINE BIOLOGY RESEARCH": 1.398,
  "PROTEIN EXPRESSION AND PURIFICATION": 1.397,
  "WILDLIFE SOCIETY BULLETIN": 1.397,
  "ASTRONOMISCHE NACHRICHTEN": 1.397,
  "CEREAL CHEMISTRY": 1.397,
  "INTERNATIONAL JOURNAL OF COMPARATIVE SOCIOLOGY": 1.396,
  "INTERNATIONAL JOURNAL OF SENSOR NETWORKS": 1.396,
  "JOURNAL OF TROPICAL PEDIATRICS": 1.396,
  "MEDECINE ET MALADIES INFECTIEUSES": 1.396,
  "SCIENTIFIC PROGRAMMING": 1.396,
  "JOURNAL OF FOOD PROCESSING AND PRESERVATION": 1.396,
  "ACI STRUCTURAL JOURNAL": 1.395,
  "ECHOCARDIOGRAPHY-A JOURNAL OF CARDIOVASCULAR ULTRASOUND AND ALLIED TECHNIQUES": 1.395,
  "ACTA OTO-LARYNGOLOGICA": 1.394,
  "ARCHAEOLOGY IN OCEANIA": 1.394,
  "ACTA POLYTECHNICA HUNGARICA": 1.394,
  "ANNALS OF CLINICAL PSYCHIATRY": 1.394,
  "INTERNATIONAL JOURNAL OF UNCERTAINTY FUZZINESS AND KNOWLEDGE-BASED SYSTEMS": 1.394,
  "INTERNATIONAL JOURNAL OF HUMANOID ROBOTICS": 1.394,
  "SCANDINAVIAN CARDIOVASCULAR JOURNAL": 1.393,
  "JOURNAL OF CLINICAL RESEARCH IN PEDIATRIC ENDOCRINOLOGY": 1.393,
  "OPHTHALMIC GENETICS": 1.393,
  "FAMILY RELATIONS": 1.393,
  "INTERNATIONAL JOURNAL OF ELECTROCHEMICAL SCIENCE": 1.392,
  "MICROELECTRONICS JOURNAL": 1.392,
  "MEDICINA ORAL PATOLOGIA ORAL Y CIRUGIA BUCAL": 1.392,
  "AUSTRALIAN JOURNAL OF EARTH SCIENCES": 1.392,
  "JOURNAL OF MULTINATIONAL FINANCIAL MANAGEMENT": 1.392,
  "AUSTRALIAN DENTAL JOURNAL": 1.392,
  "VERTEBRATE ZOOLOGY": 1.391,
  "PARALLEL COMPUTING": 1.391,
  "ARCHIVES EUROPEENNES DE SOCIOLOGIE": 1.391,
  "INTERNATIONAL JOURNAL OF SPEECH-LANGUAGE PATHOLOGY": 1.391,
  "SOCIETY AND MENTAL HEALTH": 1.39,
  "INTERNATIONAL ANGIOLOGY": 1.389,
  "AUSTRALIAN OCCUPATIONAL THERAPY JOURNAL": 1.388,
  "INTERNATIONAL JOURNAL OF COMMUNICATION SYSTEMS": 1.388,
  "JOURNAL OF TRANSCULTURAL NURSING": 1.388,
  "NATIONS AND NATIONALISM": 1.388,
  "WELDING IN THE WORLD": 1.387,
  "ZYGOTE": 1.386,
  "BIOTA NEOTROPICA": 1.386,
  "BULLETIN OF THE POLISH ACADEMY OF SCIENCES-TECHNICAL SCIENCES": 1.386,
  "IET CIRCUITS DEVICES & SYSTEMS": 1.385,
  "INTERNATIONAL JOURNAL OF LOWER EXTREMITY WOUNDS": 1.385,
  "INTERNATIONAL JOURNAL OF SHIPPING AND TRANSPORT LOGISTICS": 1.384,
  "MEDICINA CLINICA": 1.384,
  "ASIA PACIFIC JOURNAL OF MARKETING AND LOGISTICS": 1.384,
  "CARTOGRAPHIC JOURNAL": 1.384,
  "ANIMAL PRODUCTION SCIENCE": 1.384,
  "JOURNAL OF GEOSCIENCES": 1.383,
  "PROCEEDINGS OF THE INSTITUTION OF MECHANICAL ENGINEERS PART D-JOURNAL OF AUTOMOBILE ENGINEERING": 1.383,
  "PSYCHOLOGY & SEXUALITY": 1.383,
  "JOURNAL OF MANIPULATIVE AND PHYSIOLOGICAL THERAPEUTICS": 1.383,
  "OXFORD REVIEW OF EDUCATION": 1.383,
  "PETROLOGY": 1.383,
  "PROCEEDINGS OF THE INSTITUTION OF CIVIL ENGINEERS-GEOTECHNICAL ENGINEERING": 1.383,
  "JOURNAL OF WORK AND ORGANIZATIONAL PSYCHOLOGY-REVISTA DE PSICOLOGIA DEL TRABAJO Y DE LAS ORGANIZACIONES": 1.383,
  "CLINICAL NEUROPHARMACOLOGY": 1.383,
  "FRONTIERS OF STRUCTURAL AND CIVIL ENGINEERING": 1.383,
  "INTERNATIONAL JOURNAL OF FORENSIC MENTAL HEALTH": 1.382,
  "PSYCHIATRIC QUARTERLY": 1.382,
  "PALAEONTOLOGISCHE ZEITSCHRIFT": 1.382,
  "VETERINARY CLINICS OF NORTH AMERICA-SMALL ANIMAL PRACTICE": 1.382,
  "BUSINESS HISTORY REVIEW": 1.382,
  "INTERNATIONAL JOURNAL ON SOFTWARE TOOLS FOR TECHNOLOGY TRANSFER": 1.382,
  "JOURNAL FOR THE SCIENTIFIC STUDY OF RELIGION": 1.382,
  "JOURNAL OF SCHOLARLY PUBLISHING": 1.382,
  "NUKLEARMEDIZIN-NUCLEAR MEDICINE": 1.381,
  "RESEARCH ON SOCIAL WORK PRACTICE": 1.381,
  "JOURNAL OF EASTERN AFRICAN STUDIES": 1.381,
  "SOCIAL POLICY & ADMINISTRATION": 1.381,
  "ANNALI DI MATEMATICA PURA ED APPLICATA": 1.381,
  "ETHNIC AND RACIAL STUDIES": 1.381,
  "HUMAN DIMENSIONS OF WILDLIFE": 1.381,
  "CRITICAL STUDIES IN MEDIA COMMUNICATION": 1.38,
  "CHINESE JOURNAL OF INTERNATIONAL LAW": 1.38,
  "EDUCATIONAL PHILOSOPHY AND THEORY": 1.38,
  "INFANT MENTAL HEALTH JOURNAL": 1.38,
  "INTERNATIONAL JOURNAL OF ENVIRONMENTAL ANALYTICAL CHEMISTRY": 1.38,
  "RADIATION AND ENVIRONMENTAL BIOPHYSICS": 1.379,
  "SCHMERZ": 1.378,
  "TUEXENIA": 1.378,
  "ECONOMIC INQUIRY": 1.378,
  "INFORMATION DEVELOPMENT": 1.377,
  "INFORMATION TECHNOLOGY & MANAGEMENT": 1.377,
  "ITALIAN JOURNAL OF ANIMAL SCIENCE": 1.377,
  "JOURNAL OF CONTINUING EDUCATION IN THE HEALTH PROFESSIONS": 1.377,
  "JOURNAL OF GEOGRAPHY": 1.377,
  "KNOWLEDGE AND MANAGEMENT OF AQUATIC ECOSYSTEMS": 1.376,
  "ASSISTIVE TECHNOLOGY": 1.376,
  "BULLETIN OF MATERIALS SCIENCE": 1.376,
  "JOURNAL OF COASTAL CONSERVATION": 1.375,
  "PADDY AND WATER ENVIRONMENT": 1.375,
  "SURVIVAL": 1.375,
  "SENSOR REVIEW": 1.375,
  "ANIMAL BIOTECHNOLOGY": 1.375,
  "CANCER RADIOTHERAPIE": 1.375,
  "INFORMATION TECHNOLOGY & PEOPLE": 1.375,
  "INTERNATIONAL THEORY": 1.375,
  "ATOMIZATION AND SPRAYS": 1.374,
  "ANNALS OF PALLIATIVE MEDICINE": 1.373,
  "DENDROBIOLOGY": 1.373,
  "INTERNATIONAL JOURNAL FOR THE PSYCHOLOGY OF RELIGION": 1.373,
  "JOURNAL OF CREATIVE BEHAVIOR": 1.373,
  "NURSE EDUCATOR": 1.373,
  "SYNTHESE": 1.372,
  "DEFENCE TECHNOLOGY": 1.372,
  "JOURNAL OF LARYNGOLOGY AND OTOLOGY": 1.372,
  "COMPUTATIONAL & APPLIED MATHEMATICS": 1.372,
  "CENTRAL EUROPEAN JOURNAL OF OPERATIONS RESEARCH": 1.372,
  "INTERNATIONAL LABOUR REVIEW": 1.371,
  "PHARMACOGNOSY MAGAZINE": 1.371,
  "ANNALS OF THE ROYAL COLLEGE OF SURGEONS OF ENGLAND": 1.37,
  "INTERNATIONAL JOURNAL OF BILINGUALISM": 1.37,
  "JOURNAL OF POPULATION ECONOMICS": 1.37,
  "JOURNAL OF COGNITIVE PSYCHOLOGY": 1.37,
  "PFG-JOURNAL OF PHOTOGRAMMETRY REMOTE SENSING AND GEOINFORMATION SCIENCE": 1.369,
  "PLANT BIOTECHNOLOGY REPORTS": 1.369,
  "SYSTEMATIC BOTANY": 1.368,
  "INTERNATIONAL JOURNAL OF PARALLEL PROGRAMMING": 1.368,
  "PROFESSIONAL DEVELOPMENT IN EDUCATION": 1.368,
  "TRANSACTIONS ON EMERGING TELECOMMUNICATIONS TECHNOLOGIES": 1.367,
  "JOURNAL OF ORTHOPAEDIC SCIENCE": 1.367,
  "ASIAN NURSING RESEARCH": 1.367,
  "INTERNATIONAL MICROBIOLOGY": 1.367,
  "LIBRARY HI TECH": 1.367,
  "WIND AND STRUCTURES": 1.367,
  "ADVANCES IN LIFE COURSE RESEARCH": 1.367,
  "BIOMETRICAL JOURNAL": 1.367,
  "HIGH PRESSURE RESEARCH": 1.367,
  "INTERNATIONAL JOURNAL OF IMPOTENCE RESEARCH": 1.366,
  "INTERNATIONAL JOURNAL OF SCIENCE EDUCATION": 1.366,
  "JOURNAL OF SMALL ANIMAL PRACTICE": 1.366,
  "NORSK GEOGRAFISK TIDSSKRIFT-NORWEGIAN JOURNAL OF GEOGRAPHY": 1.366,
  "PSYCHOLOGICAL RECORD": 1.366,
  "ECONOMIC AND LABOUR RELATIONS REVIEW": 1.365,
  "EDUCATIONAL PSYCHOLOGY": 1.364,
  "FINITE FIELDS AND THEIR APPLICATIONS": 1.364,
  "INTERNATIONAL JOURNAL OF IMAGING SYSTEMS AND TECHNOLOGY": 1.364,
  "JOURNAL OF PLANT BIOLOGY": 1.364,
  "JOURNAL OF POLICY MODELING": 1.364,
  "RESEARCH IN ASTRONOMY AND ASTROPHYSICS": 1.363,
  "TROPICAL PLANT PATHOLOGY": 1.363,
  "ARKIVOC": 1.363,
  "ANNALS OF WORK EXPOSURES AND HEALTH": 1.362,
  "CUAJ-CANADIAN UROLOGICAL ASSOCIATION JOURNAL": 1.362,
  "ENVIRONMENTAL MODELING & ASSESSMENT": 1.362,
  "GLOBAL HEALTH PROMOTION": 1.362,
  "INTERNATIONAL JOURNAL OF SPORTS SCIENCE & COACHING": 1.362,
  "JOURNAL OF RELIGION & HEALTH": 1.362,
  "JOURNAL OF EVIDENCE-BASED DENTAL PRACTICE": 1.361,
  "JOURNAL OF FIXED POINT THEORY AND APPLICATIONS": 1.361,
  "JOURNAL OF THE EUROPEAN OPTICAL SOCIETY-RAPID PUBLICATIONS": 1.361,
  "OZONE-SCIENCE & ENGINEERING": 1.361,
  "PALYNOLOGY": 1.361,
  "CANADIAN JOURNAL OF CHEMISTRY": 1.36,
  "JOURNAL OF NATURAL FIBERS": 1.36,
  "SCIENTIA MARINA": 1.36,
  "INDIAN JOURNAL OF MEDICAL RESEARCH": 1.36,
  "PLANT BREEDING": 1.36,
  "ADVANCES IN CHROMATOGRAPHY": 1.359,
  "HIP INTERNATIONAL": 1.359,
  "JOURNAL OF ADOLESCENT & ADULT LITERACY": 1.359,
  "JOURNAL OF ELDER ABUSE & NEGLECT": 1.359,
  "JOURNAL OF REAL ESTATE RESEARCH": 1.358,
  "MAPAN-JOURNAL OF METROLOGY SOCIETY OF INDIA": 1.358,
  "MUSICAE SCIENTIAE": 1.358,
  "NUMERICAL MATHEMATICS-THEORY METHODS AND APPLICATIONS": 1.357,
  "REFERENCE SERVICES REVIEW": 1.357,
  "REVISTA DE CONTABILIDAD-SPANISH ACCOUNTING REVIEW": 1.357,
  "RUSSIAN GEOLOGY AND GEOPHYSICS": 1.357,
  "SOCIAL COGNITION": 1.357,
  "URSUS": 1.356,
  "JOURNAL OF COMPARATIVE PATHOLOGY": 1.356,
  "ANALYTICAL LETTERS": 1.356,
  "CANADIAN JOURNAL OF PUBLIC HEALTH-REVUE CANADIENNE DE SANTE PUBLIQUE": 1.356,
  "SELECTA MATHEMATICA-NEW SERIES": 1.356,
  "DISASTER PREVENTION AND MANAGEMENT": 1.355,
  "JOURNAL OF EMERGENCY MEDICINE": 1.355,
  "JOURNAL OF NEUROLINGUISTICS": 1.355,
  "CHEMICAL PAPERS": 1.355,
  "ENGINEERING COMPUTATIONS": 1.355,
  "JOURNAL OF NUCLEAR SCIENCE AND TECHNOLOGY": 1.355,
  "LEADERSHIP": 1.355,
  "INFORMATION ECONOMICS AND POLICY": 1.354,
  "TELEVISION & NEW MEDIA": 1.354,
  "ADVANCES IN NEONATAL CARE": 1.354,
  "EURASIP JOURNAL ON AUDIO SPEECH AND MUSIC PROCESSING": 1.354,
  "JOURNAL OF EMPIRICAL FINANCE": 1.354,
  "WILDLIFE RESEARCH": 1.353,
  "JOURNAL OF EDUCATIONAL AND PSYCHOLOGICAL CONSULTATION": 1.353,
  "SOCIAL JUSTICE RESEARCH": 1.353,
  "CURRENT ANALYTICAL CHEMISTRY": 1.353,
  "INDIAN JOURNAL OF PHYSICS": 1.353,
  "INTERNATIONAL JOURNAL OF SEXUAL HEALTH": 1.353,
  "JOURNAL OF SUSTAINABLE FORESTRY": 1.353,
  "PARENTING-SCIENCE AND PRACTICE": 1.351,
  "SCANNING": 1.351,
  "COLORATION TECHNOLOGY": 1.351,
  "JOURNAL OF ENVIRONMENTAL PATHOLOGY TOXICOLOGY AND ONCOLOGY": 1.351,
  "JOURNAL OF HETEROCYCLIC CHEMISTRY": 1.351,
  "PROCEEDINGS OF THE INSTITUTION OF MECHANICAL ENGINEERS PART M-JOURNAL OF ENGINEERING FOR THE MARITIME ENVIRONMENT": 1.351,
  "BULLETIN OF THE PEABODY MUSEUM OF NATURAL HISTORY": 1.351,
  "EVALUATION AND PROGRAM PLANNING": 1.351,
  "LIBRARY QUARTERLY": 1.351,
  "PERSPECTIVES IN PSYCHIATRIC CARE": 1.35,
  "WATER ENVIRONMENT RESEARCH": 1.35,
  "BIOLOGICAL AGRICULTURE & HORTICULTURE": 1.35,
  "COMMUNICATIONS IN PARTIAL DIFFERENTIAL EQUATIONS": 1.35,
  "CULTURAL SOCIOLOGY": 1.349,
  "DEVELOPMENTAL NEUROREHABILITATION": 1.349,
  "GROWTH FACTORS": 1.349,
  "JOURNAL OF PEDIATRIC ENDOCRINOLOGY & METABOLISM": 1.347,
  "JOURNAL OF MECHANICS OF MATERIALS AND STRUCTURES": 1.347,
  "AMFITEATRU ECONOMIC": 1.347,
  "ECONOMETRIC THEORY": 1.347,
  "JOURNAL OF COMPUTATIONAL MATHEMATICS": 1.347,
  "JOURNAL OF PARASITOLOGY": 1.347,
  "DISCOURSE & SOCIETY": 1.347,
  "FEMALE PELVIC MEDICINE AND RECONSTRUCTIVE SURGERY": 1.346,
  "JOURNAL OF CRYPTOLOGY": 1.346,
  "POLYCYCLIC AROMATIC COMPOUNDS": 1.346,
  "HAND CLINICS": 1.345,
  "INTERNATIONAL JOURNAL OF ACAROLOGY": 1.345,
  "ZEITSCHRIFT FUR GASTROENTEROLOGIE": 1.345,
  "ANNALS OF NONINVASIVE ELECTROCARDIOLOGY": 1.345,
  "ASTRONOMY REPORTS": 1.345,
  "BIOTECHNOLOGIE AGRONOMIE SOCIETE ET ENVIRONNEMENT": 1.345,
  "EUROPEAN NEUROLOGY": 1.344,
  "SOMATOSENSORY AND MOTOR RESEARCH": 1.344,
  "CONTRIBUTIONS TO PLASMA PHYSICS": 1.344,
  "DESALINATION AND WATER TREATMENT": 1.344,
  "JOURNAL OF MEDICINE AND PHILOSOPHY": 1.344,
  "JOURNAL OF EMPIRICAL RESEARCH ON HUMAN RESEARCH ETHICS": 1.344,
  "OTJR-OCCUPATION PARTICIPATION AND HEALTH": 1.344,
  "TUMORI J": 1.344,
  "CHILD & FAMILY SOCIAL WORK": 1.344,
  "COGNITIVE PROCESSING": 1.343,
  "EUROPEAN GERIATRIC MEDICINE": 1.343,
  "INTERNATIONAL JOURNAL OF DENTAL HYGIENE": 1.343,
  "INTERNATIONAL RELATIONS OF THE ASIA-PACIFIC": 1.343,
  "JOURNAL OF ESSENTIAL OIL RESEARCH": 1.343,
  "METAPHOR AND SYMBOL": 1.343,
  "APPLICATIONS IN PLANT SCIENCES": 1.343,
  "INTERNATIONAL JOURNAL OF ARTIFICIAL ORGANS": 1.343,
  "RIVISTA ITALIANA DI PALEONTOLOGIA E STRATIGRAFIA": 1.342,
  "ANALYSIS AND APPLICATIONS": 1.342,
  "ASIAN BUSINESS & MANAGEMENT": 1.342,
  "BMC STRUCTURAL BIOLOGY": 1.342,
  "BULLETIN OF THE GEOLOGICAL SOCIETY OF FINLAND": 1.341,
  "COLLEGIAN": 1.341,
  "INTERNATIONAL JOURNAL OF NETWORK MANAGEMENT": 1.34,
  "JOURNAL OF ARTHROPOD-BORNE DISEASES": 1.34,
  "LASER PHYSICS": 1.34,
  "NATURAL LANGUAGE & LINGUISTIC THEORY": 1.34,
  "OPEN SYSTEMS & INFORMATION DYNAMICS": 1.34,
  "PSYCHOLOGISCHE RUNDSCHAU": 1.339,
  "CONGENITAL ANOMALIES": 1.339,
  "PLANT PRODUCTION SCIENCE": 1.338,
  "GENETICA": 1.338,
  "MEASUREMENT & CONTROL": 1.338,
  "MOBILIZATION": 1.338,
  "AUSTRALIAN HEALTH REVIEW": 1.338,
  "INTERNATIONAL JOURNAL OF PERIODONTICS & RESTORATIVE DENTISTRY": 1.337,
  "JOURNAL OF THERMAL SCIENCE": 1.337,
  "RACE ETHNICITY AND EDUCATION": 1.337,
  "ASIAN-AUSTRALASIAN JOURNAL OF ANIMAL SCIENCES": 1.337,
  "ADVANCES IN CLINICAL AND EXPERIMENTAL MEDICINE": 1.336,
  "INTERNATIONAL AGROPHYSICS": 1.336,
  "NETWORKS": 1.336,
  "AUSTRALIAN JOURNAL OF CHEMISTRY": 1.336,
  "CONTEMPORARY POLITICS": 1.335,
  "ENVIRONMENTAL BIOLOGY OF FISHES": 1.335,
  "JOURNAL OF CRIME & JUSTICE": 1.334,
  "HEALTH POLICY AND TECHNOLOGY": 1.333,
  "INTERNATIONAL JOURNAL OF PEDIATRIC OTORHINOLARYNGOLOGY": 1.333,
  "IRANIAN JOURNAL OF PUBLIC HEALTH": 1.333,
  "DESIGNS CODES AND CRYPTOGRAPHY": 1.333,
  "EUROPEAN JOURNAL OF APPLIED MATHEMATICS": 1.333,
  "FOOD SCIENCE AND TECHNOLOGY": 1.333,
  "INTERNATIONAL JOURNAL OF TOXICOLOGY": 1.333,
  "INTERNATIONAL JOURNAL OF ADVANCED ROBOTIC SYSTEMS": 1.333,
  "IRANIAN JOURNAL OF ALLERGY ASTHMA AND IMMUNOLOGY": 1.333,
  "MEDICAL LETTER ON DRUGS AND THERAPEUTICS": 1.333,
  "MATHEMATICAL THINKING AND LEARNING": 1.333,
  "OCCUPATIONAL MEDICINE-OXFORD": 1.331,
  "SMALL GROUP RESEARCH": 1.331,
  "FOOD SCIENCE AND TECHNOLOGY INTERNATIONAL": 1.331,
  "INTERNATIONAL JOURNAL OF COMPUTATIONAL METHODS": 1.33,
  "INTERNATIONAL JOURNAL OF MINERALS METALLURGY AND MATERIALS": 1.33,
  "JOURNAL OF MECHANICAL SCIENCE AND TECHNOLOGY": 1.33,
  "OPEN MEDICINE": 1.33,
  "AJAR-AFRICAN JOURNAL OF AIDS RESEARCH": 1.329,
  "AUSTRALIAN SOCIAL WORK": 1.329,
  "COMMUNICATION & SPORT": 1.329,
  "NATURE CONSERVATION-BULGARIA": 1.329,
  "GENERAL THORACIC AND CARDIOVASCULAR SURGERY": 1.328,
  "INTERNATIONAL JOURNAL OF PEPTIDE RESEARCH AND THERAPEUTICS": 1.328,
  "JOGNN-JOURNAL OF OBSTETRIC GYNECOLOGIC AND NEONATAL NURSING": 1.328,
  "NEW TECHNOLOGY WORK AND EMPLOYMENT": 1.327,
  "SPATIAL STATISTICS": 1.327,
  "WRITTEN COMMUNICATION": 1.327,
  "COMPUTATIONAL METHODS IN APPLIED MATHEMATICS": 1.327,
  "INFORMATICS FOR HEALTH & SOCIAL CARE": 1.327,
  "BIOMEDICAL RESEARCH-TOKYO": 1.327,
  "ENVIRONMENT AND DEVELOPMENT ECONOMICS": 1.327,
  "EUROPEAN JOURNAL OF INDUSTRIAL ENGINEERING": 1.327,
  "JOURNAL OF ASTROPHYSICS AND ASTRONOMY": 1.327,
  "JOURNAL OF COMPUTATIONAL ACOUSTICS": 1.326,
  "PHILOSOPHY OF SCIENCE": 1.326,
  "CONTEMPORARY NURSE": 1.326,
  "JOURNAL OF CHROMATOGRAPHIC SCIENCE": 1.326,
  "JOURNAL OF NEUROLOGICAL SURGERY PART B-SKULL BASE": 1.325,
  "JOURNAL OF RENAL CARE": 1.325,
  "NEMATOLOGY": 1.325,
  "NUMERICAL HEAT TRANSFER PART B-FUNDAMENTALS": 1.325,
  "CLINICS IN PLASTIC SURGERY": 1.324,
  "EUROPEAN EARLY CHILDHOOD EDUCATION RESEARCH JOURNAL": 1.324,
  "INFANT AND CHILD DEVELOPMENT": 1.324,
  "PUBLIC MONEY & MANAGEMENT": 1.323,
  "CHEMISTRY AND ECOLOGY": 1.323,
  "FEMINIST LEGAL STUDIES": 1.323,
  "ISSUES IN SCIENCE AND TECHNOLOGY": 1.322,
  "IMPLANT DENTISTRY": 1.322,
  "POLISH MARITIME RESEARCH": 1.322,
  "DYNAMIC GAMES AND APPLICATIONS": 1.322,
  "PSYCHOSIS-PSYCHOLOGICAL SOCIAL AND INTEGRATIVE APPROACHES": 1.321,
  "RAFFLES BULLETIN OF ZOOLOGY": 1.321,
  "CANADIAN ENTOMOLOGIST": 1.321,
  "E & M EKONOMIE A MANAGEMENT": 1.321,
  "GEOBIOS": 1.321,
  "JOURNAL OF ADHESION SCIENCE AND TECHNOLOGY": 1.32,
  "NUCLEAR INSTRUMENTS & METHODS IN PHYSICS RESEARCH SECTION B-BEAM INTERACTIONS WITH MATERIALS AND ATOMS": 1.319,
  "SMALL RUMINANT RESEARCH": 1.319,
  "SCIENCE & EDUCATION": 1.319,
  "SILICON": 1.319,
  "SOIL AND WATER RESEARCH": 1.318,
  "GLQ-A JOURNAL OF LESBIAN AND GAY STUDIES": 1.318,
  "OPTICAL ENGINEERING": 1.318,
  "ZOOSYSTEMATICS AND EVOLUTION": 1.318,
  "EXPERIMENTAL ANIMALS": 1.318,
  "HELGOLAND MARINE RESEARCH": 1.317,
  "INTERNATIONAL JOURNAL OF COMPUTERIZED DENTISTRY": 1.317,
  "JOURNAL OF OLEO SCIENCE": 1.317,
  "MELBOURNE UNIVERSITY LAW REVIEW": 1.317,
  "AUSTRALASIAN JOURNAL ON AGEING": 1.317,
  "CHILD ABUSE REVIEW": 1.316,
  "CRIMINAL BEHAVIOUR AND MENTAL HEALTH": 1.316,
  "EXPERIMENTAL AGING RESEARCH": 1.316,
  "GENDER IN MANAGEMENT": 1.316,
  "JOURNAL OF NURSING ADMINISTRATION": 1.316,
  "OPTIMIZATION": 1.316,
  "FRONTIERS OF EARTH SCIENCE": 1.315,
  "JOURNAL OF SPECTRAL THEORY": 1.315,
  "RECORDS OF NATURAL PRODUCTS": 1.315,
  "FUNDAMENTA INFORMATICAE": 1.315,
  "JOURNAL OF MACROMOLECULAR SCIENCE PART B-PHYSICS": 1.314,
  "SOCIAL SCIENCE QUARTERLY": 1.314,
  "BALKAN MEDICAL JOURNAL": 1.314,
  "IRANIAN JOURNAL OF KIDNEY DISEASES": 1.313,
  "JOURNAL OF AGRICULTURAL BIOLOGICAL AND ENVIRONMENTAL STATISTICS": 1.313,
  "JOURNAL OF LIBRARIANSHIP AND INFORMATION SCIENCE": 1.313,
  "LETTERS IN MATHEMATICAL PHYSICS": 1.313,
  "COMPARATIVE EUROPEAN POLITICS": 1.313,
  "GROWTH AND CHANGE": 1.313,
  "PLASTICS RUBBER AND COMPOSITES": 1.313,
  "JOURNAL OF AOAC INTERNATIONAL": 1.312,
  "ADSORPTION SCIENCE & TECHNOLOGY": 1.311,
  "AGRICULTURAL AND FOOD SCIENCE": 1.311,
  "ANTHROZOOS": 1.311,
  "CURRENT COMPUTER-AIDED DRUG DESIGN": 1.311,
  "DEATH STUDIES": 1.311,
  "JOURNAL OF NEAR INFRARED SPECTROSCOPY": 1.311,
  "JOURNAL OF MEDICAL IMAGING AND RADIATION ONCOLOGY": 1.31,
  "RACE & CLASS": 1.31,
  "REVISTA ESPANOLA DE DERECHO CONSTITUCIONAL": 1.309,
  "TAIWANESE JOURNAL OF OBSTETRICS & GYNECOLOGY": 1.309,
  "ACTA CRYSTALLOGRAPHICA SECTION F-STRUCTURAL BIOLOGY COMMUNICATIONS": 1.309,
  "JOURNAL OF FORENSIC AND LEGAL MEDICINE": 1.309,
  "NORTH AMERICAN JOURNAL OF ECONOMICS AND FINANCE": 1.308,
  "SCIENCE AND TECHNOLOGY FOR THE BUILT ENVIRONMENT": 1.308,
  "ARCHIVES OF INSECT BIOCHEMISTRY AND PHYSIOLOGY": 1.308,
  "BIOINVASIONS RECORDS": 1.308,
  "ULTRASTRUCTURAL PATHOLOGY": 1.307,
  "BIOPSYCHOSOCIAL MEDICINE": 1.307,
  "GLOBAL POLICY": 1.306,
  "JOURNAL OF PSYCHOSOCIAL ONCOLOGY": 1.306,
  "NEUROREHABILITATION": 1.306,
  "AUSTRALASIAN JOURNAL OF ENVIRONMENTAL MANAGEMENT": 1.306,
  "INTERNATIONAL JOURNAL OF COMPUTER MATHEMATICS": 1.306,
  "INTERNATIONAL JOURNAL OF CONFLICT MANAGEMENT": 1.306,
  "HYSTRIX-ITALIAN JOURNAL OF MAMMALOGY": 1.306,
  "JOURNAL OF ETHNOBIOLOGY": 1.306,
  "AMERICAN JOURNAL OF PHYSICS": 1.306,
  "CANADIAN JOURNAL OF DEVELOPMENT STUDIES-REVUE CANADIENNE D ETUDES DU DEVELOPPEMENT": 1.305,
  "INSECT SYSTEMATICS & EVOLUTION": 1.305,
  "JOURNAL OF CRIMINAL LAW & CRIMINOLOGY": 1.305,
  "JOURNAL OF TROPICAL ECOLOGY": 1.304,
  "JOURNAL OF VETERINARY EMERGENCY AND CRITICAL CARE": 1.304,
  "LASER AND PARTICLE BEAMS": 1.304,
  "JOURNAL OF MICRO-NANOLITHOGRAPHY MEMS AND MOEMS": 1.304,
  "MANAGEMENT COMMUNICATION QUARTERLY": 1.304,
  "PLASMA SCIENCE & TECHNOLOGY": 1.303,
  "GROUND WATER MONITORING AND REMEDIATION": 1.303,
  "JOURNAL OF AGRICULTURAL AND RESOURCE ECONOMICS": 1.302,
  "PROCEEDINGS OF THE LONDON MATHEMATICAL SOCIETY": 1.302,
  "BOLLETTINO DELLA SOCIETA PALEONTOLOGICA ITALIANA": 1.302,
  "CRITICAL REVIEWS IN IMMUNOLOGY": 1.302,
  "INTERNATIONAL JOURNAL OF LAW AND PSYCHIATRY": 1.302,
  "JOURNAL OF APPLIED ANIMAL WELFARE SCIENCE": 1.302,
  "JOURNAL OF TRANSPORTATION SAFETY & SECURITY": 1.302,
  "INTERNATIONAL JOURNAL OF VEHICLE DESIGN": 1.302,
  "INDUSTRIAL ROBOT-THE INTERNATIONAL JOURNAL OF ROBOTICS RESEARCH AND APPLICATION": 1.302,
  "JOURNAL OF SOLAR ENERGY ENGINEERING-TRANSACTIONS OF THE ASME": 1.301,
  "POLAR SCIENCE": 1.301,
  "SOCIAL & LEGAL STUDIES": 1.301,
  "CURRENT BIOINFORMATICS": 1.301,
  "GROUP DYNAMICS-THEORY RESEARCH AND PRACTICE": 1.301,
  "INTERNATIONAL JOURNAL OF NURSING PRACTICE": 1.3,
  "INTERNATIONAL JOURNAL OF OPHTHALMOLOGY": 1.3,
  "NAUTILUS": 1.299,
  "NEGOTIATION AND CONFLICT MANAGEMENT RESEARCH": 1.299,
  "COGNITION TECHNOLOGY & WORK": 1.299,
  "EUROPEAN JOURNAL OF TAXONOMY": 1.298,
  "INTERCULTURAL PRAGMATICS": 1.297,
  "JOURNAL OF ARACHNOLOGY": 1.297,
  "JOURNAL OF MATHEMATICAL ANALYSIS AND APPLICATIONS": 1.297,
  "JOURNAL OF THE CHINESE CHEMICAL SOCIETY": 1.297,
  "LITHIC TECHNOLOGY": 1.297,
  "JOURNAL OF KOREAN NEUROSURGICAL SOCIETY": 1.296,
  "PRISON JOURNAL": 1.296,
  "ENVIRONMENTAL ENGINEERING AND MANAGEMENT JOURNAL": 1.296,
  "JOURNAL OF RADIOANALYTICAL AND NUCLEAR CHEMISTRY": 1.296,
  "JOURNAL OF AMBIENT INTELLIGENCE AND SMART ENVIRONMENTS": 1.296,
  "POLISH JOURNAL OF ENVIRONMENTAL STUDIES": 1.295,
  "REVIEW OF WORLD ECONOMICS": 1.295,
  "COMPUTATIONAL ECONOMICS": 1.295,
  "JOURNAL OF COMPUTER SCIENCE AND TECHNOLOGY": 1.294,
  "JOURNAL OF LAW & ECONOMICS": 1.294,
  "JOURNAL OF ORGANIZATIONAL CHANGE MANAGEMENT": 1.294,
  "JOURNAL OF HUMAN RIGHTS": 1.294,
  "LANGUAGE LEARNING AND DEVELOPMENT": 1.294,
  "PRAMANA-JOURNAL OF PHYSICS": 1.293,
  "POLITICAL STUDIES REVIEW": 1.293,
  "EUROPEAN JOURNAL OF WILDLIFE RESEARCH": 1.293,
  "ROBOTICA": 1.293,
  "REVIEW OF ECONOMICS OF THE HOUSEHOLD": 1.293,
  "AUSTRALIAN JOURNAL OF MANAGEMENT": 1.293,
  "IRANIAN JOURNAL OF PHARMACEUTICAL RESEARCH": 1.293,
  "PHYSICAL GEOGRAPHY": 1.293,
  "REVIEW OF INCOME AND WEALTH": 1.293,
  "STUDIES IN HISTORY AND PHILOSOPHY OF SCIENCE": 1.292,
  "ZEITSCHRIFT FUR PSYCHOLOGIE-JOURNAL OF PSYCHOLOGY": 1.292,
  "SEMINARS IN ULTRASOUND CT AND MRI": 1.292,
  "ANNALS OF SURGICAL TREATMENT AND RESEARCH": 1.292,
  "JOURNAL OF ECONOMIC THEORY": 1.292,
  "JOURNAL OF EVOLUTION EQUATIONS": 1.292,
  "JOURNAL OF PIPELINE SYSTEMS ENGINEERING AND PRACTICE": 1.292,
  "MEDITERRANEAN JOURNAL OF MATHEMATICS": 1.292,
  "SOCIOLOGICAL RESEARCH ONLINE": 1.291,
  "SPORTS MEDICINE AND ARTHROSCOPY REVIEW": 1.291,
  "INTERNATIONAL JOURNAL OF OSTEOARCHAEOLOGY": 1.291,
  "INTERNATIONAL JOURNAL OF CIRCUMPOLAR HEALTH": 1.291,
  "AMERICAN JOURNAL OF CLINICAL HYPNOSIS": 1.291,
  "ANNALS OF VASCULAR SURGERY": 1.291,
  "ARTS & HEALTH": 1.29,
  "HEALTH INFORMATION AND LIBRARIES JOURNAL": 1.289,
  "MATHEMATICAL PROBLEMS IN ENGINEERING": 1.289,
  "JOURNAL OF SOCIAL WORK": 1.289,
  "PEDIATRIC DERMATOLOGY": 1.289,
  "WATER AND ENVIRONMENT JOURNAL": 1.289,
  "TRANSACTIONS OF THE INDIAN INSTITUTE OF METALS": 1.289,
  "VASCULAR": 1.289,
  "ARTHROPOD SYSTEMATICS & PHYLOGENY": 1.288,
  "CARNETS DE GEOLOGIE": 1.287,
  "HUMAN RIGHTS LAW REVIEW": 1.287,
  "INTERNATIONAL JOURNAL OF AGING & HUMAN DEVELOPMENT": 1.286,
  "JOURNAL OF VETERINARY PHARMACOLOGY AND THERAPEUTICS": 1.286,
  "JOURNAL OF INFECTION IN DEVELOPING COUNTRIES": 1.286,
  "CARYOLOGIA": 1.286,
  "CYBERPSYCHOLOGY-JOURNAL OF PSYCHOSOCIAL RESEARCH ON CYBERSPACE": 1.286,
  "JOURNAL OF REAL ESTATE FINANCE AND ECONOMICS": 1.286,
  "JOURNAL OF VETERINARY DIAGNOSTIC INVESTIGATION": 1.286,
  "AFRICAN JOURNAL OF RANGE & FORAGE SCIENCE": 1.286,
  "FIRE AND MATERIALS": 1.285,
  "PLANT ECOLOGY & DIVERSITY": 1.285,
  "REVISTA BRASILEIRA DE CIENCIA DO SOLO": 1.284,
  "SEMINARS IN MUSCULOSKELETAL RADIOLOGY": 1.284,
  "INTERPRETATION-A JOURNAL OF SUBSURFACE CHARACTERIZATION": 1.284,
  "JOURNAL OF AUTOMATED REASONING": 1.284,
  "JOURNAL OF GENERAL AND APPLIED MICROBIOLOGY": 1.283,
  "AUSTRALIAN JOURNAL OF INTERNATIONAL AFFAIRS": 1.283,
  "CHINA REVIEW-AN INTERDISCIPLINARY JOURNAL ON GREATER CHINA": 1.282,
  "INNOVATIONS IN EDUCATION AND TEACHING INTERNATIONAL": 1.282,
  "QUARTERLY JOURNAL OF ENGINEERING GEOLOGY AND HYDROGEOLOGY": 1.281,
  "SOFTWARE TESTING VERIFICATION & RELIABILITY": 1.28,
  "BIOSEMIOTICS": 1.28,
  "BUILDING SERVICES ENGINEERING RESEARCH & TECHNOLOGY": 1.28,
  "CADERNOS DE SAUDE PUBLICA": 1.28,
  "DANISH MEDICAL JOURNAL": 1.279,
  "GENDER AND EDUCATION": 1.278,
  "JOURNAL OF ASIAN NATURAL PRODUCTS RESEARCH": 1.278,
  "WIENER KLINISCHE WOCHENSCHRIFT": 1.278,
  "DIATOM RESEARCH": 1.278,
  "INTERNATIONAL SOCIOLOGY": 1.278,
  "JOURNAL OF DYNAMICAL AND CONTROL SYSTEMS": 1.278,
  "PHYSICS OF METALS AND METALLOGRAPHY": 1.278,
  "WORLD JOURNAL OF PEDIATRICS": 1.277,
  "PROTEIN AND PEPTIDE LETTERS": 1.277,
  "PHYTOTAXA": 1.277,
  "READING TEACHER": 1.277,
  "ATMOSPHERE-OCEAN": 1.277,
  "BEHAVIOUR CHANGE": 1.277,
  "CONCURRENCY AND COMPUTATION-PRACTICE & EXPERIENCE": 1.276,
  "INTERNATIONAL JOURNAL OF OPTICS": 1.276,
  "JOURNAL OF RAPTOR RESEARCH": 1.275,
  "KOREAN JOURNAL OF PARASITOLOGY": 1.275,
  "NUCLEOSIDES NUCLEOTIDES & NUCLEIC ACIDS": 1.275,
  "PRESSE MEDICALE": 1.275,
  "ACM TRANSACTIONS ON ARCHITECTURE AND CODE OPTIMIZATION": 1.274,
  "ANALES DE PEDIATRIA": 1.274,
  "JOURNAL OF ELECTROCARDIOLOGY": 1.274,
  "MARINE GEORESOURCES & GEOTECHNOLOGY": 1.274,
  "PROCEEDINGS OF THE INSTITUTION OF MECHANICAL ENGINEERS PART I-JOURNAL OF SYSTEMS AND CONTROL ENGINEERING": 1.273,
  "JOURNAL OF URBAN PLANNING AND DEVELOPMENT": 1.272,
  "AUSTRALIAN JOURNAL OF BOTANY": 1.272,
  "BRITISH JOURNAL OF ORAL & MAXILLOFACIAL SURGERY": 1.271,
  "FISCAL STUDIES": 1.271,
  "HIGH TEMPERATURE": 1.271,
  "LANGUAGE AND EDUCATION": 1.271,
  "INDIAN PEDIATRICS": 1.27,
  "JOURNAL OF MACROMOLECULAR SCIENCE PART A-PURE AND APPLIED CHEMISTRY": 1.27,
  "REVISTA BRASILEIRA DE REUMATOLOGIA": 1.27,
  "NEW ASTRONOMY": 1.27,
  "QUANTITATIVE INFRARED THERMOGRAPHY JOURNAL": 1.27,
  "WOMEN & HEALTH": 1.27,
  "ACROSS LANGUAGES AND CULTURES": 1.269,
  "FOLIA NEUROPATHOLOGICA": 1.269,
  "INTERNATIONAL JOURNAL OF TECHNOLOGY MANAGEMENT": 1.268,
  "POSTEPY W KARDIOLOGII INTERWENCYJNEJ": 1.268,
  "YOUNG": 1.268,
  "HEALTH & SOCIAL WORK": 1.267,
  "JOURNAL OF SYSTEMS ARCHITECTURE": 1.267,
  "LEIDEN JOURNAL OF INTERNATIONAL LAW": 1.267,
  "TWIN RESEARCH AND HUMAN GENETICS": 1.267,
  "INTERNATIONAL JOURNAL OF EVIDENCE-BASED HEALTHCARE": 1.267,
  "JOURNAL OF MATHEMATICAL INEQUALITIES": 1.267,
  "PHYSIOTHERAPY THEORY AND PRACTICE": 1.267,
  "REVISTA DE LA FACULTAD DE CIENCIAS AGRARIAS": 1.267,
  "SCIENCE OF ADVANCED MATERIALS": 1.265,
  "ARCHIVES ANIMAL BREEDING": 1.265,
  "FACIAL PLASTIC SURGERY CLINICS OF NORTH AMERICA": 1.265,
  "REVISTA ARGENTINA DE MICROBIOLOGIA": 1.265,
  "WILLDENOWIA": 1.265,
  "APPLIED PSYCHOLOGICAL MEASUREMENT": 1.265,
  "JOURNAL OF EDUCATIONAL RESEARCH": 1.265,
  "JOURNAL OF FIRE SCIENCES": 1.264,
  "JOURNAL OF FORESTRY RESEARCH": 1.264,
  "CONSERVATION GENETICS RESOURCES": 1.264,
  "ETHNICITY & DISEASE": 1.264,
  "GENE EXPRESSION PATTERNS": 1.264,
  "LANGUAGE TESTING": 1.264,
  "MINIMALLY INVASIVE THERAPY & ALLIED TECHNOLOGIES": 1.263,
  "WEB ECOLOGY": 1.263,
  "INTERNATIONAL JOURNAL OF MODERN PHYSICS A": 1.263,
  "JOURNAL OF TOXICOLOGIC PATHOLOGY": 1.263,
  "TRANSACTIONS OF THE ASABE": 1.262,
  "WORLD JOURNAL OF CLINICAL CASES": 1.262,
  "ZOO BIOLOGY": 1.262,
  "ANNALES DE L INSTITUT HENRI POINCARE-PROBABILITES ET STATISTIQUES": 1.262,
  "BUSINESS HISTORY": 1.262,
  "GEOGRAFIA FISICA E DINAMICA QUATERNARIA": 1.262,
  "HISTORY OF POLITICAL ECONOMY": 1.262,
  "MUSIC PERCEPTION": 1.262,
  "METROECONOMICA": 1.262,
  "POLAR RESEARCH": 1.261,
  "THORACIC AND CARDIOVASCULAR SURGEON": 1.261,
  "GEOLOGICA ACTA": 1.26,
  "OPEN ECONOMIES REVIEW": 1.26,
  "FOOT AND ANKLE CLINICS": 1.26,
  "INTEGRATION-THE VLSI JOURNAL": 1.26,
  "INFORMATION VISUALIZATION": 1.259,
  "INTERACTION STUDIES": 1.259,
  "JOURNAL OF WILDLIFE DISEASES": 1.259,
  "PHILOSOPHICAL PSYCHOLOGY": 1.259,
  "IEEE COMPUTER ARCHITECTURE LETTERS": 1.259,
  "POWDER METALLURGY": 1.259,
  "SERVICE INDUSTRIES JOURNAL": 1.259,
  "EUROPEAN JOURNAL OF PEDIATRIC SURGERY": 1.258,
  "EXPLORATIONS IN ECONOMIC HISTORY": 1.258,
  "AUSTRALIAN JOURNAL OF EDUCATION": 1.258,
  "DISTRIBUTED AND PARALLEL DATABASES": 1.257,
  "ECONOMETRICS JOURNAL": 1.256,
  "ENVIRONMENTAL GEOTECHNICS": 1.256,
  "LANGUAGE ACQUISITION": 1.256,
  "VISUAL COGNITION": 1.256,
  "VIDEOSURGERY AND OTHER MINIINVASIVE TECHNIQUES": 1.256,
  "CONSTRUCTIVE APPROXIMATION": 1.255,
  "JOURNAL OF ENGINEERING MATHEMATICS": 1.255,
  "NEUROREPORT": 1.255,
  "PROCEEDINGS OF THE INSTITUTION OF MECHANICAL ENGINEERS PART K-JOURNAL OF MULTI-BODY DYNAMICS": 1.255,
  "DIVING AND HYPERBARIC MEDICINE": 1.255,
  "KOREAN JOURNAL FOR FOOD SCIENCE OF ANIMAL RESOURCES": 1.255,
  "CRANIO-THE JOURNAL OF CRANIOMANDIBULAR & SLEEP PRACTICE": 1.255,
  "AMERICAN POLITICS RESEARCH": 1.255,
  "COMBINATORICA": 1.254,
  "DISCRETE AND CONTINUOUS DYNAMICAL SYSTEMS": 1.254,
  "IEEE TRANSACTIONS ON PROFESSIONAL COMMUNICATION": 1.254,
  "LEARNING CULTURE AND SOCIAL INTERACTION": 1.254,
  "SPORT MARKETING QUARTERLY": 1.254,
  "STUDIES IN CONTINUING EDUCATION": 1.254,
  "WEATHER": 1.254,
  "ZOOMORPHOLOGY": 1.254,
  "ZOOKEYS": 1.253,
  "PALAEOWORLD": 1.253,
  "ARABIAN JOURNAL OF GEOSCIENCES": 1.253,
  "ARCHIVES OF IRANIAN MEDICINE": 1.253,
  "ASIA-PACIFIC PSYCHIATRY": 1.253,
  "BIOMEDICAL PAPERS-OLOMOUC": 1.253,
  "CANADIAN GEOGRAPHER-GEOGRAPHE CANADIEN": 1.253,
  "EUROPEAN POLITICAL SCIENCE": 1.253,
  "JOURNAL OF ECONOMICS": 1.253,
  "SINGAPORE MEDICAL JOURNAL": 1.253,
  "ELEMENTARY SCHOOL JOURNAL": 1.253,
  "IEEE TRANSACTIONS ON SEMICONDUCTOR MANUFACTURING": 1.253,
  "JOURNAL OF BEHAVIORAL AND EXPERIMENTAL ECONOMICS": 1.252,
  "PSYCHOLOGY IN THE SCHOOLS": 1.252,
  "JOURNAL OF INTEGRATIVE NEUROSCIENCE": 1.252,
  "STROJNISKI VESTNIK-JOURNAL OF MECHANICAL ENGINEERING": 1.251,
  "ECOLOGY OF FOOD AND NUTRITION": 1.251,
  "FOREST SYSTEMS": 1.25,
  "JOURNAL OF FAMILY THERAPY": 1.25,
  "JOURNAL OF INDIVIDUAL DIFFERENCES": 1.25,
  "CURRENT SPORTS MEDICINE REPORTS": 1.25,
  "PROCEEDINGS OF THE INSTITUTION OF MECHANICAL ENGINEERS PART J-JOURNAL OF ENGINEERING TRIBOLOGY": 1.25,
  "ACTAS UROLOGICAS ESPANOLAS": 1.25,
  "CLINICAL IMAGING": 1.25,
  "INDIAN JOURNAL OF PEDIATRICS": 1.25,
  "JOURNAL OF INEQUALITIES AND APPLICATIONS": 1.25,
  "ADVANCES IN COMPUTERS": 1.25,
  "JOURNAL OF THE SOCIETY FOR INFORMATION DISPLAY": 1.25,
  "OPHTHALMIC PLASTIC AND RECONSTRUCTIVE SURGERY": 1.25,
  "AMERICAN JOURNAL OF THERAPEUTICS": 1.25,
  "AMPHIBIAN & REPTILE CONSERVATION": 1.249,
  "INTERNATIONAL DEVELOPMENT PLANNING REVIEW": 1.248,
  "JOURNAL OF OFFSHORE MECHANICS AND ARCTIC ENGINEERING-TRANSACTIONS OF THE ASME": 1.248,
  "JOURNAL OF PERINATAL & NEONATAL NURSING": 1.248,
  "INVESTMENT ANALYSTS JOURNAL": 1.247,
  "SCANDINAVIAN JOURNAL OF ECONOMICS": 1.247,
  "INTERNATIONAL JOURNAL OF AEROSPACE ENGINEERING": 1.247,
  "JOURNAL OF ENERGY ENGINEERING": 1.247,
  "JOURNAL OF THE LONDON MATHEMATICAL SOCIETY-SECOND SERIES": 1.246,
  "BIOFUELS-UK": 1.246,
  "CREATIVITY RESEARCH JOURNAL": 1.246,
  "INTERNATIONAL JOURNAL OF SPELEOLOGY": 1.246,
  "INTERNATIONAL JOURNAL OF CONFLICT AND VIOLENCE": 1.245,
  "INTERNATIONAL JOURNAL OF EXERGY": 1.245,
  "JOURNAL FOR SPECIALISTS IN PEDIATRIC NURSING": 1.244,
  "JOURNAL OF SUPERCONDUCTIVITY AND NOVEL MAGNETISM": 1.244,
  "NATURAL LANGUAGE ENGINEERING": 1.244,
  "FRONTIERS OF COMPUTER SCIENCE": 1.244,
  "JOURNAL OF COMPUTER AND SYSTEM SCIENCES": 1.244,
  "VETERINARY RADIOLOGY & ULTRASOUND": 1.243,
  "DISCRETE EVENT DYNAMIC SYSTEMS-THEORY AND APPLICATIONS": 1.243,
  "GREEN PROCESSING AND SYNTHESIS": 1.242,
  "ANNALS ACADEMY OF MEDICINE SINGAPORE": 1.242,
  "BIOCHEMICAL SYSTEMATICS AND ECOLOGY": 1.242,
  "CONCURRENT ENGINEERING-RESEARCH AND APPLICATIONS": 1.242,
  "CLINICS": 1.242,
  "OMEGA-JOURNAL OF DEATH AND DYING": 1.242,
  "GASTROENTEROLOGIA Y HEPATOLOGIA": 1.241,
  "PROCEEDINGS OF THE INSTITUTION OF MECHANICAL ENGINEERS PART E-JOURNAL OF PROCESS MECHANICAL ENGINEERING": 1.241,
  "ARDEA": 1.241,
  "ACTA POLITICA": 1.241,
  "IMA JOURNAL OF MANAGEMENT MATHEMATICS": 1.24,
  "INTERNATIONAL JOURNAL OF MIDDLE EAST STUDIES": 1.24,
  "JOURNAL OF LINGUISTICS": 1.24,
  "JOURNAL OF NUTRITIONAL SCIENCE AND VITAMINOLOGY": 1.24,
  "JOURNAL OF WOMEN POLITICS & POLICY": 1.24,
  "LATIN AMERICAN JOURNAL OF SOLIDS AND STRUCTURES": 1.24,
  "PROGRESS IN DEVELOPMENT STUDIES": 1.239,
  "SORT-STATISTICS AND OPERATIONS RESEARCH TRANSACTIONS": 1.239,
  "SEXUAL & REPRODUCTIVE HEALTHCARE": 1.239,
  "APPLIED STOCHASTIC MODELS IN BUSINESS AND INDUSTRY": 1.239,
  "EUROPEAN JOURNAL OF FINANCE": 1.239,
  "ITALIAN JOURNAL OF ZOOLOGY": 1.239,
  "MEDICAL DOSIMETRY": 1.239,
  "SOCIAL EPISTEMOLOGY": 1.238,
  "ACM TRANSACTIONS ON APPLIED PERCEPTION": 1.238,
  "INDIAN JOURNAL OF PSYCHIATRY": 1.238,
  "INTERNATIONAL JOURNAL OF CULTURAL STUDIES": 1.238,
  "JOURNAL OF OBSTETRICS AND GYNAECOLOGY RESEARCH": 1.238,
  "MEASUREMENT SCIENCE REVIEW": 1.237,
  "SOUTH AMERICAN JOURNAL OF HERPETOLOGY": 1.237,
  "AMERICAN CERAMIC SOCIETY BULLETIN": 1.237,
  "GENETIC TESTING AND MOLECULAR BIOMARKERS": 1.237,
  "INTERNATIONAL JOURNAL OF THEORETICAL PHYSICS": 1.236,
  "POLIMERY": 1.236,
  "BLOOD COAGULATION & FIBRINOLYSIS": 1.236,
  "HERPETOZOA": 1.235,
  "JOURNAL OF LEISURE RESEARCH": 1.235,
  "MINI-REVIEWS IN ORGANIC CHEMISTRY": 1.235,
  "NETHERLANDS QUARTERLY OF HUMAN RIGHTS": 1.235,
  "PHOTONIC SENSORS": 1.235,
  "SET-VALUED AND VARIATIONAL ANALYSIS": 1.234,
  "TREE-RING RESEARCH": 1.234,
  "JOURNAL OF EXPERIMENTAL AND THEORETICAL PHYSICS": 1.234,
  "MAMMAL RESEARCH": 1.234,
  "PEDIATRIC EMERGENCY CARE": 1.234,
  "BULLETIN OF THE GEOLOGICAL SOCIETY OF DENMARK": 1.234,
  "INSTRUMENTATION SCIENCE & TECHNOLOGY": 1.234,
  "JOURNAL OF DRUG ISSUES": 1.233,
  "NEW ZEALAND JOURNAL OF BOTANY": 1.233,
  "POLISH POLAR RESEARCH": 1.233,
  "LABORATORY ANIMALS": 1.233,
  "PHILOSOPHICAL MAGAZINE LETTERS": 1.233,
  "PREPARATIVE BIOCHEMISTRY & BIOTECHNOLOGY": 1.233,
  "APPLIED PSYCHOPHYSIOLOGY AND BIOFEEDBACK": 1.233,
  "EXPLORATION GEOPHYSICS": 1.232,
  "JOURNAL OF APPLIED ANALYSIS AND COMPUTATION": 1.232,
  "PETROPHYSICS": 1.232,
  "ZOOSYSTEMA": 1.231,
  "CURRENT HIV RESEARCH": 1.231,
  "HUMAN-WILDLIFE INTERACTIONS": 1.231,
  "JOURNAL OF STRAIN ANALYSIS FOR ENGINEERING DESIGN": 1.231,
  "JOURNAL OF URBAN AFFAIRS": 1.231,
  "JOURNAL OF PEDIATRIC HEALTH CARE": 1.231,
  "JOURNAL OF THERMAL SCIENCE AND ENGINEERING APPLICATIONS": 1.231,
  "ENGINEERING ECONOMIST": 1.231,
  "JOURNAL OF LINGUISTIC ANTHROPOLOGY": 1.231,
  "NONLINEAR DYNAMICS PSYCHOLOGY AND LIFE SCIENCES": 1.231,
  "REPRESENTATION THEORY": 1.231,
  "JOURNAL OF ETHNICITY IN SUBSTANCE ABUSE": 1.231,
  "OXFORD ECONOMIC PAPERS-NEW SERIES": 1.23,
  "PHYSIOLOGY INTERNATIONAL": 1.23,
  "VETERINARY CLINICS OF NORTH AMERICA-EQUINE PRACTICE": 1.229,
  "ACTA BOTANICA BRASILICA": 1.229,
  "ACTA OF BIOENGINEERING AND BIOMECHANICS": 1.229,
  "ANATOLIAN JOURNAL OF CARDIOLOGY": 1.228,
  "JOURNAL OF ELASTOMERS AND PLASTICS": 1.228,
  "MACROHETEROCYCLES": 1.228,
  "ACTA BIOLOGICA CRACOVIENSIA SERIES BOTANICA": 1.228,
  "FEMINIST THEORY": 1.228,
  "GREEN MATERIALS": 1.227,
  "JOURNAL OF ASIAN ECONOMICS": 1.227,
  "JOURNAL OF GREY SYSTEM": 1.227,
  "JOURNAL OF THE AMERICAN PSYCHIATRIC NURSES ASSOCIATION": 1.227,
  "OSIRIS": 1.226,
  "PUBLIC HEALTH NURSING": 1.226,
  "THEORY AND PRACTICE OF LOGIC PROGRAMMING": 1.226,
  "INTERNATIONAL JOURNAL OF PATTERN RECOGNITION AND ARTIFICIAL INTELLIGENCE": 1.226,
  "ADAPTED PHYSICAL ACTIVITY QUARTERLY": 1.225,
  "ANNALS OF THORACIC AND CARDIOVASCULAR SURGERY": 1.225,
  "GEOCHEMISTRY-EXPLORATION ENVIRONMENT ANALYSIS": 1.225,
  "RESOURCE GEOLOGY": 1.225,
  "RESEARCH PAPERS IN EDUCATION": 1.224,
  "CHINESE JOURNAL OF PHYSIOLOGY": 1.224,
  "IOWA LAW REVIEW": 1.223,
  "JOURNAL OF THE CERAMIC SOCIETY OF JAPAN": 1.223,
  "JOVE-JOURNAL OF VISUALIZED EXPERIMENTS": 1.223,
  "LAKE AND RESERVOIR MANAGEMENT": 1.222,
  "NEUROCASE": 1.222,
  "JOURNAL OF SPORTS ECONOMICS": 1.222,
  "PROCEEDINGS OF THE INSTITUTION OF CIVIL ENGINEERS-ENERGY": 1.222,
  "TURKISH JOURNAL OF GASTROENTEROLOGY": 1.222,
  "AMERICAN JOURNAL OF DERMATOPATHOLOGY": 1.221,
  "AUSTRALASIAN PLANT PATHOLOGY": 1.221,
  "CONSTRAINTS": 1.221,
  "CRITICAL INQUIRY": 1.221,
  "JOURNAL OF APPLIED BOTANY AND FOOD QUALITY": 1.221,
  "POSTEPY HIGIENY I MEDYCYNY DOSWIADCZALNEJ": 1.22,
  "THEORY & PSYCHOLOGY": 1.22,
  "JOURNAL OF RESEARCH OF THE NATIONAL INSTITUTE OF STANDARDS AND TECHNOLOGY": 1.22,
  "MATHEMATICS": 1.22,
  "ADVANCED ROBOTICS": 1.22,
  "ADVANCES IN CIVIL ENGINEERING": 1.219,
  "ENDOCRINE METABOLIC & IMMUNE DISORDERS-DRUG TARGETS": 1.219,
  "GEOTECTONICS": 1.219,
  "INDUSTRIAL RELATIONS": 1.219,
  "JOURNAL OF EARTH SYSTEM SCIENCE": 1.219,
  "JOURNAL OF ORAL SCIENCE": 1.219,
  "MATERIALS RESEARCH-IBERO-AMERICAN JOURNAL OF MATERIALS": 1.219,
  "PROCEEDINGS OF THE INSTITUTION OF MECHANICAL ENGINEERS PART G-JOURNAL OF AEROSPACE ENGINEERING": 1.218,
  "DATA BASE FOR ADVANCES IN INFORMATION SYSTEMS": 1.218,
  "MEDICAL PRINCIPLES AND PRACTICE": 1.217,
  "JOURNAL OF SOCIAL PSYCHOLOGY": 1.217,
  "JOURNAL OF CORRECTIONAL HEALTH CARE": 1.217,
  "REVISTA BRASILEIRA DE ENTOMOLOGIA": 1.217,
  "JOURNAL OF COMPUTER INFORMATION SYSTEMS": 1.217,
  "MODERN CHINA": 1.217,
  "CRYPTOGRAPHY AND COMMUNICATIONS-DISCRETE-STRUCTURES BOOLEAN FUNCTIONS AND SEQUENCES": 1.217,
  "APPLIED LINGUISTICS REVIEW": 1.216,
  "BIOREMEDIATION JOURNAL": 1.216,
  "CANADIAN JOURNAL ON AGING-REVUE CANADIENNE DU VIEILLISSEMENT": 1.216,
  "CIENCIA E AGROTECNOLOGIA": 1.216,
  "CANADIAN JOURNAL OF OCCUPATIONAL THERAPY-REVUE CANADIENNE D ERGOTHERAPIE": 1.216,
  "CENTRAL EUROPEAN JOURNAL OF ENERGETIC MATERIALS": 1.216,
  "HUMAN PERFORMANCE": 1.216,
  "JOURNAL OF GLOBAL INFORMATION MANAGEMENT": 1.216,
  "LINGUISTIC INQUIRY": 1.215,
  "TOURISM ECONOMICS": 1.215,
  "ASIAN JOURNAL OF COMMUNICATION": 1.215,
  "BIOTECHNOLOGY & BIOTECHNOLOGICAL EQUIPMENT": 1.215,
  "JOURNAL OF PHYTOPATHOLOGY": 1.214,
  "SOCIAL WORK IN HEALTH CARE": 1.214,
  "CHIMIA": 1.214,
  "JOURNAL OF NEUROSCIENCE NURSING": 1.214,
  "JOURNAL OF SOCIOLOGY": 1.214,
  "METROLOGY AND MEASUREMENT SYSTEMS": 1.214,
  "PERSONAL RELATIONSHIPS": 1.213,
  "AMERICAN JOURNAL OF POTATO RESEARCH": 1.213,
  "ANTHROPOLOGY & MEDICINE": 1.213,
  "CRYPTOGAMIE BRYOLOGIE": 1.212,
  "JOURNAL OF AGRICULTURAL METEOROLOGY": 1.211,
  "LATERALITY": 1.211,
  "SEMINARS IN SPEECH AND LANGUAGE": 1.21,
  "ENERGY SOURCES PART B-ECONOMICS PLANNING AND POLICY": 1.21,
  "JOURNAL OF NANOSCIENCE AND NANOTECHNOLOGY": 1.21,
  "JOURNAL OF LANGUAGE AND POLITICS": 1.21,
  "JOURNAL OF ORGANIZATIONAL AND END USER COMPUTING": 1.21,
  "ENERGY & ENVIRONMENT": 1.21,
  "INTERNATIONAL JOURNAL OF DEVELOPMENTAL BIOLOGY": 1.21,
  "JOURNAL OF APPLIED ANIMAL RESEARCH": 1.209,
  "JOURNAL FOR HEALTHCARE QUALITY": 1.209,
  "REVIEWS IN MATHEMATICAL PHYSICS": 1.209,
  "JOURNAL OF ORGANIZATIONAL BEHAVIOR MANAGEMENT": 1.208,
  "CRYSTAL RESEARCH AND TECHNOLOGY": 1.208,
  "NEOTROPICAL ENTOMOLOGY": 1.208,
  "ZEITSCHRIFT FUR KRISTALLOGRAPHIE-CRYSTALLINE MATERIALS": 1.208,
  "FAMILY MEDICINE": 1.207,
  "MEASUREMENT AND EVALUATION IN COUNSELING AND DEVELOPMENT": 1.206,
  "TROPICAL ANIMAL HEALTH AND PRODUCTION": 1.206,
  "AMERICAN BANKRUPTCY LAW JOURNAL": 1.206,
  "INDIANA UNIVERSITY MATHEMATICS JOURNAL": 1.206,
  "SCIENCE OF COMPUTER PROGRAMMING": 1.206,
  "SAO PAULO MEDICAL JOURNAL": 1.206,
  "SYMMETRY INTEGRABILITY AND GEOMETRY-METHODS AND APPLICATIONS": 1.206,
  "WORLD ECONOMY": 1.206,
  "WORLD TRADE REVIEW": 1.206,
  "ENVIRONMENTAL ENGINEERING RESEARCH": 1.205,
  "JOURNAL OF BEHAVIORAL EDUCATION": 1.205,
  "RENDICONTI LINCEI-SCIENZE FISICHE E NATURALI": 1.205,
  "TURKISH JOURNAL OF BOTANY": 1.204,
  "JOURNAL OF FINANCIAL RESEARCH": 1.204,
  "JOURNAL OF LAW AND SOCIETY": 1.204,
  "CLINICAL LINGUISTICS & PHONETICS": 1.203,
  "CRITICAL ASIAN STUDIES": 1.203,
  "MATHEMATICAL INEQUALITIES & APPLICATIONS": 1.203,
  "OXFORD JOURNAL OF LEGAL STUDIES": 1.203,
  "WISCONSIN LAW REVIEW": 1.203,
  "AUSTRALIAN AND NEW ZEALAND JOURNAL OF CRIMINOLOGY": 1.202,
  "JOURNAL OF ASIAN STUDIES": 1.202,
  "POPULATION RESEARCH AND POLICY REVIEW": 1.202,
  "SCIENCE AND TECHNOLOGY OF NUCLEAR INSTALLATIONS": 1.201,
  "JOURNAL OF EXPERIMENTAL ZOOLOGY PART A-ECOLOGICAL AND INTEGRATIVE PHYSIOLOGY": 1.2,
  "SPECTROSCOPY LETTERS": 1.2,
  "EASTERN EUROPEAN ECONOMICS": 1.2,
  "POLAR-POLITICAL AND LEGAL ANTHROPOLOGY REVIEW": 1.2,
  "ACTA MICROBIOLOGICA ET IMMUNOLOGICA HUNGARICA": 1.2,
  "CLINICAL NEPHROLOGY": 1.2,
  "COMMUNITY DENTAL HEALTH": 1.2,
  "CUTANEOUS AND OCULAR TOXICOLOGY": 1.2,
  "JOURNAL OF CONTEMPORARY ACCOUNTING & ECONOMICS": 1.2,
  "JOURNAL OF SYSTEMS SCIENCE AND SYSTEMS ENGINEERING": 1.2,
  "ZEITSCHRIFT FUR NATURFORSCHUNG SECTION A-A JOURNAL OF PHYSICAL SCIENCES": 1.2,
  "SOLA": 1.199,
  "JOURNAL OF INVESTIGATIVE PSYCHOLOGY AND OFFENDER PROFILING": 1.199,
  "THERAPEUTIC APHERESIS AND DIALYSIS": 1.199,
  "ACTA CHIMICA SLOVENICA": 1.199,
  "APPLICABLE ANALYSIS": 1.198,
  "GFF": 1.198,
  "JOURNAL OF COMMUNITY PSYCHOLOGY": 1.198,
  "REVISTA DE CERCETARE SI INTERVENTIE SOCIALA": 1.197,
  "ANNALS OF REGIONAL SCIENCE": 1.197,
  "ASTRONOMY LETTERS-A JOURNAL OF ASTRONOMY AND SPACE ASTROPHYSICS": 1.197,
  "CHEMIE INGENIEUR TECHNIK": 1.197,
  "AMERICAN JOURNAL OF CRIMINAL JUSTICE": 1.197,
  "DRUGS OF TODAY": 1.196,
  "INTERNATIONAL JOURNAL OF APPLIED CERAMIC TECHNOLOGY": 1.196,
  "ZDRAVSTVENO VARSTVO": 1.196,
  "ENTOMOLOGICAL SCIENCE": 1.195,
  "FOLIA BIOLOGICA": 1.195,
  "JOURNAL OF PENSION ECONOMICS & FINANCE": 1.195,
  "VERHALTENSTHERAPIE": 1.194,
  "JOURNAL OF POLYMER ENGINEERING": 1.194,
  "ASIA PACIFIC JOURNAL OF EDUCATION": 1.194,
  "CHEMICAL RESEARCH IN CHINESE UNIVERSITIES": 1.194,
  "MATHEMATICAL PHYSICS ANALYSIS AND GEOMETRY": 1.194,
  "NURSING PHILOSOPHY": 1.194,
  "SOCIAL SCIENCE JOURNAL": 1.194,
  "SWISS JOURNAL OF PALAEONTOLOGY": 1.193,
  "ACTA HISTOCHEMICA ET CYTOCHEMICA": 1.193,
  "AMERICAN JOURNAL OF VETERINARY RESEARCH": 1.193,
  "ASIAN JOURNAL OF SOCIAL PSYCHOLOGY": 1.192,
  "ECONOMETRIC REVIEWS": 1.192,
  "INTERNATIONAL JOURNAL OF ELECTRONICS": 1.192,
  "JOURNAL OF NURSING EDUCATION": 1.192,
  "MARINE TECHNOLOGY SOCIETY JOURNAL": 1.191,
  "PETROLEUM SCIENCE AND TECHNOLOGY": 1.191,
  "PALAEOBIODIVERSITY AND PALAEOENVIRONMENTS": 1.191,
  "TRANSLATIONAL CANCER RESEARCH": 1.191,
  "INTERNATIONAL JOURNAL OF COMMUNICATION": 1.191,
  "JOURNAL OF CRUSTACEAN BIOLOGY": 1.19,
  "ATOMIC SPECTROSCOPY": 1.19,
  "ENDEAVOUR": 1.19,
  "REVISTA MEXICANA DE INGENIERIA QUIMICA": 1.19,
  "AMERICAN FERN JOURNAL": 1.19,
  "ECONOMIC HISTORY REVIEW": 1.189,
  "INTERNATIONAL JOURNAL OF PHYSICAL MODELLING IN GEOTECHNICS": 1.189,
  "NODEA-NONLINEAR DIFFERENTIAL EQUATIONS AND APPLICATIONS": 1.189,
  "SEMINARS IN CUTANEOUS MEDICINE AND SURGERY": 1.189,
  "CHINESE PHYSICS LETTERS": 1.189,
  "ETHNICITIES": 1.189,
  "LINGUISTICS": 1.189,
  "ELECTRONIC JOURNAL OF QUALITATIVE THEORY OF DIFFERENTIAL EQUATIONS": 1.188,
  "FOUNDATIONS OF SCIENCE": 1.188,
  "JOURNAL OF AFRICAN CULTURAL STUDIES": 1.188,
  "LABORATORY PHONOLOGY": 1.188,
  "CHINESE JOURNAL OF COMMUNICATION": 1.188,
  "MANAGERIAL AUDITING JOURNAL": 1.188,
  "AMERICAN JOURNAL OF PSYCHOLOGY": 1.188,
  "DISSERTATIONES MATHEMATICAE": 1.188,
  "JOURNAL OF THE TEXTILE INSTITUTE": 1.187,
  "MEDICAL PROBLEMS OF PERFORMING ARTISTS": 1.187,
  "ACTA GEODYNAMICA ET GEOMATERIALIA": 1.186,
  "BULLETIN OF INSECTOLOGY": 1.186,
  "DEFENCE AND PEACE ECONOMICS": 1.186,
  "JOURNAL OF CARDIOVASCULAR SURGERY": 1.186,
  "JOURNAL OF ORAL IMPLANTOLOGY": 1.186,
  "PHYSICOCHEMICAL PROBLEMS OF MINERAL PROCESSING": 1.185,
  "FOLIA PRIMATOLOGICA": 1.185,
  "HUMAN BIOLOGY": 1.185,
  "JOURNAL OF AGING & SOCIAL POLICY": 1.185,
  "NEAR SURFACE GEOPHYSICS": 1.185,
  "JOURNAL OF NEUROLOGICAL SURGERY PART A-CENTRAL EUROPEAN NEUROSURGERY": 1.185,
  "NUCLEAR SCIENCE AND ENGINEERING": 1.185,
  "TOURISM REVIEW": 1.185,
  "ACTA VETERINARIA HUNGARICA": 1.185,
  "INTERNATIONAL JOURNAL OF CHEMICAL REACTOR ENGINEERING": 1.184,
  "JOURNAL OF MENTAL HEALTH RESEARCH IN INTELLECTUAL DISABILITIES": 1.184,
  "PAEDIATRICS & CHILD HEALTH": 1.184,
  "BRAGANTIA": 1.183,
  "EKLEM HASTALIKLARI VE CERRAHISI-JOINT DISEASES AND RELATED SURGERY": 1.183,
  "FOREST SCIENCE": 1.183,
  "JOURNAL OF INNOVATIVE OPTICAL HEALTH SCIENCES": 1.183,
  "NOVA HEDWIGIA": 1.183,
  "TRANSFORMATIONS IN BUSINESS & ECONOMICS": 1.183,
  "EUROPEAN JOURNAL OF MIGRATION AND LAW": 1.183,
  "SBORNIK MATHEMATICS": 1.182,
  "DISSENT": 1.181,
  "IEEE TRANSACTIONS ON COMPUTATIONAL INTELLIGENCE AND AI IN GAMES": 1.181,
  "INTERNATIONAL JOURNAL OF CULTURAL POLICY": 1.181,
  "JOURNAL OF AAPOS": 1.181,
  "JOURNAL OF NONLINEAR MATHEMATICAL PHYSICS": 1.181,
  "CITY & COMMUNITY": 1.181,
  "INNOVATION-THE EUROPEAN JOURNAL OF SOCIAL SCIENCE RESEARCH": 1.181,
  "SAUDI MEDICAL JOURNAL": 1.18,
  "AFRICAN DEVELOPMENT REVIEW-REVUE AFRICAINE DE DEVELOPPEMENT": 1.18,
  "INTERNATIONAL JOURNAL OF LOW-CARBON TECHNOLOGIES": 1.18,
  "JOURNAL OF PEDIATRIC OPHTHALMOLOGY & STRABISMUS": 1.179,
  "LITERACY": 1.179,
  "OPTICA APPLICATA": 1.179,
  "BULLETIN DE LA SOCIETE GEOLOGIQUE DE FRANCE": 1.179,
  "INTERNATIONAL JOURNAL OF INCLUSIVE EDUCATION": 1.179,
  "JOURNAL OF COASTAL RESEARCH": 1.178,
  "NEW PERSPECTIVES ON TURKEY": 1.178,
  "CHINA & WORLD ECONOMY": 1.178,
  "EARLY CHILDHOOD EDUCATION JOURNAL": 1.176,
  "MECHANICAL SCIENCES": 1.176,
  "ORL-JOURNAL FOR OTO-RHINO-LARYNGOLOGY HEAD AND NECK SURGERY": 1.175,
  "SYSTEMS RESEARCH AND BEHAVIORAL SCIENCE": 1.175,
  "INTERNATIONAL JOURNAL OF NURSING KNOWLEDGE": 1.175,
  "JOURNAL OF THERMOPHYSICS AND HEAT TRANSFER": 1.175,
  "JOURNAL OF WATER SUPPLY RESEARCH AND TECHNOLOGY-AQUA": 1.175,
  "JOURNAL OF PERSONNEL PSYCHOLOGY": 1.175,
  "POLAR RECORD": 1.174,
  "ACTA PHYSICO-CHIMICA SINICA": 1.174,
  "ANAIS BRASILEIROS DE DERMATOLOGIA": 1.174,
  "CHINA AGRICULTURAL ECONOMIC REVIEW": 1.174,
  "EARTHQUAKE ENGINEERING AND ENGINEERING VIBRATION": 1.173,
  "JOURNAL OF BIOSOCIAL SCIENCE": 1.173,
  "INTERNATIONAL JOURNAL OF MICRO AIR VEHICLES": 1.173,
  "PERCEPTUAL AND MOTOR SKILLS": 1.173,
  "TOPICS IN LANGUAGE DISORDERS": 1.173,
  "ARQUIVOS DE NEURO-PSIQUIATRIA": 1.172,
  "EVOLUTION EQUATIONS AND CONTROL THEORY": 1.172,
  "ACAROLOGIA": 1.172,
  "ASTA-ADVANCES IN STATISTICAL ANALYSIS": 1.171,
  "BASIC AND APPLIED SOCIAL PSYCHOLOGY": 1.171,
  "DIAGNOSTICA": 1.171,
  "ASIA & THE PACIFIC POLICY STUDIES": 1.171,
  "FOLIA GEOBOTANICA": 1.171,
  "INTERNATIONAL BRAZ J UROL": 1.17,
  "QUARTERLY OF APPLIED MATHEMATICS": 1.17,
  "JOURNAL OF VISUAL LANGUAGES AND COMPUTING": 1.17,
  "MICROPROCESSORS AND MICROSYSTEMS": 1.17,
  "PROCEEDINGS OF THE ROYAL SOCIETY OF EDINBURGH SECTION A-MATHEMATICS": 1.17,
  "HUMAN SERVICE ORGANIZATIONS MANAGEMENT LEADERSHIP & GOVERNANCE": 1.17,
  "JOURNAL OF HORTICULTURAL SCIENCE & BIOTECHNOLOGY": 1.17,
  "VETERINARY SURGERY": 1.17,
  "APPLIED MEASUREMENT IN EDUCATION": 1.17,
  "CRITICAL CRIMINOLOGY": 1.169,
  "HEALTH CARE ANALYSIS": 1.169,
  "ICHNOS-AN INTERNATIONAL JOURNAL FOR PLANT AND ANIMAL TRACES": 1.169,
  "KENNEDY INSTITUTE OF ETHICS JOURNAL": 1.169,
  "OUTLOOK ON AGRICULTURE": 1.169,
  "REVISTA CLINICA ESPANOLA": 1.168,
  "REVISTA MEXICANA DE CIENCIAS GEOLOGICAS": 1.168,
  "RUSSIAN JOURNAL OF ELECTROCHEMISTRY": 1.168,
  "ACTA AMAZONICA": 1.167,
  "ACTA INFORMATICA": 1.167,
  "CIRCUIT WORLD": 1.167,
  "CYTOJOURNAL": 1.167,
  "NEW ZEALAND JOURNAL OF FORESTRY SCIENCE": 1.167,
  "OIL SHALE": 1.167,
  "PEDIATRIC HEMATOLOGY AND ONCOLOGY": 1.167,
  "INDIAN JOURNAL OF PHARMACOLOGY": 1.167,
  "AUSTRALIAN SYSTEMATIC BOTANY": 1.166,
  "CANADIAN JOURNAL OF UROLOGY": 1.166,
  "EUROPEAN JOURNAL OF SPECIAL NEEDS EDUCATION": 1.166,
  "JOURNAL OF SOLUTION CHEMISTRY": 1.166,
  "SURGICAL AND RADIOLOGIC ANATOMY": 1.166,
  "ETHOLOGY ECOLOGY & EVOLUTION": 1.165,
  "JOURNAL OF PLANT BIOCHEMISTRY AND BIOTECHNOLOGY": 1.165,
  "MATHEMATICAL MODELLING AND ANALYSIS": 1.164,
  "ACTA ACUSTICA UNITED WITH ACUSTICA": 1.164,
  "AUSTRALIAN JOURNAL OF RURAL HEALTH": 1.164,
  "EXPLORE-THE JOURNAL OF SCIENCE AND HEALING": 1.164,
  "IDENTITIES-GLOBAL STUDIES IN CULTURE AND POWER": 1.164,
  "INDUSTRIAL LUBRICATION AND TRIBOLOGY": 1.163,
  "JOURNAL OF SHELLFISH RESEARCH": 1.163,
  "JOURNAL OF PLASTIC SURGERY AND HAND SURGERY": 1.163,
  "JOURNAL OF PUBLIC ECONOMIC THEORY": 1.162,
  "PORTAL-LIBRARIES AND THE ACADEMY": 1.162,
  "ECONOMICS & POLITICS": 1.162,
  "JOURNAL OF BUILDING PHYSICS": 1.16,
  "ACTA APPLICANDAE MATHEMATICAE": 1.16,
  "JOURNAL OF SIGNAL PROCESSING SYSTEMS FOR SIGNAL IMAGE AND VIDEO TECHNOLOGY": 1.16,
  "SPANISH JOURNAL OF AGRICULTURAL RESEARCH": 1.16,
  "CLIOMETRICA": 1.16,
  "ETHNOGRAPHY": 1.16,
  "JOURNAL OF GYNECOLOGY OBSTETRICS AND HUMAN REPRODUCTION": 1.159,
  "PRIMARY HEALTH CARE RESEARCH AND DEVELOPMENT": 1.159,
  "FLUORIDE": 1.159,
  "FRONTIERS OF INFORMATION TECHNOLOGY & ELECTRONIC ENGINEERING": 1.159,
  "INTERNATIONAL JOURNAL OF NONLINEAR SCIENCES AND NUMERICAL SIMULATION": 1.158,
  "INTERNATIONAL JOURNAL OF METALCASTING": 1.158,
  "JOURNAL OF APPLIED COMMUNICATION RESEARCH": 1.158,
  "MILITARY PSYCHOLOGY": 1.158,
  "ONDERSTEPOORT JOURNAL OF VETERINARY RESEARCH": 1.158,
  "FIRST LANGUAGE": 1.157,
  "NATURAL AREAS JOURNAL": 1.157,
  "PAST & PRESENT": 1.157,
  "DISASTER MEDICINE AND PUBLIC HEALTH PREPAREDNESS": 1.156,
  "INTERNATIONAL JOURNAL OF SOCIAL WELFARE": 1.155,
  "IRISH JOURNAL OF MEDICAL SCIENCE": 1.155,
  "INTERNATIONAL JOURNAL OF IMMUNOGENETICS": 1.155,
  "POTENTIAL ANALYSIS": 1.155,
  "REVISTA INTERNACIONAL DE MEDICINA Y CIENCIAS DE LA ACTIVIDAD FISICA Y DEL DEPORTE": 1.154,
  "SCIENCE CHINA-MATHEMATICS": 1.154,
  "ANNALS OF AGRICULTURAL AND ENVIRONMENTAL MEDICINE": 1.154,
  "EUROPEAN JOURNAL ON CRIMINAL POLICY AND RESEARCH": 1.154,
  "HERZOGIA": 1.154,
  "IZVESTIYA MATHEMATICS": 1.154,
  "JOURNAL OF HERPETOLOGY": 1.153,
  "BIODIVERSITY DATA JOURNAL": 1.153,
  "CIN-COMPUTERS INFORMATICS NURSING": 1.153,
  "EMPIRICAL ECONOMICS": 1.153,
  "JOURNAL OF MULTIVARIATE ANALYSIS": 1.153,
  "JOURNAL OF THE AMERICAN ASSOCIATION OF NURSE PRACTITIONERS": 1.152,
  "LANGUAGE RESOURCES AND EVALUATION": 1.152,
  "PROTEIN JOURNAL": 1.152,
  "TRANSFUSION CLINIQUE ET BIOLOGIQUE": 1.152,
  "AFFILIA-JOURNAL OF WOMEN AND SOCIAL WORK": 1.152,
  "JOURNAL OF FAMILY VIOLENCE": 1.152,
  "REVISTA DE LA REAL ACADEMIA DE CIENCIAS EXACTAS FISICAS Y NATURALES SERIE A-MATEMATICAS": 1.152,
  "COLOR RESEARCH AND APPLICATION": 1.152,
  "IRRIGATION AND DRAINAGE": 1.151,
  "INTERNATIONAL JOURNAL OF SCIENCE AND MATHEMATICS EDUCATION": 1.151,
  "JOURNAL OF TRANSPORT ECONOMICS AND POLICY": 1.15,
  "JOURNAL OF INTERNATIONAL DEVELOPMENT": 1.15,
  "MICROBIOLOGY": 1.15,
  "NOTRE DAME LAW REVIEW": 1.15,
  "CROP BREEDING AND APPLIED BIOTECHNOLOGY": 1.15,
  "EUROPEAN REVIEW OF ECONOMIC HISTORY": 1.15,
  "OCEAN DEVELOPMENT AND INTERNATIONAL LAW": 1.149,
  "PHASE TRANSITIONS": 1.149,
  "STATISTICAL MODELLING": 1.149,
  "JOURNAL OF ECONOMICS & MANAGEMENT STRATEGY": 1.148,
  "JOURNAL OF INDUSTRIAL AND MANAGEMENT OPTIMIZATION": 1.148,
  "NURSING ECONOMICS": 1.147,
  "ADVANCES IN MECHANICAL ENGINEERING": 1.147,
  "AUSTRALIAN JOURNAL OF PRIMARY HEALTH": 1.147,
  "IEEE INSTRUMENTATION & MEASUREMENT MAGAZINE": 1.147,
  "JOURNAL OF BALTIC SCIENCE EDUCATION": 1.147,
  "METHODS OF INFORMATION IN MEDICINE": 1.147,
  "OPERATIVE ORTHOPADIE UND TRAUMATOLOGIE": 1.147,
  "SUGAR TECH": 1.147,
  "EUROPEAN JOURNAL OF WOMENS STUDIES": 1.146,
  "MATHEMATICAL METHODS OF OPERATIONS RESEARCH": 1.146,
  "PSYCHOLOGICAL REPORTS": 1.146,
  "VETERINARY OPHTHALMOLOGY": 1.146,
  "ALCHERINGA": 1.145,
  "IEEE TECHNOLOGY AND SOCIETY MAGAZINE": 1.145,
  "INTERNATIONAL JOURNAL OF GEOMETRIC METHODS IN MODERN PHYSICS": 1.144,
  "JOURNAL OF APPROXIMATION THEORY": 1.143,
  "PHYTOPARASITICA": 1.143,
  "JOURNAL OF MANAGEMENT & ORGANIZATION": 1.143,
  "BRITISH POLITICS": 1.143,
  "CONTEMPORARY SOUTHEAST ASIA": 1.143,
  "LABORATORY MEDICINE": 1.143,
  "ZEMDIRBYSTE-AGRICULTURE": 1.143,
  "ANNALES ZOOLOGICI FENNICI": 1.143,
  "NATURAL RESOURCE MODELING": 1.143,
  "RANGELAND JOURNAL": 1.143,
  "TEACHING SOCIOLOGY": 1.142,
  "COPEIA": 1.141,
  "ASTIN BULLETIN": 1.141,
  "INTERNATIONAL JOURNAL OF MODERN PHYSICS C": 1.141,
  "JOURNAL OF THE AMERICAN ASSOCIATION FOR LABORATORY ANIMAL SCIENCE": 1.141,
  "SCANDINAVIAN JOURNAL OF STATISTICS": 1.141,
  "CANADIAN JOURNAL OF PHYSICS": 1.141,
  "JOURNAL OF SPACECRAFT AND ROCKETS": 1.141,
  "JOURNAL OF ENERGY IN SOUTHERN AFRICA": 1.141,
  "TRANSITION METAL CHEMISTRY": 1.141,
  "JOURNAL OF MORAL EDUCATION": 1.14,
  "PLANT ECOLOGY AND EVOLUTION": 1.14,
  "INTERNATIONAL FEMINIST JOURNAL OF POLITICS": 1.14,
  "JOURNAL OF LANGUAGE AND SOCIAL PSYCHOLOGY": 1.14,
  "JOURNAL OF FOOT & ANKLE SURGERY": 1.139,
  "RUSSIAN CHEMICAL BULLETIN": 1.139,
  "TRANSACTIONS OF THE INDIAN CERAMIC SOCIETY": 1.138,
  "APPLIED ENTOMOLOGY AND ZOOLOGY": 1.138,
  "REVISTA BRASILEIRA DE PARASITOLOGIA VETERINARIA": 1.138,
  "ACTA ZOOLOGICA": 1.138,
  "FISHERY BULLETIN": 1.137,
  "FOREIGN POLICY ANALYSIS": 1.137,
  "ANNALS OF MATHEMATICS AND ARTIFICIAL INTELLIGENCE": 1.136,
  "HETEROATOM CHEMISTRY": 1.136,
  "WATER POLICY": 1.136,
  "PREHOSPITAL AND DISASTER MEDICINE": 1.136,
  "RAMANUJAN JOURNAL": 1.135,
  "CANADIAN ASSOCIATION OF RADIOLOGISTS JOURNAL-JOURNAL DE L ASSOCIATION CANADIENNE DES RADIOLOGISTES": 1.135,
  "JOURNAL OF WATER AND CLIMATE CHANGE": 1.134,
  "WORK-A JOURNAL OF PREVENTION ASSESSMENT & REHABILITATION": 1.133,
  "ADVANCES IN APPLIED MATHEMATICS": 1.133,
  "BIRD STUDY": 1.133,
  "BLOOD PRESSURE MONITORING": 1.133,
  "CZECH JOURNAL OF ANIMAL SCIENCE": 1.133,
  "CIENCIA & SAUDE COLETIVA": 1.133,
  "DISCRETE AND CONTINUOUS DYNAMICAL SYSTEMS-SERIES B": 1.132,
  "PEDIATRIC AND DEVELOPMENTAL PATHOLOGY": 1.132,
  "RANDOM STRUCTURES & ALGORITHMS": 1.131,
  "BIOMEDICAL ENGINEERING-BIOMEDIZINISCHE TECHNIK": 1.131,
  "NEUROLOGIA I NEUROCHIRURGIA POLSKA": 1.131,
  "JOURNAL OF FUNCTION SPACES": 1.13,
  "OPEN PHYSICS": 1.13,
  "GAMES AND ECONOMIC BEHAVIOR": 1.13,
  "JAPANESE JOURNAL OF INFECTIOUS DISEASES": 1.13,
  "ACSMS HEALTH & FITNESS JOURNAL": 1.13,
  "ACTA ORNITHOLOGICA": 1.13,
  "ACTA PHYSICA SLOVACA": 1.13,
  "AUSTRALASIAN PHYSICAL & ENGINEERING SCIENCES IN MEDICINE": 1.13,
  "AUSTRALIAN EDUCATIONAL RESEARCHER": 1.13,
  "AGRICULTURAL ECONOMICS-ZEMEDELSKA EKONOMIKA": 1.13,
  "ANNUAL REPORTS IN MEDICINAL CHEMISTRY": 1.129,
  "ASIAN AMERICAN JOURNAL OF PSYCHOLOGY": 1.129,
  "ASIAN POPULATION STUDIES": 1.129,
  "BIOCONTROL SCIENCE AND TECHNOLOGY": 1.128,
  "BULLETIN OF LATIN AMERICAN RESEARCH": 1.128,
  "COMPOST SCIENCE & UTILIZATION": 1.127,
  "CLINICAL JOURNAL OF ONCOLOGY NURSING": 1.127,
  "DECISION ANALYSIS": 1.127,
  "ECONOMICS AND PHILOSOPHY": 1.127,
  "EXPERIMENTAL PSYCHOLOGY": 1.127,
  "EMERGENCY MEDICINE INTERNATIONAL": 1.126,
  "EMPIRICAL STUDIES OF THE ARTS": 1.126,
  "EUROPEAN PHYSICAL JOURNAL H": 1.125,
  "GEMS & GEMOLOGY": 1.125,
  "HAMOSTASEOLOGIE": 1.125,
  "HUMAN FACTORS AND ERGONOMICS IN MANUFACTURING & SERVICE INDUSTRIES": 1.125,
  "IMA JOURNAL OF MATHEMATICAL CONTROL AND INFORMATION": 1.125,
  "ICELANDIC AGRICULTURAL SCIENCES": 1.125,
  "J-FOR-JOURNAL OF SCIENCE & TECHNOLOGY FOR FOREST PRODUCTS AND PROCESSES": 1.125,
  "JOURNAL OF JAPANESE STUDIES": 1.125,
  "JOURNAL OF PSYCHOPHYSIOLOGY": 1.125,
  "JOURNAL OF CONTEMPORARY CRIMINAL JUSTICE": 1.125,
  "JOURNAL OF MATHEMATICAL LOGIC": 1.125,
  "KOLNER ZEITSCHRIFT FUR SOZIOLOGIE UND SOZIALPSYCHOLOGIE": 1.125,
  "LANGUAGE POLICY": 1.124,
  "MALAYSIAN JOURNAL OF LIBRARY & INFORMATION SCIENCE": 1.124,
  "NETWORK-COMPUTATION IN NEURAL SYSTEMS": 1.123,
  "NORDIC PSYCHOLOGY": 1.123,
  "SEXUALITY AND DISABILITY": 1.123,
  "STANFORD JOURNAL OF INTERNATIONAL LAW": 1.122,
  "ST PETERSBURG MATHEMATICAL JOURNAL": 1.122,
  "TURKISH JOURNAL OF CHEMISTRY": 1.122,
  "TERMINOLOGY": 1.122,
  "THEORY OF COMPUTING": 1.122,
  "WASHINGTON QUARTERLY": 1.122,
  "WEED BIOLOGY AND MANAGEMENT": 1.122,
  "WOMEN & CRIMINAL JUSTICE": 1.121,
  "YOUTH JUSTICE-AN INTERNATIONAL JOURNAL": 1.121,
  "ZEITSCHRIFT FUR NATURFORSCHUNG SECTION C-A JOURNAL OF BIOSCIENCES": 1.121,
  "HERZ": 1.121,
  "ELECTRONIC JOURNAL OF PROBABILITY": 1.12,
  "JOURNAL OF THE GEOLOGICAL SOCIETY OF INDIA": 1.12,
  "JOURNAL OF THE INSTITUTE OF BREWING": 1.12,
  "JOURNAL OF THE ROYAL ARMY MEDICAL CORPS": 1.12,
  "BIO-MEDICAL MATERIALS AND ENGINEERING": 1.12,
  "FLUID DYNAMICS RESEARCH": 1.12,
  "HEALTH PHYSICS": 1.12,
  "ACTA MATHEMATICA SCIENTIA": 1.12,
  "KOREAN JOURNAL OF METALS AND MATERIALS": 1.119,
  "SOIL & SEDIMENT CONTAMINATION": 1.119,
  "AFRICAN JOURNAL OF MARINE SCIENCE": 1.119,
  "CHILEAN JOURNAL OF AGRICULTURAL RESEARCH": 1.118,
  "PETROLEUM CHEMISTRY": 1.118,
  "GEOCHEMICAL JOURNAL": 1.118,
  "JOURNAL OF INTERNATIONAL CRIMINAL JUSTICE": 1.118,
  "SEMINARS IN INTERVENTIONAL RADIOLOGY": 1.118,
  "ZOOTAXA": 1.117,
  "FRONTIERS OF MECHANICAL ENGINEERING": 1.117,
  "JOURNAL OF NANOELECTRONICS AND OPTOELECTRONICS": 1.117,
  "OXFORD BULLETIN OF ECONOMICS AND STATISTICS": 1.116,
  "REPORTS ON MATHEMATICAL PHYSICS": 1.116,
  "REVIEW OF AFRICAN POLITICAL ECONOMY": 1.116,
  "APPLIED ARTIFICIAL INTELLIGENCE": 1.116,
  "JOURNAL OF LIQUID CHROMATOGRAPHY & RELATED TECHNOLOGIES": 1.116,
  "ZEITSCHRIFT FUR GEOMORPHOLOGIE": 1.115,
  "CANADIAN JOURNAL OF PLANT SCIENCE": 1.115,
  "ELECTRONIC JOURNAL OF STATISTICS": 1.115,
  "NEUROETHICS": 1.115,
  "QUALITATIVE THEORY OF DYNAMICAL SYSTEMS": 1.115,
  "STRENGTH AND CONDITIONING JOURNAL": 1.115,
  "STUDIES IN HISTORY AND PHILOSOPHY OF MODERN PHYSICS": 1.115,
  "ACTA BOTANICA CROATICA": 1.114,
  "ARID LAND RESEARCH AND MANAGEMENT": 1.114,
  "ANIMAL REPRODUCTION": 1.114,
  "COMPARATIVE STUDIES IN SOCIETY AND HISTORY": 1.114,
  "HUMAN RIGHTS QUARTERLY": 1.114,
  "JOURNAL OF SYMPLECTIC GEOMETRY": 1.113,
  "PHYSICA C-SUPERCONDUCTIVITY AND ITS APPLICATIONS": 1.113,
  "REVISTA ESPANOLA DE DOCUMENTACION CIENTIFICA": 1.113,
  "RURAL AND REMOTE HEALTH": 1.113,
  "AUSTRALIAN JOURNAL OF PSYCHOLOGY": 1.113,
  "CRITICAL DISCOURSE STUDIES": 1.112,
  "POLYMER SCIENCE SERIES A": 1.112,
  "POST-COMMUNIST ECONOMIES": 1.112,
  "BRAZILIAN JOURNAL OF BIOLOGY": 1.112,
  "DISCRETE APPLIED MATHEMATICS": 1.112,
  "DISCOURSE & COMMUNICATION": 1.111,
  "JOURNAL OF INDUSTRIAL ECONOMICS": 1.111,
  "LATIN AMERICAN ANTIQUITY": 1.111,
  "COLOMBIA MEDICA": 1.111,
  "INTERNATIONAL JOURNAL OF OSTEOPATHIC MEDICINE": 1.111,
  "JOURNAL OF CONTEMPORARY EUROPEAN STUDIES": 1.111,
  "STUDIES ON NEOTROPICAL FAUNA AND ENVIRONMENT": 1.111,
  "TOP": 1.111,
  "CURRICULUM INQUIRY": 1.111,
  "JOURNAL OF FISH AND WILDLIFE MANAGEMENT": 1.111,
  "LUTS-LOWER URINARY TRACT SYMPTOMS": 1.111,
  "REVIEW OF RELIGIOUS RESEARCH": 1.111,
  "VETERINARY RESEARCH COMMUNICATIONS": 1.11,
  "ASIA-PACIFIC JOURNAL OF ACCOUNTING & ECONOMICS": 1.109,
  "COMPUTER JOURNAL": 1.109,
  "FUNDAMENTAL AND APPLIED LIMNOLOGY": 1.109,
  "ICHTHYOLOGICAL RESEARCH": 1.109,
  "IZVESTIYA-PHYSICS OF THE SOLID EARTH": 1.109,
  "TEACHING OF PSYCHOLOGY": 1.108,
  "FOLIA HISTOCHEMICA ET CYTOBIOLOGICA": 1.108,
  "KNOWLEDGE ORGANIZATION": 1.108,
  "REVISTA LATINO-AMERICANA DE ENFERMAGEM": 1.108,
  "CURRENT ISSUES IN LANGUAGE PLANNING": 1.108,
  "ICON-INTERNATIONAL JOURNAL OF CONSTITUTIONAL LAW": 1.108,
  "INTERNATIONAL JOURNAL OF CAST METALS RESEARCH": 1.107,
  "INDIAN JOURNAL OF ORTHOPAEDICS": 1.107,
  "CHALCOGENIDE LETTERS": 1.107,
  "INDIAN JOURNAL OF OPHTHALMOLOGY": 1.106,
  "ISSUES IN MENTAL HEALTH NURSING": 1.106,
  "JOURNAL OF WATER SANITATION AND HYGIENE FOR DEVELOPMENT": 1.106,
  "LINEAR ALGEBRA AND ITS APPLICATIONS": 1.106,
  "MEDICAL HISTORY": 1.106,
  "QUALITATIVE SOCIOLOGY": 1.106,
  "VIOLENCE AND VICTIMS": 1.106,
  "AERONAUTICAL JOURNAL": 1.105,
  "LANGUAGE ASSESSMENT QUARTERLY": 1.105,
  "PERIODICA POLYTECHNICA-CIVIL ENGINEERING": 1.104,
  "PROCESSING AND APPLICATION OF CERAMICS": 1.104,
  "EUROPEAN JOURNAL OF EDUCATION": 1.104,
  "INTERNATIONAL JOURNAL OF SURGICAL PATHOLOGY": 1.104,
  "MEMBRANE WATER TREATMENT": 1.104,
  "MICRO & NANO LETTERS": 1.104,
  "POLISH JOURNAL OF CHEMICAL TECHNOLOGY": 1.104,
  "TROPICAL PLANT BIOLOGY": 1.104,
  "ZEITSCHRIFT FUR PHYSIKALISCHE CHEMIE-INTERNATIONAL JOURNAL OF RESEARCH IN PHYSICAL CHEMISTRY & CHEMICAL PHYSICS": 1.104,
  "ARCHIVES ITALIENNES DE BIOLOGIE": 1.103,
  "JOURNAL OF DIFFERENCE EQUATIONS AND APPLICATIONS": 1.103,
  "JOURNAL OF INTEGRAL EQUATIONS AND APPLICATIONS": 1.102,
  "BIOINSPIRED BIOMIMETIC AND NANOBIOMATERIALS": 1.101,
  "DISCRETE DYNAMICS IN NATURE AND SOCIETY": 1.101,
  "ECONOMIC COMPUTATION AND ECONOMIC CYBERNETICS STUDIES AND RESEARCH": 1.1,
  "FLORIDA ENTOMOLOGIST": 1.1,
  "INTERNATIONAL JOURNAL OF OCCUPATIONAL AND ENVIRONMENTAL HEALTH": 1.099,
  "JOURNAL OF CENTRAL SOUTH UNIVERSITY": 1.098,
  "SOFT MATERIALS": 1.098,
  "EDUCATION AND URBAN SOCIETY": 1.098,
  "HORTICULTURE JOURNAL": 1.098,
  "LC GC EUROPE": 1.098,
  "TOXICOLOGICAL AND ENVIRONMENTAL CHEMISTRY": 1.098,
  "COMBINATORICS PROBABILITY & COMPUTING": 1.098,
  "CHINA INFORMATION": 1.098,
  "PUBLIC CHOICE": 1.098,
  "ARTERY RESEARCH": 1.098,
  "ASTROPHYSICAL BULLETIN": 1.098,
  "JOURNAL OF AFRICAN ECONOMIES": 1.097,
  "JOURNAL OF NURSING RESEARCH": 1.097,
  "ACTA PARASITOLOGICA": 1.097,
  "APPLIED ECONOMICS": 1.097,
  "BRODOGRADNJA": 1.096,
  "INTERNATIONAL JOURNAL OF DATA WAREHOUSING AND MINING": 1.096,
  "REVISTA BRASILEIRA DE ANESTESIOLOGIA": 1.096,
  "APPLICABLE ANALYSIS AND DISCRETE MATHEMATICS": 1.096,
  "DYNAMICAL SYSTEMS-AN INTERNATIONAL JOURNAL": 1.096,
  "GIORNALE ITALIANO DI DERMATOLOGIA E VENEREOLOGIA": 1.096,
  "ISJ-INVERTEBRATE SURVIVAL JOURNAL": 1.095,
  "JOURNAL OF ASIA-PACIFIC ENTOMOLOGY": 1.095,
  "JOURNAL OF MEDIA ETHICS": 1.095,
  "RADIOENGINEERING": 1.095,
  "ACTA ETHOLOGICA": 1.095,
  "BETON- UND STAHLBETONBAU": 1.094,
  "COLLOID JOURNAL": 1.093,
  "COMPTES RENDUS MECANIQUE": 1.093,
  "CLINICAL AND INVESTIGATIVE MEDICINE": 1.093,
  "GEOGRAFISK TIDSSKRIFT-DANISH JOURNAL OF GEOGRAPHY": 1.093,
  "JOURNAL OF HEALTH CARE FOR THE POOR AND UNDERSERVED": 1.093,
  "JOURNAL OF MEDICAL ULTRASONICS": 1.092,
  "JOURNAL OF MINIMAL ACCESS SURGERY": 1.092,
  "REVISTA MATEMATICA COMPLUTENSE": 1.092,
  "EUROPEAN JOURNAL OF ENTOMOLOGY": 1.092,
  "ITALIAN JOURNAL OF AGRONOMY": 1.092,
  "ASIA PACIFIC VIEWPOINT": 1.092,
  "LINEAR & MULTILINEAR ALGEBRA": 1.091,
  "RESEARCH IN GERONTOLOGICAL NURSING": 1.09,
  "CULTURAL STUDIES": 1.09,
  "INTERNATIONAL JOURNAL OF CLINICAL AND EXPERIMENTAL HYPNOSIS": 1.09,
  "JOURNAL OF AIRCRAFT": 1.089,
  "JOURNAL OF CHILD SEXUAL ABUSE": 1.089,
  "LINGUA": 1.089,
  "AFRICAN ZOOLOGY": 1.088,
  "JOURNAL OF STOMATOLOGY ORAL AND MAXILLOFACIAL SURGERY": 1.088,
  "MARINE GEODESY": 1.088,
  "ECONOMIC THEORY": 1.088,
  "INTERNATIONAL JOURNAL OF PLANT PRODUCTION": 1.088,
  "NUCLEAR SCIENCE AND TECHNIQUES": 1.088,
  "ZEITSCHRIFT FUR NATURFORSCHUNG SECTION B-A JOURNAL OF CHEMICAL SCIENCES": 1.088,
  "ACTA CLINICA BELGICA": 1.087,
  "ANNALS OF CLINICAL AND LABORATORY SCIENCE": 1.087,
  "CORPUS LINGUISTICS AND LINGUISTIC THEORY": 1.087,
  "INTERNATIONAL JOURNAL OF INDUSTRIAL ORGANIZATION": 1.087,
  "APPLIED RHEOLOGY": 1.086,
  "ADVANCES IN QUANTUM CHEMISTRY": 1.086,
  "JOURNAL OF GEOMETRIC ANALYSIS": 1.083,
  "TRANSPLANTATION PROCEEDINGS": 1.083,
  "BRAIN IMPAIRMENT": 1.083,
  "BRAZILIAN JOURNAL OF BOTANY": 1.083,
  "JOURNAL OF COMBINATORIAL THEORY SERIES A": 1.083,
  "JOURNAL OF MATERIAL CULTURE": 1.083,
  "JOURNAL OF INTERNATIONAL TRADE & ECONOMIC DEVELOPMENT": 1.082,
  "NETHERLANDS JOURNAL OF MEDICINE": 1.082,
  "PROGRESS IN TRANSPLANTATION": 1.082,
  "ADVANCED STEEL CONSTRUCTION": 1.082,
  "JOURNAL OF HUAZHONG UNIVERSITY OF SCIENCE AND TECHNOLOGY-MEDICAL SCIENCES": 1.081,
  "JOURNAL OF ORTHOPAEDIC SURGERY": 1.081,
  "JUNDISHAPUR JOURNAL OF MICROBIOLOGY": 1.08,
  "NEURAL NETWORK WORLD": 1.08,
  "SYDOWIA": 1.079,
  "INTERNAL MEDICINE": 1.079,
  "NEW ZEALAND JOURNAL OF AGRICULTURAL RESEARCH": 1.079,
  "RHETORIC SOCIETY QUARTERLY": 1.079,
  "AUSTRALIAN FORESTRY": 1.079,
  "AUSTRALIAN MAMMALOGY": 1.079,
  "CLINICAL LABORATORY": 1.079,
  "RIVISTA DI PSICHIATRIA": 1.078,
  "JOURNAL OF DEVELOPMENTAL AND PHYSICAL DISABILITIES": 1.077,
  "COMMUNICATION AND CRITICAL-CULTURAL STUDIES": 1.077,
  "LETTERS IN DRUG DESIGN & DISCOVERY": 1.076,
  "NUCLEAR TECHNOLOGY": 1.076,
  "CRIME LAW AND SOCIAL CHANGE": 1.076,
  "ENGINEERING STUDIES": 1.076,
  "SOCIAL WORK RESEARCH": 1.076,
  "ACTA CARDIOLOGICA": 1.075,
  "ARTHROPODA SELECTA": 1.075,
  "INTERNATIONAL JOURNAL OF FOOD ENGINEERING": 1.075,
  "CANADIAN JOURNAL OF AGRICULTURAL ECONOMICS-REVUE CANADIENNE D AGROECONOMIE": 1.074,
  "INDIAN JOURNAL OF MEDICAL MICROBIOLOGY": 1.074,
  "JOURNAL OF COSMETIC AND LASER THERAPY": 1.074,
  "PERFUSION-UK": 1.074,
  "PHYSICS OF THE SOLID STATE": 1.073,
  "REVISTA LATINOAMERICANA DE INVESTIGACION EN MATEMATICA EDUCATIVA-RELIME": 1.073,
  "SEXUAL AND RELATIONSHIP THERAPY": 1.073,
  "CANADIAN JOURNAL OF SOIL SCIENCE": 1.073,
  "IET INFORMATION SECURITY": 1.073,
  "INTERNATIONAL JOURNAL OF PSYCHIATRY IN MEDICINE": 1.072,
  "MONTHLY REVIEW-AN INDEPENDENT SOCIALIST MAGAZINE": 1.071,
  "MATHEMATICAL MODELLING OF NATURAL PHENOMENA": 1.071,
  "AD HOC & SENSOR WIRELESS NETWORKS": 1.071,
  "BIOTECHNIC & HISTOCHEMISTRY": 1.071,
  "EUROPEAN JOURNAL OF INTEGRATIVE MEDICINE": 1.071,
  "LIFETIME DATA ANALYSIS": 1.071,
  "MUSIC EDUCATION RESEARCH": 1.071,
  "NEUROCHIRURGIE": 1.07,
  "VETERINARY CLINICAL PATHOLOGY": 1.07,
  "BIOCHEMISTRY AND MOLECULAR BIOLOGY EDUCATION": 1.07,
  "CLINICAL NEUROPATHOLOGY": 1.07,
  "FAMILY & COMMUNITY HEALTH": 1.07,
  "INTERNATIONAL JOURNAL OF OPTOMECHATRONICS": 1.07,
  "INTERPRETING": 1.07,
  "JOURNAL OF PEDIATRIC HEMATOLOGY ONCOLOGY": 1.07,
  "LAZAROA": 1.07,
  "STATISTICA SINICA": 1.07,
  "SOCIAL SCIENCE JAPAN JOURNAL": 1.07,
  "JOURNAL OF WOMEN & AGING": 1.07,
  "JOURNAL OF PLANT DISEASES AND PROTECTION": 1.069,
  "ORTHODONTICS & CRANIOFACIAL RESEARCH": 1.069,
  "QUALITATIVE SOCIAL WORK": 1.068,
  "QUALITY TECHNOLOGY AND QUANTITATIVE MANAGEMENT": 1.068,
  "BUNDESGESUNDHEITSBLATT-GESUNDHEITSFORSCHUNG-GESUNDHEITSSCHUTZ": 1.068,
  "CHINESE JOURNAL OF ELECTRONICS": 1.067,
  "INTERNATIONAL JOURNAL OF CLINICAL PHARMACOLOGY AND THERAPEUTICS": 1.067,
  "REVISTA DA ESCOLA DE ENFERMAGEM DA USP": 1.067,
  "APPLIED GEOPHYSICS": 1.067,
  "INTERNATIONAL COMMUNICATION GAZETTE": 1.067,
  "PSICOLOGIA-REFLEXAO E CRITICA": 1.066,
  "SOCIOLOGY COMPASS": 1.066,
  "AMPHIBIA-REPTILIA": 1.066,
  "AUSTRALASIAN PSYCHIATRY": 1.065,
  "CARDIOLOGY IN THE YOUNG": 1.065,
  "HELLENIC JOURNAL OF NUCLEAR MEDICINE": 1.065,
  "SOCIAL INFLUENCE": 1.065,
  "VETERINARY MEDICINE AND SCIENCE": 1.064,
  "ACM TRANSACTIONS ON DESIGN AUTOMATION OF ELECTRONIC SYSTEMS": 1.064,
  "ACTA GEODAETICA ET GEOPHYSICA": 1.063,
  "DM DISEASE-A-MONTH": 1.063,
  "EUROPEAN ZOOLOGICAL JOURNAL": 1.063,
  "INTERNATIONAL POLYMER PROCESSING": 1.063,
  "JOURNAL OF FORENSIC PSYCHIATRY & PSYCHOLOGY": 1.062,
  "CAMBRIDGE QUARTERLY OF HEALTHCARE ETHICS": 1.062,
  "CONCEPTS IN MAGNETIC RESONANCE PART B-MAGNETIC RESONANCE ENGINEERING": 1.062,
  "INTERNATIONAL JOURNAL OF ELECTRICAL ENGINEERING EDUCATION": 1.062,
  "JOURNAL OF BUSINESS-TO-BUSINESS MARKETING": 1.062,
  "JOURNAL OF HISTORICAL PRAGMATICS": 1.062,
  "PLASMA PHYSICS REPORTS": 1.061,
  "TRANSLATION STUDIES": 1.061,
  "ERGODIC THEORY AND DYNAMICAL SYSTEMS": 1.061,
  "JOURNAL OF LATIN AMERICAN STUDIES": 1.061,
  "RUSSIAN JOURNAL OF PLANT PHYSIOLOGY": 1.061,
  "DREAMING": 1.06,
  "JOURNAL OF CIRCUITS SYSTEMS AND COMPUTERS": 1.06,
  "JOURNAL OF HYMENOPTERA RESEARCH": 1.06,
  "JOURNAL OF SYSTEMS SCIENCE & COMPLEXITY": 1.059,
  "PEDIATRICS INTERNATIONAL": 1.059,
  "TRAVAIL HUMAIN": 1.059,
  "ANAIS DA ACADEMIA BRASILEIRA DE CIENCIAS": 1.059,
  "ACTA MONTANISTICA SLOVACA": 1.058,
  "ANNALI DI BOTANICA": 1.058,
  "ETHICS & BEHAVIOR": 1.058,
  "JOURNAL OF EDUCATIONAL MEASUREMENT": 1.058,
  "REHABILITATION": 1.058,
  "INTERNATIONAL FOOD AND AGRIBUSINESS MANAGEMENT REVIEW": 1.058,
  "IRANIAN JOURNAL OF IMMUNOLOGY": 1.057,
  "ADVANCES IN MATHEMATICAL PHYSICS": 1.057,
  "BOTANICAL SCIENCES": 1.056,
  "CHINESE MANAGEMENT STUDIES": 1.056,
  "JOURNAL OF VETERINARY CARDIOLOGY": 1.056,
  "LEGAL STUDIES": 1.056,
  "ORAL AND MAXILLOFACIAL SURGERY CLINICS OF NORTH AMERICA": 1.056,
  "EMERGING MARKETS FINANCE AND TRADE": 1.055,
  "ENDOCRINOLOGIA DIABETES Y NUTRICION": 1.055,
  "INDIAN JOURNAL OF EXPERIMENTAL BIOLOGY": 1.055,
  "IRBM": 1.054,
  "JOURNAL OF PHOTOPOLYMER SCIENCE AND TECHNOLOGY": 1.054,
  "READING & WRITING QUARTERLY": 1.054,
  "WORLD ENGLISHES": 1.054,
  "ANALYSES OF SOCIAL ISSUES AND PUBLIC POLICY": 1.054,
  "BIORHEOLOGY": 1.053,
  "EURE-REVISTA LATINOAMERICANA DE ESTUDIOS URBANO REGIONALES": 1.053,
  "INTERNATIONAL JOURNAL OF GERONTOLOGY": 1.053,
  "ITALIAN JOURNAL OF AGROMETEOROLOGY-RIVISTA ITALIANA DI AGROMETEOROLOGIA": 1.053,
  "JOURNAL OF RATIONAL-EMOTIVE AND COGNITIVE-BEHAVIOR THERAPY": 1.052,
  "MICROWAVE AND OPTICAL TECHNOLOGY LETTERS": 1.052,
  "REGULAR & CHAOTIC DYNAMICS": 1.052,
  "AMERICAN JOURNAL OF OTOLARYNGOLOGY": 1.052,
  "FEMINIST REVIEW": 1.052,
  "INTERNATIONAL JOURNAL FOR MULTISCALE COMPUTATIONAL ENGINEERING": 1.051,
  "MOLECULAR BIOLOGY": 1.051,
  "ACTA CIRURGICA BRASILEIRA": 1.051,
  "CHINESE JOURNAL OF ANALYTICAL CHEMISTRY": 1.051,
  "JOURNAL OF INSECT BEHAVIOR": 1.051,
  "JOURNAL OF MENTAL HEALTH POLICY AND ECONOMICS": 1.051,
  "ACTA CRYSTALLOGRAPHICA SECTION C-STRUCTURAL CHEMISTRY": 1.05,
  "JOURNAL OF FRESHWATER ECOLOGY": 1.05,
  "CANADIAN JOURNAL OF SOCIOLOGY-CAHIERS CANADIENS DE SOCIOLOGIE": 1.05,
  "CAREER DEVELOPMENT QUARTERLY": 1.05,
  "FISHERIES SCIENCE": 1.05,
  "JOURNAL OF IBERIAN GEOLOGY": 1.05,
  "MODERN PHYSICS LETTERS B": 1.049,
  "NORDIC PULP & PAPER RESEARCH JOURNAL": 1.049,
  "WIRELESS PERSONAL COMMUNICATIONS": 1.049,
  "REVISTA ESPANOLA DE MEDICINA NUCLEAR E IMAGEN MOLECULAR": 1.048,
  "AUTEX RESEARCH JOURNAL": 1.048,
  "BANACH JOURNAL OF MATHEMATICAL ANALYSIS": 1.047,
  "JOURNAL OF EQUINE VETERINARY SCIENCE": 1.047,
  "JOURNAL OF THE AUDIO ENGINEERING SOCIETY": 1.047,
  "JOURNAL OF FOOD AND NUTRITION RESEARCH": 1.047,
  "JOURNAL OF OROFACIAL ORTHOPEDICS-FORTSCHRITTE DER KIEFERORTHOPADIE": 1.046,
  "BRAZILIAN JOURNAL OF OCEANOGRAPHY": 1.046,
  "CANADIAN JOURNAL OF VETERINARY RESEARCH-REVUE CANADIENNE DE RECHERCHE VETERINAIRE": 1.046,
  "JOURNAL OF PSYCHIATRIC PRACTICE": 1.046,
  "PEDIATRIC ANNALS": 1.045,
  "COMMUNICATIONS ON PURE AND APPLIED ANALYSIS": 1.045,
  "JOURNAL OF CONTINUING EDUCATION IN NURSING": 1.045,
  "JOURNAL OF PRESSURE VESSEL TECHNOLOGY-TRANSACTIONS OF THE ASME": 1.044,
  "JOURNAL OF POLICY AND PRACTICE IN INTELLECTUAL DISABILITIES": 1.044,
  "AIRCRAFT ENGINEERING AND AEROSPACE TECHNOLOGY": 1.044,
  "ANTHROPOLOGICAL QUARTERLY": 1.043,
  "JOURNAL OF ELECTRONIC IMAGING": 1.043,
  "EAST ASIAN JOURNAL ON APPLIED MATHEMATICS": 1.043,
  "JOURNAL OF GLOBAL INFORMATION TECHNOLOGY MANAGEMENT": 1.043,
  "SOUTH AFRICAN GEOGRAPHICAL JOURNAL": 1.043,
  "CYTOLOGIA": 1.043,
  "JOURNAL OF THEORETICAL POLITICS": 1.043,
  "WATER SCIENCE AND TECHNOLOGY-WATER SUPPLY": 1.043,
  "WORKPLACE HEALTH & SAFETY": 1.043,
  "EMIRATES JOURNAL OF FOOD AND AGRICULTURE": 1.042,
  "JOURNAL OF FAMILY AND ECONOMIC ISSUES": 1.042,
  "INDIAN JOURNAL OF TRADITIONAL KNOWLEDGE": 1.042,
  "INTERNATIONAL JOURNAL OF CLIMATE CHANGE STRATEGIES AND MANAGEMENT": 1.042,
  "NORTH AMERICAN JOURNAL OF AQUACULTURE": 1.042,
  "STATISTICS IN BIOPHARMACEUTICAL RESEARCH": 1.041,
  "UNIVERSAL ACCESS IN THE INFORMATION SOCIETY": 1.041,
  "BOTANICA MARINA": 1.04,
  "ZEITSCHRIFT FUR GERONTOLOGIE UND GERIATRIE": 1.039,
  "INTERNATIONAL JOURNAL OF SURFACE SCIENCE AND ENGINEERING": 1.039,
  "MATERIALS SCIENCE-POLAND": 1.039,
  "PUBLIC ADMINISTRATION AND DEVELOPMENT": 1.039,
  "ACTA GEOPHYSICA": 1.039,
  "CURRENT LEGAL PROBLEMS": 1.038,
  "JOURNAL OF MODERN AFRICAN STUDIES": 1.038,
  "LANGUAGE AND COGNITION": 1.038,
  "REVISTA MEXICANA DE BIODIVERSIDAD": 1.037,
  "DIFFERENTIAL AND INTEGRAL EQUATIONS": 1.037,
  "JOURNAL OF AQUATIC ANIMAL HEALTH": 1.037,
  "EUROPEAN LAW REVIEW": 1.037,
  "HNO": 1.037,
  "HAGUE JOURNAL ON THE RULE OF LAW": 1.037,
  "INFORMATION PROCESSING LETTERS": 1.037,
  "JOURNAL OF APPLIED FLUID MECHANICS": 1.037,
  "MODELING IDENTIFICATION AND CONTROL": 1.037,
  "FLUCTUATION AND NOISE LETTERS": 1.037,
  "MARINE AND FRESHWATER BEHAVIOUR AND PHYSIOLOGY": 1.036,
  "CANADIAN METALLURGICAL QUARTERLY": 1.036,
  "POLITICAL THEORY": 1.035,
  "CRITIQUE OF ANTHROPOLOGY": 1.035,
  "EUROPEAN JOURNAL OF COMBINATORICS": 1.035,
  "JOURNAL OF REGULATORY ECONOMICS": 1.034,
  "LONGITUDINAL AND LIFE COURSE STUDIES": 1.034,
  "ARS MATHEMATICA CONTEMPORANEA": 1.034,
  "JOURNAL OF MACROECONOMICS": 1.034,
  "JOURNAL OF UNIVERSAL COMPUTER SCIENCE": 1.033,
  "JOURNAL OF VETERINARY MEDICAL SCIENCE": 1.033,
  "MATHEMATICAL RESEARCH LETTERS": 1.033,
  "TEACHERS COLLEGE RECORD": 1.033,
  "JOURNAL OF CONSTRUCTIVIST PSYCHOLOGY": 1.033,
  "JOURNAL OF INTERDISCIPLINARY HISTORY": 1.033,
  "RANDOM MATRICES-THEORY AND APPLICATIONS": 1.033,
  "STUDIES IN AMERICAN POLITICAL DEVELOPMENT": 1.032,
  "ISRAEL JOURNAL OF PLANT SCIENCES": 1.032,
  "CARPATHIAN JOURNAL OF EARTH AND ENVIRONMENTAL SCIENCES": 1.032,
  "GRANA": 1.031,
  "JOURNAL OF TRADITIONAL CHINESE MEDICINE": 1.031,
  "POLYMER SCIENCE SERIES B": 1.031,
  "WOMENS STUDIES INTERNATIONAL FORUM": 1.031,
  "HORTSCIENCE": 1.031,
  "JOURNAL OF SOCIAL WORK EDUCATION": 1.031,
  "JOURNAL OF TIME SERIES ANALYSIS": 1.031,
  "CONTEMPORARY ECONOMIC POLICY": 1.031,
  "ERWERBS-OBSTBAU": 1.03,
  "ANAESTHESIST": 1.03,
  "AEROSPACE MEDICINE AND HUMAN PERFORMANCE": 1.03,
  "BULLETIN DES SCIENCES MATHEMATIQUES": 1.03,
  "ANALES DE PSICOLOGIA": 1.03,
  "ASIA-PACIFIC JOURNAL OF TEACHER EDUCATION": 1.029,
  "EUROPEAN SOCIETIES": 1.029,
  "ORAL HEALTH & PREVENTIVE DENTISTRY": 1.029,
  "JOURNAL OF POWER ELECTRONICS": 1.029,
  "THEORETICAL AND MATHEMATICAL PHYSICS": 1.029,
  "THERAPEUTIC INNOVATION & REGULATORY SCIENCE": 1.029,
  "ZEITSCHRIFT FUR RHEUMATOLOGIE": 1.029,
  "JOURNAL OF BUSINESS AND TECHNICAL COMMUNICATION": 1.029,
  "KOEDOE": 1.029,
  "LANGUAGE VARIATION AND CHANGE": 1.029,
  "METHODOLOGY-EUROPEAN JOURNAL OF RESEARCH METHODS FOR THE BEHAVIORAL AND SOCIAL SCIENCES": 1.028,
  "SURVEY RESEARCH METHODS": 1.028,
  "ARCHIVES OF ACOUSTICS": 1.028,
  "CANADIAN PUBLIC POLICY-ANALYSE DE POLITIQUES": 1.027,
  "ANNALS OF INDIAN ACADEMY OF NEUROLOGY": 1.027,
  "EDUCATION AND TREATMENT OF CHILDREN": 1.027,
  "ASIA PACIFIC BUSINESS REVIEW": 1.027,
  "CLOTHING AND TEXTILES RESEARCH JOURNAL": 1.027,
  "INTERNATIONAL JOURNAL OF PEST MANAGEMENT": 1.027,
  "NAGOYA JOURNAL OF MEDICAL SCIENCE": 1.027,
  "NORTHWESTERN JOURNAL OF INTERNATIONAL LAW & BUSINESS": 1.026,
  "ACTA ORTHOPAEDICA ET TRAUMATOLOGICA TURCICA": 1.026,
  "HEREDITAS": 1.026,
  "SOUTHERN FORESTS": 1.026,
  "TURKISH NEUROSURGERY": 1.026,
  "WATER SA": 1.025,
  "JOURNAL OF CONTEMPORARY ETHNOGRAPHY": 1.025,
  "PHYSIOTHERAPY CANADA": 1.025,
  "RADICAL PHILOSOPHY": 1.025,
  "AI EDAM-ARTIFICIAL INTELLIGENCE FOR ENGINEERING DESIGN ANALYSIS AND MANUFACTURING": 1.024,
  "ENERGY SOURCES PART A-RECOVERY UTILIZATION AND ENVIRONMENTAL EFFECTS": 1.024,
  "INTERNATIONAL JOURNAL OF BIOMATHEMATICS": 1.024,
  "JOURNAL OF ANALYTICAL CHEMISTRY": 1.024,
  "POSTCOLONIAL STUDIES": 1.024,
  "AFRICAN JOURNAL OF ECOLOGY": 1.024,
  "ISLAND ARC": 1.024,
  "JOURNAL OF OIL PALM RESEARCH": 1.024,
  "TRANSPORTATION PLANNING AND TECHNOLOGY": 1.023,
  "JOURNAL OF COMBINATORIAL THEORY SERIES B": 1.023,
  "NEUROSCIENCES": 1.023,
  "OCEANOLOGY": 1.023,
  "ASTERISQUE": 1.022,
  "ASIA PACIFIC JOURNAL OF HUMAN RESOURCES": 1.022,
  "GRASAS Y ACEITES": 1.022,
  "JOURNAL OF HISTORICAL SOCIOLOGY": 1.022,
  "JOURNAL OF IMMIGRANT & REFUGEE STUDIES": 1.022,
  "KUWAIT JOURNAL OF SCIENCE": 1.021,
  "JOURNAL OF SOUTHERN AFRICAN STUDIES": 1.02,
  "NORDIC JOURNAL OF BOTANY": 1.02,
  "SARCOIDOSIS VASCULITIS AND DIFFUSE LUNG DISEASES": 1.02,
  "ELECTRIC POWER COMPONENTS AND SYSTEMS": 1.02,
  "FOOD SCIENCE AND BIOTECHNOLOGY": 1.019,
  "HOLISTIC NURSING PRACTICE": 1.019,
  "JOURNAL OF COMPLEXITY": 1.019,
  "AUSTRALIAN VETERINARY JOURNAL": 1.019,
  "JOURNAL OF GENERAL PLANT PATHOLOGY": 1.018,
  "ALGEBRA & NUMBER THEORY": 1.017,
  "ELECTRONIC LIBRARY": 1.017,
  "PLANT BIOTECHNOLOGY": 1.017,
  "UNIVERSITY OF TORONTO LAW JOURNAL": 1.017,
  "WULFENIA": 1.017,
  "CULTURA Y EDUCACION": 1.016,
  "JOURNAL OF TRAUMA NURSING": 1.016,
  "PROCESS SAFETY PROGRESS": 1.016,
  "SCIENCE OF SINTERING": 1.016,
  "REVISTA MEXICANA DE CIENCIAS PECUARIAS": 1.015,
  "TEACHER EDUCATION AND SPECIAL EDUCATION": 1.015,
  "BOTANY LETTERS": 1.014,
  "CANADIAN PUBLIC ADMINISTRATION-ADMINISTRATION PUBLIQUE DU CANADA": 1.014,
  "EURASIAN SOIL SCIENCE": 1.014,
  "JOURNAL OF GRAPH THEORY": 1.014,
  "PERIODICUM BIOLOGORUM": 1.014,
  "ALGORITHMICA": 1.013,
  "COMPARATIVE CYTOGENETICS": 1.013,
  "INTERNATIONAL JOURNAL OF MANPOWER": 1.012,
  "JOURNAL OF HISTORICAL GEOGRAPHY": 1.012,
  "SPECTROSCOPY": 1.012,
  "AFRICA": 1.011,
  "CARBONATES AND EVAPORITES": 1.011,
  "INTERNATIONAL MIGRATION": 1.011,
  "JOURNAL OF SWINE HEALTH AND PRODUCTION": 1.01,
  "JOURNAL OF ENGINEERING THERMOPHYSICS": 1.01,
  "JOURNAL OF INVERSE AND ILL-POSED PROBLEMS": 1.009,
  "NAVAL RESEARCH LOGISTICS": 1.009,
  "ADVANCES IN MATHEMATICS OF COMMUNICATIONS": 1.009,
  "GEOLOGICA BELGICA": 1.008,
  "JOURNAL OF COMPUTATIONAL BIOLOGY": 1.008,
  "JOURNAL OF VISUALIZATION": 1.008,
  "NURSING CLINICS OF NORTH AMERICA": 1.008,
  "HETEROCYCLES": 1.008,
  "STOCHASTIC ANALYSIS AND APPLICATIONS": 1.008,
  "JOURNAL OF APPLIED ICHTHYOLOGY": 1.008,
  "PROCEEDINGS OF THE INSTITUTION OF CIVIL ENGINEERS-STRUCTURES AND BUILDINGS": 1.008,
  "AQUATIC ECOSYSTEM HEALTH & MANAGEMENT": 1.007,
  "ECONOMICS LETTERS": 1.006,
  "JOURNAL OF SYMBOLIC COMPUTATION": 1.005,
  "CIENCIA E TECNICA VITIVINICOLA": 1.005,
  "HERPETOLOGICAL JOURNAL": 1.004,
  "INTERNATIONAL JOURNAL OF MENTAL HEALTH PROMOTION": 1.004,
  "JOURNAL OF ANIMAL AND FEED SCIENCES": 1,
  "JOURNAL OF PERIANESTHESIA NURSING": 1,
  "LANGUAGE AWARENESS": 1,
  "NORDIC STUDIES ON ALCOHOL AND DRUGS": 1,
  "RESEARCH IN SCIENCE & TECHNOLOGICAL EDUCATION": 1,
  "AEQUATIONES MATHEMATICAE": 1,
  "FEW-BODY SYSTEMS": 1,
  "RUSSIAN JOURNAL OF MATHEMATICAL PHYSICS": 1,
  "INTERVIROLOGY": 1,
  "INTERNATIONAL JOURNAL OF STEEL STRUCTURES": 1,
  "RESULTS IN MATHEMATICS": 1,
  "SCIENCE & SOCIETY": 1,
  "SECURITY JOURNAL": 1,
  "ICHTHYOLOGICAL EXPLORATION OF FRESHWATERS": 1,
  "JOURNAL OF FORENSIC PSYCHOLOGY PRACTICE": 1,
  "MECHANICAL ENGINEERING": 1,
  "NATION": 1,
  "NETWORKS AND HETEROGENEOUS MEDIA": 1,
  "SOUTHERN MEDICAL JOURNAL": 1,
  "EUROPEAN JOURNAL OF PAEDIATRIC DENTISTRY": 1,
  "INTERNATIONAL JOURNAL OF INJURY CONTROL AND SAFETY PROMOTION": 1,
  "ISRAEL JOURNAL OF ECOLOGY & EVOLUTION": 1,
  "GLOBAL NEST JOURNAL": 1,
  "INDIAN JOURNAL OF HEMATOLOGY AND BLOOD TRANSFUSION": 1,
  "JOURNAL OF THE INDIAN SOCIETY OF REMOTE SENSING": 1,
  "SOUTH AFRICAN JOURNAL OF ECONOMICS": 1,
  "ERDKUNDE": 1,
  "KINETICS AND CATALYSIS": 1,
  "OPTICAL REVIEW": 1,
  "PROGRAM-ELECTRONIC LIBRARY AND INFORMATION SYSTEMS": 1,
  "ADVANCES IN COMPLEX SYSTEMS": 1,
  "BULLETIN OF THE MALAYSIAN MATHEMATICAL SCIENCES SOCIETY": 1,
  "CLINICAL CASE STUDIES": 1,
  "FORUM MATHEMATICUM": 1,
  "JOURNAL OF THE AMERICAN PSYCHOANALYTIC ASSOCIATION": 1,
  "NEW REVIEW OF HYPERMEDIA AND MULTIMEDIA": 1,
  "INTERNATIONAL JOURNAL OF AEROACOUSTICS": 1,
  "ENCEPHALE-REVUE DE PSYCHIATRIE CLINIQUE BIOLOGIQUE ET THERAPEUTIQUE": 1,
  "GEOCHRONOMETRIA": 1,
  "IRISH POLITICAL STUDIES": 1,
  "ANNALES DE LA SOCIETE ENTOMOLOGIQUE DE FRANCE": 1,
  "AQUATIC LIVING RESOURCES": 1,
  "JOURNAL OF ENGLISH LINGUISTICS": 1,
  "PROBABILITY IN THE ENGINEERING AND INFORMATIONAL SCIENCES": 1,
  "QME-QUANTITATIVE MARKETING AND ECONOMICS": 1,
  "SOLAR SYSTEM RESEARCH": 1,
  "ZEITSCHRIFT FUR WIRTSCHAFTSGEOGRAPHIE": 1,
  "INTERACTING WITH COMPUTERS": 1,
  "INTERNATIONAL JOURNAL OF MODERN PHYSICS B": 1,
  "INTERNATIONAL JOURNAL OF TURBO & JET-ENGINES": 0.995,
  "JOURNAL OF REPRODUCTIVE AND INFANT PSYCHOLOGY": 0.994,
  "POTATO RESEARCH": 0.994,
  "PEDIATRIC PHYSICAL THERAPY": 0.994,
  "REVISTA ESPANOLA DE PEDAGOGIA": 0.994,
  "INTERNATIONAL REVIEW OF RESEARCH IN DEVELOPMENTAL DISABILITIES": 0.993,
  "JOURNAL OF PIDGIN AND CREOLE LANGUAGES": 0.993,
  "MATHEMATICAL AND COMPUTER MODELLING OF DYNAMICAL SYSTEMS": 0.993,
  "PROGRESS IN CHEMISTRY": 0.992,
  "ECOLOGICAL PSYCHOLOGY": 0.992,
  "ETRI JOURNAL": 0.992,
  "EUROPEAN JOURNAL OF PHYSICS": 0.991,
  "IRANIAN JOURNAL OF BIOTECHNOLOGY": 0.991,
  "JOURNAL OF MODERN HISTORY": 0.991,
  "PACIFIC AFFAIRS": 0.99,
  "PACIFIC SCIENCE": 0.99,
  "PHONOLOGY": 0.99,
  "ACOUSTICAL PHYSICS": 0.99,
  "CHILD LANGUAGE TEACHING & THERAPY": 0.989,
  "INTERNATIONAL JOURNAL OF VENTILATION": 0.989,
  "JAVNOST-THE PUBLIC": 0.989,
  "ARQUIVOS BRASILEIROS DE OFTALMOLOGIA": 0.989,
  "BRATISLAVA MEDICAL JOURNAL-BRATISLAVSKE LEKARSKE LISTY": 0.989,
  "CHEMICAL AND BIOCHEMICAL ENGINEERING QUARTERLY": 0.989,
  "GENES & GENETIC SYSTEMS": 0.988,
  "JOURNAL OF MINING AND METALLURGY SECTION B-METALLURGY": 0.987,
  "MALAWI MEDICAL JOURNAL": 0.987,
  "POLICY STUDIES": 0.986,
  "REVISTA ESPANOLA DE INVESTIGACIONES SOCIOLOGICAS": 0.986,
  "VASCULAR AND ENDOVASCULAR SURGERY": 0.986,
  "ADVANCES IN APPLIED CLIFFORD ALGEBRAS": 0.986,
  "CELLULOSE CHEMISTRY AND TECHNOLOGY": 0.986,
  "DIABETOLOGIE UND STOFFWECHSEL": 0.986,
  "DREWNO": 0.986,
  "IET COMPUTERS AND DIGITAL TECHNIQUES": 0.985,
  "INTERNATIONAL JOURNAL OF TRANSPORT ECONOMICS": 0.985,
  "JOURNAL OF ALGEBRAIC GEOMETRY": 0.985,
  "JOURNAL OF BIOLOGICAL PHYSICS": 0.985,
  "OFIOLITI": 0.985,
  "PHYSICS AND CHEMISTRY OF GLASSES-EUROPEAN JOURNAL OF GLASS SCIENCE AND TECHNOLOGY PART B": 0.985,
  "NOROPSIKIYATRI ARSIVI-ARCHIVES OF NEUROPSYCHIATRY": 0.985,
  "TIJDSCHRIFT VOOR ECONOMISCHE EN SOCIALE GEOGRAFIE": 0.985,
  "ACTA DERMATOVENEROLOGICA CROATICA": 0.985,
  "BLUMEA": 0.985,
  "INTERNATIONAL JOURNAL OF TROPICAL INSECT SCIENCE": 0.984,
  "JOURNAL OF ALGEBRAIC COMBINATORICS": 0.984,
  "JOURNAL OF DISABILITY POLICY STUDIES": 0.984,
  "JOURNAL OF WEB ENGINEERING": 0.984,
  "REHABILITATION COUNSELING BULLETIN": 0.983,
  "ANNALES DE L INSTITUT FOURIER": 0.983,
  "AVIAN BIOLOGY RESEARCH": 0.983,
  "INTERNATIONAL JOURNAL OF THERMOPHYSICS": 0.983,
  "LANGUAGE SCIENCES": 0.983,
  "LARYNGO-RHINO-OTOLOGIE": 0.982,
  "MILITARY MEDICINE": 0.982,
  "ATLANTIC GEOLOGY": 0.982,
  "CONDENSED MATTER PHYSICS": 0.982,
  "EUROPEAN JOURNAL OF MASS SPECTROMETRY": 0.982,
  "INTERNATIONAL JOURNAL OF MATERIALS RESEARCH": 0.981,
  "MEDIZINISCHE KLINIK-INTENSIVMEDIZIN UND NOTFALLMEDIZIN": 0.981,
  "REVISTA BRASILEIRA DE POLITICA INTERNACIONAL": 0.981,
  "CANADIAN JOURNAL OF ANIMAL SCIENCE": 0.981,
  "JOURNAL OF MICROWAVE POWER AND ELECTROMAGNETIC ENERGY": 0.981,
  "ULTRASOUND QUARTERLY": 0.98,
  "YONAGO ACTA MEDICA": 0.98,
  "CANADIAN JOURNAL OF ADMINISTRATIVE SCIENCES-REVUE CANADIENNE DES SCIENCES DE L ADMINISTRATION": 0.98,
  "INTERNATIONAL JOURNAL ON ARTIFICIAL INTELLIGENCE TOOLS": 0.98,
  "JOURNAL OF GERONTOLOGICAL SOCIAL WORK": 0.98,
  "JOURNAL OF POLITICAL PHILOSOPHY": 0.98,
  "INTERNATIONAL JOURNAL OF SPORTS MARKETING & SPONSORSHIP": 0.979,
  "MYCOBIOLOGY": 0.979,
  "PRAGMATICS": 0.979,
  "SYSTEMS ENGINEERING": 0.979,
  "WOOD AND FIBER SCIENCE": 0.978,
  "ASIA PACIFIC EDUCATION REVIEW": 0.978,
  "JOURNAL OF HEALTHCARE MANAGEMENT": 0.978,
  "MATHEMATISCHE NACHRICHTEN": 0.978,
  "ASIA-PACIFIC EDUCATION RESEARCHER": 0.977,
  "CANADIAN JOURNAL OF PLANT PATHOLOGY": 0.977,
  "COMMENTARII MATHEMATICI HELVETICI": 0.977,
  "CZECH JOURNAL OF FOOD SCIENCES": 0.977,
  "IMAGING SCIENCE JOURNAL": 0.977,
  "INDAGATIONES MATHEMATICAE-NEW SERIES": 0.977,
  "INTERNATIONAL JOURNAL OF ODONATOLOGY": 0.977,
  "INTERNATIONAL JOURNAL OF LAW CRIME AND JUSTICE": 0.977,
  "INTERNATIONAL JOURNAL ON DOCUMENT ANALYSIS AND RECOGNITION": 0.977,
  "STUDIES IN PHILOSOPHY AND EDUCATION": 0.977,
  "ZOOLOGICAL SCIENCE": 0.976,
  "JOURNAL OF BIOINFORMATICS AND COMPUTATIONAL BIOLOGY": 0.976,
  "MOLLUSCAN RESEARCH": 0.976,
  "ADVANCES IN APPLIED MATHEMATICS AND MECHANICS": 0.976,
  "COLD WAR HISTORY": 0.975,
  "ENVIRONMENTAL & ENGINEERING GEOSCIENCE": 0.975,
  "JOURNAL OF BIOLOGICAL EDUCATION": 0.975,
  "JOURNAL OF COMBINATORIAL DESIGNS": 0.975,
  "JOURNAL OF EAST ASIAN STUDIES": 0.975,
  "ALEA-LATIN AMERICAN JOURNAL OF PROBABILITY AND MATHEMATICAL STATISTICS": 0.975,
  "EKONOMICKY CASOPIS": 0.975,
  "EVOLUTIONARY ECOLOGY RESEARCH": 0.974,
  "NORTH-WESTERN JOURNAL OF ZOOLOGY": 0.974,
  "SIAM JOURNAL ON DISCRETE MATHEMATICS": 0.974,
  "ACTA SCIENTIARUM-AGRONOMY": 0.973,
  "INTERNATIONAL JOURNAL OF AVIATION PSYCHOLOGY": 0.973,
  "ZEITSCHRIFT FUR PSYCHOSOMATISCHE MEDIZIN UND PSYCHOTHERAPIE": 0.973,
  "ANNALES ZOOLOGICI": 0.973,
  "DIPLOMATIC HISTORY": 0.973,
  "GESUNDHEITSWESEN": 0.973,
  "GLOBAL ECONOMIC REVIEW": 0.973,
  "ACTA OECONOMICA": 0.973,
  "AORN JOURNAL": 0.973,
  "CERAMICS-SILIKATY": 0.972,
  "JOURNAL OF GERONTOLOGICAL NURSING": 0.972,
  "MICROELECTRONICS INTERNATIONAL": 0.972,
  "AUSTRALIAN JOURNAL OF POLITICAL SCIENCE": 0.971,
  "CELLULAR POLYMERS": 0.97,
  "HEALTH EDUCATION JOURNAL": 0.97,
  "HISTORY OF THE HUMAN SCIENCES": 0.97,
  "JOURNAL OF BIOLOGICAL SYSTEMS": 0.969,
  "JOURNAL AMERICAN WATER WORKS ASSOCIATION": 0.969,
  "STRATIGRAPHY AND GEOLOGICAL CORRELATION": 0.969,
  "CRITICAL REVIEW": 0.969,
  "INTERNATIONAL JOURNAL OF QUANTUM INFORMATION": 0.969,
  "JOURNAL OF FUNCTIONAL PROGRAMMING": 0.968,
  "JOURNAL OF NATURAL HISTORY": 0.968,
  "JOURNAL OF MAGNETICS": 0.968,
  "JOURNAL OF OFFICIAL STATISTICS": 0.968,
  "TOPOLOGICAL METHODS IN NONLINEAR ANALYSIS": 0.968,
  "COLLECTANEA MATHEMATICA": 0.967,
  "EMPIRICA": 0.967,
  "OCHRONA SRODOWISKA": 0.967,
  "SYMBOLIC INTERACTION": 0.967,
  "ACTA MEDICA MEDITERRANEA": 0.967,
  "CIRUGIA ESPANOLA": 0.967,
  "GEOCHEMISTRY INTERNATIONAL": 0.967,
  "INDIANA LAW JOURNAL": 0.966,
  "JOURNAL OF WORLD TRADE": 0.966,
  "PSYCHOTHERAPIE PSYCHOSOMATIK MEDIZINISCHE PSYCHOLOGIE": 0.966,
  "PAKISTAN JOURNAL OF MEDICAL SCIENCES": 0.966,
  "AUSTRALIAN JOURNAL OF SOCIAL ISSUES": 0.966,
  "AFRICA SPECTRUM": 0.966,
  "ANTHROPOLOGICAL FORUM": 0.966,
  "BRAZILIAN JOURNAL OF PHYSICS": 0.966,
  "CONTRIBUTIONS OF THE ASTRONOMICAL OBSERVATORY SKALNATE PLESO": 0.966,
  "INTERNATIONAL JOURNAL OF WEB AND GRID SERVICES": 0.966,
  "JOURNAL OF AGGRESSION MALTREATMENT & TRAUMA": 0.965,
  "JOURNAL OF THEORETICAL AND APPLIED ELECTRONIC COMMERCE RESEARCH": 0.965,
  "NEW GENERATION COMPUTING": 0.964,
  "POSITIVITY": 0.964,
  "SERBIAN ASTRONOMICAL JOURNAL": 0.964,
  "SERIES-JOURNAL OF THE SPANISH ECONOMIC ASSOCIATION": 0.964,
  "MATHEMATISCHE ZEITSCHRIFT": 0.963,
  "MINERVA PEDIATRICA": 0.963,
  "REVISTA BRASILEIRA DE ZOOTECNIA-BRAZILIAN JOURNAL OF ANIMAL SCIENCE": 0.963,
  "JOURNAL OF THE JAPAN PETROLEUM INSTITUTE": 0.963,
  "JOURNAL OF THE NATIONAL MEDICAL ASSOCIATION": 0.963,
  "RADIATION PROTECTION DOSIMETRY": 0.962,
  "CANADIAN JOURNAL OF MATHEMATICS-JOURNAL CANADIEN DE MATHEMATIQUES": 0.962,
  "INFORMATION AND COMPUTATION": 0.962,
  "STUDIES IN COMPARATIVE INTERNATIONAL DEVELOPMENT": 0.961,
  "SCRIPTA NOVA-REVISTA ELECTRONICA DE GEOGRAFIA Y CIENCIAS SOCIALES": 0.961,
  "ANNALS OF PURE AND APPLIED LOGIC": 0.961,
  "CHINESE JOURNAL OF GEOPHYSICS-CHINESE EDITION": 0.961,
  "CURRENT PHARMACEUTICAL ANALYSIS": 0.96,
  "INTERNATIONAL JOURNAL OF CORPUS LINGUISTICS": 0.96,
  "JOURNAL OF THE AMERICAN SOCIETY FOR HORTICULTURAL SCIENCE": 0.96,
  "JOURNAL OF VETERINARY RESEARCH": 0.96,
  "NERVENARZT": 0.959,
  "ORNIS FENNICA": 0.959,
  "PSYCHOLOGIE IN ERZIEHUNG UND UNTERRICHT": 0.959,
  "AMERICAN LAW AND ECONOMICS REVIEW": 0.959,
  "FOUNDATIONS OF CHEMISTRY": 0.958,
  "ISRAEL MEDICAL ASSOCIATION JOURNAL": 0.958,
  "JOURNAL OF CARBOHYDRATE CHEMISTRY": 0.958,
  "JOURNAL OF THE SERBIAN CHEMICAL SOCIETY": 0.958,
  "JOURNAL OF AGRICULTURAL SCIENCE AND TECHNOLOGY": 0.958,
  "PSYCHOANALYTIC PSYCHOLOGY": 0.958,
  "SOUTHERN ECONOMIC JOURNAL": 0.958,
  "TRANSACTIONS OF THE JAPAN SOCIETY FOR AERONAUTICAL AND SPACE SCIENCES": 0.957,
  "INQUIRY-AN INTERDISCIPLINARY JOURNAL OF PHILOSOPHY": 0.957,
  "SOCIOLOGICAL PERSPECTIVES": 0.957,
  "AUSTRALIAN FAMILY PHYSICIAN": 0.957,
  "CHILDREN & SOCIETY": 0.957,
  "GEOFISICA INTERNACIONAL": 0.957,
  "INTERNATIONAL JOURNAL OF SELECTION AND ASSESSMENT": 0.956,
  "JPC-JOURNAL OF PLANAR CHROMATOGRAPHY-MODERN TLC": 0.956,
  "JOURNAL OF CERAMIC SCIENCE AND TECHNOLOGY": 0.956,
  "JOURNAL OF NONCOMMUTATIVE GEOMETRY": 0.955,
  "PHONETICA": 0.955,
  "COMBUSTION EXPLOSION AND SHOCK WAVES": 0.955,
  "ESTONIAN JOURNAL OF EARTH SCIENCES": 0.955,
  "JOURNAL OF GENETICS": 0.955,
  "LOW TEMPERATURE PHYSICS": 0.954,
  "ACTION RESEARCH": 0.953,
  "CHEMOSENSORY PERCEPTION": 0.953,
  "EDUCATION AND TRAINING IN AUTISM AND DEVELOPMENTAL DISABILITIES": 0.953,
  "INTERNATIONAL TAX AND PUBLIC FINANCE": 0.952,
  "JOURNAL OF GENETIC PSYCHOLOGY": 0.952,
  "JOURNAL OF BIOMATERIALS AND TISSUE ENGINEERING": 0.952,
  "JOURNAL OF QUANTITATIVE LINGUISTICS": 0.952,
  "LATIN AMERICAN ECONOMIC REVIEW": 0.951,
  "ANALOG INTEGRATED CIRCUITS AND SIGNAL PROCESSING": 0.951,
  "ADVANCES IN APPLIED PROBABILITY": 0.951,
  "ANNALES DE LIMNOLOGIE-INTERNATIONAL JOURNAL OF LIMNOLOGY": 0.95,
  "COMPUTATIONAL COMPLEXITY": 0.95,
  "INDIAN JOURNAL OF PURE & APPLIED PHYSICS": 0.95,
  "JOURNAL OF FAMILY PRACTICE": 0.95,
  "LITHUANIAN JOURNAL OF PHYSICS": 0.95,
  "NUMERICAL FUNCTIONAL ANALYSIS AND OPTIMIZATION": 0.95,
  "RUSSIAN JOURNAL OF INORGANIC CHEMISTRY": 0.95,
  "UNDERSEA AND HYPERBARIC MEDICINE": 0.95,
  "CESIFO ECONOMIC STUDIES": 0.949,
  "JOURNAL OF CAVE AND KARST STUDIES": 0.949,
  "LAW PROBABILITY & RISK": 0.949,
  "OCCUPATIONAL THERAPY INTERNATIONAL": 0.949,
  "JOURNAL OF CLINICAL ULTRASOUND": 0.949,
  "JOURNAL OF RESEARCH IN MUSIC EDUCATION": 0.949,
  "PHARMAZIE": 0.948,
  "FAMILIES IN SOCIETY-THE JOURNAL OF CONTEMPORARY SOCIAL SERVICES": 0.948,
  "PEDIATRIC ENDOCRINOLOGY REVIEWS PER": 0.948,
  "AVIAN RESEARCH": 0.948,
  "INTERNATIONAL JOURNAL OF DISABILITY DEVELOPMENT AND EDUCATION": 0.948,
  "JOURNAL OF PLANT PATHOLOGY": 0.948,
  "LOGOPEDICS PHONIATRICS VOCOLOGY": 0.948,
  "ACM TRANSACTIONS ON ALGORITHMS": 0.947,
  "REVIEW OF KEYNESIAN ECONOMICS": 0.947,
  "JOURNAL OF COMBINATORIAL OPTIMIZATION": 0.947,
  "JOURNAL OF FORECASTING": 0.947,
  "DISCOURSE CONTEXT & MEDIA": 0.947,
  "DISCRETE OPTIMIZATION": 0.947,
  "JOURNAL OF MECHANICS IN MEDICINE AND BIOLOGY": 0.947,
  "JOURNAL OF SUBSTANCE USE": 0.947,
  "RISK MANAGEMENT-AN INTERNATIONAL JOURNAL": 0.947,
  "ENSENANZA DE LAS CIENCIAS": 0.946,
  "JOURNAL OF BACK AND MUSCULOSKELETAL REHABILITATION": 0.946,
  "KNOWLEDGE ENGINEERING REVIEW": 0.946,
  "MACROECONOMIC DYNAMICS": 0.946,
  "QUEUEING SYSTEMS": 0.946,
  "ACM TRANSACTIONS ON RECONFIGURABLE TECHNOLOGY AND SYSTEMS": 0.945,
  "PROCEEDINGS OF THE AMERICAN MATHEMATICAL SOCIETY": 0.945,
  "CYBIUM": 0.945,
  "INTEGRAL TRANSFORMS AND SPECIAL FUNCTIONS": 0.945,
  "JOURNAL OF EXPERIMENTAL PSYCHOPATHOLOGY": 0.945,
  "NEPHROLOGIE & THERAPEUTIQUE": 0.944,
  "BANGLADESH JOURNAL OF PHARMACOLOGY": 0.944,
  "JOURNAL OF GENERAL PSYCHOLOGY": 0.944,
  "SPIN": 0.944,
  "ACTA AGRICULTURAE SCANDINAVICA SECTION B-SOIL AND PLANT SCIENCE": 0.943,
  "CONTEMPORARY EUROPEAN HISTORY": 0.943,
  "HETEROCYCLIC COMMUNICATIONS": 0.943,
  "JOURNAL OF VOLCANOLOGY AND SEISMOLOGY": 0.943,
  "REVUE DE MEDECINE INTERNE": 0.943,
  "VETERINARY AND COMPARATIVE ORTHOPAEDICS AND TRAUMATOLOGY": 0.943,
  "HANDCHIRURGIE MIKROCHIRURGIE PLASTISCHE CHIRURGIE": 0.943,
  "ZEITSCHRIFT FUR ANALYSIS UND IHRE ANWENDUNGEN": 0.942,
  "ANNALS OF SAUDI MEDICINE": 0.942,
  "ASYMPTOTIC ANALYSIS": 0.942,
  "DERMATOLOGICA SINICA": 0.942,
  "INTERNATIONAL JOURNAL OF NUMERICAL ANALYSIS AND MODELING": 0.942,
  "JOURNAL OF APPLIED POULTRY RESEARCH": 0.942,
  "FRUITS": 0.941,
  "INTERNATIONAL REVIEW OF FINANCE": 0.941,
  "MONATSHEFTE FUR MATHEMATIK": 0.941,
  "APPLIED MATHEMATICS-A JOURNAL OF CHINESE UNIVERSITIES SERIES B": 0.941,
  "BIOCONTROL SCIENCE": 0.941,
  "CHEMICAL INDUSTRY & CHEMICAL ENGINEERING QUARTERLY": 0.941,
  "COMPLEX VARIABLES AND ELLIPTIC EQUATIONS": 0.941,
  "GRASSLAND SCIENCE": 0.941,
  "JOURNAL OF GEOMETRY AND PHYSICS": 0.94,
  "MLJEKARSTVO": 0.94,
  "NATIONAL TAX JOURNAL": 0.94,
  "POLIMEROS-CIENCIA E TECNOLOGIA": 0.939,
  "REVUE D EPIDEMIOLOGIE ET DE SANTE PUBLIQUE": 0.939,
  "SCOTTISH GEOGRAPHICAL JOURNAL": 0.939,
  "TRANSACTIONS OF THE INSTITUTE OF METAL FINISHING": 0.939,
  "CANADIAN JOURNAL OF CRIMINOLOGY AND CRIMINAL JUSTICE": 0.939,
  "COMPLEMENTARY MEDICINE RESEARCH": 0.939,
  "EQUINE VETERINARY EDUCATION": 0.939,
  "IEEE LATIN AMERICA TRANSACTIONS": 0.938,
  "JOURNAL OF APICULTURAL SCIENCE": 0.938,
  "UKRAINIAN JOURNAL OF PHYSICAL OPTICS": 0.938,
  "NATIONALITIES PAPERS-THE JOURNAL OF NATIONALISM AND ETHNICITY": 0.938,
  "ANNALI DELLA SCUOLA NORMALE SUPERIORE DI PISA-CLASSE DI SCIENZE": 0.938,
  "INTERNATIONAL JOURNAL OF AGRICULTURE AND BIOLOGY": 0.938,
  "NEUROLOGIST": 0.937,
  "POLISH JOURNAL OF VETERINARY SCIENCES": 0.937,
  "OPTICS AND SPECTROSCOPY": 0.936,
  "REVISTA DA ASSOCIACAO MEDICA BRASILEIRA": 0.936,
  "ACCREDITATION AND QUALITY ASSURANCE": 0.936,
  "ACM TRANSACTIONS ON PROGRAMMING LANGUAGES AND SYSTEMS": 0.935,
  "AFRICAN STUDIES REVIEW": 0.935,
  "ENVIRONMENT AND HISTORY": 0.935,
  "EUROPEAN PHYSICAL JOURNAL-APPLIED PHYSICS": 0.934,
  "ECOLOGICAL RESTORATION": 0.934,
  "FORESTRY CHRONICLE": 0.934,
  "INFORMATION TECHNOLOGY AND LIBRARIES": 0.934,
  "INVERTEBRATE NEUROSCIENCE": 0.934,
  "IRANIAN JOURNAL OF SCIENCE AND TECHNOLOGY-TRANSACTIONS OF CIVIL ENGINEERING": 0.934,
  "KLINISCHE PADIATRIE": 0.934,
  "MATHEMATICS OF CONTROL SIGNALS AND SYSTEMS": 0.933,
  "MULTILINGUA-JOURNAL OF CROSS-CULTURAL AND INTERLANGUAGE COMMUNICATION": 0.933,
  "PROCEEDINGS OF THE INSTITUTION OF CIVIL ENGINEERS-MARITIME ENGINEERING": 0.933,
  "POLITICS AND RELIGION": 0.933,
  "QUARTERLY JOURNAL OF MECHANICS AND APPLIED MATHEMATICS": 0.933,
  "RECORDS OF THE AUSTRALIAN MUSEUM": 0.933,
  "REVISTA ROMANA DE MEDICINA DE LABORATOR": 0.933,
  "SPACE AND CULTURE": 0.933,
  "TRABAJOS DE PREHISTORIA": 0.932,
  "INFORMATION RESEARCH-AN INTERNATIONAL ELECTRONIC JOURNAL": 0.932,
  "JOURNAL OF PHILOSOPHY OF EDUCATION": 0.932,
  "JOURNAL OF SOCIAL AND CLINICAL PSYCHOLOGY": 0.932,
  "JOURNAL OF DENTAL SCIENCES": 0.931,
  "CHINESE JOURNAL OF INORGANIC CHEMISTRY": 0.931,
  "ENVIRONMENTAL FORENSICS": 0.931,
  "JOURNAL OF PURE AND APPLIED ALGEBRA": 0.931,
  "STUDIES IN CONSERVATION": 0.93,
  "BRAZILIAN JOURNAL OF CARDIOVASCULAR SURGERY": 0.93,
  "CMES-COMPUTER MODELING IN ENGINEERING & SCIENCES": 0.929,
  "LATIN AMERICAN POLITICS AND SOCIETY": 0.929,
  "NEW REPUBLIC": 0.929,
  "CERNE": 0.929,
  "INTERNATIONAL JOURNAL OF NUMERICAL MODELLING-ELECTRONIC NETWORKS DEVICES AND FIELDS": 0.929,
  "URBAN DESIGN INTERNATIONAL": 0.929,
  "BRITTONIA": 0.929,
  "CRUSTACEANA": 0.928,
  "INDIAN JOURNAL OF ENGINEERING AND MATERIALS SCIENCES": 0.927,
  "JOURNAL OF CONVEX ANALYSIS": 0.927,
  "RUSSIAN JOURNAL OF BIOORGANIC CHEMISTRY": 0.927,
  "ANNALI ITALIANI DI CHIRURGIA": 0.927,
  "COLUMBIA JOURNAL OF TRANSNATIONAL LAW": 0.927,
  "IETE JOURNAL OF RESEARCH": 0.927,
  "INTERNATIONAL JOURNAL OF CENTRAL BANKING": 0.926,
  "ACTA PROTOZOOLOGICA": 0.926,
  "AMERICAN JOURNAL OF COMPARATIVE LAW": 0.926,
  "ANIMAL BIODIVERSITY AND CONSERVATION": 0.926,
  "INSIGHT": 0.925,
  "JOURNAL OF THE AMERICAN SOCIETY OF BREWING CHEMISTS": 0.925,
  "KLINISCHE MONATSBLATTER FUR AUGENHEILKUNDE": 0.925,
  "PROCEEDINGS OF THE INSTITUTION OF CIVIL ENGINEERS-TRANSPORT": 0.925,
  "CHINESE JOURNAL OF CHEMICAL PHYSICS": 0.925,
  "PLANTA DANINHA": 0.924,
  "BRAZILIAN JOURNAL OF CHEMICAL ENGINEERING": 0.924,
  "IBM JOURNAL OF RESEARCH AND DEVELOPMENT": 0.924,
  "INTELLIGENT AUTOMATION AND SOFT COMPUTING": 0.923,
  "PAKISTAN JOURNAL OF ZOOLOGY": 0.923,
  "ADVANCES IN GEOMETRY": 0.923,
  "ACTA HISTRIAE": 0.922,
  "FILOMAT": 0.922,
  "GESUNDE PFLANZEN": 0.922,
  "INTERNATIONAL JOURNAL OF DATA MINING AND BIOINFORMATICS": 0.922,
  "PUBLIC PERSONNEL MANAGEMENT": 0.922,
  "RETHINKING HISTORY": 0.921,
  "THEORETICAL MEDICINE AND BIOETHICS": 0.921,
  "ACM TRANSACTIONS ON ASIAN AND LOW-RESOURCE LANGUAGE INFORMATION PROCESSING": 0.92,
  "ASIA EUROPE JOURNAL": 0.92,
  "HEALTH CARE FOR WOMEN INTERNATIONAL": 0.92,
  "JOURNAL OF AQUATIC PLANT MANAGEMENT": 0.92,
  "LINGUISTICS AND PHILOSOPHY": 0.92,
  "OPEN GEOSCIENCES": 0.92,
  "FORMAL METHODS IN SYSTEM DESIGN": 0.919,
  "JOURNAL OF AEROSPACE INFORMATION SYSTEMS": 0.919,
  "PROTECTION OF METALS AND PHYSICAL CHEMISTRY OF SURFACES": 0.919,
  "TECHNOLOGY AND HEALTH CARE": 0.918,
  "VETERINARIA ITALIANA": 0.918,
  "AMERICAN BUSINESS LAW JOURNAL": 0.918,
  "INTELLIGENCE AND NATIONAL SECURITY": 0.917,
  "JOURNAL OF COMPARATIVE GERMANIC LINGUISTICS": 0.917,
  "JOURNAL OF EXERCISE SCIENCE & FITNESS": 0.917,
  "JOURNAL OF GLOBAL HISTORY": 0.917,
  "MATHEMATICAL COMMUNICATIONS": 0.917,
  "REVIEW OF INTERNATIONAL ECONOMICS": 0.915,
  "HAUTARZT": 0.915,
  "JOURNAL OF CRANIOFACIAL SURGERY": 0.914,
  "REVISTA CIENCIA AGRONOMICA": 0.914,
  "REVISTA PORTUGUESA DE CARDIOLOGIA": 0.914,
  "SOCIAL INCLUSION": 0.914,
  "AFRICAN HEALTH SCIENCES": 0.914,
  "FORMAL ASPECTS OF COMPUTING": 0.914,
  "JOURNAL OF COLLEGE STUDENT DEVELOPMENT": 0.913,
  "MINERALS & METALLURGICAL PROCESSING": 0.913,
  "SYNTHESIS AND REACTIVITY IN INORGANIC METAL-ORGANIC AND NANO-METAL CHEMISTRY": 0.912,
  "TRANSFORMATION GROUPS": 0.912,
  "PEDIATRIC NEUROSURGERY": 0.911,
  "ANNALES ACADEMIAE SCIENTIARUM FENNICAE-MATHEMATICA": 0.911,
  "BOLETIN DE LA SOCIEDAD GEOLOGICA MEXICANA": 0.911,
  "JOURNAL OF SOCIAL SERVICE RESEARCH": 0.911,
  "SOUTH AFRICAN JOURNAL OF PSYCHOLOGY": 0.91,
  "ARMED FORCES & SOCIETY": 0.91,
  "MINERVA CARDIOANGIOLOGICA": 0.91,
  "PHOSPHORUS SULFUR AND SILICON AND THE RELATED ELEMENTS": 0.91,
  "SOUTH ATLANTIC QUARTERLY": 0.91,
  "APPLIED MAGNETIC RESONANCE": 0.91,
  "CAHIERS AGRICULTURES": 0.909,
  "FOLIA MORPHOLOGICA": 0.909,
  "HOMO-JOURNAL OF COMPARATIVE HUMAN BIOLOGY": 0.909,
  "BRITISH JOURNAL OF OCCUPATIONAL THERAPY": 0.909,
  "EXPERIMENTAL TECHNIQUES": 0.908,
  "INTERNATIONAL JOURNAL OF GLOBAL WARMING": 0.907,
  "POLITICS & GENDER": 0.907,
  "RUSSIAN JOURNAL OF NUMERICAL ANALYSIS AND MATHEMATICAL MODELLING": 0.907,
  "TURKISH JOURNAL OF HEMATOLOGY": 0.907,
  "ARCHIV FUR MOLLUSKENKUNDE": 0.907,
  "CONTRIBUTIONS TO INDIAN SOCIOLOGY": 0.906,
  "HYPATIA-A JOURNAL OF FEMINIST PHILOSOPHY": 0.906,
  "MEDYCYNA PRACY": 0.906,
  "NEUES JAHRBUCH FUR GEOLOGIE UND PALAONTOLOGIE-ABHANDLUNGEN": 0.905,
  "SCANDINAVIAN POLITICAL STUDIES": 0.905,
  "SUPREME COURT REVIEW": 0.904,
  "JOURNAL OF RUSSIAN LASER RESEARCH": 0.904,
  "JOURNAL OF FOREST RESEARCH": 0.904,
  "ACTA REUMATOLOGICA PORTUGUESA": 0.903,
  "COMPUTATIONAL INTELLIGENCE": 0.903,
  "DRVNA INDUSTRIJA": 0.903,
  "ECONOMIC DEVELOPMENT QUARTERLY": 0.902,
  "EDUCATIONAL STUDIES": 0.902,
  "JOURNAL OF CELLULAR AUTOMATA": 0.901,
  "POLISH JOURNAL OF MICROBIOLOGY": 0.901,
  "COMPUTATIONAL MATHEMATICS AND MATHEMATICAL PHYSICS": 0.901,
  "JOURNAL OF THE ROYAL SOCIETY OF NEW ZEALAND": 0.901,
  "JOURNAL OF CHINESE POLITICAL SCIENCE": 0.9,
  "REVISTA PANAMERICANA DE SALUD PUBLICA-PAN AMERICAN JOURNAL OF PUBLIC HEALTH": 0.9,
  "AUSTRALIAN ECONOMIC PAPERS": 0.9,
  "ACTA GEOGRAPHICA SLOVENICA-GEOGRAFSKI ZBORNIK": 0.9,
  "BIOLOGICAL RHYTHM RESEARCH": 0.9,
  "CHELONIAN CONSERVATION AND BIOLOGY": 0.899,
  "EUROPEAN JOURNAL OF CULTURAL STUDIES": 0.899,
  "NURSING SCIENCE QUARTERLY": 0.898,
  "TECHNICAL PHYSICS LETTERS": 0.898,
  "ANNALS OF THE INSTITUTE OF STATISTICAL MATHEMATICS": 0.897,
  "CANADIAN REVIEW OF SOCIOLOGY-REVUE CANADIENNE DE SOCIOLOGIE": 0.897,
  "CLINICAL NURSE SPECIALIST": 0.897,
  "BALTIC JOURNAL OF ROAD AND BRIDGE ENGINEERING": 0.897,
  "INORGANIC MATERIALS": 0.897,
  "JOURNAL DE GYNECOLOGIE OBSTETRIQUE ET BIOLOGIE DE LA REPRODUCTION": 0.896,
  "JOURNAL OF THEORETICAL AND APPLIED MECHANICS": 0.896,
  "SOLVENT EXTRACTION RESEARCH AND DEVELOPMENT-JAPAN": 0.896,
  "JOURNAL OF BEHAVIORAL FINANCE": 0.896,
  "BALKAN JOURNAL OF MEDICAL GENETICS": 0.896,
  "INQUIRY-THE JOURNAL OF HEALTH CARE ORGANIZATION PROVISION AND FINANCING": 0.895,
  "INTERNATIONAL JOURNAL OF COOPERATIVE INFORMATION SYSTEMS": 0.895,
  "JOURNAL OF CONTEMPORARY HISTORY": 0.895,
  "JOURNAL OF LEGAL MEDICINE": 0.894,
  "SADHANA-ACADEMY PROCEEDINGS IN ENGINEERING SCIENCES": 0.894,
  "CURRENT PROTEOMICS": 0.894,
  "PROMET-TRAFFIC & TRANSPORTATION": 0.894,
  "SPORT IN SOCIETY": 0.894,
  "ANNALES SOCIETATIS GEOLOGORUM POLONIAE": 0.893,
  "BULLETIN OF THE LONDON MATHEMATICAL SOCIETY": 0.893,
  "JOURNAL OF APPLIED STATISTICS": 0.893,
  "JOURNAL OF STATISTICAL COMPUTATION AND SIMULATION": 0.893,
  "VISUAL COMMUNICATION": 0.892,
  "REVISTA MEXICANA DE FISICA": 0.892,
  "AI COMMUNICATIONS": 0.892,
  "BULLETIN OF THE CHEMICAL SOCIETY OF ETHIOPIA": 0.891,
  "HAHR-HISPANIC AMERICAN HISTORICAL REVIEW": 0.891,
  "INTERNATIONAL JOURNAL OF LAW POLICY AND THE FAMILY": 0.891,
  "ISRAEL JOURNAL OF MATHEMATICS": 0.891,
  "MATERIALS TRANSACTIONS": 0.891,
  "EXPERT OPINION ON ORPHAN DRUGS": 0.891,
  "GERMAN HISTORY": 0.89,
  "JOURNAL OF ECONOMIC ISSUES": 0.89,
  "REVUE ROUMAINE DES SCIENCES TECHNIQUES-SERIE ELECTROTECHNIQUE ET ENERGETIQUE": 0.889,
  "SOCIAL SCIENCE INFORMATION SUR LES SCIENCES SOCIALES": 0.888,
  "AMERICAN JOURNAL OF LAW & MEDICINE": 0.888,
  "ELECTRONIC JOURNAL OF COMBINATORICS": 0.888,
  "MEDICC REVIEW": 0.888,
  "WILDFOWL": 0.888,
  "JOURNAL OF COLD REGIONS ENGINEERING": 0.887,
  "JOURNAL OF THE HISTORY OF ECONOMIC THOUGHT": 0.887,
  "OPERATIONS RESEARCH LETTERS": 0.886,
  "CLINICAL DYSMORPHOLOGY": 0.886,
  "JOURNAL OF PACIFIC RIM PSYCHOLOGY": 0.886,
  "REVISTA ESPANOLA DE QUIMIOTERAPIA": 0.886,
  "SYNTAX-A JOURNAL OF THEORETICAL EXPERIMENTAL AND INTERDISCIPLINARY RESEARCH": 0.886,
  "CHEMICAL AND PROCESS ENGINEERING-INZYNIERIA CHEMICZNA I PROCESOWA": 0.885,
  "ENVIRONMENTAL AND ECOLOGICAL STATISTICS": 0.885,
  "GEOLOGICAL QUARTERLY": 0.885,
  "GENES & GENOMICS": 0.885,
  "GERMAN JOURNAL OF HUMAN RESOURCE MANAGEMENT-ZEITSCHRIFT FUR PERSONALFORSCHUNG": 0.885,
  "JOURNAL OF THE CANADIAN DENTAL ASSOCIATION": 0.884,
  "JOURNAL OF ELECTROCHEMICAL SCIENCE AND TECHNOLOGY": 0.884,
  "NUTRICION HOSPITALARIA": 0.883,
  "QUALITY MANAGEMENT IN HEALTH CARE": 0.883,
  "ACTA METALLURGICA SINICA": 0.883,
  "BRAZILIAN ARCHIVES OF BIOLOGY AND TECHNOLOGY": 0.883,
  "JAPANESE PSYCHOLOGICAL RESEARCH": 0.883,
  "QUARTERLY JOURNAL OF SPEECH": 0.882,
  "TEXAS HEART INSTITUTE JOURNAL": 0.882,
  "IZVESTIYA ATMOSPHERIC AND OCEANIC PHYSICS": 0.882,
  "JOURNAL OF HOMELAND SECURITY AND EMERGENCY MANAGEMENT": 0.882,
  "TRANSYLVANIAN REVIEW OF ADMINISTRATIVE SCIENCES": 0.882,
  "ACTA CARSOLOGICA": 0.881,
  "CURRENT SCIENCE": 0.881,
  "CRITICAL CARE NURSING CLINICS OF NORTH AMERICA": 0.881,
  "GEOLOGIA CROATICA": 0.881,
  "HISTORICAL JOURNAL": 0.881,
  "JOURNAL OF STATISTICAL PLANNING AND INFERENCE": 0.881,
  "JOURNAL OF THE TORREY BOTANICAL SOCIETY": 0.881,
  "JOURNAL OF BIOPHARMACEUTICAL STATISTICS": 0.879,
  "RADIOPHYSICS AND QUANTUM ELECTRONICS": 0.879,
  "BALTIC FORESTRY": 0.879,
  "EXPERIMENTAL AND CLINICAL TRANSPLANTATION": 0.879,
  "INTERNATIONAL JOURNAL OF ROBOTICS & AUTOMATION": 0.879,
  "INTERNATIONAL JOURNAL OF PHARMACOLOGY": 0.879,
  "SYSTEMIC PRACTICE AND ACTION RESEARCH": 0.878,
  "JOURNAL OF PLANT NUTRITION": 0.878,
  "INTERNATIONAL JOURNAL OF CLOTHING SCIENCE AND TECHNOLOGY": 0.877,
  "SLEEP AND BIOLOGICAL RHYTHMS": 0.877,
  "CRYSTALLOGRAPHY REPORTS": 0.876,
  "RUSSIAN JOURNAL OF ORGANIC CHEMISTRY": 0.876,
  "AFRICAN JOURNAL OF AQUATIC SCIENCE": 0.876,
  "APPLIED ONTOLOGY": 0.875,
  "ECONOMIC RECORD": 0.875,
  "ENGLISH LANGUAGE & LINGUISTICS": 0.875,
  "HISTORY AND PHILOSOPHY OF THE LIFE SCIENCES": 0.875,
  "INTERNATIONAL JOURNAL OF ISLAMIC AND MIDDLE EASTERN FINANCE AND MANAGEMENT": 0.875,
  "PROCEEDINGS OF THE YORKSHIRE GEOLOGICAL SOCIETY": 0.875,
  "PROGRAMMING AND COMPUTER SOFTWARE": 0.875,
  "REVISTA CHILENA DE HISTORIA NATURAL": 0.875,
  "REVISTA DE CIENCIA POLITICA": 0.875,
  "STUDIA MATHEMATICA": 0.874,
  "THEORETICAL AND EXPERIMENTAL CHEMISTRY": 0.874,
  "SPANISH JOURNAL OF PSYCHOLOGY": 0.874,
  "EDUCATIONAL GERONTOLOGY": 0.873,
  "SURFACE REVIEW AND LETTERS": 0.873,
  "TENSIDE SURFACTANTS DETERGENTS": 0.873,
  "TRANSPORTATION RESEARCH RECORD": 0.873,
  "ASIAN JOURNAL OF MATHEMATICS": 0.873,
  "GINEKOLOGIA POLSKA": 0.872,
  "MECHANICS & INDUSTRY": 0.872,
  "COMMUNITY ECOLOGY": 0.871,
  "METHODOLOGY AND COMPUTING IN APPLIED PROBABILITY": 0.871,
  "MOSCOW MATHEMATICAL JOURNAL": 0.871,
  "TOPICS IN APPLIED PHYSICS": 0.871,
  "ADVANCES IN STRATEGIC MANAGEMENT-A RESEARCH ANNUAL": 0.87,
  "JOURNAL OF LOSS & TRAUMA": 0.87,
  "SOCIAL THEORY & HEALTH": 0.87,
  "HISTORY OF SCIENCE": 0.869,
  "PSYCHIATRY PSYCHOLOGY AND LAW": 0.869,
  "TRANSLATOR": 0.869,
  "JOURNAL OF THE HISTORY OF MEDICINE AND ALLIED SCIENCES": 0.869,
  "ZOOLOGIA": 0.868,
  "BULLETIN OF SYMBOLIC LOGIC": 0.868,
  "BEHAVIORAL PSYCHOLOGY-PSICOLOGIA CONDUCTUAL": 0.868,
  "CANADIAN JOURNAL OF CIVIL ENGINEERING": 0.868,
  "FISH PATHOLOGY": 0.868,
  "JOURNAL OF THE INDIAN INSTITUTE OF SCIENCE": 0.868,
  "AMERICAN MALACOLOGICAL BULLETIN": 0.867,
  "CHINESE JOURNAL OF OCEANOLOGY AND LIMNOLOGY": 0.867,
  "DISCRETE & COMPUTATIONAL GEOMETRY": 0.867,
  "DIACHRONICA": 0.867,
  "DISCUSSIONES MATHEMATICAE GRAPH THEORY": 0.867,
  "INTERNATIONAL JOURNAL OF OFFSHORE AND POLAR ENGINEERING": 0.867,
  "ISIS": 0.866,
  "JOURNAL OF THE JAPANESE AND INTERNATIONAL ECONOMIES": 0.865,
  "SILVAE GENETICA": 0.865,
  "STATISTICAL ANALYSIS AND DATA MINING": 0.865,
  "AATCC JOURNAL OF RESEARCH": 0.864,
  "APPLIED ENGINEERING IN AGRICULTURE": 0.864,
  "FRONTIERS-A JOURNAL OF WOMEN STUDIES": 0.864,
  "JOURNAL OF ENVIRONMENTAL HEALTH": 0.864,
  "JOURNAL OF PEDIATRIC ORTHOPAEDICS-PART B": 0.864,
  "SIBERIAN MATHEMATICAL JOURNAL": 0.864,
  "TURKISH JOURNAL OF FISHERIES AND AQUATIC SCIENCES": 0.864,
  "MATHEMATICAL PROCEEDINGS OF THE CAMBRIDGE PHILOSOPHICAL SOCIETY": 0.863,
  "ITALIAN JOURNAL OF FOOD SCIENCE": 0.863,
  "JOURNAL OF LANGUAGE IDENTITY AND EDUCATION": 0.863,
  "MINERVA CHIRURGICA": 0.863,
  "ECONOMICS OF TRANSITION": 0.863,
  "ECONOMICS-THE OPEN ACCESS OPEN-ASSESSMENT E-JOURNAL": 0.863,
  "HISTORICAL METHODS": 0.863,
  "IRANIAN JOURNAL OF PARASITOLOGY": 0.863,
  "JOURNAL OF AMERICAN HISTORY": 0.862,
  "JOURNAL OF SCIENTIFIC & INDUSTRIAL RESEARCH": 0.862,
  "JOURNAL OF INTERNATIONAL ADVANCED OTOLOGY": 0.862,
  "QUALITY ASSURANCE AND SAFETY OF CROPS & FOODS": 0.862,
  "JOURNAL OF LAW MEDICINE & ETHICS": 0.861,
  "BIOMEDICA": 0.861,
  "CHINA FOUNDRY": 0.861,
  "EUROPEAN JOURNAL OF INFLAMMATION": 0.861,
  "HISPANIC JOURNAL OF BEHAVIORAL SCIENCES": 0.861,
  "JOURNAL OF ELEMENTOLOGY": 0.861,
  "JOURNAL OF LASER MICRO NANOENGINEERING": 0.861,
  "SLAVIC REVIEW": 0.861,
  "INFINITE DIMENSIONAL ANALYSIS QUANTUM PROBABILITY AND RELATED TOPICS": 0.86,
  "MAMMALIA": 0.86,
  "SOCIAL SERVICE REVIEW": 0.86,
  "ANNALES BOTANICI FENNICI": 0.86,
  "AFRICAN JOURNAL OF WILDLIFE RESEARCH": 0.859,
  "CHILD & FAMILY BEHAVIOR THERAPY": 0.859,
  "CROATICA CHEMICA ACTA": 0.859,
  "EXPERIMENTAL MATHEMATICS": 0.859,
  "HELMINTHOLOGIA": 0.859,
  "REVIEW OF SYMBOLIC LOGIC": 0.859,
  "BEHAVIORAL INTERVENTIONS": 0.859,
  "CIENCIAS MARINAS": 0.859,
  "FUTURE VIROLOGY": 0.859,
  "INTERNATIONAL JOURNAL FOR EDUCATIONAL AND VOCATIONAL GUIDANCE": 0.857,
  "INZINERINE EKONOMIKA-ENGINEERING ECONOMICS": 0.857,
  "ALLELOPATHY JOURNAL": 0.857,
  "BULLETIN DU CANCER": 0.857,
  "FLUID DYNAMICS": 0.857,
  "INTERFACES": 0.857,
  "BIOLOGIA": 0.857,
  "DISCRETE MATHEMATICS": 0.857,
  "LEX LOCALIS-JOURNAL OF LOCAL SELF-GOVERNMENT": 0.857,
  "APPLIED BIOCHEMISTRY AND MICROBIOLOGY": 0.857,
  "AUSTRALIAN JOURNAL OF ANTHROPOLOGY": 0.856,
  "DYNAMICS OF PARTIAL DIFFERENTIAL EQUATIONS": 0.856,
  "GRAPHICAL MODELS": 0.855,
  "INTERNATIONAL JOURNAL OF COGNITIVE THERAPY": 0.854,
  "IRANIAN JOURNAL OF SCIENCE AND TECHNOLOGY-TRANSACTIONS OF MECHANICAL ENGINEERING": 0.854,
  "JOURNAL OF OPERATIONAL RISK": 0.854,
  "NEW ZEALAND JOURNAL OF CROP AND HORTICULTURAL SCIENCE": 0.854,
  "PROCEEDINGS OF THE LINNEAN SOCIETY OF NEW SOUTH WALES": 0.854,
  "VIAL-VIGO INTERNATIONAL JOURNAL OF APPLIED LINGUISTICS": 0.854,
  "EUROPEAN JOURNAL OF HORTICULTURAL SCIENCE": 0.853,
  "INTERNATIONAL JOURNAL OF MARKET RESEARCH": 0.853,
  "OPEN MATHEMATICS": 0.853,
  "REVIEW OF INDUSTRIAL ORGANIZATION": 0.853,
  "STOCHASTICS-AN INTERNATIONAL JOURNAL OF PROBABILITY AND STOCHASTIC PROCESSES": 0.853,
  "ZOOLOGICAL STUDIES": 0.853,
  "COMMUNITY DEVELOPMENT JOURNAL": 0.852,
  "INTERNATIONAL JOURNAL OF UNCONVENTIONAL COMPUTING": 0.852,
  "ROMANIAN JOURNAL OF ECONOMIC FORECASTING": 0.851,
  "FOLIA BIOLOGICA-KRAKOW": 0.851,
  "JOURNAL OF SEED SCIENCE": 0.851,
  "NATURE + CULTURE": 0.851,
  "PIGMENT & RESIN TECHNOLOGY": 0.85,
  "ANASTHESIOLOGIE & INTENSIVMEDIZIN": 0.85,
  "LETTERS IN ORGANIC CHEMISTRY": 0.85,
  "PROCEEDINGS OF THE ENTOMOLOGICAL SOCIETY OF WASHINGTON": 0.85,
  "VETERINARY RESEARCH FORUM": 0.849,
  "ACTA HERPETOLOGICA": 0.849,
  "JOURNAL OF TRANSPORTATION ENGINEERING PART B-PAVEMENTS": 0.849,
  "SCOTTISH JOURNAL OF GEOLOGY": 0.849,
  "ASIAN HERPETOLOGICAL RESEARCH": 0.848,
  "JOURNAL OF PORTFOLIO MANAGEMENT": 0.848,
  "JOURNAL OF SYSTEMS ENGINEERING AND ELECTRONICS": 0.848,
  "PROCEEDINGS OF THE INSTITUTION OF MECHANICAL ENGINEERS PART P-JOURNAL OF SPORTS ENGINEERING AND TECHNOLOGY": 0.848,
  "AMERICAN JOURNAL OF DENTISTRY": 0.848,
  "BRITISH JOURNAL OF GUIDANCE & COUNSELLING": 0.847,
  "COMMUNICATION DISORDERS QUARTERLY": 0.847,
  "INFANCIA Y APRENDIZAJE": 0.847,
  "HERPETOLOGICAL CONSERVATION AND BIOLOGY": 0.846,
  "JOURNAL OF THE PHILOSOPHY OF SPORT": 0.846,
  "ZEITSCHRIFT FUR PADAGOGISCHE PSYCHOLOGIE": 0.846,
  "ACTA SOCIETATIS BOTANICORUM POLONIAE": 0.846,
  "JOURNAL D ANALYSE MATHEMATIQUE": 0.846,
  "JOURNAL OF ECONOMIC METHODOLOGY": 0.846,
  "LATIN AMERICAN PERSPECTIVES": 0.846,
  "SCIENTIA IRANICA": 0.846,
  "THEORETICAL COMPUTER SCIENCE": 0.846,
  "ASIAN AND PACIFIC MIGRATION JOURNAL": 0.846,
  "EUROPEAN JOURNAL OF HOSPITAL PHARMACY-SCIENCE AND PRACTICE": 0.846,
  "JOURNAL OF FORENSIC NURSING": 0.845,
  "PCI JOURNAL": 0.845,
  "PLANT GENETIC RESOURCES-CHARACTERIZATION AND UTILIZATION": 0.844,
  "PSYCH JOURNAL": 0.844,
  "INDEPENDENT REVIEW": 0.844,
  "PALEONTOLOGICAL JOURNAL": 0.844,
  "REVIEW OF DEVELOPMENT ECONOMICS": 0.844,
  "UNFALLCHIRURG": 0.844,
  "JOURNAL OF ELECTRICAL ENGINEERING & TECHNOLOGY": 0.844,
  "JOURNAL OF INTERNET TECHNOLOGY": 0.843,
  "ACTA ADRIATICA": 0.843,
  "ACTA PHYTOTAXONOMICA ET GEOBOTANICA": 0.843,
  "ANNALES DE CHIRURGIE PLASTIQUE ESTHETIQUE": 0.843,
  "ANTHROPOLOGY SOUTHERN AFRICA": 0.843,
  "BALTIC JOURNAL OF ECONOMICS": 0.842,
  "ECONOMIA POLITICA": 0.842,
  "GEOFIZIKA": 0.842,
  "MATERIALI IN TEHNOLOGIJE": 0.842,
  "METHODS IN MICROBIOLOGY": 0.841,
  "EARLY CHILD DEVELOPMENT AND CARE": 0.841,
  "MEDIA INTERNATIONAL AUSTRALIA": 0.841,
  "FUNCTIONAL ANALYSIS AND ITS APPLICATIONS": 0.841,
  "JOURNAL OF IMAGING SCIENCE AND TECHNOLOGY": 0.84,
  "COMPLEX ANALYSIS AND OPERATOR THEORY": 0.84,
  "IDS BULLETIN-INSTITUTE OF DEVELOPMENT STUDIES": 0.84,
  "JOURNAL OF TESTING AND EVALUATION": 0.84,
  "KSII TRANSACTIONS ON INTERNET AND INFORMATION SYSTEMS": 0.84,
  "REVISTA DE GEOGRAFIA NORTE GRANDE": 0.84,
  "REVISTA DE HISTORIA ECONOMICA": 0.84,
  "ALGEBRAIC AND GEOMETRIC TOPOLOGY": 0.839,
  "CEREAL RESEARCH COMMUNICATIONS": 0.839,
  "INTERNATIONAL JOURNAL": 0.839,
  "JOURNAL OF HOSPICE & PALLIATIVE NURSING": 0.839,
  "STOCHASTICS AND DYNAMICS": 0.839,
  "COMMUNICATIONS-EUROPEAN JOURNAL OF COMMUNICATION RESEARCH": 0.839,
  "EAST ASIAN SCIENCE TECHNOLOGY AND SOCIETY-AN INTERNATIONAL JOURNAL": 0.838,
  "INFORMATION TECHNOLOGY AND CONTROL": 0.838,
  "JOURNAL OF AQUATIC FOOD PRODUCT TECHNOLOGY": 0.837,
  "ZEITSCHRIFT FUR KINDER-UND JUGENDPSYCHIATRIE UND PSYCHOTHERAPIE": 0.837,
  "ARCHIVE FOR HISTORY OF EXACT SCIENCES": 0.837,
  "ASIAN JOURNAL OF TECHNOLOGY INNOVATION": 0.837,
  "ETHICS & GLOBAL POLITICS": 0.837,
  "JOURNAL OF NONPARAMETRIC STATISTICS": 0.837,
  "PROCEEDINGS OF THE INSTITUTION OF CIVIL ENGINEERS-WATER MANAGEMENT": 0.837,
  "COMPEL-THE INTERNATIONAL JOURNAL FOR COMPUTATION AND MATHEMATICS IN ELECTRICAL AND ELECTRONIC ENGINEERING": 0.837,
  "SCIENCE AND ENGINEERING OF COMPOSITE MATERIALS": 0.836,
  "ENGLISH TEACHING-PRACTICE AND CRITIQUE": 0.836,
  "NETHERLANDS JOURNAL OF GEOSCIENCES-GEOLOGIE EN MIJNBOUW": 0.836,
  "SOCIAL SEMIOTICS": 0.836,
  "TRANSACTIONS OF FAMENA": 0.835,
  "CANADIAN JOURNAL OF ECONOMICS-REVUE CANADIENNE D ECONOMIQUE": 0.835,
  "INTERNATIONAL JOURNAL OF MICROWAVE AND WIRELESS TECHNOLOGIES": 0.835,
  "MECHANICS OF COMPOSITE MATERIALS": 0.835,
  "ANALYSIS MATHEMATICA": 0.835,
  "AUSTRALIAN JOURNAL OF ADVANCED NURSING": 0.835,
  "COMPARATIVE MEDICINE": 0.834,
  "EUROPEAN JOURNAL OF PSYCHIATRY": 0.833,
  "JOURNAL OF OVONIC RESEARCH": 0.833,
  "MANAGERIAL AND DECISION ECONOMICS": 0.833,
  "RAE-REVISTA DE ADMINISTRACAO DE EMPRESAS": 0.833,
  "ZOOLOGY IN THE MIDDLE EAST": 0.833,
  "ANNALES DE DERMATOLOGIE ET DE VENEREOLOGIE": 0.833,
  "CASTANEA": 0.833,
  "GENETICS RESEARCH": 0.833,
  "JNP-JOURNAL FOR NURSE PRACTITIONERS": 0.833,
  "JOURNAL OF EARTHQUAKE AND TSUNAMI": 0.833,
  "PLANKTON & BENTHOS RESEARCH": 0.833,
  "PROCEEDINGS OF THE STEKLOV INSTITUTE OF MATHEMATICS": 0.833,
  "ACTA OCEANOLOGICA SINICA": 0.832,
  "COSMIC RESEARCH": 0.832,
  "JOURNAL OF OCEAN UNIVERSITY OF CHINA": 0.832,
  "NEUROENDOCRINOLOGY LETTERS": 0.831,
  "PALZ": 0.831,
  "SOCIAL SCIENCE HISTORY": 0.831,
  "ZEITSCHRIFT FUR SEXUALFORSCHUNG": 0.83,
  "ANIMAL SCIENCE PAPERS AND REPORTS": 0.83,
  "ARCHIVES OF METALLURGY AND MATERIALS": 0.83,
  "COLEOPTERISTS BULLETIN": 0.83,
  "FERROELECTRICS": 0.829,
  "JOURNAL OF VETERINARY MEDICAL EDUCATION": 0.829,
  "BULLETIN DE LA SOCIETE MATHEMATIQUE DE FRANCE": 0.829,
  "JOURNAL OF THE HISTORY OF BIOLOGY": 0.829,
  "JOURNAL OF CYTOLOGY": 0.829,
  "JOURNAL OF MORAL PHILOSOPHY": 0.829,
  "JOURNAL OF THE SOUTH AFRICAN VETERINARY ASSOCIATION": 0.829,
  "CHINESE JOURNAL OF STRUCTURAL CHEMISTRY": 0.829,
  "IET SOFTWARE": 0.829,
  "JOURNAL OF SOCIAL WORK PRACTICE": 0.828,
  "COMMUNICATIONS IN ANALYSIS AND GEOMETRY": 0.828,
  "CRYOLETTERS": 0.828,
  "EASTERN MEDITERRANEAN HEALTH JOURNAL": 0.828,
  "HISTORIA AGRARIA": 0.828,
  "RIVISTA ITALIANA DELLE SOSTANZE GRASSE": 0.828,
  "CHINA OCEAN ENGINEERING": 0.828,
  "INTERNATIONAL POLITICS": 0.828,
  "SOUTH AFRICAN JOURNAL OF EDUCATION": 0.828,
  "COMPUTATIONAL METHODS AND FUNCTION THEORY": 0.827,
  "IRANIAN JOURNAL OF SCIENCE AND TECHNOLOGY TRANSACTION A-SCIENCE": 0.827,
  "JOURNAL OF PLANT REGISTRATIONS": 0.826,
  "JOURNAL OF THE AUSTRALIAN CERAMIC SOCIETY": 0.826,
  "LANGUAGE AND LITERATURE": 0.826,
  "FRESENIUS ENVIRONMENTAL BULLETIN": 0.826,
  "PUBLICATIONES MATHEMATICAE-DEBRECEN": 0.826,
  "SEMICONDUCTORS": 0.826,
  "SYLWAN": 0.826,
  "ELECTRONIC JOURNAL OF DIFFERENTIAL EQUATIONS": 0.826,
  "INTERNATIONAL JOURNAL OF ENVIRONMENT AND POLLUTION": 0.826,
  "JOURNAL OF ADDICTIONS NURSING": 0.825,
  "JOURNAL OF CLINICAL SPORT PSYCHOLOGY": 0.825,
  "RENDICONTI LINCEI-MATEMATICA E APPLICAZIONI": 0.825,
  "SOCIETY & ANIMALS": 0.825,
  "TURKISH JOURNAL OF FIELD CROPS": 0.824,
  "APPLIED ECOLOGY AND ENVIRONMENTAL RESEARCH": 0.824,
  "JOURNAL OF PSYCHOSOCIAL NURSING AND MENTAL HEALTH SERVICES": 0.824,
  "JOURNAL OF THEORETICAL PROBABILITY": 0.824,
  "MATHEMATIKA": 0.824,
  "REVISTA BRASILEIRA DE FRUTICULTURA": 0.824,
  "ACTA AGRICULTURAE SCANDINAVICA SECTION A-ANIMAL SCIENCE": 0.824,
  "ANTHROPOLOGICAL SCIENCE": 0.824,
  "JOURNAL OF CHILD & ADOLESCENT SUBSTANCE ABUSE": 0.824,
  "JOURNAL OF ESSENTIAL OIL BEARING PLANTS": 0.823,
  "CHEMICAL & ENGINEERING NEWS": 0.822,
  "COMMUNICATIONS IN SOIL SCIENCE AND PLANT ANALYSIS": 0.822,
  "IEEJ TRANSACTIONS ON ELECTRICAL AND ELECTRONIC ENGINEERING": 0.822,
  "JOURNAL OF THERMAL SCIENCE AND TECHNOLOGY": 0.822,
  "FORDHAM LAW REVIEW": 0.822,
  "INORGANIC AND NANO-METAL CHEMISTRY": 0.822,
  "JOURNAL OF THE AMERICAN LEATHER CHEMISTS ASSOCIATION": 0.822,
  "ELEKTRONIKA IR ELEKTROTECHNIKA": 0.822,
  "INTERNATIONAL JOURNAL OF APPLIED ELECTROMAGNETICS AND MECHANICS": 0.822,
  "JOURNAL OF NUMBER THEORY": 0.821,
  "SCIENCE & SPORTS": 0.821,
  "INTERNATIONAL JOURNAL OF OIL GAS AND COAL TECHNOLOGY": 0.821,
  "POLYMERS & POLYMER COMPOSITES": 0.821,
  "PROCEEDINGS OF THE INSTITUTION OF CIVIL ENGINEERS-CIVIL ENGINEERING": 0.821,
  "PSYCHIATRIA DANUBINA": 0.821,
  "BEHAVIORAL SCIENCES & THE LAW": 0.82,
  "INTERVENTION IN SCHOOL AND CLINIC": 0.82,
  "ORTHOPAEDIC NURSING": 0.82,
  "THERMOPHYSICS AND AEROMECHANICS": 0.819,
  "ANNALES DE PALEONTOLOGIE": 0.819,
  "CANADIAN JOURNAL OF DIETETIC PRACTICE AND RESEARCH": 0.818,
  "ORAL RADIOLOGY": 0.818,
  "PROCEEDINGS OF THE NATIONAL ACADEMY OF SCIENCES INDIA SECTION A-PHYSICAL SCIENCES": 0.818,
  "COMPUTATIONAL STATISTICS": 0.818,
  "GYNECOLOGIE OBSTETRIQUE FERTILITE & SENOLOGIE": 0.817,
  "JOURNAL OF THEORETICAL & COMPUTATIONAL CHEMISTRY": 0.817,
  "KEW BULLETIN": 0.816,
  "THEORY AND DECISION": 0.816,
  "ACTA BIOLOGICA HUNGARICA": 0.815,
  "OPHTHALMOLOGE": 0.815,
  "TAIWANESE JOURNAL OF MATHEMATICS": 0.815,
  "SCOTTISH MEDICAL JOURNAL": 0.815,
  "AIBR-REVISTA DE ANTROPOLOGIA IBEROAMERICANA": 0.815,
  "FIBRES & TEXTILES IN EASTERN EUROPE": 0.814,
  "RUSSIAN JOURNAL OF NONDESTRUCTIVE TESTING": 0.814,
  "BIOLOGY AND ENVIRONMENT-PROCEEDINGS OF THE ROYAL IRISH ACADEMY": 0.814,
  "CHEMICAL JOURNAL OF CHINESE UNIVERSITIES-CHINESE": 0.814,
  "FOOD BIOTECHNOLOGY": 0.814,
  "GRAVITATION & COSMOLOGY": 0.813,
  "LATIN AMERICAN RESEARCH REVIEW": 0.813,
  "THEORY IN BIOSCIENCES": 0.812,
  "INTERFACES AND FREE BOUNDARIES": 0.812,
  "JOURNAL OF APPLIED SPECTROSCOPY": 0.812,
  "SAGE OPEN": 0.812,
  "STATISTICS": 0.811,
  "B E JOURNAL OF MACROECONOMICS": 0.811,
  "DISSOLUTION TECHNOLOGIES": 0.811,
  "INTERNATIONAL JOURNAL OF MATERIALS & PRODUCT TECHNOLOGY": 0.81,
  "LYMPHOLOGY": 0.81,
  "OCEANOLOGICAL AND HYDROBIOLOGICAL STUDIES": 0.81,
  "POLITIKON": 0.81,
  "CONNECTION SCIENCE": 0.81,
  "EUROPEAN BUSINESS ORGANIZATION LAW REVIEW": 0.81,
  "NEW ZEALAND JOURNAL OF ZOOLOGY": 0.809,
  "ZEITSCHRIFT FUR ERZIEHUNGSWISSENSCHAFT": 0.809,
  "ZEITSCHRIFT FUR PSYCHIATRIE PSYCHOLOGIE UND PSYCHOTHERAPIE": 0.808,
  "GLASS PHYSICS AND CHEMISTRY": 0.808,
  "INVERTEBRATE REPRODUCTION & DEVELOPMENT": 0.808,
  "INVASIVE PLANT SCIENCE AND MANAGEMENT": 0.808,
  "PAKISTAN JOURNAL OF BOTANY": 0.808,
  "ARAB JOURNAL OF GASTROENTEROLOGY": 0.807,
  "JOURNAL OF CONSCIOUSNESS STUDIES": 0.807,
  "CHUNGARA-REVISTA DE ANTROPOLOGIA CHILENA": 0.807,
  "JOURNAL OF CHEMICAL RESEARCH": 0.806,
  "JOURNAL OF POULTRY SCIENCE": 0.806,
  "LATIN AMERICAN JOURNAL OF AQUATIC RESEARCH": 0.806,
  "STRENGTH OF MATERIALS": 0.806,
  "CHIRURG": 0.806,
  "GEOMAGNETISM AND AERONOMY": 0.806,
  "PESQUISA AGROPECUARIA BRASILEIRA": 0.806,
  "ACTA CHROMATOGRAPHICA": 0.806,
  "ACTA ICHTHYOLOGICA ET PISCATORIA": 0.806,
  "AFRICAN INVERTEBRATES": 0.806,
  "ALGEBRA UNIVERSALIS": 0.806,
  "BRITISH JOURNAL OF RELIGIOUS EDUCATION": 0.806,
  "EARTH MOON AND PLANETS": 0.805,
  "EUROPEAN JOURNAL OF SOCIAL WORK": 0.805,
  "GEOMORPHOLOGIE-RELIEF PROCESSUS ENVIRONNEMENT": 0.804,
  "GERMAN JOURNAL OF AGRICULTURAL ECONOMICS": 0.804,
  "INTERNATIONAL REVIEW OF LAW AND ECONOMICS": 0.804,
  "IRAL-INTERNATIONAL REVIEW OF APPLIED LINGUISTICS IN LANGUAGE TEACHING": 0.804,
  "IRANIAN JOURNAL OF VETERINARY RESEARCH": 0.803,
  "JOURNAL OF OPERATOR THEORY": 0.802,
  "JAPANESE JOURNAL OF MATHEMATICS": 0.802,
  "JOURNAL OF SPECIALISED TRANSLATION": 0.802,
  "JOURNAL OF THE ASIA PACIFIC ECONOMY": 0.802,
  "LIBRARY COLLECTIONS ACQUISITIONS & TECHNICAL SERVICES": 0.801,
  "MERRILL-PALMER QUARTERLY-JOURNAL OF DEVELOPMENTAL PSYCHOLOGY": 0.801,
  "MICHIGAN MATHEMATICAL JOURNAL": 0.8,
  "PATTERNS OF PREJUDICE": 0.8,
  "PLASTIC SURGERY": 0.8,
  "REVISTA BRASILEIRA DE PALEONTOLOGIA": 0.8,
  "TOHOKU MATHEMATICAL JOURNAL": 0.8,
  "TRANSACTIONS OF THE ROYAL SOCIETY OF SOUTH AUSTRALIA": 0.8,
  "TURKIYE ENTOMOLOJI DERGISI-TURKISH JOURNAL OF ENTOMOLOGY": 0.8,
  "JOURNAL OF ALGEBRA": 0.8,
  "POLISH JOURNAL OF PATHOLOGY": 0.8,
  "PERIODICA MATHEMATICA HUNGARICA": 0.8,
  "JAPAN JOURNAL OF NURSING SCIENCE": 0.8,
  "BRITISH JOURNAL OF MIDDLE EASTERN STUDIES": 0.8,
  "IEEE PULSE": 0.8,
  "INTERNATIONAL JOURNAL OF SPORT PSYCHOLOGY": 0.8,
  "INTERNATIONAL FOOD RESEARCH JOURNAL": 0.8,
  "TECHNOLOGY AND CULTURE": 0.8,
  "TURKISH JOURNAL OF BIOLOGY": 0.8,
  "ACTA BOTANICA MEXICANA": 0.8,
  "JOURNAL OF BALTIC STUDIES": 0.8,
  "M S-MEDECINE SCIENCES": 0.8,
  "ROMANIAN JOURNAL OF INFORMATION SCIENCE AND TECHNOLOGY": 0.8,
  "ANTHROPOLOGY & EDUCATION QUARTERLY": 0.799,
  "DIFFERENTIAL EQUATIONS": 0.798,
  "RESEARCH AND THEORY FOR NURSING PRACTICE": 0.798,
  "ENTOMOLOGICA FENNICA": 0.798,
  "INTERPRETER AND TRANSLATOR TRAINER": 0.797,
  "AMERICAN MIDLAND NATURALIST": 0.797,
  "ANATOMIA HISTOLOGIA EMBRYOLOGIA": 0.797,
  "TECHNICAL COMMUNICATION": 0.797,
  "ACTA VETERINARIA-BEOGRAD": 0.796,
  "CAMBRIDGE REVIEW OF INTERNATIONAL AFFAIRS": 0.796,
  "JAPANESE JOURNAL OF VETERINARY RESEARCH": 0.796,
  "JOURNAL OF POST KEYNESIAN ECONOMICS": 0.796,
  "JOURNAL OF PSYCHOLINGUISTIC RESEARCH": 0.795,
  "ORAL HISTORY REVIEW": 0.795,
  "PERSPECTIVES-STUDIES IN TRANSLATION THEORY AND PRACTICE": 0.795,
  "WATERBIRDS": 0.794,
  "AGROCHIMICA": 0.794,
  "ADVANCES IN CONDENSED MATTER PHYSICS": 0.794,
  "COMMUNICATION CULTURE & CRITIQUE": 0.794,
  "JOURNAL OF ECONOMIC EDUCATION": 0.794,
  "SOUTH AFRICAN JOURNAL OF ANIMAL SCIENCE": 0.793,
  "CZECH JOURNAL OF GENETICS AND PLANT BREEDING": 0.793,
  "ESAIM-PROBABILITY AND STATISTICS": 0.793,
  "INTEGRAL EQUATIONS AND OPERATOR THEORY": 0.793,
  "JOURNAL OF POLITENESS RESEARCH-LANGUAGE BEHAVIOUR CULTURE": 0.792,
  "JOURNAL OF THE FACULTY OF ENGINEERING AND ARCHITECTURE OF GAZI UNIVERSITY": 0.792,
  "NEW MEDIT": 0.792,
  "SEMINARS IN ROENTGENOLOGY": 0.792,
  "HORTTECHNOLOGY": 0.792,
  "JAPAN AND THE WORLD ECONOMY": 0.792,
  "JOURNAL OF LEGAL EDUCATION": 0.792,
  "JOURNAL OF THE CHINESE INSTITUTE OF ENGINEERS": 0.791,
  "JOURNAL OF SUPERHARD MATERIALS": 0.791,
  "ADVANCES IN ELECTRICAL AND COMPUTER ENGINEERING": 0.79,
  "ANNALS OF COMBINATORICS": 0.79,
  "JOURNAL OF LABOR RESEARCH": 0.79,
  "JOURNAL OF COMMUNITY HEALTH NURSING": 0.79,
  "POLITICS PHILOSOPHY & ECONOMICS": 0.789,
  "SPORTVERLETZUNG-SPORTSCHADEN": 0.789,
  "ZEITSCHRIFT FUR SPRACHWISSENSCHAFT": 0.789,
  "REVISTA BRASILEIRA DE ENGENHARIA AGRICOLA E AMBIENTAL": 0.789,
  "SOCIAL WORK IN PUBLIC HEALTH": 0.789,
  "ZYGON": 0.789,
  "DOKLADY PHYSICS": 0.789,
  "EUROPEAN REVIEW OF APPLIED PSYCHOLOGY-REVUE EUROPEENNE DE PSYCHOLOGIE APPLIQUEE": 0.789,
  "JOURNAL OF DEMOGRAPHIC ECONOMICS": 0.788,
  "REVISTA DE PSICOLOGIA DEL DEPORTE": 0.788,
  "SCIENCE TECHNOLOGY AND SOCIETY": 0.788,
  "TROPICAL ECOLOGY": 0.788,
  "HARVARD JOURNAL OF LAW AND PUBLIC POLICY": 0.788,
  "HISTORIA Y POLITICA": 0.788,
  "POLITICAL SCIENCE QUARTERLY": 0.787,
  "EUROPEAN JOURNAL OF LAW AND ECONOMICS": 0.787,
  "IRISH JOURNAL OF AGRICULTURAL AND FOOD RESEARCH": 0.787,
  "ACTA MATHEMATICA SINICA-ENGLISH SERIES": 0.787,
  "ACTA PHYSICA SINICA": 0.787,
  "COMPUTER ANIMATION AND VIRTUAL WORLDS": 0.786,
  "CUTIS": 0.786,
  "INTERNATIONAL JOURNAL OF SOFTWARE ENGINEERING AND KNOWLEDGE ENGINEERING": 0.786,
  "IRANIAN RED CRESCENT MEDICAL JOURNAL": 0.786,
  "JOURNAL OF FUSION ENERGY": 0.786,
  "JOURNAL OF AGROMETEOROLOGY": 0.786,
  "MACEDONIAN JOURNAL OF CHEMISTRY AND CHEMICAL ENGINEERING": 0.786,
  "NATIONAL MEDICAL JOURNAL OF INDIA": 0.785,
  "STUDIA PSYCHOLOGICA": 0.785,
  "TEHNICKI VJESNIK-TECHNICAL GAZETTE": 0.785,
  "ASTROPHYSICS": 0.785,
  "RUSSIAN JOURNAL OF GENERAL CHEMISTRY": 0.785,
  "ULUSAL TRAVMA VE ACIL CERRAHI DERGISI-TURKISH JOURNAL OF TRAUMA & EMERGENCY SURGERY": 0.784,
  "ZEITSCHRIFT FUR GESUNDHEITSPSYCHOLOGIE": 0.784,
  "AUSTRALIAN & NEW ZEALAND JOURNAL OF STATISTICS": 0.784,
  "DOKLADY PHYSICAL CHEMISTRY": 0.784,
  "ESTUDIOS ATACAMENOS": 0.784,
  "JOURNAL OF THE PAKISTAN MEDICAL ASSOCIATION": 0.784,
  "WOOD RESEARCH": 0.783,
  "CLIMATE CHANGE ECONOMICS": 0.782,
  "ERDE": 0.782,
  "JOURNAL OF AFRICAN HISTORY": 0.782,
  "JOURNAL OF CONSUMER PROTECTION AND FOOD SAFETY": 0.782,
  "JOURNAL OF TRANSPORTATION ENGINEERING PART A-SYSTEMS": 0.781,
  "METALLURGICAL RESEARCH & TECHNOLOGY": 0.781,
  "PHYSICS OF WAVE PHENOMENA": 0.781,
  "METRIKA": 0.781,
  "PROGRESS IN COMMUNITY HEALTH PARTNERSHIPS-RESEARCH EDUCATION AND ACTION": 0.78,
  "JOURNAL OF ANTHROPOLOGICAL RESEARCH": 0.78,
  "RAIRO-OPERATIONS RESEARCH": 0.78,
  "AMERICAN ANNALS OF THE DEAF": 0.78,
  "ANALELE STIINTIFICE ALE UNIVERSITATII OVIDIUS CONSTANTA-SERIA MATEMATICA": 0.779,
  "DIGEST JOURNAL OF NANOMATERIALS AND BIOSTRUCTURES": 0.779,
  "GERMAN ECONOMIC REVIEW": 0.779,
  "NAGOYA MATHEMATICAL JOURNAL": 0.779,
  "PHYSICS TEACHER": 0.779,
  "WATER RESOURCES": 0.779,
  "DOKLADY EARTH SCIENCES": 0.779,
  "TECHNICAL PHYSICS": 0.778,
  "AQUATIC MAMMALS": 0.778,
  "BULLETIN OF THE MENNINGER CLINIC": 0.778,
  "CENTRAL EUROPEAN JOURNAL OF PUBLIC HEALTH": 0.778,
  "ECOLOGY LAW QUARTERLY": 0.778,
  "INTERNATIONAL JOURNAL OF FINANCE & ECONOMICS": 0.778,
  "JOURNAL OF ELECTRICAL ENGINEERING-ELEKTROTECHNICKY CASOPIS": 0.778,
  "MATERIALS SCIENCE-MEDZIAGOTYRA": 0.777,
  "QUARTERLY JOURNAL OF MATHEMATICS": 0.777,
  "RUSSIAN JOURNAL OF COORDINATION CHEMISTRY": 0.776,
  "RADIATION EFFECTS AND DEFECTS IN SOLIDS": 0.776,
  "VETERINARNI MEDICINA": 0.776,
  "ACTA MEDICA OKAYAMA": 0.776,
  "DEUTSCHE MEDIZINISCHE WOCHENSCHRIFT": 0.776,
  "FORTSCHRITTE DER NEUROLOGIE PSYCHIATRIE": 0.776,
  "JOURNAL OF INORGANIC MATERIALS": 0.776,
  "REVISTA ESPANOLA DE SALUD PUBLICA": 0.774,
  "HIGH ENERGY CHEMISTRY": 0.774,
  "INDIAN JOURNAL OF PHARMACEUTICAL SCIENCES": 0.774,
  "JOURNAL OF MATHEMATICAL ECONOMICS": 0.774,
  "JOURNAL OF ENVIRONMENTAL PROTECTION AND ECOLOGY": 0.773,
  "WILSON JOURNAL OF ORNITHOLOGY": 0.773,
  "BIOCELL": 0.773,
  "ZEITSCHRIFT FUR SOZIOLOGIE": 0.773,
  "CLINICA Y SALUD": 0.773,
  "HOMOLOGY HOMOTOPY AND APPLICATIONS": 0.773,
  "JOURNAL OF LOGICAL AND ALGEBRAIC METHODS IN PROGRAMMING": 0.773,
  "JOURNAL OF THE OPTICAL SOCIETY OF KOREA": 0.773,
  "RUSSIAN METEOROLOGY AND HYDROLOGY": 0.772,
  "ORTHOPADE": 0.772,
  "ZEITSCHRIFT FUR ORTHOPADIE UND UNFALLCHIRURGIE": 0.772,
  "ACOUSTICS AUSTRALIA": 0.772,
  "JOURNAL OF CHEMICAL CRYSTALLOGRAPHY": 0.771,
  "JOURNAL OF THE KOREAN PHYSICAL SOCIETY": 0.771,
  "NOTARZT": 0.771,
  "REVUE SUISSE DE ZOOLOGIE": 0.771,
  "FOOD CULTURE & SOCIETY": 0.771,
  "PRAGUE ECONOMIC PAPERS": 0.77,
  "ACTA PAULISTA DE ENFERMAGEM": 0.769,
  "REVISTA ROMANA DE MATERIALE-ROMANIAN JOURNAL OF MATERIALS": 0.769,
  "EUROPEAN JOURNAL FOR PHILOSOPHY OF SCIENCE": 0.769,
  "JOURNAL OF CHEMICAL ENGINEERING OF JAPAN": 0.769,
  "JOURNAL OF VISUAL IMPAIRMENT & BLINDNESS": 0.769,
  "JOURNAL OF COMPETITION LAW & ECONOMICS": 0.769,
  "LIBRARY TRENDS": 0.769,
  "FETAL AND PEDIATRIC PATHOLOGY": 0.768,
  "GLASS AND CERAMICS": 0.768,
  "DOKLADY MATHEMATICS": 0.768,
  "ECOSCIENCE": 0.767,
  "GENEVA RISK AND INSURANCE REVIEW": 0.767,
  "GROUPS GEOMETRY AND DYNAMICS": 0.767,
  "HYDROLOGIE UND WASSERBEWIRTSCHAFTUNG": 0.767,
  "INTERNATIONAL JOURNAL OF PSYCHOLOGICAL RESEARCH": 0.767,
  "JOURNAL OF ELECTRONIC TESTING-THEORY AND APPLICATIONS": 0.766,
  "JOURNAL OF NEW MUSIC RESEARCH": 0.765,
  "MAIN GROUP CHEMISTRY": 0.765,
  "MALAYSIAN JOURNAL OF COMPUTER SCIENCE": 0.765,
  "RUSSIAN PHYSICS JOURNAL": 0.765,
  "SOCIAL COMPASS": 0.764,
  "SOCIOLOGICAL SPECTRUM": 0.764,
  "TURKISH JOURNAL OF ELECTRICAL ENGINEERING AND COMPUTER SCIENCES": 0.763,
  "NEPHROLOGY NURSING JOURNAL": 0.763,
  "NOTULAE BOTANICAE HORTI AGROBOTANICI CLUJ-NAPOCA": 0.763,
  "ELECTRONIC COMMUNICATIONS IN PROBABILITY": 0.763,
  "HORTICULTURAL SCIENCE": 0.763,
  "ZENTRALBLATT FUR CHIRURGIE": 0.762,
  "BAUINGENIEUR": 0.762,
  "INDIAN ECONOMIC AND SOCIAL HISTORY REVIEW": 0.762,
  "IRANIAN STUDIES": 0.762,
  "QUIMICA NOVA": 0.762,
  "JOURNAL OF BLACK STUDIES": 0.761,
  "JOURNAL OF THE AMERICAN HELICOPTER SOCIETY": 0.761,
  "JOURNAL OF HARD TISSUE BIOLOGY": 0.761,
  "COMPUTER SCIENCE AND INFORMATION SYSTEMS": 0.76,
  "FOOD AND DRUG LAW JOURNAL": 0.76,
  "MIDDLE EAST JOURNAL": 0.76,
  "QUAESTIONES MATHEMATICAE": 0.76,
  "SOTSIOLOGICHESKIE ISSLEDOVANIYA": 0.759,
  "TRENDS IN GLYCOSCIENCE AND GLYCOTECHNOLOGY": 0.759,
  "ASIAN JOURNAL OF CRIMINOLOGY": 0.759,
  "JOURNAL OF THE AMERICAN MOSQUITO CONTROL ASSOCIATION": 0.759,
  "PAKISTAN JOURNAL OF AGRICULTURAL SCIENCES": 0.759,
  "REDIA-GIORNALE DI ZOOLOGIA": 0.759,
  "TRAVAIL GENRE ET SOCIETES": 0.759,
  "HUMAN STUDIES": 0.759,
  "JOURNAL OF PSEUDO-DIFFERENTIAL OPERATORS AND APPLICATIONS": 0.759,
  "REVISTA DE HISTORIA INDUSTRIAL": 0.759,
  "ENVIRONMENT PROTECTION ENGINEERING": 0.758,
  "JOURNAL OF BALKAN AND NEAR EASTERN STUDIES": 0.758,
  "HISTORY AND THEORY": 0.758,
  "INTERNATIONAL JOURNAL OF GAME THEORY": 0.758,
  "JOURNAL OF NIPPON MEDICAL SCHOOL": 0.758,
  "NATURAL RESOURCES JOURNAL": 0.757,
  "STATISTICS & PROBABILITY LETTERS": 0.757,
  "WOMEN & THERAPY": 0.757,
  "ANTI-CORROSION METHODS AND MATERIALS": 0.756,
  "EUROPEAN JOURNAL OF FUTURES RESEARCH": 0.756,
  "INDIAN JOURNAL OF CHEMICAL TECHNOLOGY": 0.756,
  "IDOJARAS": 0.756,
  "JOURNAL OF EARLY MODERN HISTORY": 0.756,
  "LAW AND HISTORY REVIEW": 0.756,
  "MAIN GROUP METAL CHEMISTRY": 0.756,
  "NUCLEAR TECHNOLOGY & RADIATION PROTECTION": 0.756,
  "PROCEEDINGS OF THE INSTITUTION OF CIVIL ENGINEERS-MUNICIPAL ENGINEER": 0.756,
  "ETHIOPIAN JOURNAL OF HEALTH DEVELOPMENT": 0.755,
  "GLASS TECHNOLOGY-EUROPEAN JOURNAL OF GLASS SCIENCE AND TECHNOLOGY PART A": 0.754,
  "JOURNAL OF MULTIPLE-VALUED LOGIC AND SOFT COMPUTING": 0.754,
  "DOKLADY BIOCHEMISTRY AND BIOPHYSICS": 0.754,
  "INTELLIGENT DATA ANALYSIS": 0.754,
  "MATHEMATICAL NOTES": 0.754,
  "ASIAN SURVEY": 0.753,
  "AUSTRALIAN JOURNAL OF ZOOLOGY": 0.752,
  "ASIAN ECONOMIC PAPERS": 0.752,
  "COMPTES RENDUS MATHEMATIQUE": 0.751,
  "INTERNATIONAL JOURNAL OF ENGINEERING EDUCATION": 0.751,
  "NEW ZEALAND GEOGRAPHER": 0.75,
  "SOCIOLOGUS": 0.75,
  "AMERICAN JOURNAL OF FAMILY THERAPY": 0.75,
  "AMERICAN SURGEON": 0.75,
  "JOURNAL OF APPLIED PROBABILITY": 0.75,
  "JOURNAL OF THE PALAEONTOLOGICAL SOCIETY OF INDIA": 0.75,
  "PROCEEDINGS OF THE EDINBURGH MATHEMATICAL SOCIETY": 0.75,
  "REVIEWS IN CARDIOVASCULAR MEDICINE": 0.75,
  "ACTA PHYSICA POLONICA B": 0.75,
  "ELECTROMAGNETICS": 0.75,
  "ENGLISH WORLD-WIDE": 0.75,
  "FOREST PRODUCTS JOURNAL": 0.75,
  "LOGIC JOURNAL OF THE IGPL": 0.75,
  "PSYCHOANALYTIC QUARTERLY": 0.749,
  "JOURNAL OF ADULT DEVELOPMENT": 0.749,
  "SOCIOLOGICAL INQUIRY": 0.748,
  "STRUCTURAL ENGINEERING INTERNATIONAL": 0.748,
  "BELGIAN JOURNAL OF ZOOLOGY": 0.748,
  "BRAZILIAN JOURNAL OF POULTRY SCIENCE": 0.748,
  "EGITIM VE BILIM-EDUCATION AND SCIENCE": 0.747,
  "TURKISH JOURNAL OF ZOOLOGY": 0.747,
  "AUSTRALASIAN JOURNAL OF EARLY CHILDHOOD": 0.747,
  "GEODETSKI VESTNIK": 0.746,
  "DIFFERENTIAL GEOMETRY AND ITS APPLICATIONS": 0.746,
  "HACETTEPE JOURNAL OF MATHEMATICS AND STATISTICS": 0.746,
  "JOURNAL OF WUHAN UNIVERSITY OF TECHNOLOGY-MATERIALS SCIENCE EDITION": 0.746,
  "NOTES AND RECORDS-THE ROYAL SOCIETY JOURNAL OF THE HISTORY OF SCIENCE": 0.745,
  "TARGET-INTERNATIONAL JOURNAL OF TRANSLATION STUDIES": 0.745,
  "WORLD RABBIT SCIENCE": 0.745,
  "FINANCE A UVER-CZECH JOURNAL OF ECONOMICS AND FINANCE": 0.744,
  "PHILOSOPHY OF THE SOCIAL SCIENCES": 0.744,
  "INTERNATIONAL SOCIAL WORK": 0.744,
  "JAPAN JOURNAL OF INDUSTRIAL AND APPLIED MATHEMATICS": 0.744,
  "RECHTSMEDIZIN": 0.743,
  "SOCIAL HISTORY OF MEDICINE": 0.743,
  "THEORY OF COMPUTING SYSTEMS": 0.743,
  "TURKISH JOURNAL OF MEDICAL SCIENCES": 0.742,
  "BULLETIN OF THE KOREAN CHEMICAL SOCIETY": 0.742,
  "JOURNAL OF THE AUSTRALIAN MATHEMATICAL SOCIETY": 0.742,
  "JOURNAL OF MARINE SCIENCE AND TECHNOLOGY-TAIWAN": 0.742,
  "TAIWANIA": 0.742,
  "AMBIX": 0.741,
  "CHINA PETROLEUM PROCESSING & PETROCHEMICAL TECHNOLOGY": 0.741,
  "ECON JOURNAL WATCH": 0.741,
  "INFOR": 0.741,
  "INTERNATIONAL JOURNAL OF MARINE AND COASTAL LAW": 0.741,
  "IRANIAN JOURNAL OF SCIENCE AND TECHNOLOGY-TRANSACTIONS OF ELECTRICAL ENGINEERING": 0.741,
  "JOURNAL OF EAST ASIAN LINGUISTICS": 0.741,
  "JOURNAL OF MARINE RESEARCH": 0.741,
  "JOURNAL OF MENS HEALTH": 0.741,
  "MAGNETOHYDRODYNAMICS": 0.741,
  "NEUES JAHRBUCH FUR MINERALOGIE-ABHANDLUNGEN": 0.741,
  "PALEONTOLOGICAL RESEARCH": 0.74,
  "PROBABILITY AND MATHEMATICAL STATISTICS-POLAND": 0.74,
  "SUCHTTHERAPIE": 0.74,
  "TERAPIA PSICOLOGICA": 0.74,
  "UNIVERSITY OF ILLINOIS LAW REVIEW": 0.74,
  "WATER QUALITY RESEARCH JOURNAL OF CANADA": 0.738,
  "BOLETIM DO INSTITUTO DE PESCA": 0.738,
  "IEICE TRANSACTIONS ON ELECTRONICS": 0.737,
  "BOLETIN DE LA ASOCIACION DE GEOGRAFOS ESPANOLES": 0.736,
  "HEMOGLOBIN": 0.736,
  "INGENIERIA E INVESTIGACION": 0.736,
  "JOURNAL OF MEDICAL PRIMATOLOGY": 0.735,
  "GENEVA PAPERS ON RISK AND INSURANCE-ISSUES AND PRACTICE": 0.735,
  "TURKISH JOURNAL OF MATHEMATICS": 0.735,
  "APPLICABLE ALGEBRA IN ENGINEERING COMMUNICATION AND COMPUTING": 0.735,
  "JOURNAL OF ALGEBRA AND ITS APPLICATIONS": 0.735,
  "MINERVA BIOTECNOLOGICA": 0.735,
  "PAKISTAN JOURNAL OF PHARMACEUTICAL SCIENCES": 0.735,
  "BRITISH JOURNAL FOR THE HISTORY OF SCIENCE": 0.735,
  "FREQUENZ": 0.734,
  "JOURNAL OF COGNITIVE PSYCHOTHERAPY": 0.734,
  "JOURNAL OF NONLINEAR AND CONVEX ANALYSIS": 0.733,
  "PSIKHOLOGICHESKII ZHURNAL": 0.733,
  "FOLIA ZOOLOGICA": 0.733,
  "JOURNAL OF THE AMERICAN ANIMAL HOSPITAL ASSOCIATION": 0.733,
  "PANOECONOMICUS": 0.733,
  "TM-TECHNISCHES MESSEN": 0.733,
  "ALGEBRA AND LOGIC": 0.733,
  "CONTINUITY AND CHANGE": 0.732,
  "KOVOVE MATERIALY-METALLIC MATERIALS": 0.732,
  "BULLETIN OF THE AUSTRALIAN MATHEMATICAL SOCIETY": 0.732,
  "MATHEMATICAL STRUCTURES IN COMPUTER SCIENCE": 0.731,
  "APPLIED ECONOMICS LETTERS": 0.731,
  "CONTEMPORARY PACIFIC": 0.731,
  "THEORY OF PROBABILITY AND ITS APPLICATIONS": 0.731,
  "TROPICAL DOCTOR": 0.731,
  "DOKLADY CHEMISTRY": 0.731,
  "GEOLOGY OF ORE DEPOSITS": 0.731,
  "INTERNATIONAL JOURNAL OF LEXICOGRAPHY": 0.73,
  "POLISH JOURNAL OF ECOLOGY": 0.73,
  "ROMANIAN BIOTECHNOLOGICAL LETTERS": 0.73,
  "SPANISH JOURNAL OF FINANCE AND ACCOUNTING-REVISTA ESPANOLA DE FINANCIACION Y CONTABILIDA": 0.73,
  "STATISTICAL METHODS AND APPLICATIONS": 0.73,
  "UNIVERSITY OF PENNSYLVANIA JOURNAL OF INTERNATIONAL LAW": 0.729,
  "AUTOMATION AND REMOTE CONTROL": 0.729,
  "ARCHIVES OF MINING SCIENCES": 0.729,
  "DEFENCE SCIENCE JOURNAL": 0.729,
  "JOURNAL OF NANO RESEARCH": 0.729,
  "KOREAN JOURNAL OF HORTICULTURAL SCIENCE & TECHNOLOGY": 0.728,
  "REPRESENTATIONS": 0.728,
  "RUSSIAN JOURNAL OF PHYSICAL CHEMISTRY B": 0.728,
  "CANADIAN JOURNAL OF STATISTICS-REVUE CANADIENNE DE STATISTIQUE": 0.727,
  "JOURNAL OF OBSTETRICS AND GYNAECOLOGY": 0.727,
  "JOURNAL OF OPTOELECTRONICS AND ADVANCED MATERIALS": 0.727,
  "JOURNAL OF APPLIED ECONOMICS": 0.727,
  "JOURNAL OF LATIN AMERICAN AND CARIBBEAN ANTHROPOLOGY": 0.727,
  "RECHT & PSYCHIATRIE": 0.727,
  "CEPAL REVIEW": 0.727,
  "IRANIAN JOURNAL OF PEDIATRICS": 0.727,
  "IEICE ELECTRONICS EXPRESS": 0.727,
  "PROGRES EN UROLOGIE": 0.727,
  "SOCIAL ANALYSIS": 0.726,
  "ACTA BIOTHEORETICA": 0.726,
  "ARKIV FOR MATEMATIK": 0.726,
  "EDUCATION AS CHANGE": 0.726,
  "HUMAN ORGANIZATION": 0.726,
  "HORTICULTURA BRASILEIRA": 0.726,
  "INTERNATIONAL JOURNAL OF DIABETES IN DEVELOPING COUNTRIES": 0.725,
  "NUKLEONIKA": 0.725,
  "APPLIED COMPUTATIONAL ELECTROMAGNETICS SOCIETY JOURNAL": 0.725,
  "FUNDAMENTA MATHEMATICAE": 0.724,
  "JOURNAL OF THE KOREAN MATHEMATICAL SOCIETY": 0.724,
  "SOUTH AFRICAN JOURNAL OF SURGERY": 0.724,
  "CONTROL ENGINEERING AND APPLIED INFORMATICS": 0.724,
  "MADERA Y BOSQUES": 0.723,
  "MEDICINA DEL LAVORO": 0.723,
  "PROGRESS IN REACTION KINETICS AND MECHANISM": 0.723,
  "SPACE POLICY": 0.723,
  "ACTA MEDICA PORTUGUESA": 0.722,
  "COMPUTER ASSISTED SURGERY": 0.722,
  "FAMILIES RELATIONSHIPS AND SOCIETIES": 0.722,
  "INTERNATIONAL JOURNAL OF AMERICAN LINGUISTICS": 0.721,
  "REVISTA DE BIOLOGIA TROPICAL": 0.721,
  "RUSSIAN JOURNAL OF PHYSICAL CHEMISTRY A": 0.721,
  "IEICE TRANSACTIONS ON COMMUNICATIONS": 0.721,
  "MOSCOW UNIVERSITY PHYSICS BULLETIN": 0.72,
  "AMERICAN INDIAN AND ALASKA NATIVE MENTAL HEALTH RESEARCH": 0.72,
  "ELECTRONIC JOURNAL OF LINEAR ALGEBRA": 0.72,
  "MIDDLE EAST POLICY": 0.72,
  "PRESENCE-TELEOPERATORS AND VIRTUAL ENVIRONMENTS": 0.719,
  "REVIEW OF DERIVATIVES RESEARCH": 0.719,
  "REVISTA INTERNACIONAL DE SOCIOLOGIA": 0.719,
  "CLINICS IN PODIATRIC MEDICINE AND SURGERY": 0.718,
  "INTERNATIONAL JOURNAL OF ACOUSTICS AND VIBRATION": 0.718,
  "INTERNATIONAL JOURNAL OF NANOTECHNOLOGY": 0.718,
  "MAYDICA": 0.718,
  "NOTRE DAME JOURNAL OF FORMAL LOGIC": 0.718,
  "SEMIGROUP FORUM": 0.718,
  "ANTHROPOLOGISCHER ANZEIGER": 0.717,
  "ANNALS OF FUNCTIONAL ANALYSIS": 0.717,
  "CANADIAN MATHEMATICAL BULLETIN-BULLETIN CANADIEN DE MATHEMATIQUES": 0.717,
  "ENTERPRISE & SOCIETY": 0.717,
  "JOURNAL OF DATABASE MANAGEMENT": 0.717,
  "JOURNAL OF CONTEMPORARY PHYSICS-ARMENIAN ACADEMY OF SCIENCES": 0.717,
  "MILAN JOURNAL OF MATHEMATICS": 0.717,
  "PROBLEMY EKOROZWOJU": 0.716,
  "RUSSIAN JOURNAL OF NEMATOLOGY": 0.716,
  "ADANSONIA": 0.716,
  "BIOMOLECULAR NMR ASSIGNMENTS": 0.716,
  "IEICE TRANSACTIONS ON INFORMATION AND SYSTEMS": 0.715,
  "PACIFIC JOURNAL OF MATHEMATICS": 0.715,
  "THALASSAS": 0.714,
  "ARCHIVE FOR MATHEMATICAL LOGIC": 0.714,
  "LIMNETICA": 0.714,
  "CURRENT OPTICS AND PHOTONICS": 0.714,
  "MATERIALS TESTING": 0.714,
  "STATISTICS AND ITS INTERFACE": 0.714,
  "JOURNAL OF SYMBOLIC LOGIC": 0.714,
  "ARCHIVES OF CLINICAL PSYCHIATRY": 0.714,
  "BULLETIN MATHEMATIQUE DE LA SOCIETE DES SCIENCES MATHEMATIQUES DE ROUMANIE": 0.714,
  "CANADIAN JOURNAL OF SCHOOL PSYCHOLOGY": 0.713,
  "HAND SURGERY & REHABILITATION": 0.713,
  "JOURNAL FOR EAST EUROPEAN MANAGEMENT STUDIES": 0.712,
  "NORTHWEST SCIENCE": 0.712,
  "ORNITHOLOGICAL SCIENCE": 0.711,
  "PSICOLOGICA": 0.711,
  "REVISTA COLOMBIANA DE CIENCIAS PECUARIAS": 0.711,
  "REVISTA DE ESTUDIOS SOCIALES": 0.711,
  "TROPICAL ZOOLOGY": 0.71,
  "ACTA ORTOPEDICA BRASILEIRA": 0.71,
  "TERRESTRIAL ATMOSPHERIC AND OCEANIC SCIENCES": 0.71,
  "JOURNAL OF THE KOREAN STATISTICAL SOCIETY": 0.709,
  "LABOR HISTORY": 0.708,
  "JOURNAL OF AVIAN MEDICINE AND SURGERY": 0.708,
  "JOURNAL OF TROPICAL FOREST SCIENCE": 0.708,
  "JOURNAL OF THE INTERNATIONAL PHONETIC ASSOCIATION": 0.708,
  "PRAGMATICS & COGNITION": 0.708,
  "REVIEW OF RADICAL POLITICAL ECONOMICS": 0.707,
  "BULLETIN OF EXPERIMENTAL BIOLOGY AND MEDICINE": 0.707,
  "CHEMISTRY OF NATURAL COMPOUNDS": 0.707,
  "JOURNAL OF NEUROSCIENCE PSYCHOLOGY AND ECONOMICS": 0.707,
  "HEMIJSKA INDUSTRIJA": 0.707,
  "LITHUANIAN MATHEMATICAL JOURNAL": 0.706,
  "MITOCHONDRIAL DNA PART A": 0.706,
  "PSYCHIATRIC ANNALS": 0.706,
  "REVISTA INTERNACIONAL DE CONTAMINACION AMBIENTAL": 0.706,
  "FRONTIERS OF MATHEMATICS IN CHINA": 0.706,
  "SOUTHWESTERN ENTOMOLOGIST": 0.706,
  "ENTOMOLOGICAL RESEARCH": 0.705,
  "HEART SURGERY FORUM": 0.705,
  "ORVOSI HETILAP": 0.704,
  "FERROELECTRICS LETTERS SECTION": 0.704,
  "INTERLENDING & DOCUMENT SUPPLY": 0.704,
  "JOURNAL OF SOCIAL HISTORY": 0.704,
  "JOURNAL OF THE POLYNESIAN SOCIETY": 0.703,
  "DYNA": 0.703,
  "ASIA-PACIFIC JOURNAL OF OPERATIONAL RESEARCH": 0.703,
  "CANDOLLEA": 0.702,
  "MITOCHONDRIAL DNA PART B-RESOURCES": 0.702,
  "SEMINARS IN PLASTIC SURGERY": 0.702,
  "ANTHROPOZOOLOGICA": 0.702,
  "INTERNATIONAL JOURNAL OF AD HOC AND UBIQUITOUS COMPUTING": 0.702,
  "KYBERNETIKA": 0.701,
  "JOURNAL OF COMPUTATIONAL FINANCE": 0.701,
  "MOLECULAR CRYSTALS AND LIQUID CRYSTALS": 0.701,
  "PROGRESS IN RUBBER PLASTICS AND RECYCLING TECHNOLOGY": 0.701,
  "RUSSIAN JOURNAL OF GENETICS": 0.7,
  "ZEITSCHRIFT FUR ENTWICKLUNGSPSYCHOLOGIE UND PADAGOGISCHE PSYCHOLOGIE": 0.7,
  "FIXED POINT THEORY": 0.7,
  "GRUNDWASSER": 0.7,
  "HUMOR-INTERNATIONAL JOURNAL OF HUMOR RESEARCH": 0.7,
  "PSYCHE-ZEITSCHRIFT FUR PSYCHOANALYSE UND IHRE ANWENDUNGEN": 0.7,
  "SOCIOLOGIE DU TRAVAIL": 0.7,
  "JOURNAL FRANCAIS D OPHTALMOLOGIE": 0.7,
  "JOURNAL OF COMPUTATIONAL AND THEORETICAL TRANSPORT": 0.699,
  "PROBLEMS OF INFORMATION TRANSMISSION": 0.699,
  "ADVANCED COMPOSITES LETTERS": 0.699,
  "ASIA-PACIFIC JOURNAL OF FINANCIAL STUDIES": 0.698,
  "DESIGN AUTOMATION FOR EMBEDDED SYSTEMS": 0.698,
  "HUMAN HEREDITY": 0.698,
  "HUMAN ECOLOGY REVIEW": 0.698,
  "INTERNATIONAL JOURNAL OF NUMBER THEORY": 0.697,
  "INTERSECCIONES EN ANTROPOLOGIA": 0.697,
  "KLINIK PSIKOFARMAKOLOJI BULTENI-BULLETIN OF CLINICAL PSYCHOPHARMACOLOGY": 0.697,
  "MATERIALWISSENSCHAFT UND WERKSTOFFTECHNIK": 0.697,
  "JOURNAL OF ENVIRONMENTAL BIOLOGY": 0.697,
  "JOURNAL OF APPLIED MECHANICS AND TECHNICAL PHYSICS": 0.696,
  "ACTA VIROLOGICA": 0.696,
  "ARCHIVES OF BIOLOGICAL SCIENCES": 0.696,
  "GLASNIK MATEMATICKI": 0.696,
  "NIHON REOROJI GAKKAISHI": 0.696,
  "NATURAL PRODUCT COMMUNICATIONS": 0.696,
  "REVISTA CAATINGA": 0.695,
  "REVISTA CHAPINGO SERIE CIENCIAS FORESTALES Y DEL AMBIENTE": 0.695,
  "SOCIOLOGICKY CASOPIS-CZECH SOCIOLOGICAL REVIEW": 0.695,
  "CIENCIA RURAL": 0.694,
  "LIBRI": 0.694,
  "POLITY": 0.694,
  "ALGEBRAS AND REPRESENTATION THEORY": 0.694,
  "APPLIED CATEGORICAL STRUCTURES": 0.694,
  "BRAZILIAN JOURNAL OF PROBABILITY AND STATISTICS": 0.694,
  "GEORGIAN MATHEMATICAL JOURNAL": 0.693,
  "PEDIATRIC ALLERGY IMMUNOLOGY AND PULMONOLOGY": 0.693,
  "PSYCHOLOGIE FRANCAISE": 0.693,
  "REVISTA SIGNOS": 0.692,
  "SOUTH AFRICAN JOURNAL OF ECONOMIC AND MANAGEMENT SCIENCES": 0.692,
  "INDIAN JOURNAL OF SURGERY": 0.692,
  "ZEITSCHRIFT FUR KLINISCHE PSYCHOLOGIE UND PSYCHOTHERAPIE": 0.692,
  "ANIMAL CELLS AND SYSTEMS": 0.692,
  "MANUSCRIPTA MATHEMATICA": 0.691,
  "PHYSICS OF PARTICLES AND NUCLEI": 0.691,
  "BIJDRAGEN TOT DE TAAL- LAND- EN VOLKENKUNDE": 0.691,
  "FUNKCIALAJ EKVACIOJ-SERIO INTERNACIA": 0.691,
  "JOURNAL OF MARINE ENGINEERING AND TECHNOLOGY": 0.69,
  "ACTA ALIMENTARIA": 0.69,
  "AFRICAN JOURNAL OF REPRODUCTIVE HEALTH": 0.69,
  "SOUTH AFRICAN JOURNAL OF INDUSTRIAL ENGINEERING": 0.69,
  "DISP": 0.69,
  "MONTHLY LABOR REVIEW": 0.69,
  "PATHOLOGE": 0.69,
  "ACTA PHYSICA POLONICA A": 0.69,
  "DISCRETE AND CONTINUOUS DYNAMICAL SYSTEMS-SERIES S": 0.69,
  "HYLE": 0.689,
  "INTERNATIONAL REVIEW OF ECONOMICS EDUCATION": 0.689,
  "PSIHOLOGIJA": 0.689,
  "REVUE DES MALADIES RESPIRATOIRES": 0.689,
  "ESTUDIOS DE PSICOLOGIA": 0.689,
  "FOLIA PHONIATRICA ET LOGOPAEDICA": 0.689,
  "JOURNAL OF SOUTHERN HEMISPHERE EARTH SYSTEMS SCIENCE": 0.688,
  "JOURNAL OF THE ECONOMIC AND SOCIAL HISTORY OF THE ORIENT": 0.688,
  "LAW AND PHILOSOPHY": 0.688,
  "NEW YORK JOURNAL OF MATHEMATICS": 0.688,
  "REVIEW OF CENTRAL AND EAST EUROPEAN LAW": 0.687,
  "SOUTH AFRICAN JOURNAL ON HUMAN RIGHTS": 0.687,
  "ACTA GASTRO-ENTEROLOGICA BELGICA": 0.686,
  "ENGENHARIA AGRICOLA": 0.686,
  "JOURNAL OF STRUCTURAL CHEMISTRY": 0.685,
  "LEPROSY REVIEW": 0.685,
  "COLLOQUIUM MATHEMATICUM": 0.685,
  "GEOGRAFIE": 0.684,
  "INTERNATIONAL JOURNAL OF FOUNDATIONS OF COMPUTER SCIENCE": 0.684,
  "MATHEMATICAL SOCIAL SCIENCES": 0.684,
  "REVISTA DE METALURGIA": 0.684,
  "SAINS MALAYSIANA": 0.683,
  "AMERICAN JOURNAL OF FORENSIC MEDICINE AND PATHOLOGY": 0.683,
  "JOURNAL OF THE AMERICAN PODIATRIC MEDICAL ASSOCIATION": 0.683,
  "JOURNAL OF MEDICAL DEVICES-TRANSACTIONS OF THE ASME": 0.683,
  "MODERN ASIAN STUDIES": 0.683,
  "ACTA MATHEMATICA HUNGARICA": 0.682,
  "AUSTRALIAN JOURNAL OF LINGUISTICS": 0.682,
  "AQUATIC INSECTS": 0.682,
  "APPLICATIONS OF MATHEMATICS": 0.682,
  "ECONOMIC AND SOCIAL REVIEW": 0.682,
  "MARINE ORNITHOLOGY": 0.681,
  "AFRICAN ENTOMOLOGY": 0.681,
  "ANALYSIS AND GEOMETRY IN METRIC SPACES": 0.681,
  "STOCHASTIC MODELS": 0.681,
  "STATISTICAL APPLICATIONS IN GENETICS AND MOLECULAR BIOLOGY": 0.68,
  "ANNALS OF GLOBAL ANALYSIS AND GEOMETRY": 0.68,
  "SOCIAL BEHAVIOR AND PERSONALITY": 0.68,
  "PROGRESS IN COMPUTATIONAL FLUID DYNAMICS": 0.68,
  "ANALES DEL SISTEMA SANITARIO DE NAVARRA": 0.68,
  "ARCHIVE FOR THE PSYCHOLOGY OF RELIGION-ARCHIV FUR RELIGIONSPSYCHOLOGIE": 0.679,
  "CURRENT MEDICAL IMAGING REVIEWS": 0.679,
  "ESTUDIOS GEOLOGICOS-MADRID": 0.679,
  "ENGLISH TODAY": 0.678,
  "GEOLOGICAL SURVEY OF DENMARK AND GREENLAND BULLETIN": 0.677,
  "CANADIAN VETERINARY JOURNAL-REVUE VETERINAIRE CANADIENNE": 0.677,
  "FOLIA HORTICULTURAE": 0.677,
  "INTERNATIONAL JOURNAL OF INDUSTRIAL ENGINEERING-THEORY APPLICATIONS AND PRACTICE": 0.676,
  "MEDICINE SCIENCE AND THE LAW": 0.676,
  "NOTFALL & RETTUNGSMEDIZIN": 0.676,
  "ARCTIC ANTHROPOLOGY": 0.676,
  "CULTURE AND ORGANIZATION": 0.676,
  "HASTINGS LAW JOURNAL": 0.676,
  "IEEE ANNALS OF THE HISTORY OF COMPUTING": 0.675,
  "IRISH EDUCATIONAL STUDIES": 0.675,
  "MYCOTAXON": 0.675,
  "PTERIDINES": 0.675,
  "RATIONALITY AND SOCIETY": 0.674,
  "ASIA PACIFIC JOURNAL OF SOCIAL WORK AND DEVELOPMENT": 0.674,
  "ASIAN STUDIES REVIEW": 0.674,
  "CIENCIA FLORESTAL": 0.674,
  "JOURNAL OF ANIMAL AND PLANT SCIENCES": 0.674,
  "SCOTTISH HISTORICAL REVIEW": 0.674,
  "HISTORY WORKSHOP JOURNAL": 0.673,
  "JOURNAL OF SYNTHETIC ORGANIC CHEMISTRY JAPAN": 0.673,
  "RUSSIAN JOURNAL OF PACIFIC GEOLOGY": 0.673,
  "BRITISH JOURNAL OF HOSPITAL MEDICINE": 0.673,
  "MATERIALS SCIENCE": 0.673,
  "PLANNING PERSPECTIVES": 0.672,
  "SOCIAL PHILOSOPHY & POLICY": 0.672,
  "DENVER LAW REVIEW": 0.672,
  "ENVIRONMENTAL HISTORY": 0.672,
  "FIBER AND INTEGRATED OPTICS": 0.671,
  "JOURNAL OF INFORMATION SCIENCE AND ENGINEERING": 0.671,
  "JOURNAL OF FRENCH LANGUAGE STUDIES": 0.67,
  "JOURNAL OF GEOMETRIC MECHANICS": 0.67,
  "MEDICINA-BUENOS AIRES": 0.67,
  "SOCIAL CHOICE AND WELFARE": 0.67,
  "EAST EUROPEAN POLITICS AND SOCIETIES": 0.67,
  "ENGINEERING MANAGEMENT JOURNAL": 0.669,
  "JOURNAL OF ZOO AND WILDLIFE MEDICINE": 0.669,
  "THEORY AND APPLICATIONS OF CATEGORIES": 0.668,
  "CONTEMPORARY POLITICAL THEORY": 0.667,
  "INTERNATIONAL JOURNAL OF WAVELETS MULTIRESOLUTION AND INFORMATION PROCESSING": 0.667,
  "RUSSIAN JOURNAL OF DEVELOPMENTAL BIOLOGY": 0.667,
  "SALUD MENTAL": 0.667,
  "JOURNAL OF THE CHILEAN CHEMICAL SOCIETY": 0.667,
  "POLITIX": 0.667,
  "REFRACTORIES AND INDUSTRIAL CERAMICS": 0.667,
  "UROLOGE": 0.667,
  "ACTA CHIRURGICA BELGICA": 0.667,
  "INDIAN JOURNAL OF PATHOLOGY AND MICROBIOLOGY": 0.667,
  "OPERATORS AND MATRICES": 0.667,
  "B E JOURNAL OF ECONOMIC ANALYSIS & POLICY": 0.667,
  "COMPARATIVE PARASITOLOGY": 0.667,
  "HIPPOKRATIA": 0.667,
  "JOURNAL OF RISK": 0.667,
  "THEORETICAL FOUNDATIONS OF CHEMICAL ENGINEERING": 0.667,
  "CHILDRENS HEALTH CARE": 0.667,
  "NEUROCIRUGIA": 0.667,
  "JOURNAL OF THE LEPIDOPTERISTS SOCIETY": 0.667,
  "JOURNAL OF OPTICAL TECHNOLOGY": 0.667,
  "SOCIAL DYNAMICS-A JOURNAL OF AFRICAN STUDIES": 0.667,
  "JOURNAL OF WORLD ENERGY LAW & BUSINESS": 0.667,
  "SOLID FUEL CHEMISTRY": 0.667,
  "VOPROSY PSIKHOLOGII": 0.667,
  "PSYCHOANALYTIC DIALOGUES": 0.667,
  "FEDERAL RESERVE BANK OF ST LOUIS REVIEW": 0.666,
  "INTERNATIONAL JOURNAL OF RADIATION RESEARCH": 0.664,
  "JOURNAL OF LIE THEORY": 0.664,
  "NARRATIVE INQUIRY": 0.663,
  "OCEAN SCIENCE JOURNAL": 0.663,
  "GEOMETRIAE DEDICATA": 0.662,
  "JOURNAL OF COMPUTER AND SYSTEMS SCIENCES INTERNATIONAL": 0.662,
  "JOURNAL OF ENTOMOLOGICAL SCIENCE": 0.662,
  "JOURNAL OF PSYCHOLOGY IN AFRICA": 0.662,
  "PRAXIS DER KINDERPSYCHOLOGIE UND KINDERPSYCHIATRIE": 0.662,
  "TURKISH JOURNAL OF VETERINARY & ANIMAL SCIENCES": 0.662,
  "AMERICAN CRIMINAL LAW REVIEW": 0.662,
  "BRAZILIAN JOURNAL OF PHARMACEUTICAL SCIENCES": 0.662,
  "JOURNAL OF PALESTINE STUDIES": 0.661,
  "ETHIK IN DER MEDIZIN": 0.661,
  "GASTROENTEROLOGY NURSING": 0.661,
  "INDIAN JOURNAL OF FIBRE & TEXTILE RESEARCH": 0.661,
  "INTERNATIONAL JOURNAL OF AERONAUTICAL AND SPACE SCIENCES": 0.66,
  "POWDER DIFFRACTION": 0.659,
  "JOURNAL OF COMMUNICATIONS TECHNOLOGY AND ELECTRONICS": 0.659,
  "LMS JOURNAL OF COMPUTATION AND MATHEMATICS": 0.659,
  "PHARMACEUTICAL CHEMISTRY JOURNAL": 0.658,
  "PROCEEDINGS OF THE ESTONIAN ACADEMY OF SCIENCES": 0.658,
  "REVISTA DE PSICOLOGIA SOCIAL": 0.657,
  "SCIENCE AND TECHNOLOGY OF ENERGETIC MATERIALS": 0.657,
  "ASIAN PERSPECTIVE": 0.657,
  "CEREAL FOODS WORLD": 0.656,
  "INDIAN JOURNAL OF CHEMISTRY SECTION B-ORGANIC CHEMISTRY INCLUDING MEDICINAL CHEMISTRY": 0.656,
  "JOURNAL OF LOGIC AND COMPUTATION": 0.656,
  "SEMIOTICA": 0.656,
  "ZEITSCHRIFT DER DEUTSCHEN GESELLSCHAFT FUR GEOWISSENSCHAFTEN": 0.655,
  "JOURNAL OF ADVANCED MECHANICAL DESIGN SYSTEMS AND MANUFACTURING": 0.655,
  "RUSSIAN JOURNAL OF APPLIED CHEMISTRY": 0.654,
  "SEED SCIENCE AND TECHNOLOGY": 0.654,
  "AMERICAN SCIENTIST": 0.653,
  "TURK PSIKIYATRI DERGISI": 0.653,
  "ARCHIVOS ARGENTINOS DE PEDIATRIA": 0.653,
  "AUSTRALIAN ECONOMIC REVIEW": 0.653,
  "INTERNATIONAL JOURNAL OF MUSIC EDUCATION": 0.653,
  "PORTA LINGUARUM": 0.652,
  "GERIATRIE ET PSYCHOLOGIE NEUROPSYCHIATRIE DE VIEILLISSEMENT": 0.652,
  "INDUSTRIA TEXTILA": 0.652,
  "JOURNAL OF WATER CHEMISTRY AND TECHNOLOGY": 0.652,
  "OPEN LIFE SCIENCES": 0.652,
  "SOCIOBIOLOGY": 0.652,
  "ANNALES DE BIOLOGIE CLINIQUE": 0.652,
  "REVUE SCIENTIFIQUE ET TECHNIQUE-OFFICE INTERNATIONAL DES EPIZOOTIES": 0.651,
  "SCIENTIA FORESTALIS": 0.651,
  "COMMUNICATIONS IN ALGEBRA": 0.651,
  "AT-AUTOMATISIERUNGSTECHNIK": 0.651,
  "AUSTRALIAN ECONOMIC HISTORY REVIEW": 0.651,
  "ANNALES POLONICI MATHEMATICI": 0.65,
  "BOSQUE": 0.65,
  "BULLETIN OF THE BRAZILIAN MATHEMATICAL SOCIETY": 0.65,
  "BALTICA": 0.65,
  "BOLETIN LATINOAMERICANO Y DEL CARIBE DE PLANTAS MEDICINALES Y AROMATICAS": 0.65,
  "BRITISH JOURNAL OF LEARNING DISABILITIES": 0.65,
  "COMPTABILITE CONTROLE AUDIT": 0.65,
  "DEVELOPING ECONOMIES": 0.65,
  "DYNAMIC SYSTEMS AND APPLICATIONS": 0.649,
  "ENTOMOLOGICA AMERICANA": 0.649,
  "FORUM-A JOURNAL OF APPLIED RESEARCH IN CONTEMPORARY POLITICS": 0.648,
  "HISTORIA MATHEMATICA": 0.647,
  "HISTORY OF PSYCHIATRY": 0.647,
  "ICGA JOURNAL": 0.647,
  "INTERNATIONAL JOURNAL OF POWDER METALLURGY": 0.647,
  "IMAGO MUNDI-THE INTERNATIONAL JOURNAL FOR THE HISTORY OF CARTOGRAPHY": 0.647,
  "INTERNATIONAL JOURNAL OF AEROSPACE PSYCHOLOGY": 0.647,
  "JOURNAL OF THE HISTORY OF THE BEHAVIORAL SCIENCES": 0.646,
  "JOURNAL OF AUSTRALIAN STUDIES": 0.646,
  "JOURNAL OF LOGIC LANGUAGE AND INFORMATION": 0.646,
  "KYOTO JOURNAL OF MATHEMATICS": 0.645,
  "LINGUISTIC TYPOLOGY": 0.645,
  "MECHANIKA": 0.644,
  "MODERN CHINESE LITERATURE AND CULTURE": 0.644,
  "ODONATOLOGICA": 0.644,
  "POLITICAL SCIENCE": 0.644,
  "POLYMER-KOREA": 0.644,
  "PHILIPPINE POLITICAL SCIENCE JOURNAL": 0.644,
  "PORTUGALIAE MATHEMATICA": 0.644,
  "PORTUGUESE ECONOMIC JOURNAL": 0.644,
  "SCIENCE IN CONTEXT": 0.644,
  "SEQUENTIAL ANALYSIS-DESIGN METHODS AND APPLICATIONS": 0.644,
  "SINTAGMA": 0.644,
  "JOURNAL OF MEDICAL IMAGING AND HEALTH INFORMATICS": 0.644,
  "ARCHIV DER MATHEMATIK": 0.643,
  "RUSSIAN JOURNAL OF ECOLOGY": 0.643,
  "RUSSIAN JOURNAL OF NON-FERROUS METALS": 0.643,
  "JOURNAL OF THE MATHEMATICAL SOCIETY OF JAPAN": 0.643,
  "IRANIAN JOURNAL OF FISHERIES SCIENCES": 0.642,
  "SINGAPORE ECONOMIC REVIEW": 0.642,
  "SUGAR INDUSTRY-ZUCKERINDUSTRIE": 0.642,
  "GRADEVINAR": 0.642,
  "KINEMATICS AND PHYSICS OF CELESTIAL BODIES": 0.642,
  "RUSSIAN JOURNAL OF MARINE BIOLOGY": 0.641,
  "SCIENTIST": 0.641,
  "HERALD OF THE RUSSIAN ACADEMY OF SCIENCES": 0.641,
  "PACIFIC ECONOMIC REVIEW": 0.641,
  "EXPOSITIONES MATHEMATICAE": 0.641,
  "ACTES DE LA RECHERCHE EN SCIENCES SOCIALES": 0.641,
  "COMMUNICATIONS IN STATISTICS-SIMULATION AND COMPUTATION": 0.641,
  "MATHEMATICA SLOVACA": 0.641,
  "CANADIAN JOURNAL OF POLITICAL SCIENCE-REVUE CANADIENNE DE SCIENCE POLITIQUE": 0.64,
  "JOURNAL OF FRICTION AND WEAR": 0.64,
  "LEXIKOS": 0.639,
  "PRAGMATICS AND SOCIETY": 0.639,
  "CARPATHIAN JOURNAL OF MATHEMATICS": 0.638,
  "ECO MONT-JOURNAL ON PROTECTED MOUNTAIN AREAS RESEARCH": 0.638,
  "GRAPHS AND COMBINATORICS": 0.638,
  "HOKKAIDO MATHEMATICAL JOURNAL": 0.638,
  "INSTRUMENTS AND EXPERIMENTAL TECHNIQUES": 0.638,
  "JOURNAL FOR THE HISTORY OF ASTRONOMY": 0.638,
  "NORTHEASTERN NATURALIST": 0.638,
  "ACTA ENTOMOLOGICA MUSEI NATIONALIS PRAGAE": 0.637,
  "NOISE CONTROL ENGINEERING JOURNAL": 0.637,
  "ACTA VETERINARIA BRNO": 0.636,
  "COMPUTER MUSIC JOURNAL": 0.636,
  "CONTINUUM-JOURNAL OF MEDIA & CULTURAL STUDIES": 0.636,
  "INTEGRATED FERROELECTRICS": 0.636,
  "ANNALS OF SCIENCE": 0.636,
  "EUROPEAN POULTRY SCIENCE": 0.636,
  "HISTORICAL MATERIALISM-RESEARCH IN CRITICAL MARXIST THEORY": 0.636,
  "JOURNAL OF THE HISTORY OF SEXUALITY": 0.636,
  "REVISTA DE NEUROLOGIA": 0.636,
  "REVISTA MEDICA DE CHILE": 0.636,
  "ENGINEERING JOURNAL-AMERICAN INSTITUTE OF STEEL CONSTRUCTION": 0.636,
  "GEOSCIENCE CANADA": 0.636,
  "JARQ-JAPAN AGRICULTURAL RESEARCH QUARTERLY": 0.635,
  "RBGN-REVISTA BRASILEIRA DE GESTAO DE NEGOCIOS": 0.635,
  "REVISTA DE NUTRICAO-BRAZILIAN JOURNAL OF NUTRITION": 0.635,
  "BULLETIN OF THE EUROPEAN ASSOCIATION OF FISH PATHOLOGISTS": 0.635,
  "EUROPEAN SURGERY-ACTA CHIRURGICA AUSTRIACA": 0.635,
  "INDIAN JOURNAL OF CHEMISTRY SECTION A-INORGANIC BIO-INORGANIC PHYSICAL THEORETICAL & ANALYTICAL CHEMISTRY": 0.634,
  "JOURNAL OF KOREAN ACADEMY OF NURSING": 0.634,
  "JOURNAL OF MODERN EUROPEAN HISTORY": 0.634,
  "HISTORY OF EDUCATION": 0.634,
  "CENTRAL EUROPEAN HISTORY": 0.634,
  "MATERIALS EVALUATION": 0.634,
  "MAEJO INTERNATIONAL JOURNAL OF SCIENCE AND TECHNOLOGY": 0.633,
  "ROCKY MOUNTAIN JOURNAL OF MATHEMATICS": 0.633,
  "BOLLETTINO DI GEOFISICA TEORICA ED APPLICATA": 0.632,
  "CANADIAN STUDIES IN POPULATION": 0.632,
  "DEUTSCHE ENTOMOLOGISCHE ZEITSCHRIFT": 0.632,
  "HIGH ABILITY STUDIES": 0.632,
  "ROMANIAN JOURNAL OF LEGAL MEDICINE": 0.632,
  "IRANIAN JOURNAL OF RADIOLOGY": 0.631,
  "UNIVERSITY POLITEHNICA OF BUCHAREST SCIENTIFIC BULLETIN-SERIES A-APPLIED MATHEMATICS AND PHYSICS": 0.631,
  "CEMENT WAPNO BETON": 0.63,
  "PSYCHIATRY AND CLINICAL PSYCHOPHARMACOLOGY": 0.63,
  "JOURNAL OF THE BELGIAN SOCIETY OF RADIOLOGY": 0.63,
  "ACADEMIA-REVISTA LATINOAMERICANA DE ADMINISTRACION": 0.63,
  "INTERNATIONAL JOURNAL OF SPEECH LANGUAGE AND THE LAW": 0.63,
  "JOURNAL OF ENGINEERED FIBERS AND FABRICS": 0.629,
  "ASIAN JOURNAL OF SOCIAL SCIENCE": 0.629,
  "INTERNATIONAL JOURNAL OF DEVELOPMENTAL DISABILITIES": 0.628,
  "JOURNAL OF SHIP PRODUCTION AND DESIGN": 0.628,
  "JOURNAL OF TOPOLOGY AND ANALYSIS": 0.628,
  "REVUE DE STOMATOLOGIE DE CHIRURGIE MAXILLO-FACIALE ET DE CHIRURGIE ORALE": 0.627,
  "SPANISH IN CONTEXT": 0.627,
  "GLASGOW MATHEMATICAL JOURNAL": 0.627,
  "ISRAEL JOURNAL OF PSYCHIATRY AND RELATED SCIENCES": 0.627,
  "INLAND WATER BIOLOGY": 0.627,
  "SOCIOLOGIA": 0.626,
  "JOURNAL OF GROUP THEORY": 0.626,
  "STAT": 0.625,
  "ENGLISH IN EDUCATION": 0.625,
  "ROMANIAN AGRICULTURAL RESEARCH": 0.625,
  "MISKOLC MATHEMATICAL NOTES": 0.625,
  "REVISTA DE LA CONSTRUCCION": 0.625,
  "SENSORS AND MATERIALS": 0.625,
  "AUSTRALIAN JOURNAL OF ADULT LEARNING": 0.625,
  "ECONOMICS OF GOVERNANCE": 0.625,
  "JUVENILE AND FAMILY COURT JOURNAL": 0.625,
  "JOURNAL OF THE SOUTHERN AFRICAN INSTITUTE OF MINING AND METALLURGY": 0.625,
  "STUDIA LOGICA": 0.625,
  "TAPPI JOURNAL": 0.625,
  "CHEMICAL ENGINEERING PROGRESS": 0.625,
  "RELATIONS INDUSTRIELLES-INDUSTRIAL RELATIONS": 0.625,
  "INDIAN JOURNAL OF GENETICS AND PLANT BREEDING": 0.624,
  "SEMINARS IN ORTHODONTICS": 0.624,
  "CIVIL ENGINEERING": 0.624,
  "THEOLOGY AND SCIENCE": 0.623,
  "FOLIA LINGUISTICA": 0.623,
  "JAAPA-JOURNAL OF THE AMERICAN ACADEMY OF PHYSICIAN ASSISTANTS": 0.623,
  "JOURNAL OF DERIVATIVES": 0.622,
  "LINGUISTIC REVIEW": 0.622,
  "NOTORNIS": 0.622,
  "JOURNAL OF MIDDLE EAST WOMENS STUDIES": 0.622,
  "REVUE FRANCAISE DE SOCIOLOGIE": 0.621,
  "IRANIAN JOURNAL OF CHEMISTRY & CHEMICAL ENGINEERING-INTERNATIONAL ENGLISH EDITION": 0.621,
  "INTERVENTIONS-INTERNATIONAL JOURNAL OF POSTCOLONIAL STUDIES": 0.621,
  "JOURNAL OF KNOT THEORY AND ITS RAMIFICATIONS": 0.62,
  "GENETIKA-BELGRADE": 0.619,
  "LIBRARY RESOURCES & TECHNICAL SERVICES": 0.619,
  "ANNALS OF CARNEGIE MUSEUM": 0.619,
  "ASIAN ECONOMIC POLICY REVIEW": 0.619,
  "CALDASIA": 0.619,
  "PHYSICS OF ATOMIC NUCLEI": 0.619,
  "RADIOPROTECTION": 0.618,
  "SWISS JOURNAL OF PSYCHOLOGY": 0.618,
  "ACTA CHIRURGIAE ORTHOPAEDICAE ET TRAUMATOLOGIAE CECHOSLOVACA": 0.618,
  "CAHIERS DE BIOLOGIE MARINE": 0.618,
  "AMERICAN JOURNAL OF ECONOMICS AND SOCIOLOGY": 0.618,
  "CONTEMPORARY SOCIOLOGY-A JOURNAL OF REVIEWS": 0.617,
  "ERNAHRUNGS UMSCHAU": 0.617,
  "GAYANA": 0.617,
  "JOURNAL OF MATERIALS EDUCATION": 0.616,
  "REVISTA DE BIOLOGIA MARINA Y OCEANOGRAFIA": 0.616,
  "SAUDE E SOCIEDADE": 0.615,
  "DEVELOPMENT SOUTHERN AFRICA": 0.615,
  "ISOKINETICS AND EXERCISE SCIENCE": 0.615,
  "METALLURGIA ITALIANA": 0.615,
  "OPTOELECTRONICS AND ADVANCED MATERIALS-RAPID COMMUNICATIONS": 0.615,
  "SCIENCEASIA": 0.615,
  "SALUD COLECTIVA": 0.615,
  "CURRENT HERPETOLOGY": 0.614,
  "EARLY SCIENCE AND MEDICINE": 0.614,
  "INTERNATIONAL JOURNAL OF HEAVY VEHICLE SYSTEMS": 0.614,
  "STRATIGRAPHY": 0.614,
  "ACTA ENDOCRINOLOGICA-BUCHAREST": 0.614,
  "SCOTTISH JOURNAL OF POLITICAL ECONOMY": 0.614,
  "ACM TRANSACTIONS ON COMPUTATIONAL LOGIC": 0.614,
  "FOOD SCIENCE AND TECHNOLOGY RESEARCH": 0.614,
  "INTERNATIONAL FINANCE": 0.614,
  "JOURNAL OF FIBER SCIENCE AND TECHNOLOGY": 0.613,
  "STUDIES IN NONLINEAR DYNAMICS AND ECONOMETRICS": 0.613,
  "ACTA POLONIAE PHARMACEUTICA": 0.613,
  "INFANTS & YOUNG CHILDREN": 0.613,
  "INTERNATIONAL JOURNAL OF WEB SERVICES RESEARCH": 0.612,
  "JOURNAL OF SOUTHEAST ASIAN STUDIES": 0.612,
  "JOURNAL OF THE GILDED AGE AND PROGRESSIVE ERA": 0.612,
  "PROCEEDINGS OF THE BIOLOGICAL SOCIETY OF WASHINGTON": 0.611,
  "CONTEMPORARY PROBLEMS OF ECOLOGY": 0.611,
  "MIKROBIYOLOJI BULTENI": 0.611,
  "INTERNATIONAL JOURNAL OF MATHEMATICS": 0.611,
  "BRITISH JOURNAL OF MUSIC EDUCATION": 0.611,
  "INTERNATIONAL JOURNAL OF PSYCHOANALYSIS": 0.611,
  "LANGUAGE PROBLEMS & LANGUAGE PLANNING": 0.611,
  "REFERENCE & USER SERVICES QUARTERLY": 0.61,
  "SOCIETY": 0.61,
  "ACTA SCIENTIARUM POLONORUM-HORTORUM CULTUS": 0.61,
  "OSTRICH": 0.61,
  "QUATERNAIRE": 0.61,
  "REVISTA IBEROAMERICANA DE DIAGNOSTICO Y EVALUACION-E AVALIACAO PSICOLOGICA": 0.61,
  "CANADIAN MODERN LANGUAGE REVIEW-REVUE CANADIENNE DES LANGUES VIVANTES": 0.609,
  "FEMINIST STUDIES": 0.609,
  "SOCIAL RESEARCH": 0.609,
  "SPIXIANA": 0.609,
  "LITHOLOGY AND MINERAL RESOURCES": 0.609,
  "PSYCHOTHERAPEUT": 0.609,
  "PRAEHISTORISCHE ZEITSCHRIFT": 0.608,
  "TROPICAL GRASSLANDS-FORRAJES TROPICALES": 0.608,
  "ENGLISH IN AUSTRALIA": 0.608,
  "EUROPEAN JOURNAL OF THE HISTORY OF ECONOMIC THOUGHT": 0.607,
  "AUSTRIAN JOURNAL OF EARTH SCIENCES": 0.607,
  "TROPICAL JOURNAL OF PHARMACEUTICAL RESEARCH": 0.607,
  "BERLINER UND MUNCHENER TIERARZTLICHE WOCHENSCHRIFT": 0.607,
  "LIBRARY JOURNAL": 0.606,
  "INDIAN JOURNAL OF ANIMAL RESEARCH": 0.606,
  "CLINICAL SOCIAL WORK JOURNAL": 0.605,
  "DYNAMIS": 0.605,
  "FUNCTIONS OF LANGUAGE": 0.605,
  "PROBUS": 0.605,
  "PSYCHOANALYSIS AND HISTORY": 0.605,
  "SOULS": 0.605,
  "JOURNAL OF THE MEXICAN CHEMICAL SOCIETY": 0.604,
  "SPECTROSCOPY AND SPECTRAL ANALYSIS": 0.604,
  "ASIAN JOURNAL OF WTO & INTERNATIONAL HEALTH LAW AND POLICY": 0.603,
  "JOURNAL OF ASIAN AND AFRICAN STUDIES": 0.603,
  "STATISTICA NEERLANDICA": 0.603,
  "ASIA PACIFIC JOURNAL OF ANTHROPOLOGY": 0.603,
  "KYUSHU JOURNAL OF MATHEMATICS": 0.603,
  "LOGICAL METHODS IN COMPUTER SCIENCE": 0.603,
  "MATHEMATICA SCANDINAVICA": 0.603,
  "HIGH TEMPERATURES-HIGH PRESSURES": 0.602,
  "JOURNAL OF BRITISH STUDIES": 0.602,
  "NEXUS NETWORK JOURNAL": 0.602,
  "INTERNATIONAL JOURNAL OF GROUP PSYCHOTHERAPY": 0.602,
  "MANCHESTER SCHOOL": 0.6,
  "NIGERIAN JOURNAL OF CLINICAL PRACTICE": 0.6,
  "OPERATIVE TECHNIQUES IN SPORTS MEDICINE": 0.6,
  "PACIFIC JOURNAL OF OPTIMIZATION": 0.6,
  "AFRICAN JOURNAL OF HERPETOLOGY": 0.6,
  "ANUARIO DE PSICOLOGIA JURIDICA": 0.6,
  "ASIAN MYRMECOLOGY": 0.6,
  "ASIAN-PACIFIC ECONOMIC LITERATURE": 0.6,
  "ASSISTENZA INFERMIERISTICA E RICERCA": 0.6,
  "GENDER AND LANGUAGE": 0.6,
  "INDIAN JOURNAL OF CANCER": 0.6,
  "IBERICA": 0.6,
  "JUSTICE SYSTEM JOURNAL": 0.6,
  "MARKOV PROCESSES AND RELATED FIELDS": 0.6,
  "NEW ZEALAND ENTOMOLOGIST": 0.6,
  "SOUTH AFRICAN JOURNAL OF BUSINESS MANAGEMENT": 0.6,
  "SURVEY METHODOLOGY": 0.6,
  "PRZEMYSL CHEMICZNY": 0.6,
  "REVISTA CHILENA DE INFECTOLOGIA": 0.599,
  "BULLETIN OF ECONOMIC RESEARCH": 0.599,
  "HIGH TEMPERATURE MATERIALS AND PROCESSES": 0.598,
  "INTERNIST": 0.598,
  "JOURNAL OF HYPERBOLIC DIFFERENTIAL EQUATIONS": 0.598,
  "MAMMAL STUDY": 0.598,
  "TOPICS IN COMPANION ANIMAL MEDICINE": 0.597,
  "VETERINARSKI ARHIV": 0.597,
  "GOSPODARKA SUROWCAMI MINERALNYMI-MINERAL RESOURCES MANAGEMENT": 0.596,
  "INDIAN JOURNAL OF PHARMACEUTICAL EDUCATION AND RESEARCH": 0.596,
  "INTERNATIONAL JOURNAL OF SPORT FINANCE": 0.596,
  "PUBLICATIONS OF THE RESEARCH INSTITUTE FOR MATHEMATICAL SCIENCES": 0.596,
  "AMERICAS": 0.595,
  "COMMUNICATIONS IN STATISTICS-THEORY AND METHODS": 0.595,
  "CZECHOSLOVAK MATHEMATICAL JOURNAL": 0.595,
  "CHEMIJA": 0.595,
  "JOURNAL OF MATHEMATICAL PHYSICS ANALYSIS GEOMETRY": 0.595,
  "JOURNAL OF PSYCHOLOGISTS AND COUNSELLORS IN SCHOOLS": 0.594,
  "LC GC NORTH AMERICA": 0.594,
  "ORDER-A JOURNAL ON THE THEORY OF ORDERED SETS AND ITS APPLICATIONS": 0.594,
  "AUSTRALIAN AND NEW ZEALAND JOURNAL OF FAMILY THERAPY": 0.594,
  "AUSTRIAN HISTORY YEARBOOK": 0.593,
  "JAPANESE ECONOMIC REVIEW": 0.593,
  "KEDI JOURNAL OF EDUCATIONAL POLICY": 0.593,
  "TETSU TO HAGANE-JOURNAL OF THE IRON AND STEEL INSTITUTE OF JAPAN": 0.592,
  "ACTA ZOOLOGICA ACADEMIAE SCIENTIARUM HUNGARICAE": 0.592,
  "ANALES DEL JARDIN BOTANICO DE MADRID": 0.591,
  "COMPUTING AND INFORMATICS": 0.591,
  "PSYCHOANALYTIC STUDY OF THE CHILD": 0.591,
  "REVUE D ECOLOGIE-LA TERRE ET LA VIE": 0.591,
  "SUMARSKI LIST": 0.59,
  "BULLETIN OF THE BELGIAN MATHEMATICAL SOCIETY-SIMON STEVIN": 0.59,
  "IHERINGIA SERIE ZOOLOGIA": 0.59,
  "JOURNAL OF INSTITUTIONAL AND THEORETICAL ECONOMICS-ZEITSCHRIFT FUR DIE GESAMTE STAATSWISSENSCHAFT": 0.59,
  "WESTERN NORTH AMERICAN NATURALIST": 0.59,
  "BERLINER JOURNAL FUR SOZIOLOGIE": 0.59,
  "CHINESE ANNALS OF MATHEMATICS SERIES B": 0.59,
  "CONTRIBUTIONS TO DISCRETE MATHEMATICS": 0.59,
  "INTERNATIONAL JOURNAL OF ALGEBRA AND COMPUTATION": 0.589,
  "JOURNAL OF THE NATIONAL SCIENCE FOUNDATION OF SRI LANKA": 0.589,
  "PHILOSOPHIA MATHEMATICA": 0.589,
  "REVISTA ARGENTINA DE CLINICA PSICOLOGICA": 0.589,
  "DIGITAL SCHOLARSHIP IN THE HUMANITIES": 0.589,
  "MECHANICS OF SOLIDS": 0.589,
  "TROPICAL BIOMEDICINE": 0.589,
  "ACUPUNCTURE & ELECTRO-THERAPEUTICS RESEARCH": 0.588,
  "CRYPTOLOGIA": 0.588,
  "HISTORICAL STUDIES IN THE NATURAL SCIENCES": 0.588,
  "INTERNATIONAL REVIEW OF SOCIAL HISTORY": 0.588,
  "JOURNAL OF MEDIA ECONOMICS": 0.588,
  "JOURNAL OF ASIAN ARCHITECTURE AND BUILDING ENGINEERING": 0.588,
  "ACTA ARITHMETICA": 0.588,
  "TOPOLOGY AND ITS APPLICATIONS": 0.587,
  "ANNALES DE PATHOLOGIE": 0.587,
  "EUROPEAN HISTORY QUARTERLY": 0.586,
  "INTERNASJONAL POLITIKK": 0.586,
  "TIERARZTLICHE PRAXIS": 0.586,
  "JOURNAL OF CREDIT RISK": 0.585,
  "OSAKA JOURNAL OF MATHEMATICS": 0.585,
  "AMERICAN SPEECH": 0.585,
  "RADIOLOGE": 0.585,
  "INTERNATIONAL LABOR AND WORKING-CLASS HISTORY": 0.585,
  "SLOVO A SLOVESNOST": 0.585,
  "JOURNAL OF TROPICAL METEOROLOGY": 0.585,
  "KAFKAS UNIVERSITESI VETERINER FAKULTESI DERGISI": 0.584,
  "INTERNATIONAL ARAB JOURNAL OF INFORMATION TECHNOLOGY": 0.584,
  "JOURNAL OF HEMATOPATHOLOGY": 0.584,
  "ABHANDLUNGEN AUS DEM MATHEMATISCHEN SEMINAR DER UNIVERSITAT HAMBURG": 0.584,
  "JOURNAL OF POLYMER MATERIALS": 0.583,
  "CYTOLOGY AND GENETICS": 0.583,
  "JCPSP-JOURNAL OF THE COLLEGE OF PHYSICIANS AND SURGEONS PAKISTAN": 0.583,
  "JOURNAL OF COMMUTATIVE ALGEBRA": 0.582,
  "JOURNAL OF SEMICONDUCTOR TECHNOLOGY AND SCIENCE": 0.582,
  "REVUE FRANCAISE DE LINGUISTIQUE APPLIQUEE": 0.581,
  "LANDBAUFORSCHUNG": 0.581,
  "AUSTRALIAN JOURNAL OF POLITICS AND HISTORY": 0.581,
  "CULTURAL STUDIES REVIEW": 0.581,
  "REVIEW OF COGNITIVE LINGUISTICS": 0.581,
  "JOURNAL OF REHABILITATION": 0.581,
  "JOURNAL OF BELIEFS & VALUES-STUDIES IN RELIGION & EDUCATION": 0.58,
  "JOURNAL OF THE SOUTH AFRICAN INSTITUTION OF CIVIL ENGINEERING": 0.58,
  "SOUTHEASTERN NATURALIST": 0.579,
  "STAHLBAU": 0.579,
  "ACTA CLINICA CROATICA": 0.579,
  "AUTOMATIKA": 0.579,
  "FILOSOFIJA-SOCIOLOGIJA": 0.579,
  "NOVON": 0.579,
  "PAEDAGOGICA HISTORICA": 0.578,
  "ASIA PACIFIC LAW REVIEW": 0.578,
  "AUSTRALIAN ABORIGINAL STUDIES": 0.578,
  "CT&F-CIENCIA TECNOLOGIA Y FUTURO": 0.578,
  "JOURNAL OF NEW MATERIALS FOR ELECTROCHEMICAL SYSTEMS": 0.578,
  "JOURNAL OF GERMANIC LINGUISTICS": 0.578,
  "MICROPALEONTOLOGY": 0.577,
  "MITTEILUNGEN DER OSTERREICHISCHEN GEOGRAPHISCHEN GESELLSCHAFT": 0.577,
  "ROMANI STUDIES": 0.577,
  "SOUTH AFRICAN JOURNAL OF PSYCHIATRY": 0.577,
  "TEXT & TALK": 0.577,
  "HEAT TRANSFER RESEARCH": 0.577,
  "PRAKTISCHE METALLOGRAPHIE-PRACTICAL METALLOGRAPHY": 0.577,
  "EPIDEMIOLOGIE MIKROBIOLOGIE IMUNOLOGIE": 0.577,
  "GERMAN STUDIES REVIEW": 0.577,
  "INTERNATIONAL JOURNAL OF MARITIME ENGINEERING": 0.576,
  "JOURNAL OF HOMOTOPY AND RELATED STRUCTURES": 0.576,
  "SCHWEIZER ARCHIV FUR TIERHEILKUNDE": 0.576,
  "INTER-ASIA CULTURAL STUDIES": 0.576,
  "JOURNAL OF KOREA TRADE": 0.576,
  "REVUE ROUMAINE DE CHIMIE": 0.574,
  "ALGEBRA COLLOQUIUM": 0.574,
  "RESTAURATOR-INTERNATIONAL JOURNAL FOR THE PRESERVATION OF LIBRARY AND ARCHIVAL MATERIAL": 0.573,
  "JOURNAL OF THE CHEMICAL SOCIETY OF PAKISTAN": 0.573,
  "MEDICINA DELLO SPORT": 0.573,
  "MALAYSIAN JOURNAL OF PATHOLOGY": 0.572,
  "PUERTO RICO HEALTH SCIENCES JOURNAL": 0.571,
  "REVUE DE PNEUMOLOGIE CLINIQUE": 0.571,
  "ARCHIVOS DE MEDICINA VETERINARIA": 0.571,
  "EASTERN EUROPEAN COUNTRYSIDE": 0.571,
  "JOURNAL OF CONTEMPORARY MATHEMATICAL ANALYSIS-ARMENIAN ACADEMY OF SCIENCES": 0.571,
  "AUSTRALIAN FEMINIST STUDIES": 0.571,
  "BABEL-REVUE INTERNATIONALE DE LA TRADUCTION-INTERNATIONAL JOURNAL OF TRANSLATION": 0.571,
  "CUSTOS E AGRONEGOCIO ON LINE": 0.571,
  "JOKULL": 0.571,
  "JOURNAL OF LABORATORY MEDICINE": 0.571,
  "PAN-PACIFIC ENTOMOLOGIST": 0.571,
  "BOLETIN DE LA SOCIEDAD ARGENTINA DE BOTANICA": 0.57,
  "CANADIAN HISTORICAL REVIEW": 0.57,
  "JOURNAL OF CERAMIC PROCESSING RESEARCH": 0.569,
  "JOURNAL OF INFRARED AND MILLIMETER WAVES": 0.569,
  "RHODORA": 0.568,
  "BUNSEKI KAGAKU": 0.568,
  "GAYANA BOTANICA": 0.568,
  "EGYPTIAN JOURNAL OF BIOLOGICAL PEST CONTROL": 0.568,
  "JOURNAL OF MATHEMATICS AND MUSIC": 0.568,
  "POWDER METALLURGY AND METAL CERAMICS": 0.567,
  "RARE METAL MATERIALS AND ENGINEERING": 0.567,
  "BIOLOGY BULLETIN": 0.567,
  "METAL SCIENCE AND HEAT TREATMENT": 0.566,
  "INTERNATIONAL JOURNAL OF HEALTH  ECONOMICS AND MANAGEMENT": 0.566,
  "PACIFIC FOCUS": 0.566,
  "BOUNDARY 2-AN INTERNATIONAL JOURNAL OF LITERATURE AND CULTURE": 0.566,
  "JOURNAL OF MODERN ITALIAN STUDIES": 0.566,
  "KARDIOLOGIYA": 0.565,
  "SOUTHERN AFRICAN LINGUISTICS AND APPLIED LANGUAGE STUDIES": 0.565,
  "SOIL MECHANICS AND FOUNDATION ENGINEERING": 0.564,
  "ARCHIVOS LATINOAMERICANOS DE NUTRICION": 0.564,
  "BIOSCIENCE JOURNAL": 0.564,
  "HISTORIOGRAPHIA LINGUISTICA": 0.563,
  "PHYSICS IN PERSPECTIVE": 0.563,
  "RUSSIAN JOURNAL OF THERIOLOGY": 0.563,
  "TRANSINFORMACAO": 0.563,
  "PSYCHOANALYTIC INQUIRY": 0.562,
  "REVISTA INTERNACIONAL DE METODOS NUMERICOS PARA CALCULO Y DISENO EN INGENIERIA": 0.561,
  "AGROCIENCIA": 0.561,
  "ANTHROPOLOGIE": 0.561,
  "REVISTA DE ESTUDIOS POLITICOS": 0.561,
  "SEMINA-CIENCIAS AGRARIAS": 0.56,
  "INTERNATIONAL JOURNAL OF MORPHOLOGY": 0.56,
  "IEICE TRANSACTIONS ON FUNDAMENTALS OF ELECTRONICS COMMUNICATIONS AND COMPUTER SCIENCES": 0.56,
  "PHI DELTA KAPPAN": 0.559,
  "AUSTRIAN JOURNAL OF POLITICAL SCIENCE": 0.559,
  "BERICHTE UBER LANDWIRTSCHAFT": 0.559,
  "REVISTA ARVORE": 0.559,
  "CHEMIE IN UNSERER ZEIT": 0.559,
  "INTERNATIONAL REVIEW OF THE RED CROSS": 0.558,
  "FORSCHUNG IM INGENIEURWESEN-ENGINEERING RESEARCH": 0.558,
  "PERFILES LATINOAMERICANOS": 0.558,
  "REVSTAT-STATISTICAL JOURNAL": 0.558,
  "AATCC REVIEW": 0.558,
  "JOURNAL OF PALLIATIVE CARE": 0.557,
  "PHYLLOMEDUSA": 0.557,
  "REVUE D HISTOIRE DES MATHEMATIQUES": 0.557,
  "RURAL HISTORY-ECONOMY SOCIETY CULTURE": 0.556,
  "BULLETIN OF THE KOREAN MATHEMATICAL SOCIETY": 0.556,
  "POLITISCHE VIERTELJAHRESSCHRIFT": 0.556,
  "ARCHIVES DE PEDIATRIE": 0.556,
  "VIE ET MILIEU-LIFE AND ENVIRONMENT": 0.556,
  "AMERICAN MATHEMATICAL MONTHLY": 0.556,
  "DADOS-REVISTA DE CIENCIAS SOCIAIS": 0.556,
  "INTERNATIONAL JOURNAL OF ARTS MANAGEMENT": 0.556,
  "JOURNAL OF EVIDENCE-BASED PSYCHOTHERAPIES": 0.556,
  "RENDICONTI DEL SEMINARIO MATEMATICO DELLA UNIVERSITA DI PADOVA": 0.555,
  "HONG KONG JOURNAL OF OCCUPATIONAL THERAPY": 0.555,
  "JOURNAL OF THE JAPAN INSTITUTE OF METALS": 0.554,
  "JOURNAL OF SOCIAL PHILOSOPHY": 0.554,
  "HISTORY AND PHILOSOPHY OF LOGIC": 0.554,
  "TERAPEVTICHESKII ARKHIV": 0.554,
  "EARTH SCIENCES RESEARCH JOURNAL": 0.554,
  "JOURNAL OF MINING SCIENCE": 0.554,
  "ACTA GEOTECHNICA SLOVENICA": 0.554,
  "FOOD HYGIENE AND SAFETY SCIENCE": 0.554,
  "INDIAN JOURNAL OF BIOCHEMISTRY & BIOPHYSICS": 0.553,
  "JOURNAL OF EMPLOYMENT COUNSELING": 0.553,
  "MAGALLANIA": 0.553,
  "ACTA SCIENTIARUM-TECHNOLOGY": 0.552,
  "BUFFALO LAW REVIEW": 0.552,
  "CHEMISTRY AND TECHNOLOGY OF FUELS AND OILS": 0.551,
  "INFORMACIJE MIDEM-JOURNAL OF MICROELECTRONICS ELECTRONIC COMPONENTS AND MATERIALS": 0.551,
  "JOURNAL OF LATIN AMERICAN CULTURAL STUDIES": 0.551,
  "CESKA A SLOVENSKA NEUROLOGIE A NEUROCHIRURGIE": 0.551,
  "DISCRETE MATHEMATICS AND THEORETICAL COMPUTER SCIENCE": 0.551,
  "JOURNAL OF CHINESE LINGUISTICS": 0.551,
  "AUSTRIAN JOURNAL OF FOREST SCIENCE": 0.55,
  "CIRUGIA Y CIRUJANOS": 0.55,
  "HISTORICAL SOCIAL RESEARCH-HISTORISCHE SOZIALFORSCHUNG": 0.549,
  "FINANZARCHIV": 0.549,
  "LANGUAGE & HISTORY": 0.549,
  "EUROPEAN JOURNAL OF ENGLISH STUDIES": 0.548,
  "JOURNAL OF EVOLUTIONARY BIOCHEMISTRY AND PHYSIOLOGY": 0.548,
  "JOURNAL OF SPANISH CULTURAL STUDIES": 0.548,
  "ESTUDIOS DE ECONOMIA": 0.547,
  "FUJITSU SCIENTIFIC & TECHNICAL JOURNAL": 0.547,
  "MICROWAVE JOURNAL": 0.547,
  "OPEN ASTRONOMY": 0.547,
  "SHILAP-REVISTA DE LEPIDOPTEROLOGIA": 0.546,
  "ASTRONOMY & GEOPHYSICS": 0.546,
  "JOURNAL OF VETERINARY DENTISTRY": 0.545,
  "SOUTH AFRICAN JOURNAL FOR RESEARCH IN SPORT PHYSICAL EDUCATION AND RECREATION": 0.545,
  "ZEITSCHRIFT FUR EVALUATION": 0.545,
  "ESA BULLETIN-EUROPEAN SPACE AGENCY": 0.545,
  "JOURNAL OF THE AUSTRALIAN LIBRARY AND INFORMATION ASSOCIATION": 0.545,
  "AFRICAN JOURNALISM STUDIES": 0.545,
  "ARGUMENTA OECONOMICA": 0.545,
  "POZNAN STUDIES IN CONTEMPORARY LINGUISTICS": 0.544,
  "AUSTRALIAN LIBRARY JOURNAL": 0.544,
  "HORTICULTURAL SCIENCE & TECHNOLOGY": 0.544,
  "ITEA-INFORMACION TECNICA ECONOMICA AGRARIA": 0.543,
  "AFRICAN JOURNAL OF LIBRARY ARCHIVES AND INFORMATION SCIENCE": 0.542,
  "CHILD WELFARE": 0.542,
  "LECTURE NOTES IN MATHEMATICS": 0.542,
  "UKRAINIAN MATHEMATICAL JOURNAL": 0.542,
  "BANGLADESH JOURNAL OF PLANT TAXONOMY": 0.542,
  "TRACE ELEMENTS AND ELECTROLYTES": 0.541,
  "ANNEE PSYCHOLOGIQUE": 0.541,
  "COMPUTATIONAL GEOMETRY-THEORY AND APPLICATIONS": 0.541,
  "INDIAN JOURNAL OF BIOTECHNOLOGY": 0.541,
  "AGRARFORSCHUNG SCHWEIZ": 0.54,
  "CHIANG MAI JOURNAL OF SCIENCE": 0.54,
  "PRESIDENTIAL STUDIES QUARTERLY": 0.54,
  "BULLETIN OF THE HISTORY OF MEDICINE": 0.54,
  "MATHEMATICAL REPORTS": 0.54,
  "POLITICKA EKONOMIE": 0.54,
  "BOIS ET FORETS DES TROPIQUES": 0.54,
  "BIOAGRO": 0.539,
  "CONVERGENCIA-REVISTA DE CIENCIAS SOCIALES": 0.539,
  "JOURNAL OF FAMILY HISTORY": 0.539,
  "LASERS IN ENGINEERING": 0.539,
  "HISTORIA CRITICA": 0.538,
  "JOURNAL OF URBAN HISTORY": 0.538,
  "ZHURNAL OBSHCHEI BIOLOGII": 0.537,
  "REVUE DE MEDECINE VETERINAIRE": 0.537,
  "INDIAN JOURNAL OF PURE & APPLIED MATHEMATICS": 0.537,
  "LEGUME RESEARCH": 0.537,
  "ARCHIVOS ESPANOLES DE UROLOGIA": 0.536,
  "ANZIAM JOURNAL": 0.536,
  "CESKOSLOVENSKA PSYCHOLOGIE": 0.536,
  "CURRENT PERSPECTIVES IN SOCIAL THEORY": 0.536,
  "HIMALAYAN GEOLOGY": 0.535,
  "HEROIN ADDICTION AND RELATED CLINICAL PROBLEMS": 0.535,
  "HISTORY OF GEO- AND SPACE SCIENCES": 0.534,
  "INTERNATIONAL JOURNAL OF ART & DESIGN EDUCATION": 0.533,
  "JOURNAL OF HISTOTECHNOLOGY": 0.533,
  "JOURNAL OF THE SOCIETY OF LEATHER TECHNOLOGISTS AND CHEMISTS": 0.533,
  "LANGUAGE AND LINGUISTICS": 0.533,
  "MOLECULAR GENETICS MICROBIOLOGY AND VIROLOGY": 0.533,
  "REVIJA ZA SOCIJALNU POLITIKU": 0.533,
  "NEW SCIENTIST": 0.533,
  "NATIONAL ACADEMY SCIENCE LETTERS-INDIA": 0.532,
  "UNIVERSITAS PSYCHOLOGICA": 0.532,
  "EMERGING MATERIALS RESEARCH": 0.532,
  "FIBRE CHEMISTRY": 0.532,
  "SOLDAGEM & INSPECAO": 0.532,
  "TURKISH JOURNAL OF BIOCHEMISTRY-TURK BIYOKIMYA DERGISI": 0.532,
  "SOUTH AFRICAN HISTORICAL JOURNAL": 0.531,
  "MATHEMATICAL LOGIC QUARTERLY": 0.531,
  "ACTA MATHEMATICAE APPLICATAE SINICA-ENGLISH SERIES": 0.531,
  "AGREKON": 0.531,
  "ITINERARIO-INTERNATIONAL JOURNAL ON THE HISTORY OF EUROPEAN EXPANSION AND GLOBAL INTERACTION": 0.531,
  "JOURNAL OF PSYCHOLOGY AND THEOLOGY": 0.531,
  "REVISTA FITOTECNIA MEXICANA": 0.531,
  "JOURNAL OF VIBRATION ENGINEERING & TECHNOLOGIES": 0.531,
  "KLINISCHE NEUROPHYSIOLOGIE": 0.529,
  "RUSSIAN JOURNAL OF HERPETOLOGY": 0.529,
  "CATHOLIC UNIVERSITY LAW REVIEW": 0.529,
  "BARIATRIC SURGICAL PRACTICE AND PATIENT CARE": 0.529,
  "COLUMBIA JOURNAL OF LAW AND SOCIAL PROBLEMS": 0.529,
  "TELOPEA": 0.528,
  "COMPTES RENDUS DE L ACADEMIE BULGARE DES SCIENCES": 0.528,
  "ENTOMOLOGICAL NEWS": 0.528,
  "KODAI MATHEMATICAL JOURNAL": 0.526,
  "REVISTA MEXICANA DE PSICOLOGIA": 0.526,
  "TIDSSKRIFT FOR SAMFUNNSFORSKNING": 0.526,
  "ALTERNATIVES": 0.526,
  "JAPANESE JOURNAL OF APPLIED ENTOMOLOGY AND ZOOLOGY": 0.525,
  "AYER": 0.525,
  "JOURNAL OF COSMETIC SCIENCE": 0.525,
  "PROCEEDINGS OF THE INDIAN ACADEMY OF SCIENCES-MATHEMATICAL SCIENCES": 0.525,
  "THAI JOURNAL OF VETERINARY MEDICINE": 0.525,
  "ENVIRONMENTAL ETHICS": 0.525,
  "AKTUELLE UROLOGIE": 0.525,
  "ARCHIVES OF NATURAL HISTORY": 0.525,
  "EUROPEAN REVIEW": 0.524,
  "TRANSLATION AND INTERPRETING STUDIES": 0.524,
  "PSYCHOLOGIST": 0.524,
  "JOURNAL OF RISK MODEL VALIDATION": 0.524,
  "QUEEN MARY JOURNAL OF INTELLECTUAL PROPERTY": 0.524,
  "BULLETIN OF THE IRANIAN MATHEMATICAL SOCIETY": 0.523,
  "MONATSSCHRIFT KINDERHEILKUNDE": 0.523,
  "CHEMICKE LISTY": 0.523,
  "CHINA-AN INTERNATIONAL JOURNAL": 0.523,
  "JOURNAL OF CONCHOLOGY": 0.522,
  "SERIALS REVIEW": 0.522,
  "TOKYO JOURNAL OF MATHEMATICS": 0.522,
  "INRA PRODUCTIONS ANIMALES": 0.522,
  "INVESTIGACION ECONOMICA": 0.521,
  "REVISTA DE EDUCACION": 0.521,
  "ANIMAL NUTRITION AND FEED TECHNOLOGY": 0.521,
  "JOURNAL OF AFRICAN MEDIA STUDIES": 0.52,
  "PROCEEDINGS OF THE JAPAN ACADEMY SERIES A-MATHEMATICAL SCIENCES": 0.52,
  "STUDIA SCIENTIARUM MATHEMATICARUM HUNGARICA": 0.52,
  "BULLETIN OF THE LEBEDEV PHYSICS INSTITUTE": 0.52,
  "JOURNAL OF VICTORIAN CULTURE": 0.52,
  "CIENCIA E INVESTIGACION AGRARIA": 0.519,
  "JOURNAL OF REPRODUCTIVE MEDICINE": 0.519,
  "MOVIMENTO": 0.518,
  "INFORMES DE LA CONSTRUCCION": 0.517,
  "PHYSIKALISCHE MEDIZIN REHABILITATIONSMEDIZIN KURORTMEDIZIN": 0.517,
  "PERSPECTIVES IN BIOLOGY AND MEDICINE": 0.516,
  "ZEITSCHRIFT FUR GEBURTSHILFE UND NEONATOLOGIE": 0.516,
  "PROPAGATION OF ORNAMENTAL PLANTS": 0.516,
  "ATOMIC ENERGY": 0.515,
  "INFORMATION & CULTURE": 0.514,
  "PESQUISA VETERINARIA BRASILEIRA": 0.514,
  "INDIAN JOURNAL OF GEO-MARINE SCIENCES": 0.514,
  "ETHNOHISTORY": 0.514,
  "REVISTA DE ECONOMIA APLICADA": 0.514,
  "REVISTA BRASILEIRA DE ORNITOLOGIA": 0.513,
  "SRPSKI ARHIV ZA CELOKUPNO LEKARSTVO": 0.513,
  "NEUROCHEMICAL JOURNAL": 0.513,
  "POSTEPY MIKROBIOLOGII": 0.513,
  "JOURNAL OF ENGINEERING RESEARCH": 0.513,
  "ENGLISH HISTORICAL REVIEW": 0.513,
  "ETIKK I PRAKSIS": 0.512,
  "RLA-REVISTA DE LINGUISTICA TEORICA Y APLICADA": 0.512,
  "JOURNAL OF MODERN DYNAMICS": 0.512,
  "METALLURGIST": 0.511,
  "MIDDLE EASTERN STUDIES": 0.511,
  "REVISTA INTERNACIONAL DE ANDROLOGIA": 0.511,
  "PACHYDERM": 0.511,
  "TRANSACTIONS OF THE AMERICAN ENTOMOLOGICAL SOCIETY": 0.511,
  "ZOOLOGICHESKY ZHURNAL": 0.511,
  "ADVANCED MATERIALS & PROCESSES": 0.51,
  "JOURNAL OF AUSTRALIAN POLITICAL ECONOMY": 0.51,
  "LATIN AMERICAN JOURNAL OF PHARMACY": 0.51,
  "TECNOLOGIA Y CIENCIAS DEL AGUA": 0.51,
  "ZEITSCHRIFT FUR KRISTALLOGRAPHIE-NEW CRYSTAL STRUCTURES": 0.51,
  "AKTUELLE RHEUMATOLOGIE": 0.51,
  "BIOLOGICHESKIE MEMBRANY": 0.509,
  "ENGENHARIA SANITARIA E AMBIENTAL": 0.509,
  "HISTORY OF ECONOMIC IDEAS": 0.509,
  "INTERNATIONAL JOURNAL OF FEMINIST APPROACHES TO BIOETHICS": 0.509,
  "LAEKNABLADID": 0.509,
  "ISRAEL JOURNAL OF VETERINARY MEDICINE": 0.509,
  "JAPANESE JOURNAL OF POLITICAL SCIENCE": 0.508,
  "REVIJA ZA KRIMINALISTIKO IN KRIMINOLOGIJO": 0.508,
  "ISRAELI JOURNAL OF AQUACULTURE-BAMIDGEH": 0.508,
  "SOUTH ASIA-JOURNAL OF SOUTH ASIAN STUDIES": 0.507,
  "SOUTHEAST ASIAN JOURNAL OF TROPICAL MEDICINE AND PUBLIC HEALTH": 0.507,
  "JOURNAL DE THEORIE DES NOMBRES DE BORDEAUX": 0.506,
  "NEMATROPICA": 0.506,
  "PHYTOPROTECTION": 0.506,
  "REVIEW OF ECONOMIC DESIGN": 0.506,
  "YAKUGAKU ZASSHI-JOURNAL OF THE PHARMACEUTICAL SOCIETY OF JAPAN": 0.505,
  "ZEITSCHRIFT FUR PADAGOGIK": 0.504,
  "ACTA BIOLOGICA COLOMBIANA": 0.504,
  "GACETA MEDICA DE MEXICO": 0.504,
  "MATERIA-RIO DE JANEIRO": 0.504,
  "JOURNAL OF FOOD SAFETY AND FOOD QUALITY-ARCHIV FUR LEBENSMITTELHYGIENE": 0.503,
  "PHYTON-INTERNATIONAL JOURNAL OF EXPERIMENTAL BOTANY": 0.503,
  "RAIRO-THEORETICAL INFORMATICS AND APPLICATIONS": 0.503,
  "EDUCATIONAL LEADERSHIP": 0.501,
  "JOURNAL OF RUBBER RESEARCH": 0.5,
  "PARALLAX": 0.5,
  "RIDE-THE JOURNAL OF APPLIED THEATRE AND PERFORMANCE": 0.5,
  "TYDSKRIF VIR GEESTESWETENSKAPPE": 0.5,
  "MEDYCYNA WETERYNARYJNA-VETERINARY MEDICINE-SCIENCE AND PRACTICE": 0.5,
  "ACTA ZOOLOGICA BULGARICA": 0.5,
  "AGRICULTURAL HISTORY": 0.5,
  "ORIENTAL INSECTS": 0.5,
  "REVISTA DEL CLAD REFORMA Y DEMOCRACIA": 0.5,
  "AMERICAN BIOLOGY TEACHER": 0.5,
  "MATHEMATICAL POPULATION STUDIES": 0.5,
  "JOURNAL OF WOMENS HISTORY": 0.5,
  "SOCIOLOGISK FORSKNING": 0.5,
  "STUDIA UNIVERSITATIS BABES-BOLYAI CHEMIA": 0.5,
  "TURKISH JOURNAL OF PEDIATRICS": 0.5,
  "ARCHIVES OF RHEUMATOLOGY": 0.5,
  "BOLLETTINO DI STORIA DELLE SCIENZE MATEMATICHE": 0.5,
  "FOURRAGES": 0.5,
  "HITOTSUBASHI JOURNAL OF ECONOMICS": 0.5,
  "INTERNATIONAL JOURNAL OF APPLIED RESEARCH IN VETERINARY MEDICINE": 0.5,
  "VOJNOSANITETSKI PREGLED": 0.5,
  "DRUSTVENA ISTRAZIVANJA": 0.5,
  "JOURNAL OF COMPARATIVE FAMILY STUDIES": 0.5,
  "POLISH SOCIOLOGICAL REVIEW": 0.5,
  "HOUSTON JOURNAL OF MATHEMATICS": 0.5,
  "OCEANIA": 0.5,
  "ANKARA UNIVERSITESI VETERINER FAKULTESI DERGISI": 0.5,
  "AUSTRALIAN ORTHODONTIC JOURNAL": 0.5,
  "IHERINGIA SERIE BOTANICA": 0.5,
  "JOURNAL OF COLD WAR STUDIES": 0.5,
  "SANTE PUBLIQUE": 0.5,
  "TARIM BILIMLERI DERGISI-JOURNAL OF AGRICULTURAL SCIENCES": 0.5,
  "ZHURNAL VYSSHEI NERVNOI DEYATELNOSTI IMENI I P PAVLOVA": 0.5,
  "MEDECINE NUCLEAIRE-IMAGERIE FONCTIONNELLE ET METABOLIQUE": 0.5,
  "BMGN-THE LOW COUNTRIES HISTORICAL REVIEW": 0.5,
  "EVOLUTION PSYCHIATRIQUE": 0.5,
  "JOURNAL OF AFRICAN LANGUAGES AND LINGUISTICS": 0.5,
  "NEUROPHYSIOLOGY": 0.499,
  "REPORTS ON MATHEMATICAL LOGIC": 0.498,
  "WIENER TIERARZTLICHE MONATSSCHRIFT": 0.497,
  "JOURNAL OF ENVIRONMENTAL SCIENCE AND MANAGEMENT": 0.497,
  "ANASTHESIOLOGIE INTENSIVMEDIZIN NOTFALLMEDIZIN SCHMERZTHERAPIE": 0.496,
  "INTERNATIONAL JOURNAL OF HUMAN GENETICS": 0.495,
  "KERNTECHNIK": 0.495,
  "PROGRESS IN NUTRITION": 0.495,
  "APPITA": 0.493,
  "INTERCIENCIA": 0.493,
  "AFINIDAD": 0.493,
  "B-ENT": 0.493,
  "BIOPHARM INTERNATIONAL": 0.493,
  "CIRCULO DE LINGUISTICA APLICADA A LA COMUNICACION": 0.492,
  "ELECTRONIC RESEARCH ANNOUNCEMENTS IN MATHEMATICAL SCIENCES": 0.492,
  "TRIMESTRE ECONOMICO": 0.491,
  "JOURNAL OF THE JAPANESE SOCIETY FOR FOOD SCIENCE AND TECHNOLOGY-NIPPON SHOKUHIN KAGAKU KOGAKU KAISHI": 0.49,
  "LABOUR HISTORY": 0.49,
  "REVUE FRANCAISE D ALLERGOLOGIE": 0.49,
  "JOURNAL OF ISRAELI HISTORY": 0.489,
  "LARGE ANIMAL REVIEW": 0.489,
  "MOKUZAI GAKKAISHI": 0.489,
  "STUDIES IN LANGUAGE": 0.489,
  "HISTORICAL RECORDS OF AUSTRALIAN SCIENCE": 0.488,
  "CANADIAN JOURNAL OF INFORMATION AND LIBRARY SCIENCE-REVUE CANADIENNE DES SCIENCES DE L INFORMATION ET DE BIBLIOTHECONOMIE": 0.488,
  "INDIAN JOURNAL OF FISHERIES": 0.488,
  "GENERATIONS-JOURNAL OF THE AMERICAN SOCIETY ON AGING": 0.488,
  "LISTY CUKROVARNICKE A REPARSKE": 0.488,
  "OIL GAS-EUROPEAN MAGAZINE": 0.488,
  "ETHICAL PERSPECTIVES": 0.488,
  "CRITICAL ARTS-SOUTH-NORTH CULTURAL AND MEDIA STUDIES": 0.487,
  "KOBUNSHI RONBUNSHU": 0.487,
  "INDIAN JOURNAL OF AGRICULTURAL SCIENCES": 0.486,
  "IN PRACTICE": 0.486,
  "DEVIANCE ET SOCIETE": 0.486,
  "HIROSHIMA MATHEMATICAL JOURNAL": 0.486,
  "INVESTIGACION CLINICA": 0.485,
  "INTERNATIONAL JOURNAL OF ECONOMIC THEORY": 0.485,
  "JOURNAL OF ARCHITECTURAL AND PLANNING RESEARCH": 0.485,
  "MINNESOTA SYMPOSIA ON CHILD PSYCHOLOGY": 0.485,
  "NOTA LEPIDOPTEROLOGICA": 0.485,
  "REVISTA DE LA SOCIEDAD ENTOMOLOGICA ARGENTINA": 0.485,
  "ZEITSCHRIFT FUR ARBEITS-UND ORGANISATIONSPSYCHOLOGIE": 0.485,
  "BAUTECHNIK": 0.484,
  "ANADOLU PSIKIYATRI DERGISI-ANATOLIAN JOURNAL OF PSYCHIATRY": 0.484,
  "ONKOLOGE": 0.484,
  "ISRAEL AFFAIRS": 0.484,
  "NAVAL ENGINEERS JOURNAL": 0.484,
  "EUROPEAN JOURNAL OF GYNAECOLOGICAL ONCOLOGY": 0.483,
  "JOURNAL OF EXOTIC PET MEDICINE": 0.483,
  "JOURNAL OF THE HISTORY OF THE NEUROSCIENCES": 0.483,
  "TRANSACTIONS OF THE CANADIAN SOCIETY FOR MECHANICAL ENGINEERING": 0.483,
  "ARQUIVO BRASILEIRO DE MEDICINA VETERINARIA E ZOOTECNIA": 0.483,
  "OSTEUROPA": 0.483,
  "GEFAHRSTOFFE REINHALTUNG DER LUFT": 0.482,
  "TOPICS IN CLINICAL NUTRITION": 0.481,
  "TURKISH JOURNAL OF GERIATRICS-TURK GERIATRI DERGISI": 0.481,
  "UNIVERSITY OF CINCINNATI LAW REVIEW": 0.481,
  "ELECTRICAL ENGINEERING IN JAPAN": 0.481,
  "KOREAN ECONOMIC REVIEW": 0.48,
  "ONOMAZEIN": 0.48,
  "MAUSAM": 0.48,
  "WAR IN HISTORY": 0.48,
  "DIFFERENCES-A JOURNAL OF FEMINIST CULTURAL STUDIES": 0.48,
  "ECONOMIST-NETHERLANDS": 0.478,
  "INDOGERMANISCHE FORSCHUNGEN": 0.478,
  "REVISTA BRASILEIRA DE MEDICINA DO ESPORTE": 0.476,
  "EARTH SCIENCES HISTORY": 0.476,
  "MALIMBUS": 0.475,
  "ORNITOLOGIA NEOTROPICAL": 0.474,
  "BAUPHYSIK": 0.474,
  "CULTURAL CRITIQUE": 0.474,
  "INDIAN JOURNAL OF GENDER STUDIES": 0.472,
  "REVISTA ESPANOLA DE LINGUISTICA APLICADA": 0.472,
  "ZEITSCHRIFT FUR NEUROPSYCHOLOGIE": 0.472,
  "NUTRITION CLINIQUE ET METABOLISME": 0.472,
  "ACTA LINGUISTICA HUNGARICA": 0.472,
  "ASIAN WOMEN": 0.472,
  "JOURNAL OF SOUTH ASIAN DEVELOPMENT": 0.471,
  "NWIG-NEW WEST INDIAN GUIDE-NIEUWE WEST-INDISCHE GIDS": 0.471,
  "REVISTA DE LA UNION MATEMATICA ARGENTINA": 0.471,
  "TURK PSIKOLOJI DERGISI": 0.471,
  "ZEITGESCHICHTE": 0.471,
  "HIDROBIOLOGICA": 0.47,
  "JOURNAL OF THE RAMANUJAN MATHEMATICAL SOCIETY": 0.47,
  "ASIAN JOURNAL OF WOMENS STUDIES": 0.469,
  "CURRENT TOPICS IN NUTRACEUTICAL RESEARCH": 0.469,
  "UTILITAS MATHEMATICA": 0.468,
  "INDIAN JOURNAL OF ANIMAL SCIENCES": 0.468,
  "NAMES-A JOURNAL OF ONOMASTICS": 0.468,
  "BALTIC ASTRONOMY": 0.467,
  "SOUTHWESTERN NATURALIST": 0.467,
  "FRENCH HISTORY": 0.467,
  "AFRICAN STUDIES": 0.467,
  "TURKISH JOURNAL OF PHYSICAL MEDICINE AND REHABILITATION": 0.467,
  "INFORMACIOS TARSADALOM": 0.467,
  "MILITARY OPERATIONS RESEARCH": 0.466,
  "ZEITSCHRIFTE FUR FAMILIENFORSCHUNG-JOURNAL OF FAMILY RESEARCH": 0.466,
  "RILCE-REVISTA DE FILOLOGIA HISPANICA": 0.465,
  "EPE JOURNAL": 0.465,
  "PROGRESS IN BIOCHEMISTRY AND BIOPHYSICS": 0.464,
  "WAR & SOCIETY": 0.464,
  "NEUROLOGY ASIA": 0.463,
  "ISI BILIMI VE TEKNIGI DERGISI-JOURNAL OF THERMAL SCIENCE AND TECHNOLOGY": 0.463,
  "MITTEILUNGEN KLOSTERNEUBURG": 0.463,
  "DUTCH CROSSING-JOURNAL OF LOW COUNTRIES STUDIES": 0.463,
  "JOURNAL OF THE FACULTY OF AGRICULTURE KYUSHU UNIVERSITY": 0.463,
  "JOURNAL OF THE KANSAS ENTOMOLOGICAL SOCIETY": 0.462,
  "LIGHT & ENGINEERING": 0.462,
  "PHYTON-ANNALES REI BOTANICAE": 0.461,
  "ACTA SCIENTIAE VETERINARIAE": 0.461,
  "ARCHIVES DES MALADIES PROFESSIONNELLES ET DE L ENVIRONNEMENT": 0.461,
  "BANGLADESH JOURNAL OF BOTANY": 0.459,
  "LINGUISTICA ANTVERPIENSIA NEW SERIES-THEMES IN TRANSLATION STUDIES": 0.459,
  "NEGOTIATION JOURNAL": 0.458,
  "JOURNAL OF VALUE INQUIRY": 0.458,
  "REVISTA CIENTIFICA-FACULTAD DE CIENCIAS VETERINARIAS": 0.458,
  "JOURNAL OF NEPAL MEDICAL ASSOCIATION": 0.458,
  "HONG KONG LAW JOURNAL": 0.458,
  "ASHRAE JOURNAL": 0.457,
  "CURRENT HISTORY": 0.456,
  "INTERNATIONAL INSOLVENCY REVIEW": 0.456,
  "RUTGERS UNIVERSITY LAW REVIEW": 0.455,
  "ZEITSCHRIFT FUR SPORTPSYCHOLOGIE": 0.455,
  "ANNALES MEDICO-PSYCHOLOGIQUES": 0.455,
  "FILTRATION & SEPARATION": 0.455,
  "GEDRAG & ORGANISATIE": 0.455,
  "INTERNATIONAL JOURNAL OF THE HISTORY OF SPORT": 0.455,
  "AUSTRAL JOURNAL OF VETERINARY SCIENCES": 0.455,
  "INTERNATIONAL JOURNAL OF CLINICAL AND EXPERIMENTAL PATHOLOGY": 0.452,
  "LABOUR-LE TRAVAIL": 0.452,
  "CONTEMPORARY PSYCHOANALYSIS": 0.452,
  "ELECTRONICS AND COMMUNICATIONS IN JAPAN": 0.452,
  "JOURNAL OF THE AMERICAN POMOLOGICAL SOCIETY": 0.452,
  "REVISTA DE LA FACULTAD DE AGRONOMIA DE LA UNIVERSIDAD DEL ZULIA": 0.451,
  "PFLEGE": 0.45,
  "WASSERWIRTSCHAFT": 0.45,
  "LASER FOCUS WORLD": 0.45,
  "ANDAMIOS": 0.45,
  "ASIAN BIOMEDICINE": 0.449,
  "ASIAN ECONOMIC JOURNAL": 0.449,
  "BRADLEYA": 0.448,
  "FRENCH CULTURAL STUDIES": 0.448,
  "JAHRBUCHER FUR NATIONALOKONOMIE UND STATISTIK": 0.448,
  "KOREAN JOURNAL OF DEFENSE ANALYSIS": 0.448,
  "KOREA OBSERVER": 0.448,
  "LANGUAGE MATTERS": 0.447,
  "VETERINARIA MEXICO": 0.447,
  "ZEITSCHRIFT FUR SOZIOLOGIE DER ERZIEHUNG UND SOZIALISATION": 0.447,
  "CHEMISTRY & INDUSTRY": 0.447,
  "HONG KONG JOURNAL OF PAEDIATRICS": 0.447,
  "JOURNAL OF PEDIATRIC INFECTIOUS DISEASES": 0.447,
  "REVISTA COLOMBIANA DE ENTOMOLOGIA": 0.446,
  "PRATIQUES PSYCHOLOGIQUES": 0.446,
  "TEKNIK DERGI": 0.445,
  "FEMINISTISCHE STUDIEN": 0.444,
  "VLAAMS DIERGENEESKUNDIG TIJDSCHRIFT": 0.444,
  "ARS COMBINATORIA": 0.444,
  "ACTA BIOETHICA": 0.444,
  "KAGAKU KOGAKU RONBUNSHU": 0.444,
  "TURK GOGUS KALP DAMAR CERRAHISI DERGISI-TURKISH JOURNAL OF THORACIC AND CARDIOVASCULAR SURGERY": 0.443,
  "REVUE ROUMAINE DE LINGUISTIQUE-ROMANIAN REVIEW OF LINGUISTICS": 0.443,
  "KGK-KAUTSCHUK GUMMI KUNSTSTOFFE": 0.443,
  "REVISTA MVZ CORDOBA": 0.443,
  "BETRIEBSWIRTSCHAFTLICHE FORSCHUNG UND PRAXIS": 0.442,
  "DIABETOLOGE": 0.442,
  "ANALYTICAL AND QUANTITATIVE CYTOPATHOLOGY AND HISTOPATHOLOGY": 0.442,
  "OBSERVATORY": 0.442,
  "TELOS": 0.441,
  "ANTHROPOLOGICAL NOTEBOOKS": 0.441,
  "CALIFORNIA FISH AND GAME": 0.441,
  "JOURNAL OF THE ENTOMOLOGICAL RESEARCH SOCIETY": 0.441,
  "INTERNATIONAL JOURNAL OF CLINICAL AND EXPERIMENTAL MEDICINE": 0.44,
  "MONATSSCHRIFT FUR KRIMINOLOGIE UND STRAFRECHTSREFORM": 0.44,
  "TOPIA-CANADIAN JOURNAL OF CULTURAL STUDIES": 0.439,
  "WEST INDIAN MEDICAL JOURNAL": 0.439,
  "NIPPON SUISAN GAKKAISHI": 0.438,
  "INVESTIGACION BIBLIOTECOLOGICA": 0.438,
  "JOURNAL OF POPULAR CULTURE": 0.437,
  "JOURNAL OF POLICY HISTORY": 0.436,
  "B E JOURNAL OF THEORETICAL ECONOMICS": 0.436,
  "INFORMACAO & SOCIEDADE-ESTUDOS": 0.436,
  "SIGNA VITAE": 0.435,
  "TEKSTIL VE KONFEKSIYON": 0.435,
  "FLEISCHWIRTSCHAFT": 0.435,
  "SOLID STATE TECHNOLOGY": 0.435,
  "TIJDSCHRIFT VOOR RECHTSGESCHIEDENIS-REVUE D HISTOIRE DU DROIT-THE LEGAL HISTORY REVIEW": 0.434,
  "CLINICAL AND EXPERIMENTAL OBSTETRICS & GYNECOLOGY": 0.434,
  "HONG KONG JOURNAL OF EMERGENCY MEDICINE": 0.433,
  "SLOVENIAN VETERINARY RESEARCH": 0.433,
  "OPEN HOUSE INTERNATIONAL": 0.433,
  "JOURNAL OF CAMEL PRACTICE AND RESEARCH": 0.432,
  "JOURNAL OF THE ANATOMICAL SOCIETY OF INDIA": 0.432,
  "MOUVEMENT SOCIAL": 0.432,
  "PHYSICS WORLD": 0.432,
  "PAPELES DE POBLACION": 0.431,
  "REVISTA CHILENA DE DERECHO": 0.431,
  "SAMPE JOURNAL": 0.431,
  "SCANDIA": 0.43,
  "ZUCHTUNGSKUNDE": 0.43,
  "ANNALS OF ECONOMICS AND FINANCE": 0.43,
  "CENTAURUS": 0.43,
  "GESTION Y POLITICA PUBLICA": 0.43,
  "VIROLOGIE": 0.429,
  "BRITAIN AND THE WORLD": 0.429,
  "JOURNAL OF THE INDIAN CHEMICAL SOCIETY": 0.429,
  "POSTEPY BIOLOGII KOMORKI": 0.429,
  "ANTHROPOS": 0.429,
  "ITE JOURNAL-INSTITUTE OF TRANSPORTATION ENGINEERS": 0.429,
  "TEMPO SOCIAL": 0.429,
  "AFRICANA LINGUISTICA": 0.429,
  "SCIENCES SOCIALES ET SANTE": 0.429,
  "FOOD TECHNOLOGY": 0.429,
  "MATERIALS PERFORMANCE": 0.429,
  "LAW LIBRARY JOURNAL": 0.429,
  "LANGAGES": 0.429,
  "ALLERGOLOGIE": 0.429,
  "FORUM DER PSYCHOANALYSE": 0.429,
  "PURE AND APPLIED MATHEMATICS QUARTERLY": 0.428,
  "AMA-AGRICULTURAL MECHANIZATION IN ASIA AFRICA AND LATIN AMERICA": 0.428,
  "ALLGEMEINE FORST UND JAGDZEITUNG": 0.427,
  "UNIVERSITY OF PITTSBURGH LAW REVIEW": 0.427,
  "JOURNAL OF AFRICAN LAW": 0.427,
  "BULLETIN DE LA SOCIETE LINNEENNE DE LYON": 0.426,
  "FORKTAIL": 0.426,
  "GRUPPENPSYCHOTHERAPIE UND GRUPPENDYNAMIK": 0.426,
  "HACIENDA PUBLICA ESPANOLA-REVIEW OF PUBLIC ECONOMICS": 0.426,
  "MAGYAR ALLATORVOSOK LAPJA": 0.425,
  "INTERDISCIPLINARY SCIENCE REVIEWS": 0.425,
  "PEDAGOGISCHE STUDIEN": 0.425,
  "BIOTECHNOLOGY LAW REPORT": 0.425,
  "PHILIPPINE JOURNAL OF CROP SCIENCE": 0.424,
  "HOUILLE BLANCHE-REVUE INTERNATIONALE DE L EAU": 0.424,
  "JOURNAL OF THE COPYRIGHT SOCIETY OF THE USA": 0.424,
  "JOURNAL OF VISUAL CULTURE": 0.424,
  "THEORETICAL BIOLOGY FORUM": 0.424,
  "BILIG": 0.424,
  "STUDIES IN SYMBOLIC INTERACTION": 0.424,
  "NORDIC JOURNAL OF LINGUISTICS": 0.424,
  "REVISTA DE ECONOMIA MUNDIAL": 0.423,
  "TOPICS IN GERIATRIC REHABILITATION": 0.423,
  "ZEITSCHRIFT FUR DIALEKTOLOGIE UND LINGUISTIK": 0.423,
  "STUDIES IN EAST EUROPEAN THOUGHT": 0.423,
  "ULUSLARARASI ILISKILER-INTERNATIONAL RELATIONS": 0.423,
  "MATHEMATICAL INTELLIGENCER": 0.421,
  "REVUE DE GEOGRAPHIE ALPINE-JOURNAL OF ALPINE RESEARCH": 0.421,
  "PFERDEHEILKUNDE": 0.421,
  "INTERNATIONAL SUGAR JOURNAL": 0.421,
  "HASELTONIA": 0.421,
  "MEDITERRANEAN HISTORICAL REVIEW": 0.421,
  "AMME IDARESI DERGISI": 0.42,
  "INTERNATIONAL SURGERY": 0.42,
  "IDEGGYOGYASZATI SZEMLE-CLINICAL NEUROSCIENCE": 0.42,
  "TIERAERZTLICHE UMSCHAU": 0.42,
  "BOLETIN DE MALARIOLOGIA Y SALUD AMBIENTAL": 0.419,
  "CROATIAN JOURNAL OF EDUCATION-HRVATSKI CASOPIS ZA ODGOJ I OBRAZOVANJE": 0.419,
  "TRAMES-JOURNAL OF THE HUMANITIES AND SOCIAL SCIENCES": 0.419,
  "INDIAN JOURNAL OF HORTICULTURE": 0.419,
  "DRUGS OF THE FUTURE": 0.419,
  "ISSUES IN LAW & MEDICINE": 0.419,
  "MEDIZINISCHE GENETIK": 0.419,
  "RANGE MANAGEMENT AND AGROFORESTRY": 0.419,
  "ZKG INTERNATIONAL": 0.418,
  "NUNCIUS-JOURNAL OF THE HISTORY OF SCIENCE": 0.418,
  "BUFFALO BULLETIN": 0.418,
  "POSTMEDIEVAL-A JOURNAL OF MEDIEVAL CULTURAL STUDIES": 0.417,
  "SOZIALE WELT-ZEITSCHRIFT FUR SOZIALWISSENSCHAFTLICHE FORSCHUNG UND PRAXIS": 0.417,
  "BERICHTE ZUR WISSENSCHAFTSGESCHICHTE": 0.417,
  "LJETOPIS SOCIJALNOG RADA": 0.417,
  "LONDON JOURNAL": 0.417,
  "ACTA BIOQUIMICA CLINICA LATINOAMERICANA": 0.417,
  "CUADERNOS DE DESARROLLO RURAL": 0.417,
  "ROMANIAN JOURNAL OF POLITICAL SCIENCE": 0.416,
  "TIJDSCHRIFT VOOR COMMUNICATIEWETENSCHAP": 0.416,
  "BULLETIN DE L ACADEMIE NATIONALE DE MEDECINE": 0.415,
  "DIABETES STOFFWECHSEL UND HERZ": 0.415,
  "REVIEW OF NETWORK ECONOMICS": 0.415,
  "ZEITSCHRIFT FUR BIBLIOTHEKSWESEN UND BIBLIOGRAPHIE": 0.415,
  "ZEITSCHRIFT FUR ARZNEI- & GEWURZPFLANZEN": 0.414,
  "SEA TECHNOLOGY": 0.414,
  "ATW-INTERNATIONAL JOURNAL FOR NUCLEAR POWER": 0.413,
  "ATLANTIS-JOURNAL OF THE SPANISH ASSOCIATION OF ANGLO-AMERICAN STUDIES": 0.413,
  "JOURNAL OF NEUROLOGICAL SCIENCES-TURKISH": 0.412,
  "IMPLANTOLOGIE": 0.412,
  "NORTHERN HISTORY": 0.411,
  "OIL & GAS JOURNAL": 0.411,
  "DIALECTOLOGIA ET GEOLINGUISTICA": 0.41,
  "ESTUDIOS FILOLOGICOS": 0.41,
  "JOURNAL OF ENHANCED HEAT TRANSFER": 0.409,
  "KUWAIT MEDICAL JOURNAL": 0.409,
  "PSYCHIATRIE DE L ENFANT": 0.408,
  "SCANDINAVIAN JOURNAL OF LABORATORY ANIMAL SCIENCE": 0.407,
  "INDIAN JOURNAL OF HETEROCYCLIC CHEMISTRY": 0.407,
  "JOURNAL OF THE HELLENIC VETERINARY MEDICAL SOCIETY": 0.407,
  "DEUTSCHE LEBENSMITTEL-RUNDSCHAU": 0.407,
  "JOURNAL OF THE PROFESSIONAL ASSOCIATION FOR CACTUS DEVELOPMENT": 0.406,
  "KLEINTIERPRAXIS": 0.405,
  "AFRICAN AND ASIAN STUDIES": 0.405,
  "LIBRARY AND INFORMATION SCIENCE": 0.405,
  "EKOLOJI": 0.404,
  "REVUE D ETUDES COMPARATIVES EST-OUEST": 0.404,
  "AEROSPACE AMERICA": 0.404,
  "GEMATOLOGIYA I TRANSFUZIOLOGIYA": 0.404,
  "ECONTENT": 0.404,
  "NATURAL HISTORY": 0.403,
  "JOURNAL OF THE CHINESE SOCIETY OF MECHANICAL ENGINEERS": 0.403,
  "NUCLEAR ENGINEERING INTERNATIONAL": 0.403,
  "AMERICAN LABORATORY": 0.403,
  "ONCOLOGIE": 0.402,
  "COATINGSTECH": 0.4,
  "ZEITSCHRIFT FUR ETHNOLOGIE": 0.4,
  "CADMO": 0.4,
  "CORRESPONDANCES EN METABOLISMES HORMONES DIABETES ET NUTRITION": 0.4,
  "PULP & PAPER-CANADA": 0.4,
  "CATTLE PRACTICE": 0.4,
  "MANUFACTURING ENGINEERING": 0.4,
  "LATIN AMERICAN APPLIED RESEARCH": 0.4,
  "TIJDSCHRIFT VOOR DIERGENEESKUNDE": 0.4,
  "WOCHENBLATT FUR PAPIERFABRIKATION": 0.4,
  "CIVIL SZEMLE": 0.4,
  "CURRICULUM MATTERS": 0.398,
  "GORTERIA": 0.398,
  "HONG KONG JOURNAL OF DERMATOLOGY & VENEREOLOGY": 0.397,
  "REVISTA DE NEFROLOGIA DIALISIS Y TRASPLANTE": 0.397,
  "SECURITIES REGULATION LAW JOURNAL": 0.397,
  "SEN-I GAKKAISHI": 0.397,
  "SURFACE COATINGS INTERNATIONAL": 0.397,
  "ADVANCES IN RHEUMATOLOGY": 0.395,
  "ANNUAL REVIEW OF CRIMINOLOGY": 0.395,
  "AUSTRALASIAN EMERGENCY CARE": 0.395,
  "AUSTRALIAN JOURNAL OF GENERAL PRACTICE": 0.394,
  "BMJ SEXUAL & REPRODUCTIVE HEALTH": 0.394,
  "BSGF-EARTH SCIENCES BULLETIN": 0.393,
  "CANCER COMMUNICATIONS": 0.393,
  "CIRCULATION-GENOMIC AND PRECISION MEDICINE": 0.393,
  "CURRENT MEDICAL SCIENCE": 0.392,
  "DATA TECHNOLOGIES AND APPLICATIONS": 0.392,
  "EUROPEAN JOURNAL OF HEALTH PSYCHOLOGY": 0.391,
  "IEEE TRANSACTIONS ON GAMES": 0.391,
  "JOURNAL OF OCEANOLOGY AND LIMNOLOGY": 0.391,
  "JOURNAL OF THEORETICAL AND COMPUTATIONAL ACOUSTICS": 0.39,
  "LIFESTYLE GENOMICS": 0.39,
  "MEDITERRANEAN BOTANY": 0.39,
  "MOLECULAR OMICS": 0.39,
  "NATURE CATALYSIS": 0.389,
  "PALEOCEANOGRAPHY AND PALEOCLIMATOLOGY": 0.389,
  "PERSPECTIVES ON BEHAVIOR SCIENCE": 0.389,
  "Pulmonology": 0.388
}


exports.impacts = impacts



//////////////////
// WEBPACK FOOTER
// ./public/wos.js
// module id = 2124
// module chunks = 0